/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		162: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "static/js/" + ({}[chunkId]||chunkId) + "." + {"0":"217eb926","1":"6af5d6de","2":"0595aef7","3":"5deb94c9","4":"ab00df11","5":"ade1a92c","6":"c2782725","7":"7e1437ad","8":"53380aef","9":"165d9b24","10":"0eb98692","11":"f2ac490b","12":"0faf8eb9","13":"3a3d3ee0","14":"5e02f3c2","15":"1894bd2a","16":"c1a96830","17":"40087937","18":"3de59a92","19":"5be6e6ba","20":"32207387","21":"60336e91","22":"e639aa29","23":"616996e6","24":"cf48b3be","25":"97ec7009","26":"648eb976","27":"fedc2355","28":"30eb6185","29":"2d19210e","30":"94fd898d","31":"730701d0","32":"f25f9c77","33":"3e3b21ec","34":"f1ccb2a3","35":"4496e5d1","36":"30a4d975","37":"58ea76c6","38":"fd02e8ae","39":"43eaceff","40":"d2aca602","41":"20c7898f","42":"cdae5303","43":"a301e554","44":"b6a56204","45":"e2994f54","46":"92e7df85","47":"e26839e4","48":"824a7a97","49":"e1b195a1","50":"f5af21bb","51":"68f0d2f3","52":"3a2e68d9","53":"caae30b9","54":"c6dbeed2","55":"9b2f65ba","56":"a97905ec","57":"9204847c","58":"e4c0e9a0","59":"23593e30","60":"2bca7cc6","61":"f770d12f","62":"7363ec2a","63":"3c41392f","64":"213df331","65":"bd72cf0a","66":"25e0c410","67":"c5042d50","68":"80dd085f","69":"924234b2","70":"362fcd32","71":"7d8fbb6b","72":"087e4f5e","73":"9280b954","74":"c1f14833","75":"a7ee8216","76":"bc754a45","77":"b53063e1","78":"e7db6510","79":"9e0734e7","80":"7089104c","81":"ca9e4c90","82":"52c8ed35","83":"ef8b47a5","84":"a23c4614","85":"0182751d","86":"3cdd7e50","87":"89a78375","88":"6d250a76","89":"6e373be4","90":"868d128d","91":"6f98573d","92":"4ff1eca4","93":"74911990","94":"7e71dada","95":"fd1b7404","96":"2e1c251e","97":"f09dde6a","98":"622c4b55","99":"69a5c634","100":"ac22c523","101":"07f5e849","102":"c957a416","103":"dcef323e","104":"7005ffa8","105":"21a17cd9","106":"cc596c52","107":"bb914fc2","108":"55568af3","109":"c8477ec9","110":"a8628cb8","111":"ee722d6e","112":"e15c7687","113":"dd061561","114":"c8ad3f87","115":"0b952efb","116":"70317030","117":"85297e87","118":"41a51224","119":"b9a7498d","120":"5c8d1daa","121":"c0666cd8","122":"5ee09d1c","123":"6cec0afd","124":"a830015f","125":"0b844c76","126":"9d07032b","127":"9c4a3a79","128":"cd91fed8","129":"e8c68c6d","130":"5d30e638","131":"2c9b4f3e","132":"b1ac6dfa","133":"241a9173","134":"a3cce01c","135":"29e31741","136":"0b19374c","137":"b7b18787","138":"719280ea","139":"f9ef6e53","140":"13415abc","141":"5629b4ed","142":"2da0b2d6","143":"dc838334","144":"1e4f8a62","145":"e67826f2","146":"5af18921","147":"8205a16e","148":"9abc563b","149":"8c6d7fe0","150":"5e997e36","151":"b7d665eb","152":"8c2dc421","153":"a60d9711","154":"2336c460","155":"aa0f9ae6","156":"45a31013","157":"fcd8334b","158":"25beffb7","159":"d77ed2bb","160":"40dbd5e0","161":"4200f3d8"}[chunkId] + ".chunk.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 367);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(374);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(386)();
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return initialState; });
/* harmony export (immutable) */ __webpack_exports__["f"] = createStartAction;
/* harmony export (immutable) */ __webpack_exports__["g"] = createSuccessAction;
/* harmony export (immutable) */ __webpack_exports__["c"] = createFailAction;
/* harmony export (immutable) */ __webpack_exports__["e"] = createResetAction;
/* harmony export (immutable) */ __webpack_exports__["a"] = createBaseAsyncHandlers;
/* harmony export (immutable) */ __webpack_exports__["b"] = createBaseAsyncReducer;
/* unused harmony export hasNoQuery */
/* harmony export (immutable) */ __webpack_exports__["i"] = isPending;
/* harmony export (immutable) */ __webpack_exports__["j"] = makeDataUpdater;
/* harmony export (immutable) */ __webpack_exports__["k"] = makeDataUpdaterRequireData;
/* harmony export (immutable) */ __webpack_exports__["d"] = createKeyedAsyncReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_helpers__ = __webpack_require__(3);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var START='start';var SUCCESS='success';var FAIL='fail';var RESET='reset';var initialState={isFetching:false,data:null,errorInfo:null,activeQuery:null,successQuery:null,failQuery:null,hasError:false,startTime:0,failTime:0,successTime:0};function getKey(key,progress){return key+'.'+progress;}function getAction(key,progress,data,args){return{type:getKey(key,progress),data:data,args:args};}function createStartAction(key,data,args){return getAction(key,START,data,args);}function createSuccessAction(key,data,args){return getAction(key,SUCCESS,data,args);}function createFailAction(key,err,args){return getAction(key,FAIL,err,args);}function createResetAction(key){return getAction(key,RESET);}function createBaseAsyncHandlers(key){var _ref;var transformer=arguments.length>1&&arguments[1]!==undefined?arguments[1]:function(data){return data;};return _ref={},_defineProperty(_ref,getKey(key,START),function(state,action){return Object.assign({},state,{isFetching:true,activeQuery:action.data,startTime:new Date().valueOf()// Prior data or error is persisted so it can continue to render
});}),_defineProperty(_ref,getKey(key,SUCCESS),function(state,action){return Object.assign({},state,{isFetching:false,data:transformer(action.data),errorInfo:null,hasError:false,successQuery:state.activeQuery,activeQuery:null,successTime:new Date().valueOf()});}),_defineProperty(_ref,getKey(key,FAIL),function(state,action){return Object.assign({},state,{isFetching:false,errorInfo:action.data,hasError:true,failQuery:state.activeQuery,activeQuery:null,failTime:new Date().valueOf()});}),_defineProperty(_ref,getKey(key,RESET),function(){return initialState;}),_ref;}function createBaseAsyncReducer(key,transformer){return Object(__WEBPACK_IMPORTED_MODULE_0__general_helpers__["a" /* createReducer */])(initialState,createBaseAsyncHandlers(key,transformer));}/**
 * If true, is in a pristine "never tried to load" state
 */function hasNoQuery(state){return!(state.activeQuery||state.successQuery||state.failQuery);}/**
 * This is typically used for one-time fetches, where you want to present
 * a loading indicator if the fetch is in progress or has not yet begun.
 */function isPending(state){return!(state.successQuery||state.failQuery);}function makeDataUpdater(func){return function(state,action){return Object.assign({},state,{data:func(state.data,action)});};}function makeDataUpdaterRequireData(func){return function(state,action){if(state===null||state===undefined){return state;}if(state.data===null||state.data===undefined){return state;}return Object.assign({},state,{data:func(state.data,action)});};}/**
 * This uses the existing async handlers, but rather than being a dumb data dump,
 * it creates an object that is keyed by some property of the response. This is
 * typically most useful for loading a bunch of data from the same endpoint by id.
 *
 * e.g.
 * Normal start action excerpt: { type: "fake.start", data: { id: "abc" }}
 * Normal success action excerpt: { type: "fake.success", data: { name: "Test 123" }, args: [{ id: "abc" }]}
 * Output: { "abc": <itemReducer output on above actions>}
 *
 * @param actionKeys Base keys that must be present for the item reducer to be called
 * @param param The parameter in the args to index on
 * @param itemReducer The item reducer to call to generate the individual entries.
 *                    Defaults to the standard async reducer if unspecified
 * @param globalReducer If the item reducer does not match, call the optional globalReducer on the full state tree
 * @param undefinedUpdateReducer If the key is undefined, call the optional undefinedUpdateReducer on the existing
 *                               data for the undefined key
 */function createKeyedAsyncReducer(_ref2){var actionKeys=_ref2.actionKeys,param=_ref2.param,itemReducer=_ref2.itemReducer,globalReducer=_ref2.globalReducer,undefinedUpdateReducer=_ref2.undefinedUpdateReducer;if(typeof actionKeys==='string'){actionKeys=[actionKeys];}if(!itemReducer){itemReducer=createBaseAsyncReducer(actionKeys[0]);}if(!globalReducer){globalReducer=function globalReducer(state){return state;};}function runReducers(itemKey,state,action){var undefinedUpdate={};if(undefinedUpdateReducer&&itemKey!==undefined&&state.undefined){undefinedUpdate.undefined=undefinedUpdateReducer(state.undefined,action);}return Object.assign({},state,undefinedUpdate,_defineProperty({},itemKey,itemReducer(state[itemKey],action)));}var startKeys=actionKeys.map(function(k){return getKey(k,START);});var endKeys=actionKeys.map(function(k){return getKey(k,FAIL);}).concat(actionKeys.map(function(k){return getKey(k,SUCCESS);}));return function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];if(startKeys.indexOf(action.type)!==-1){var itemKey=action.data[param]||action.data[0][param];return runReducers(itemKey,state,action);}else if(endKeys.indexOf(action.type)!==-1){var _itemKey=action.args[0][param];return runReducers(_itemKey,state,action);}return globalReducer(state,action);};}

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createReducer;
/* harmony export (immutable) */ __webpack_exports__["e"] = makeActionCreator;
/* unused harmony export createSimpleKeyValueHandler */
/* harmony export (immutable) */ __webpack_exports__["b"] = createSimpleKeyValueReducer;
/* unused harmony export createSimpleToggleHandler */
/* harmony export (immutable) */ __webpack_exports__["c"] = createSimpleToggleReducer;
/* harmony export (immutable) */ __webpack_exports__["d"] = createToggleAndSetReducer;
/* harmony export (immutable) */ __webpack_exports__["f"] = resetState;
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function createReducer(){var initialState=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};for(var _len=arguments.length,handlers=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){handlers[_key-1]=arguments[_key];}var allHandlers=Object.assign.apply(Object,[{}].concat(handlers));return function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];if(allHandlers.hasOwnProperty(action.type)){return allHandlers[action.type](state,action);}return state;};}function makeActionCreator(type){for(var _len2=arguments.length,argNames=Array(_len2>1?_len2-1:0),_key2=1;_key2<_len2;_key2++){argNames[_key2-1]=arguments[_key2];}return function(){for(var _len3=arguments.length,args=Array(_len3),_key3=0;_key3<_len3;_key3++){args[_key3]=arguments[_key3];}var action={type:type};argNames.forEach(function(arg,index){action[argNames[index]]=args[index];});return action;};}function createSimpleKeyValueHandler(eventType){return _defineProperty({},eventType,function(state,action){return action.data||null;});}function createSimpleKeyValueReducer(eventType,initialState){return createReducer(initialState,createSimpleKeyValueHandler(eventType));}function createSimpleToggleHandler(eventType){return _defineProperty({},eventType,function(state){return!state;});}function createSimpleToggleReducer(eventType,initialState){return createReducer(initialState,createSimpleToggleHandler(eventType));}function createToggleAndSetReducer(toggleEvent,setEvent,initialState){return createReducer(initialState,createSimpleToggleHandler(toggleEvent),createSimpleKeyValueHandler(setEvent));}function resetState(types,handler){return function(state,action){if(types.indexOf(action.type)!==-1){state=undefined;}return handler(state,action);};}

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["r"] = getString;
/* harmony export (immutable) */ __webpack_exports__["s"] = getStringWithParams;
/* harmony export (immutable) */ __webpack_exports__["x"] = getTheme;
/* harmony export (immutable) */ __webpack_exports__["e"] = getBrand;
/* harmony export (immutable) */ __webpack_exports__["m"] = getLocale;
/* harmony export (immutable) */ __webpack_exports__["A"] = hasBrandError;
/* harmony export (immutable) */ __webpack_exports__["f"] = getBrandCommon;
/* harmony export (immutable) */ __webpack_exports__["g"] = getBrandId;
/* harmony export (immutable) */ __webpack_exports__["j"] = getComputedBridgeBrand;
/* harmony export (immutable) */ __webpack_exports__["t"] = getStudentBrandName;
/* harmony export (immutable) */ __webpack_exports__["u"] = getTeacherBrandName;
/* harmony export (immutable) */ __webpack_exports__["n"] = getLocaleId;
/* harmony export (immutable) */ __webpack_exports__["y"] = getThemeId;
/* harmony export (immutable) */ __webpack_exports__["C"] = isConfigOk;
/* harmony export (immutable) */ __webpack_exports__["B"] = isConfigLoaded;
/* harmony export (immutable) */ __webpack_exports__["z"] = getUiBase;
/* harmony export (immutable) */ __webpack_exports__["i"] = getBrandVal;
/* harmony export (immutable) */ __webpack_exports__["p"] = getQueryParamsForReload;
/* harmony export (immutable) */ __webpack_exports__["E"] = isJigsawOnly;
/* harmony export (immutable) */ __webpack_exports__["k"] = getDevicesLink;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAccountCenterLink;
/* harmony export (immutable) */ __webpack_exports__["F"] = isTeacherPortalEnabled;
/* unused harmony export getTeacherTaxonomyBrowseEnabled */
/* harmony export (immutable) */ __webpack_exports__["w"] = getTeacherTaxonomyFilters;
/* unused harmony export getTeacherTaxonomyBrowse */
/* harmony export (immutable) */ __webpack_exports__["l"] = getJigsawHost;
/* harmony export (immutable) */ __webpack_exports__["H"] = thumbnailsEnabled;
/* harmony export (immutable) */ __webpack_exports__["G"] = onboardingEnabled;
/* harmony export (immutable) */ __webpack_exports__["q"] = getReaderUrl;
/* harmony export (immutable) */ __webpack_exports__["o"] = getLoginRedirect;
/* harmony export (immutable) */ __webpack_exports__["h"] = getBrandItem;
/* harmony export (immutable) */ __webpack_exports__["v"] = getTeacherExploreSwimlanes;
/* harmony export (immutable) */ __webpack_exports__["D"] = isFeenyEnabled;
/* harmony export (immutable) */ __webpack_exports__["c"] = getAssignmentCreatorUrlBase;
/* harmony export (immutable) */ __webpack_exports__["a"] = ancillariesEnabled;
/* harmony export (immutable) */ __webpack_exports__["d"] = getBookshelfUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_objects__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__watson_config_action__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_dev_dev_selectors__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_api_redux_bridge_session_selectors__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_ui_pages_shared_url_builder__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_utils_strings__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_utils_env__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_api_redux_bridge_assetGroups_recommendations_utils__ = __webpack_require__(115);
var emptyArray=[];function getString(state,id){var value=Object(__WEBPACK_IMPORTED_MODULE_0__utils_objects__["b" /* findKeyInObj */])(state.config[__WEBPACK_IMPORTED_MODULE_1__watson_config_action__["b" /* LOCALE_KEY */]].data,id);if(value&&Object(__WEBPACK_IMPORTED_MODULE_2__redux_dev_dev_selectors__["b" /* isStringDebugEnabled */])(state)){value='😱'.repeat(value.length);}return value;}function getStringWithParams(state,id,params){return Object(__WEBPACK_IMPORTED_MODULE_5_app_utils_strings__["i" /* replaceParams */])(getString(state,id),params);}function getTheme(state){return state.config[__WEBPACK_IMPORTED_MODULE_1__watson_config_action__["c" /* THEME_KEY */]].data;}function getBrand(state){return state.config[__WEBPACK_IMPORTED_MODULE_1__watson_config_action__["a" /* BRAND_KEY */]].data||{};}function getLocale(state){return state.config[__WEBPACK_IMPORTED_MODULE_1__watson_config_action__["b" /* LOCALE_KEY */]].data||{};}function hasBrandError(state){return state.config[__WEBPACK_IMPORTED_MODULE_1__watson_config_action__["a" /* BRAND_KEY */]].hasError;}function getBrandCommon(state){return getBrand(state).common||{};}function getBrandId(state){return state.config[__WEBPACK_IMPORTED_MODULE_1__watson_config_action__["a" /* BRAND_KEY */]].successQuery;}function getComputedBridgeBrand(state){// If you're passing ?brand= to test in dev, you probably want segmentation turned off
if(getBrandId(state)!==window.location.hostname&&Object(__WEBPACK_IMPORTED_MODULE_6_app_utils_env__["c" /* isDevOrLocal */])()){return null;}var common=getBrandCommon(state);if(common.bridgeBrand){return common.bridgeBrand;}return null;}function getStudentBrandName(state){return getBrandCommon(state).name;}function getTeacherBrandName(state){return getBrand(state).teacher.name;}function getLocaleId(state){return state.config[__WEBPACK_IMPORTED_MODULE_1__watson_config_action__["b" /* LOCALE_KEY */]].successQuery;}function getThemeId(state){return state.config[__WEBPACK_IMPORTED_MODULE_1__watson_config_action__["c" /* THEME_KEY */]].successQuery;}function isItemReady(state,key){var node=state.config[key];return!!node.data;}function isItemLoaded(state,key){var node=state.config[key];return!!node.data||node.hasError;}function isConfigOk(state){var itemsToCheck=[__WEBPACK_IMPORTED_MODULE_1__watson_config_action__["a" /* BRAND_KEY */],__WEBPACK_IMPORTED_MODULE_1__watson_config_action__["c" /* THEME_KEY */],__WEBPACK_IMPORTED_MODULE_1__watson_config_action__["b" /* LOCALE_KEY */]];return itemsToCheck.reduce(function(acc,cv){return acc&&isItemReady(state,cv);},true);}function isConfigLoaded(state){var itemsToCheck=[__WEBPACK_IMPORTED_MODULE_1__watson_config_action__["a" /* BRAND_KEY */],__WEBPACK_IMPORTED_MODULE_1__watson_config_action__["c" /* THEME_KEY */],__WEBPACK_IMPORTED_MODULE_1__watson_config_action__["b" /* LOCALE_KEY */]];return itemsToCheck.reduce(function(acc,cv){return acc&&isItemLoaded(state,cv);},true);}function getUiBase(state){return state.config[__WEBPACK_IMPORTED_MODULE_1__watson_config_action__["d" /* UIBASE_KEY */]];}function getBrandVal(state,key){var data=getBrand(state);return Object(__WEBPACK_IMPORTED_MODULE_0__utils_objects__["b" /* findKeyInObj */])(data,key);}function getQueryParamsForReload(state){var currentBrand=getBrandId(state);var currentLocale=getLocaleId(state);var currentTheme=getThemeId(state);var brandCommon=getBrandCommon(state);var params={};if(currentBrand!==window.location.hostname){params.brand=currentBrand;}if(currentLocale!==brandCommon.locale){params.locale=currentLocale;}if(currentTheme!==brandCommon.theme){params.theme=currentTheme;}return params;}function isJigsawOnly(state){var base=getBrandCommon(state).jigsawOnly;return base&&base.enabled;}function getMulliganHost(state){return'https://'+getBrandCommon(state).mulliganHost;}function getDevicesLink(state){return getMulliganHost(state)+'/devices';}function getAccountCenterLink(state){return getMulliganHost(state)+'/user/profile';}function isTeacherPortalEnabled(state){return!isJigsawOnly(state)&&getBrandCommon(state).teacherPortalEnabled;}function getTeacherTaxonomyBase(state){return getBrand(state).teacher.taxonomies;}var FILTER='filter';var BROWSE='browse';function selectTaxonomies(state,key){var base=getTeacherTaxonomyBase(state);if(base&&base[key].enabled){return base[key].taxonomies||emptyArray;}return emptyArray;}function getTeacherTaxonomyBrowseEnabled(state){var base=getTeacherTaxonomyBase(state);return base&&base[BROWSE].enabled;}function getTeacherTaxonomyFilters(state){return selectTaxonomies(state,FILTER);}function getTeacherTaxonomyBrowse(state){return selectTaxonomies(state,BROWSE);}function getJigsawHost(state){return getBrandCommon(state).jigsawHost;}function getValueForCurrentUiBase(state,featurePath,defaultReturn){var uiBase=getUiBase(state);var configBase=getBrand(state)[uiBase];var item=Object(__WEBPACK_IMPORTED_MODULE_0__utils_objects__["b" /* findKeyInObj */])(configBase,featurePath);if(item===null){return defaultReturn;}return item;}function thumbnailsEnabled(state){return getValueForCurrentUiBase(state,'thumbnails.enabled',true);}function onboardingEnabled(state){return getValueForCurrentUiBase(state,'onboarding.enabled',true);}function getReaderUrl(state,vbid){if(Object(__WEBPACK_IMPORTED_MODULE_3_app_api_redux_bridge_session_selectors__["i" /* isTeacher */])(state)&&getBrandVal(state,'teacher.readerRedirect.enabled')){var url=getBrandVal(state,'teacher.readerRedirect.bookshelfUrl');return Object(__WEBPACK_IMPORTED_MODULE_4_app_ui_pages_shared_url_builder__["a" /* getBookshelfReaderRedirectUrl */])(url,vbid);}return Object(__WEBPACK_IMPORTED_MODULE_4_app_ui_pages_shared_url_builder__["d" /* getInternalReaderUrl */])(vbid);}function getLoginRedirect(state){if(getBrandVal(state,'common.loginRedirect.enabled')){return getBrandVal(state,'common.loginRedirect.url');}return null;}function getBrandItem(state,key){return Object(__WEBPACK_IMPORTED_MODULE_0__utils_objects__["b" /* findKeyInObj */])(getBrand(state),key);}function getTeacherExploreSwimlanes(state){return __WEBPACK_IMPORTED_MODULE_7_app_api_redux_bridge_assetGroups_recommendations_utils__["a" /* POSSIBLE_SWIMLANES */].reduce(function(acc,cv){var dataObj=getBrandItem(state,'teacher.exploreSwimlanes.'+cv);if(dataObj&&dataObj.enabled){acc.push(cv);}return acc;},[]).filter(function(val){return!!val;});}function isFeenyEnabled(state){return getBrandItem(state,'teacher.feeny.enabled');}function getAssignmentCreatorUrlBase(state){return getBrandItem(state,'teacher.feeny.creatorUrl');}function ancillariesEnabled(state){return getValueForCurrentUiBase(state,'ancillaries.enabled',true);}function getBookshelfUrl(state){return getBrandItem(state,'common.bookshelfUrl');}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createComponentTheme=__webpack_require__(161);Object.defineProperty(exports,'createComponentTheme',{enumerable:!0,get:function get(){return _interopRequireDefault(_createComponentTheme).default}});var _createTheme=__webpack_require__(162);Object.defineProperty(exports,'createTheme',{enumerable:!0,get:function get(){return _interopRequireDefault(_createTheme).default}});var _createThemedComponent=__webpack_require__(556);Object.defineProperty(exports,'createThemedComponent',{enumerable:!0,get:function get(){return _interopRequireDefault(_createThemedComponent).default}});var _getStyle=__webpack_require__(557);Object.defineProperty(exports,'getStyle',{enumerable:!0,get:function get(){return _interopRequireDefault(_getStyle).default}});var _ThemeProvider=__webpack_require__(558);Object.defineProperty(exports,'ThemeProvider',{enumerable:!0,get:function get(){return _interopRequireDefault(_ThemeProvider).default}});var _withTheme=__webpack_require__(164);Object.defineProperty(exports,'withTheme',{enumerable:!0,get:function get(){return _interopRequireDefault(_withTheme).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(390);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREATE_PAGE_VIEWER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GET_BOOK_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return NEXT_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return PREV_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return HAS_NEXT_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return HAS_PREV_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return GET_NEXT_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return GET_PREV_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return GET_TOC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return GET_BOOKMARKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return GET_HIGHLIGHTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return GET_USER_INFO; });
/* unused harmony export SIGN_OUT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return GO_TO_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return SEARCH_CONTENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return GO_TO_CFI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return GO_TO_SEARCH_RESULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return HIGHLIGHT_CURRENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DELETE_HIGHLIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return UPDATE_HIGHLIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return GO_TO_HIGHLIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return SET_BOOKMARK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DELETE_BOOKMARK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return GET_THUMBNAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return SET_ZOOM_SCALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return HIGHLIGHT_TERM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return UNHIGHLIGHT_TERMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return INCREASE_ZOOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DECREASE_ZOOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return TTS_V2_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return TTS_V2_PAUSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return TTS_V2_RESUME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return TTS_V2_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return TTS_V2_NEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return TTS_V2_PREV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return TTS_V2_SET_VOICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return TTS_V2_SEND_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return TTS_V2_SET_NO_CONTENT_MSG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return TTS_V2_GET_VOICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DESTROY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DISABLE_SCROLLING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ENABLE_SCROLLING; });
/* unused harmony export UPDATE_LICENSE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return GET_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DEACTIVATE_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return GET_CITATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return GET_PAGE_BREAKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return GO_TO_BOOKMARK; });
/* unused harmony export GENERATE_CAPTCHA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLEAR_SELECTION; });
/* unused harmony export DISABLE_ZOOM */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return SSO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return SET_USER_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return GET_NOTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return UPDATE_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DELETE_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return GET_ANCILLARIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return SET_DPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return SCROLL_TO_TOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SCROLL_TO_LEFT; });
var CREATE_PAGE_VIEWER='Jigsaw.createPageViewer';var GET_BOOK_LIST='Jigsaw.getBookList';var NEXT_PAGE='Book.goToNextPage';var PREV_PAGE='Book.goToPreviousPage';var HAS_NEXT_PAGE='Book.hasNextPage';var HAS_PREV_PAGE='Book.hasPreviousPage';var GET_NEXT_PAGE='Book.getNextPage';var GET_PREV_PAGE='Book.getPreviousPage';var GET_TOC='Book.getTOC';var GET_BOOKMARKS='Book.getBookmarks';var GET_HIGHLIGHTS='Book.getHighlights';var GET_USER_INFO='Jigsaw.User.getInfo';var SIGN_OUT='Jigsaw.User.signOut';var GO_TO_PAGE='Book.goToPage';var SEARCH_CONTENT='Book.searchContent';var GO_TO_CFI='Book.goToCFI';var GO_TO_SEARCH_RESULT='Book.goToSearchResult';var HIGHLIGHT_CURRENT='Book.highlightCurrentSelection';var DELETE_HIGHLIGHT='Book.deleteHighlight';var UPDATE_HIGHLIGHT='Book.updateHighlight';var GO_TO_HIGHLIGHT='Book.goToHighlight';var SET_BOOKMARK='Book.setBookmark';var DELETE_BOOKMARK='Book.deleteBookmark';var GET_THUMBNAILS='Book.getThumbnails';var SET_ZOOM_SCALE='Book.setZoomScale';var HIGHLIGHT_TERM='Book.highlightTerm';var UNHIGHLIGHT_TERMS='Book.unhighlightTerms';var INCREASE_ZOOM='Book.increaseZoomScale';var DECREASE_ZOOM='Book.decreaseZoomScale';var TTS_V2_START='TTS.startFromTop';var TTS_V2_PAUSE='TTS.pause';var TTS_V2_RESUME='TTS.resume';var TTS_V2_CANCEL='TTS.cancel';var TTS_V2_NEXT='TTS.skipForward';var TTS_V2_PREV='TTS.skipBack';var TTS_V2_SET_VOICE='TTS.setVoice';var TTS_V2_SEND_STATUS='TTS.sendStatus';var TTS_V2_SET_NO_CONTENT_MSG='TTS.setNoContentMessage';var TTS_V2_GET_VOICES='TTS.getVoices';var DESTROY='destroy';var DISABLE_SCROLLING='Book.disableScrolling';var ENABLE_SCROLLING='Book.enableScrolling';var UPDATE_LICENSE='Jigsaw.User.updateLicense';var GET_DEVICES='Jigsaw.User.getDevices';var DEACTIVATE_DEVICE='Jigsaw.User.deactivateDevice';var GET_CITATION='Book.getCitationInfo';var GET_PAGE_BREAKS='Book.getPageBreaks';var GO_TO_BOOKMARK='Book.goToBookmark';var GENERATE_CAPTCHA='Jigsaw.User.generateCaptcha';var CLEAR_SELECTION='Book.clearSelection';var DISABLE_ZOOM='Viewport.zoomDisabled';var SSO='Jigsaw.User.SSO';var SET_USER_INFO='Jigsaw.User.setInfo';var GET_NOTES='Book.getNotes';var ADD_NOTE='Book.addNote';var UPDATE_NOTE='Book.updateNote';var DELETE_NOTE='Book.deleteNote';var GET_ANCILLARIES='Book.getAncillaries';var SET_DPS='Viewport.setDPS';var SCROLL_TO_TOP='Viewport.scrollToTop';var SCROLL_TO_LEFT='Viewport.scrollToLeft';

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process, module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectGlobal", function() { return injectGlobal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isStyledComponent", function() { return isStyledComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "consolidateStreamedStyles", function() { return consolidateStreamedStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThemeProvider", function() { return ThemeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withTheme", function() { return withTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ServerStyleSheet", function() { return ServerStyleSheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StyleSheetManager", function() { return StyleSheetManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS", function() { return __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_stylis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis_rule_sheet__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_stylis_rule_sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_is__);








var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
});

// 

var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    var chunk = obj[key];
    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
  }).map(function (key) {
    if (isPlainObject(obj[key])) return objToCss(obj[key], key);
    return __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default()(key) + ': ' + obj[key] + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

var flatten = function flatten(chunks, executionContext) {
  return chunks.reduce(function (ruleSet, chunk) {
    /* Remove falsey values */
    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
      return ruleSet;
    }

    /* Flatten ruleSet */
    if (Array.isArray(chunk)) {
      ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
      return ruleSet;
    }

    /* Handle other components */
    if (chunk.hasOwnProperty('styledComponentId')) {
      // $FlowFixMe not sure how to make this pass
      ruleSet.push('.' + chunk.styledComponentId);
      return ruleSet;
    }

    /* Either execute or defer the function */
    if (typeof chunk === 'function') {
      if (executionContext) {
        ruleSet.push.apply(ruleSet, flatten([chunk(executionContext)], executionContext));
      } else ruleSet.push(chunk);

      return ruleSet;
    }

    /* Handle objects */
    ruleSet.push(
    // $FlowFixMe have to add %checks somehow to isPlainObject
    isPlainObject(chunk) ? objToCss(chunk) : chunk.toString());

    return ruleSet;
  }, []);
};

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new __WEBPACK_IMPORTED_MODULE_1_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new __WEBPACK_IMPORTED_MODULE_1_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];
// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_2_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

stylis.use([parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var stringifyRules = function stringifyRules(rules, selector, prefix) {
  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  return stylis(prefix || !selector ? '' : selector, cssStr);
};

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

// 

function isStyledComponent(target) /* : %checks */{
  return (
    // $FlowFixMe TODO: flow for styledComponentId
    typeof target === 'function' && typeof target.styledComponentId === 'string'
  );
}

// 

/* This function is DEPRECATED and will be removed on the next major version release.
 * It was needed to rehydrate all style blocks prepended to chunks before React
 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
 * the use of streamed style tags and will perform the rehydration earlier when needed
 * this function will not be needed anymore */
function consolidateStreamedStyles() {
  if (false) {
    // eslint-disable-next-line no-console
    console.warn('styled-components automatically does streaming SSR rehydration now.\n' + 'Calling consolidateStreamedStyles manually is no longer necessary and a noop now.\n' + '- Please remove the consolidateStreamedStyles call from your client.');
  }
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
var generateAlphabeticName = function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
};

// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 

var css = (function (styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (typeof styles === 'function' || isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
});

// 


var SC_ATTR = typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_BRIDGE_HOST":"services.vstbridge.com","REACT_APP_ENVIRONMENT":"production","REACT_APP_REVISION":"","REACT_APP_JIGSAW_HOST":"jigsaw.vitalsource.com","REACT_APP_FEENY_HOST":"assignments.vitalsource.com"}).SC_ATTR || 'data-styled-components';
var SC_STREAM_ATTR = 'data-styled-streamed';
var CONTEXT_KEY = '__styled-components-stylesheet__';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = "production" !== 'production';

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? {
  "1": "Cannot create styled-component for component: %s.\n\n",
  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n* Are you trying to reuse it across renders?\n* Are you accidentally calling collectStyles twice?\n\n",
  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n* Does this error occur on the client and is your target falsy?\n* Does this error occur on the server and is the sheet falsy?\n\n",
  "5": "The clone method cannot be used on the client!\n\n* Are you running in a client-like environment on the server?\n* Are you trying to run SSR on the client?\n\n",
  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n* Are you using a custom target that isn't mounted?\n* Does your document not have a valid head element?\n* Have you accidentally removed a style tag manually?\n\n",
  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
  "9": "Missing document `<head>`\n\n",
  "10": "Cannot find sheet for given tag\n"
} : {};

/**
 * super basic version of sprintf
 */
function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c = void 0;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      interpolations[_key2 - 1] = arguments[_key2];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
    } else {
      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations))));
    }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = document.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = document.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var el = document.createElement('style');
  el.setAttribute(SC_ATTR, '');

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(document.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker);
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    styleTag: el,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    css: css,
    toHTML: wrapAsHtmlTag(css, names),
    toElement: wrapAsElement(css, names),
    clone: function clone() {
      throw new StyledComponentsError(5);
    }
  };
};

var makeTextNode = function makeTextNode(id) {
  return document.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }
    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTagInternal(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeServerTag = function makeServerTag() {
  return makeServerTagInternal();
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

/* wraps a given tag so that rehydration is performed once when necessary */
var makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
  /* rehydration function that adds all rules to the new tag */
  var rehydrate = once(function () {
    /* add all extracted components to the new tag */
    for (var i = 0, len = extracted.length; i < len; i += 1) {
      var _extracted$i = extracted[i],
          componentId = _extracted$i.componentId,
          cssFromDOM = _extracted$i.cssFromDOM;

      var cssRules = splitByRules(cssFromDOM);
      tag.insertRules(componentId, cssRules);
    }

    /* remove old HTMLStyleElements, since they have been rehydrated */
    for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
      var el = els[_i];
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  });

  if (immediateRehydration) rehydrate();

  return _extends({}, tag, {
    /* add rehydration hook to insertion methods */
    insertMarker: function insertMarker(id) {
      rehydrate();
      return tag.insertMarker(id);
    },
    insertRules: function insertRules(id, cssRules, name) {
      rehydrate();
      return tag.insertRules(id, cssRules, name);
    }
  });
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {
  /* a map from ids to tags */
  /* deferred rules for a given id */
  /* this is used for not reinjecting rules via hasNameForId() */
  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
  /* a list of tags belonging to this StyleSheet */
  /* a tag for import rules */
  /* current capacity until a new tag must be created */
  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.sealed = false;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate() {
    if (!IS_BROWSER || this.forceServer) {
      return this;
    }

    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + ']');
    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (nodesSize === 0) {
      return this;
    }

    for (var i = 0; i < nodesSize; i += 1) {
      // $FlowFixMe: We can trust that all elements in this query are style elements
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0; j < elNamesSize; j += 1) {
        var name = elNames[j];
        /* add rehydrated name to sheet to avoid readding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (extractedSize === 0) {
      return this;
    }

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);
    var rehydrationTag = makeRehydrationTag(tag, els, extracted, isStreamed);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(rehydrationTag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = rehydrationTag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);
    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;
    this.sealed = true;
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !this.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;
    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      this.sealed = false;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for injectGlobal to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);
      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);
    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;
    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return Object(__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

var _StyleSheetManager$ch;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager() {
    classCallCheck(this, StyleSheetManager);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StyleSheetManager.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[CONTEXT_KEY] = this.sheetInstance, _ref;
  };

  StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
    if (this.props.sheet) {
      this.sheetInstance = this.props.sheet;
    } else if (this.props.target) {
      this.sheetInstance = new StyleSheet(this.props.target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    /* eslint-disable react/prop-types */
    // Flow v0.43.1 will report an error accessing the `children` property,
    // but v0.47.0 will not. It is necessary to use a type cast instead of
    // a "fixme" comment to satisfy both Flow versions.
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(this.props.children);
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);
 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.closed = false;
  }

  ServerStyleSheet.prototype.complete = function complete() {
    if (!this.closed) {
      /* Remove closed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.closed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.closed) {
      throw new StyledComponentsError(2);
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.complete();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.complete();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        /* prepend style html to chunk */
        this.push(html + chunk);
        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.complete();
    });
    readableStream.on('error', function (err) {
      _this.complete();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme, defaultProps) {
  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types */
  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}

// 

function isTag(target) /* : %checks */{
  return typeof target === 'string';
}

// 

function generateDisplayName(target) {
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

// 
/* eslint-disable max-len */
/**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 * */
/*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus
*/
/* eslint-enable max-len */

var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveA(?:spectRatio|lpha)|ointsAt[X-Z]|anose1)|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:strokeMiterlimi|(?:specularConsta|repeatCou|fontVaria)n|(?:(?:specularE|e)xpon|renderingInt|asc)en|d(?:iffuseConsta|esce)n|(?:fontSizeAdju|lengthAdju|manife)s|baselineShif|onPointerOu|vectorEffec|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|k(?:ernel(?:UnitLength|Matrix)|[1-4])|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|(?:pointerEve|keyPoi)nts|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|unicodeRange|mathematical|vAlphabetic|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|a(?:rabicForm|l(?:phabetic|t)|sync)|pathLength|innerHTML|xlinkShow|(?:xlinkHr|glyphR)ef|(?:tabInde|(?:sand|b)bo|viewBo)x|(?:(?:href|xml|src)La|kerni)ng|autoPlay|o(?:verflow|pen)|f(?:o(?:ntSize|rm?)|il(?:ter|l))|r(?:e(?:quired|sult|f))?|divisor|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|i(?:temRef|n2|s)|t(?:arget[XY]|o)|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|(?:width|size)s|prefix|typeof|itemID|s(?:t(?:roke|art)|hape|cope|rc)|t(?:arget|ype)|(?:stri|la)ng|a(?:ccept|s)|m(?:edia|a(?:sk|x)|in)|x(?:mlns)?|width|value|size|href|k(?:ey)?|end|low|by|i[dn]|y[12]|g[12]|x[12]|f[xy]|[yz])$/;

/* From DOMProperty */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

var validAttr = (function (name) {
  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
});

// 

function hasInInheritanceChain(child, parent) {
  var target = child;

  while (target) {
    target = Object.getPrototypeOf(target);

    if (target && target === parent) {
      return true;
    }
  }

  return false;
}

// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */

var createBroadcast = function createBroadcast(initialState) {
  var listeners = {};
  var id = 0;
  var state = initialState;

  function publish(nextState) {
    state = nextState;

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in listeners) {
      var listener = listeners[key];
      if (listener === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }

      listener(state);
    }
  }

  function subscribe(listener) {
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    listener(state);
    return currentId;
  }

  function unsubscribe(unsubID) {
    listeners[unsubID] = undefined;
  }

  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
};

var _contextShape, _ThemeProvider$contex;

// NOTE: DO NOT CHANGE, changing this is a semver major change!
var CHANNEL = '__styled-components__';
var CHANNEL_NEXT = CHANNEL + 'next__';

var CONTEXT_CHANNEL_SHAPE = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  getTheme: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  subscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  unsubscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var contextShape = (_contextShape = {}, _contextShape[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _contextShape[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _contextShape);

var warnChannelDeprecated = void 0;
if (false) {
  warnChannelDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.error('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
  });
}

var isFunction = function isFunction(test) {
  return typeof test === 'function';
};

/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.unsubscribeToOuterId = -1;

    _this.getTheme = _this.getTheme.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
    // with the outer theme
    var outerContext = this.context[CHANNEL_NEXT];
    if (outerContext !== undefined) {
      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
        _this2.outerTheme = theme;

        if (_this2.broadcast !== undefined) {
          _this2.publish(_this2.props.theme);
        }
      });
    }

    this.broadcast = createBroadcast(this.getTheme());
  };

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _this3 = this,
        _babelHelpers$extends;

    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
      getTheme: this.getTheme,
      subscribe: this.broadcast.subscribe,
      unsubscribe: this.broadcast.unsubscribe
    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
      if (false) {
        warnChannelDeprecated();
      }

      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
      return function () {
        return _this3.broadcast.unsubscribe(unsubscribeId);
      };
    }, _babelHelpers$extends));
  };

  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.theme !== nextProps.theme) {
      this.publish(nextProps.theme);
    }
  };

  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeToOuterId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    }
  };

  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation


  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
    var theme = passedTheme || this.props.theme;

    if (isFunction(theme)) {
      var mergedTheme = theme(this.outerTheme);

      if (false) {
        throw new StyledComponentsError(7);
      }

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, this.outerTheme, theme);
  };

  ThemeProvider.prototype.publish = function publish(theme) {
    this.broadcast.publish(this.getTheme(theme));
  };

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(this.props.children);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

ThemeProvider.childContextTypes = contextShape;
ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);

var _babelHelpers$extends;

// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var STATIC_EXECUTION_CONTEXT = {};

var modifiedContextShape = _extends({}, contextShape, (_babelHelpers$extends = {}, _babelHelpers$extends[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]), _babelHelpers$extends));

var identifiers = {};

/* We depend on components having unique IDs */
var generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);

  return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
};

// $FlowFixMe

var BaseStyledComponent = function (_Component) {
  inherits(BaseStyledComponent, _Component);

  function BaseStyledComponent() {
    var _temp, _this, _ret;

    classCallCheck(this, BaseStyledComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
      theme: null,
      generatedClassName: ''
    }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
  }

  BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
    if (this.unsubscribeId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
    }
  };

  BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
    var attrs = this.constructor.attrs;

    var context = _extends({}, props, { theme: theme });
    if (attrs === undefined) {
      return context;
    }

    this.attrs = Object.keys(attrs).reduce(function (acc, key) {
      var attr = attrs[key];

      // eslint-disable-next-line no-param-reassign
      acc[key] = typeof attr === 'function' && !hasInInheritanceChain(attr, __WEBPACK_IMPORTED_MODULE_3_react__["Component"]) ? attr(context) : attr;
      return acc;
    }, {});

    return _extends({}, context, this.attrs);
  };

  BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _constructor = this.constructor,
        attrs = _constructor.attrs,
        componentStyle = _constructor.componentStyle,
        warnTooManyClasses = _constructor.warnTooManyClasses;

    var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.master;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names
    if (componentStyle.isStatic && attrs === undefined) {
      return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
    } else {
      var executionContext = this.buildExecutionContext(theme, props);
      var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);

      if (false) {
        warnTooManyClasses(className);
      }

      return className;
    }
  };

  BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var componentStyle = this.constructor.componentStyle;

    var styledContext = this.context[CHANNEL_NEXT];

    // If this is a statically-styled component, we don't need to the theme
    // to generate or build styles.
    if (componentStyle.isStatic) {
      var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
      this.setState({ generatedClassName: generatedClassName });
      // If there is a theme in the context, subscribe to the event emitter. This
      // is necessary due to pure components blocking context updates, this circumvents
      // that by updating when an event is emitted
    } else if (styledContext !== undefined) {
      var subscribe = styledContext.subscribe;

      this.unsubscribeId = subscribe(function (nextTheme) {
        // This will be called once immediately
        var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);

        var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);

        _this2.setState({ theme: theme, generatedClassName: generatedClassName });
      });
    } else {
      // eslint-disable-next-line react/prop-types
      var theme = this.props.theme || EMPTY_OBJECT;
      var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
      this.setState({ theme: theme, generatedClassName: _generatedClassName });
    }
  };

  BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this3 = this;

    // If this is a statically-styled component, we don't need to listen to
    // props changes to update styles
    var componentStyle = this.constructor.componentStyle;

    if (componentStyle.isStatic) {
      return;
    }

    this.setState(function (prevState) {
      var theme = determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
      var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);

      return { theme: theme, generatedClassName: generatedClassName };
    });
  };

  BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unsubscribeFromContext();
  };

  BaseStyledComponent.prototype.render = function render() {
    // eslint-disable-next-line react/prop-types
    var innerRef = this.props.innerRef;
    var generatedClassName = this.state.generatedClassName;
    var _constructor2 = this.constructor,
        styledComponentId = _constructor2.styledComponentId,
        target = _constructor2.target;


    var isTargetTag = isTag(target);

    var className = [
    // eslint-disable-next-line react/prop-types
    this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

    var baseProps = _extends({}, this.attrs, {
      className: className
    });

    if (isStyledComponent(target)) {
      baseProps.innerRef = innerRef;
    } else {
      baseProps.ref = innerRef;
    }

    var propsForElement = baseProps;
    var key = void 0;

    for (key in this.props) {
      // Don't pass through non HTML tags through to HTML elements
      // always omit innerRef
      if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || validAttr(key))) {
        propsForElement[key] = key === 'style' && key in this.attrs ? _extends({}, this.attrs[key], this.props[key]) : this.props[key];
      }
    }

    return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(target, propsForElement);
  };

  return BaseStyledComponent;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
  var createStyledComponent = function createStyledComponent(target, options, rules) {
    var _options$isClass = options.isClass,
        isClass = _options$isClass === undefined ? !isTag(target) : _options$isClass,
        _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
        _options$componentId = options.componentId,
        componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
        _options$ParentCompon = options.ParentComponent,
        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
        extendingRules = options.rules,
        attrs = options.attrs;


    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);

    var StyledComponent = function (_ParentComponent) {
      inherits(StyledComponent, _ParentComponent);

      function StyledComponent() {
        classCallCheck(this, StyledComponent);
        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
      }

      StyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId,
            optionsToCopy = objectWithoutProperties(options, ['componentId']);


        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

        var newOptions = _extends({}, optionsToCopy, {
          componentId: newComponentId,
          ParentComponent: StyledComponent
        });

        return createStyledComponent(tag, newOptions, rules);
      };

      createClass(StyledComponent, null, [{
        key: 'extend',
        get: function get$$1() {
          var rulesFromOptions = options.rules,
              parentComponentId = options.componentId,
              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);


          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);

          var newOptions = _extends({}, optionsToCopy, {
            rules: newRules,
            parentComponentId: parentComponentId,
            ParentComponent: StyledComponent
          });

          return constructWithOptions(createStyledComponent, target, newOptions);
        }
      }]);
      return StyledComponent;
    }(ParentComponent);

    StyledComponent.attrs = attrs;
    StyledComponent.componentStyle = componentStyle;
    StyledComponent.contextTypes = modifiedContextShape;
    StyledComponent.displayName = displayName;
    StyledComponent.styledComponentId = styledComponentId;
    StyledComponent.target = target;


    if (false) {
      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
    }

    if (isClass) {
      __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(StyledComponent, target, {
        // all SC-specific things should not be hoisted
        attrs: true,
        componentStyle: true,
        displayName: true,
        extend: true,
        styledComponentId: true,
        target: true,
        warnTooManyClasses: true,
        withComponent: true
      });
    }

    return StyledComponent;
  };

  return createStyledComponent;
});

// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(str) {
  var l = str.length | 0,
      h = l | 0,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;

    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);

    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;

    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;

  return h >>> 0;
}

// 

var areStylesCacheable = IS_BROWSER;

var isStaticRules = function isStaticRules(rules, attrs) {
  for (var i = 0, len = rules.length; i < len; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule)) {
      return false;
    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs !== undefined) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in attrs) {
      if (typeof attrs[key] === 'function') {
        return false;
      }
    }
  }

  return true;
};

var isHMREnabled = typeof module !== 'undefined' && module.hot && "production" !== 'production';

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */
var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
  /* combines hashStr (murmurhash) and nameGenerator for convenience */
  var generateRuleHash = function generateRuleHash(str) {
    return nameGenerator(murmurhash(str));
  };

  var ComponentStyle = function () {
    function ComponentStyle(rules, attrs, componentId) {
      classCallCheck(this, ComponentStyle);

      this.rules = rules;
      this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
      this.componentId = componentId;

      if (!StyleSheet.master.hasId(componentId)) {
        var placeholder =  false ? ['.' + componentId + ' {}'] : [];

        StyleSheet.master.deferredInject(componentId, placeholder);
      }
    }

    /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
      var isStatic = this.isStatic,
          componentId = this.componentId,
          lastClassName = this.lastClassName;

      if (areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) {
        return lastClassName;
      }

      var flatCSS = flatten(this.rules, executionContext);
      var name = generateRuleHash(this.componentId + flatCSS.join(''));

      if (!styleSheet.hasNameForId(componentId, name)) {
        styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
      }

      this.lastClassName = name;
      return name;
    };

    ComponentStyle.generateName = function generateName(str) {
      return generateRuleHash(str);
    };

    return ComponentStyle;
  }();

  return ComponentStyle;
});

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var _styled = (function (styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  domElements.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });

  return styled;
});

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

var _keyframes = (function (nameGenerator, stringifyRules, css) {
  return function () {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var name = nameGenerator(murmurhash(replaceWhitespace(JSON.stringify(rules))));
    var id = 'sc-keyframes-' + name;

    if (!styleSheet.hasNameForId(id, name)) {
      styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
    }

    return name;
  };
});

// 

var _injectGlobal = (function (stringifyRules, css) {
  var injectGlobal = function injectGlobal() {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var hash = murmurhash(JSON.stringify(rules));
    var id = 'sc-global-' + hash;

    if (!styleSheet.hasId(id)) {
      styleSheet.inject(id, stringifyRules(rules));
    }
  };

  return injectGlobal;
});

// 

var _constructWithOptions = (function (css) {
  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

    if (!Object(__WEBPACK_IMPORTED_MODULE_6_react_is__["isValidElementType"])(tag)) {
      throw new StyledComponentsError(1, String(tag));
    }

    /* This is callable directly as a template function */
    // $FlowFixMe: Not typed to avoid destructuring arguments
    var templateFunction = function templateFunction() {
      return componentConstructor(tag, options, css.apply(undefined, arguments));
    };

    /* If config methods are called, wrap up a new template function and merge options */
    templateFunction.withConfig = function (config) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    templateFunction.attrs = function (attrs) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
        attrs: _extends({}, options.attrs || EMPTY_OBJECT, attrs)
      }));
    };

    return templateFunction;
  };

  return constructWithOptions;
});

// 

var withTheme = (function (Component$$1) {
  var isStatelessFunctionalComponent = typeof Component$$1 === 'function' &&
  // $FlowFixMe TODO: flow for prototype
  !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);

  // NOTE: We can't pass a ref to a stateless functional component
  var shouldSetInnerRef = isStyledComponent(Component$$1) || isStatelessFunctionalComponent;

  var WithTheme = function (_React$Component) {
    inherits(WithTheme, _React$Component);

    function WithTheme() {
      var _temp, _this, _ret;

      classCallCheck(this, WithTheme);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping


    WithTheme.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var defaultProps = this.constructor.defaultProps;

      var styledContext = this.context[CHANNEL_NEXT];
      var themeProp = determineTheme(this.props, undefined, defaultProps);
      if (styledContext === undefined && themeProp === undefined && "production" !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
      } else if (styledContext === undefined && themeProp !== undefined) {
        this.setState({ theme: themeProp });
      } else {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
          _this2.setState({ theme: theme });
        });
      }
    };

    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var defaultProps = this.constructor.defaultProps;

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, defaultProps);

        return { theme: theme };
      });
    };

    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    WithTheme.prototype.render = function render() {
      var props = _extends({
        theme: this.state.theme
      }, this.props);

      if (!shouldSetInnerRef) {
        props.ref = props.innerRef;
        delete props.innerRef;
      }

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component$$1, props);
    };

    return WithTheme;
  }(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

  WithTheme.contextTypes = contextShape;
  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';
  WithTheme.styledComponentId = 'withTheme';


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(WithTheme, Component$$1);
});

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Warning if you've imported this file on React Native */
if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Warning if there are several instances of styled-components */
if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

/* Instantiate singletons */
var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
var constructWithOptions = _constructWithOptions(css);
var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);

/* Instantiate exported singletons */
var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
var injectGlobal = _injectGlobal(stringifyRules, css);
var styled = _styled(StyledComponent, constructWithOptions);

/* harmony default export */ __webpack_exports__["default"] = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(521), __webpack_require__(122)(module)))

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return compose; });
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(393);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT' + Math.random().toString(36).substring(7).split('').join('.'),
  REPLACE: '@@redux/REPLACE' + Math.random().toString(36).substring(7).split('').join('.')
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) return false;

  var proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.REPLACE });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty
}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && 'action "' + String(actionType) + '"' || 'an action';

  return 'Given ' + actionDescription + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if ((typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var store = createStore.apply(undefined, args);
      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(undefined, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */
function isCrushed() {}

if (false) {
  warning("You are currently using minified code outside of NODE_ENV === 'production'. " + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _themeShape=__webpack_require__(559);Object.defineProperty(exports,'themeShape',{enumerable:!0,get:function get(){return _interopRequireDefault(_themeShape).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _getContrast=__webpack_require__(445),_getContrast2=_interopRequireDefault(_getContrast);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var getMainShadeIndex=function(palette,backgroundColor){for(var colorIndex=6,colorIsAccessible=_getContrast2.default.isAccessible(palette[colorIndex],backgroundColor);!colorIsAccessible;)colorIndex++,void 0===palette[colorIndex]?(console.warn('Shades #6 and higher in the color palette do not have a high enough contrast ratio against a background color of '+backgroundColor+'.'),colorIsAccessible=!0):colorIsAccessible=_getContrast2.default.isAccessible(palette[colorIndex],backgroundColor);return Math.min(colorIndex,Object.keys(palette).length-1)},createColorPalette=function(palette,name){return{get name(){return name},getShade:function getShade(index){return palette[index]},getMainShade:function getMainShade(){var _ref=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},_ref$backgroundColor=_ref.backgroundColor,backgroundColor=void 0===_ref$backgroundColor?'#ffffff':_ref$backgroundColor,_ref$offset=_ref.offset,offset=void 0===_ref$offset?0:_ref$offset,index=void 0;return index='#ffffff'===backgroundColor?(palette.inflection||getMainShadeIndex(palette,backgroundColor))+offset:getMainShadeIndex(palette,backgroundColor)+offset,palette[Math.min(index,Object.keys(palette).length-1)]}}};exports.default=createColorPalette;

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return LOGIN_TEACHER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return RESET_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CREATE_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return COMPLETE_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return UPDATE_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return HOME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return MY_BOOKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CLASSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CLASSES_CLASS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CLASSES_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CLASSES_CLASS_REQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CLASSES_COLLECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return EXPLORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVITY_LOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return READER_BASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return READER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return COOKIE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return BOOK_NOT_FOUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return SYSTEM_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return BOOK_ACCESS_DENIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return FILE_NOT_FOUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return NO_GROUPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ADMIN_EXPLORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADMIN_ALL_BOOKS; });
/* unused harmony export ADMIN_TAXONOMY_BASE */
/* unused harmony export ADMIN_TAXONOMY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADMIN_COLLECTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ADMIN_COLLECTIONS_CLASS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ADMIN_COLLECTIONS_CLASS_REQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ADMIN_COLLECTIONS_COLLECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ADMIN_ROSTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ADMIN_ROSTER_CLASS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ADMIN_ROSTER_CLASS_REQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return WEBVIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return WEBVIEW_EXPLORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return DEFAULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return DEV_THEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return DEV_BRAND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return DEV_LOCALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return DEV_JIGSAW_LIBRARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return REDIRECT_BASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return LOGIN_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return BOOKSHELF_READER_REDIRECT_BASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return BOOKSHELF_READER_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ASSIGNMENT_CREATOR_BASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ASSIGNMENT_CREATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return DECIDE; });
var LOGIN='/login';var LOGIN_TEACHER='/login/teacher';var RESET_PASSWORD='/reset-password';var CREATE_ACCOUNT='/create-account';var COMPLETE_ACCOUNT='/complete-account';var UPDATE_PASSWORD='/update-password';var HOME='/home';var MY_BOOKS='/home/mybooks';var CLASSES='/home/classes';var CLASSES_CLASS='/home/classes/:class?/:collection?';var CLASSES_ALL='/home/classes/all';var CLASSES_CLASS_REQ='/home/classes/:class/:collection?';var CLASSES_COLLECTION='/home/classes/:class/:collection';var EXPLORE='/home/explore';var ACTIVITY_LOG='/home/activity';var PROFILE='/home/profile';var READER_BASE='/books';var READER='/books/:vbid';var COOKIE_ERROR='/cookie-error';var BOOK_NOT_FOUND='/book-not-found';var SYSTEM_ERROR='/system-error';var BOOK_ACCESS_DENIED='/book-access-denied';var FILE_NOT_FOUND='/file-not-found';var NO_GROUPS='/no-groups';var ADMIN='/admin';var ADMIN_EXPLORE='/admin/explore';var ADMIN_ALL_BOOKS='/admin/explore/allbooks';var ADMIN_TAXONOMY_BASE='/admin/explore/taxonomy';var ADMIN_TAXONOMY='/admin/explore/taxonomy/:id/:category';var ADMIN_COLLECTIONS='/admin/collections';var ADMIN_COLLECTIONS_CLASS='/admin/collections/:class?';var ADMIN_COLLECTIONS_CLASS_REQ='/admin/collections/:class/:collection?';var ADMIN_COLLECTIONS_COLLECTION='/admin/collections/:class/:collection';var ADMIN_ROSTER='/admin/roster';var ADMIN_ROSTER_CLASS='/admin/roster/:class?';var ADMIN_ROSTER_CLASS_REQ='/admin/roster/:class';var WEBVIEW='/webview';var WEBVIEW_EXPLORE='/webview/explore';var DEFAULT='/';var DEV_THEME='/dev/theme';var DEV_BRAND='/dev/brand';var DEV_LOCALE='/dev/locale';var DEV_JIGSAW_LIBRARY='/dev/jigsaw-library';var REDIRECT_BASE='/redirect';var REDIRECT='/redirect/:url';var LOGIN_REDIRECT='/loginredirect';var BOOKSHELF_READER_REDIRECT_BASE='/reader-redirect';var BOOKSHELF_READER_REDIRECT='/reader-redirect/:vbid/:url';var ASSIGNMENT_CREATOR_BASE='/assignment-creator';var ASSIGNMENT_CREATOR='/assignment-creator/:mode/:vbid/:assignmentId?';var DECIDE='/user/decide';

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_ROSTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_SESSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return LOG_IN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return LOG_OUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVATE_ASSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return RESET_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return UPDATE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREATE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return GET_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return LIST_GROUPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_ADOPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DELETE_ADOPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return LIST_ADOPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_ADOPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_TAXONOMIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return LIST_ASSETS_MULTI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return LIST_ASSETS; });
/* unused harmony export UPDATE_ASSETS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return UPDATE_ADOPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return LIST_USERS; });
var GET_ROSTER='VST.Bridge.Roster.get';var GET_SESSION='VST.Bridge.Session.get';var LOG_IN='VST.Bridge.Session.login';var LOG_OUT='VST.Bridge.Session.logout';var ACTIVATE_ASSET='VST.BridgeAsset.activate';var RESET_USER='VST.Bridge.User.reset';var UPDATE_USER='VST.Bridge.User.update';var CREATE_USER='VST.Bridge.User.create';var GET_USER='VST.Bridge.Users.get';var LIST_GROUPS='VST.Bridge.Groups.list';var GET_GROUP='VST.Bridge.Groups.get';var CREATE_ADOPTION='VST.Bridge.Adoptions.create';var DELETE_ADOPTION='VST.Bridge.Adoptions.delete';var LIST_ADOPTIONS='VST.Bridge.Adoptions.list';var GET_ADOPTION='VST.Bridge.Adoptions.get';var GET_TAXONOMIES='VST.Bridge.Taxonomies.get';var LIST_ASSETS_MULTI='VST.Bridge.Assets.lists';// When used with redux, the following are not used directly in favor of the remapped versions
// that provide some additional use context
var LIST_ASSETS='VST.Bridge.Assets.list';var UPDATE_ASSETS='VST.Bridge.Assets.update';var UPDATE_ADOPTION='VST.Bridge.Adoptions.update';var LIST_USERS='VST.Bridge.Users.list';

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony export (immutable) */ __webpack_exports__["b"] = noticeError;
/* harmony export (immutable) */ __webpack_exports__["c"] = setUser;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_env__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_honeybadger_js__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_honeybadger_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_honeybadger_js__);
function init(){__WEBPACK_IMPORTED_MODULE_1_honeybadger_js___default.a.configure({apiKey:'8c0737ae',environment:Object(__WEBPACK_IMPORTED_MODULE_0__utils_env__["a" /* getEnvironmentId */])(),revision:Object(__WEBPACK_IMPORTED_MODULE_0__utils_env__["b" /* getRevisionId */])(),disabled:Object(__WEBPACK_IMPORTED_MODULE_0__utils_env__["d" /* isLocal */])()});}function noticeError(e){var errorToLog=e;if(typeof e==='string'){errorToLog=new Error(e);}__WEBPACK_IMPORTED_MODULE_1_honeybadger_js___default.a.notify(errorToLog);if(Object(__WEBPACK_IMPORTED_MODULE_0__utils_env__["c" /* isDevOrLocal */])()){// eslint-disable-next-line no-console
console.error(e);}}function setUser(jigsawUser){__WEBPACK_IMPORTED_MODULE_1_honeybadger_js___default.a.setContext({user_id:jigsawUser?jigsawUser.identifier||'':''});}

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = findKeyInObj;
/* harmony export (immutable) */ __webpack_exports__["c"] = findKeyParentInObj;
/* unused harmony export areKeyValuesEqual */
/* harmony export (immutable) */ __webpack_exports__["e"] = stripNullAndUndefined;
/* unused harmony export flattenObject */
/* harmony export (immutable) */ __webpack_exports__["d"] = isEmpty;
/* harmony export (immutable) */ __webpack_exports__["a"] = deepClone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_merge__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_merge__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function findKeyInObj(obj,key){if(!key||!key.split){return null;}return key.split('.').reduce(function(acc,cv){if(acc!==null&&typeof acc!=='undefined'){return acc[cv];}return null;},obj);}function findKeyParentInObj(obj,key){if(key.indexOf('.')===-1){return obj;}var pathParts=key.split('.');pathParts.pop();return findKeyInObj(obj,pathParts.join('.'));}/**
 * See if two objects contain all the same key/value pairs
 */function areKeyValuesEqual(obj1,obj2){var k1=Object.keys(obj1);var k2=Object.keys(obj2);if(k1.length!==k2.length){return false;}for(var i=0;i<k1.length;i++){var k=k1[i];if(obj1[k]!==obj2[k]){return false;}}return true;}function stripNullAndUndefined(obj){return Object.keys(obj).reduce(function(acc,cv){var val=obj[cv];if(val!==null&&typeof val!=='undefined'){acc[cv]=val;}return acc;},{});}function flattenObject(obj){if(!obj||(typeof obj==='undefined'?'undefined':_typeof(obj))!=='object'){return{};}var result={};Object.keys(obj).forEach(function(cv){var val=obj[cv];if((typeof val==='undefined'?'undefined':_typeof(val))==='object'){var flatObj=flattenObject(val);Object.keys(flatObj).forEach(function(k){result[cv+'.'+k]=flatObj[k];});}else{result[cv]=val;}});return result;}function isEmpty(obj){return Object.keys(obj).length===0;}function deepClone(obj){return __WEBPACK_IMPORTED_MODULE_0_merge___default.a.recursive(true,obj);}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _Icon=__webpack_require__(596);Object.defineProperty(exports,'default',{enumerable:!0,get:function get(){return _interopRequireDefault(_Icon).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createStyledComponent=__webpack_require__(560);Object.defineProperty(exports,'createStyledComponent',{enumerable:!0,get:function get(){return _interopRequireDefault(_createStyledComponent).default}});var _css=__webpack_require__(561);Object.defineProperty(exports,'css',{enumerable:!0,get:function get(){return _interopRequireDefault(_css).default}});var _filterLayoutStyles=__webpack_require__(562);Object.defineProperty(exports,'filterLayoutStyles',{enumerable:!0,get:function get(){return _interopRequireDefault(_filterLayoutStyles).default}});var _resetInheritedStyles=__webpack_require__(575);Object.defineProperty(exports,'resetInheritedStyles',{enumerable:!0,get:function get(){return _interopRequireDefault(_resetInheritedStyles).default}}),Object.defineProperty(exports,'resetInheritedStylesObject',{enumerable:!0,get:function get(){return _resetInheritedStyles.resetInheritedStylesObject}});var _visuallyHidden=__webpack_require__(577);Object.defineProperty(exports,'visuallyHidden',{enumerable:!0,get:function get(){return _interopRequireDefault(_visuallyHidden).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createJigsawAction */
/* harmony export (immutable) */ __webpack_exports__["a"] = createJigsawEventAction;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJigsawReaderAction;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getBookList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createPageViewer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return hasNextPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return hasPrevPage; });
/* unused harmony export getNextPage */
/* unused harmony export getPrevPage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getToc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return goToPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return searchContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return goToCfi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getThumbnails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return goToSearchResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return destroy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return enableScrolling; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return disableScrolling; });
/* unused harmony export getDevices */
/* unused harmony export deactivateDevice */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getCitation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getPageBreaks; });
/* unused harmony export clearSelection */
/* unused harmony export setUserInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return scrollToTop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return scrollToLeft; });
/* harmony export (immutable) */ __webpack_exports__["s"] = nextPage;
/* harmony export (immutable) */ __webpack_exports__["t"] = prevPage;
/* harmony export (immutable) */ __webpack_exports__["r"] = navToThumb;
/* harmony export (immutable) */ __webpack_exports__["u"] = resetSearch;
/* harmony export (immutable) */ __webpack_exports__["A"] = tryClearSelection;
/* harmony export (immutable) */ __webpack_exports__["z"] = setLastBrandAccessed;
/* harmony export (immutable) */ __webpack_exports__["y"] = setJigsawHost;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__page_context_selectors__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_watson_watson_config_selectors__ = __webpack_require__(4);
function createJigsawAction(apiCall){return function(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return{jigsaw:{apiCall:apiCall,args:args,targetReader:false}};};}function createJigsawEventAction(eventName){return function(data){var dataToUse=data;if(typeof data==='string'||typeof data==='number'){dataToUse={value:data};}return{type:eventName,data:Object.assign({},dataToUse,{timestamp:new Date().valueOf()})};};}function createJigsawReaderAction(apiCall){return function(){for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return{jigsaw:{apiCall:apiCall,args:args,targetReader:true}};};}var getBookList=createJigsawAction(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["n" /* GET_BOOK_LIST */]);var createPageViewer=createJigsawAction(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["c" /* CREATE_PAGE_VIEWER */]);var hasNextPage=createJigsawReaderAction(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["D" /* HAS_NEXT_PAGE */]);var hasPrevPage=createJigsawReaderAction(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["E" /* HAS_PREV_PAGE */]);var getNextPage=createJigsawReaderAction(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["r" /* GET_NEXT_PAGE */]);var getPrevPage=createJigsawReaderAction(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["u" /* GET_PREV_PAGE */]);var getToc=createJigsawReaderAction(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["w" /* GET_TOC */]);var getUserInfo=createJigsawAction(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["x" /* GET_USER_INFO */]);var goToPage=createJigsawReaderAction(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["B" /* GO_TO_PAGE */]);var searchContent=createJigsawReaderAction(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["M" /* SEARCH_CONTENT */]);var goToCfi=createJigsawReaderAction(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["z" /* GO_TO_CFI */]);var getThumbnails=createJigsawReaderAction(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["v" /* GET_THUMBNAILS */]);var goToSearchResult=createJigsawReaderAction(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["C" /* GO_TO_SEARCH_RESULT */]);var destroy=createJigsawReaderAction(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["i" /* DESTROY */]);var enableScrolling=createJigsawReaderAction(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["k" /* ENABLE_SCROLLING */]);var disableScrolling=createJigsawReaderAction(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["j" /* DISABLE_SCROLLING */]);var getDevices=createJigsawAction(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["p" /* GET_DEVICES */]);var deactivateDevice=createJigsawAction(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["d" /* DEACTIVATE_DEVICE */]);var getCitation=createJigsawReaderAction(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["o" /* GET_CITATION */]);var getPageBreaks=createJigsawReaderAction(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["t" /* GET_PAGE_BREAKS */]);var clearSelection=createJigsawReaderAction(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["b" /* CLEAR_SELECTION */]);var setUserInfo=createJigsawAction(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["P" /* SET_USER_INFO */]);var scrollToTop=createJigsawReaderAction(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["L" /* SCROLL_TO_TOP */]);var scrollToLeft=createJigsawReaderAction(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["K" /* SCROLL_TO_LEFT */]);var nextPageInternal=createJigsawReaderAction(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["I" /* NEXT_PAGE */]);function nextPage(){return function(dispatch,getState){if(__WEBPACK_IMPORTED_MODULE_2__page_context_selectors__["e" /* hasNextPage */](getState())){dispatch(nextPageInternal());}};}var prevPageInternal=createJigsawReaderAction(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["J" /* PREV_PAGE */]);function prevPage(){return function(dispatch,getState){if(__WEBPACK_IMPORTED_MODULE_2__page_context_selectors__["f" /* hasPrevPage */](getState())){dispatch(prevPageInternal());}};}function navToThumb(thumb){return function(dispatch){dispatch(goToPage(thumb.label));};}function resetSearch(){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_async_helpers__["e" /* createResetAction */])(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["M" /* SEARCH_CONTENT */]));};}function tryClearSelection(){return function(dispatch){if(window.watsonViewer){dispatch(clearSelection());}};}function setLastBrandAccessed(){return function(dispatch,getState){var lastBrandAccessed=Object(__WEBPACK_IMPORTED_MODULE_3__redux_watson_watson_config_selectors__["g" /* getBrandId */])(getState());dispatch(setUserInfo({lastBrandAccessed:lastBrandAccessed}));};}function setJigsawHost(){return function(dispatch,getState){var jigsawHost=Object(__WEBPACK_IMPORTED_MODULE_3__redux_watson_watson_config_selectors__["l" /* getJigsawHost */])(getState());if(window.Jigsaw&&jigsawHost){window.Jigsaw.host=jigsawHost;}};}

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["k"] = getBaseMethod;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LIST_ALL_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LIST_ADOPTION_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UPDATE_ADOPTION_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UPDATE_ADOPTION_ALL_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LIST_ALL_ASSETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SEARCH_ASSETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LIST_ACTIVE_ASSETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LIST_ADOPTION_ASSETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UPDATE_ADOPTION_ASSETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UPDATE_ADOPTION_NAME; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bridge_methods__ = __webpack_require__(13);
var SEPARATOR='::';function getBaseMethod(method){var parts=method.split(SEPARATOR);if(parts.length===2){return parts[1];}return method;}function getNewKey(baseMethod,newMethod){return'watson.bridge.'+newMethod+SEPARATOR+baseMethod;}var LIST_ALL_USERS=getNewKey(__WEBPACK_IMPORTED_MODULE_0__bridge_methods__["o" /* LIST_USERS */],'LIST_ALL_USERS');var LIST_ADOPTION_USERS=getNewKey(__WEBPACK_IMPORTED_MODULE_0__bridge_methods__["o" /* LIST_USERS */],'LIST_ADOPTION_USERS');var UPDATE_ADOPTION_USERS=getNewKey(__WEBPACK_IMPORTED_MODULE_0__bridge_methods__["s" /* UPDATE_ADOPTION */],'UPDATE_ADOPTION_USERS');var UPDATE_ADOPTION_ALL_USERS=getNewKey(__WEBPACK_IMPORTED_MODULE_0__bridge_methods__["s" /* UPDATE_ADOPTION */],'UPDATE_ADOPTION_ALL_USERS');var LIST_ALL_ASSETS=getNewKey(__WEBPACK_IMPORTED_MODULE_0__bridge_methods__["l" /* LIST_ASSETS */],'LIST_ALL_ASSETS');var SEARCH_ASSETS=getNewKey(__WEBPACK_IMPORTED_MODULE_0__bridge_methods__["l" /* LIST_ASSETS */],'SEARCH_ASSETS');var LIST_ACTIVE_ASSETS=getNewKey(__WEBPACK_IMPORTED_MODULE_0__bridge_methods__["l" /* LIST_ASSETS */],'LIST_ACTIVE_ASSETS');var LIST_ADOPTION_ASSETS=getNewKey(__WEBPACK_IMPORTED_MODULE_0__bridge_methods__["l" /* LIST_ASSETS */],'LIST_ADOPTION_ASSETS');var UPDATE_ADOPTION_ASSETS=getNewKey(__WEBPACK_IMPORTED_MODULE_0__bridge_methods__["s" /* UPDATE_ADOPTION */],'UPDATE_ADOPTION_ASSETS');var UPDATE_ADOPTION_NAME=getNewKey(__WEBPACK_IMPORTED_MODULE_0__bridge_methods__["s" /* UPDATE_ADOPTION */],'UPDATE_ADOPTION_NAME');

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(409);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(415);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(128);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(417);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(419);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(421);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(423);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(129);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(76);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(425);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(427);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(429);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(430);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_12__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(431);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withDestroyViewerReset;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_jigsaw_jigsaw_methods__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_util_async_helpers__ = __webpack_require__(2);
// https://stackoverflow.com/questions/35622588/how-to-reset-the-state-of-a-redux-store/35641992#35641992
var types=[Object(__WEBPACK_IMPORTED_MODULE_2__redux_util_async_helpers__["f" /* createStartAction */])(__WEBPACK_IMPORTED_MODULE_1__redux_jigsaw_jigsaw_methods__["i" /* DESTROY */]).type];function withDestroyViewerReset(handler){return Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["f" /* resetState */])(types,handler);}

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDisplayName;
/* harmony export (immutable) */ __webpack_exports__["d"] = getFullName;
/* harmony export (immutable) */ __webpack_exports__["c"] = getFirstName;
/* harmony export (immutable) */ __webpack_exports__["b"] = getEmail;
/* harmony export (immutable) */ __webpack_exports__["h"] = isLoggedInToBridge;
/* harmony export (immutable) */ __webpack_exports__["g"] = isBridgeSessionPending;
/* harmony export (immutable) */ __webpack_exports__["e"] = getGradeLevel;
/* harmony export (immutable) */ __webpack_exports__["i"] = isTeacher;
/* harmony export (immutable) */ __webpack_exports__["f"] = hasCookieError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bridge_methods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_name__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_watson_watson_config_selectors__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bridge_helpers__ = __webpack_require__(138);
function getDisplayName(state){var base=state.bridge[__WEBPACK_IMPORTED_MODULE_0__bridge_methods__["h" /* GET_SESSION */]].data;if(base){return Object(__WEBPACK_IMPORTED_MODULE_1__utils_name__["a" /* shortenName */])(base.firstName,base.lastName);}return'';}function getFullName(state){var base=state.bridge[__WEBPACK_IMPORTED_MODULE_0__bridge_methods__["h" /* GET_SESSION */]].data;if(base){return base.firstName+' '+base.lastName;}return'';}function getFirstName(state){var base=state.bridge[__WEBPACK_IMPORTED_MODULE_0__bridge_methods__["h" /* GET_SESSION */]].data;return base?base.firstName:'';}function getEmail(state){var base=state.bridge[__WEBPACK_IMPORTED_MODULE_0__bridge_methods__["h" /* GET_SESSION */]].data;if(base){return base.email;}return'';}function isLoggedInToBridge(state){var base=state.bridge[__WEBPACK_IMPORTED_MODULE_0__bridge_methods__["h" /* GET_SESSION */]];return!Object(__WEBPACK_IMPORTED_MODULE_2__redux_util_async_helpers__["i" /* isPending */])(base)&&!base.hasError;}function isBridgeSessionPending(state){return Object(__WEBPACK_IMPORTED_MODULE_2__redux_util_async_helpers__["i" /* isPending */])(state.bridge[__WEBPACK_IMPORTED_MODULE_0__bridge_methods__["h" /* GET_SESSION */]]);}function getGradeLevel(state){var base=state.bridge[__WEBPACK_IMPORTED_MODULE_0__bridge_methods__["h" /* GET_SESSION */]].data;if(base&&base.level){return base.level;}return null;}function isTeacher(state){return!Object(__WEBPACK_IMPORTED_MODULE_3__redux_watson_watson_config_selectors__["E" /* isJigsawOnly */])(state)&&getGradeLevel(state)===null;}function hasCookieError(state){return Object(__WEBPACK_IMPORTED_MODULE_4__bridge_helpers__["a" /* isCookieError */])(state.bridge[__WEBPACK_IMPORTED_MODULE_0__bridge_methods__["h" /* GET_SESSION */]].errorInfo);}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isDevOrLocal;
/* harmony export (immutable) */ __webpack_exports__["a"] = getEnvironmentId;
/* harmony export (immutable) */ __webpack_exports__["b"] = getRevisionId;
/* harmony export (immutable) */ __webpack_exports__["d"] = isLocal;
var ENV_LOCAL='local';var ENV_PROD='production';function isDevOrLocal(){return getEnvironmentId()!==ENV_PROD;}function getEnvironmentId(){return "production"||ENV_LOCAL;}function getRevisionId(){return ""||null;}function isLocal(){return getEnvironmentId()===ENV_LOCAL;}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createEvent=__webpack_require__(563);Object.defineProperty(exports,'createEvent',{enumerable:!0,get:function get(){return _interopRequireDefault(_createEvent).default}});var _entries=__webpack_require__(564);Object.defineProperty(exports,'entries',{enumerable:!0,get:function get(){return _interopRequireDefault(_entries).default}});var _generateUniqueId=__webpack_require__(565);Object.defineProperty(exports,'generateUniqueId',{enumerable:!0,get:function get(){return _interopRequireDefault(_generateUniqueId).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(375);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOOK_NAV_REQUESTED", function() { return BOOK_NAV_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOOK_SELECTION_CANCELLED", function() { return BOOK_SELECTION_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOOK_SELECTION_MADE", function() { return BOOK_SELECTION_MADE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOOK_SELECTION_WITH_POSITION", function() { return BOOK_SELECTION_WITH_POSITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOOK_PAGE_BREAK", function() { return BOOK_PAGE_BREAK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOOK_CLICK", function() { return BOOK_CLICK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOOK_TOUCH_START", function() { return BOOK_TOUCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOOK_TOUCH_END", function() { return BOOK_TOUCH_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOOK_TOUCH_MOVE", function() { return BOOK_TOUCH_MOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOOK_KEY_UP", function() { return BOOK_KEY_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOOK_KEY_DOWN", function() { return BOOK_KEY_DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOOK_KEY_PRESS", function() { return BOOK_KEY_PRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOOK_MOUSE_MOVE", function() { return BOOK_MOUSE_MOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOOK_MOUSE_WHEEL", function() { return BOOK_MOUSE_WHEEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HIGHLIGHT_CLICK", function() { return HIGHLIGHT_CLICK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HIGHLIGHT_MOUSE_OUT", function() { return HIGHLIGHT_MOUSE_OUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HIGHLIGHT_MOUSE_OVER", function() { return HIGHLIGHT_MOUSE_OVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NOTE_ICON_CLICK", function() { return NOTE_ICON_CLICK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PAGE_READY", function() { return PAGE_READY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PAGE_LOAD", function() { return PAGE_LOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PAGE_UNLOAD", function() { return PAGE_UNLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PAGE_RESIZE", function() { return PAGE_RESIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PAGE_SCROLL", function() { return PAGE_SCROLL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PAGE_TRANSFORM", function() { return PAGE_TRANSFORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "USER_SIGNOUT", function() { return USER_SIGNOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TTS_V2_STATUS", function() { return TTS_V2_STATUS; });
var BOOK_NAV_REQUESTED='book:navigationRequested';var BOOK_SELECTION_CANCELLED='book:selectionCancelled';var BOOK_SELECTION_MADE='book:selectionMade';var BOOK_SELECTION_WITH_POSITION='book:selectionWithPosition';var BOOK_PAGE_BREAK='book:pagebreak';var BOOK_CLICK='book:click';var BOOK_TOUCH_START='book:touchstart';var BOOK_TOUCH_END='book:touchend';var BOOK_TOUCH_MOVE='book:touchmove';var BOOK_KEY_UP='book:keyup';var BOOK_KEY_DOWN='book:keydown';var BOOK_KEY_PRESS='book:keypress';var BOOK_MOUSE_MOVE='book:mousemove';var BOOK_MOUSE_WHEEL='book:mousewheel';var HIGHLIGHT_CLICK='highlight:click';var HIGHLIGHT_MOUSE_OUT='highlight:mouseout';var HIGHLIGHT_MOUSE_OVER='highlight:mouseover';var NOTE_ICON_CLICK='noteicon:click';var PAGE_READY='page:ready';var PAGE_LOAD='page:load';var PAGE_UNLOAD='page:unload';var PAGE_RESIZE='page:resize';var PAGE_SCROLL='page:scroll';var PAGE_TRANSFORM='page:transform';var USER_SIGNOUT='user:signout';var TTS_V2_STATUS='tts-v2:status';

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * This addresses an issue with Route transitions causing multiple
 * redirects. The wrapped Switch seems to be the suggested way to
 * do these transitions, but it causes a remount which causes extra
 * redirects. I found someone commenting on this, but have yet to
 * find the ideal solution. This seems to work reliably though.
 *
 * I tried using location withRouter to do a location comparison,
 * but that didn't have the updated value yet
 */var RedirectOnce=function(_React$Component){_inherits(RedirectOnce,_React$Component);function RedirectOnce(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RedirectOnce);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RedirectOnce.__proto__||Object.getPrototypeOf(RedirectOnce)).call.apply(_ref,[this].concat(args))),_this),_this.rendered=false,_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RedirectOnce,[{key:'componentDidMount',value:function componentDidMount(){this.rendered=true;}},{key:'render',value:function render(){if(!this.rendered){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Redirect */],{to:this.props.to});}return null;}}]);return RedirectOnce;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (RedirectOnce);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["i"] = replaceParams;
/* harmony export (immutable) */ __webpack_exports__["j"] = replaceParamsSingularPlural;
/* harmony export (immutable) */ __webpack_exports__["c"] = decodeHtml;
/* harmony export (immutable) */ __webpack_exports__["d"] = encodeHtml;
/* harmony export (immutable) */ __webpack_exports__["a"] = compareCaseInsensitive;
/* unused harmony export upcaseFirstLetter */
/* unused harmony export downcaseFirstLetter */
/* harmony export (immutable) */ __webpack_exports__["b"] = dashesToCamelCase;
/* harmony export (immutable) */ __webpack_exports__["h"] = lengthInBytes;
/* harmony export (immutable) */ __webpack_exports__["g"] = hash;
/* harmony export (immutable) */ __webpack_exports__["e"] = getFileExtension;
/* harmony export (immutable) */ __webpack_exports__["f"] = getFileName;
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function replaceParams(template,params){if(!params){return template;}var result=template;Object.keys(params).filter(function(k){return typeof params[k]==='string'||typeof params[k]==='number';}).forEach(function(k){result=result.split('%{'+k+'}').join(params[k]);});var componentKeys=Object.keys(params).filter(function(k){return _typeof(params[k])==='object'||typeof params[k]==='function';});if(componentKeys.length>0){return interpolateComponents(result,params);}return result;}function replaceParamsSingularPlural(singularTemplate,pluralTemplate,params,count){if(count===1){return replaceParams(singularTemplate,params);}return replaceParams(pluralTemplate,params);}function decodeHtml(str){if(str){// http://stackoverflow.com/questions/3700326/decode-amp-back-to-in-javascript
var elem=document.createElement('textarea');elem.innerHTML=str;return elem.value;}return null;}function encodeHtml(str){if(str){// https://stackoverflow.com/questions/6234773/can-i-escape-html-special-chars-in-javascript
return str.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#039;');}return'';}// Based on https://github.com/martinandert/react-interpolate-component
function interpolateComponents(template,params){return template.split(/%{(.*?)}/).reduce(function(acc,cv,index){if(index%2===0){if(cv.length!==0){acc.push(cv);}}else{acc.push(params[cv]);}return acc;},[]);}function compareCaseInsensitive(a,b){var aVal=a.toUpperCase();var bVal=b.toUpperCase();if(aVal<bVal){return-1;}else if(aVal>bVal){return 1;}return 0;}function upcaseFirstLetter(s){return s.charAt(0).toUpperCase()+s.slice(1);}function downcaseFirstLetter(s){return s.charAt(0).toLowerCase()+s.slice(1);}function dashesToCamelCase(s){var parts=s.split('-');return downcaseFirstLetter(parts.map(function(p){return upcaseFirstLetter(p.toLowerCase());}).join(''));}function lengthInBytes(str){return new Blob([str]).size;}// http://erlycoder.com/49/javascript-hash-functions-to-convert-string-into-integer-hash-
function hash(s){var hash=0;for(var i=0;i<s.length;i++){/* eslint-disable no-bitwise */hash=s.charCodeAt(i)+(hash<<6)+(hash<<16)-hash;/* eslint-enable no-bitwise */}return hash;}/**
 * @param path
 * @return {string} Lower-cased file name extension, if available. Empty string otherwise.
 */function getFileExtension(path){path=path.split('?')[0];var index=path.lastIndexOf('.');if(index>-1&&index<path.length-2){var result=path.substring(index+1).toLowerCase();if(result.indexOf('/')===-1){return result;}}return'';}function getFileName(path){var parser=document.createElement('a');parser.href=path;if(parser.pathname.length<=1){return decodeURIComponent(parser.hostname);}return decodeURIComponent(parser.pathname).replace('/','');}

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = getCurrentTitle;
/* harmony export (immutable) */ __webpack_exports__["d"] = getCurrentCoverTemplate;
/* harmony export (immutable) */ __webpack_exports__["e"] = getCurrentCoverWidths;
/* harmony export (immutable) */ __webpack_exports__["q"] = isFixedLayout;
/* harmony export (immutable) */ __webpack_exports__["r"] = isPBK;
/* harmony export (immutable) */ __webpack_exports__["p"] = isBookNotFound;
/* harmony export (immutable) */ __webpack_exports__["o"] = isBookNoAccess;
/* harmony export (immutable) */ __webpack_exports__["c"] = currentBookHasAncillaries;
/* harmony export (immutable) */ __webpack_exports__["l"] = hasCookieError;
/* unused harmony export getInteractionErrors */
/* harmony export (immutable) */ __webpack_exports__["g"] = getLastInteractionError;
/* harmony export (immutable) */ __webpack_exports__["k"] = getThumbnails;
/* harmony export (immutable) */ __webpack_exports__["n"] = hasThumbnails;
/* harmony export (immutable) */ __webpack_exports__["s"] = thumbsLoading;
/* harmony export (immutable) */ __webpack_exports__["j"] = getThumbnailForBookmark;
/* harmony export (immutable) */ __webpack_exports__["a"] = bookHasPageBreaks;
/* harmony export (immutable) */ __webpack_exports__["b"] = bookHasSpreads;
/* harmony export (immutable) */ __webpack_exports__["h"] = getPageBreaks;
/* harmony export (immutable) */ __webpack_exports__["m"] = hasPageBreakData;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getPageBreaksAsThumbs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jigsaw_helpers__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reselect__);
var emptyArray=[];function getCurrentTitle(state){var data=state.jigsaw[__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["c" /* CREATE_PAGE_VIEWER */]].data;return data?data.title:null;}function getCurrentCoverTemplate(state){var data=state.jigsaw[__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["c" /* CREATE_PAGE_VIEWER */]].data;return data?data.coverURL:null;}function getCurrentCoverWidths(state){var data=state.jigsaw[__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["c" /* CREATE_PAGE_VIEWER */]].data;return data?data.coverWidths:[];}function isFixedLayout(state){var data=state.jigsaw[__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["c" /* CREATE_PAGE_VIEWER */]].data;return data&&data.layout==='fixed';}function isPBK(state){var data=state.jigsaw[__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["c" /* CREATE_PAGE_VIEWER */]].data;return data&&data.vbkType==='pbk';}function isBookNotFound(state){var err=state.jigsaw[__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["c" /* CREATE_PAGE_VIEWER */]].errorInfo;return err&&err.errorCode===404;}function isBookNoAccess(state){var err=state.jigsaw[__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["c" /* CREATE_PAGE_VIEWER */]].errorInfo;return err&&err.errorCode===403;}function currentBookHasAncillaries(state){var data=state.jigsaw[__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["c" /* CREATE_PAGE_VIEWER */]].data;return data&&data.hasAncillaries;}function hasCookieError(state){if(state.jigsaw[__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["x" /* GET_USER_INFO */]].hasError){return Object(__WEBPACK_IMPORTED_MODULE_1__jigsaw_helpers__["e" /* isCookieError */])(state.jigsaw[__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["x" /* GET_USER_INFO */]].errorInfo);}return false;}function getInteractionErrors(state){return state.jigsaw.interactionErrors;}function getLastInteractionError(state){var errors=getInteractionErrors(state);if(errors.length>0){return errors[errors.length-1];}return null;}function getThumbnails(state){var base=state.jigsaw[__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["v" /* GET_THUMBNAILS */]].data;return base?base.thumbnails:emptyArray;}function hasThumbnails(state){return getThumbnails(state).length>0;}function thumbsLoading(state){return state.jigsaw[__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["v" /* GET_THUMBNAILS */]].isFetching;}function getThumbnailForBookmark(state,bookmark){return getThumbnails(state).filter(function(t){return t.label===bookmark.page;})[0];}function bookHasPageBreaks(state){var base=state.jigsaw[__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["c" /* CREATE_PAGE_VIEWER */]].data;return base&&base.hasPageBreaks;}function bookHasSpreads(state){var base=state.jigsaw[__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["c" /* CREATE_PAGE_VIEWER */]].data;return base&&base.dpsAvailable;}function getPageBreaks(state){var base=state.jigsaw[__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["t" /* GET_PAGE_BREAKS */]].data;if(base){return base.pagelist;}return emptyArray;}function hasPageBreakData(state){return getPageBreaks(state).length>0;}var getPageBreaksAsThumbs=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function(state){return getPageBreaks(state);},function(pagelist){return pagelist.map(function(p){return{cfiref:p.cfiWithoutAssertions,label:p.label,urlref:p.url,images:[]};});});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return KEY_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FLUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REHYDRATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PAUSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PERSIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PURGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REGISTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_VERSION; });
var KEY_PREFIX = 'persist:';
var FLUSH = 'persist/FLUSH';
var REHYDRATE = 'persist/REHYDRATE';
var PAUSE = 'persist/PAUSE';
var PERSIST = 'persist/PERSIST';
var PURGE = 'persist/PURGE';
var REGISTER = 'persist/REGISTER';
var DEFAULT_VERSION = -1;

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = getQueryValue;
/* unused harmony export getQueryParamsAsObj */
/* harmony export (immutable) */ __webpack_exports__["e"] = getQueryParamsAsObjConvertTypes;
/* unused harmony export getQueryValueFromString */
/* harmony export (immutable) */ __webpack_exports__["g"] = reloadWithParams;
/* unused harmony export encodeParams */
/* harmony export (immutable) */ __webpack_exports__["a"] = appendOrUpdateParams;
/* harmony export (immutable) */ __webpack_exports__["c"] = getOrigin;
/* harmony export (immutable) */ __webpack_exports__["d"] = getOriginWithoutProtocol;
/* unused harmony export openUrl */
/* harmony export (immutable) */ __webpack_exports__["b"] = getDomain;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function getQueryValue(param){return getQueryValueFromString(window.location.search,param);}function getQueryParamsAsObj(){return __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(window.location.search);}function getQueryParamsAsObjConvertTypes(){var raw=getQueryParamsAsObj();var keys=Object.keys(raw);var result={};keys.forEach(function(k){var rawVal=raw[k];var asFloat=parseFloat(rawVal);var asInt=parseInt(rawVal,10);var asBool=rawVal==='true'?true:rawVal==='false'?false:null;var isNull=rawVal==='null';var isUndefined=rawVal==='undefined';if(!isNaN(asFloat)){result[k]=asFloat;}else if(!isNaN(asInt)){result[k]=asInt;}else if(asBool!==null){result[k]=asBool;}else if(isNull){result[k]=null;}else if(isUndefined){result[k]=undefined;}else{result[k]=rawVal;}});return result;}function getQueryValueFromString(search,param){return __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(search)[param];}function reloadWithParams(params){var paramStr=encodeParams(params);window.location.href=window.location.pathname+'?'+paramStr;}function encodeParams(params){return __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(params);}function appendOrUpdateParams(url,params){if(params){var _url$split=url.split('?'),_url$split2=_slicedToArray(_url$split,2),base=_url$split2[0],search=_url$split2[1];var initialParams=__WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(search);var finalParams=Object.assign({},initialParams,params);var paramStr=encodeParams(finalParams);if(paramStr){return base+'?'+paramStr;}return base;}return url;}// IE11 doesn't have window.location.origin
// https://tosbourn.com/a-fix-for-window-location-origin-in-internet-explorer/
function getOrigin(){return window.location.protocol+'//'+window.location.hostname+(window.location.port?':'+window.location.port:'');}function getOriginWithoutProtocol(){return window.location.hostname+(window.location.port?':'+window.location.port:'');}function openUrl(url){var win=window.open(url,'_blank');win.opener=null;return win;}// From fraction
function getDomain(host){if(host.length===0){return'';}var hostParts=host.split('.').reverse();if(hostParts.length>=3){var tldReg=/^(com|edu|gov|net|mil|org|nom|co|name|info|biz|uk|is|ca)$/i;if(hostParts[1].match(tldReg)&&hostParts[0].match(tldReg)){return hostParts[2]+'.'+hostParts[1]+'.'+hostParts[0];}}return hostParts[1]+'.'+hostParts[0];}

/***/ }),
/* 33 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = removeFromArray;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeAtIndex;
/* harmony export (immutable) */ __webpack_exports__["g"] = removeValue;
/* harmony export (immutable) */ __webpack_exports__["d"] = removeDuplicateValues;
/* harmony export (immutable) */ __webpack_exports__["e"] = removeDuplicates;
/* harmony export (immutable) */ __webpack_exports__["b"] = mergeDuplicates;
/* harmony export (immutable) */ __webpack_exports__["a"] = findWhere;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_array_find_index__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_merge__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_merge__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/**
 * Remove the element from the array that matches the provided key/value pair.
 * This is useful for removing items by ID.
 */function removeFromArray(arr,keyName,keyVal){var index=__WEBPACK_IMPORTED_MODULE_0_array_find_index___default()(arr,function(e){return e&&e[keyName]===keyVal;});return removeAtIndex(arr,index);}/**
 * Remove the item from the array at the specified index and return a new array.
 * If the index is out of bounds, return the original array.
 * This immutability is important for Redux
 */function removeAtIndex(arr,index){if(index>=0&&index<arr.length){var copiedArray=[].concat(_toConsumableArray(arr));copiedArray.splice(index,1);return copiedArray;}return arr;}function removeValue(arr,value){var index=arr.indexOf(value);if(index!==-1){return removeAtIndex(arr,index);}return arr;}function removeDuplicateValues(arr){var seen={};return arr.filter(function(item){if(seen[item]){return false;}seen[item]=true;return true;});}function removeDuplicates(arr,keyName){var seen={};var newArray=arr.filter(function(obj){var myVal=obj[keyName];if(typeof myVal!=='undefined'&&seen[myVal]){return false;}seen[myVal]=true;return true;});if(newArray.length===arr.length){return arr;}return newArray;}function mergeDuplicates(arr,keyName){var objectsByKey={};var indexesByKey={};var newArray=[];arr.forEach(function(arrayItem){var keyVal=arrayItem[keyName];var oldObj=objectsByKey[keyVal];var oldIndex=indexesByKey[keyVal];if(oldObj){var newObj=__WEBPACK_IMPORTED_MODULE_1_merge___default.a.recursive(arrayItem,oldObj);objectsByKey[keyVal]=newObj;newArray[oldIndex]=newObj;}else if(typeof arrayItem[keyName]!=='undefined'){objectsByKey[keyVal]=arrayItem;indexesByKey[keyVal]=newArray.length;newArray.push(arrayItem);}});if(newArray.length===arr.length){return arr;}return newArray;}function findWhere(array,fn){var index=__WEBPACK_IMPORTED_MODULE_0_array_find_index___default()(array,function(el){return fn(el);});if(index!==-1){return array[index];}return null;}

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getErrorContent;
/* harmony export (immutable) */ __webpack_exports__["e"] = isCookieError;
/* harmony export (immutable) */ __webpack_exports__["b"] = findIndexMatchingCfiFallBackToBefore;
/* harmony export (immutable) */ __webpack_exports__["c"] = findIndexMatchingDocAndCfiFallBackToBefore;
/* harmony export (immutable) */ __webpack_exports__["a"] = findIndexMatchingCfiFallBackToAfter;
function getErrorContent(resp){if(resp.isSuccess()){return null;}return{errorDetail:resp.data.errors,message:resp.message,errorCode:resp.code||resp.data.code};}function isCookieError(normalizedError){var err=normalizedError.errorDetail;return err&&err.message==='You must enable third-party cookies';}function findIndexMatchingCfiFallBackToBefore(orderedItems,getItemCfi,cfi){if(orderedItems.length===0||!cfi){return-1;}for(var i=0;i<orderedItems.length-1;i++){var compare=window.Jigsaw.CFIUtils.compareCFIs;var compareThis=compare(cfi,getItemCfi(orderedItems[i]));var compareNext=compare(cfi,getItemCfi(orderedItems[i+1]));if(compareThis===0||compareNext<0){return i;}}return orderedItems.length-1;}function stripAssertions(cfi){return cfi.replace(/ *\[[^\]]*\] */g,'');}function getContentDocPath(cfi){if(typeof cfi==='string'&&cfi.indexOf('!')>0){return stripAssertions(cfi).split('!')[0];}return null;}/**
 * Look for a cfi match within the provided cfi's content document,
 * falling backwards to the nearest item for that doc if an exact match
 * is not found. Return the first item on that page if there is no
 * previous match for that CFI. -1 if no content for that page is available
 * or bad data provided.
 *
 * Assumes orderedItems is sorted
 */function findIndexMatchingDocAndCfiFallBackToBefore(orderedItems,getItemCfi,cfi){if(orderedItems.length===0||!cfi){return-1;}var cfiDoc=getContentDocPath(cfi);for(var i=0;i<orderedItems.length-1;i++){var compare=window.Jigsaw.CFIUtils.compareCFIs;var firstItemCfi=getItemCfi(orderedItems[i]);if(cfiDoc===getContentDocPath(firstItemCfi)){var compareThis=compare(cfi,firstItemCfi);var compareNext=compare(cfi,getItemCfi(orderedItems[i+1]));if(compareThis===0||compareNext<0){return i;}}}return-1;}function findIndexMatchingCfiFallBackToAfter(orderedItems,getItemCfi,cfi){if(orderedItems.length===0||!cfi){return-1;}for(var i=0;i<orderedItems.length-1;i++){var compare=window.Jigsaw.CFIUtils.compareCFIs;var compareThis=compare(cfi,getItemCfi(orderedItems[i]));var compareNext=compare(cfi,getItemCfi(orderedItems[i+1]));if(compareThis===0){return i;}else if(compareNext<0){return i+1;}}return orderedItems.length-1;}

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(410);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(413);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__createHashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(414);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(55);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(45);
/* unused harmony reexport parsePath */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__PathUtils__["b"]; });










/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule warning
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.22.2';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(134)(module)))

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(20);
/* harmony default export */ __webpack_exports__["a"] = (function(mapStateToProps,mapDispatchToProps,mergeProps,options){return function(Component){return Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["h" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps,mergeProps,options)(Component));};});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = afterLogOut;
/* harmony export (immutable) */ __webpack_exports__["c"] = tryRedirectJigsawFailure;
/* harmony export (immutable) */ __webpack_exports__["b"] = tryRedirectBridgeFailure;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jigsaw_helpers__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bridge_helpers__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_bridge_bridge_methods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_jigsaw_jigsaw_methods__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_api_redux_watson_watson_config_selectors__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_utils_route__ = __webpack_require__(32);
function handleAccessError(apiCall){return function(dispatch){if(apiCall!==__WEBPACK_IMPORTED_MODULE_2__redux_bridge_bridge_methods__["h" /* GET_SESSION */]&&apiCall!==__WEBPACK_IMPORTED_MODULE_3__redux_jigsaw_jigsaw_methods__["x" /* GET_USER_INFO */]){dispatch(afterLogOut());}};}function afterLogOut(){return function(dispatch,getState){var params=Object(__WEBPACK_IMPORTED_MODULE_4_app_api_redux_watson_watson_config_selectors__["p" /* getQueryParamsForReload */])(getState());window.location.assign(Object(__WEBPACK_IMPORTED_MODULE_5_app_utils_route__["a" /* appendOrUpdateParams */])('/',params));};}function tryRedirectJigsawFailure(err,apiCall){return function(dispatch){if(err.errorCode===401||Object(__WEBPACK_IMPORTED_MODULE_0__jigsaw_helpers__["e" /* isCookieError */])(err)){dispatch(handleAccessError(apiCall));}};}function tryRedirectBridgeFailure(err,apiCall){return function(dispatch){if(err.status===401||Object(__WEBPACK_IMPORTED_MODULE_1__bridge_helpers__["a" /* isCookieError */])(err)){dispatch(handleAccessError(apiCall));}};}

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(435);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _Button=__webpack_require__(520);Object.defineProperty(exports,'default',{enumerable:!0,get:function get(){return _interopRequireDefault(_Button).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {/*!
 * @name JavaScript/NodeJS Merge v1.2.0
 * @author yeikos
 * @repository https://github.com/yeikos/js.merge

 * Copyright 2014 yeikos - MIT license
 * https://raw.github.com/yeikos/js.merge/master/LICENSE
 */

;(function(isNode) {

	/**
	 * Merge one or more objects 
	 * @param bool? clone
	 * @param mixed,... arguments
	 * @return object
	 */

	var Public = function(clone) {

		return merge(clone === true, false, arguments);

	}, publicName = 'merge';

	/**
	 * Merge two or more objects recursively 
	 * @param bool? clone
	 * @param mixed,... arguments
	 * @return object
	 */

	Public.recursive = function(clone) {

		return merge(clone === true, true, arguments);

	};

	/**
	 * Clone the input removing any reference
	 * @param mixed input
	 * @return mixed
	 */

	Public.clone = function(input) {

		var output = input,
			type = typeOf(input),
			index, size;

		if (type === 'array') {

			output = [];
			size = input.length;

			for (index=0;index<size;++index)

				output[index] = Public.clone(input[index]);

		} else if (type === 'object') {

			output = {};

			for (index in input)

				output[index] = Public.clone(input[index]);

		}

		return output;

	};

	/**
	 * Merge two objects recursively
	 * @param mixed input
	 * @param mixed extend
	 * @return mixed
	 */

	function merge_recursive(base, extend) {

		if (typeOf(base) !== 'object')

			return extend;

		for (var key in extend) {

			if (typeOf(base[key]) === 'object' && typeOf(extend[key]) === 'object') {

				base[key] = merge_recursive(base[key], extend[key]);

			} else {

				base[key] = extend[key];

			}

		}

		return base;

	}

	/**
	 * Merge two or more objects
	 * @param bool clone
	 * @param bool recursive
	 * @param array argv
	 * @return object
	 */

	function merge(clone, recursive, argv) {

		var result = argv[0],
			size = argv.length;

		if (clone || typeOf(result) !== 'object')

			result = {};

		for (var index=0;index<size;++index) {

			var item = argv[index],

				type = typeOf(item);

			if (type !== 'object') continue;

			for (var key in item) {

				var sitem = clone ? Public.clone(item[key]) : item[key];

				if (recursive) {

					result[key] = merge_recursive(result[key], sitem);

				} else {

					result[key] = sitem;

				}

			}

		}

		return result;

	}

	/**
	 * Get type of variable
	 * @param mixed input
	 * @return string
	 *
	 * @see http://jsperf.com/typeofvar
	 */

	function typeOf(input) {

		return ({}).toString.call(input).slice(8, -1).toLowerCase();

	}

	if (isNode) {

		module.exports = Public;

	} else {

		window[publicName] = Public;

	}

})(typeof module === 'object' && module && typeof module.exports === 'object' && module.exports);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(134)(module)))

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPrefixedValue;
var regex = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
module.exports = exports['default'];

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = findNearestElementMatchingTags;
/* harmony export (immutable) */ __webpack_exports__["b"] = findNearestElementMatchingAttribute;
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
/* harmony export (immutable) */ __webpack_exports__["i"] = loadScript;
/* unused harmony export loadScriptPromise */
/* harmony export (immutable) */ __webpack_exports__["j"] = loadScripts;
/* harmony export (immutable) */ __webpack_exports__["l"] = scrollIntoView;
/* harmony export (immutable) */ __webpack_exports__["h"] = isVisible;
/* harmony export (immutable) */ __webpack_exports__["g"] = isOpaque;
/* harmony export (immutable) */ __webpack_exports__["f"] = isOnScreen;
/* harmony export (immutable) */ __webpack_exports__["e"] = getFirstFocusableElement;
/* harmony export (immutable) */ __webpack_exports__["d"] = forceRedraw;
/* harmony export (immutable) */ __webpack_exports__["k"] = nodeListToArray;
function findNearestElementMatchingTags(el,tagNames){if(!el||!tagNames){return null;}var lowerCaseTags=tagNames.map(function(t){return t.toLowerCase();});if(el.tagName&&lowerCaseTags.indexOf(el.tagName.toLowerCase())!==-1){return el;}else if(el.parentNode){return findNearestElementMatchingTags(el.parentNode,tagNames);}return null;}function findNearestElementMatchingAttribute(el,attributeName,attributeValue){if(!el||!attributeName||!attributeValue){return null;}if(el.getAttribute(attributeName)===attributeValue){return el;}else if(el.parentNode){return findNearestElementMatchingAttribute(el.parentNode,attributeName,attributeValue);}return null;}function contains(outer,inner){return outer&&inner instanceof Node&&outer.contains(inner);}function loadScript(_ref){var src=_ref.src,onLoad=_ref.onLoad,onError=_ref.onError;var script=document.createElement('script');script.src=src;script.type='text/javascript';script.onload=onLoad;script.onerror=onError;var head=document.getElementsByTagName('head')[0];head.appendChild(script);}function loadScriptPromise(src){return new Promise(function(resolve,reject){loadScript({src:src,onLoad:function onLoad(){return resolve();},onError:function onError(){return reject();}});});}function loadScripts(){for(var _len=arguments.length,src=Array(_len),_key=0;_key<_len;_key++){src[_key]=arguments[_key];}return src.reduce(function(acc,cv){return acc.then(function(){return loadScriptPromise(cv);});},Promise.resolve());}// TODO: Currently only handles X
function findNearestScrollParent(node){function isScrollable(el){return getComputedStyle(el)['overflow-x']==='auto';}if(isScrollable(node)){return node;}else if(node.parentElement){return findNearestScrollParent(node.parentElement);}return null;}/**
 * Make sure the given child element is fully visible in it's scrollable
 * parent. If it's not, put it all the way to the left.
 * element.scrollIntoView can overscroll and look bad in IE11
 * TODO: Currently only handles X
 */function scrollIntoView(node){if(!node){return;}var parent=findNearestScrollParent(node);if(parent){var width=parent.offsetWidth;var scrollX=parent.scrollLeft;var itemX=node.offsetLeft;var itemWidth=node.offsetWidth;if(itemX<scrollX||itemX+itemWidth>scrollX+width){parent.scrollLeft=node.offsetLeft;}}}function isVisible(el){if(!el){return false;}var style=window.getComputedStyle(el);return style.display!=='none'&&style.visibility!=='hidden'&&style.opacity!=='0'&&(el.parentElement?isVisible(el.parentElement):true);}function isOpaque(el){if(!el){return false;}var style=window.getComputedStyle(el);return style.opacity==='1'&&(el.parentElement?isOpaque(el.parentElement):true);}function isOnScreen(el){if(!el){return false;}var rect=el.getBoundingClientRect();return rect.left+rect.width>0&&rect.left<window.innerWidth&&rect.top+rect.height>0&&rect.top<window.innerHeight;}// https://gomakethings.com/how-to-get-the-first-and-last-focusable-elements-in-the-dom/
function getFirstFocusableElement(node){var focusable=node.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');if(focusable.length>0){return focusable[0];}return null;}// https://stackoverflow.com/questions/3485365/how-can-i-force-webkit-to-redraw-repaint-to-propagate-style-changes
function forceRedraw(el){if(el){var current=el.style.display;el.style.display='none';// eslint-disable-next-line no-unused-vars
var h=el.offsetHeight;el.style.display=current;}}/**
 * NodeList does not support things like map, so you may want
 * to convert it to an array
 */function nodeListToArray(list){var items=[];for(var i=0;i<list.length;i++){items.push(list[i]);}return items;}

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_watson_watson_config_selectors__ = __webpack_require__(4);
var mapStateToProps=function mapStateToProps(state){return{theme:Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_watson_watson_config_selectors__["x" /* getTheme */])(state)};};function withTheme(ThemedComponent){return Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(ThemedComponent);}

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCurrentCfi;
/* harmony export (immutable) */ __webpack_exports__["b"] = getCurrentPage;
/* harmony export (immutable) */ __webpack_exports__["e"] = hasNextPage;
/* harmony export (immutable) */ __webpack_exports__["f"] = hasPrevPage;
/* harmony export (immutable) */ __webpack_exports__["g"] = isPageLoading;
/* harmony export (immutable) */ __webpack_exports__["d"] = getPageAspectRatio;
/* harmony export (immutable) */ __webpack_exports__["c"] = getDocViewportWidth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jigsaw_events__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_utils_objects__ = __webpack_require__(15);
function getCurrentCfi(state){var loads=getPageLoadsWithData(state);if(loads.length>0){return loads[0].cfi;}return null;}function getCurrentPage(state){return state.jigsaw[__WEBPACK_IMPORTED_MODULE_0__jigsaw_events__["BOOK_PAGE_BREAK"]].value;}function hasNextPage(state){return state.jigsaw[__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["D" /* HAS_NEXT_PAGE */]].data;}function hasPrevPage(state){return state.jigsaw[__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["E" /* HAS_PREV_PAGE */]].data;}function isPageLoading(state){return state.jigsaw.pageLoading;}function getPageLoadsWithData(state){return state.jigsaw[__WEBPACK_IMPORTED_MODULE_0__jigsaw_events__["PAGE_LOAD"]].filter(function(evt){return evt&&!Object(__WEBPACK_IMPORTED_MODULE_2_app_utils_objects__["d" /* isEmpty */])(evt);});}function getPageAspectRatio(state){var sizes=getPageLoadsWithData(state).map(function(cv){if(cv.docViewportHeight){return{w:cv.docViewportWidth,h:cv.docViewportHeight};}else{return{w:cv.boundingRectWidth,h:cv.boundingRectHeight};}});var isValid=sizes.reduce(function(acc,cv){return acc&&!!cv.w&&!!cv.h;},true);if(isValid){return sizes.reduce(function(acc,cv){return acc+cv.w/cv.h;},0);}return null;}function getDocViewportWidth(state){var data=getPageLoadsWithData(state);if(data.length>0){if(data[0].docViewportWidth){return data.reduce(function(acc,cv){return acc+cv.docViewportWidth;},0);}}return undefined;}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (arr, predicate, ctx) {
	if (typeof Array.prototype.findIndex === 'function') {
		return arr.findIndex(predicate, ctx);
	}

	if (typeof predicate !== 'function') {
		throw new TypeError('predicate must be a function');
	}

	var list = Object(arr);
	var len = list.length;

	if (len === 0) {
		return -1;
	}

	for (var i = 0; i < len; i++) {
		if (predicate.call(ctx, list[i], i, list)) {
			return i;
		}
	}

	return -1;
};


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOCALE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return THEME_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BRAND_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UIBASE_KEY; });
/* unused harmony export loadLocale */
/* harmony export (immutable) */ __webpack_exports__["e"] = loadBrand;
/* harmony export (immutable) */ __webpack_exports__["f"] = loadLocaleAndTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_route__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_merge__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__localize_modules__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_bridge_session_selectors__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_api_analytics_reporting__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_async__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__watson_config_selectors__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__redux_bridgesaw_bridgesaw_selectors__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__redux_bridge_users_utils__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_objects__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__cookies__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_chameleonjs__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_chameleonjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_chameleonjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_api_redux_watson_theme_actions__ = __webpack_require__(443);
var importForAll=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(state,importer,base){var bases,importers,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:bases=getConfigBases(state);if(base){bases.push(base);}importers=bases.map(function(b){return importer(b);});_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_8__utils_async__["a" /* importAll */])(importers);case 5:result=_context.sent;return _context.abrupt('return',result.filter(function(i){return!!i;}));case 7:case'end':return _context.stop();}}},_callee,this);}));return function importForAll(_x,_x2,_x3){return _ref.apply(this,arguments);};}();var fetchBrand=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(brandId){var localBrandData,remoteBrandData,brandToFetch;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:localBrandData={};remoteBrandData={};brandToFetch=brandId;_context3.prev=3;_context3.next=6;return __webpack_require__(437)("./"+brandId+'.json');case 6:localBrandData=_context3.sent;brandToFetch=localBrandData.inherit;delete localBrandData.inherit;_context3.next=13;break;case 11:_context3.prev=11;_context3.t0=_context3['catch'](3);case 13:_context3.prev=13;_context3.next=16;return __WEBPACK_IMPORTED_MODULE_14_chameleonjs___default.a.loadBrand(brandToFetch,'watson');case 16:remoteBrandData=_context3.sent;_context3.next=22;break;case 19:_context3.prev=19;_context3.t1=_context3['catch'](13);localBrandData={};case 22:return _context3.abrupt('return',__WEBPACK_IMPORTED_MODULE_3_merge___default.a.recursive(remoteBrandData,localBrandData));case 23:case'end':return _context3.stop();}}},_callee3,this,[[3,11],[13,19]]);}));return function fetchBrand(_x6){return _ref3.apply(this,arguments);};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var LOCALE_KEY='config.locale';var THEME_KEY='config.theme';var BRAND_KEY='config.brand';var UIBASE_KEY='config.uiBase';var DEFAULT_LOCALE='en';var UI_BASES=['kiddie','middle'];var UI_BASE_QUERY_PARAM='uiBase';var setUiBase=Object(__WEBPACK_IMPORTED_MODULE_6__redux_util_general_helpers__["e" /* makeActionCreator */])(UIBASE_KEY,'data');function getConfigBases(state){// Due to the way the dependencies work, config data loads twice:
// Once to get the base config only prior to loading the session, and again after
// the session has loaded to complete the config. uiBase and logged-in
// determination depend on the base config, so don't even try to load additional
// data during the first load phase, since it leads to js errors and such.
if(!Object(__WEBPACK_IMPORTED_MODULE_10__redux_bridgesaw_bridgesaw_selectors__["c" /* isSessionPending */])(state)&&Object(__WEBPACK_IMPORTED_MODULE_10__redux_bridgesaw_bridgesaw_selectors__["b" /* isLoggedIn */])(state)){var bases=[getUiBase(state)];if(Object(__WEBPACK_IMPORTED_MODULE_5__redux_bridge_session_selectors__["i" /* isTeacher */])(state)){bases.push('teacher');}return bases.filter(function(b){return!!b;});}return[];}function getUiBase(state){if(!Object(__WEBPACK_IMPORTED_MODULE_10__redux_bridgesaw_bridgesaw_selectors__["b" /* isLoggedIn */])(state)){// Don't load level-specific content if we don't need it
return null;}// Teacher login and internal testing
// Use cookie to maintain setting across reloads
var queryVal=Object(__WEBPACK_IMPORTED_MODULE_2__utils_route__["f" /* getQueryValue */])(UI_BASE_QUERY_PARAM);var cookieVal=Object(__WEBPACK_IMPORTED_MODULE_13__cookies__["d" /* getUiBaseCookie */])();var grade=Object(__WEBPACK_IMPORTED_MODULE_5__redux_bridge_session_selectors__["e" /* getGradeLevel */])(state);if(queryVal){if(UI_BASES.indexOf(queryVal)>=0){return queryVal;}return'middle';}else if(Object(__WEBPACK_IMPORTED_MODULE_9__watson_config_selectors__["E" /* isJigsawOnly */])(state)){return Object(__WEBPACK_IMPORTED_MODULE_9__watson_config_selectors__["f" /* getBrandCommon */])(state).jigsawOnly.reader;}else if(cookieVal&&!grade){if(UI_BASES.indexOf(cookieVal)>=0){return cookieVal;}return'middle';}// Just base it off of session for students
if(grade&&Object(__WEBPACK_IMPORTED_MODULE_11__redux_bridge_users_utils__["c" /* isKiddieUser */])(grade)){return'kiddie';}return'middle';}function loadLocale(locale){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch,getState){var localeData,defaultData,data,finalData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:locale=locale.split('_').join('-');dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_async_helpers__["f" /* createStartAction */])(LOCALE_KEY,locale));_context2.next=4;return importForAll(getState(),function(s){return function(){return __webpack_require__(142)("./"+locale+'/'+s+'.json');};},'common');case 4:localeData=_context2.sent;defaultData=[];if(!(locale!==DEFAULT_LOCALE)){_context2.next=10;break;}_context2.next=9;return importForAll(getState(),function(s){return function(){return __webpack_require__(142)("./"+DEFAULT_LOCALE+'/'+s+'.json');};},'common');case 9:defaultData=_context2.sent;case 10:data=[].concat(_toConsumableArray(localeData),_toConsumableArray(defaultData));finalData=__WEBPACK_IMPORTED_MODULE_3_merge___default.a.recursive.apply(__WEBPACK_IMPORTED_MODULE_3_merge___default.a,_toConsumableArray(data.reverse()));if(!(Object.keys(finalData).length>0)){_context2.next=19;break;}_context2.next=15;return Object(__WEBPACK_IMPORTED_MODULE_4__localize_modules__["a" /* localizeModules */])(locale);case 15:delete finalData.smartling;dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_async_helpers__["g" /* createSuccessAction */])(LOCALE_KEY,finalData));_context2.next=21;break;case 19:Object(__WEBPACK_IMPORTED_MODULE_7_app_api_analytics_reporting__["b" /* noticeError */])('Could not load any locale data for '+locale);dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_async_helpers__["c" /* createFailAction */])(LOCALE_KEY));case 21:case'end':return _context2.stop();}}},_callee2,this);}));return function(_x4,_x5){return _ref2.apply(this,arguments);};}();}// This is only used to determine the initial brand at load time in
// order to initialize the store. After the brand has loaded, you
// should ask redux for the brand id. This is so we do not have
// to maintain a brand query value through url changes.
function getStartBrand(){var urlBrand=window.location.hostname;var queryBrand=Object(__WEBPACK_IMPORTED_MODULE_2__utils_route__["f" /* getQueryValue */])('brand');return queryBrand||urlBrand;}function getStartLocale(brandLocale){var queryLocale=Object(__WEBPACK_IMPORTED_MODULE_2__utils_route__["f" /* getQueryValue */])('locale');return queryLocale||brandLocale||DEFAULT_LOCALE;}function loadBrand(){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch){var brand,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:brand=getStartBrand();dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_async_helpers__["f" /* createStartAction */])(BRAND_KEY,brand));_context4.next=4;return fetchBrand(brand);case 4:data=_context4.sent;if(!Object(__WEBPACK_IMPORTED_MODULE_12__utils_objects__["d" /* isEmpty */])(data)){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_async_helpers__["g" /* createSuccessAction */])(BRAND_KEY,data));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_async_helpers__["c" /* createFailAction */])(BRAND_KEY));Object(__WEBPACK_IMPORTED_MODULE_7_app_api_analytics_reporting__["b" /* noticeError */])('Could not load any brand for '+brand);}case 6:case'end':return _context4.stop();}}},_callee4,this);}));return function(_x7){return _ref4.apply(this,arguments);};}();}function loadLocaleAndTheme(){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch,getState){var uiBase,brand;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:uiBase=getUiBase(getState());dispatch(setUiBase(uiBase));// The query param may disappear as you navigate around. We need to persist
// the teacher's selection for reloads
if(uiBase){Object(__WEBPACK_IMPORTED_MODULE_13__cookies__["e" /* setUiBaseCookie */])(uiBase);}else{Object(__WEBPACK_IMPORTED_MODULE_13__cookies__["b" /* clearUiBaseCookie */])();}brand=Object(__WEBPACK_IMPORTED_MODULE_9__watson_config_selectors__["e" /* getBrand */])(getState());if(!Object(__WEBPACK_IMPORTED_MODULE_9__watson_config_selectors__["A" /* hasBrandError */])(getState())){dispatch(loadLocale(getStartLocale(brand.common.locale)));}else{dispatch(loadLocale(getStartLocale()));}dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_app_api_redux_watson_theme_actions__["a" /* loadTheme */])());case 6:case'end':return _context5.stop();}}},_callee5,this);}));return function(_x8,_x9){return _ref5.apply(this,arguments);};}();}

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withLoading;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_loadable__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_loadable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_ui_route_RedirectOnce__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_redux_route_routes__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_ui_core_common_CenteredLoader__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_api_analytics_reporting__ = __webpack_require__(14);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function Loader(props){function log(msg){Object(__WEBPACK_IMPORTED_MODULE_6_app_api_analytics_reporting__["b" /* noticeError */])(msg);}if(props.isLoading){if(props.timedOut){log('Loader timed out');return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_ui_route_RedirectOnce__["a" /* default */],{to:__WEBPACK_IMPORTED_MODULE_4__api_redux_route_routes__["T" /* SYSTEM_ERROR */]});}else if(props.pastDelay){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_ui_core_common_CenteredLoader__["a" /* default */],{fullScreen:true});}else{return null;}}else if(props.error){log('Loader error');return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_ui_route_RedirectOnce__["a" /* default */],{to:__WEBPACK_IMPORTED_MODULE_4__api_redux_route_routes__["T" /* SYSTEM_ERROR */]});}else{return null;}}function loaderWithDelay(componentLoader){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return componentLoader();case 2:result=_context.sent;return _context.abrupt('return',new Promise(function(resolve){setTimeout(function(){return resolve(result);},100);}));case 4:case'end':return _context.stop();}}},_callee,this);}));}function withLoading(componentLoader){return __WEBPACK_IMPORTED_MODULE_2_react_loadable___default()({loading:Loader,loader:loaderWithDelay(componentLoader)});}

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(45);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["a" /* default */])(a.state, b.state);
};

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrivateContentRenderer__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_redux_watson_watson_config_selectors__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_redux_route_routes__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RouteRendererInternal=function(_React$Component){_inherits(RouteRendererInternal,_React$Component);function RouteRendererInternal(){_classCallCheck(this,RouteRendererInternal);return _possibleConstructorReturn(this,(RouteRendererInternal.__proto__||Object.getPrototypeOf(RouteRendererInternal)).apply(this,arguments));}_createClass(RouteRendererInternal,[{key:'render',value:function render(){var _props=this.props,hasAccess=_props.hasAccess,redirectTo=_props.redirectTo,bridgeRequired=_props.bridgeRequired,jigsawOnly=_props.jigsawOnly,innerProps=_objectWithoutProperties(_props,['hasAccess','redirectTo','bridgeRequired','jigsawOnly']);var blocked=jigsawOnly&&bridgeRequired;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__PrivateContentRenderer__["a" /* default */],{component:__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],hasAccess:hasAccess&&!blocked,redirectTo:blocked?__WEBPACK_IMPORTED_MODULE_5__api_redux_route_routes__["G" /* FILE_NOT_FOUND */]:redirectTo,innerProps:innerProps});}}]);return RouteRendererInternal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){return{jigsawOnly:Object(__WEBPACK_IMPORTED_MODULE_4__api_redux_watson_watson_config_selectors__["E" /* isJigsawOnly */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(RouteRendererInternal));

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var randomFromSeed = __webpack_require__(568);

var ORIGINAL = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
var alphabet;
var previousSeed;

var shuffled;

function reset() {
    shuffled = false;
}

function setCharacters(_alphabet_) {
    if (!_alphabet_) {
        if (alphabet !== ORIGINAL) {
            alphabet = ORIGINAL;
            reset();
        }
        return;
    }

    if (_alphabet_ === alphabet) {
        return;
    }

    if (_alphabet_.length !== ORIGINAL.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. You submitted ' + _alphabet_.length + ' characters: ' + _alphabet_);
    }

    var unique = _alphabet_.split('').filter(function(item, ind, arr){
       return ind !== arr.lastIndexOf(item);
    });

    if (unique.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. These characters were not unique: ' + unique.join(', '));
    }

    alphabet = _alphabet_;
    reset();
}

function characters(_alphabet_) {
    setCharacters(_alphabet_);
    return alphabet;
}

function setSeed(seed) {
    randomFromSeed.seed(seed);
    if (previousSeed !== seed) {
        reset();
        previousSeed = seed;
    }
}

function shuffle() {
    if (!alphabet) {
        setCharacters(ORIGINAL);
    }

    var sourceArray = alphabet.split('');
    var targetArray = [];
    var r = randomFromSeed.nextValue();
    var characterIndex;

    while (sourceArray.length > 0) {
        r = randomFromSeed.nextValue();
        characterIndex = Math.floor(r * sourceArray.length);
        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
    }
    return targetArray.join('');
}

function getShuffled() {
    if (shuffled) {
        return shuffled;
    }
    shuffled = shuffle();
    return shuffled;
}

/**
 * lookup shuffled letter
 * @param index
 * @returns {string}
 */
function lookup(index) {
    var alphabetShuffled = getShuffled();
    return alphabetShuffled[index];
}

function get () {
  return alphabet || ORIGINAL;
}

module.exports = {
    get: get,
    characters: characters,
    seed: setSeed,
    lookup: lookup,
    shuffled: getShuffled
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _FormControl=__webpack_require__(609);Object.defineProperty(exports,'default',{enumerable:!0,get:function get(){return _interopRequireDefault(_FormControl).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAsyncReducerWithModify;
/* unused harmony export getAsyncHandlersWithModify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_array__ = __webpack_require__(34);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function getAsyncReducerWithModify(params){return Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__["a" /* createReducer */])(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["h" /* initialState */],getAsyncHandlersWithModify(params));}function getAsyncHandlersWithModify(_ref){var _ref2;var fetchKey=_ref.fetchKey,createKey=_ref.createKey,deleteKey=_ref.deleteKey,appendNode=_ref.appendNode,itemParam=_ref.itemParam,appendNodeCreate=_ref.appendNodeCreate,appendOnCreate=_ref.appendOnCreate;var baseListReducer=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["b" /* createBaseAsyncReducer */])(fetchKey,function(data){var result=data[appendNode].filter(function(item){return!!item[itemParam];}).map(function(item){return item[itemParam];});return Object.assign({},data,_defineProperty({},appendNode,result));});return _ref2={},_defineProperty(_ref2,Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["g" /* createSuccessAction */])(fetchKey).type,function(state,action){var result=baseListReducer(state,action);if(state.data){result.data[appendNode]=Object(__WEBPACK_IMPORTED_MODULE_2__utils_array__["d" /* removeDuplicateValues */])([].concat(_toConsumableArray(state.data[appendNode]),_toConsumableArray(result.data[appendNode])));}return result;}),_defineProperty(_ref2,Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["c" /* createFailAction */])(fetchKey).type,function(state,action){return baseListReducer(state,action);}),_defineProperty(_ref2,Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["f" /* createStartAction */])(fetchKey).type,function(state,action){return baseListReducer(state,action);}),_defineProperty(_ref2,Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["g" /* createSuccessAction */])(createKey).type,Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["k" /* makeDataUpdaterRequireData */])(function(state,action){var newData=[].concat(_toConsumableArray(state[appendNode]));var newItem=action.data[appendNodeCreate][itemParam];if(appendOnCreate){newData.push(newItem);}else{newData.unshift(newItem);}return Object.assign({},state,_defineProperty({// don't update offset, since we don't know where in the results this item would be
totalElements:state.totalElements+1},appendNode,newData));})),_defineProperty(_ref2,Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["f" /* createStartAction */])(deleteKey).type,Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["k" /* makeDataUpdaterRequireData */])(function(state,action){var paramStr=''+action.data[0][itemParam];var dataStrVals=state[appendNode].map(function(n){return''+n;});var index=dataStrVals.indexOf(paramStr);if(index===-1){return state;}var result=[].concat(_toConsumableArray(state[appendNode]));result.splice(index,1);return Object.assign({},state,_defineProperty({offset:state.offset-1,totalElements:state.totalElements-1},appendNode,result));})),_ref2;}

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withTheme__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objects__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styletron_client__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styletron_utils__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_api_analytics_reporting__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_color__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_utils_browser__ = __webpack_require__(61);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var styletron=new __WEBPACK_IMPORTED_MODULE_3_styletron_client__["a" /* default */]();function getRestProps(props){var component=props.component,render=props.render,children=props.children,dispatch=props.dispatch,restProps=_objectWithoutProperties(props,['component','render','children','dispatch']);return restProps;}function getStyleProps(props){var _getRestProps=getRestProps(props),theme=_getRestProps.theme,mergeClasses=_getRestProps.mergeClasses,styleProps=_objectWithoutProperties(_getRestProps,['theme','mergeClasses']);return styleProps;}var pseudo=['before','after','hover','focus','active','disabled','placeholder'];function getKey(fullKey){for(var i=0;i<pseudo.length;i++){if(fullKey.indexOf(pseudo[i])===0){var prefixed=':'+pseudo[i];if(pseudo[i]==='placeholder'){if(Object(__WEBPACK_IMPORTED_MODULE_7_app_utils_browser__["a" /* isEdge */])()){// https://github.com/styletron/styletron/issues/230
return'::-webkit-input-placeholder';}return'::placeholder';}return prefixed;}}return fullKey;}function getStyle(fullKey,color){var alpha=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'1';var char=alpha.charAt(0);var toMix=null;if(char==='-'||char==='+'){toMix='#FFFFFF';if(parseFloat(alpha)<0){toMix='#000000';}}var alphaNum=parseFloat(alpha);var colorVal=Object(__WEBPACK_IMPORTED_MODULE_6__utils_color__["a" /* hexToCssRgba */])(color,alphaNum);if(toMix){colorVal=Object(__WEBPACK_IMPORTED_MODULE_6__utils_color__["b" /* mix */])(color,toMix,Math.abs(alphaNum)*100);}for(var i=0;i<pseudo.length;i++){if(fullKey.indexOf(pseudo[i])===0){var styleName=fullKey.split(pseudo[i])[1];styleName=styleName.charAt(0).toLowerCase()+styleName.slice(1);return _defineProperty({},styleName,colorVal+' !important');}}return colorVal+' !important';}var SimpleThemer=function(_React$Component){_inherits(SimpleThemer,_React$Component);function SimpleThemer(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,SimpleThemer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=SimpleThemer.__proto__||Object.getPrototypeOf(SimpleThemer)).call.apply(_ref2,[this].concat(args))),_this),_this.state={key:null,classes:[]},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SimpleThemer,[{key:'render',value:function render(){var allClasses=this.state.classes.concat(this.props.mergeClasses);var joinedClasses=allClasses.join(' ');if(this.props.render){return this.props.render(joinedClasses);}else if(this.props.component){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.props.component,{className:joinedClasses},this.props.children);}return null;}}]);return SimpleThemer;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);SimpleThemer.getDerivedStateFromProps=function(props){if(!props.theme){return[];}var styleProps=getStyleProps(props);var classes=Object.keys(styleProps).map(function(cv){if(cv&&props[cv]){var desiredStyle=Object(__WEBPACK_IMPORTED_MODULE_2__utils_objects__["b" /* findKeyInObj */])(props.theme,props[cv]);if(desiredStyle){var _desiredStyle$split=desiredStyle.split('@'),_desiredStyle$split2=_slicedToArray(_desiredStyle$split,2),colorName=_desiredStyle$split2[0],alpha=_desiredStyle$split2[1];var color=props.theme.colors[colorName];if(color){var key=getKey(cv);var style=getStyle(cv,color,alpha);try{return Object(__WEBPACK_IMPORTED_MODULE_4_styletron_utils__["a" /* injectStyle */])(styletron,_defineProperty({},key,style));}catch(e){Object(__WEBPACK_IMPORTED_MODULE_5_app_api_analytics_reporting__["b" /* noticeError */])('Failed to inject style '+key+' '+cv+' '+props[cv]+' '+JSON.stringify(style));return null;}}}}if(props[cv]){Object(__WEBPACK_IMPORTED_MODULE_5_app_api_analytics_reporting__["b" /* noticeError */])('Missing Color: '+props[cv]);}return null;}).filter(function(e){return e!==null;});return{classes:classes};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__withTheme__["a" /* default */])(SimpleThemer));

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = isTouchDevice;
/* harmony export (immutable) */ __webpack_exports__["b"] = isFirefox;
/* harmony export (immutable) */ __webpack_exports__["f"] = isSafari;
/* harmony export (immutable) */ __webpack_exports__["d"] = isIEorEdge;
/* harmony export (immutable) */ __webpack_exports__["c"] = isIENotEdge;
/* harmony export (immutable) */ __webpack_exports__["a"] = isEdge;
/* harmony export (immutable) */ __webpack_exports__["e"] = isIOS;
/* harmony export (immutable) */ __webpack_exports__["i"] = supportsSvgCssAnimation;
/* harmony export (immutable) */ __webpack_exports__["h"] = supportsDownloadAttribute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bowser__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bowser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bowser__);
function isTouchDevice(){return'ontouchstart'in document.documentElement;}function isFirefox(){return __WEBPACK_IMPORTED_MODULE_0_bowser___default.a.firefox;}function isSafari(){return __WEBPACK_IMPORTED_MODULE_0_bowser___default.a.safari;}function isIEorEdge(){return __WEBPACK_IMPORTED_MODULE_0_bowser___default.a.msedge||__WEBPACK_IMPORTED_MODULE_0_bowser___default.a.msie;}function isIENotEdge(){return __WEBPACK_IMPORTED_MODULE_0_bowser___default.a.msie;}function isEdge(){return __WEBPACK_IMPORTED_MODULE_0_bowser___default.a.msedge;}function isIOS(){return __WEBPACK_IMPORTED_MODULE_0_bowser___default.a.ios;}function supportsSvgCssAnimation(){// Should be able to allow msedge once this is fixed:
// https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6493460/
return!isIEorEdge();}function supportsDownloadAttribute(){return'download'in document.createElement('a');}

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CenteredLoader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_ui_core_common_Loading__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_CenteredLoader_css__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_CenteredLoader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_CenteredLoader_css__);
function CenteredLoader(_ref){var fullScreen=_ref.fullScreen,fullScreenFlex=_ref.fullScreenFlex,children=_ref.children;var classes=['CenteredLoader'];if(fullScreen){classes.push('CenteredLoader--FullScreen');}if(fullScreenFlex){classes.push('CenteredLoader--FullScreenFlex');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.join(' ')},children||__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_app_ui_core_common_Loading__["a" /* default */],null));}

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(195);
// Random uid, suitable for internal use (e.g. auto-generated element IDs)
function getUid(){var context=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'UID';var date=new Date().valueOf().toString(36);var rand=Object(__WEBPACK_IMPORTED_MODULE_0__number__["d" /* getRandomInt */])(0,100000000).toString(36);return context+'.'+date+'.'+rand;}

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = HundredPercentContainer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_HundredPercentContainer_css__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_HundredPercentContainer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_HundredPercentContainer_css__);
function HundredPercentContainer(_ref){var children=_ref.children,_ref$id=_ref.id,id=_ref$id===undefined?null:_ref$id,_ref$className=_ref.className,className=_ref$className===undefined?'':_ref$className,style=_ref.style,flex=_ref.flex,scroll=_ref.scroll,onScroll=_ref.onScroll;var classes=['HundredPercentContainer'];if(flex){classes.push('HundredPercentContainer--Flex');}if(scroll){classes.push('HundredPercentContainer--Scroll');}if(className){classes.push(className);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.join(' '),id:id,style:style,onScroll:onScroll},children);}

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getInternalReaderUrl;
/* harmony export (immutable) */ __webpack_exports__["f"] = getReaderUrlWithHost;
/* harmony export (immutable) */ __webpack_exports__["g"] = getRedirectUrl;
/* harmony export (immutable) */ __webpack_exports__["a"] = getBookshelfReaderRedirectUrl;
/* harmony export (immutable) */ __webpack_exports__["e"] = getNewAssigmentUrl;
/* harmony export (immutable) */ __webpack_exports__["c"] = getEditAssignmentUrl;
/* harmony export (immutable) */ __webpack_exports__["h"] = getViewAssignmentUrl;
/* harmony export (immutable) */ __webpack_exports__["b"] = getBookshelfViewAssignmentUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_redux_route_routes__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_route__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_ui_pages_redirect_AssignmentCreatorRedirect__ = __webpack_require__(143);
function getInternalReaderUrl(isbn){return __WEBPACK_IMPORTED_MODULE_0__api_redux_route_routes__["P" /* READER_BASE */]+'/'+isbn;}function getReaderUrlWithHost(isbn){return Object(__WEBPACK_IMPORTED_MODULE_1__utils_route__["c" /* getOrigin */])()+getInternalReaderUrl(isbn);}function getRedirectUrl(destination){var params=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var url=__WEBPACK_IMPORTED_MODULE_0__api_redux_route_routes__["R" /* REDIRECT_BASE */]+'/'+encodeURIComponent(destination);return Object(__WEBPACK_IMPORTED_MODULE_1__utils_route__["a" /* appendOrUpdateParams */])(url,params);}function getBookshelfReaderRedirectUrl(url,vbid){return __WEBPACK_IMPORTED_MODULE_0__api_redux_route_routes__["o" /* BOOKSHELF_READER_REDIRECT_BASE */]+'/'+vbid+'/'+encodeURIComponent(url);}function getNewAssigmentUrl(vbid){return __WEBPACK_IMPORTED_MODULE_0__api_redux_route_routes__["m" /* ASSIGNMENT_CREATOR_BASE */]+'/'+__WEBPACK_IMPORTED_MODULE_2_app_ui_pages_redirect_AssignmentCreatorRedirect__["NEW"]+'/'+vbid;}function getEditAssignmentUrl(vbid,assignmentId){return __WEBPACK_IMPORTED_MODULE_0__api_redux_route_routes__["m" /* ASSIGNMENT_CREATOR_BASE */]+'/'+__WEBPACK_IMPORTED_MODULE_2_app_ui_pages_redirect_AssignmentCreatorRedirect__["EDIT"]+'/'+vbid+'/'+assignmentId;}function getViewAssignmentUrl(vbid,assignmentId){return __WEBPACK_IMPORTED_MODULE_0__api_redux_route_routes__["m" /* ASSIGNMENT_CREATOR_BASE */]+'/'+__WEBPACK_IMPORTED_MODULE_2_app_ui_pages_redirect_AssignmentCreatorRedirect__["VIEW"]+'/'+vbid+'/'+assignmentId;}function getBookshelfViewAssignmentUrl(base,vbid,assignmentId){return'https:'+base+'/#/books/'+vbid+'/assignment/'+assignmentId;}

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return markSeen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reset; });
/* harmony export (immutable) */ __webpack_exports__["c"] = tryResetOnboarding;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_api_redux_ui_common_onboarding_selectors__ = __webpack_require__(213);
var markSeen=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["e" /* makeActionCreator */])('onboarding.markSeen','id');var reset=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["e" /* makeActionCreator */])('onboarding.reset');function tryResetOnboarding(){return function(dispatch,getState){var expires=Object(__WEBPACK_IMPORTED_MODULE_2_app_api_redux_ui_common_onboarding_selectors__["a" /* getExpiration */])(getState());if(expires&&__WEBPACK_IMPORTED_MODULE_1_moment___default()(expires).isBefore(__WEBPACK_IMPORTED_MODULE_1_moment___default()())){dispatch(reset());}};}

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isStringDebugEnabled;
/* harmony export (immutable) */ __webpack_exports__["c"] = pointingToProd;
/* harmony export (immutable) */ __webpack_exports__["a"] = isAssetStatusEnabled;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dev_keys__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_cookie__ = __webpack_require__(81);
function isStringDebugEnabled(state){return state.dev[__WEBPACK_IMPORTED_MODULE_0__dev_keys__["b" /* TOGGLE_STRING_DEBUG */]];}function pointingToProd(){return Object(__WEBPACK_IMPORTED_MODULE_1__utils_cookie__["a" /* getCookie */])('productionJigsaw')==='true';}function isAssetStatusEnabled(state){return state.dev[__WEBPACK_IMPORTED_MODULE_0__dev_keys__["a" /* TOGGLE_ASSET_STATUS */]];}

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hexToRgbComponents */
/* harmony export (immutable) */ __webpack_exports__["a"] = hexToCssRgba;
/* harmony export (immutable) */ __webpack_exports__["b"] = mix;
// https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
function hexToRgbComponents(hex){// Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
var shorthandRegex=/^#?([a-f\d])([a-f\d])([a-f\d])$/i;hex=hex.replace(shorthandRegex,function(m,r,g,b){return r+r+g+g+b+b;});var result=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);return result?{r:parseInt(result[1],16),g:parseInt(result[2],16),b:parseInt(result[3],16)}:null;}function hexToCssRgba(hex){var alpha=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var components=hexToRgbComponents(hex);if(components){return'rgba('+components.r+', '+components.g+', '+components.b+', '+alpha+')';}return null;}// https://gist.github.com/jedfoster/7939513
function mix(c1,c2,weight){function d2h(d){return d.toString(16);}// convert a decimal value to hex
function h2d(h){return parseInt(h,16);}// convert a hex value to decimal
weight=typeof weight!=='undefined'?weight:50;// set the weight to 50%, if that argument is omitted
var color='#';for(var i=1;i<=5;i+=2){// loop through each of the 3 hex pairs—red, green, and blue
var v1=h2d(c1.substr(i,2));// extract the current pairs
var v2=h2d(c2.substr(i,2));// combine the current pairs from each source color, according to the specified weight
var val=d2h(Math.floor(v2+(v1-v2)*(weight/100.0)));while(val.length<2){val='0'+val;}// prepend a '0' if val results in a single digit
color+=val;// concatenate val to our new color string
}return color;// PROFIT!
}

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withUiBase__ = __webpack_require__(148);
function SelectUIBase(_ref){var uiBase=_ref.uiBase,children=_ref.children;if(uiBase==='kiddie'){return children[0];}return children[1];}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__withUiBase__["a" /* default */])(SelectUIBase));

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = once;
/* harmony export (immutable) */ __webpack_exports__["a"] = argsToArray;
/* harmony export (immutable) */ __webpack_exports__["b"] = makePrevValReturner;
function once(fn){var called=false;return function(){if(!called){called=true;return fn.apply(undefined,arguments);}return null;};}function argsToArray(args){return[].slice.call(args);}function makePrevValReturner(fn){var prevVal=null;var currentVal=null;return function(){var result=fn.apply(undefined,arguments);if(result!==currentVal){prevVal=currentVal;currentVal=result;}return prevVal;};}

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REMOVE; });
/* harmony export (immutable) */ __webpack_exports__["c"] = addOrUpdateClass;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return removeClass; });
/* harmony export (immutable) */ __webpack_exports__["e"] = removeExpiredClasses;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__known_class_selectors__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
var ADD='known-classes.add';var REMOVE='known-classes.remove';var addOrUpdateClassObj=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["e" /* makeActionCreator */])(ADD,'code','name');function addOrUpdateClass(code,name){return function(dispatch){dispatch(addOrUpdateClassObj(code,name));};}var removeClass=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["e" /* makeActionCreator */])(REMOVE,'code');function removeExpiredClasses(){return function(dispatch,getState){var classes=Object(__WEBPACK_IMPORTED_MODULE_1__known_class_selectors__["a" /* getAllClasses */])(getState());classes.forEach(function(c){if(__WEBPACK_IMPORTED_MODULE_2_moment___default()(c.expires).isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()())){dispatch(removeClass(c.code));}});};}

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(77);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isLoggedIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = isSessionPending;
/* harmony export (immutable) */ __webpack_exports__["a"] = hasCookieError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_watson_watson_config_selectors__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_jigsaw_user_info_selectors__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_bridge_session_selectors__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_jigsaw_jigsaw_selectors__ = __webpack_require__(30);
function isLoggedIn(state){if(Object(__WEBPACK_IMPORTED_MODULE_0__redux_watson_watson_config_selectors__["E" /* isJigsawOnly */])(state)){return Object(__WEBPACK_IMPORTED_MODULE_1__redux_jigsaw_user_info_selectors__["c" /* isLoggedInToJigsaw */])(state);}return Object(__WEBPACK_IMPORTED_MODULE_2__redux_bridge_session_selectors__["h" /* isLoggedInToBridge */])(state);}function isSessionPending(state){return Object(__WEBPACK_IMPORTED_MODULE_1__redux_jigsaw_user_info_selectors__["b" /* isJigsawSessionPending */])(state)||Object(__WEBPACK_IMPORTED_MODULE_2__redux_bridge_session_selectors__["g" /* isBridgeSessionPending */])(state);}function hasCookieError(state){return Object(__WEBPACK_IMPORTED_MODULE_3__redux_jigsaw_jigsaw_selectors__["l" /* hasCookieError */])(state)||Object(__WEBPACK_IMPORTED_MODULE_2__redux_bridge_session_selectors__["f" /* hasCookieError */])(state);}

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUserProfile;
/* unused harmony export devicesHaveBeenFetched */
/* unused harmony export getActiveUserDevices */
/* unused harmony export devicesLoading */
/* unused harmony export hasDevicesError */
/* harmony export (immutable) */ __webpack_exports__["c"] = isLoggedInToJigsaw;
/* harmony export (immutable) */ __webpack_exports__["b"] = isJigsawSessionPending;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_util_async_helpers__ = __webpack_require__(2);
function getUserProfile(state){var base=state.jigsaw[__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["x" /* GET_USER_INFO */]].data;return base?base.user:{};}function devicesHaveBeenFetched(state){return!!state.jigsaw.devices.successQuery;}function getActiveUserDevices(state){var base=state.jigsaw.devices.data;return base&&base.devices?base.devices.filter(function(d){return d.active;}):[];}function devicesLoading(state){return state.jigsaw.devices.isFetching;}function hasDevicesError(state){return state.jigsaw.devices.hasError;}function isLoggedInToJigsaw(state){var base=state.jigsaw[__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["x" /* GET_USER_INFO */]];return!Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_async_helpers__["i" /* isPending */])(base)&&!base.hasError;}function isJigsawSessionPending(state){return Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_async_helpers__["i" /* isPending */])(state.jigsaw[__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["x" /* GET_USER_INFO */]]);}

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = setCookie;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeCookie;
/* harmony export (immutable) */ __webpack_exports__["a"] = getCookie;
// http://www.w3schools.com/js/js_cookies.asp
// Set a browser cookie
function setCookie(cname,cvalue,exdays){var d=new Date();d.setTime(d.getTime()+exdays*24*60*60*1000);var expires='expires='+d.toUTCString();document.cookie=cname+'='+cvalue+'; '+expires+';path=/';}function removeCookie(cname){setCookie(cname,false,-1);}// Get a browser cookie
function getCookie(cname){var name=cname+'=';var ca=document.cookie.split(';');for(var i=0;i<ca.length;i++){var c=ca[i];while(c.charAt(0)===' '){c=c.substring(1);}if(c.indexOf(name)===0){return c.substring(name.length,c.length);}}return'';}

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TOGGLE_STRING_DEBUG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOGGLE_ASSET_STATUS; });
var TOGGLE_STRING_DEBUG='dev.toggleStringDebug';var TOGGLE_ASSET_STATUS='dev.toggleAssetStatus';

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RedirectOnce__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_redux_route_routes__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_api_analytics_reporting__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PrivateContentRenderer=function(_React$Component){_inherits(PrivateContentRenderer,_React$Component);function PrivateContentRenderer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PrivateContentRenderer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PrivateContentRenderer.__proto__||Object.getPrototypeOf(PrivateContentRenderer)).call.apply(_ref,[this].concat(args))),_this),_this.state={hasError:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PrivateContentRenderer,[{key:'componentDidCatch',value:function componentDidCatch(e){Object(__WEBPACK_IMPORTED_MODULE_3_app_api_analytics_reporting__["b" /* noticeError */])(e);this.setState({hasError:true});}},{key:'renderPrivateContent',value:function renderPrivateContent(){var ProtectedComponent=this.props.component;if(this.props.render){return this.props.render(this.props.innerProps);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProtectedComponent,this.props.innerProps);}}},{key:'renderRedirect',value:function renderRedirect(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RedirectOnce__["a" /* default */],{to:this.props.redirectTo});}},{key:'render',value:function render(){if(this.state.hasError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RedirectOnce__["a" /* default */],{to:__WEBPACK_IMPORTED_MODULE_2__api_redux_route_routes__["T" /* SYSTEM_ERROR */]});}else if(this.props.hasAccess){return this.renderPrivateContent();}return this.renderRedirect();}}]);return PrivateContentRenderer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);PrivateContentRenderer.defaultProps={innerProps:{}};/* harmony default export */ __webpack_exports__["a"] = (PrivateContentRenderer);

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _propTypes = __webpack_require__(1);

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactLifecyclesCompat = __webpack_require__(85);

var _PropTypes = __webpack_require__(154);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/741op4mmj0?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 *
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;

    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null // allows for nested Transitions
    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return { status: EXITED };
    }
    return null;
  };

  // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null

  //   if (prevProps !== this.props) {
  //     const { status } = this.state

  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }

  //   return { nextStatus }
  // }

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;


      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var nextStatus = arguments[1];

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    return pt.apply(undefined, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func

  // Name the function so it is clearer in the documentation
} : {};function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = (0, _reactLifecyclesCompat.polyfill)(Transition);

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;

var _exenv = __webpack_require__(151);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _FormGroup=__webpack_require__(586);Object.defineProperty(exports,'default',{enumerable:!0,get:function get(){return _interopRequireDefault(_FormGroup).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony export (immutable) */ __webpack_exports__["b"] = trackEvent;
/* harmony export (immutable) */ __webpack_exports__["c"] = trackPageView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dom__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objects__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_func__ = __webpack_require__(70);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var pendingData=[];var gtag=function gtag(){pendingData.push(arguments);};var trackingCode=null;function init(code){trackingCode=code;Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["i" /* loadScript */])({src:'https://www.googletagmanager.com/gtag/js?id='+code,onLoad:function onLoad(){window.dataLayer=window.dataLayer||[];gtag=function gtag(){window.dataLayer.push(arguments);};gtag('js',new Date());gtag('config',code,{send_page_view:false});pendingData.forEach(function(args){var arr=Object(__WEBPACK_IMPORTED_MODULE_2__utils_func__["a" /* argsToArray */])(args);if(arr[0]==='config'){arr[1]=trackingCode;}gtag.apply(undefined,_toConsumableArray(arr));});pendingData=[];},onError:function onError(){gtag=function gtag(){};}});}function trackEvent(category,action,label,value){var data={event_category:category,event_label:label,value:value};gtag('event',action,Object(__WEBPACK_IMPORTED_MODULE_1__utils_objects__["e" /* stripNullAndUndefined */])(data));}function trackPageView(path){var loc=window.location;gtag('config',trackingCode,{page_path:path,page_location:loc.protocol+'//'+loc.host+path,// HistoryTracker watches router, but title won't be accurate until route renders
page_title:''});}

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__persistReducer__ = __webpack_require__(90);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__persistReducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__persistCombineReducers__ = __webpack_require__(684);
/* unused harmony reexport persistCombineReducers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__persistStore__ = __webpack_require__(686);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__persistStore__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createMigrate__ = __webpack_require__(687);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__createMigrate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransform__ = __webpack_require__(688);
/* unused harmony reexport createTransform */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getStoredState__ = __webpack_require__(180);
/* unused harmony reexport getStoredState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createPersistoid__ = __webpack_require__(179);
/* unused harmony reexport createPersistoid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__purgeStoredState__ = __webpack_require__(181);
/* unused harmony reexport purgeStoredState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(31);
/* unused harmony namespace reexport */











/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = persistReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stateReconciler_autoMergeLevel1__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createPersistoid__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getStoredState__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__purgeStoredState__ = __webpack_require__(181);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var DEFAULT_TIMEOUT = 5000;
/*
  @TODO add validation / handling for:
  - persisting a reducer which has nested _persist
  - handling actions that fire before reydrate is called
*/
function persistReducer(config, baseReducer) {
  if (false) {
    if (!config) throw new Error('config is required for persistReducer');
    if (!config.key) throw new Error('key is required in persistor config');
    if (!config.storage) throw new Error("redux-persist: config.storage is required. Try using one of the provided storage engines `import storage from 'redux-persist/lib/storage'`");
  }

  var version = config.version !== undefined ? config.version : __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DEFAULT_VERSION */];
  var debug = config.debug || false;
  var stateReconciler = config.stateReconciler === undefined ? __WEBPACK_IMPORTED_MODULE_1__stateReconciler_autoMergeLevel1__["a" /* default */] : config.stateReconciler;
  var getStoredState = config.getStoredState || __WEBPACK_IMPORTED_MODULE_3__getStoredState__["a" /* default */];
  var timeout = config.timeout !== undefined ? config.timeout : DEFAULT_TIMEOUT;
  var _persistoid = null;
  var _purge = false;
  var _paused = true;
  var conditionalUpdate = function conditionalUpdate(state) {
    // update the persistoid only if we are rehydrated and not paused
    state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
    return state;
  };

  return function (state, action) {
    var _ref = state || {},
        _persist = _ref._persist,
        rest = _objectWithoutProperties(_ref, ['_persist']);

    var restState = rest;

    if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* PERSIST */]) {
      var _sealed = false;
      var _rehydrate = function _rehydrate(payload, err) {
        // dev warning if we are already sealed
        if (false) console.error('redux-persist: rehydrate for "' + config.key + '" called after timeout.', payload, err);

        // only rehydrate if we are not already sealed
        if (!_sealed) {
          action.rehydrate(config.key, payload, err);
          _sealed = true;
        }
      };
      timeout && setTimeout(function () {
        !_sealed && _rehydrate(undefined, new Error('redux-persist: persist timed out for persist key "' + config.key + '"'));
      }, timeout);

      // @NOTE PERSIST resumes if paused.
      _paused = false;

      // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set
      if (!_persistoid) _persistoid = Object(__WEBPACK_IMPORTED_MODULE_2__createPersistoid__["a" /* default */])(config);

      // @NOTE PERSIST can be called multiple times, noop after the first
      if (_persist) return state;
      if (typeof action.rehydrate !== 'function' || typeof action.register !== 'function') throw new Error('redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.');

      action.register(config.key);

      getStoredState(config).then(function (restoredState) {
        var migrate = config.migrate || function (s, v) {
          return Promise.resolve(s);
        };
        migrate(restoredState, version).then(function (migratedState) {
          _rehydrate(migratedState);
        }, function (migrateErr) {
          if (false) console.error('redux-persist: migration error', migrateErr);
          _rehydrate(undefined, migrateErr);
        });
      }, function (err) {
        _rehydrate(undefined, err);
      });

      return _extends({}, baseReducer(restState, action), {
        _persist: { version: version, rehydrated: false }
      });
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* PURGE */]) {
      _purge = true;
      action.result(Object(__WEBPACK_IMPORTED_MODULE_4__purgeStoredState__["a" /* default */])(config));
      return _extends({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FLUSH */]) {
      action.result(_persistoid && _persistoid.flush());
      return _extends({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* PAUSE */]) {
      _paused = true;
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* REHYDRATE */]) {
      // noop on restState if purging
      if (_purge) return _extends({}, restState, {
        _persist: _extends({}, _persist, { rehydrated: true })

        // @NOTE if key does not match, will continue to default else below
      });if (action.key === config.key) {
        var reducedState = baseReducer(restState, action);
        var inboundState = action.payload;
        // only reconcile state if stateReconciler and inboundState are both defined
        var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;

        var _newState = _extends({}, reconciledRest, {
          _persist: _extends({}, _persist, { rehydrated: true })
        });
        return conditionalUpdate(_newState);
      }
    }

    // if we have not already handled PERSIST, straight passthrough
    if (!_persist) return baseReducer(state, action);

    // run base reducer:
    // is state modified ? return original : return updated
    var newState = baseReducer(restState, action);
    if (newState === restState) return state;else {
      newState._persist = _persist;
      return conditionalUpdate(newState);
    }
  };
}

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LocaleStringTest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_watson_watson_config_selectors__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_utils_strings__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_ui_core_common_UnsafeHtml__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_api_analytics_reporting__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
function LocaleString(_ref){var id=_ref.id,value=_ref.value,_ref$params=_ref.params,params=_ref$params===undefined?{}:_ref$params,unsafeHtml=_ref.unsafeHtml,noSpan=_ref.noSpan,count=_ref.count;function getInnerContent(){var content=value;if(count!==undefined){params=Object.assign({count:count},params);content=Object(__WEBPACK_IMPORTED_MODULE_2_app_utils_strings__["j" /* replaceParamsSingularPlural */])(value[1],value[2],params,count);}else if(params){content=Object(__WEBPACK_IMPORTED_MODULE_2_app_utils_strings__["i" /* replaceParams */])(value,params);}if(!content){Object(__WEBPACK_IMPORTED_MODULE_5_app_api_analytics_reporting__["b" /* noticeError */])('Missing message: '+id);return'';}if(unsafeHtml){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_ui_core_common_UnsafeHtml__["a" /* default */],null,content);}return content;}var content=getInnerContent();if(noSpan||typeof content!=='string'){return getInnerContent();}return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{'data-msg-id':id},content);}LocaleString.propTypes={id:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,unsafeHtml:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,noSpan:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool};var mapStateToProps=function mapStateToProps(state,ownProps){return{value:Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_watson_watson_config_selectors__["r" /* getString */])(state,ownProps.id)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(LocaleString));var LocaleStringTest=LocaleString;

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Button;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_Button_css__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_Button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_Button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseTextLink__ = __webpack_require__(95);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/**
 * Just a button, plus:
 *   - auto-sets type to "button"
 *   - uses pointer cursor when enabled
 * Accepts custom css classes
 *
 * Will render an inline-block link if you give it a to or href property.
 * (Helpful for styled buttons that need to support multiple modes of linking)
 */function Button(_ref){var children=_ref.children,_ref$type=_ref.type,type=_ref$type===undefined?'button':_ref$type,className=_ref.className,dispatch=_ref.dispatch,domRef=_ref.domRef,restProps=_objectWithoutProperties(_ref,['children','type','className','dispatch','domRef']);var classes=['Button'];if(restProps.to||restProps.href){classes.push('Button--Link');}if(className){classes.push(className);}if(restProps.to||restProps.href){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BaseTextLink__["a" /* default */],Object.assign({},restProps,{className:classes.join(' ')}),children);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',Object.assign({type:type,className:classes.join(' ')},restProps,{ref:function ref(el){return domRef&&domRef(el);}}),children);}

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return INSET_CLASSNAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BORDER_CLASSNAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FOCUS_SIBLING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return NO_FOCUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FOCUS_CHILD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FOCUS_CHILD_DEPTH_2; });
/* unused harmony export FOCUS_CHILD_BORDER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IMPORTANT_CLASSNAME; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__withTheme__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__color_extractor__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_ThemedFocus_css__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_ThemedFocus_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_ThemedFocus_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var INSET_CLASSNAME='ThemedFocus__Inset';var BORDER_CLASSNAME='ThemedFocus__Border';var FOCUS_SIBLING='ThemedFocus__Sibling';var NO_FOCUS='ThemedFocus__None';var FOCUS_CHILD='ThemedFocus__Child';var FOCUS_CHILD_DEPTH_2='ThemedFocus__ChildDepth2';var FOCUS_CHILD_BORDER='ThemedFocus__ChildBorder';// You probably don't want this unless you really want to override
// an existing shadow and don't find a border or outline sufficient
// e.g. something crazy made out of :after and :before
var IMPORTANT_CLASSNAME='ThemedFocus__Important';var enabledClass='ThemedFocus--Enabled';var ThemedFocus=function(_React$Component){_inherits(ThemedFocus,_React$Component);function ThemedFocus(){_classCallCheck(this,ThemedFocus);return _possibleConstructorReturn(this,(ThemedFocus.__proto__||Object.getPrototypeOf(ThemedFocus)).apply(this,arguments));}_createClass(ThemedFocus,[{key:'componentDidMount',value:function componentDidMount(){this.updateStyles();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.theme!==this.props.theme){this.updateStyles();}}},{key:'updateStyles',value:function updateStyles(){var sheet=document.styleSheets[0];var colors=Object(__WEBPACK_IMPORTED_MODULE_2__color_extractor__["b" /* getColors */])(this.props.theme,'common.focus.default');var color=colors['common.focus.default'];var w='3px';var notClasses=[IMPORTANT_CLASSNAME,INSET_CLASSNAME,BORDER_CLASSNAME,NO_FOCUS].map(function(c){return'.'+c;});// HACK! We want to preserve vstui focus styles even when our global focus style stuff is enabled.
// It's not the end of the world if these change out from under us; the focus will just look different
var vstuiPrefixes=['Button__button','TextField__InputControl','TableHeaderCell__sort'].map(function(c){return'[class*='+c+']';});var nots=notClasses.concat(vstuiPrefixes).map(function(item){return':not('+item+')';}).join('');sheet.insertRule('.'+enabledClass+' *'+nots+':focus { box-shadow: 0 0 0 '+w+' '+color+'; }',0);sheet.insertRule('.'+enabledClass+' .'+IMPORTANT_CLASSNAME+':focus { box-shadow: 0 0 0 '+w+' '+color+' !important; }',0);sheet.insertRule('.'+enabledClass+' .'+INSET_CLASSNAME+':focus { box-shadow: inset 0 0 0 '+w+' '+color+'; }',0);sheet.insertRule('.'+enabledClass+' .'+BORDER_CLASSNAME+':focus { border: '+w+' solid '+color+'; }',0);sheet.insertRule('.'+enabledClass+' *:focus ~ .'+FOCUS_SIBLING+' { box-shadow: 0 0 0 '+w+' '+color+'; }',0);sheet.insertRule('.'+enabledClass+' *:focus > .'+FOCUS_CHILD+' { box-shadow: 0 0 0 '+w+' '+color+'; }',0);sheet.insertRule('.'+enabledClass+' *:focus > .'+FOCUS_CHILD_BORDER+' { border: '+w+' solid '+color+'; }',0);sheet.insertRule('.'+enabledClass+' *:focus > * > .'+FOCUS_CHILD_DEPTH_2+' { box-shadow: 0 0 0 '+w+' '+color+'; }',0);}},{key:'render',value:function render(){var classes=['ThemedFocus','ThemedFocus--Enabled'];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.join(' ')},this.props.children);}}]);return ThemedFocus;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["h"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["h" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1__withTheme__["a" /* default */])(ThemedFocus)));

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UnsafeHtml;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function UnsafeHtml(_ref){var children=_ref.children,Tag=_ref.tag,restProps=_objectWithoutProperties(_ref,['children','tag']);var unsafeContent={__html:children};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag,Object.assign({dangerouslySetInnerHTML:unsafeContent},restProps));}UnsafeHtml.defaultProps={tag:'span'};UnsafeHtml.propTypes={tag:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = BaseTextLink;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(20);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function BaseTextLink(_ref){var children=_ref.children,target=_ref.target,restProps=_objectWithoutProperties(_ref,['children','target']);if(restProps.href){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',Object.assign({},restProps,{target:target,rel:'noopener noreferer'}),children);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],restProps,children);}BaseTextLink.defaultProps={target:'_blank'};BaseTextLink.propTypes={to:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,href:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,target:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return KIDDIE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MIDDLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TEACHER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FontProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FontProvider_css__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FontProvider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FontProvider_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__kiddie_kiddie_css__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__kiddie_kiddie_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__kiddie_kiddie_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middle_middle_css__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middle_middle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__middle_middle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__teacher_teacher_css__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__teacher_teacher_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__teacher_teacher_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Import all stylesheets up front to assist with roster printing,
//   as the styles need to be in the head before the print occurs
// Font files don't load until used
var KIDDIE='kiddie';var MIDDLE='middle';var TEACHER='teacher';var FontProvider=function(_React$Component){_inherits(FontProvider,_React$Component);function FontProvider(){_classCallCheck(this,FontProvider);return _possibleConstructorReturn(this,(FontProvider.__proto__||Object.getPrototypeOf(FontProvider)).apply(this,arguments));}_createClass(FontProvider,[{key:'render',value:function render(){var classes=['FontProvider'];if(this.props.fontKey){classes.push('FontProvider--'+this.props.fontKey);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.join(' ')},this.props.children);}}]);return FontProvider;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);FontProvider.propTypes={fontKey:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired};

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = matches;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function matches(q){return window.matchMedia(q).matches;}var MediaQuery=function(_React$Component){_inherits(MediaQuery,_React$Component);function MediaQuery(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MediaQuery);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MediaQuery.__proto__||Object.getPrototypeOf(MediaQuery)).call.apply(_ref,[this].concat(args))),_this),_this.state={matches:matches(_this.props.mediaQuery)},_this.boundMediaEvent=_this.handleMediaEvent.bind(_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MediaQuery,[{key:'componentDidMount',value:function componentDidMount(){this.mql=window.matchMedia(this.props.mediaQuery);this.mql.addListener(this.boundMediaEvent);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.mql.removeListener(this.boundMediaEvent);}},{key:'handleMediaEvent',value:function handleMediaEvent(mql){var matches=mql.matches;this.setState({matches:matches});if(this.props.onMediaChange){this.props.onMediaChange(matches);}}},{key:'render',value:function render(){if(this.props.render){return this.props.render(this.state.matches);}return null;}}]);return MediaQuery;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (MediaQuery);MediaQuery.propTypes={mediaQuery:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,render:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onMediaChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TABLET; });
var TABLET='(max-width: 1265px)';

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(501);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return toggleFullScreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setFullScreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setZoomScalingFactor; });
/* harmony export (immutable) */ __webpack_exports__["d"] = setZoomWithScaleFactor;
/* harmony export (immutable) */ __webpack_exports__["g"] = updateZoomScaleFactor;
/* harmony export (immutable) */ __webpack_exports__["a"] = refreshZoom;
/* harmony export (immutable) */ __webpack_exports__["f"] = updateScrolling;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_jigsaw_zoom_actions__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_jigsaw_zoom_selectors__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_jigsaw_jigsaw_selectors__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_jigsaw_jigsaw_action__ = __webpack_require__(18);
var toggleFullScreen=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["e" /* makeActionCreator */])('ui.common.reader.toggleFullScreen');var setFullScreen=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["e" /* makeActionCreator */])('ui.common.reader.setFullScreen');/**
 * Zoom of 1 * scaling factor = raw zoom needed to fill visible area
 */var setZoomScalingFactor=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["e" /* makeActionCreator */])('ui.common.reader.setZoomScalingFactor','data');/**
 * val of 1 = fill visible area
 */function setZoomWithScaleFactor(val){return function(dispatch,getState){var factor=Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["b" /* getZoomScalingFactor */])(getState());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_jigsaw_zoom_actions__["a" /* setRawZoom */])(val*factor));};}function setZoomScaleFactor(factor){return function(dispatch,getState){var oldFactor=Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["b" /* getZoomScalingFactor */])(getState());var rawZoom=Object(__WEBPACK_IMPORTED_MODULE_3__redux_jigsaw_zoom_selectors__["a" /* getCurrentRawZoom */])(getState());var oldScaledZoom=rawZoom/oldFactor;dispatch(setZoomScalingFactor(factor));dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_jigsaw_zoom_actions__["a" /* setRawZoom */])(oldScaledZoom*factor));};}/**
 * Update the scaling factor and re-zoom the page to compensate.
 * Runs only on change
 */function updateZoomScaleFactor(factor){return function(dispatch,getState){var oldFactor=Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["b" /* getZoomScalingFactor */])(getState());if(oldFactor!==factor){dispatch(setZoomScaleFactor(factor));}};}/**
 * Force a re-zoom of the current page
 */function refreshZoom(){return function(dispatch,getState){var currentFactor=Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["b" /* getZoomScalingFactor */])(getState());dispatch(setZoomScaleFactor(currentFactor));};}function updateScrolling(){return function(dispatch,getState){if(Object(__WEBPACK_IMPORTED_MODULE_4__redux_jigsaw_jigsaw_selectors__["q" /* isFixedLayout */])(getState())){var zoom=Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["a" /* getCurrentScaledZoom */])(getState());if(zoom===1){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_jigsaw_jigsaw_action__["w" /* scrollToTop */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_jigsaw_jigsaw_action__["v" /* scrollToLeft */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_jigsaw_jigsaw_action__["e" /* disableScrolling */])());}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_jigsaw_jigsaw_action__["f" /* enableScrolling */])());}}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_jigsaw_jigsaw_action__["f" /* enableScrolling */])());}};}

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_watson_watson_config_selectors__ = __webpack_require__(4);
var mapStateToProps=function mapStateToProps(state){return{locale:Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_watson_watson_config_selectors__["m" /* getLocale */])(state)};};function withLocale(LocalizedComponent){return Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(LocalizedComponent);}

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MountAfterTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = getDelay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_ui_core_common_InnerTransition__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_RouteTransition__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_common_MountAfterDelay__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
function MountAfterTransition(_ref){var children=_ref.children,render=_ref.render;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__core_common_MountAfterDelay__["a" /* default */],{timeout:getDelay(),render:render},children);}function getDelay(){return Math.max(__WEBPACK_IMPORTED_MODULE_0_app_ui_core_common_InnerTransition__["a" /* DURATION */],__WEBPACK_IMPORTED_MODULE_1__main_RouteTransition__["a" /* DURATION */]);}

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return areBookmarksPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hasBookmarks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasBookmarkLoadError; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getBookmarkForThumb;
/* harmony export (immutable) */ __webpack_exports__["f"] = isBookmarkAddProcessingForThumb;
/* harmony export (immutable) */ __webpack_exports__["g"] = isBookmarkDeleteProcessingForThumb;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBookmarks; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_api_redux_jigsaw_userdata_utils_selector_utils__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_userdata_bookmarks_utils__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_api_redux_jigsaw_toc_selectors__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_api_jigsaw_helpers__ = __webpack_require__(35);
var base=Object(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_jigsaw_userdata_utils_selector_utils__["a" /* createSelectors */])('bookmarks');var areBookmarksPending=base.isPending;var hasBookmarks=base.hasItems;var hasBookmarkLoadError=base.hasError;function getBookmarkForThumb(state,thumb){var bookmarks=base.getItems(state);return Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_userdata_bookmarks_utils__["a" /* findBookmarkForThumb */])(bookmarks,thumb);}function isBookmarkAddProcessingForThumb(state,thumb){var addsInProgress=state.jigsaw.bookmarks.pending.add;return addsInProgress.some(function(p){return p.epub_cfi===thumb.cfiref||p.pbk_label===thumb.label;});}function isBookmarkDeleteProcessingForThumb(state,thumb){var deletesInProgress=state.jigsaw.bookmarks.pending.del.map(function(id){return base.getItemData(state,id);});var myBookmark=Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_userdata_bookmarks_utils__["a" /* findBookmarkForThumb */])(deletesInProgress,thumb);if(myBookmark){return base.isDeleteProcessing(state,myBookmark.guid);}return false;}var getBookmarks=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function(state){return base.getItems(state);},function(state){return Object(__WEBPACK_IMPORTED_MODULE_3_app_api_redux_jigsaw_toc_selectors__["c" /* getToc */])(state);},function(bookmarks,toc){return bookmarks.map(function(b){if(b.epubCfi||b.pbkPage){var cfi=b.epubCfi||'/'+b.pbkPage;var index=Object(__WEBPACK_IMPORTED_MODULE_4_app_api_jigsaw_helpers__["b" /* findIndexMatchingCfiFallBackToBefore */])(toc,function(el){return el.cfi;},cfi);if(index>=0){return Object.assign({},b,{chapterTitle:toc[index].title});}}return b;});});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_ASSIGNMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_ASSIGNMENT; });
/* harmony export (immutable) */ __webpack_exports__["d"] = tryListAllAssignments;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return deleteAssignment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_api_redux_feeny_action__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_feeny_assignments_selectors__ = __webpack_require__(220);
var ALL_ASSIGNMENTS='Feeny.Assignments.all';var DELETE_ASSIGNMENT='Feeny.Assignments.delete';var baseListAssignments=Object(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_feeny_action__["a" /* createFeenyAction */])(ALL_ASSIGNMENTS);function tryListAllAssignments(){return function(dispatch,getState){if(Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_feeny_assignments_selectors__["b" /* needsAssignmentFetch */])(getState())){dispatch(baseListAssignments());}};}var deleteAssignment=Object(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_feeny_action__["a" /* createFeenyAction */])(DELETE_ASSIGNMENT);

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isTransitioning; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_RouteTransition_css__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_RouteTransition_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_RouteTransition_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_redux_route_routes__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_common_HundredPercentTransitions__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DURATION=600;var isTransitioning=false;var errorRoutes=[__WEBPACK_IMPORTED_MODULE_2__api_redux_route_routes__["q" /* BOOK_NOT_FOUND */],__WEBPACK_IMPORTED_MODULE_2__api_redux_route_routes__["p" /* BOOK_ACCESS_DENIED */],__WEBPACK_IMPORTED_MODULE_2__api_redux_route_routes__["x" /* COOKIE_ERROR */],__WEBPACK_IMPORTED_MODULE_2__api_redux_route_routes__["T" /* SYSTEM_ERROR */],__WEBPACK_IMPORTED_MODULE_2__api_redux_route_routes__["G" /* FILE_NOT_FOUND */],__WEBPACK_IMPORTED_MODULE_2__api_redux_route_routes__["M" /* NO_GROUPS */]];var RouteTransition=function(_React$Component){_inherits(RouteTransition,_React$Component);function RouteTransition(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RouteTransition);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RouteTransition.__proto__||Object.getPrototypeOf(RouteTransition)).call.apply(_ref,[this].concat(args))),_this),_this.lastPath=_this.props.location.pathname,_this.boundTransitionDone=_this.transitionDone.bind(_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RouteTransition,[{key:'componentDidUpdate',value:function componentDidUpdate(){if(this.lastPath!==this.props.location.pathname){isTransitioning=true;}this.lastPath=this.props.location.pathname;}},{key:'transitionDone',value:function transitionDone(){isTransitioning=false;}},{key:'render',value:function render(){var transition='';var durations={enter:DURATION,exit:DURATION};var onEntered=this.boundTransitionDone;var onExited=this.boundTransitionDone;var path=this.props.location.pathname;var key=this.props.location.key;if(Object(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["g" /* matchPath */])(path,{path:__WEBPACK_IMPORTED_MODULE_2__api_redux_route_routes__["O" /* READER */]})){transition='RouteTransition__Reader';}else if(errorRoutes.indexOf(path)!==-1){transition='RouteTransition__Error';}else{durations={enter:0,exit:0};onEntered=null;onExited=null;// HOME has nested routes and we don't want to transition
// when those change
if(Object(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["g" /* matchPath */])(path,{path:__WEBPACK_IMPORTED_MODULE_2__api_redux_route_routes__["H" /* HOME */]})){key='home';}else if(Object(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["g" /* matchPath */])(path,{path:__WEBPACK_IMPORTED_MODULE_2__api_redux_route_routes__["b" /* ADMIN */]})){key='admin';}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__core_common_HundredPercentTransitions__["b" /* HundredPercentTransitionGroup */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__core_common_HundredPercentTransitions__["a" /* HundredPercentTransition */],{key:key,classNames:transition,timeout:durations,onEntered:onEntered,onExited:onExited},this.props.children));}}]);return RouteTransition;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["b"] = (RouteTransition);

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_MainSizer_css__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_MainSizer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_MainSizer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HundredPercentContainer__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalTarget__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vstui_VstuiDialog__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_ui_core_common_Toast__ = __webpack_require__(361);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MainSizer=function(_React$Component){_inherits(MainSizer,_React$Component);function MainSizer(){_classCallCheck(this,MainSizer);return _possibleConstructorReturn(this,(MainSizer.__proto__||Object.getPrototypeOf(MainSizer)).apply(this,arguments));}_createClass(MainSizer,[{key:'render',value:function render(){var _props=this.props,children=_props.children,sizeInfo=_objectWithoutProperties(_props,['children']);var overflow=sizeInfo.overflow,overflowX=sizeInfo.overflowX,overflowY=sizeInfo.overflowY,restProps=_objectWithoutProperties(sizeInfo,['overflow','overflowX','overflowY']);var overflowProps={overflow:overflow,overflowX:overflowX,overflowY:overflowY};Object.keys(overflowProps).forEach(function(k){return!overflowProps[k]&&delete overflowProps[k];});var innerProps=Object.assign({},restProps);if(restProps.minWidth){innerProps.overflowX='hidden';}if(restProps.minHeight){innerProps.overflowXY='hidden';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MainSizer',style:overflowProps,id:__WEBPACK_IMPORTED_MODULE_4__vstui_VstuiDialog__["a" /* VSTUI_DIALOG_TARGET */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:Object.assign({},innerProps)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__HundredPercentContainer__["a" /* default */],{id:__WEBPACK_IMPORTED_MODULE_3__ModalTarget__["a" /* APP_ID */]},children),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ModalTarget__["b" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_ui_core_common_Toast__["a" /* ToastContainer */],null)));}}]);return MainSizer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (MainSizer);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = RedirectOffSite;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_ui_pages_shared_url_builder__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_ui_route_RedirectOnce__ = __webpack_require__(28);
function RedirectOffSite(_ref){var to=_ref.to,params=_ref.params;var redirect=Object(__WEBPACK_IMPORTED_MODULE_1_app_ui_pages_shared_url_builder__["g" /* getRedirectUrl */])(to,params);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_ui_route_RedirectOnce__["a" /* default */],{to:redirect});}

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getHighlights; });
/* harmony export (immutable) */ __webpack_exports__["a"] = areHighlightsLoading;
/* harmony export (immutable) */ __webpack_exports__["d"] = hasHighlightLoadError;
/* unused harmony export getMarkers */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getUnsharedMarkers; });
/* harmony export (immutable) */ __webpack_exports__["e"] = hasHighlights;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_api_redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_api_redux_jigsaw_jigsaw_selectors__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_api_jigsaw_helpers__ = __webpack_require__(35);
var emptyArray=[];function getRawHighlights(state){var data=state.jigsaw.highlights.data;return data?data.highlights:emptyArray;}var getHighlights=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(function(state){return getRawHighlights(state);},function(state){return Object(__WEBPACK_IMPORTED_MODULE_2_app_api_redux_jigsaw_jigsaw_selectors__["h" /* getPageBreaks */])(state);},function(highlights,pageBreaks){return highlights.map(function(h){if(!h.startLabel&&h.cfi){var index=Object(__WEBPACK_IMPORTED_MODULE_3_app_api_jigsaw_helpers__["b" /* findIndexMatchingCfiFallBackToBefore */])(pageBreaks,function(el){return el.cfi;},h.cfi);if(index>=0){return Object.assign({},h,{startLabel:pageBreaks[index].label});}}return h;});});function areHighlightsLoading(state){return Object(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_util_async_helpers__["i" /* isPending */])(state.jigsaw.highlights);}function hasHighlightLoadError(state){return state.jigsaw.highlights.hasError;}function getMarkers(state){var data=state.jigsaw.highlights.data;return data?data.markers:emptyArray;}var getUnsharedMarkers=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(function(state){return getMarkers(state);},function(markers){return markers.filter(function(m){return!m.shared;});});function hasHighlights(state){return getHighlights(state).length>0;}

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_redux_watson_watson_config_selectors__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_common_BrandedDocumentTitle__ = __webpack_require__(150);
var mapStateToProps=function mapStateToProps(state){return{brandName:Object(__WEBPACK_IMPORTED_MODULE_1__api_redux_watson_watson_config_selectors__["t" /* getStudentBrandName */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__core_common_BrandedDocumentTitle__["a" /* default */]));

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return areNotesPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isNoteUpdateProcessing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasNoteLoadError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_api_redux_jigsaw_userdata_utils_selector_utils__ = __webpack_require__(160);
var base=Object(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_jigsaw_userdata_utils_selector_utils__["a" /* createSelectors */])('notes');var getNotes=base.getItems;var areNotesPending=base.isPending;var hasNotes=base.hasItems;var isNoteUpdateProcessing=base.isUpdateProcessing;var hasNoteLoadError=base.hasError;

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MODAL; });
var TOAST=9000;var MODAL=10000;

/***/ }),
/* 113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _CaretDownSmall=__webpack_require__(595);Object.defineProperty(exports,'CaretDownSmall',{enumerable:!0,get:function get(){return _interopRequireDefault(_CaretDownSmall).default}});var _CaretLeftSmall=__webpack_require__(597);Object.defineProperty(exports,'CaretLeftSmall',{enumerable:!0,get:function get(){return _interopRequireDefault(_CaretLeftSmall).default}});var _CaretRightSmall=__webpack_require__(598);Object.defineProperty(exports,'CaretRightSmall',{enumerable:!0,get:function get(){return _interopRequireDefault(_CaretRightSmall).default}});var _Checkbox=__webpack_require__(599);Object.defineProperty(exports,'Checkbox',{enumerable:!0,get:function get(){return _interopRequireDefault(_Checkbox).default}});var _CheckboxChecked=__webpack_require__(600);Object.defineProperty(exports,'CheckboxChecked',{enumerable:!0,get:function get(){return _interopRequireDefault(_CheckboxChecked).default}});var _Checkmark=__webpack_require__(601);Object.defineProperty(exports,'Checkmark',{enumerable:!0,get:function get(){return _interopRequireDefault(_Checkmark).default}});var _CheckmarkCircle=__webpack_require__(602);Object.defineProperty(exports,'CheckmarkCircle',{enumerable:!0,get:function get(){return _interopRequireDefault(_CheckmarkCircle).default}});var _ExclamationCircle=__webpack_require__(603);Object.defineProperty(exports,'ExclamationCircle',{enumerable:!0,get:function get(){return _interopRequireDefault(_ExclamationCircle).default}});var _FormError=__webpack_require__(604);Object.defineProperty(exports,'FormError',{enumerable:!0,get:function get(){return _interopRequireDefault(_FormError).default}});var _ICircle=__webpack_require__(605);Object.defineProperty(exports,'ICircle',{enumerable:!0,get:function get(){return _interopRequireDefault(_ICircle).default}});var _RadioButton=__webpack_require__(606);Object.defineProperty(exports,'RadioButton',{enumerable:!0,get:function get(){return _interopRequireDefault(_RadioButton).default}});var _RadioButtonSelected=__webpack_require__(607);Object.defineProperty(exports,'RadioButtonSelected',{enumerable:!0,get:function get(){return _interopRequireDefault(_RadioButtonSelected).default}});var _XSmall=__webpack_require__(608);Object.defineProperty(exports,'XSmall',{enumerable:!0,get:function get(){return _interopRequireDefault(_XSmall).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return POSSIBLE_SWIMLANES; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getParams;
var POSSIBLE_SWIMLANES=['recommended','popular','added','recommendedSubject1','recommendedSubject2','recommendedSubject3'];var popularFilters={recommendedSubject1:'recommended.subject1',recommendedSubject2:'recommended.subject2',recommendedSubject3:'recommended.subject3'};function getParams(id){var params={active:false,limit:100,sort:id};if(popularFilters[id]){params.sort='popular';params.filters=[popularFilters[id]];}return params;}

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = replaceStrings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_objects__ = __webpack_require__(15);
function replaceStrings(localeData,obj){var strings=Object.keys(obj).filter(function(k){return typeof obj[k]==='string'&&k!=='value';}).reduce(function(acc,cv){var val=Object(__WEBPACK_IMPORTED_MODULE_0__utils_objects__["b" /* findKeyInObj */])(localeData,obj[cv]);if(val){acc[cv]=val;}return acc;},{});return Object.assign({},obj,strings);}

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(370);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(120);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(124);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(73);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(397);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule warning
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(36);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(130);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(78);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(420)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 134 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return importFirst; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return importAll; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/**
 * Given a list of import functions, try imports until one succeeds
 */var importFirst=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(imports){var i;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:i=0;case 1:if(!(i<imports.length)){_context.next=15;break;}_context.prev=2;_context.next=5;return imports[i]();case 5:_context.t0=_context.sent;_context.t1=i;return _context.abrupt("return",{data:_context.t0,index:_context.t1});case 10:_context.prev=10;_context.t2=_context["catch"](2);case 12:i++;_context.next=1;break;case 15:throw new Error("Couldn't import any files");case 16:case"end":return _context.stop();}}},_callee,this,[[2,10]]);}));return function importFirst(_x){return _ref.apply(this,arguments);};}();/**
 * Import All The Things
 * Resolve with an array with all the imported data, nulls for failures
 */var importAll=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(imports){var _this=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Promise.all(imports.map(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(item){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_context2.next=3;return item();case 3:return _context2.abrupt("return",_context2.sent);case 6:_context2.prev=6;_context2.t0=_context2["catch"](0);return _context2.abrupt("return",null);case 9:case"end":return _context2.stop();}}},_callee2,_this,[[0,6]]);}));return function(_x3){return _ref3.apply(this,arguments);};}()));case 2:return _context3.abrupt("return",_context3.sent);case 3:case"end":return _context3.stop();}}},_callee3,this);}));return function importAll(_x2){return _ref2.apply(this,arguments);};}();

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": [
		236,
		122
	],
	"./af.js": [
		236,
		122
	],
	"./ar": [
		243,
		115
	],
	"./ar-dz": [
		237,
		121
	],
	"./ar-dz.js": [
		237,
		121
	],
	"./ar-kw": [
		238,
		120
	],
	"./ar-kw.js": [
		238,
		120
	],
	"./ar-ly": [
		239,
		119
	],
	"./ar-ly.js": [
		239,
		119
	],
	"./ar-ma": [
		240,
		118
	],
	"./ar-ma.js": [
		240,
		118
	],
	"./ar-sa": [
		241,
		117
	],
	"./ar-sa.js": [
		241,
		117
	],
	"./ar-tn": [
		242,
		116
	],
	"./ar-tn.js": [
		242,
		116
	],
	"./ar.js": [
		243,
		115
	],
	"./az": [
		244,
		114
	],
	"./az.js": [
		244,
		114
	],
	"./be": [
		245,
		113
	],
	"./be.js": [
		245,
		113
	],
	"./bg": [
		246,
		112
	],
	"./bg.js": [
		246,
		112
	],
	"./bm": [
		247,
		111
	],
	"./bm.js": [
		247,
		111
	],
	"./bn": [
		248,
		110
	],
	"./bn.js": [
		248,
		110
	],
	"./bo": [
		249,
		109
	],
	"./bo.js": [
		249,
		109
	],
	"./br": [
		250,
		108
	],
	"./br.js": [
		250,
		108
	],
	"./bs": [
		251,
		107
	],
	"./bs.js": [
		251,
		107
	],
	"./ca": [
		252,
		106
	],
	"./ca.js": [
		252,
		106
	],
	"./cs": [
		253,
		105
	],
	"./cs.js": [
		253,
		105
	],
	"./cv": [
		254,
		104
	],
	"./cv.js": [
		254,
		104
	],
	"./cy": [
		255,
		103
	],
	"./cy.js": [
		255,
		103
	],
	"./da": [
		256,
		102
	],
	"./da.js": [
		256,
		102
	],
	"./de": [
		259,
		99
	],
	"./de-at": [
		257,
		101
	],
	"./de-at.js": [
		257,
		101
	],
	"./de-ch": [
		258,
		100
	],
	"./de-ch.js": [
		258,
		100
	],
	"./de.js": [
		259,
		99
	],
	"./dv": [
		260,
		98
	],
	"./dv.js": [
		260,
		98
	],
	"./el": [
		261,
		97
	],
	"./el.js": [
		261,
		97
	],
	"./en-au": [
		262,
		96
	],
	"./en-au.js": [
		262,
		96
	],
	"./en-ca": [
		263,
		95
	],
	"./en-ca.js": [
		263,
		95
	],
	"./en-gb": [
		264,
		94
	],
	"./en-gb.js": [
		264,
		94
	],
	"./en-ie": [
		265,
		93
	],
	"./en-ie.js": [
		265,
		93
	],
	"./en-il": [
		266,
		92
	],
	"./en-il.js": [
		266,
		92
	],
	"./en-nz": [
		267,
		91
	],
	"./en-nz.js": [
		267,
		91
	],
	"./eo": [
		268,
		90
	],
	"./eo.js": [
		268,
		90
	],
	"./es": [
		271,
		87
	],
	"./es-do": [
		269,
		89
	],
	"./es-do.js": [
		269,
		89
	],
	"./es-us": [
		270,
		88
	],
	"./es-us.js": [
		270,
		88
	],
	"./es.js": [
		271,
		87
	],
	"./et": [
		272,
		86
	],
	"./et.js": [
		272,
		86
	],
	"./eu": [
		273,
		85
	],
	"./eu.js": [
		273,
		85
	],
	"./fa": [
		274,
		84
	],
	"./fa.js": [
		274,
		84
	],
	"./fi": [
		275,
		83
	],
	"./fi.js": [
		275,
		83
	],
	"./fo": [
		276,
		82
	],
	"./fo.js": [
		276,
		82
	],
	"./fr": [
		279,
		79
	],
	"./fr-ca": [
		277,
		81
	],
	"./fr-ca.js": [
		277,
		81
	],
	"./fr-ch": [
		278,
		80
	],
	"./fr-ch.js": [
		278,
		80
	],
	"./fr.js": [
		279,
		79
	],
	"./fy": [
		280,
		78
	],
	"./fy.js": [
		280,
		78
	],
	"./gd": [
		281,
		77
	],
	"./gd.js": [
		281,
		77
	],
	"./gl": [
		282,
		76
	],
	"./gl.js": [
		282,
		76
	],
	"./gom-latn": [
		283,
		75
	],
	"./gom-latn.js": [
		283,
		75
	],
	"./gu": [
		284,
		74
	],
	"./gu.js": [
		284,
		74
	],
	"./he": [
		285,
		73
	],
	"./he.js": [
		285,
		73
	],
	"./hi": [
		286,
		72
	],
	"./hi.js": [
		286,
		72
	],
	"./hr": [
		287,
		71
	],
	"./hr.js": [
		287,
		71
	],
	"./hu": [
		288,
		70
	],
	"./hu.js": [
		288,
		70
	],
	"./hy-am": [
		289,
		69
	],
	"./hy-am.js": [
		289,
		69
	],
	"./id": [
		290,
		68
	],
	"./id.js": [
		290,
		68
	],
	"./is": [
		291,
		67
	],
	"./is.js": [
		291,
		67
	],
	"./it": [
		292,
		66
	],
	"./it.js": [
		292,
		66
	],
	"./ja": [
		293,
		65
	],
	"./ja.js": [
		293,
		65
	],
	"./jv": [
		294,
		64
	],
	"./jv.js": [
		294,
		64
	],
	"./ka": [
		295,
		63
	],
	"./ka.js": [
		295,
		63
	],
	"./kk": [
		296,
		62
	],
	"./kk.js": [
		296,
		62
	],
	"./km": [
		297,
		61
	],
	"./km.js": [
		297,
		61
	],
	"./kn": [
		298,
		60
	],
	"./kn.js": [
		298,
		60
	],
	"./ko": [
		299,
		59
	],
	"./ko.js": [
		299,
		59
	],
	"./ky": [
		300,
		58
	],
	"./ky.js": [
		300,
		58
	],
	"./lb": [
		301,
		57
	],
	"./lb.js": [
		301,
		57
	],
	"./lo": [
		302,
		56
	],
	"./lo.js": [
		302,
		56
	],
	"./lt": [
		303,
		55
	],
	"./lt.js": [
		303,
		55
	],
	"./lv": [
		304,
		54
	],
	"./lv.js": [
		304,
		54
	],
	"./me": [
		305,
		53
	],
	"./me.js": [
		305,
		53
	],
	"./mi": [
		306,
		52
	],
	"./mi.js": [
		306,
		52
	],
	"./mk": [
		307,
		51
	],
	"./mk.js": [
		307,
		51
	],
	"./ml": [
		308,
		50
	],
	"./ml.js": [
		308,
		50
	],
	"./mn": [
		309,
		49
	],
	"./mn.js": [
		309,
		49
	],
	"./mr": [
		310,
		48
	],
	"./mr.js": [
		310,
		48
	],
	"./ms": [
		312,
		46
	],
	"./ms-my": [
		311,
		47
	],
	"./ms-my.js": [
		311,
		47
	],
	"./ms.js": [
		312,
		46
	],
	"./mt": [
		313,
		45
	],
	"./mt.js": [
		313,
		45
	],
	"./my": [
		314,
		44
	],
	"./my.js": [
		314,
		44
	],
	"./nb": [
		315,
		43
	],
	"./nb.js": [
		315,
		43
	],
	"./ne": [
		316,
		42
	],
	"./ne.js": [
		316,
		42
	],
	"./nl": [
		318,
		40
	],
	"./nl-be": [
		317,
		41
	],
	"./nl-be.js": [
		317,
		41
	],
	"./nl.js": [
		318,
		40
	],
	"./nn": [
		319,
		39
	],
	"./nn.js": [
		319,
		39
	],
	"./pa-in": [
		320,
		38
	],
	"./pa-in.js": [
		320,
		38
	],
	"./pl": [
		321,
		37
	],
	"./pl.js": [
		321,
		37
	],
	"./pt": [
		323,
		35
	],
	"./pt-br": [
		322,
		36
	],
	"./pt-br.js": [
		322,
		36
	],
	"./pt.js": [
		323,
		35
	],
	"./ro": [
		324,
		34
	],
	"./ro.js": [
		324,
		34
	],
	"./ru": [
		325,
		33
	],
	"./ru.js": [
		325,
		33
	],
	"./sd": [
		326,
		32
	],
	"./sd.js": [
		326,
		32
	],
	"./se": [
		327,
		31
	],
	"./se.js": [
		327,
		31
	],
	"./si": [
		328,
		30
	],
	"./si.js": [
		328,
		30
	],
	"./sk": [
		329,
		29
	],
	"./sk.js": [
		329,
		29
	],
	"./sl": [
		330,
		28
	],
	"./sl.js": [
		330,
		28
	],
	"./sq": [
		331,
		27
	],
	"./sq.js": [
		331,
		27
	],
	"./sr": [
		333,
		25
	],
	"./sr-cyrl": [
		332,
		26
	],
	"./sr-cyrl.js": [
		332,
		26
	],
	"./sr.js": [
		333,
		25
	],
	"./ss": [
		334,
		24
	],
	"./ss.js": [
		334,
		24
	],
	"./sv": [
		335,
		23
	],
	"./sv.js": [
		335,
		23
	],
	"./sw": [
		336,
		22
	],
	"./sw.js": [
		336,
		22
	],
	"./ta": [
		337,
		21
	],
	"./ta.js": [
		337,
		21
	],
	"./te": [
		338,
		20
	],
	"./te.js": [
		338,
		20
	],
	"./tet": [
		339,
		19
	],
	"./tet.js": [
		339,
		19
	],
	"./tg": [
		340,
		18
	],
	"./tg.js": [
		340,
		18
	],
	"./th": [
		341,
		17
	],
	"./th.js": [
		341,
		17
	],
	"./tl-ph": [
		342,
		16
	],
	"./tl-ph.js": [
		342,
		16
	],
	"./tlh": [
		343,
		15
	],
	"./tlh.js": [
		343,
		15
	],
	"./tr": [
		344,
		14
	],
	"./tr.js": [
		344,
		14
	],
	"./tzl": [
		345,
		13
	],
	"./tzl.js": [
		345,
		13
	],
	"./tzm": [
		347,
		11
	],
	"./tzm-latn": [
		346,
		12
	],
	"./tzm-latn.js": [
		346,
		12
	],
	"./tzm.js": [
		347,
		11
	],
	"./ug-cn": [
		348,
		10
	],
	"./ug-cn.js": [
		348,
		10
	],
	"./uk": [
		349,
		9
	],
	"./uk.js": [
		349,
		9
	],
	"./ur": [
		350,
		8
	],
	"./ur.js": [
		350,
		8
	],
	"./uz": [
		352,
		6
	],
	"./uz-latn": [
		351,
		7
	],
	"./uz-latn.js": [
		351,
		7
	],
	"./uz.js": [
		352,
		6
	],
	"./vi": [
		353,
		5
	],
	"./vi.js": [
		353,
		5
	],
	"./x-pseudo": [
		354,
		4
	],
	"./x-pseudo.js": [
		354,
		4
	],
	"./yo": [
		355,
		3
	],
	"./yo.js": [
		355,
		3
	],
	"./zh-cn": [
		356,
		2
	],
	"./zh-cn.js": [
		356,
		2
	],
	"./zh-hk": [
		357,
		1
	],
	"./zh-hk.js": [
		357,
		1
	],
	"./zh-tw": [
		358,
		0
	],
	"./zh-tw.js": [
		358,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 136;
module.exports = webpackAsyncContext;

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shortenName;
function shortenName(first,last){if(first){var name=first;if(last){name=name+' '+last.charAt(0)+'.';}return name;}return'';}

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isCookieError;
var cookieMessages=[//'No local storage', 'You must enable local storage'
];function isCookieError(err){if(err&&err.message){return cookieMessages.indexOf(err.message)>=0;}return false;}

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = cookiesAccepted;
/* harmony export (immutable) */ __webpack_exports__["a"] = acceptCookies;
/* harmony export (immutable) */ __webpack_exports__["d"] = getUiBaseCookie;
/* harmony export (immutable) */ __webpack_exports__["e"] = setUiBaseCookie;
/* harmony export (immutable) */ __webpack_exports__["b"] = clearUiBaseCookie;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_cookie__ = __webpack_require__(81);
var COOKIE='cookies-accepted';var UI_BASE='uiBase';function cookiesAccepted(){return!!Object(__WEBPACK_IMPORTED_MODULE_0__utils_cookie__["a" /* getCookie */])(COOKIE);}function acceptCookies(){Object(__WEBPACK_IMPORTED_MODULE_0__utils_cookie__["c" /* setCookie */])(COOKIE,true,365);}function getUiBaseCookie(){return Object(__WEBPACK_IMPORTED_MODULE_0__utils_cookie__["a" /* getCookie */])(UI_BASE);}function setUiBaseCookie(val){Object(__WEBPACK_IMPORTED_MODULE_0__utils_cookie__["c" /* setCookie */])(UI_BASE,val,30);}function clearUiBaseCookie(){Object(__WEBPACK_IMPORTED_MODULE_0__utils_cookie__["b" /* removeCookie */])(UI_BASE);}

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;function _objectSpread(a){for(var b=1;b<arguments.length;b++){var c=null==arguments[b]?{}:arguments[b],d=Object.keys(c);"function"==typeof Object.getOwnPropertySymbols&&(d=d.concat(Object.getOwnPropertySymbols(c).filter(function(a){return Object.getOwnPropertyDescriptor(c,a).enumerable}))),d.forEach(function(b){_defineProperty(a,b,c[b])})}return a}function _defineProperty(a,b,c){return b in a?Object.defineProperty(a,b,{value:c,enumerable:!0,configurable:!0,writable:!0}):a[b]=c,a}function _typeof(a){return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(a){return typeof a}:function(a){return a&&"function"==typeof Symbol&&a.constructor===Symbol&&a!==Symbol.prototype?"symbol":typeof a},_typeof(a)}(function(a,b){"object"===( false?"undefined":_typeof(exports))&&"undefined"!=typeof module?b(): true?!(__WEBPACK_AMD_DEFINE_FACTORY__ = (b),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):b()})(this,function(){"use strict";var l=Math.min;function a(a){return a&&a.__esModule&&Object.prototype.hasOwnProperty.call(a,"default")?a.default:a}function b(a,b){return b={exports:{}},a(b,b.exports),b.exports}function d(a){return a&&a.default||a}function e(a){return Math.pow((a+.055)/1.055,2.4)}/*
	 * @param {number} a luminance value
	 * @param {number} b luminance value
	 * @returns {number} contrast ratio
	 */function f(c,a){var b=Math.max(c,a),d=l(c,a);return(b+.05)/(d+.05)}/*
	 * @param {array} a rgb value
	 * @param {array} b rgb value
	 * @returns {number} contrast ratio
	 */function g(c,a){return f(B(c),B(a))}/*
	 * @param {string} a hex value
	 * @param {string} b hex value
	 * @returns {number} contrast ratio
	 */function h(){// ensure that runtime compilation only happens once
return y||(y=/^[\s	\n\v\f\r   ᠎             　\u2028\u2029﻿"]+$/)}function i(a,b,c){return a=j(a,c),b=j(b,c),D.rgb(a,b)}function j(a,b){if("string"!=typeof a)throw new TypeError("get-contrast expects colors as strings");return xc(a)&&(a=mf[a]),a=k(a,b),a.match(/\((.*)\)/)[1].split(",").slice(0,3)}function k(a,b){b=b||{},a=z(a);// Check if the rgb returned color is rgba and if the 'a' value is 0.
var c=a.match(/\((.*)\)/)[1].split(",");if(4==c.length&&"0"==c[3]&&!b.ignoreAlpha)throw new TypeError("get-contrast cannot contrast transparent colors");else return a}var m={maroon:"#800000",red:"#ff0000",orange:"#ffA500",yellow:"#ffff00",olive:"#808000",purple:"#800080",fuchsia:"#ff00ff",white:"#ffffff",lime:"#00ff00",green:"#008000",navy:"#000080",blue:"#0000ff",aqua:"#00ffff",teal:"#008080",black:"#000000",silver:"#c0c0c0",gray:"#808080",transparent:"#0000"},n=function(c,d,e,f){var h=Math.round;return(null==f||""===f)&&(f=1),c=parseFloat(c),d=parseFloat(d),e=parseFloat(e),f=parseFloat(f),255>=c&&0<=c&&255>=d&&0<=d&&255>=e&&0<=e&&1>=f&&0<=f?[h(c),h(d),h(e),f]:null},o=function(a){if(3===a.length&&(a+="f"),4===a.length){var b=a.charAt(0),c=a.charAt(1),d=a.charAt(2),e=a.charAt(3);a=b+b+c+c+d+d+e+e}6===a.length&&(a+="ff");for(var f=[],g=0,h=a.length;g<h;g+=2)f.push(parseInt(a.substr(g,2),16)/(6==g?255:1));return f},r=function(a,b,c){return 0>c&&(c+=1),1<c&&(c-=1),c<1/6?a+6*(b-a)*c:c<1/2?b:c<2/3?a+6*((b-a)*(2/3-c)):a},s=function(c,d,e,f){var i,j,k;if((null==f||""===f)&&(f=1),c=parseFloat(c)/360,d=parseFloat(d)/100,e=parseFloat(e)/100,f=parseFloat(f)/1,1<c||0>c||1<d||0>d||1<e||0>e||1<f||0>f)return null;if(0===d)i=j=k=e;else{var m=.5>e?e*(1+d):e+d-e*d,n=2*e-m;i=r(n,m,c+1/3),k=r(n,m,c),j=r(n,m,c-1/3)}return[255*i,255*k,255*j,f]},t=[];for(var u in m)t.push(u);var c="("+t.join("|")+")",p=/(?:#([a-f0-9]{3,8}))/i,q=/(?:rgb)a?\(\s*([.\d%]+)\s*,\s*([.\d%]+)\s*,\s*([.\d%]+)\s*(?:,\s*([.\d]+)\s*)?\)/i,v=/(?:hsl)a?\(\s*([.\d%]+)\s*,\s*([.\d%]+)\s*,\s*([.\d%]+)\s*(?:,\s*([.\d]+)\s*)?\)/i,w=function(a,b){if(null==a)return null;a=(a+"").replace(/\s+/,"");var c=m[a];if(c)return w(c,b);if(c=a.match(p))a=o(c[1]);else if(c=a.match(q))a=c.slice(1);else if(c=a.match(v))a=s.apply(null,c.slice(1));else return null;return a&&(a=n.apply(null,a))?b?a:(1===a[3]&&a.splice(3,1),"rgb"+(4===a.length?"a":"")+"("+a+")"):null},x=RegExp([c,"(?:#([a-f0-9]{3,8}))","(?:rgb)a?\\(\\s*([.\\d%]+)\\s*,\\s*([.\\d%]+)\\s*,\\s*([.\\d%]+)\\s*(?:,\\s*([.\\d]+)\\s*)?\\)","(?:hsl)a?\\(\\s*([.\\d%]+)\\s*,\\s*([.\\d%]+)\\s*,\\s*([.\\d%]+)\\s*(?:,\\s*([.\\d]+)\\s*)?\\)"].join("|"),"gi");w.replace=function(a,b){return b||(b=function(a){return w(a)}),(a+"").replace(x,b)},w.matches=function(a){return!!(a+"").match(x)};var y,z=w,// low-gamma adjust coefficient
A=1/12.92,B=function(a){var c=a[0]/255,d=a[1]/255,f=a[2]/255,h=.03928>=c?c*A:e(c),i=.03928>=d?d*A:e(d),g=.03928>=f?f*A:e(f);return h*.2126+i*.7152+g*.0722},C=function(a){if("string"!=typeof a)throw new TypeError("Expected a string");a=a.replace(/^#/,""),3===a.length&&(a=a[0]+a[0]+a[1]+a[1]+a[2]+a[2]);var b=parseInt(a,16);return[b>>16,255&b>>8,255&b]},D={luminance:f,rgb:g,hex:function(c,a){return g(C(c),C(a))}/*
	 * @param {array} a rgb value
	 * @param {array} b rgb value
	 * @returns {number} contrast ratio
	 */,score:function(a){return 7<=a?"AAA":4.5<=a?"AA":""}},E=/**
	 * Test whether a value is "empty".
	 *
	 * @param {Mixed} val
	 * @return {Boolean}
	 */function(a){if(null==a)return!0;if("number"==typeof a)return 0==a;if(void 0!==a.length)return 0===a.length;for(var b in a)if(F.call(a,b))return!1;return!0}/*!
	 * is-whitespace <https://github.com/jonschlinkert/is-whitespace>
	 *
	 * Copyright (c) 2014-2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */,F=Object.prototype.hasOwnProperty,G=function(a){return"string"==typeof a&&h().test(a)},H=function(a){return"boolean"!=typeof a&&("string"==typeof a&&a.length?G(a):E(a))},I="#00ffff",J="#f0f8ff",K="#faebd7",L="#000000",M="#0000ff",N="#00ffff",O="#00008b",P="#008b8b",Q="#006400",R="#00ced1",S="#00bfff",T="#008000",U="#00ff00",V="#0000cd",W="#00fa9a",X="#000080",Y="#00ff7f",Z="#008080",$="#191970",_="#1e90ff",aa="#20b2aa",ba="#228b22",ca="#2e8b57",da="#2f4f4f",ea="#2f4f4f",fa="#32cd32",ga="#3cb371",ha="#40e0d0",ia="#4169e1",ja="#4682b4",ka="#483d8b",la="#48d1cc",ma="#4b0082",na="#556b2f",oa="#5f9ea0",pa="#6495ed",qa="#66cdaa",ra="#696969",sa="#696969",ta="#6a5acd",ua="#6b8e23",va="#708090",wa="#708090",xa="#778899",ya="#778899",za="#7b68ee",Aa="#7cfc00",Ba="#7fffd4",Ca="#7fff00",Da="#808080",Ea="#808080",Fa="#800000",Ga="#808000",Ha="#800080",Ia="#87cefa",Ja="#87ceeb",Ka="#8a2be2",La="#8b008b",Ma="#8b0000",Na="#8b4513",Oa="#8fbc8f",Pa="#90ee90",Qa="#9370db",Ra="#9400d3",Sa="#98fb98",Ta="#9932cc",Ua="#9acd32",Va="#a0522d",Wa="#a52a2a",Xa="#a9a9a9",Ya="#a9a9a9",Za="#adff2f",$a="#add8e6",_a="#afeeee",ab="#b0c4de",bb="#b0e0e6",cb="#b22222",db="#b8860b",eb="#ba55d3",fb="#bc8f8f",gb="#bdb76b",hb="#c0c0c0",ib="#c71585",jb="#cd5c5c",kb="#cd853f",lb="#d2691e",mb="#d2b48c",nb="#d3d3d3",ob="#d3d3d3",pb="#d8bfd8",qb="#daa520",rb="#da70d6",sb="#db7093",tb="#dc143c",ub="#dcdcdc",vb="#dda0dd",wb="#deb887",xb="#e0ffff",yb="#e6e6fa",zb="#e9967a",Ab="#eee8aa",Bb="#ee82ee",Cb="#f0ffff",Db="#f0fff0",Eb="#f0e68c",Fb="#f08080",Gb="#f4a460",Hb="#f5f5dc",Ib="#f5fffa",Jb="#f5deb3",Kb="#f5f5f5",Lb="#f8f8ff",Mb="#fafad2",Nb="#faf0e6",Ob="#fa8072",Pb="#fdf5e6",Qb="#ffe4c4",Rb="#ffebcd",Sb="#ff7f50",Tb="#fff8dc",Ub="#ff8c00",Vb="#ff1493",Wb="#fffaf0",Xb="#ff00ff",Yb="#ffd700",Zb="#ff69b4",$b="#fffff0",_b="#fff0f5",ac="#fffacd",bc="#ffb6c1",cc="#ffa07a",dc="#ffffe0",ec="#ff00ff",fc="#ffe4e1",gc="#ffe4b5",hc="#ffdead",ic="#ffa500",jc="#ff4500",kc="#ffefd5",lc="#ffdab9",mc="#ffc0cb",nc="#ff0000",oc="#fff5ee",pc="#fffafa",qc="#ff6347",rc="#ffffff",sc="#ffff00",tc="#663399",uc=/*#__PURE__*/Object.freeze({aqua:I,aliceblue:J,antiquewhite:K,black:L,blue:M,cyan:N,darkblue:O,darkcyan:P,darkgreen:Q,darkturquoise:R,deepskyblue:S,green:T,lime:U,mediumblue:V,mediumspringgreen:W,navy:X,springgreen:Y,teal:Z,midnightblue:$,dodgerblue:_,lightseagreen:aa,forestgreen:ba,seagreen:ca,darkslategray:da,darkslategrey:ea,limegreen:fa,mediumseagreen:ga,turquoise:ha,royalblue:ia,steelblue:ja,darkslateblue:ka,mediumturquoise:la,indigo:ma,darkolivegreen:na,cadetblue:oa,cornflowerblue:pa,mediumaquamarine:qa,dimgray:ra,dimgrey:sa,slateblue:ta,olivedrab:ua,slategray:va,slategrey:wa,lightslategray:xa,lightslategrey:ya,mediumslateblue:za,lawngreen:Aa,aquamarine:Ba,chartreuse:Ca,gray:Da,grey:Ea,maroon:Fa,olive:Ga,purple:Ha,lightskyblue:Ia,skyblue:Ja,blueviolet:Ka,darkmagenta:La,darkred:Ma,saddlebrown:Na,darkseagreen:Oa,lightgreen:Pa,mediumpurple:Qa,darkviolet:Ra,palegreen:Sa,darkorchid:Ta,yellowgreen:Ua,sienna:Va,brown:Wa,darkgray:Xa,darkgrey:Ya,greenyellow:Za,lightblue:$a,paleturquoise:_a,lightsteelblue:ab,powderblue:bb,firebrick:cb,darkgoldenrod:db,mediumorchid:eb,rosybrown:fb,darkkhaki:gb,silver:hb,mediumvioletred:ib,indianred:jb,peru:kb,chocolate:lb,tan:mb,lightgray:nb,lightgrey:ob,thistle:pb,goldenrod:qb,orchid:rb,palevioletred:sb,crimson:tb,gainsboro:ub,plum:vb,burlywood:wb,lightcyan:xb,lavender:yb,darksalmon:zb,palegoldenrod:Ab,violet:Bb,azure:Cb,honeydew:Db,khaki:Eb,lightcoral:Fb,sandybrown:Gb,beige:Hb,mintcream:Ib,wheat:Jb,whitesmoke:Kb,ghostwhite:Lb,lightgoldenrodyellow:Mb,linen:Nb,salmon:Ob,oldlace:Pb,bisque:Qb,blanchedalmond:Rb,coral:Sb,cornsilk:Tb,darkorange:Ub,deeppink:Vb,floralwhite:Wb,fuchsia:Xb,gold:Yb,hotpink:Zb,ivory:$b,lavenderblush:_b,lemonchiffon:ac,lightpink:bc,lightsalmon:cc,lightyellow:dc,magenta:ec,mistyrose:fc,moccasin:gc,navajowhite:hc,orange:ic,orangered:jc,papayawhip:kc,peachpuff:lc,pink:mc,red:nc,seashell:oc,snow:pc,tomato:qc,white:rc,yellow:sc,rebeccapurple:tc,default:{aqua:I,aliceblue:J,antiquewhite:K,black:L,blue:M,cyan:N,darkblue:O,darkcyan:P,darkgreen:Q,darkturquoise:R,deepskyblue:S,green:T,lime:U,mediumblue:V,mediumspringgreen:W,navy:X,springgreen:Y,teal:Z,midnightblue:$,dodgerblue:_,lightseagreen:aa,forestgreen:ba,seagreen:ca,darkslategray:da,darkslategrey:ea,limegreen:fa,mediumseagreen:ga,turquoise:ha,royalblue:ia,steelblue:ja,darkslateblue:ka,mediumturquoise:la,indigo:ma,darkolivegreen:na,cadetblue:oa,cornflowerblue:pa,mediumaquamarine:qa,dimgray:ra,dimgrey:sa,slateblue:ta,olivedrab:ua,slategray:va,slategrey:wa,lightslategray:xa,lightslategrey:ya,mediumslateblue:za,lawngreen:Aa,aquamarine:Ba,chartreuse:Ca,gray:Da,grey:Ea,maroon:Fa,olive:Ga,purple:Ha,lightskyblue:Ia,skyblue:Ja,blueviolet:Ka,darkmagenta:La,darkred:Ma,saddlebrown:Na,darkseagreen:Oa,lightgreen:Pa,mediumpurple:Qa,darkviolet:Ra,palegreen:Sa,darkorchid:Ta,yellowgreen:Ua,sienna:Va,brown:Wa,darkgray:Xa,darkgrey:Ya,greenyellow:Za,lightblue:$a,paleturquoise:_a,lightsteelblue:ab,powderblue:bb,firebrick:cb,darkgoldenrod:db,mediumorchid:eb,rosybrown:fb,darkkhaki:gb,silver:hb,mediumvioletred:ib,indianred:jb,peru:kb,chocolate:lb,tan:mb,lightgray:nb,lightgrey:ob,thistle:pb,goldenrod:qb,orchid:rb,palevioletred:sb,crimson:tb,gainsboro:ub,plum:vb,burlywood:wb,lightcyan:xb,lavender:yb,darksalmon:zb,palegoldenrod:Ab,violet:Bb,azure:Cb,honeydew:Db,khaki:Eb,lightcoral:Fb,sandybrown:Gb,beige:Hb,mintcream:Ib,wheat:Jb,whitesmoke:Kb,ghostwhite:Lb,lightgoldenrodyellow:Mb,linen:Nb,salmon:Ob,oldlace:Pb,bisque:Qb,blanchedalmond:Rb,coral:Sb,cornsilk:Tb,darkorange:Ub,deeppink:Vb,floralwhite:Wb,fuchsia:Xb,gold:Yb,hotpink:Zb,ivory:$b,lavenderblush:_b,lemonchiffon:ac,lightpink:bc,lightsalmon:cc,lightyellow:dc,magenta:ec,mistyrose:fc,moccasin:gc,navajowhite:hc,orange:ic,orangered:jc,papayawhip:kc,peachpuff:lc,pink:mc,red:nc,seashell:oc,snow:pc,tomato:qc,white:rc,yellow:sc,rebeccapurple:tc}}),vc=d(uc),wc=function(){return Object.keys(vc)},xc=function(a){if("string"!=typeof a)throw new TypeError("is-named-css-color expects a string");var b=new RegExp("^"+wc().join("|")+"$","i");return b.test(a)},yc="#f0f8ff",zc="#faebd7",Ac="#00ffff",Bc="#7fffd4",Cc="#f0ffff",Dc="#f5f5dc",Ec="#ffe4c4",Fc="#000000",Gc="#ffebcd",Hc="#0000ff",Ic="#8a2be2",Jc="#a52a2a",Kc="#deb887",Lc="#5f9ea0",Mc="#7fff00",Nc="#d2691e",Oc="#ff7f50",Pc="#6495ed",Qc="#fff8dc",Rc="#dc143c",Sc="#00ffff",Tc="#00008b",Uc="#008b8b",Vc="#b8860b",Wc="#a9a9a9",Xc="#006400",Yc="#a9a9a9",Zc="#bdb76b",$c="#8b008b",_c="#556b2f",ad="#ff8c00",bd="#9932cc",cd="#8b0000",dd="#e9967a",ed="#8fbc8f",fd="#483d8b",gd="#2f4f4f",hd="#2f4f4f",id="#00ced1",jd="#9400d3",kd="#ff1493",ld="#00bfff",md="#696969",nd="#696969",od="#1e90ff",pd="#b22222",qd="#fffaf0",rd="#228b22",sd="#ff00ff",td="#dcdcdc",ud="#f8f8ff",vd="#ffd700",wd="#daa520",xd="#808080",yd="#008000",zd="#adff2f",Ad="#808080",Bd="#f0fff0",Cd="#ff69b4",Dd="#cd5c5c",Ed="#4b0082",Fd="#fffff0",Gd="#f0e68c",Hd="#e6e6fa",Id="#fff0f5",Jd="#7cfc00",Kd="#fffacd",Ld="#add8e6",Md="#f08080",Nd="#e0ffff",Od="#fafad2",Pd="#d3d3d3",Qd="#90ee90",Rd="#d3d3d3",Sd="#ffb6c1",Td="#ffa07a",Ud="#20b2aa",Vd="#87cefa",Wd="#778899",Xd="#778899",Yd="#b0c4de",Zd="#ffffe0",$d="#00ff00",_d="#32cd32",ae="#faf0e6",be="#ff00ff",ce="#800000",de="#66cdaa",ee="#0000cd",fe="#ba55d3",ge="#9370db",he="#3cb371",ie="#7b68ee",je="#00fa9a",ke="#48d1cc",le="#c71585",me="#191970",ne="#f5fffa",oe="#ffe4e1",pe="#ffe4b5",qe="#ffdead",re="#000080",se="#fdf5e6",te="#808000",ue="#6b8e23",ve="#ffa500",we="#ff4500",xe="#da70d6",ye="#eee8aa",ze="#98fb98",Ae="#afeeee",Be="#db7093",Ce="#ffefd5",De="#ffdab9",Ee="#cd853f",Fe="#ffc0cb",Ge="#dda0dd",He="#b0e0e6",Ie="#800080",Je="#663399",Ke="#ff0000",Le="#bc8f8f",Me="#4169e1",Ne="#8b4513",Oe="#fa8072",Pe="#f4a460",Qe="#2e8b57",Re="#fff5ee",Se="#a0522d",Te="#c0c0c0",Ue="#87ceeb",Ve="#6a5acd",We="#708090",Xe="#708090",Ye="#fffafa",Ze="#00ff7f",$e="#4682b4",_e="#d2b48c",af="#008080",bf="#d8bfd8",cf="#ff6347",df="#40e0d0",ef="#ee82ee",ff="#f5deb3",gf="#ffffff",hf="#f5f5f5",jf="#ffff00",kf="#9acd32",lf=/*#__PURE__*/Object.freeze({aliceblue:yc,antiquewhite:zc,aqua:Ac,aquamarine:Bc,azure:Cc,beige:Dc,bisque:Ec,black:Fc,blanchedalmond:Gc,blue:Hc,blueviolet:Ic,brown:Jc,burlywood:Kc,cadetblue:Lc,chartreuse:Mc,chocolate:Nc,coral:Oc,cornflowerblue:Pc,cornsilk:Qc,crimson:Rc,cyan:Sc,darkblue:Tc,darkcyan:Uc,darkgoldenrod:Vc,darkgray:Wc,darkgreen:Xc,darkgrey:Yc,darkkhaki:Zc,darkmagenta:$c,darkolivegreen:_c,darkorange:ad,darkorchid:bd,darkred:cd,darksalmon:dd,darkseagreen:ed,darkslateblue:fd,darkslategray:gd,darkslategrey:hd,darkturquoise:id,darkviolet:jd,deeppink:kd,deepskyblue:ld,dimgray:md,dimgrey:nd,dodgerblue:od,firebrick:pd,floralwhite:qd,forestgreen:rd,fuchsia:sd,gainsboro:td,ghostwhite:ud,gold:vd,goldenrod:wd,gray:xd,green:yd,greenyellow:zd,grey:Ad,honeydew:Bd,hotpink:Cd,indianred:Dd,indigo:Ed,ivory:Fd,khaki:Gd,lavender:Hd,lavenderblush:Id,lawngreen:Jd,lemonchiffon:Kd,lightblue:Ld,lightcoral:Md,lightcyan:Nd,lightgoldenrodyellow:Od,lightgray:Pd,lightgreen:Qd,lightgrey:Rd,lightpink:Sd,lightsalmon:Td,lightseagreen:Ud,lightskyblue:Vd,lightslategray:Wd,lightslategrey:Xd,lightsteelblue:Yd,lightyellow:Zd,lime:$d,limegreen:_d,linen:ae,magenta:be,maroon:ce,mediumaquamarine:de,mediumblue:ee,mediumorchid:fe,mediumpurple:ge,mediumseagreen:he,mediumslateblue:ie,mediumspringgreen:je,mediumturquoise:ke,mediumvioletred:le,midnightblue:me,mintcream:ne,mistyrose:oe,moccasin:pe,navajowhite:qe,navy:re,oldlace:se,olive:te,olivedrab:ue,orange:ve,orangered:we,orchid:xe,palegoldenrod:ye,palegreen:ze,paleturquoise:Ae,palevioletred:Be,papayawhip:Ce,peachpuff:De,peru:Ee,pink:Fe,plum:Ge,powderblue:He,purple:Ie,rebeccapurple:Je,red:Ke,rosybrown:Le,royalblue:Me,saddlebrown:Ne,salmon:Oe,sandybrown:Pe,seagreen:Qe,seashell:Re,sienna:Se,silver:Te,skyblue:Ue,slateblue:Ve,slategray:We,slategrey:Xe,snow:Ye,springgreen:Ze,steelblue:$e,tan:_e,teal:af,thistle:bf,tomato:cf,turquoise:df,violet:ef,wheat:ff,white:gf,whitesmoke:hf,yellow:jf,yellowgreen:kf,default:{aliceblue:yc,antiquewhite:zc,aqua:Ac,aquamarine:Bc,azure:Cc,beige:Dc,bisque:Ec,black:Fc,blanchedalmond:Gc,blue:Hc,blueviolet:Ic,brown:Jc,burlywood:Kc,cadetblue:Lc,chartreuse:Mc,chocolate:Nc,coral:Oc,cornflowerblue:Pc,cornsilk:Qc,crimson:Rc,cyan:Sc,darkblue:Tc,darkcyan:Uc,darkgoldenrod:Vc,darkgray:Wc,darkgreen:Xc,darkgrey:Yc,darkkhaki:Zc,darkmagenta:$c,darkolivegreen:_c,darkorange:ad,darkorchid:bd,darkred:cd,darksalmon:dd,darkseagreen:ed,darkslateblue:fd,darkslategray:gd,darkslategrey:hd,darkturquoise:id,darkviolet:jd,deeppink:kd,deepskyblue:ld,dimgray:md,dimgrey:nd,dodgerblue:od,firebrick:pd,floralwhite:qd,forestgreen:rd,fuchsia:sd,gainsboro:td,ghostwhite:ud,gold:vd,goldenrod:wd,gray:xd,green:yd,greenyellow:zd,grey:Ad,honeydew:Bd,hotpink:Cd,indianred:Dd,indigo:Ed,ivory:Fd,khaki:Gd,lavender:Hd,lavenderblush:Id,lawngreen:Jd,lemonchiffon:Kd,lightblue:Ld,lightcoral:Md,lightcyan:Nd,lightgoldenrodyellow:Od,lightgray:Pd,lightgreen:Qd,lightgrey:Rd,lightpink:Sd,lightsalmon:Td,lightseagreen:Ud,lightskyblue:Vd,lightslategray:Wd,lightslategrey:Xd,lightsteelblue:Yd,lightyellow:Zd,lime:$d,limegreen:_d,linen:ae,magenta:be,maroon:ce,mediumaquamarine:de,mediumblue:ee,mediumorchid:fe,mediumpurple:ge,mediumseagreen:he,mediumslateblue:ie,mediumspringgreen:je,mediumturquoise:ke,mediumvioletred:le,midnightblue:me,mintcream:ne,mistyrose:oe,moccasin:pe,navajowhite:qe,navy:re,oldlace:se,olive:te,olivedrab:ue,orange:ve,orangered:we,orchid:xe,palegoldenrod:ye,palegreen:ze,paleturquoise:Ae,palevioletred:Be,papayawhip:Ce,peachpuff:De,peru:Ee,pink:Fe,plum:Ge,powderblue:He,purple:Ie,rebeccapurple:Je,red:Ke,rosybrown:Le,royalblue:Me,saddlebrown:Ne,salmon:Oe,sandybrown:Pe,seagreen:Qe,seashell:Re,sienna:Se,silver:Te,skyblue:Ue,slateblue:Ve,slategray:We,slategrey:Xe,snow:Ye,springgreen:Ze,steelblue:$e,tan:_e,teal:af,thistle:bf,tomato:cf,turquoise:df,violet:ef,wheat:ff,white:gf,whitesmoke:hf,yellow:jf,yellowgreen:kf}}),mf=d(lf),nf={ratio:i,score:function(a,b,c){var d=D.score(i(a,b,c));return H(d)?"F":d},isAccessible:function(a,b,c){return 4.5<i(a,b,c)},isNotTransparent:k},of=b(function(a,b){Object.defineProperty(b,"__esModule",{value:!0});var c=function(a){return a&&a.__esModule?a:{default:a}}(nf),d=function(a,b){for(var d=6,e=c.default.isAccessible(a[d],b);!e;)d++,void 0===a[d]?(console.warn("Shades #6 and higher in the color palette do not have a high enough contrast ratio against a background color of "+b+"."),e=!0):e=c.default.isAccessible(a[d],b);return l(d,Object.keys(a).length-1)};b.default=function c(a,b){return{get name(){return b},getShade:function(b){return a[b]},getMainShade:function(){var b,c=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},e=c.backgroundColor,f=void 0===e?"#ffffff":e,g=c.offset,h=void 0===g?0:g;return b="#ffffff"===f?(a.inflection||d(a,f))+h:d(a,f)+h,a[l(b,Object.keys(a).length-1)]}}}}),pf=a(of),qf=b(function(a,b){Object.defineProperty(b,"__esModule",{value:!0});var c=function(a){return a&&a.__esModule?a:{default:a}}(of);b.default=(0,c.default)({1:"#eef7ff",2:"#deedfd",3:"#bddbf4",4:"#84baeb",5:"#3b8fde",6:"#1176d4",7:"#0d66b8",8:"#09549c",9:"#0a4276",10:"#072d52",inflection:6},"blue")});// # Relative luminance
//
// http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
// https://en.wikipedia.org/wiki/Luminance_(relative)
// https://en.wikipedia.org/wiki/Luminosity_function
// https://en.wikipedia.org/wiki/Rec._709#Luma_coefficients
// red, green, and blue coefficients
a(qf);var rf=b(function(a,b){Object.defineProperty(b,"__esModule",{value:!0});var c=function(a){return a&&a.__esModule?a:{default:a}}(of);b.default=(0,c.default)({1:"#fef3f1",2:"#fac3bb",3:"#faa094",4:"#fa7d6d",5:"#eb4f3b",6:"#d24634",7:"#b83e2e",8:"#9e3528",9:"#7a291f",10:"#571d16",inflection:6},"brick")});a(rf);var sf=b(function(a,b){Object.defineProperty(b,"__esModule",{value:!0});var c=function(a){return a&&a.__esModule?a:{default:a}}(of);b.default=(0,c.default)({1:"#fef3e9",2:"#fec491",3:"#fead64",4:"#f58525",5:"#e06107",6:"#ca500f",7:"#b0430c",8:"#983600",9:"#772700",10:"#571d00",inflection:6},"cheddar")});a(sf);var tf=b(function(a,b){Object.defineProperty(b,"__esModule",{value:!0});var c=function(a){return a&&a.__esModule?a:{default:a}}(of);b.default=(0,c.default)({1:"#f54250",2:"#cc313d"},"cherry")});a(tf);var uf=b(function(a,b){Object.defineProperty(b,"__esModule",{value:!0});var c=function(a){return a&&a.__esModule?a:{default:a}}(of);b.default=(0,c.default)({1:"#fafafa",2:"#f6f6f6",3:"#ececec",4:"#dadada",5:"#949494",6:"#757575",7:"#646464",8:"#525252",9:"#3c3c3c",10:"#1c1c1c",inflection:6},"cloud")});a(uf);var vf=b(function(a,b){Object.defineProperty(b,"__esModule",{value:!0});var c=function(a){return a&&a.__esModule?a:{default:a}}(of);b.default=(0,c.default)({1:"#f8f5fa",2:"#ddcbe9",3:"#c4a4d9",4:"#b389d0",5:"#a775c9",6:"#945eb9",7:"#794d96",8:"#5e3c75",9:"#3f284f",10:"#2d1c38",inflection:6},"eggplant")});a(vf);var wf=b(function(a,b){Object.defineProperty(b,"__esModule",{value:!0});var c=function(a){return a&&a.__esModule?a:{default:a}}(of);b.default=(0,c.default)({1:"#fff5dd",2:"#ffe29c",3:"#ffd560",4:"#e8b520",5:"#be8a0d",6:"#9a6f07",7:"#855f07",8:"#715005",9:"#5a4206",10:"#3b2b04",inflection:6},"gold")});a(wf);var xf=b(function(a,b){Object.defineProperty(b,"__esModule",{value:!0});var c=function(a){return a&&a.__esModule?a:{default:a}}(of);b.default=(0,c.default)({1:"#21a921",2:"#0a870a"},"grass")});a(xf);var yf=b(function(a,b){Object.defineProperty(b,"__esModule",{value:!0});var c=function(a){return a&&a.__esModule?a:{default:a}}(of);b.default=(0,c.default)({1:"#edf7ed",2:"#d1ead1",3:"#a3d4a3",4:"#79c679",5:"#35a335",6:"#048a04",7:"#047103",8:"#015e02",9:"#024d03",10:"#023302",inflection:6},"green")});a(yf);var zf=b(function(a,b){Object.defineProperty(b,"__esModule",{value:!0});var c=function(a){return a&&a.__esModule?a:{default:a}}(of);b.default=(0,c.default)({1:"#e8f7f2",2:"#c0eadb",3:"#86e0c2",4:"#24c991",5:"#1a9c6e",6:"#16825c",7:"#12694a",8:"#0d4f38",9:"#0a3c2b",10:"#07291d",inflection:6},"jungle")});a(zf);var Af=b(function(a,b){Object.defineProperty(b,"__esModule",{value:!0});var c=function(a){return a&&a.__esModule?a:{default:a}}(of);b.default=(0,c.default)({1:"#f2f4f9",2:"#d2d9ed",3:"#b2bee0",4:"#91a3d4",5:"#7188c7",6:"#5773bf",7:"#425ba1",8:"#334a88",9:"#24386e",10:"#002244",inflection:6},"magic")});a(Af);var Bf=b(function(a,b){Object.defineProperty(b,"__esModule",{value:!0});var c=function(a){return a&&a.__esModule?a:{default:a}}(of);b.default=(0,c.default)({1:"#ebf9fc",2:"#c9e5ea",3:"#acd5dd",4:"#6eadba",5:"#5f96a1",6:"#4f7e87",7:"#41666e",8:"#324e54",9:"#273e42",10:"#1d2d30",inflection:6},"mist")});a(Bf);var Cf=b(function(a,b){Object.defineProperty(b,"__esModule",{value:!0});var c=function(a){return a&&a.__esModule?a:{default:a}}(of);b.default=(0,c.default)({9:"#40404c",10:"#2f2f39",11:"#1b1b26"},"ninja")});a(Cf);var Df=b(function(a,b){Object.defineProperty(b,"__esModule",{value:!0});var c=function(a){return a&&a.__esModule?a:{default:a}}(of);b.default=(0,c.default)({1:"#eaf7fc",2:"#b0e3f4",3:"#75cfec",4:"#00a7db",5:"#0093c4",6:"#007fad",7:"#006c94",8:"#005a75",9:"#00465c",10:"#003342",inflection:6},"ocean")});a(Df);var Ef=b(function(a,b){Object.defineProperty(b,"__esModule",{value:!0});var c=function(a){return a&&a.__esModule?a:{default:a}}(of);b.default=(0,c.default)({1:"#fff3e3",2:"#ffd69b",3:"#ffb55f",4:"#ff943b",5:"#e65f14",6:"#d04a00",7:"#b54102",8:"#983702",9:"#7a2d00",10:"#541f00",inflection:6},"orange")});a(Ef);var Ff=b(function(a,b){Object.defineProperty(b,"__esModule",{value:!0});var c=function(a){return a&&a.__esModule?a:{default:a}}(of);b.default=(0,c.default)({1:"#f4f6ea",2:"#e0eab8",3:"#ccde87",4:"#a3c523",5:"#7e9e06",6:"#637d05",7:"#536904",8:"#415203",9:"#303d02",10:"#202902",inflection:6},"pickle")});a(Ff);var Gf=b(function(a,b){Object.defineProperty(b,"__esModule",{value:!0});var c=function(a){return a&&a.__esModule?a:{default:a}}(of);b.default=(0,c.default)({1:"#f7f5ff",2:"#e3dbff",3:"#ccbdfe",4:"#bca9fa",5:"#9375f2",6:"#8956f0",7:"#683ac8",8:"#532ca6",9:"#3f1c86",10:"#2a1359",inflection:6},"purple")});a(Gf);var Hf=b(function(a,b){Object.defineProperty(b,"__esModule",{value:!0});var c=function(a){return a&&a.__esModule?a:{default:a}}(of);b.default=(0,c.default)({1:"#fff2f4",2:"#ffe1e6",3:"#fabcc5",4:"#f78394",5:"#ed596f",6:"#e71d3a",7:"#d21c35",8:"#a9172c",9:"#7e1021",10:"#5c0c18",inflection:6},"red")});a(Hf);var If=b(function(a,b){Object.defineProperty(b,"__esModule",{value:!0});var c=function(a){return a&&a.__esModule?a:{default:a}}(of);b.default=(0,c.default)({1:"#fdf2f5",2:"#fbcada",3:"#f8a2bf",4:"#f57aa3",5:"#ed3e79",6:"#d81e5d",7:"#bf1b52",8:"#a61747",9:"#8c143c",10:"#610e29",inflection:6},"sangria")});a(If);var Jf=b(function(a,b){Object.defineProperty(b,"__esModule",{value:!0});var c=function(a){return a&&a.__esModule?a:{default:a}}(of);b.default=(0,c.default)({1:"#fafafa",2:"#f6f6f6",3:"#ececec",4:"#dadada",5:"#949494",6:"#757575",7:"#646464",8:"#525252",9:"#3c3c3c",10:"#1c1c1c",inflection:6},"silver")});a(Jf);var Kf=b(function(a,b){function c(a){return a&&a.__esModule?a:{default:a}}Object.defineProperty(b,"__esModule",{value:!0}),Object.defineProperty(b,"blue",{enumerable:!0,get:function(){return c(qf).default}}),Object.defineProperty(b,"brick",{enumerable:!0,get:function(){return c(rf).default}}),Object.defineProperty(b,"cheddar",{enumerable:!0,get:function(){return c(sf).default}}),Object.defineProperty(b,"cherry",{enumerable:!0,get:function(){return c(tf).default}}),Object.defineProperty(b,"cloud",{enumerable:!0,get:function(){return c(uf).default}}),Object.defineProperty(b,"eggplant",{enumerable:!0,get:function(){return c(vf).default}}),Object.defineProperty(b,"gold",{enumerable:!0,get:function(){return c(wf).default}}),Object.defineProperty(b,"grass",{enumerable:!0,get:function(){return c(xf).default}}),Object.defineProperty(b,"green",{enumerable:!0,get:function(){return c(yf).default}}),Object.defineProperty(b,"jungle",{enumerable:!0,get:function(){return c(zf).default}}),Object.defineProperty(b,"magic",{enumerable:!0,get:function(){return c(Af).default}}),Object.defineProperty(b,"mist",{enumerable:!0,get:function(){return c(Bf).default}}),Object.defineProperty(b,"ninja",{enumerable:!0,get:function(){return c(Cf).default}}),Object.defineProperty(b,"ocean",{enumerable:!0,get:function(){return c(Df).default}}),Object.defineProperty(b,"orange",{enumerable:!0,get:function(){return c(Ef).default}}),Object.defineProperty(b,"pickle",{enumerable:!0,get:function(){return c(Ff).default}}),Object.defineProperty(b,"purple",{enumerable:!0,get:function(){return c(Gf).default}}),Object.defineProperty(b,"red",{enumerable:!0,get:function(){return c(Hf).default}}),Object.defineProperty(b,"sangria",{enumerable:!0,get:function(){return c(If).default}}),Object.defineProperty(b,"silver",{enumerable:!0,get:function(){return c(Jf).default}})}),Lf=a(Kf),Mf=pf({1:"#fef3e9",2:"#fedbbd",3:"#fedbbd",4:"#fead64",5:"#ff993f",6:"#f58525",7:"#EB7100",8:"#e06107",9:"#ca500f",10:"#b0430c"},"chegg"),Nf=pf({1:"#FAE6E3",2:"#FAC3BB",3:"#F36671",4:"#E64956",5:"#F75F4B",6:"#D92F3E",7:"#DA1B2C",8:"#B83E2E",9:"#B31522",10:"#852D21"},"macmillan"),Of=pf({1:"#F7F5FF",2:"#DED6FF",3:"#C2B4FF",4:"#A793FF",5:"#866BFF",6:"#6840F7",7:"#461DD9",8:"#2D04BF",9:"#290B97",10:"#1C056F"},"jrPurple"),Pf=_objectSpread({},Lf,{chegg:Mf,macmillan:Nf,jrPurple:Of}),Qf=function(a,b){var c=2<arguments.length&&arguments[2]!==void 0?arguments[2]:"prod",d="dev"===c?"chameleon-dev.vitalbook.com":"chameleon.vitalsource.com",e="https://".concat(d,"/api/brands/").concat(a,"/").concat(b);return Tf(e,2500).then(function(d){return 200===d.status?d.json():Rf(a,b,d.json(),c)}).catch(function(){return Rf(a,b,"BrandError",c)})},Rf=function(a,b,c){var d=3<arguments.length&&arguments[3]!==void 0?arguments[3]:"prod",e="https://storage.googleapis.com/vst-chameleon-".concat(d,"/backups/backup_").concat(a,"_").concat(b,".json");return fetch(e).then(function(a){return 200===a.status?a.json():c}).catch(function(){return c})},Sf=function(a){// This is necessary to prevent loading brands from external unexpected sources
// When using the brand param
// EX: brand=../../evils3bucket/myEvilBrand.json will load an evil brand
// REGEX built with characters from https://www.owasp.org/index.php/XSS_(Cross_Site_Scripting)_Prevention_Cheat_Sheet
return a.replace(/\.\.|[\\&<>"'/]/gi,"")},Tf=function(a,b){return new Promise(function(c,d){var e=!1,f=setTimeout(function(){e=!0,d(new Error("Request timed out"))},b);fetch(a).then(function(a){clearTimeout(f),e||c(a)}).catch(function(a){e||d(a)})})};module.exports={loadBrand:function e(a,b){var c=2<arguments.length&&arguments[2]!==void 0?arguments[2]:"prod",d=Sf(a);// First try Chameleon
return new Promise(function(a){Qf(d,b,c).then(function(b){a(b.data||b)}).catch(function(a){return console.log(a)})})},colors:Pf}});


/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports = {"colors":{"red":"#D11149","blue":"#1A8FE3","orange":"#F17105","yellow":"#FFCC33","purple":"#6320EE","light-error":"#FFADB3","white":"#FFFFFF","black":"#000000","vstui-base-1":"#000000","vstui-base-2":"#000000","vstui-base-3":"#000000","vstui-base-4":"#000000","vstui-base-5":"#000000","vstui-base-6":"#000000","vstui-base-7":"#000000","vstui-base-8":"#000000","vstui-base-9":"#000000","vstui-base-10":"#000000","vstui-primary-1":"#000000","vstui-primary-2":"#000000","vstui-primary-3":"#000000","vstui-primary-4":"#000000","vstui-primary-5":"#000000","vstui-primary-6":"#000000","vstui-primary-7":"#000000","vstui-primary-8":"#000000","vstui-primary-9":"#000000","vstui-primary-10":"#000000","vstui-secondary-1":"#000000","vstui-secondary-2":"#000000","vstui-secondary-3":"#000000","vstui-secondary-4":"#000000","vstui-secondary-5":"#000000","vstui-secondary-6":"#000000","vstui-secondary-7":"#000000","vstui-secondary-8":"#000000","vstui-secondary-9":"#000000","vstui-secondary-10":"#000000","vstui-secondaryStudent-1":"#000000","vstui-secondaryStudent-2":"#000000","vstui-secondaryStudent-3":"#000000","vstui-secondaryStudent-4":"#000000","vstui-secondaryStudent-5":"#000000","vstui-secondaryStudent-6":"#000000","vstui-secondaryStudent-7":"#000000","vstui-secondaryStudent-8":"#000000","vstui-secondaryStudent-9":"#000000","vstui-secondaryStudent-10":"#000000","vstui-focus-4":"#000000"},"common":{"GradientBackground":{"color":"vstui-base-7","gradient":"black"},"ErrorPageLink":"vstui-base-8","IconButton":{"default":{"base":"white","active":"vstui-secondaryStudent-4"},"dark":{"base":"vstui-base-8"}},"Slider":"vstui-secondaryStudent-4","TextButton":{"default":{"base":{"bg":"vstui-primary-6","fg":"white"},"hover":{"bg":"vstui-primary-7","fg":"white"}}},"Thumbnail":{"pageNum":{"bg":"vstui-base-8","fg":"white"},"active":"vstui-secondaryStudent-4"},"toolbar":"vstui-base-8","login":{"SelectName":{"switchClassBorder":"vstui-secondaryStudent-4"},"MiddleEnterPassword":{"error":"vstui-secondaryStudent-4"},"LoginLozengeButton":{"border":"white@0.5","text":"white"},"ErrorMessage":"light-error"},"selectedAccent":"vstui-secondaryStudent-4","darkHeader":"vstui-base-8","secondaryHeader":"vstui-primary-6","topNav":{"fg":"white","bg":"vstui-base-7","selectedBtn":{"bg":"vstui-base-8","border":"vstui-secondaryStudent-4"}},"subNav":{"bg":"vstui-base-8","fg":"white","selectedBtn":{"border":"vstui-secondaryStudent-4"}},"profile":{"itemHover":{"bg":"vstui-primary-7","fg":"white"}},"focus":{"default":"vstui-focus-4"},"SearchIcon":"vstui-primary-6","AvatarBlank":{"fg":"black@+0.3","bg":"white"},"passwordPics":{"house":"blue","sun":"yellow","heart":"red","apple":"red","fish":"orange","face":"yellow","star":"orange","hat":"purple","tree":"blue"},"ThemedLoader":{"c1":"vstui-primary-6@+0.2","c2":"vstui-primary-6@+0.4","c3":"vstui-primary-6@+0.6","c4":"vstui-primary-6@+0.8","c5":"vstui-primary-6"},"Hotspot":{"c1":"vstui-primary-6@0.3","c2":"vstui-primary-6@0.5","c3":"vstui-primary-6"},"accentSecondary":"vstui-secondary-6"},"kiddie":{"KiddiePageArrow":{"default":{"center":"vstui-primary-6","edge":"white"},"alternate":{"center":"vstui-primary-6","edge":"white"}},"Confetti":{"c1":"red","c2":"yellow","c3":"orange"},"SwimlaneEnd":{"c1":"vstui-primary-6","c2":"vstui-base-7"}},"middle":{"HighlightIcon":"red","NoteIcon":"blue","StarIcon":"orange","ThemedToolTip":{"bg":"vstui-primary-6","fg":"white"},"BookOverlay":{"color":"vstui-base-7","gradient":"black","fg":"white"},"RightPanel":{"header":"vstui-primary-6"},"SwimlaneEnd":{"c1":"vstui-base-7","c2":"vstui-base-8","button":"vstui-base-7"}},"teacher":{"vstui":{"primary":{"1":"vstui-primary-1","2":"vstui-primary-2","3":"vstui-primary-3","4":"vstui-primary-4","5":"vstui-primary-5","6":"vstui-primary-6","7":"vstui-primary-7","8":"vstui-primary-8","9":"vstui-primary-9","10":"vstui-primary-10"},"secondary":{"1":"vstui-secondary-1","2":"vstui-secondary-2","3":"vstui-secondary-3","4":"vstui-secondary-4","5":"vstui-secondary-5","6":"vstui-secondary-6","7":"vstui-secondary-7","8":"vstui-secondary-8","9":"vstui-secondary-9","10":"vstui-secondary-10"}},"explorer":{"activeTab":"vstui-secondary-6","lightning":"vstui-secondary-6","lightningText":"vstui-primary-7","plusIcon":"vstui-primary-7"},"Header":{"bg":"vstui-base-9","buttons":{"default":{"fg":"white","bg":"vstui-base-9","border":"vstui-base-9"},"hover":{"fg":"white","bg":"vstui-base-10","border":"vstui-base-10"},"active":{"fg":"white","bg":"vstui-base-10","border":"vstui-base-4"}},"iconButtons":{"default":{"fg":"white","bg":"vstui-base-9"},"hover":{"fg":"white","bg":"vstui-base-10"},"active":{"fg":"white","bg":"vstui-secondary-6"}}},"subNavBar":"vstui-base-8","subNavBarFg":"white","Slider":"vstui-secondary-6","CollectionStudentIndicator":{"avatar":"vstui-base-8","avatarHead":"white","extra":"vstui-primary-6"},"BookCardBase":{"badge":"vstui-primary-6"},"BookCardMenu":{"buttonHoverBg":"vstui-primary-6","buttonHoverBorder":"vstui-primary-6"},"SelectableBookCard":{"theme":"vstui-primary-6"},"LozengeButton":{"default":{"text":"white","border":"white"},"active":{"text":"white","border":"vstui-base-4"}},"RosterMain":{"header":"vstui-base-10"},"RosterSideBar":{"header":"vstui-base-9","link":"vstui-primary-7"},"RosterStat":"vstui-primary-6","MiddleInstrux":"vstui-primary-7","panelHeader":{"text":"white","bg":"vstui-base-8"},"EmptyCollection":{"text":"vstui-primary-7"},"studentsPanel":{"icons":"vstui-primary-6"},"headers":{"theme":"vstui-primary-7"},"ExploreSearch":{"clear":"vstui-primary-7"},"ExplorePanelNoCollections":{"text":"vstui-primary-7"},"inputBorder":"vstui-secondary-4","BookAlert":{"accent":"vstui-secondary-6"},"matchVstuiButton":{"default":"vstui-primary-6","hover":"vstui-primary-7"},"textLink":"vstui-secondary-7","AssignmentList":{"text":"vstui-primary-7"}}}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en/common.json": [
		743,
		157
	],
	"./en/kiddie.json": [
		744,
		156
	],
	"./en/middle.json": [
		745,
		155
	],
	"./en/teacher.json": [
		746,
		154
	],
	"./es-MX/common.json": [
		747,
		153
	],
	"./es-MX/kiddie.json": [
		748,
		152
	],
	"./es-MX/middle.json": [
		749,
		151
	],
	"./es-MX/teacher.json": [
		750,
		150
	],
	"./pt-BR/common.json": [
		751,
		149
	],
	"./pt-BR/kiddie.json": [
		752,
		148
	],
	"./pt-BR/middle.json": [
		753,
		147
	],
	"./pt-BR/teacher.json": [
		754,
		146
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 142;
module.exports = webpackAsyncContext;

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NEW", function() { return NEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EDIT", function() { return EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VIEW", function() { return VIEW; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_ui_route_RedirectOffSite__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_api_redux_watson_watson_config_selectors__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_ui_pages_shared_url_builder__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_ui_bridge_AssetActivator__ = __webpack_require__(227);
var NEW='new';var EDIT='edit';var VIEW='view';function AssignmentCreatorRedirect(_ref){var match=_ref.match,urlBase=_ref.urlBase;var _match$params=match.params,vbid=_match$params.vbid,assignmentId=_match$params.assignmentId,mode=_match$params.mode;var finalUrl=urlBase+'/#/books/'+vbid+'/assignment/';if(mode===NEW){finalUrl+=NEW;}else if(mode===EDIT){finalUrl+=assignmentId+'/'+EDIT;}else if(mode===VIEW){finalUrl=Object(__WEBPACK_IMPORTED_MODULE_4_app_ui_pages_shared_url_builder__["b" /* getBookshelfViewAssignmentUrl */])(urlBase,vbid,assignmentId);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_ui_bridge_AssetActivator__["a" /* default */],{vbid:vbid},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_app_ui_route_RedirectOffSite__["a" /* default */],{to:finalUrl,params:{sso:true,newWin:true}}));}/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function(state){return{urlBase:Object(__WEBPACK_IMPORTED_MODULE_2_app_api_redux_watson_watson_config_selectors__["c" /* getAssignmentCreatorUrlBase */])(state)};})(AssignmentCreatorRedirect));

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = callApiByName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_objects__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_analytics_reporting__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_merge__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_merge__);
function callApiByName(methodStr,context){var params=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var brand=arguments[3];// Bridge sometimes performs destructive actions on the object, so force a copy before giving to bridge
var finalParams=params.map(function(p){return __WEBPACK_IMPORTED_MODULE_2_merge___default.a.clone(p);});if(brand){finalParams[0]=Object.assign({},finalParams[0],{brand:brand});}var apiFunc=Object(__WEBPACK_IMPORTED_MODULE_0__utils_objects__["b" /* findKeyInObj */])(context,methodStr);var apiContext=Object(__WEBPACK_IMPORTED_MODULE_0__utils_objects__["c" /* findKeyParentInObj */])(context,methodStr);if(apiFunc&&apiContext){var result=apiFunc.apply(apiContext,finalParams);if(!result||typeof result.then!=='function'){Object(__WEBPACK_IMPORTED_MODULE_1_app_api_analytics_reporting__["b" /* noticeError */])('Bridge API Method '+methodStr+' did not return a promise');return Promise.reject({code:'internal.noresponse'});}return result;}Object(__WEBPACK_IMPORTED_MODULE_1_app_api_analytics_reporting__["b" /* noticeError */])('Bridge API method not found '+methodStr);return Promise.reject({code:'internal.methodnotfound'});}

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_api_redux_util_connect_enhancer__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteRenderer__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_redux_bridgesaw_bridgesaw_selectors__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_redux_bridge_session_selectors__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_redux_watson_watson_config_selectors__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_env__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_redux_jigsaw_user_info_selectors__ = __webpack_require__(80);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PrivateRoute=function(_React$Component){_inherits(PrivateRoute,_React$Component);function PrivateRoute(){_classCallCheck(this,PrivateRoute);return _possibleConstructorReturn(this,(PrivateRoute.__proto__||Object.getPrototypeOf(PrivateRoute)).apply(this,arguments));}_createClass(PrivateRoute,[{key:'componentDidMount',value:function componentDidMount(){if(!this.props.jigsawOnly&&this.props.loggedInToJigsaw&&!this.props.loggedInToBridge&&Object(__WEBPACK_IMPORTED_MODULE_7__utils_env__["c" /* isDevOrLocal */])()){alert('This account is is logged into Jigsaw but not Bridge. This might be caused by logging in with a student account that is broken due to an unexpected account merge, logging in with a teacher account that is not rostered to this bridge, or visiting this page while logged in to a normal bookshelf account.\n\nThis message only appears in dev.');}}},{key:'render',value:function render(){var _props=this.props,loggedIn=_props.loggedIn,cookieError=_props.cookieError,restProps=_objectWithoutProperties(_props,['loggedIn','cookieError']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RouteRenderer__["a" /* default */],Object.assign({hasAccess:loggedIn,redirectTo:cookieError?__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["x" /* COOKIE_ERROR */]:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["I" /* LOGIN */]},restProps));}}]);return PrivateRoute;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){return{loggedIn:Object(__WEBPACK_IMPORTED_MODULE_4__api_redux_bridgesaw_bridgesaw_selectors__["b" /* isLoggedIn */])(state),loggedInToBridge:Object(__WEBPACK_IMPORTED_MODULE_5__api_redux_bridge_session_selectors__["h" /* isLoggedInToBridge */])(state),loggedInToJigsaw:Object(__WEBPACK_IMPORTED_MODULE_8__api_redux_jigsaw_user_info_selectors__["c" /* isLoggedInToJigsaw */])(state),jigsawOnly:Object(__WEBPACK_IMPORTED_MODULE_6__api_redux_watson_watson_config_selectors__["E" /* isJigsawOnly */])(state),cookieError:Object(__WEBPACK_IMPORTED_MODULE_4__api_redux_bridgesaw_bridgesaw_selectors__["a" /* hasCookieError */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_app_api_redux_util_connect_enhancer__["a" /* default */])(mapStateToProps)(PrivateRoute));

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PreloadHomePage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_ui_core_common_withLoading__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_SelectUIBase__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_common_HundredPercentContainer__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reader_ReaderPage__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_createUiBaseMountAction__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_MountAfterTransition__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_InitPageData__ = __webpack_require__(363);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MiddleHomeMain=Object(__WEBPACK_IMPORTED_MODULE_1_app_ui_core_common_withLoading__["a" /* default */])(function(){return __webpack_require__.e/* import() */(125).then(__webpack_require__.bind(null, 757));});var KiddieHomeMain=Object(__WEBPACK_IMPORTED_MODULE_1_app_ui_core_common_withLoading__["a" /* default */])(function(){return __webpack_require__.e/* import() */(124).then(__webpack_require__.bind(null, 758));});var PreloadHomePage=Object(__WEBPACK_IMPORTED_MODULE_5__config_createUiBaseMountAction__["a" /* createUiBaseMountAction */])(KiddieHomeMain.preload,MiddleHomeMain.preload);var HomePage=function(_React$Component){_inherits(HomePage,_React$Component);function HomePage(){_classCallCheck(this,HomePage);return _possibleConstructorReturn(this,(HomePage.__proto__||Object.getPrototypeOf(HomePage)).apply(this,arguments));}_createClass(HomePage,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__core_common_HundredPercentContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__config_SelectUIBase__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(KiddieHomeMain,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MiddleHomeMain,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_MountAfterTransition__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__reader_ReaderPage__["a" /* PreloadReaderPage */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_InitPageData__["a" /* default */],null));}}]);return HomePage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["b"] = (HomePage);

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalizeString;
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
module.exports = exports["default"];

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withUiBase;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_redux_watson_watson_config_selectors__ = __webpack_require__(4);
var mapStateToProps=function mapStateToProps(state){return{uiBase:Object(__WEBPACK_IMPORTED_MODULE_1__api_redux_watson_watson_config_selectors__["z" /* getUiBase */])(state)};};function withUiBase(Component){return Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(Component);}

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PreloadReaderPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_utils_strings__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_ui_config_StudentBrandedDocumentTitle__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_ui_config_SelectUIBase__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_ui_core_common_withLoading__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_api_redux_jigsaw_jigsaw_selectors__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_api_redux_route_routes__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_redux_jigsaw_jigsaw_selectors__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_redux_route_routes__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_ui_route_RedirectOnce__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config_createUiBaseMountAction__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__home_HomePage__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_MountAfterTransition__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__jigsaw_SetFocusOnPageLoad__ = __webpack_require__(499);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AsyncKiddieMain=Object(__WEBPACK_IMPORTED_MODULE_5_app_ui_core_common_withLoading__["a" /* default */])(function(){return __webpack_require__.e/* import() */(126).then(__webpack_require__.bind(null, 755));});var AsyncMiddleMain=Object(__WEBPACK_IMPORTED_MODULE_5_app_ui_core_common_withLoading__["a" /* default */])(function(){return __webpack_require__.e/* import() */(123).then(__webpack_require__.bind(null, 756));});var PreloadReaderPage=Object(__WEBPACK_IMPORTED_MODULE_11__config_createUiBaseMountAction__["a" /* createUiBaseMountAction */])(AsyncKiddieMain.preload,AsyncMiddleMain.preload);var ReaderPage=function(_React$Component){_inherits(ReaderPage,_React$Component);function ReaderPage(){_classCallCheck(this,ReaderPage);return _possibleConstructorReturn(this,(ReaderPage.__proto__||Object.getPrototypeOf(ReaderPage)).apply(this,arguments));}_createClass(ReaderPage,[{key:'render',value:function render(){if(this.props.notFound){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_ui_route_RedirectOnce__["a" /* default */],{to:__WEBPACK_IMPORTED_MODULE_7_app_api_redux_route_routes__["q" /* BOOK_NOT_FOUND */]});}else if(this.props.noAccess){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_app_ui_route_RedirectOnce__["a" /* default */],{to:__WEBPACK_IMPORTED_MODULE_9__api_redux_route_routes__["p" /* BOOK_ACCESS_DENIED */]});}var pageProps={vbid:this.props.match.params.vbid};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_ui_config_StudentBrandedDocumentTitle__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_2_app_utils_strings__["c" /* decodeHtml */])(this.props.title)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__jigsaw_SetFocusOnPageLoad__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_ui_config_SelectUIBase__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AsyncKiddieMain,pageProps),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AsyncMiddleMain,pageProps)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shared_MountAfterTransition__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__home_HomePage__["a" /* PreloadHomePage */],null))));}}]);return ReaderPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){return{title:Object(__WEBPACK_IMPORTED_MODULE_6_app_api_redux_jigsaw_jigsaw_selectors__["f" /* getCurrentTitle */])(state),notFound:Object(__WEBPACK_IMPORTED_MODULE_6_app_api_redux_jigsaw_jigsaw_selectors__["p" /* isBookNotFound */])(state),noAccess:Object(__WEBPACK_IMPORTED_MODULE_8__api_redux_jigsaw_jigsaw_selectors__["o" /* isBookNoAccess */])(state)};};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(ReaderPage));

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_api_redux_watson_watson_config_selectors__ = __webpack_require__(4);
function BrandedDocumentTitle(_ref){var title=_ref.title,brandName=_ref.brandName,children=_ref.children;var fullTitle='';if(title&&brandName){fullTitle=brandName+': '+title;}else if(brandName){fullTitle=brandName;}else if(title){fullTitle=title;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a,{title:fullTitle},children);}BrandedDocumentTitle.defaultProps={brandName:''};BrandedDocumentTitle.propTypes={brandName:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,title:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,children:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element.isRequired};var mapStateToProps=function mapStateToProps(state,ownProps){return{title:ownProps.titleId?Object(__WEBPACK_IMPORTED_MODULE_4_app_api_redux_watson_watson_config_selectors__["r" /* getString */])(state,ownProps.titleId):ownProps.title};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(BrandedDocumentTitle));

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createUiBaseMountAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__withUiBase__ = __webpack_require__(148);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function createUiBaseMountAction(kiddieFn,middleFn){var ComponentWithUiBaseMountAction=function(_React$Component){_inherits(ComponentWithUiBaseMountAction,_React$Component);function ComponentWithUiBaseMountAction(){_classCallCheck(this,ComponentWithUiBaseMountAction);return _possibleConstructorReturn(this,(ComponentWithUiBaseMountAction.__proto__||Object.getPrototypeOf(ComponentWithUiBaseMountAction)).apply(this,arguments));}_createClass(ComponentWithUiBaseMountAction,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.timeoutId=setTimeout(function(){if(_this2.props.uiBase==='kiddie'){kiddieFn();}else if(_this2.props.uiBase==='middle'){middleFn();}},this.props.delay);}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearTimeout(this.timeoutId);}},{key:'render',value:function render(){return null;}}]);return ComponentWithUiBaseMountAction;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);ComponentWithUiBaseMountAction.defaultProps={delay:0};return Object(__WEBPACK_IMPORTED_MODULE_1__withUiBase__["a" /* default */])(ComponentWithUiBaseMountAction);}

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = __webpack_require__(490);

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _ReplaceTransition = __webpack_require__(494);

var _ReplaceTransition2 = _interopRequireDefault(_ReplaceTransition);

var _TransitionGroup = __webpack_require__(155);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _Transition = __webpack_require__(84);

var _Transition2 = _interopRequireDefault(_Transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition2.default,
  TransitionGroup: _TransitionGroup2.default,
  ReplaceTransition: _ReplaceTransition2.default,
  CSSTransition: _CSSTransition2.default
};

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterDone: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitDone: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactLifecyclesCompat = __webpack_require__(85);

var _ChildMapping = __webpack_require__(495);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes = {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes2.default.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes2.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes2.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes2.default.func
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }

  /**
   * The `<TransitionGroup>` component manages a set of `<Transition>` components
   * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
   * state machine for managing the mounting and unmounting of components over
   * time.
   *
   * Consider the example below using the `Fade` CSS transition from before.
   * As items are removed or added to the TodoList the `in` prop is toggled
   * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
   * component in a `<TransitionGroup>`, not just css.
   *
   * ## Example
   *
   * <iframe src="https://codesandbox.io/embed/00rqyo26kn?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual `<Transition>`
   * components. This means you can mix and match animations across different
   * list items.
   */
};
var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var handleExited = _this.handleExited.bind(_this);

    // Initial children should all be entering, dependent on appear
    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  TransitionGroup.prototype.getChildContext = function getChildContext() {
    return {
      transitionGroup: { isMounting: !this.appeared }
    };
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;

    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  TransitionGroup.prototype.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);

    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    this.setState(function (state) {
      var children = _extends({}, state.children);

      delete children[child.key];
      return { children: children };
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _props = this.props,
        Component = _props.component,
        childFactory = _props.childFactory,
        props = _objectWithoutProperties(_props, ['component', 'childFactory']);

    var children = values(this.state.children).map(childFactory);

    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }
    return _react2.default.createElement(
      Component,
      props,
      children
    );
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes2.default.object.isRequired
};


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
module.exports = exports['default'];

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCurrentRawZoom;
function getCurrentRawZoom(state){return state.jigsaw.zoom;}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;

var _warning = __webpack_require__(44);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(86);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = "length" in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  if (!appElement && !globalElement) {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return false;
  }

  return true;
}

function hide(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).setAttribute("aria-hidden", "true");
  }
}

function show(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).removeAttribute("aria-hidden");
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = null;
}

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return lastModalTargetId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APP_ID; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_modal__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var lastModalTargetId=null;var APP_ID='modalAppId';var count=0;var ModalTarget=function(_React$Component){_inherits(ModalTarget,_React$Component);function ModalTarget(props){_classCallCheck(this,ModalTarget);/* This addresses issues with each page having its own modal
     * target. Need to not reuse IDs so both can be active at once.
     */var _this=_possibleConstructorReturn(this,(ModalTarget.__proto__||Object.getPrototypeOf(ModalTarget)).call(this,props));var id='modalTargetId'+count++;lastModalTargetId=id;_this.modalTargetId=id;return _this;}_createClass(ModalTarget,[{key:'componentDidMount',value:function componentDidMount(){this.lookForApp();}},{key:'lookForApp',value:function lookForApp(){var _this2=this;var el=document.getElementById(APP_ID);if(el){__WEBPACK_IMPORTED_MODULE_1_react_modal___default.a.setAppElement('#'+APP_ID);}else{setTimeout(function(){return _this2.lookForApp();},100);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:this.modalTargetId});}}]);return ModalTarget;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["b"] = (ModalTarget);

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSelectors;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_api_redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
var emptyArray=[];function createSelectors(name){function getAllData(state){return state.jigsaw[name].entries;}var getItems=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(function(state){return state.jigsaw[name].list.data;},function(state){return getAllData(state);},function(list,data){return list?list.items.map(function(id){return data[id];}).filter(function(item){return!!item;}):emptyArray;});function isProcessing(state,actionName,guid){return state.jigsaw[name].pending[actionName].indexOf(guid)>=0;}return{getItems:getItems,getItemData:function getItemData(state,guid){return state.jigsaw[name].entries[guid];},isPending:function isPending(state){return Object(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_util_async_helpers__["i" /* isPending */])(state.jigsaw[name].list);},hasItems:function hasItems(state){return getItems(state).length>0;},isDeleteProcessing:function isDeleteProcessing(state,guid){return isProcessing(state,'del',guid);},isUpdateProcessing:function isUpdateProcessing(state,guid){return isProcessing(state,'update',guid);},hasError:function hasError(state){return state.jigsaw[name].list.hasError;}};}

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target};Object.defineProperty(exports,"__esModule",{value:!0});function _objectWithoutProperties(obj,keys){var target={};for(var i in obj)0<=keys.indexOf(i)||Object.prototype.hasOwnProperty.call(obj,i)&&(target[i]=obj[i]);return target}var createComponentTheme=function(theme,componentStyles){var vstui=theme.vstui,other=_objectWithoutProperties(theme,["vstui"]);return _extends({vstui:_extends({},componentStyles,vstui)},other)};exports.default=createComponentTheme;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createColor=__webpack_require__(528),_createColor2=_interopRequireDefault(_createColor),_createTypography=__webpack_require__(549),_createTypography2=_interopRequireDefault(_createTypography),_createTransitions=__webpack_require__(550),_createTransitions2=_interopRequireDefault(_createTransitions),_createShape=__webpack_require__(552),_createShape2=_interopRequireDefault(_createShape),_createSizes=__webpack_require__(553),_createSizes2=_interopRequireDefault(_createSizes),_createZIndex=__webpack_require__(554),_createZIndex2=_interopRequireDefault(_createZIndex),_createBoxShadows=__webpack_require__(555),_createBoxShadows2=_interopRequireDefault(_createBoxShadows);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var createTheme=function(){var options=0<arguments.length&&arguments[0]!==void 0?arguments[0]:{},_options$color=options.color,colorInput=_options$color===void 0?{}:_options$color,_options$direction=options.direction,direction=_options$direction===void 0?'ltr':_options$direction,_options$shadow=options.shadow,shadowInput=_options$shadow===void 0?{}:_options$shadow,_options$shape=options.shape,shapeInput=_options$shape===void 0?{}:_options$shape,_options$size=options.size,sizeInput=_options$size===void 0?{}:_options$size,_options$transition=options.transition,transitionInput=_options$transition===void 0?{}:_options$transition,_options$typography=options.typography,typographyInput=_options$typography===void 0?{}:_options$typography,_options$zIndex=options.zIndex,zIndexInput=_options$zIndex===void 0?{}:_options$zIndex,color=(0,_createColor2.default)(colorInput),shadow=(0,_createBoxShadows2.default)(shadowInput),shape=(0,_createShape2.default)(shapeInput),size=(0,_createSizes2.default)(sizeInput),transition=(0,_createTransitions2.default)(transitionInput),typography=(0,_createTypography2.default)(typographyInput),zIndex=(0,_createZIndex2.default)(zIndexInput);return{vstui:{breakpoint:{xs:'(max-width: 375px)'},color:color,direction:direction,rem:function rem(value){var remRegex=/rem$/,pxRegex=/px$/;if('inherit'===value)return value;if('number'==typeof value)return typography.pxToRem(value);if('string'==typeof value){if(value.match(remRegex))return value;if(value.match(pxRegex)){var unitlessValue=value.split(pxRegex)[0],number=parseInt(unitlessValue,10);return typography.pxToRem(number)}}throw new Error('rem: invalid value')},shadow:shadow,shape:shape,size:size,typography:typography,transition:transition,zIndex:zIndex}}};exports.default=createTheme;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _blue=__webpack_require__(529);Object.defineProperty(exports,'blue',{enumerable:!0,get:function get(){return _interopRequireDefault(_blue).default}});var _brick=__webpack_require__(530);Object.defineProperty(exports,'brick',{enumerable:!0,get:function get(){return _interopRequireDefault(_brick).default}});var _cheddar=__webpack_require__(531);Object.defineProperty(exports,'cheddar',{enumerable:!0,get:function get(){return _interopRequireDefault(_cheddar).default}});var _cherry=__webpack_require__(532);Object.defineProperty(exports,'cherry',{enumerable:!0,get:function get(){return _interopRequireDefault(_cherry).default}});var _cloud=__webpack_require__(533);Object.defineProperty(exports,'cloud',{enumerable:!0,get:function get(){return _interopRequireDefault(_cloud).default}});var _eggplant=__webpack_require__(534);Object.defineProperty(exports,'eggplant',{enumerable:!0,get:function get(){return _interopRequireDefault(_eggplant).default}});var _gold=__webpack_require__(535);Object.defineProperty(exports,'gold',{enumerable:!0,get:function get(){return _interopRequireDefault(_gold).default}});var _grass=__webpack_require__(536);Object.defineProperty(exports,'grass',{enumerable:!0,get:function get(){return _interopRequireDefault(_grass).default}});var _green=__webpack_require__(537);Object.defineProperty(exports,'green',{enumerable:!0,get:function get(){return _interopRequireDefault(_green).default}});var _jungle=__webpack_require__(538);Object.defineProperty(exports,'jungle',{enumerable:!0,get:function get(){return _interopRequireDefault(_jungle).default}});var _magic=__webpack_require__(539);Object.defineProperty(exports,'magic',{enumerable:!0,get:function get(){return _interopRequireDefault(_magic).default}});var _mist=__webpack_require__(540);Object.defineProperty(exports,'mist',{enumerable:!0,get:function get(){return _interopRequireDefault(_mist).default}});var _ninja=__webpack_require__(541);Object.defineProperty(exports,'ninja',{enumerable:!0,get:function get(){return _interopRequireDefault(_ninja).default}});var _ocean=__webpack_require__(542);Object.defineProperty(exports,'ocean',{enumerable:!0,get:function get(){return _interopRequireDefault(_ocean).default}});var _orange=__webpack_require__(543);Object.defineProperty(exports,'orange',{enumerable:!0,get:function get(){return _interopRequireDefault(_orange).default}});var _pickle=__webpack_require__(544);Object.defineProperty(exports,'pickle',{enumerable:!0,get:function get(){return _interopRequireDefault(_pickle).default}});var _purple=__webpack_require__(545);Object.defineProperty(exports,'purple',{enumerable:!0,get:function get(){return _interopRequireDefault(_purple).default}});var _red=__webpack_require__(546);Object.defineProperty(exports,'red',{enumerable:!0,get:function get(){return _interopRequireDefault(_red).default}});var _sangria=__webpack_require__(547);Object.defineProperty(exports,'sangria',{enumerable:!0,get:function get(){return _interopRequireDefault(_sangria).default}});var _silver=__webpack_require__(548);Object.defineProperty(exports,'silver',{enumerable:!0,get:function get(){return _interopRequireDefault(_silver).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _styledComponents=__webpack_require__(8);Object.defineProperty(exports,'default',{enumerable:!0,get:function get(){return _styledComponents.withTheme}});

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _Card=__webpack_require__(582);Object.defineProperty(exports,'default',{enumerable:!0,get:function get(){return _interopRequireDefault(_Card).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _Label=__webpack_require__(587);Object.defineProperty(exports,'default',{enumerable:!0,get:function get(){return _interopRequireDefault(_Label).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _themes=__webpack_require__(5),getBackgroundImage=function(color){var encodedColor=encodeURIComponent(color);return'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 14 14\'%3E%3Cpath fill=\''+encodedColor+'\' d=\'M8 6a1 1 0 1 1-2 0V4a1 1 0 1 1 2 0v2zm-1 5a1 1 0 1 1 0-2 1 1 0 1 1 0 2zM7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0z\' /%3E%3C/svg%3E%0A")'},componentTheme=function(baseTheme){var _baseTheme$vstui=baseTheme.vstui,color=_baseTheme$vstui.color,shape=_baseTheme$vstui.shape,size=_baseTheme$vstui.size,typography=_baseTheme$vstui.typography,primaryMain=color.primary.getMainShade(),secondaryMain=color.secondary.getMainShade(),primary3=color.primary.getShade(3),secondary3=color.secondary.getShade(3),black20='rgba(0, 0, 0, 0.20)',black43='rgba(0, 0, 0, 0.43)',backgroundImage=getBackgroundImage(color.transparent),backgroundImage_invalid=getBackgroundImage(color.error),backgroundImage_invalidFocus=getBackgroundImage(color.error),highlight_invalid='#ffb7bd';return(0,_themes.createComponentTheme)(baseTheme,{CheckboxControl_width:'270px',CheckboxControl_minHeight_small:size.small,CheckboxControl_minHeight_medium:size.medium,CheckboxControl_minHeight_large:size.large,CheckboxIcon_backgroundColor_primary:color.white,CheckboxIcon_backgroundColor_primary_invalid:color.white,CheckboxIcon_backgroundColor_primary_disabled:color.white,CheckboxIcon_backgroundColor_primary_focus:color.white,CheckboxIcon_backgroundColor_primary_invalidFocus:color.white,CheckboxIcon_backgroundColor_primary_checked:primaryMain,CheckboxIcon_backgroundColor_primary_checkedInvalid:color.error,CheckboxIcon_backgroundColor_primary_checkedDisabled:black20,CheckboxIcon_backgroundColor_primary_checkedFocus:primaryMain,CheckboxIcon_backgroundColor_primary_checkedInvalidFocus:color.error,CheckboxIcon_backgroundColor_secondary:color.white,CheckboxIcon_backgroundColor_secondary_invalid:color.white,CheckboxIcon_backgroundColor_secondary_disabled:color.white,CheckboxIcon_backgroundColor_secondary_focus:color.white,CheckboxIcon_backgroundColor_secondary_invalidFocus:color.white,CheckboxIcon_backgroundColor_secondary_checked:secondaryMain,CheckboxIcon_backgroundColor_secondary_checkedInvalid:color.error,CheckboxIcon_backgroundColor_secondary_checkedDisabled:black20,CheckboxIcon_backgroundColor_secondary_checkedFocus:secondaryMain,CheckboxIcon_backgroundColor_secondary_checkedInvalidFocus:color.error,CheckboxControl_backgroundImage:backgroundImage,CheckboxControl_backgroundImage_invalid:backgroundImage_invalid,CheckboxControl_backgroundImage_invalidFocus:backgroundImage_invalidFocus,CheckboxControl_backgroundPosition_small:'right 12px top '+(size.small-2-14)/2+'px',CheckboxControl_backgroundPosition_medium:'right 12px top '+(size.medium-2-14)/2+'px',CheckboxControl_backgroundPosition_large:'right 14px top '+(size.large-2-14)/2+'px',CheckboxControl_backgroundSize:'14px 14px',CheckboxIcon_borderColor_primary:black43,CheckboxIcon_borderColor_primary_invalid:color.error,CheckboxIcon_borderColor_primary_disabled:black20,CheckboxIcon_borderColor_primary_focus:color.onSurface,CheckboxIcon_borderColor_primary_invalidFocus:color.onSurface,CheckboxIcon_borderColor_primary_checked:primaryMain,CheckboxIcon_borderColor_primary_checkedInvalid:color.error,CheckboxIcon_borderColor_primary_checkedDisabled:black20,CheckboxIcon_borderColor_primary_checkedFocus:color.onSurface,CheckboxIcon_borderColor_primary_checkedInvalidFocus:color.onSurface,CheckboxIcon_borderColor_secondary:black43,CheckboxIcon_borderColor_secondary_invalid:color.error,CheckboxIcon_borderColor_secondary_disabled:black20,CheckboxIcon_borderColor_secondary_focus:color.onSurface,CheckboxIcon_borderColor_secondary_invalidFocus:color.onSurface,CheckboxIcon_borderColor_secondary_checked:secondaryMain,CheckboxIcon_borderColor_secondary_checkedInvalid:color.error,CheckboxIcon_borderColor_secondary_checkedDisabled:black20,CheckboxIcon_borderColor_secondary_checkedFocus:color.onSurface,CheckboxIcon_borderColor_secondary_checkedInvalidFocus:color.onSurface,CheckboxIcon_color_primary_checked:color.white,CheckboxIcon_color_primary_checkedInvalid:color.white,CheckboxIcon_color_primary_checkedDisabled:color.white,CheckboxIcon_color_primary_checkedFocus:color.white,CheckboxIcon_color_primary_checkedInvalidFocus:color.white,CheckboxIcon_color_secondary_checked:color.white,CheckboxIcon_color_secondary_checkedInvalid:color.white,CheckboxIcon_color_secondary_checkedDisabled:color.white,CheckboxIcon_color_secondary_checkedFocus:color.white,CheckboxIcon_color_secondary_checkedInvalidFocus:color.white,CheckboxControl_fontFamily:typography.fontFamily,CheckboxControl_fontSize_small:typography.fontSize,CheckboxControl_fontSize_medium:typography.fontSize,CheckboxControl_fontSize_large:typography.fontSize,CheckboxControl_fontWeight:typography.fontWeightRegular,CheckboxIconHighlight_backgroundColor_primary:color.transparent,CheckboxIconHighlight_backgroundColor_primary_invalid:color.transparent,CheckboxIconHighlight_backgroundColor_primary_disabled:color.transparent,CheckboxIconHighlight_backgroundColor_primary_focus:primary3,CheckboxIconHighlight_backgroundColor_primary_invalidFocus:highlight_invalid,CheckboxIconHighlight_backgroundColor_primary_checked:color.transparent,CheckboxIconHighlight_backgroundColor_primary_checkedInvalid:highlight_invalid,CheckboxIconHighlight_backgroundColor_primary_checkedDisabled:color.transparent,CheckboxIconHighlight_backgroundColor_primary_checkedFocus:primary3,CheckboxIconHighlight_backgroundColor_primary_checkedInvalidFocus:highlight_invalid,CheckboxIconHighlight_backgroundColor_secondary:color.transparent,CheckboxIconHighlight_backgroundColor_secondary_invalid:color.transparent,CheckboxIconHighlight_backgroundColor_secondary_disabled:color.transparent,CheckboxIconHighlight_backgroundColor_secondary_focus:secondary3,CheckboxIconHighlight_backgroundColor_secondary_invalidFocus:highlight_invalid,CheckboxIconHighlight_backgroundColor_secondary_checked:color.transparent,CheckboxIconHighlight_backgroundColor_secondary_checkedInvalid:color.transparent,CheckboxIconHighlight_backgroundColor_secondary_checkedDisabled:color.transparent,CheckboxIconHighlight_backgroundColor_secondary_checkedFocus:secondary3,CheckboxIconHighlight_backgroundColor_secondary_checkedInvalidFocus:highlight_invalid,CheckboxContainer_backgroundColor:color.white,CheckboxContainer_borderColor:black43,CheckboxContainer_borderStyle:shape.borderStyle,CheckboxContainer_borderWidth:shape.borderWidth,CheckboxContainer_borderRadius:shape.borderRadius})};exports.default=componentTheme;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createReactContext=__webpack_require__(610),_createReactContext2=_interopRequireDefault(_createReactContext);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var FormContext=(0,_createReactContext2.default)();exports.default=FormContext;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _Form=__webpack_require__(620);Object.defineProperty(exports,'default',{enumerable:!0,get:function get(){return _interopRequireDefault(_Form).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var TableHeader=function(_PureComponent){function TableHeader(){return _classCallCheck(this,TableHeader),_possibleConstructorReturn(this,(TableHeader.__proto__||Object.getPrototypeOf(TableHeader)).apply(this,arguments))}return _inherits(TableHeader,_PureComponent),_createClass(TableHeader,[{key:'render',value:function render(){return _react2.default.createElement('thead',null,this.props.children)}}]),TableHeader}(_react.PureComponent);TableHeader.propTypes={children:_propTypes2.default.node},TableHeader.displayName='TableHeader',exports.default=TableHeader;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var TableBody=function(_PureComponent){function TableBody(){return _classCallCheck(this,TableBody),_possibleConstructorReturn(this,(TableBody.__proto__||Object.getPrototypeOf(TableBody)).apply(this,arguments))}return _inherits(TableBody,_PureComponent),_createClass(TableBody,[{key:'render',value:function render(){return _react2.default.createElement('tbody',null,this.props.children)}}]),TableBody}(_react.PureComponent);TableBody.propTypes={children:_propTypes2.default.node},TableBody.defaultProps={},TableBody.displayName='TableBody',exports.default=TableBody;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes),_styledComponents=__webpack_require__(8),_styledComponents2=_interopRequireDefault(_styledComponents);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var Styled={tr:_styledComponents2.default.tr.withConfig({displayName:'TableRow__tr'})(['@media print{page-break-inside:avoid;}'])},TableRow=function(_Component){function TableRow(props){_classCallCheck(this,TableRow);var _this=_possibleConstructorReturn(this,(TableRow.__proto__||Object.getPrototypeOf(TableRow)).call(this,props));return _this.state={hover:!1},_this.handleMouseEnter=_this.handleMouseEnter.bind(_this),_this.handleMouseLeave=_this.handleMouseLeave.bind(_this),_this}return _inherits(TableRow,_Component),_createClass(TableRow,[{key:'handleMouseEnter',value:function handleMouseEnter(){this.setState({hover:!0})}},{key:'handleMouseLeave',value:function handleMouseLeave(){this.setState({hover:!1})}},{key:'render',value:function render(){var _this2=this,children=_react2.default.Children.map(this.props.children,function(child){return _react2.default.cloneElement(child,{rowHover:_this2.state.hover})});return _react2.default.createElement(Styled.tr,{onMouseEnter:this.handleMouseEnter,onMouseLeave:this.handleMouseLeave},children)}}]),TableRow}(_react.Component);TableRow.propTypes={children:_propTypes2.default.node},TableRow.defaultProps={},TableRow.displayName='TableRow',exports.default=TableRow;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_templateObject=_taggedTemplateLiteral(['\n  box-sizing: border-box;\n  & *,\n  & *::before,\n  & *::after {\n    box-sizing: inherit;\n  }\n\n  button {\n    cursor: pointer;\n  }\n  button[disabled] {\n    cursor: default;\n  }\n'],['\n  box-sizing: border-box;\n  & *,\n  & *::before,\n  & *::after {\n    box-sizing: inherit;\n  }\n\n  button {\n    cursor: pointer;\n  }\n  button[disabled] {\n    cursor: default;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  border-bottom: 1px solid;\n\n  /* This is purposely using the data cell color token. */\n  /* The header border color is used for dividers between cells. */\n  border-bottom-color: ',';\n\n  font-family: ',';\n  font-weight: ',';\n  text-align: ',';\n\n  /* Hides content, but will still be read by screen readers */\n  ',';\n\n  /* This should hide the cell, retain dimensions, and still be read\n     by screen readers. */\n  opacity: ',';\n\n  @media print {\n    border-bottom-color: ',';\n    opacity: 1;\n  }\n'],['\n  border-bottom: 1px solid;\n\n  /* This is purposely using the data cell color token. */\n  /* The header border color is used for dividers between cells. */\n  border-bottom-color: ',';\n\n  font-family: ',';\n  font-weight: ',';\n  text-align: ',';\n\n  /* Hides content, but will still be read by screen readers */\n  ',';\n\n  /* This should hide the cell, retain dimensions, and still be read\n     by screen readers. */\n  opacity: ',';\n\n  @media print {\n    border-bottom-color: ',';\n    opacity: 1;\n  }\n']),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes),_styledComponents=__webpack_require__(8),_styledComponents2=_interopRequireDefault(_styledComponents),_SortIcon=__webpack_require__(631),_SortIcon2=_interopRequireDefault(_SortIcon),_styles=__webpack_require__(17),_themes=__webpack_require__(5),_propTypes3=__webpack_require__(10);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}))}var Styled={button:{},div:{},span:{}},normalizeStyles=(0,_styles.css)(_templateObject),cellStyles=(0,_styles.css)(_templateObject2,(0,_themes.getStyle)('TableDataCell_borderColor'),(0,_themes.getStyle)('TableHeaderCell_fontFamily'),(0,_themes.getStyle)('TableHeaderCell_fontWeight'),function(props){return props.sc.numeric?'right':'left'},function(props){return props.sc.visuallyHidden?(0,_styles.visuallyHidden)():''},function(props){return props.sc.visuallyHiddenRetainDimensions?0:1},function(props){return props.theme.vstui.color.black});Styled.th=_styledComponents2.default.th.withConfig({displayName:'TableHeaderCell__th'})(['',';',';padding:0;background-color:',';border-left:1px solid;border-left-color:',';color:',';font-size:',';line-height:1.23;&:first-child{border-left:none;}@media print{background:',';border-left:none;color:',';font-weight:',';}'],normalizeStyles,cellStyles,(0,_themes.getStyle)('TableHeaderCell_backgroundColor'),(0,_themes.getStyle)('TableHeaderCell_borderColor'),(0,_themes.getStyle)('TableHeaderCell_color'),function(props){return props.theme.vstui.rem((0,_themes.getStyle)('TableHeaderCell_fontSize')(props))},function(props){return props.theme.vstui.color.white},function(props){return props.theme.vstui.color.black},function(props){return props.theme.vstui.typography.fontWeightMedium}),Styled.div.headerText=_styledComponents2.default.div.withConfig({displayName:'TableHeaderCell__headerText'})(['position:relative;width:100%;background:none;border:none;border-radius:0;@media print{padding:0 5px;}']),Styled.button.sort=_styledComponents2.default.button.withConfig({displayName:'TableHeaderCell__sort'})(['width:100%;padding:5px 20px;background:none;border:none;outline-offset:-4px;color:inherit;font-family:inherit;font-size:inherit;line-height:inherit;text-align:',';',';'],function(props){return props.sc.numeric?'right':'left'},function(props){return props.sc.visuallyHidden?(0,_styles.visuallyHidden)():''}),Styled.div.sortIconWrapper=_styledComponents2.default.div.withConfig({displayName:'TableHeaderCell__sortIconWrapper'})(['position:absolute;top:calc(50% - 2px);right:8px;@media print{display:none;}']),Styled.span.sortDirection=_styledComponents2.default.span.withConfig({displayName:'TableHeaderCell__sortDirection'})(['',';'],function(props){return props.sc.visuallyHidden?(0,_styles.visuallyHidden)():''});var TableHeaderCell=function(_Component){function TableHeaderCell(props){_classCallCheck(this,TableHeaderCell);var _this=_possibleConstructorReturn(this,(TableHeaderCell.__proto__||Object.getPrototypeOf(TableHeaderCell)).call(this,props));return _this.handleClick=_this.handleClick.bind(_this),_this}return _inherits(TableHeaderCell,_Component),_createClass(TableHeaderCell,[{key:'handleClick',value:function handleClick(event){this.props.onClick(event,this.props.index)}},{key:'renderSortIcon',value:function renderSortIcon(){var _props=this.props,index=_props.index,sortIndex=_props.sortIndex,sortOrder=_props.sortOrder,tableType=_props.tableType;if(void 0===sortIndex&&void 0===index)return null;if(sortIndex===index){var direction=1===sortOrder?'ascending':'descending';return _react2.default.createElement(Styled.div.sortIconWrapper,null,'header'===tableType&&_react2.default.createElement(_SortIcon2.default,{direction:direction}),_react2.default.createElement(Styled.span.sortDirection,{sc:{visuallyHidden:!0}},'sorted ',direction))}return null}},{key:'render',value:function render(){var _props2=this.props,children=_props2.children,hidden=_props2.hidden,numeric=_props2.numeric,tableType=_props2.tableType,theme=_props2.theme,conditionalButtonProps={};return('header'===tableType&&hidden||'body'===tableType)&&(conditionalButtonProps.tabIndex=-1),_react2.default.createElement(Styled.th,{sc:{numeric:numeric,visuallyHiddenRetainDimensions:'body'===tableType},scope:'col',theme:theme},_react2.default.createElement(Styled.div.headerText,{sc:{numeric:numeric}},_react2.default.createElement(Styled.button.sort,_extends({},conditionalButtonProps,{onClick:this.handleClick,sc:{visuallyHidden:hidden}}),children,this.renderSortIcon())))}}]),TableHeaderCell}(_react.Component);TableHeaderCell.propTypes={children:_propTypes2.default.node,hidden:_propTypes2.default.bool,index:_propTypes2.default.number,numeric:_propTypes2.default.bool,onClick:_propTypes2.default.func,sortIndex:_propTypes2.default.number,sortOrder:_propTypes2.default.number,tableType:_propTypes2.default.oneOf(['body','header']),theme:_propTypes3.themeShape},TableHeaderCell.defaultProps={theme:(0,_themes.createTheme)()},TableHeaderCell.displayName='TableHeaderCell';var TableHeaderCellWithTheme=(0,_themes.withTheme)(TableHeaderCell);TableHeaderCellWithTheme.WrappedComponent=TableHeaderCell,exports.default=TableHeaderCellWithTheme;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_templateObject=_taggedTemplateLiteral(['\n  border-bottom: 1px solid;\n  border-bottom-color: ',';\n  font-family: ',';\n  font-weight: ',';\n  text-align: ',';\n\n  @media print {\n    border-bottom: 1px solid ',';\n  }\n'],['\n  border-bottom: 1px solid;\n  border-bottom-color: ',';\n  font-family: ',';\n  font-weight: ',';\n  text-align: ',';\n\n  @media print {\n    border-bottom: 1px solid ',';\n  }\n']),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes),_styledComponents=__webpack_require__(8),_styledComponents2=_interopRequireDefault(_styledComponents),_styles=__webpack_require__(17),_themes=__webpack_require__(5),_propTypes3=__webpack_require__(10);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}))}var Styled={div:{}},cellStyles=(0,_styles.css)(_templateObject,(0,_themes.getStyle)('TableDataCell_borderColor'),(0,_themes.getStyle)('TableDataCell_fontFamily'),(0,_themes.getStyle)('TableDataCell_fontWeight'),function(props){return props.numeric?'right':'left'},function(props){return props.theme.vstui.color.black});Styled.td=_styledComponents2.default.td.withConfig({displayName:'TableDataCell__td'})(['',';padding:13px 20px;background:',';color:',';font-size:',';line-height:1.36;vertical-align:top;@media print{padding:0 5px;color:',';font-size:',';}'],cellStyles,function(props){return props.sc.rowHover?props.sc.secondary?(0,_themes.getStyle)('TableDataCell_backgroundColor_secondary_hover'):(0,_themes.getStyle)('TableDataCell_backgroundColor_primary_hover'):(0,_themes.getStyle)('TableDataCell_backgroundColor')},(0,_themes.getStyle)('TableDataCell_color'),function(props){return props.theme.vstui.rem((0,_themes.getStyle)('TableDataCell_fontSize')(props))},function(props){return props.theme.vstui.color.black},function(props){return props.theme.vstui.typography.pxToRem(props.theme.vstui.typography.fontSize-1)});var TableDataCell=function(_Component){function TableDataCell(){return _classCallCheck(this,TableDataCell),_possibleConstructorReturn(this,(TableDataCell.__proto__||Object.getPrototypeOf(TableDataCell)).apply(this,arguments))}return _inherits(TableDataCell,_Component),_createClass(TableDataCell,[{key:'render',value:function render(){var _props=this.props,numeric=_props.numeric,rowHover=_props.rowHover,secondary=_props.secondary,theme=_props.theme;return _react2.default.createElement(Styled.td,{sc:{numeric:numeric,rowHover:rowHover,secondary:secondary},theme:theme},this.props.children)}}]),TableDataCell}(_react.Component);TableDataCell.propTypes={children:_propTypes2.default.node,numeric:_propTypes2.default.bool,rowHover:_propTypes2.default.bool,secondary:_propTypes2.default.bool,theme:_propTypes3.themeShape},TableDataCell.defaultProps={theme:(0,_themes.createTheme)()},TableDataCell.displayName='TableDataCell';var TableDataCellWithTheme=(0,_themes.withTheme)(TableDataCell);TableDataCellWithTheme.WrappedComponent=TableDataCell,exports.default=TableDataCellWithTheme;

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SimpleTextLink;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseTextLink__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_SimpleTextLink_css__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_SimpleTextLink_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_SimpleTextLink_css__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function SimpleTextLink(_ref){var className=_ref.className,restProps=_objectWithoutProperties(_ref,['className']);var classes=['SimpleTextLink',className];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__BaseTextLink__["a" /* default */],Object.assign({className:classes.join(' ')},restProps));}

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withMediaQuery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MediaQuery__ = __webpack_require__(97);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function withMediaQuery(query){return function(Component){return function(_React$Component){_inherits(ComponentWithMediaQuery,_React$Component);function ComponentWithMediaQuery(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ComponentWithMediaQuery);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ComponentWithMediaQuery.__proto__||Object.getPrototypeOf(ComponentWithMediaQuery)).call.apply(_ref,[this].concat(args))),_this),_this.state={matches:Object(__WEBPACK_IMPORTED_MODULE_1__MediaQuery__["b" /* matches */])(query)},_this.boundOnMediaChange=_this.onMediaChange.bind(_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ComponentWithMediaQuery,[{key:'onMediaChange',value:function onMediaChange(matches){this.setState({matches:matches});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({mediaQueryMatches:this.state.matches},this.props)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__MediaQuery__["a" /* default */],{mediaQuery:query,onMediaChange:this.boundOnMediaChange}));}}]);return ComponentWithMediaQuery;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);};}

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_bridge_session_selectors__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_api_redux_route_routes__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_api_redux_util_connect_enhancer__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteRenderer__ = __webpack_require__(56);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CookieRoute=function(_React$Component){_inherits(CookieRoute,_React$Component);function CookieRoute(){_classCallCheck(this,CookieRoute);return _possibleConstructorReturn(this,(CookieRoute.__proto__||Object.getPrototypeOf(CookieRoute)).apply(this,arguments));}_createClass(CookieRoute,[{key:'render',value:function render(){var _props=this.props,cookieError=_props.cookieError,restProps=_objectWithoutProperties(_props,['cookieError']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__RouteRenderer__["a" /* default */],Object.assign({hasAccess:!cookieError,redirectTo:__WEBPACK_IMPORTED_MODULE_2_app_api_redux_route_routes__["x" /* COOKIE_ERROR */]},restProps));}}]);return CookieRoute;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){return{cookieError:Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_bridge_session_selectors__["f" /* hasCookieError */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_app_api_redux_util_connect_enhancer__["a" /* default */])(mapStateToProps)(CookieRoute));

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return toggleStringDebug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return toggleAssetStatus; });
/* harmony export (immutable) */ __webpack_exports__["b"] = pointToProd;
/* harmony export (immutable) */ __webpack_exports__["a"] = pointToDev;
/* harmony export (immutable) */ __webpack_exports__["e"] = tryLoadProdServices;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dev_keys__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_cookie__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dev_selectors__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dom__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_env__ = __webpack_require__(24);
var toggleStringDebug=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["e" /* makeActionCreator */])(__WEBPACK_IMPORTED_MODULE_1__dev_keys__["b" /* TOGGLE_STRING_DEBUG */]);var toggleAssetStatus=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["e" /* makeActionCreator */])(__WEBPACK_IMPORTED_MODULE_1__dev_keys__["a" /* TOGGLE_ASSET_STATUS */]);function setCookieAndReload(newVal){Object(__WEBPACK_IMPORTED_MODULE_2__utils_cookie__["c" /* setCookie */])('productionJigsaw',newVal,2);var interval=window.setInterval(function(){var val=Object(__WEBPACK_IMPORTED_MODULE_2__utils_cookie__["a" /* getCookie */])('productionJigsaw');if(''+val===''+newVal){window.clearInterval(interval);window.location.reload();}},200);}function pointToProd(){return function(){setCookieAndReload('true');};}function pointToDev(){return function(){setCookieAndReload('false');};}function tryLoadProdServices(){return function(dispatch){if(Object(__WEBPACK_IMPORTED_MODULE_3__dev_selectors__["c" /* pointingToProd */])()&&Object(__WEBPACK_IMPORTED_MODULE_5__utils_env__["c" /* isDevOrLocal */])()){window.jigsawLoadError=false;window.bridgeLoadError=false;var cacheBust='?v='+new Date().valueOf();return Object(__WEBPACK_IMPORTED_MODULE_4__utils_dom__["j" /* loadScripts */])('//jigsaw.vitalsource.com/assets/v1/jigsaw/box.js'+cacheBust,'//services.vstbridge.com/assets/v1/bridge.js'+cacheBust).catch(function(){return dispatch(pointToDev());});}return Promise.resolve();};}

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createPersistoid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(31);


// @TODO remove once flow < 0.63 support is no longer required.

function createPersistoid(config) {
  // defaults
  var blacklist = config.blacklist || null;
  var whitelist = config.whitelist || null;
  var transforms = config.transforms || [];
  var throttle = config.throttle || 0;
  var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* KEY_PREFIX */]) + config.key;
  var storage = config.storage;
  var serialize = config.serialize === false ? function (x) {
    return x;
  } : defaultSerialize;

  // initialize stateful values
  var lastState = {};
  var stagedState = {};
  var keysToProcess = [];
  var timeIterator = null;
  var writePromise = null;

  var update = function update(state) {
    // add any changed keys to the queue
    Object.keys(state).forEach(function (key) {
      if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop
      if (lastState[key] === state[key]) return; // value unchanged? noop
      if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop
      keysToProcess.push(key); // add key to queue
    });

    //if any key is missing in the new state which was present in the lastState,
    //add it for processing too
    Object.keys(lastState).forEach(function (key) {
      if (state[key] === undefined) {
        keysToProcess.push(key);
      }
    });

    // start the time iterator if not running (read: throttle)
    if (timeIterator === null) {
      timeIterator = setInterval(processNextKey, throttle);
    }

    lastState = state;
  };

  function processNextKey() {
    if (keysToProcess.length === 0) {
      if (timeIterator) clearInterval(timeIterator);
      timeIterator = null;
      return;
    }

    var key = keysToProcess.shift();
    var endState = transforms.reduce(function (subState, transformer) {
      return transformer.in(subState, key, lastState);
    }, lastState[key]);

    if (endState !== undefined) {
      try {
        stagedState[key] = serialize(endState);
      } catch (err) {
        console.error('redux-persist/createPersistoid: error serializing state', err);
      }
    } else {
      //if the endState is undefined, no need to persist the existing serialized content
      delete stagedState[key];
    }

    if (keysToProcess.length === 0) {
      writeStagedState();
    }
  }

  function writeStagedState() {
    // cleanup any removed keys just before write.
    Object.keys(stagedState).forEach(function (key) {
      if (lastState[key] === undefined) {
        delete stagedState[key];
      }
    });

    writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
  }

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1 && key !== '_persist') return false;
    if (blacklist && blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function onWriteFail(err) {
    // @TODO add fail handlers (typically storage full)
    if (err && "production" !== 'production') {
      console.error('Error storing data', err);
    }
  }

  var flush = function flush() {
    while (keysToProcess.length !== 0) {
      processNextKey();
    }
    return writePromise || Promise.resolve();
  };

  // return `persistoid`
  return {
    update: update,
    flush: flush
  };
}

// @NOTE in the future this may be exposed via config
function defaultSerialize(data) {
  return JSON.stringify(data);
}

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStoredState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(31);




function getStoredState(config) {
  var transforms = config.transforms || [];
  var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* KEY_PREFIX */]) + config.key;
  var storage = config.storage;
  var debug = config.debug;
  var deserialize = config.serialize === false ? function (x) {
    return x;
  } : defaultDeserialize;
  return storage.getItem(storageKey).then(function (serialized) {
    if (!serialized) return undefined;else {
      try {
        var state = {};
        var rawState = deserialize(serialized);
        Object.keys(rawState).forEach(function (key) {
          state[key] = transforms.reduceRight(function (subState, transformer) {
            return transformer.out(subState, key, rawState);
          }, deserialize(rawState[key]));
        });
        return state;
      } catch (err) {
        if (false) console.log('redux-persist/getStoredState: Error restoring data ' + serialized, err);
        throw err;
      }
    }
  });
}

function defaultDeserialize(serial) {
  return JSON.parse(serial);
}

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = purgeStoredState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(31);




function purgeStoredState(config) {
  var storage = config.storage;
  var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* KEY_PREFIX */]) + config.key;
  return storage.removeItem(storageKey, warnIfRemoveError);
}

function warnIfRemoveError(err) {
  if (err && "production" !== 'production') {
    console.error('redux-persist/purgeStoredState: Error purging data stored state', err);
  }
}

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createWebStorage = __webpack_require__(689);

var _createWebStorage2 = _interopRequireDefault(_createWebStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createWebStorage2.default)('local');

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_userdata_utils_reducer_parts__ = __webpack_require__(698);
function createDataReducer(_ref){var get=_ref.get,add=_ref.add,del=_ref.del,_ref$update=_ref.update,update=_ref$update===undefined?'NONE':_ref$update,listName=_ref.listName,itemName=_ref.itemName;return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({list:Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_userdata_utils_reducer_parts__["b" /* createListReducer */])({get:get,add:add,del:del,listName:listName,itemName:itemName}),entries:Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_userdata_utils_reducer_parts__["a" /* createEntryReducer */])({get:get,add:add,update:update,listName:listName,itemName:itemName}),pending:Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_userdata_utils_reducer_parts__["c" /* createPendingReducer */])({add:add,del:del,update:update})});}

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getBatchUpdateReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__ = __webpack_require__(2);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var emptyArray=[];function processUpdate(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["h" /* initialState */];var outputNodeName=arguments[1];var id=arguments[2];var assigned=arguments[3];if(assigned){var data=state.data?state.data[outputNodeName]:emptyArray;var oldCount=state.data?state.data.totalElements:0;var index=data.indexOf(id);if(index===-1){var _Object$assign;return Object.assign({},state,{data:Object.assign({},state.data,(_Object$assign={},_defineProperty(_Object$assign,outputNodeName,[].concat(_toConsumableArray(data),[id])),_defineProperty(_Object$assign,'totalElements',oldCount+1),_Object$assign))});}}else if(!assigned&&state.data&&state.data[outputNodeName]){var offset=state.data.offset;var total=state.data.totalElements;var _data=state.data[outputNodeName];var _index=_data.indexOf(id);if(_index!==-1){var _Object$assign2;var newContent=[].concat(_toConsumableArray(_data));newContent.splice(_index,1);return Object.assign({},state,{data:Object.assign({},state.data,(_Object$assign2={},_defineProperty(_Object$assign2,outputNodeName,newContent),_defineProperty(_Object$assign2,'offset',offset-1),_defineProperty(_Object$assign2,'totalElements',total-1),_Object$assign2))});}}return state;}function getBatchUpdateReducer(_ref){var updateAction=_ref.updateAction,paramNodeName=_ref.paramNodeName,itemKeyName=_ref.itemKeyName,outputNodeName=_ref.outputNodeName,useStart=_ref.useStart;return function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];var actionCreator=useStart?__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["f" /* createStartAction */]:__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["g" /* createSuccessAction */];if(action.type===actionCreator(updateAction).type){var newState=Object.assign({},state);var base=useStart?action.data:action.args;var changedAdoptions=base[0].adoptions;changedAdoptions.forEach(function(a){var adoptionId=a.id;var items=a[paramNodeName];items.forEach(function(item){newState[adoptionId]=processUpdate(newState[adoptionId],outputNodeName,item[itemKeyName],item.assigned);});});return newState;}return state;};}

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export assetReducerInitialState */
/* harmony export (immutable) */ __webpack_exports__["a"] = makeAssetReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__ = __webpack_require__(3);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var assetReducerInitialState=Object.assign({},__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["h" /* initialState */],{pastQueries:[]});function makeAssetReducer(key){var _extras;var baseHandlers=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["a" /* createBaseAsyncHandlers */])(key);function doFetchStart(state,action){var isFirstPage=action.data[0].offset===0;var stateToUse=isFirstPage?assetReducerInitialState:state;var baseResult=baseHandlers[action.type](stateToUse,action);// Search needs to show past queries
if(isFirstPage){var updatedQueries=state.pastQueries.slice();if(state.data&&state.successQuery){updatedQueries.unshift({args:state.successQuery,count:state.data.totalElements});}baseResult.pastQueries=updatedQueries.slice(0,20);}return baseResult;}function doFetchSuccess(state,action){var baseResult=baseHandlers[action.type](state,action);var oldBooks=state.data?state.data.content||[]:[];var vbids=baseResult.data.content.map(function(d){return d.vbid;});return Object.assign({},baseResult,{data:Object.assign({},baseResult.data,{content:oldBooks.concat(vbids)})});}function doFetchFail(state,action){return baseHandlers[action.type](state,action);}var fetchStart=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["f" /* createStartAction */])(key).type;var fetchSuccess=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["g" /* createSuccessAction */])(key).type;var fetchFail=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["c" /* createFailAction */])(key).type;var extras=(_extras={},_defineProperty(_extras,fetchStart,doFetchStart),_defineProperty(_extras,fetchSuccess,doFetchSuccess),_defineProperty(_extras,fetchFail,doFetchFail),_extras);return Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__["a" /* createReducer */])(assetReducerInitialState,extras);}

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _Button=__webpack_require__(43);Object.defineProperty(exports,'Button',{enumerable:!0,get:function get(){return _interopRequireDefault(_Button).default}});var _Card=__webpack_require__(165);Object.defineProperty(exports,'Card',{enumerable:!0,get:function get(){return _interopRequireDefault(_Card).default}});var _Checkbox=__webpack_require__(584);Object.defineProperty(exports,'Checkbox',{enumerable:!0,get:function get(){return _interopRequireDefault(_Checkbox).default}});var _Dialog=__webpack_require__(614);Object.defineProperty(exports,'Dialog',{enumerable:!0,get:function get(){return _interopRequireDefault(_Dialog).default}}),Object.defineProperty(exports,'DialogActionButton',{enumerable:!0,get:function get(){return _Dialog.DialogActionButton}}),Object.defineProperty(exports,'DialogActions',{enumerable:!0,get:function get(){return _Dialog.DialogActions}}),Object.defineProperty(exports,'DialogContent',{enumerable:!0,get:function get(){return _Dialog.DialogContent}});var _Form=__webpack_require__(169);Object.defineProperty(exports,'Form',{enumerable:!0,get:function get(){return _interopRequireDefault(_Form).default}});var _Icon=__webpack_require__(16);Object.defineProperty(exports,'Icon',{enumerable:!0,get:function get(){return _interopRequireDefault(_Icon).default}});var _Link=__webpack_require__(622);Object.defineProperty(exports,'Link',{enumerable:!0,get:function get(){return _interopRequireDefault(_Link).default}});var _Select=__webpack_require__(624);Object.defineProperty(exports,'Select',{enumerable:!0,get:function get(){return _interopRequireDefault(_Select).default}});var _Table=__webpack_require__(629);Object.defineProperty(exports,'Table',{enumerable:!0,get:function get(){return _interopRequireDefault(_Table).default}});var _TextField=__webpack_require__(633);Object.defineProperty(exports,'TextField',{enumerable:!0,get:function get(){return _interopRequireDefault(_TextField).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PAGE_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PAGE_EFFECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BATCH_SCROLL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BATCH_SCROLL_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MODAL_OPENED; });
/**
 * This is intended to be a bypass for special cases where React/Redux performance
 * is inadequate. Don't use this unless you have a specific reason to do so.
 *
 * Use with CustomEvent
 */var PAGE_AREA='events.pageArea';var PAGE_EFFECT='events.pageEffect';var BATCH_SCROLL='events.batchScroll';var BATCH_SCROLL_UPDATE='events.batchScrollUpdate';var MODAL_OPENED='events.modalOpened';

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EventNotifications=function(_React$Component){_inherits(EventNotifications,_React$Component);function EventNotifications(props){_classCallCheck(this,EventNotifications);var _this=_possibleConstructorReturn(this,(EventNotifications.__proto__||Object.getPrototypeOf(EventNotifications)).call(this,props));_this.boundNotify=function(event,data){return _this.notify(event,data);};return _this;}_createClass(EventNotifications,[{key:'componentDidMount',value:function componentDidMount(){this.tryBindEvents();}},{key:'componentWillUnmount',value:function componentWillUnmount(){var _this2=this;clearTimeout(this.timeoutId);if(window.watsonViewer){this.props.events.forEach(function(e){window.watsonViewer.unbind(e,_this2.boundNotify);});}}// TODO: Probably better to replace with an always-present event dispatcher that mediates contact with the viewer
},{key:'tryBindEvents',value:function tryBindEvents(){var _this3=this;if(window.watsonViewer){this.props.events.forEach(function(e){window.watsonViewer.bind(e,_this3.boundNotify);});}else{this.timeoutId=setTimeout(function(){return _this3.tryBindEvents();},this.props.retryInterval);}}},{key:'notify',value:function notify(event,data){if(this.props.onJigsawEvent){this.props.onJigsawEvent(event,data);}}},{key:'render',value:function render(){return null;}}]);return EventNotifications;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);EventNotifications.defaultProps={retryInterval:2000};/* harmony default export */ __webpack_exports__["a"] = (EventNotifications);

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createBridgeAction;
function createBridgeAction(apiCall){return function(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return{bridge:{apiCall:apiCall,args:args}};};}

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Manager__ = __webpack_require__(506);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Manager", function() { return __WEBPACK_IMPORTED_MODULE_0__Manager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Target__ = __webpack_require__(507);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Target", function() { return __WEBPACK_IMPORTED_MODULE_1__Target__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popper__ = __webpack_require__(508);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Popper", function() { return __WEBPACK_IMPORTED_MODULE_2__Popper__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "placements", function() { return __WEBPACK_IMPORTED_MODULE_2__Popper__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Arrow__ = __webpack_require__(510);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Arrow", function() { return __WEBPACK_IMPORTED_MODULE_3__Arrow__["a"]; });





/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MascotEnabled;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BrandToggleBoolean__ = __webpack_require__(512);
function MascotEnabled(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__BrandToggleBoolean__["a" /* default */],{configKey:'common.mascotEnabled'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,children),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,null));}

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MountAfterDelay=function(_React$Component){_inherits(MountAfterDelay,_React$Component);function MountAfterDelay(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MountAfterDelay);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MountAfterDelay.__proto__||Object.getPrototypeOf(MountAfterDelay)).call.apply(_ref,[this].concat(args))),_this),_this.state={ready:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MountAfterDelay,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.timeoutId=setTimeout(function(){return _this2.setReady();},this.props.timeout);}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.timeoutId){clearTimeout(this.timeoutId);}}},{key:'setReady',value:function setReady(){this.timeoutId=null;this.setState({ready:true});}},{key:'render',value:function render(){if(this.props.render){return this.props.render(this.state.ready);}if(this.state.ready){return this.props.children;}return this.props.placeholder||null;}}]);return MountAfterDelay;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (MountAfterDelay);MountAfterDelay.propTypes={timeout:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired};

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_ImageWithFadeIn_css__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_ImageWithFadeIn_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_ImageWithFadeIn_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_api_analytics_reporting__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MonitoredImage=function(_React$PureComponent){_inherits(MonitoredImage,_React$PureComponent);function MonitoredImage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MonitoredImage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MonitoredImage.__proto__||Object.getPrototypeOf(MonitoredImage)).call.apply(_ref,[this].concat(args))),_this),_this.boundOnError=_this.onError.bind(_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MonitoredImage,[{key:'onError',value:function onError(e){Object(__WEBPACK_IMPORTED_MODULE_2_app_api_analytics_reporting__["b" /* noticeError */])('Missing Image: '+this.props.src+' or '+this.props.srcSet);if(this.props.onError){this.props.onError(e);}}},{key:'render',value:function render(){var _props=this.props,onError=_props.onError,restProps=_objectWithoutProperties(_props,['onError']);return(// Provided by restProps
// eslint-disable-next-line jsx-a11y/alt-text
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',Object.assign({},restProps,{onError:this.boundOnError})));}}]);return MonitoredImage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);/* harmony default export */ __webpack_exports__["a"] = (MonitoredImage);

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getColors;
/* harmony export (immutable) */ __webpack_exports__["a"] = getColor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_objects__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_color__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_api_analytics_reporting__ = __webpack_require__(14);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();/**
 * Convert color names like "common.IconButton" to
 * {
 *    "common.IconButton": "#00ff00"
 * }
 * Includes color mixing
 * Mostly used for complex color applications
 */function getColors(theme){var result={};for(var _len=arguments.length,colors=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){colors[_key-1]=arguments[_key];}colors.forEach(function(c){var val=Object(__WEBPACK_IMPORTED_MODULE_0__utils_objects__["b" /* findKeyInObj */])(theme,c);if(val){var _val$split=val.split('@'),_val$split2=_slicedToArray(_val$split,2),name=_val$split2[0],alphaStr=_val$split2[1];var hex=Object(__WEBPACK_IMPORTED_MODULE_0__utils_objects__["b" /* findKeyInObj */])(theme.colors,name);if(hex){var alpha=parseFloat(alphaStr)||1;var toMix='#FFFFFF';if(alpha<0){toMix='#000000';}result[c]=Object(__WEBPACK_IMPORTED_MODULE_1__utils_color__["b" /* mix */])(hex,toMix,Math.abs(alpha)*100);}else{Object(__WEBPACK_IMPORTED_MODULE_2_app_api_analytics_reporting__["b" /* noticeError */])('Could not find color: '+name);}}else{Object(__WEBPACK_IMPORTED_MODULE_2_app_api_analytics_reporting__["b" /* noticeError */])('Could not find color: '+c);}if(!result[c]){result[c]='#000000';}});return result;}function getColor(theme,color){return getColors(theme,color)[color];}

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getRandomArbitrary;
/* harmony export (immutable) */ __webpack_exports__["d"] = getRandomInt;
/* harmony export (immutable) */ __webpack_exports__["e"] = getRandomIntInclusive;
/* harmony export (immutable) */ __webpack_exports__["b"] = coinFlip;
/* harmony export (immutable) */ __webpack_exports__["a"] = clamp;
//https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/random
/**
 * @param min Inclusive
 * @param max Exclusive
 * @returns {*}
 */function getRandomArbitrary(min,max){return Math.random()*(max-min)+min;}/**
 * @param min Inclusive
 * @param max Exclusive
 * @returns {number}
 */function getRandomInt(min,max){min=Math.ceil(min);max=Math.floor(max);return Math.floor(Math.random()*(max-min))+min;}/**
 * @param min Inclusive
 * @param max Inclusive
 * @returns {number}
 */function getRandomIntInclusive(min,max){min=Math.ceil(min);max=Math.floor(max);return Math.floor(Math.random()*(max-min+1))+min;}function coinFlip(){return getRandomIntInclusive(0,1)===0;}function clamp(n,min,max){return Math.min(Math.max(n,min),max);}

/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isKiddieUser;
/* unused harmony export isMiddleUser */
/* harmony export (immutable) */ __webpack_exports__["b"] = isJrUser;
/* harmony export (immutable) */ __webpack_exports__["a"] = getShortName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_name__ = __webpack_require__(137);
var KIDDIE_GRADES=['PK','KG','01','02','03'];var MIDDLE_GRADES=['04','05','06','07','08'];function isKiddieUser(grade){return KIDDIE_GRADES.indexOf(grade)>=0;}function isMiddleUser(grade){return MIDDLE_GRADES.indexOf(grade)>=0;}function isJrUser(grade){return isKiddieUser(grade)||isMiddleUser(grade);}function getShortName(student){if(student.firstName){return Object(__WEBPACK_IMPORTED_MODULE_0__utils_name__["a" /* shortenName */])(student.firstName,student.lastName);}return Object(__WEBPACK_IMPORTED_MODULE_0__utils_name__["a" /* shortenName */])(student.first_name,student.last_name);}

/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fonts_FontProvider__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_ScopeStyles__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_common_MainSizer__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MainSizerWithBanner__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_StudentBrandedDocumentTitle__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_TeacherBrandedDocumentTitle__ = __webpack_require__(211);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BasePage=function(_React$Component){_inherits(BasePage,_React$Component);function BasePage(){_classCallCheck(this,BasePage);return _possibleConstructorReturn(this,(BasePage.__proto__||Object.getPrototypeOf(BasePage)).apply(this,arguments));}_createClass(BasePage,[{key:'render',value:function render(){var Sizer=this.props.useBanner?__WEBPACK_IMPORTED_MODULE_5__MainSizerWithBanner__["a" /* default */]:__WEBPACK_IMPORTED_MODULE_3__core_common_MainSizer__["a" /* default */];var innerContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__config_ScopeStyles__["c" /* ScopeStyles */],{styleKey:this.props.styleKey},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__fonts_FontProvider__["a" /* FontProvider */],{fontKey:this.props.fontKey},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Sizer,{minWidth:this.props.minWidth,minHeight:this.props.minHeight,overflow:this.props.overflow,overflowX:this.props.overflowX,overflowY:this.props.overflowY},this.props.children)));var Title=this.props.teacherBrand?__WEBPACK_IMPORTED_MODULE_7__config_TeacherBrandedDocumentTitle__["a" /* default */]:__WEBPACK_IMPORTED_MODULE_6__config_StudentBrandedDocumentTitle__["a" /* default */];if(this.props.titleId||this.props.title){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,{titleId:this.props.titleId,title:this.props.title},innerContent);}return innerContent;}}]);return BasePage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);BasePage.propTypes={titleId:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,title:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,styleKey:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,fontKey:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,minWidth:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,minHeight:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,overflow:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,overflowX:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,overflowY:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,children:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any.isRequired,useBanner:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,teacherBrand:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (BasePage);

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withModalTargetDetection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_ModalFrame_css__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_ModalFrame_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_ModalFrame_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_ui_core_common_ModalTarget__ = __webpack_require__(159);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function withModalTargetDetection(Component){return function(_React$Component){_inherits(ComponentWithModalTargetDetection,_React$Component);function ComponentWithModalTargetDetection(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ComponentWithModalTargetDetection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ComponentWithModalTargetDetection.__proto__||Object.getPrototypeOf(ComponentWithModalTargetDetection)).call.apply(_ref,[this].concat(args))),_this),_this.state={id:null},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ComponentWithModalTargetDetection,[{key:'componentDidMount',// This makes sure the target is up-to-date and available at initial mount
value:function componentDidMount(){this.setState({id:__WEBPACK_IMPORTED_MODULE_2_app_ui_core_common_ModalTarget__["c" /* lastModalTargetId */]});}},{key:'render',value:function render(){var _this2=this;if(!this.state.id){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({},this.props,{parentSelector:function parentSelector(){return document.querySelector('#'+_this2.state.id);}}));}}]);return ComponentWithModalTargetDetection;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);}

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withTextForward;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__withLocale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__replace_strings__ = __webpack_require__(116);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/**
 * Create a new component that inspects all string properties
 * and attempts to find them in the locale string data,
 * replacing them with the actual string values if present.
 */function withTextForward(Component){function ComponentWithStrings(_ref){var locale=_ref.locale,dispatch=_ref.dispatch,restProps=_objectWithoutProperties(_ref,['locale','dispatch']);var updatedData=Object(__WEBPACK_IMPORTED_MODULE_2__replace_strings__["a" /* replaceStrings */])(locale,restProps,true);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,updatedData);}return Object(__WEBPACK_IMPORTED_MODULE_1__withLocale__["a" /* default */])(ComponentWithStrings);}

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isFullScreen;
/* harmony export (immutable) */ __webpack_exports__["b"] = getZoomScalingFactor;
/* harmony export (immutable) */ __webpack_exports__["a"] = getCurrentScaledZoom;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_jigsaw_zoom_selectors__ = __webpack_require__(156);
function isFullScreen(state){return state.ui.common.reader.isFullScreen;}function getZoomScalingFactor(state){return state.ui.common.reader.zoomScalingFactor;}function getCurrentScaledZoom(state){var rawZoom=Object(__WEBPACK_IMPORTED_MODULE_0__redux_jigsaw_zoom_selectors__["a" /* getCurrentRawZoom */])(state);var factor=getZoomScalingFactor(state);var computed=rawZoom/factor;if(Math.abs(1-computed)<=0.01){return 1;}return computed;}

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_ui_config_withTheme__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_GradientBackground_css__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_GradientBackground_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_GradientBackground_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_ThemedGradient__ = __webpack_require__(222);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GradientBackground=function(_React$Component){_inherits(GradientBackground,_React$Component);function GradientBackground(){_classCallCheck(this,GradientBackground);return _possibleConstructorReturn(this,(GradientBackground.__proto__||Object.getPrototypeOf(GradientBackground)).apply(this,arguments));}_createClass(GradientBackground,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__config_ThemedGradient__["a" /* default */],{color:'common.GradientBackground.color',gradient:'common.GradientBackground.gradient',render:function render(style){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'GradientBackground',style:style},_this2.props.children);}});}}]);return GradientBackground;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_app_ui_config_withTheme__["a" /* default */])(GradientBackground));

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withApi;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_api_bridge_proxy__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_api_redux_route_route_actions__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_redux_watson_watson_config_selectors__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function withApi(ApiComponent){var ApiCaller=function(_Component){_inherits(ApiCaller,_Component);function ApiCaller(props){_classCallCheck(this,ApiCaller);var _this=_possibleConstructorReturn(this,(ApiCaller.__proto__||Object.getPrototypeOf(ApiCaller)).call(this,props));_this.boundCallBridgeApi=function(){return _this.callBridgeApi.apply(_this,arguments);};return _this;}_createClass(ApiCaller,[{key:'componentDidMount',value:function componentDidMount(){this.mounted=true;}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.mounted=false;}},{key:'callBridgeApi',value:function callBridgeApi(methodStr){var _this2=this;for(var _len=arguments.length,params=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){params[_key-1]=arguments[_key];}return new Promise(function(resolve,reject){Object(__WEBPACK_IMPORTED_MODULE_2_app_api_bridge_proxy__["a" /* callApiByName */])(methodStr,window,params,_this2.props.bridgeBrand).then(function(data){if(_this2.mounted){resolve(data);}},function(data){if(_this2.mounted){_this2.props.tryRedirectBridgeFailure(data,methodStr);reject(data);}}).catch();});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ApiComponent,Object.assign({},this.props,{callBridgeApi:this.boundCallBridgeApi}));}}]);return ApiCaller;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);return Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{tryRedirectBridgeFailure:__WEBPACK_IMPORTED_MODULE_3_app_api_redux_route_route_actions__["b" /* tryRedirectBridgeFailure */]})(ApiCaller);}var mapStateToProps=function mapStateToProps(state){return{bridgeBrand:Object(__WEBPACK_IMPORTED_MODULE_4__api_redux_watson_watson_config_selectors__["j" /* getComputedBridgeBrand */])(state)};};

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return toggleReadAloud; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return toggleBookCompletePage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return toggleToolsCollapsed; });
/* harmony export (immutable) */ __webpack_exports__["d"] = prevPageKiddie;
/* harmony export (immutable) */ __webpack_exports__["c"] = nextPageKiddie;
/* harmony export (immutable) */ __webpack_exports__["b"] = hideBookCompletePage;
/* harmony export (immutable) */ __webpack_exports__["a"] = collapseTools;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__kiddie_selectors__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_jigsaw_jigsaw_action__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_jigsaw_page_context_selectors__ = __webpack_require__(50);
var toggleReadAloud=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["e" /* makeActionCreator */])('ui.kiddie.toggleReadAloud');var toggleBookCompletePage=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["e" /* makeActionCreator */])('ui.kiddie.toggleBookCompletePage');var toggleToolsCollapsed=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["e" /* makeActionCreator */])('ui.kiddie.toggleToolsCollapsed');function prevPageKiddie(){return function(dispatch,getState){if(Object(__WEBPACK_IMPORTED_MODULE_1__kiddie_selectors__["c" /* isBookCompleteShowing */])(getState())){dispatch(toggleBookCompletePage());}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_jigsaw_jigsaw_action__["t" /* prevPage */])());}};}function nextPageKiddie(){return function(dispatch,getState){if(!Object(__WEBPACK_IMPORTED_MODULE_3__redux_jigsaw_page_context_selectors__["e" /* hasNextPage */])(getState())){dispatch(toggleBookCompletePage());}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_jigsaw_jigsaw_action__["s" /* nextPage */])());}};}function hideBookCompletePage(){return function(dispatch,getState){if(Object(__WEBPACK_IMPORTED_MODULE_1__kiddie_selectors__["c" /* isBookCompleteShowing */])(getState())){dispatch(toggleBookCompletePage());}};}function collapseTools(){return function(dispatch,getState){if(!Object(__WEBPACK_IMPORTED_MODULE_1__kiddie_selectors__["a" /* areToolsCollapsed */])(getState())){dispatch(toggleToolsCollapsed());}};}

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = BoBroken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function BoBroken(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({focusable:"false","aria-hidden":true,xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 157.78 173.04",width:"315.56",height:"346.08"},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{cx:"49.12",cy:"124.71",rx:"31.12",ry:"3.87",fill:"#bac8cc",opacity:".5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{"data-name":"8-broken_page"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M31.58 123.35h-.08a1.19 1.19 0 0 1-1.11-1.27c.3-4.6.59-14.25.59-14.35a1.19 1.19 0 1 1 2.38.07c0 .1-.3 9.8-.6 14.43a1.19 1.19 0 0 1-1.18 1.12zM1.19 99.94a1.19 1.19 0 0 1-.94-1.92l9.25-12a1.191 1.191 0 1 1 1.89 1.45l-9.25 12a1.19 1.19 0 0 1-.95.47zM91.17 106.67a1.19 1.19 0 0 1-1.17-1c-.61-3.77-2.41-14.09-3.47-16.59a1.19 1.19 0 0 1 2.19-.93c1.39 3.27 3.54 16.57 3.63 17.14a1.19 1.19 0 0 1-1 1.37zM65 124.11a1.19 1.19 0 0 1-1.19-1.1c-.51-6.41-.85-14.27-.86-14.35a1.19 1.19 0 0 1 1.14-1.24 1.22 1.22 0 0 1 1.24 1.14c0 .08.34 7.89.85 14.26a1.19 1.19 0 0 1-1.09 1.28z",fill:"#0a87c6"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#6320ee",d:"M129.79 139.42l-3.08 1.32-3.09-5.44 6.91-.73-.74 4.85zM74.78 153.33l-5.87 2.79.88 1.18.15 2.79 3.23-1.33 2.94 1.47 1.47-4.4-2.8-2.5zM116.45 153.41l-7.88-.51 1.06 3.19 2.99 4.01 2.64-4 4.38.64 3.39-5.5-5.63-1.26-.95 3.43zM130.7 152.76l-5.82-.96-.03 2.06 3.21 2.05 1.39-.75 1.31 1.88 2.72-2.41-1.7-4.13-1.08 2.26zM112.45 169.03l-2.37 1 1.87 1.13 1.31 1.88 2.69-2.63-1.67-3.91-1.83 2.53zM114.36 137.36l-7.17-.39.67-7-7.31-2.73s-1.14-7.34-1.62-7.1c-9.3 4.62-15.2 13.1-15.67 18.85-.07.88 3.65 7.64 4.79 8.1 5.36 2.14 15.13.71 24.06-4.54 2.02-1.22 2.25-5.19 2.25-5.19zm-17.43 4.75l-2 1.85-1.88-1.45 1.68-1.5.9-2.23 3.06 1.44 1.25 3.87zM155.33 147.8c.06-.28.31-2.05.31-2.05l-1.64-2.74 2.61-1.56c.5-2.46 1-4.84 1.14-5.52.32-1.36-3.51.75-6.11-.91-3.85-2.46-7-9.85-12.84-10.38-.33 0 5.59 10.62 5.59 10.62l-5.6 1.71 2.18 3.29-3.39 4.11 2.58 2s-6.77 3.7-6.57 3.72c5.68.52 11.37-4.21 15.85-4.41s5.65 3.31 5.89 2.12z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M78.46 110.36l-72.4-.59a5.09 5.09 0 0 1-2.87-5.66l13.32-74.19a5.09 5.09 0 0 1 5.83-4l74.86 12.7a5.09 5.09 0 0 1 4.15 5.94l-15.74 61.18c-.61 3.26-2.8 4.99-7.15 4.62z",fill:"#1a8fe3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fc3",d:"M56.75 30.65L59.67 0l13 10.63-15.92 20.02z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fc3",d:"M56.74 30.64l13-6.73 9.55 8.53-22.55-1.8z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fc3",d:"M56.75 30.65l-17.93-9.24L49.32 15l7.43 15.65z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{"data-name":"8-broken_page"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M59.47 91.6a.89.89 0 0 1-.82-.54 5.72 5.72 0 0 0-5.32-3.31 6.15 6.15 0 0 0-5.69 3.33.893.893 0 0 1-1.62-.75 7.79 7.79 0 0 1 7.34-4.37 7.45 7.45 0 0 1 6.93 4.39.89.89 0 0 1-.82 1.24z",fill:"#00435e"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M77.81 72.37c0 5.44-4.41 8.86-9.86 8.86s-9.86-5.41-9.86-10.86 4.5-6.8 9.86-5.86 9.86 2.42 9.86 7.86z",fill:"#fff"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{cx:"63.34",cy:"75.86",r:"1.55",fill:"#141104"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M29.5 72.37c0 5.44 4.41 8.86 9.86 8.86s9.86-5.41 9.86-10.86-4.24-6.45-9.86-5.86c-5.42.6-9.86 2.42-9.86 7.86z",fill:"#fff"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{cx:"43.42",cy:"75.86",r:"1.55",fill:"#141104"})));}

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__withModalTargetDetection__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_EmptyModalContainer_css__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_EmptyModalContainer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_EmptyModalContainer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_ui_style_common_zindex__ = __webpack_require__(112);
/**
 * In most cases you will want to use the Modal component to render modal-type content.
 * However, in rare cases the modal content may need to be invisible to screen readers.
 * This doesn't play nice with the Modal, which puts a role on the overlay portion that
 * is still picked up by screen readers and is confusing. react-modal does not currently
 * support removing that attribute. This component renders an empty full-size container
 * into the same target that modals use.
 */function EmptyModalContainer(_ref){var children=_ref.children,parentSelector=_ref.parentSelector,_ref$zIndex=_ref.zIndex,zIndex=_ref$zIndex===undefined?__WEBPACK_IMPORTED_MODULE_4_app_ui_style_common_zindex__["a" /* MODAL */]:_ref$zIndex;var content=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'EmptyModalContainer',style:{zIndex:zIndex}},children);return __WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.createPortal(content,parentSelector());}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__withModalTargetDetection__["a" /* default */])(EmptyModalContainer));

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SCALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SLIDE_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SLIDE_LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SLIDE_RIGHT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_InnerTransition_css__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_InnerTransition_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_InnerTransition_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Duration also exists in css
var DURATION=400;var SCALE='Scale';var SLIDE_UP='SlideUp';var SLIDE_LEFT='SlideLeft';var SLIDE_RIGHT='SlideRight';var InnerTransition=function(_React$Component){_inherits(InnerTransition,_React$Component);function InnerTransition(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InnerTransition);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InnerTransition.__proto__||Object.getPrototypeOf(InnerTransition)).call.apply(_ref,[this].concat(args))),_this),_this.state={currentTransitionKey:_this.props.transitionKey,prevTransitionKey:null,prevValidTransitionKey:null},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InnerTransition,[{key:'shouldBlockTransition',value:function shouldBlockTransition(){var firstLoad=this.state.prevValidTransitionKey===null;var reloadedRoute=this.state.prevValidTransitionKey===this.state.currentTransitionKey;return firstLoad||reloadedRoute||this.props.transitionKey===null;}},{key:'getTransition',value:function getTransition(){var suffix=this.props.transition?this.props.transition:SCALE;return'InnerTransition__'+suffix;}},{key:'render',value:function render(){var classes=['InnerTransition'];if(this.props.flex){classes.push('InnerTransition--Flex');}else if(this.props.hundredPercent){classes.push('InnerTransition--HundredPercent');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_transition_group__["TransitionGroup"],{className:classes.join(' ')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_transition_group__["CSSTransition"],{classNames:this.getTransition(),timeout:DURATION,key:this.props.transitionKey,exit:false,enter:!this.shouldBlockTransition()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'InnerTransition__Content'},this.props.children)));}}]);return InnerTransition;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);InnerTransition.getDerivedStateFromProps=function(nextProps,prevState){if(nextProps.transitionKey!==prevState.currentTransitionKey){var updatedState={currentTransitionKey:nextProps.transitionKey,prevTransitionKey:prevState.currentTransitionKey};if(prevState.currentTransitionKey){updatedState.prevValidTransitionKey=prevState.currentTransitionKey;}return updatedState;}return null;};/* harmony default export */ __webpack_exports__["f"] = (InnerTransition);

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withBrand;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_watson_watson_config_selectors__ = __webpack_require__(4);
var mapStateToProps=function mapStateToProps(state){return{brand:Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_watson_watson_config_selectors__["e" /* getBrand */])(state)};};function withBrand(BrandedComponent){return Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(BrandedComponent);}

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VSTUI_DIALOG_TARGET; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vitalsource_vstui__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vitalsource_vstui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__vitalsource_vstui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_withTextForward__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_replace_strings__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_withLocale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_strings__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var VSTUI_DIALOG_TARGET='vstuiDialogTarget';function VstuiDialog(_ref){var isOpen=_ref.isOpen,addCloseToPrimary=_ref.addCloseToPrimary,addCloseToSecondary=_ref.addCloseToSecondary,locale=_ref.locale,titleParams=_ref.titleParams,restProps=_objectWithoutProperties(_ref,['isOpen','addCloseToPrimary','addCloseToSecondary','locale','titleParams']);var extraProps={};function addClose(itemName){var existingValue=Object.assign({},restProps[itemName]);if(existingValue){var oldClick=existingValue.onClick;existingValue.onClick=function(e){oldClick&&oldClick(e);restProps.onClose();};}extraProps[itemName]=existingValue;}function fixButtonText(button){if(allProps[button]){return Object(__WEBPACK_IMPORTED_MODULE_3__config_replace_strings__["a" /* replaceStrings */])(locale,allProps[button]);}return null;}// title gets expanded to template by withTextForward
if(titleParams){extraProps.title=Object(__WEBPACK_IMPORTED_MODULE_5__utils_strings__["i" /* replaceParams */])(restProps.title,titleParams);}if(addCloseToPrimary){addClose('primaryActionButton');}if(addCloseToSecondary){addClose('secondaryActionButton');}var allProps=Object.assign({},restProps,extraProps);allProps.primaryActionButton=fixButtonText('primaryActionButton');allProps.secondaryActionButton=fixButtonText('secondaryActionButton');return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__vitalsource_vstui__["Dialog"],Object.assign({open:isOpen,onRequestClose:restProps.onClose,rootSelector:'#'+VSTUI_DIALOG_TARGET},allProps));}/**
 * There are a lot of dialogs, and if all the dialogs mount right out of the
 * gate it leads to performance problems. vstui doesn't handle this, so I have to.
 * The two-step process is needed to trigger the enter animation.
 **/var MountableDialog=function(_React$Component){_inherits(MountableDialog,_React$Component);function MountableDialog(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,MountableDialog);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=MountableDialog.__proto__||Object.getPrototypeOf(MountableDialog)).call.apply(_ref2,[this].concat(args))),_this),_this.state={mounted:false,shown:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MountableDialog,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(this.state.mounted&&!prevState.mounted){this.setState({shown:this.props.isOpen});}}},{key:'render',value:function render(){if(!this.state.mounted){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(VstuiDialog,Object.assign({},this.props,{isOpen:this.state.shown}));}}]);return MountableDialog;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);MountableDialog.getDerivedStateFromProps=function(nextProps,prevState){if(nextProps.isOpen){return{mounted:true,shown:prevState.mounted};}return{shown:false};};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_2__config_withTextForward__["a" /* withTextForward */])(Object(__WEBPACK_IMPORTED_MODULE_4__config_withLocale__["a" /* default */])(MountableDialog)));

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_redux_watson_watson_config_selectors__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_common_BrandedDocumentTitle__ = __webpack_require__(150);
var mapStateToProps=function mapStateToProps(state){return{brandName:Object(__WEBPACK_IMPORTED_MODULE_1__api_redux_watson_watson_config_selectors__["u" /* getTeacherBrandName */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__core_common_BrandedDocumentTitle__["a" /* default */]));

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isUserActivityLoading;
/* harmony export (immutable) */ __webpack_exports__["b"] = hasUserActivityLoadError;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSortedUserActivity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_userdata_highlights_selectors__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_api_redux_jigsaw_userdata_bookmarks_selectors__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_api_redux_jigsaw_userdata_notes_selectors__ = __webpack_require__(111);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function isUserActivityLoading(state){return Object(__WEBPACK_IMPORTED_MODULE_2_app_api_redux_jigsaw_userdata_bookmarks_selectors__["a" /* areBookmarksPending */])(state)||Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_userdata_highlights_selectors__["a" /* areHighlightsLoading */])(state)||Object(__WEBPACK_IMPORTED_MODULE_3_app_api_redux_jigsaw_userdata_notes_selectors__["a" /* areNotesPending */])(state);}function hasUserActivityLoadError(state){return Object(__WEBPACK_IMPORTED_MODULE_2_app_api_redux_jigsaw_userdata_bookmarks_selectors__["d" /* hasBookmarkLoadError */])(state)||Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_userdata_highlights_selectors__["d" /* hasHighlightLoadError */])(state)||Object(__WEBPACK_IMPORTED_MODULE_3_app_api_redux_jigsaw_userdata_notes_selectors__["c" /* hasNoteLoadError */])(state);}function sortUserData(normalizedItems){return normalizedItems.sort(function(a,b){if(a.compareDate===b.compareDate){return 0;}return new Date(a.compareDate)<new Date(b.compareDate)?1:-1;});}var getSortedUserActivity=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return Object(__WEBPACK_IMPORTED_MODULE_2_app_api_redux_jigsaw_userdata_bookmarks_selectors__["c" /* getBookmarks */])(state);},function(state){return Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_userdata_highlights_selectors__["b" /* getHighlights */])(state);},function(state){return Object(__WEBPACK_IMPORTED_MODULE_3_app_api_redux_jigsaw_userdata_notes_selectors__["b" /* getNotes */])(state);},function(bookmarks,highlights,notes){var fixedBookmarks=bookmarks.map(function(b){return{data:b,type:'bookmark',compareDate:b.markedAt,key:'bookmark'+b.guid};});var fixedHighlights=highlights.map(function(h){return{data:h,type:'highlight',compareDate:h.lastModifiedAt,key:'highlight'+h.syncId};});var fixedNotes=notes.map(function(n){return{data:n,type:'note',compareDate:n.markedAt,key:'note'+n.guid};});var data=[].concat(_toConsumableArray(fixedBookmarks),_toConsumableArray(fixedHighlights),_toConsumableArray(fixedNotes));return sortUserData(data);});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getSeenStates */
/* harmony export (immutable) */ __webpack_exports__["b"] = hasBeenSeen;
/* harmony export (immutable) */ __webpack_exports__["a"] = getExpiration;
function getUserBase(state){var base=state.ui.common.onboarding;return base[base.active]||{};}function getSeenStates(state){var base=getUserBase(state);var result={};Object.keys(base).filter(function(k){return k!=='expires';}).forEach(function(k){if(base[k].seen){result[k]=true;}});return result;}function hasBeenSeen(state,id){return!!getSeenStates(state)[id];}function getExpiration(state){return getUserBase(state).expires;}

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StudentLoginPage", function() { return StudentLoginPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TeacherLoginPage", function() { return TeacherLoginPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResetPassword", function() { return ResetPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CreateAccount", function() { return CreateAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CompleteAccount", function() { return CompleteAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UpdatePassword", function() { return UpdatePassword; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_common_withLoading__ = __webpack_require__(53);
var StudentLoginPage=Object(__WEBPACK_IMPORTED_MODULE_0__core_common_withLoading__["a" /* default */])(function(){return __webpack_require__.e/* import() */(127).then(__webpack_require__.bind(null, 759));});var TeacherLoginPage=Object(__WEBPACK_IMPORTED_MODULE_0__core_common_withLoading__["a" /* default */])(function(){return __webpack_require__.e/* import() */(134).then(__webpack_require__.bind(null, 760));});var ResetPassword=Object(__WEBPACK_IMPORTED_MODULE_0__core_common_withLoading__["a" /* default */])(function(){return __webpack_require__.e/* import() */(132).then(__webpack_require__.bind(null, 761));});var CreateAccount=Object(__WEBPACK_IMPORTED_MODULE_0__core_common_withLoading__["a" /* default */])(function(){return __webpack_require__.e/* import() */(133).then(__webpack_require__.bind(null, 762));});var CompleteAccount=Object(__WEBPACK_IMPORTED_MODULE_0__core_common_withLoading__["a" /* default */])(function(){return __webpack_require__.e/* import() */(129).then(__webpack_require__.bind(null, 763));});var UpdatePassword=Object(__WEBPACK_IMPORTED_MODULE_0__core_common_withLoading__["a" /* default */])(function(){return __webpack_require__.e/* import() */(131).then(__webpack_require__.bind(null, 764));});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LoadingTest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_Loading_css__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_Loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_Loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_redux_watson_watson_config_selectors__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_ui_config_SimpleThemer__ = __webpack_require__(60);
function Circle(_ref){var color=_ref.color;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_app_ui_config_SimpleThemer__["a" /* default */],{backgroundColor:color,mergeClasses:'Loading__Circle',render:function render(className){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:className});}});}function Loading(_ref2){var alt=_ref2.alt,colors=_ref2.colors;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Loading',role:'img','aria-label':alt},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Circle,{color:colors[0]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Circle,{color:colors[1]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Circle,{color:colors[2]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Circle,{color:colors[3]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Circle,{color:colors[4]}));}Loading.defaultProps={colors:[]};var mapStateToProps=function mapStateToProps(state){return{alt:Object(__WEBPACK_IMPORTED_MODULE_3__api_redux_watson_watson_config_selectors__["r" /* getString */])(state,'common.general.loading')};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(Loading));var LoadingTest=Loading;

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setRawZoom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return zoomIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return zoomOut; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jigsaw_action__ = __webpack_require__(18);
var setRawZoom=Object(__WEBPACK_IMPORTED_MODULE_1__jigsaw_action__["b" /* createJigsawReaderAction */])(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["Q" /* SET_ZOOM_SCALE */]);/**
 * Actions that take no arguments and may be bound to click handlers
 * are pre-bound reject all args here so that you can't accidentally
 * pass in the click event object as a param
 */var zoomIn=function zoomIn(){return Object(__WEBPACK_IMPORTED_MODULE_1__jigsaw_action__["b" /* createJigsawReaderAction */])(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["H" /* INCREASE_ZOOM */])();};var zoomOut=function zoomOut(){return Object(__WEBPACK_IMPORTED_MODULE_1__jigsaw_action__["b" /* createJigsawReaderAction */])(__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["e" /* DECREASE_ZOOM */])();};

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = isReadAloudOpen;
/* harmony export (immutable) */ __webpack_exports__["c"] = isBookCompleteShowing;
/* harmony export (immutable) */ __webpack_exports__["b"] = hasNextPageKiddie;
/* harmony export (immutable) */ __webpack_exports__["a"] = areToolsCollapsed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_jigsaw_page_context_selectors__ = __webpack_require__(50);
function isReadAloudOpen(state){return state.ui.kiddie.isReadAloudOpen;}function isBookCompleteShowing(state){return state.ui.kiddie.isBookCompleteShowing;}function hasNextPageKiddie(state){var jigaswVal=Object(__WEBPACK_IMPORTED_MODULE_0__redux_jigsaw_page_context_selectors__["e" /* hasNextPage */])(state);if(typeof jigaswVal==='boolean'){return!isBookCompleteShowing(state);}return false;}function areToolsCollapsed(state){return state.ui.kiddie.areToolsCollapsed;}

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KIDDIE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MIDDLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TEACHER; });
/* harmony export (immutable) */ __webpack_exports__["c"] = ScopeStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var KIDDIE='kiddie';var MIDDLE='middle';var TEACHER='teacher';function ScopeStyles(_ref){var children=_ref.children,styleKey=_ref.styleKey;var classes=['ScopeStyles'];if(styleKey){classes.push('ScopeStyles--'+styleKey);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.join(' ')},children);}

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return togglePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return toggleSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return toggleReadAloud; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setReadAloud; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return toggleNotesFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return toggleBookmarksFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return toggleHighlightsFilter; });
/* harmony export (immutable) */ __webpack_exports__["a"] = closePanel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__middle_selectors__ = __webpack_require__(223);
var togglePanel=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["e" /* makeActionCreator */])('ui.middle.togglePanel');var toggleSearch=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["e" /* makeActionCreator */])('ui.middle.toggleSearch');var setSearch=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["e" /* makeActionCreator */])('ui.middle.setSearch');var toggleReadAloud=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["e" /* makeActionCreator */])('ui.middle.toggleReadAloud');var setReadAloud=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["e" /* makeActionCreator */])('ui.middle.setReadAloud');var toggleNotesFilter=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["e" /* makeActionCreator */])('ui.middle.toggleNotesFilter');var toggleBookmarksFilter=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["e" /* makeActionCreator */])('ui.middle.toggleBookmarksFilter');var toggleHighlightsFilter=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["e" /* makeActionCreator */])('ui.middle.toggleHighlightsFilter');function closePanel(){return function(dispatch,getState){if(Object(__WEBPACK_IMPORTED_MODULE_1__middle_selectors__["f" /* isPanelOpen */])(getState())){dispatch(togglePanel());}};}

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAssignmentsForVbid; });
/* harmony export (immutable) */ __webpack_exports__["b"] = needsAssignmentFetch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_utils_strings__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_api_redux_watson_watson_config_selectors__ = __webpack_require__(4);
var emptyArray=[];function getAssignments(state){var base=state.feeny.assignments.data;return base&&base.data?base.data:emptyArray;}function createSelectorFactory(){var selectors={};return function(state,vbid){if(!selectors[vbid]){selectors[vbid]=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return getAssignments(state);},function(assignments){return assignments.filter(function(a){return a.vbid===vbid;}).sort(function(a,b){return Object(__WEBPACK_IMPORTED_MODULE_1_app_utils_strings__["a" /* compareCaseInsensitive */])(a.title,b.title);});});}return selectors[vbid](state);};}var getAssignmentsForVbid=createSelectorFactory();function needsAssignmentFetch(state){var base=state.feeny.assignments;return Object(__WEBPACK_IMPORTED_MODULE_2_app_api_redux_watson_watson_config_selectors__["D" /* isFeenyEnabled */])(state)&&!base.isFetching&&!base.successQuery&&!base.failQuery;}

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = callApiByName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_objects__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_analytics_reporting__ = __webpack_require__(14);
function callApiByName(methodStr,context){var params=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var callback=arguments.length>3&&arguments[3]!==undefined?arguments[3]:function(){};var apiFunc=Object(__WEBPACK_IMPORTED_MODULE_0__utils_objects__["b" /* findKeyInObj */])(context,methodStr);var apiContext=Object(__WEBPACK_IMPORTED_MODULE_0__utils_objects__["c" /* findKeyParentInObj */])(context,methodStr);if(apiFunc&&apiContext){return apiFunc.apply(apiContext,params.concat(callback));}var message='Jigsaw API method not found: '+methodStr;Object(__WEBPACK_IMPORTED_MODULE_1_app_api_analytics_reporting__["b" /* noticeError */])(message);callback({isSuccess:function isSuccess(){return false;},message:message,code:404,data:{errors:null}});}

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_ui_config_withTheme__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_common_style_GradientBackground_css__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_common_style_GradientBackground_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__core_common_style_GradientBackground_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_utils_objects__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_color__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ThemedGradient=function(_React$Component){_inherits(ThemedGradient,_React$Component);function ThemedGradient(){_classCallCheck(this,ThemedGradient);return _possibleConstructorReturn(this,(ThemedGradient.__proto__||Object.getPrototypeOf(ThemedGradient)).apply(this,arguments));}_createClass(ThemedGradient,[{key:'render',value:function render(){var colorName=Object(__WEBPACK_IMPORTED_MODULE_3_app_utils_objects__["b" /* findKeyInObj */])(this.props.theme,this.props.color);var gradientName=Object(__WEBPACK_IMPORTED_MODULE_3_app_utils_objects__["b" /* findKeyInObj */])(this.props.theme,this.props.gradient);var color=Object(__WEBPACK_IMPORTED_MODULE_3_app_utils_objects__["b" /* findKeyInObj */])(this.props.theme.colors,colorName);var gradient=Object(__WEBPACK_IMPORTED_MODULE_3_app_utils_objects__["b" /* findKeyInObj */])(this.props.theme.colors,gradientName);var v1=Object(__WEBPACK_IMPORTED_MODULE_5__utils_color__["a" /* hexToCssRgba */])(gradient,0.5);var v2=Object(__WEBPACK_IMPORTED_MODULE_5__utils_color__["a" /* hexToCssRgba */])(gradient,0);var style={backgroundColor:color,backgroundImage:'linear-gradient(-45deg, '+v1+', '+v2+')'};return this.props.render(style);}}]);return ThemedGradient;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_app_ui_config_withTheme__["a" /* default */])(ThemedGradient));ThemedGradient.propTypes={color:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,gradient:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired};

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = isPanelOpen;
/* harmony export (immutable) */ __webpack_exports__["h"] = isSearchOpen;
/* harmony export (immutable) */ __webpack_exports__["g"] = isReadAloudOpen;
/* harmony export (immutable) */ __webpack_exports__["e"] = isNotesFilterOn;
/* harmony export (immutable) */ __webpack_exports__["d"] = isHighlightsFilterOn;
/* harmony export (immutable) */ __webpack_exports__["c"] = isBookmarksFilterOn;
/* harmony export (immutable) */ __webpack_exports__["b"] = hasUserActivity;
/* unused harmony export hasFilteredUserActivity */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFilteredActivityItems; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_jigsaw_userdata_selectors__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_api_redux_jigsaw_userdata_highlights_selectors__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_api_redux_jigsaw_userdata_notes_selectors__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_api_redux_jigsaw_userdata_bookmarks_selectors__ = __webpack_require__(104);
function isPanelOpen(state){return state.ui.middle.isPanelOpen;}function isSearchOpen(state){return state.ui.middle.isSearchOpen;}function isReadAloudOpen(state){return state.ui.middle.isReadAloudOpen;}function isNotesFilterOn(state){return state.ui.middle.notesFilterOn;}function isHighlightsFilterOn(state){return state.ui.middle.highlightsFilterOn;}function isBookmarksFilterOn(state){return state.ui.middle.bookmarksFilterOn;}function hasUserActivity(state){return Object(__WEBPACK_IMPORTED_MODULE_1__redux_jigsaw_userdata_selectors__["a" /* getSortedUserActivity */])(state).length>0;}var hasFilteredUserActivity=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return isNotesFilterOn(state);},function(state){return isHighlightsFilterOn(state);},function(state){return isBookmarksFilterOn(state);},function(state){return Object(__WEBPACK_IMPORTED_MODULE_3_app_api_redux_jigsaw_userdata_notes_selectors__["d" /* hasNotes */])(state);},function(state){return Object(__WEBPACK_IMPORTED_MODULE_2_app_api_redux_jigsaw_userdata_highlights_selectors__["e" /* hasHighlights */])(state);},function(state){return Object(__WEBPACK_IMPORTED_MODULE_4_app_api_redux_jigsaw_userdata_bookmarks_selectors__["e" /* hasBookmarks */])(state);},function(notesOn,highlightsOn,bookmarksOn,hasNotes,hasHighlights,hasBookmarks){return notesOn&&hasNotes||bookmarksOn&&hasBookmarks||highlightsOn&&hasHighlights;});var getFilteredActivityItems=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function(state){return isNotesFilterOn(state);},function(state){return isHighlightsFilterOn(state);},function(state){return isBookmarksFilterOn(state);},function(state){return Object(__WEBPACK_IMPORTED_MODULE_1__redux_jigsaw_userdata_selectors__["a" /* getSortedUserActivity */])(state);},function(notes,highlights,bookmarks,data){return data.filter(function(d){return notes&&d.type==='note'||highlights&&d.type==='highlight'||bookmarks&&d.type==='bookmark';});});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withMatchesTablet;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withMediaQuery__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_common_breakpoints__ = __webpack_require__(98);
function withMatchesTablet(Component){return Object(__WEBPACK_IMPORTED_MODULE_0__withMediaQuery__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__style_common_breakpoints__["a" /* TABLET */])(Component);}

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toggleSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setSearch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__ = __webpack_require__(3);
var toggleSearch=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["e" /* makeActionCreator */])('ui.common.library.toggleSearch');var setSearch=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["e" /* makeActionCreator */])('ui.common.library.setSearch');

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_ui_config_LocaleString__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_ErrorPageTemplate_css__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_ErrorPageTemplate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_ErrorPageTemplate_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_redux_route_routes__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_MascotEnabled__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ErrorPageLink__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SimpleHeaderFrame__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_redux_bridge_session_selectors__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_redux_watson_watson_config_selectors__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fonts_FontProvider__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_BasePage__ = __webpack_require__(199);
function ErrorPageTemplate(_ref){var Bo=_ref.bo,messageIds=_ref.messageIds,hasLibraryLink=_ref.hasLibraryLink,loggedIn=_ref.loggedIn,disableLogoLink=_ref.disableLogoLink,jigsawOnly=_ref.jigsawOnly;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shared_BasePage__["a" /* default */],{fontKey:__WEBPACK_IMPORTED_MODULE_10__fonts_FontProvider__["c" /* MIDDLE */],titleId:'common.pageTitles.error',overflow:'auto',minWidth:'370px',minHeight:'650px'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SimpleHeaderFrame__["a" /* default */],{disableLogoLink:disableLogoLink},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ErrorPageTemplate'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__config_MascotEnabled__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ErrorPageTemplate__Bo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Bo,null))),messageIds.map(function(id){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ErrorPageTemplate__Message',key:id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_app_ui_config_LocaleString__["a" /* default */],{id:id}));}),hasLibraryLink&&!jigsawOnly&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ErrorPageTemplate__LibraryLink'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ErrorPageLink__["a" /* default */],{to:loggedIn?__WEBPACK_IMPORTED_MODULE_3__api_redux_route_routes__["A" /* DEFAULT */]:__WEBPACK_IMPORTED_MODULE_3__api_redux_route_routes__["I" /* LOGIN */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_app_ui_config_LocaleString__["a" /* default */],{id:loggedIn?'common.errorPages.backToLibrary':'common.errorPages.backToSignIn'}))))));}var mapStateToProps=function mapStateToProps(state){return{loggedIn:Object(__WEBPACK_IMPORTED_MODULE_7__api_redux_bridge_session_selectors__["h" /* isLoggedInToBridge */])(state),jigsawOnly:Object(__WEBPACK_IMPORTED_MODULE_9__api_redux_watson_watson_config_selectors__["E" /* isJigsawOnly */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps)(ErrorPageTemplate));

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AssetActivatorTest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bridge_withApi__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_redux_bridge_bridge_methods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AssetActivator=function(_React$Component){_inherits(AssetActivator,_React$Component);function AssetActivator(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AssetActivator);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AssetActivator.__proto__||Object.getPrototypeOf(AssetActivator)).call.apply(_ref,[this].concat(args))),_this),_this.state={activated:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AssetActivator,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.props.callBridgeApi(__WEBPACK_IMPORTED_MODULE_2__api_redux_bridge_bridge_methods__["a" /* ACTIVATE_ASSET */],{vbid:this.props.vbid,active:true})// If there's an error, the page will handle it when it tries to
// render the book content and can't
.catch(function(){}).then(function(){return _this2.setActivated();});}},{key:'setActivated',value:function setActivated(){this.setState({activated:true});}},{key:'render',value:function render(){if(this.state.activated){return this.props.children;}return null;}}]);return AssetActivator;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);AssetActivator.propTypes={vbid:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__bridge_withApi__["a" /* default */])(AssetActivator));var AssetActivatorTest=AssetActivator;

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getBookmarks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deleteBookmark; });
/* unused harmony export setBookmark */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return navToBookmark; });
/* harmony export (immutable) */ __webpack_exports__["d"] = setBookmarkForThumb;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_api_redux_jigsaw_jigsaw_methods__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_action__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_api_redux_jigsaw_jigsaw_selectors__ = __webpack_require__(30);
var getBookmarks=Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_action__["b" /* createJigsawReaderAction */])(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_jigsaw_jigsaw_methods__["m" /* GET_BOOKMARKS */]);var deleteBookmark=Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_action__["b" /* createJigsawReaderAction */])(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_jigsaw_jigsaw_methods__["f" /* DELETE_BOOKMARK */]);var setBookmark=Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_action__["b" /* createJigsawReaderAction */])(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_jigsaw_jigsaw_methods__["N" /* SET_BOOKMARK */]);var navToBookmark=Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_action__["b" /* createJigsawReaderAction */])(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_jigsaw_jigsaw_methods__["y" /* GO_TO_BOOKMARK */]);function setBookmarkForThumb(thumb){return function(dispatch,getState){if(Object(__WEBPACK_IMPORTED_MODULE_2_app_api_redux_jigsaw_jigsaw_selectors__["r" /* isPBK */])(getState())){dispatch(setBookmark({pbk_label:thumb.label,pbk_page:thumb.cfiref.substring(1)}));}else{dispatch(setBookmark({epub_cfi:thumb.cfiref}));}};}

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export updateNoteInternal */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deleteNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addNote; });
/* harmony export (immutable) */ __webpack_exports__["d"] = updateNote;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_api_redux_jigsaw_jigsaw_methods__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_action__ = __webpack_require__(18);
var updateNoteInternal=Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_action__["b" /* createJigsawReaderAction */])(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_jigsaw_jigsaw_methods__["_4" /* UPDATE_NOTE */]);var getNotes=Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_action__["b" /* createJigsawReaderAction */])(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_jigsaw_jigsaw_methods__["s" /* GET_NOTES */]);var deleteNote=Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_action__["b" /* createJigsawReaderAction */])(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_jigsaw_jigsaw_methods__["h" /* DELETE_NOTE */]);var addNote=Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_action__["b" /* createJigsawReaderAction */])(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_jigsaw_jigsaw_methods__["a" /* ADD_NOTE */]);function updateNote(id,note){return function(dispatch){if(!note){dispatch(deleteNote(id));}else{// While the api supports a string, object notation facilitates proper data updates in redux
dispatch(updateNoteInternal(id,{note:note}));}};}

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return logOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSession; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bridge_methods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bridge_actions__ = __webpack_require__(189);
var logOut=Object(__WEBPACK_IMPORTED_MODULE_1__bridge_actions__["a" /* createBridgeAction */])(__WEBPACK_IMPORTED_MODULE_0__bridge_methods__["q" /* LOG_OUT */]);var getSession=Object(__WEBPACK_IMPORTED_MODULE_1__bridge_actions__["a" /* createBridgeAction */])(__WEBPACK_IMPORTED_MODULE_0__bridge_methods__["h" /* GET_SESSION */]);

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_redux_watson_watson_config_selectors__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_common_MonitoredImage__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_objects__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_utils_strings__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_ui_core_common_withMatchesTablet__ = __webpack_require__(224);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function wrapFile(file){if(file.indexOf('/')===-1){return ""+'/'+file;}return file;}var BrandedLogo=function(_Component){_inherits(BrandedLogo,_Component);function BrandedLogo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BrandedLogo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BrandedLogo.__proto__||Object.getPrototypeOf(BrandedLogo)).call.apply(_ref,[this].concat(args))),_this),_this.state={rawWidth:0,rawHeight:0},_this.onImageLoaded=function(e){_this.setState({rawWidth:e.target.naturalWidth||e.target.offsetWidth,rawHeight:e.target.naturalHeight||e.target.offsetHeight});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BrandedLogo,[{key:'useTablet',value:function useTablet(){return this.props.mediaQueryMatches&&!this.props.defaultOnly;}},{key:'getLogoData',value:function getLogoData(){var base=this.useTablet()?this.props.logo.tablet:this.props.logo.default;return base||this.props.logo.default;}},{key:'getWidth',value:function getWidth(){if(this.state.rawWidth===0){return undefined;}return this.state.rawWidth*this.getScale();}},{key:'getHeight',value:function getHeight(){if(this.state.rawHeight===0){return undefined;}return this.state.rawHeight*this.getScale();}},{key:'getScale',value:function getScale(){if(this.state.rawHeight===0){return 1;}var expectedHeight=this.useTablet()?this.props.tabletHeight:this.props.height;return expectedHeight/this.state.rawHeight;}},{key:'render',value:function render(){if(!this.props.logo){return null;}var alt=Object(__WEBPACK_IMPORTED_MODULE_5_app_utils_strings__["i" /* replaceParams */])(this.props.altTemplate,{productName:this.props.logo.alt});var base=this.getLogoData();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__core_common_MonitoredImage__["a" /* default */],{className:this.props.className,src:wrapFile(base.file),alt:alt,style:{display:'block',position:'relative',top:base.vOffset||0,left:0},width:this.getWidth(),height:this.getHeight(),onLoad:this.onImageLoaded});}}]);return BrandedLogo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BrandedLogo.propTypes={logo:__WEBPACK_IMPORTED_MODULE_6_prop_types__["any"],className:__WEBPACK_IMPORTED_MODULE_6_prop_types__["string"],defaultOnly:__WEBPACK_IMPORTED_MODULE_6_prop_types__["any"],altTemplate:__WEBPACK_IMPORTED_MODULE_6_prop_types__["any"]};BrandedLogo.defaultProps={className:''};var mapStateToProps=function mapStateToProps(state,ownProps){return{logo:Object(__WEBPACK_IMPORTED_MODULE_4__utils_objects__["b" /* findKeyInObj */])(Object(__WEBPACK_IMPORTED_MODULE_2__api_redux_watson_watson_config_selectors__["e" /* getBrand */])(state),ownProps.logoKey),altTemplate:Object(__WEBPACK_IMPORTED_MODULE_2__api_redux_watson_watson_config_selectors__["r" /* getString */])(state,'common.productHome')};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_7_app_ui_core_common_withMatchesTablet__["a" /* default */])(BrandedLogo)));

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearSingleFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__ = __webpack_require__(3);
var applyFilters=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["e" /* makeActionCreator */])('ui.teacher.taxonomyFilters.APPLY_FILTERS','data');var setFilter=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["e" /* makeActionCreator */])('ui.teacher.taxonomyFilters.SET_FILTER','taxonomy','name','value');var clearFilters=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["e" /* makeActionCreator */])('ui.teacher.taxonomyFilters.CLEAR_FILTERS');var clearSingleFilter=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["e" /* makeActionCreator */])('ui.teacher.taxonomyFilters.RESET_FILTER','name');

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getHighlights; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return highlightCurrent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deleteHighlight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateHighlight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return goToHighlight; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_api_redux_jigsaw_jigsaw_methods__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_action__ = __webpack_require__(18);
var getHighlights=Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_action__["b" /* createJigsawReaderAction */])(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_jigsaw_jigsaw_methods__["q" /* GET_HIGHLIGHTS */]);var highlightCurrent=Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_action__["b" /* createJigsawReaderAction */])(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_jigsaw_jigsaw_methods__["F" /* HIGHLIGHT_CURRENT */]);var deleteHighlight=Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_action__["b" /* createJigsawReaderAction */])(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_jigsaw_jigsaw_methods__["g" /* DELETE_HIGHLIGHT */]);var updateHighlight=Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_action__["b" /* createJigsawReaderAction */])(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_jigsaw_jigsaw_methods__["_3" /* UPDATE_HIGHLIGHT */]);var goToHighlight=Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_action__["b" /* createJigsawReaderAction */])(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_jigsaw_jigsaw_methods__["A" /* GO_TO_HIGHLIGHT */]);

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAllClasses;
function getAllClasses(state){return state.knownClasses||[];}

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return localizedHumanizer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return localizeModules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_humanize_duration__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_humanize_duration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_humanize_duration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_api_analytics_reporting__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_async__ = __webpack_require__(135);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var localizedHumanizer=__WEBPACK_IMPORTED_MODULE_2_humanize_duration___default.a;var localizeModules=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(locale){var lang,_ref2,index,langs;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:locale=locale.split('_').join('-').toLowerCase();lang=locale.split('-')[0];if(!(locale!=='en')){_context.next=16;break;}_context.prev=3;_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_4__utils_async__["b" /* importFirst */])([function(){return __webpack_require__(136)("./"+locale);},function(){return __webpack_require__(136)("./"+lang);}]);case 6:_ref2=_context.sent;index=_ref2.index;__WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale(index===0?locale:lang);_context.next=14;break;case 11:_context.prev=11;_context.t0=_context['catch'](3);Object(__WEBPACK_IMPORTED_MODULE_3_app_api_analytics_reporting__["b" /* noticeError */])('MomentJS not available for locale '+locale);case 14:_context.next=17;break;case 16:__WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale('en');case 17:langs=__WEBPACK_IMPORTED_MODULE_2_humanize_duration___default.a.getSupportedLanguages();if(langs.indexOf(lang)!==-1){localizedHumanizer=__WEBPACK_IMPORTED_MODULE_2_humanize_duration___default.a.humanizer({language:lang});}else{Object(__WEBPACK_IMPORTED_MODULE_3_app_api_analytics_reporting__["b" /* noticeError */])('HumanizeDuration not available for locale '+locale);}case 19:case'end':return _context.stop();}}},_callee,this,[[3,11]]);}));return function localizeModules(_x){return _ref.apply(this,arguments);};}();

/***/ }),
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HundredPercentTransitionGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HundredPercentTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_HundredPercentTransitions_css__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_HundredPercentTransitions_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_HundredPercentTransitions_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HundredPercentTransitionGroup=function(_React$Component){_inherits(HundredPercentTransitionGroup,_React$Component);function HundredPercentTransitionGroup(){_classCallCheck(this,HundredPercentTransitionGroup);return _possibleConstructorReturn(this,(HundredPercentTransitionGroup.__proto__||Object.getPrototypeOf(HundredPercentTransitionGroup)).apply(this,arguments));}_createClass(HundredPercentTransitionGroup,[{key:'render',value:function render(){var classes=['HundredPercentTransitions__Group'];if(this.props.noPosition){classes.push('HundredPercentTransitions__Group--NoPosition');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.join(' ')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_transition_group__["TransitionGroup"],null,this.props.children));}}]);return HundredPercentTransitionGroup;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var HundredPercentTransition=function(_React$Component2){_inherits(HundredPercentTransition,_React$Component2);function HundredPercentTransition(){_classCallCheck(this,HundredPercentTransition);return _possibleConstructorReturn(this,(HundredPercentTransition.__proto__||Object.getPrototypeOf(HundredPercentTransition)).apply(this,arguments));}_createClass(HundredPercentTransition,[{key:'render',value:function render(){var _props=this.props,children=_props.children,restProps=_objectWithoutProperties(_props,['children']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_transition_group__["CSSTransition"],restProps,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'HundredPercentTransitions__Content'},children));}}]);return HundredPercentTransition;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getToc;
/* harmony export (immutable) */ __webpack_exports__["b"] = getActiveTocLabel;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getActiveTocIndex; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__page_context_selectors__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_api_jigsaw_helpers__ = __webpack_require__(35);
var emptyArray=[];function getToc(state){var data=state.jigsaw[__WEBPACK_IMPORTED_MODULE_0__jigsaw_methods__["w" /* GET_TOC */]].data;return data?data.toc:emptyArray;}function getActiveTocLabel(state){var index=getActiveTocIndex(state);if(index>=0){return getToc(state)[index].title;}return null;}var getActiveTocIndex=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(function(state){return getToc(state);},function(state){return Object(__WEBPACK_IMPORTED_MODULE_2__page_context_selectors__["a" /* getCurrentCfi */])(state);},function(toc,cfi){var docMatch=Object(__WEBPACK_IMPORTED_MODULE_3_app_api_jigsaw_helpers__["c" /* findIndexMatchingDocAndCfiFallBackToBefore */])(toc,function(el){return el.cfi;},cfi);if(docMatch>=0){return docMatch;}return Object(__WEBPACK_IMPORTED_MODULE_3_app_api_jigsaw_helpers__["b" /* findIndexMatchingCfiFallBackToBefore */])(toc,function(el){return el.cfi;},cfi);});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToastContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_ui_core_common_EmptyModalContainer__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_Toast_css__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_Toast_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_Toast_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_ui_config_ThemedFocus__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_ui_style_common_zindex__ = __webpack_require__(112);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ID='Toast__Container';var ToastContainer=function(_React$Component){_inherits(ToastContainer,_React$Component);function ToastContainer(){_classCallCheck(this,ToastContainer);return _possibleConstructorReturn(this,(ToastContainer.__proto__||Object.getPrototypeOf(ToastContainer)).apply(this,arguments));}_createClass(ToastContainer,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_app_ui_core_common_EmptyModalContainer__["a" /* default */],{zIndex:__WEBPACK_IMPORTED_MODULE_5_app_ui_style_common_zindex__["b" /* TOAST */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Toast__Container',id:ID}));}}]);return ToastContainer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Toast=function(_React$Component2){_inherits(Toast,_React$Component2);function Toast(){_classCallCheck(this,Toast);return _possibleConstructorReturn(this,(Toast.__proto__||Object.getPrototypeOf(Toast)).apply(this,arguments));}_createClass(Toast,[{key:'componentDidMount',value:function componentDidMount(){var _this3=this;this.timeoutId=setTimeout(function(){if(_this3.props.onClose){_this3.props.onClose();}},10000);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(!this.props.isOpen&&prevProps.isOpen){clearTimeout(this.timeoutId);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearTimeout(this.timeoutId);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_modal___default.a,{isOpen:this.props.isOpen,ariaHideApp:false,overlayClassName:{base:'Toast',beforeClose:'Toast--Closing',afterOpen:'Toast--Opened'},className:'Toast__Content '+__WEBPACK_IMPORTED_MODULE_4_app_ui_config_ThemedFocus__["g" /* NO_FOCUS */],closeTimeoutMS:950,parentSelector:function parentSelector(){return document.querySelector('#'+ID);},role:'alertdialog'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Toast__Inner '+__WEBPACK_IMPORTED_MODULE_4_app_ui_config_ThemedFocus__["b" /* FOCUS_CHILD */]},this.props.children));}}]);return Toast;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["b"] = (Toast);

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export matchesAnyRoute */
/* harmony export (immutable) */ __webpack_exports__["c"] = isTeacherRoute;
/* harmony export (immutable) */ __webpack_exports__["b"] = isSafeUrl;
/* harmony export (immutable) */ __webpack_exports__["d"] = isUrl;
/* harmony export (immutable) */ __webpack_exports__["a"] = getFullUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_dom__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routes__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config_base_whitelist_json__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config_base_whitelist_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_config_base_whitelist_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_route__ = __webpack_require__(32);
function matchesAnyRoute(path,pathsToCheck){return pathsToCheck.reduce(function(acc,cv){var matches=!!Object(__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["g" /* matchPath */])(path,{path:cv});return matches||acc;},false);}function isTeacherRoute(path){return matchesAnyRoute(path,[__WEBPACK_IMPORTED_MODULE_1__routes__["b" /* ADMIN */],__WEBPACK_IMPORTED_MODULE_1__routes__["Q" /* REDIRECT */]]);}function isSafeUrl(url){var el=document.createElement('a');el.setAttribute('href',url);var safeProtocol=__WEBPACK_IMPORTED_MODULE_2_config_base_whitelist_json___default.a.protocols.indexOf(el.protocol)!==-1;var currentDomain=Object(__WEBPACK_IMPORTED_MODULE_3__utils_route__["b" /* getDomain */])(window.location.hostname);var newDomain=Object(__WEBPACK_IMPORTED_MODULE_3__utils_route__["b" /* getDomain */])(el.hostname);var safeDomain=newDomain===currentDomain||__WEBPACK_IMPORTED_MODULE_2_config_base_whitelist_json___default.a.domains.indexOf(newDomain)!==-1;return safeProtocol&&safeDomain;}function isUrl(url){var el=document.createElement('a');el.setAttribute('href',url);return!!(el.protocol&&el.hostname);}function getFullUrl(url){var el=document.createElement('a');el.setAttribute('href',url);return el.href;}

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_redux_jigsaw_jigsaw_action__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InitPageData=function(_React$Component){_inherits(InitPageData,_React$Component);function InitPageData(){_classCallCheck(this,InitPageData);return _possibleConstructorReturn(this,(InitPageData.__proto__||Object.getPrototypeOf(InitPageData)).apply(this,arguments));}_createClass(InitPageData,[{key:'componentDidMount',value:function componentDidMount(){this.props.init();}},{key:'render',value:function render(){return null;}}]);return InitPageData;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapDispatchToProps=function mapDispatchToProps(dispatch){return{init:function init(){// We need this for cover widths/urls only
dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__api_redux_jigsaw_jigsaw_action__["g" /* getBookList */])({perPage:0}));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null,mapDispatchToProps)(InitPageData));

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAllStudents;
/* harmony export (immutable) */ __webpack_exports__["b"] = getRosterData;
/* harmony export (immutable) */ __webpack_exports__["c"] = isRosterLoading;
/* unused harmony export hasRosterError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bridge_methods__ = __webpack_require__(13);
var emptyArray=[];function getAllStudents(state){return getRosterData(state).learners||emptyArray;}function getRosterData(state){return state.bridge[__WEBPACK_IMPORTED_MODULE_0__bridge_methods__["g" /* GET_ROSTER */]].data;}function isRosterLoading(state){return state.bridge[__WEBPACK_IMPORTED_MODULE_0__bridge_methods__["g" /* GET_ROSTER */]].isFetching;}function hasRosterError(state){return state.bridge[__WEBPACK_IMPORTED_MODULE_0__bridge_methods__["g" /* GET_ROSTER */]].hasError;}

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_common_SimpleTextLink__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_ui_config_SimpleThemer__ = __webpack_require__(60);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ErrorPageLink=function(_React$Component){_inherits(ErrorPageLink,_React$Component);function ErrorPageLink(){_classCallCheck(this,ErrorPageLink);return _possibleConstructorReturn(this,(ErrorPageLink.__proto__||Object.getPrototypeOf(ErrorPageLink)).apply(this,arguments));}_createClass(ErrorPageLink,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_ui_config_SimpleThemer__["a" /* default */],{mergeClasses:'ErrorPageLink',color:'common.ErrorPageLink',render:function render(c){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__core_common_SimpleTextLink__["a" /* default */],Object.assign({},_this2.props,{className:c}));}});}}]);return ErrorPageLink;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ErrorPageLink);

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_ui_core_common_GradientBackground__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_ui_config_BrandedLogo__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_SimpleHeaderFrame_css__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_SimpleHeaderFrame_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_SimpleHeaderFrame_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_common_withMediaQuery__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_common_breakpoints__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_redux_route_routes__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(20);
function SimpleHeaderFrame(_ref){var children=_ref.children,mediaQueryMatches=_ref.mediaQueryMatches,defaultHeight=_ref.defaultHeight,tabletHeight=_ref.tabletHeight,defaultLeft=_ref.defaultLeft,tabletLeft=_ref.tabletLeft,disableLogoLink=_ref.disableLogoLink;var logo=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_ui_config_BrandedLogo__["a" /* default */],{logoKey:'common.logo',height:41,tabletHeight:31});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'SimpleHeaderFrame'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'SimpleHeaderFrame__BannerArea',style:{height:mediaQueryMatches?tabletHeight:defaultHeight}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_app_ui_core_common_GradientBackground__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'SimpleHeaderFrame__Logo',style:{paddingLeft:mediaQueryMatches?tabletLeft:defaultLeft}},disableLogoLink?logo:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */],{to:__WEBPACK_IMPORTED_MODULE_6__api_redux_route_routes__["A" /* DEFAULT */]},logo)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'SimpleHeaderFrame__Content'},children));}SimpleHeaderFrame.defaultProps={defaultHeight:80,tabletHeight:60,defaultLeft:30,tabletLeft:24};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__core_common_withMediaQuery__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__style_common_breakpoints__["a" /* TABLET */])(SimpleHeaderFrame));

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(368);
module.exports = __webpack_require__(373);


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(369).enable();
  window.Promise = __webpack_require__(371);
}

// fetch() polyfill for making API calls.
__webpack_require__(372);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(54);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(117);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(117);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 372 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_ui_main_App__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_api_analytics_reporting__ = __webpack_require__(14);
try{Object(__WEBPACK_IMPORTED_MODULE_4_app_api_analytics_reporting__["a" /* init */])();__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__app_ui_main_App__["a" /* default */],null),document.getElementById('root'));}catch(e){Object(__WEBPACK_IMPORTED_MODULE_4_app_api_analytics_reporting__["b" /* noticeError */])(e);document.getElementById('root').innerHTML='Oops! Something went wrong. Please try again later!';document.getElementById('staticloader').remove();}

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.2
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(54),n=__webpack_require__(118),p=__webpack_require__(119),q=__webpack_require__(72),r="function"===typeof Symbol&&Symbol.for,t=r?Symbol.for("react.element"):60103,u=r?Symbol.for("react.portal"):60106,v=r?Symbol.for("react.fragment"):60107,w=r?Symbol.for("react.strict_mode"):60108,x=r?Symbol.for("react.profiler"):60114,y=r?Symbol.for("react.provider"):60109,z=r?Symbol.for("react.context"):60110,A=r?Symbol.for("react.async_mode"):60111,B=
r?Symbol.for("react.forward_ref"):60112;r&&Symbol.for("react.timeout");var C="function"===typeof Symbol&&Symbol.iterator;function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}
var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function F(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function G(){}
G.prototype=F.prototype;function H(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}var I=H.prototype=new G;I.constructor=H;k(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:J.current}}
function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,e,c){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+T(d,h);g+=S(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+T(d,h++),g+=S(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function U(a,b){a.func.call(a.context,b,a.count++)}
function V(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,q.thatReturnsArgument):null!=a&&(N(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(O,"$&/")+"/");b=Q(b,g,c,d);null==a||S(a,"",V,b);R(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=Q(null,null,b,e);null==a||S(a,"",U,b);R(b)},count:function(a){return null==a?0:S(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];W(a,b,null,q.thatReturnsArgument);return b},only:function(a){N(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:F,PureComponent:H,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:z,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_currentValue2:a,_changedBits:0,_changedBits2:0,Provider:null,Consumer:null};a.Provider={$$typeof:y,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:B,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:A,unstable_Profiler:x,createElement:M,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==
b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.4.2",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:J,
assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default?Z.default:Z;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.2
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(118),ba=__webpack_require__(0),m=__webpack_require__(376),p=__webpack_require__(54),v=__webpack_require__(72),da=__webpack_require__(377),ea=__webpack_require__(378),fa=__webpack_require__(379),ha=__webpack_require__(119);
function A(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ba?void 0:A("227");
function ia(a,b,c,d,e,f,g,h,k){this._hasCaughtError=!1;this._caughtError=null;var n=Array.prototype.slice.call(arguments,3);try{b.apply(c,n)}catch(r){this._caughtError=r,this._hasCaughtError=!0}}
var B={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){ia.apply(B,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){B.invokeGuardedCallback.apply(this,arguments);if(B.hasCaughtError()){var n=B.clearCaughtError();B._hasRethrowError||(B._hasRethrowError=!0,B._rethrowError=n)}},rethrowCaughtError:function(){return ka.apply(B,arguments)},hasCaughtError:function(){return B._hasCaughtError},clearCaughtError:function(){if(B._hasCaughtError){var a=
B._caughtError;B._caughtError=null;B._hasCaughtError=!1;return a}A("198")}};function ka(){if(B._hasRethrowError){var a=B._rethrowError;B._rethrowError=null;B._hasRethrowError=!1;throw a;}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:A("96",a);if(!oa[c]){b.extractEvents?void 0:A("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?A("99",h):void 0;pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&qa(k[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:A("98",d,a)}}}}
function qa(a,b,c){ra[a]?A("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={};function ta(a){la?A("101"):void 0;la=Array.prototype.slice.call(a);na()}function ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?A("102",c):void 0,ma[c]=d,b=!0)}b&&na()}
var va={plugins:oa,eventNameDispatchConfigs:pa,registrationNameModules:ra,registrationNameDependencies:sa,possibleRegistrationNames:null,injectEventPluginOrder:ta,injectEventPluginsByName:ua},wa=null,xa=null,ya=null;function za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=ya(d);B.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Aa(a,b){null==b?A("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ba(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ca=null;
function Da(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)za(a,b,c[e],d[e]);else c&&za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ea(a){return Da(a,!0)}function Fa(a){return Da(a,!1)}var Ga={injectEventPluginOrder:ta,injectEventPluginsByName:ua};
function Ha(a,b){var c=a.stateNode;if(!c)return null;var d=wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?A("231",b,typeof c):void 0;
return c}function Ia(a,b){null!==a&&(Ca=Aa(Ca,a));a=Ca;Ca=null;a&&(b?Ba(a,Ea):Ba(a,Fa),Ca?A("95"):void 0,B.rethrowCaughtError())}function Ja(a,b,c,d){for(var e=null,f=0;f<oa.length;f++){var g=oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=Aa(e,g))}Ia(e,!1)}var Ka={injection:Ga,getListener:Ha,runEventsInBatch:Ia,runExtractedEventsInBatch:Ja},La=Math.random().toString(36).slice(2),C="__reactInternalInstance$"+La,Ma="__reactEventHandlers$"+La;
function Na(a){if(a[C])return a[C];for(;!a[C];)if(a.parentNode)a=a.parentNode;else return null;a=a[C];return 5===a.tag||6===a.tag?a:null}function Oa(a){if(5===a.tag||6===a.tag)return a.stateNode;A("33")}function Pa(a){return a[Ma]||null}var Qa={precacheFiberNode:function(a,b){b[C]=a},getClosestInstanceFromNode:Na,getInstanceFromNode:function(a){a=a[C];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Oa,getFiberCurrentPropsFromNode:Pa,updateFiberProps:function(a,b){a[Ma]=b}};
function F(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ra(a,b,c){for(var d=[];a;)d.push(a),a=F(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function Sa(a,b,c){if(b=Ha(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a)}function Ta(a){a&&a.dispatchConfig.phasedRegistrationNames&&Ra(a._targetInst,Sa,a)}
function Ua(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?F(b):null;Ra(b,Sa,a)}}function Va(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ha(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a))}function Xa(a){a&&a.dispatchConfig.registrationName&&Va(a._targetInst,null,a)}function Ya(a){Ba(a,Ta)}
function Za(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=F(h))g++;h=0;for(var k=f;k;k=F(k))h++;for(;0<g-h;)e=F(e),g--;for(;0<h-g;)f=F(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=F(e);f=F(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=F(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=F(d)}for(d=0;d<e.length;d++)Va(e[d],"bubbled",a);for(a=c.length;0<a--;)Va(c[a],"captured",b)}
var $a={accumulateTwoPhaseDispatches:Ya,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ba(a,Ua)},accumulateEnterLeaveDispatches:Za,accumulateDirectDispatches:function(a){Ba(a,Xa)}};function ab(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var bb={animationend:ab("Animation","AnimationEnd"),animationiteration:ab("Animation","AnimationIteration"),animationstart:ab("Animation","AnimationStart"),transitionend:ab("Transition","TransitionEnd")},cb={},db={};m.canUseDOM&&(db=document.createElement("div").style,"AnimationEvent"in window||(delete bb.animationend.animation,delete bb.animationiteration.animation,delete bb.animationstart.animation),"TransitionEvent"in window||delete bb.transitionend.transition);
function eb(a){if(cb[a])return cb[a];if(!bb[a])return a;var b=bb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in db)return cb[a]=b[c];return a}var fb=eb("animationend"),gb=eb("animationiteration"),hb=eb("animationstart"),ib=eb("transitionend"),jb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),kb=null;
function lb(){!kb&&m.canUseDOM&&(kb="textContent"in document.documentElement?"textContent":"innerText");return kb}var G={_root:null,_startText:null,_fallbackText:null};function mb(){if(G._fallbackText)return G._fallbackText;var a,b=G._startText,c=b.length,d,e=nb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);G._fallbackText=e.slice(a,1<d?1-d:void 0);return G._fallbackText}function nb(){return"value"in G._root?G._root.value:G._root[lb()]}
var ob="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),pb={type:null,target:null,currentTarget:v.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function H(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?v.thatReturnsTrue:v.thatReturnsFalse;this.isPropagationStopped=v.thatReturnsFalse;return this}
p(H.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=v.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=v.thatReturnsTrue)},persist:function(){this.isPersistent=v.thatReturnsTrue},isPersistent:v.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<ob.length;a++)this[ob[a]]=null}});H.Interface=pb;H.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;p(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=p({},d.Interface,a);c.extend=d.extend;qb(c);return c};qb(H);
function rb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function sb(a){a instanceof this?void 0:A("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function qb(a){a.eventPool=[];a.getPooled=rb;a.release=sb}var tb=H.extend({data:null}),ub=H.extend({data:null}),vb=[9,13,27,32],wb=m.canUseDOM&&"CompositionEvent"in window,xb=null;m.canUseDOM&&"documentMode"in document&&(xb=document.documentMode);
var yb=m.canUseDOM&&"TextEvent"in window&&!xb,zb=m.canUseDOM&&(!wb||xb&&8<xb&&11>=xb),Ab=String.fromCharCode(32),Bb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Cb=!1;
function Db(a,b){switch(a){case "keyup":return-1!==vb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Eb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Fb=!1;function Gb(a,b){switch(a){case "compositionend":return Eb(b);case "keypress":if(32!==b.which)return null;Cb=!0;return Ab;case "textInput":return a=b.data,a===Ab&&Cb?null:a;default:return null}}
function Hb(a,b){if(Fb)return"compositionend"===a||!wb&&Db(a,b)?(a=mb(),G._root=null,G._startText=null,G._fallbackText=null,Fb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return zb?null:b.data;default:return null}}
var Ib={eventTypes:Bb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(wb)b:{switch(a){case "compositionstart":e=Bb.compositionStart;break b;case "compositionend":e=Bb.compositionEnd;break b;case "compositionupdate":e=Bb.compositionUpdate;break b}e=void 0}else Fb?Db(a,c)&&(e=Bb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=Bb.compositionStart);e?(zb&&(Fb||e!==Bb.compositionStart?e===Bb.compositionEnd&&Fb&&(f=mb()):(G._root=d,G._startText=nb(),Fb=!0)),e=tb.getPooled(e,b,c,d),f?e.data=
f:(f=Eb(c),null!==f&&(e.data=f)),Ya(e),f=e):f=null;(a=yb?Gb(a,c):Hb(a,c))?(b=ub.getPooled(Bb.beforeInput,b,c,d),b.data=a,Ya(b)):b=null;return null===f?b:null===b?f:[f,b]}},Jb=null,Kb={injectFiberControlledHostComponent:function(a){Jb=a}},Lb=null,Mb=null;function Nb(a){if(a=xa(a)){Jb&&"function"===typeof Jb.restoreControlledState?void 0:A("194");var b=wa(a.stateNode);Jb.restoreControlledState(a.stateNode,a.type,b)}}function Ob(a){Lb?Mb?Mb.push(a):Mb=[a]:Lb=a}
function Pb(){return null!==Lb||null!==Mb}function Qb(){if(Lb){var a=Lb,b=Mb;Mb=Lb=null;Nb(a);if(b)for(a=0;a<b.length;a++)Nb(b[a])}}var Rb={injection:Kb,enqueueStateRestore:Ob,needsStateRestore:Pb,restoreStateIfNeeded:Qb};function Sb(a,b){return a(b)}function Tb(a,b,c){return a(b,c)}function Ub(){}var Vb=!1;function Wb(a,b){if(Vb)return a(b);Vb=!0;try{return Sb(a,b)}finally{Vb=!1,Pb()&&(Ub(),Qb())}}
var Xb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Yb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Xb[a.type]:"textarea"===b?!0:!1}function Zb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function $b(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function ac(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function bc(a){var b=ac(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function cc(a){a._valueTracker||(a._valueTracker=bc(a))}function dc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=ac(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var ec=ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,fc="function"===typeof Symbol&&Symbol.for,gc=fc?Symbol.for("react.element"):60103,hc=fc?Symbol.for("react.portal"):60106,ic=fc?Symbol.for("react.fragment"):60107,jc=fc?Symbol.for("react.strict_mode"):60108,kc=fc?Symbol.for("react.profiler"):60114,lc=fc?Symbol.for("react.provider"):60109,mc=fc?Symbol.for("react.context"):60110,pc=fc?Symbol.for("react.async_mode"):60111,qc=fc?Symbol.for("react.forward_ref"):60112,rc=fc?Symbol.for("react.timeout"):
60113,sc="function"===typeof Symbol&&Symbol.iterator;function tc(a){if(null===a||"undefined"===typeof a)return null;a=sc&&a[sc]||a["@@iterator"];return"function"===typeof a?a:null}
function uc(a){var b=a.type;if("function"===typeof b)return b.displayName||b.name;if("string"===typeof b)return b;switch(b){case pc:return"AsyncMode";case mc:return"Context.Consumer";case ic:return"ReactFragment";case hc:return"ReactPortal";case kc:return"Profiler("+a.pendingProps.id+")";case lc:return"Context.Provider";case jc:return"StrictMode";case rc:return"Timeout"}if("object"===typeof b&&null!==b)switch(b.$$typeof){case qc:return a=b.render.displayName||b.render.name||"",""!==a?"ForwardRef("+
a+")":"ForwardRef"}return null}function vc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=uc(a);var f=null;c&&(f=uc(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a.return}while(a);return b}
var wc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,xc=Object.prototype.hasOwnProperty,zc={},Ac={};
function Bc(a){if(xc.call(Ac,a))return!0;if(xc.call(zc,a))return!1;if(wc.test(a))return Ac[a]=!0;zc[a]=!0;return!1}function Cc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Dc(a,b,c,d){if(null===b||"undefined"===typeof b||Cc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function I(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var J={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){J[a]=new I(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];J[b]=new I(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){J[a]=new I(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){J[a]=new I(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){J[a]=new I(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){J[a]=new I(a,3,!0,a.toLowerCase(),null)});
["capture","download"].forEach(function(a){J[a]=new I(a,4,!1,a.toLowerCase(),null)});["cols","rows","size","span"].forEach(function(a){J[a]=new I(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){J[a]=new I(a,5,!1,a.toLowerCase(),null)});var Ec=/[\-:]([a-z])/g;function Fc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ec,
Fc);J[b]=new I(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ec,Fc);J[b]=new I(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ec,Fc);J[b]=new I(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});J.tabIndex=new I("tabIndex",1,!1,"tabindex",null);
function Gc(a,b,c,d){var e=J.hasOwnProperty(b)?J[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Dc(b,c,e,d)&&(c=null),d||null===e?Bc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Hc(a,b){var c=b.checked;return p({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Ic(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Jc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Kc(a,b){b=b.checked;null!=b&&Gc(a,"checked",b,!1)}
function Lc(a,b){Kc(a,b);var c=Jc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?Mc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Mc(a,b.type,Jc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Nc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){b=""+a._wrapperState.initialValue;var d=a.value;c||b===d||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==c&&(a.name=c)}function Mc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Jc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var Oc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Pc(a,b,c){a=H.getPooled(Oc.change,a,b,c);a.type="change";Ob(c);Ya(a);return a}var Qc=null,Rc=null;function Sc(a){Ia(a,!1)}function Tc(a){var b=Oa(a);if(dc(b))return a}
function Uc(a,b){if("change"===a)return b}var Vc=!1;m.canUseDOM&&(Vc=$b("input")&&(!document.documentMode||9<document.documentMode));function Wc(){Qc&&(Qc.detachEvent("onpropertychange",Xc),Rc=Qc=null)}function Xc(a){"value"===a.propertyName&&Tc(Rc)&&(a=Pc(Rc,a,Zb(a)),Wb(Sc,a))}function Yc(a,b,c){"focus"===a?(Wc(),Qc=b,Rc=c,Qc.attachEvent("onpropertychange",Xc)):"blur"===a&&Wc()}function Zc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Tc(Rc)}
function $c(a,b){if("click"===a)return Tc(b)}function ad(a,b){if("input"===a||"change"===a)return Tc(b)}
var bd={eventTypes:Oc,_isInputEventSupported:Vc,extractEvents:function(a,b,c,d){var e=b?Oa(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Uc:Yb(e)?Vc?f=ad:(f=Zc,g=Yc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=$c);if(f&&(f=f(a,b)))return Pc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Mc(e,"number",e.value)}},cd=H.extend({view:null,detail:null}),dd={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function ed(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=dd[a])?!!b[a]:!1}function fd(){return ed}
var gd=cd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:fd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),hd=gd.extend({pointerId:null,width:null,height:null,pressure:null,tiltX:null,tiltY:null,pointerType:null,isPrimary:null}),id={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},
mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},jd={eventTypes:id,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||
e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Na(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,n=void 0;if("mouseout"===a||"mouseover"===a)g=gd,h=id.mouseLeave,k=id.mouseEnter,n="mouse";else if("pointerout"===a||"pointerover"===a)g=hd,h=id.pointerLeave,k=id.pointerEnter,n="pointer";a=null==f?e:Oa(f);e=null==b?e:Oa(b);h=g.getPooled(h,f,c,d);h.type=n+"leave";h.target=a;h.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=n+"enter";c.target=e;c.relatedTarget=a;Za(h,
c,f,b);return[h,c]}};function kd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){2!==kd(a)?A("188"):void 0}
function md(a){var b=a.alternate;if(!b)return b=kd(a),3===b?A("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return ld(e),a;if(g===d)return ld(e),b;g=g.sibling}A("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:A("189")}}c.alternate!==d?A("190"):void 0}3!==c.tag?A("188"):void 0;return c.stateNode.current===c?a:b}function nd(a){a=md(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function od(a){a=md(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}var pd=H.extend({animationName:null,elapsedTime:null,pseudoElement:null}),qd=H.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),rd=cd.extend({relatedTarget:null});
function sd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var td={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},ud={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},vd=cd.extend({key:function(a){if(a.key){var b=td[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=sd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?ud[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:fd,charCode:function(a){return"keypress"===
a.type?sd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?sd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),wd=gd.extend({dataTransfer:null}),xd=cd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:fd}),yd=H.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),zd=gd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Ad=[["abort","abort"],[fb,"animationEnd"],[gb,"animationIteration"],[hb,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ib,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],Bd={},Cd={};function Dd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Bd[a]=b;Cd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],["pointerdown","pointerDown"],
["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Dd(a,!0)});Ad.forEach(function(a){Dd(a,!1)});
var Ed={eventTypes:Bd,isInteractiveTopLevelEventType:function(a){a=Cd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Cd[a];if(!e)return null;switch(a){case "keypress":if(0===sd(c))return null;case "keydown":case "keyup":a=vd;break;case "blur":case "focus":a=rd;break;case "click":if(2===c.button)return null;case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=gd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
wd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=xd;break;case fb:case gb:case hb:a=pd;break;case ib:a=yd;break;case "scroll":a=cd;break;case "wheel":a=zd;break;case "copy":case "cut":case "paste":a=qd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=hd;break;default:a=H}b=a.getPooled(e,b,c,d);Ya(b);return b}},Fd=Ed.isInteractiveTopLevelEventType,
Gd=[];function Hd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c.return;)c=c.return;c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Na(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Ja(a.topLevelType,b,a.nativeEvent,Zb(a.nativeEvent))}var Id=!0;function Kd(a){Id=!!a}function K(a,b){if(!b)return null;var c=(Fd(a)?Ld:Md).bind(null,a);b.addEventListener(a,c,!1)}
function Nd(a,b){if(!b)return null;var c=(Fd(a)?Ld:Md).bind(null,a);b.addEventListener(a,c,!0)}function Ld(a,b){Tb(Md,a,b)}function Md(a,b){if(Id){var c=Zb(b);c=Na(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(Gd.length){var d=Gd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Wb(Hd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Gd.length&&Gd.push(a)}}}
var Od={get _enabled(){return Id},setEnabled:Kd,isEnabled:function(){return Id},trapBubbledEvent:K,trapCapturedEvent:Nd,dispatchEvent:Md},Pd={},Qd=0,Rd="_reactListenersID"+(""+Math.random()).slice(2);function Sd(a){Object.prototype.hasOwnProperty.call(a,Rd)||(a[Rd]=Qd++,Pd[a[Rd]]={});return Pd[a[Rd]]}function Td(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Ud(a,b){var c=Td(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Td(c)}}function Vd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Wd=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Xd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Yd=null,Zd=null,$d=null,ae=!1;
function be(a,b){if(ae||null==Yd||Yd!==da())return null;var c=Yd;"selectionStart"in c&&Vd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return $d&&ea($d,c)?null:($d=c,a=H.getPooled(Xd.select,Zd,a,b),a.type="select",a.target=Yd,Ya(a),a)}
var ce={eventTypes:Xd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Sd(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Oa(b):window;switch(a){case "focus":if(Yb(e)||"true"===e.contentEditable)Yd=e,Zd=b,$d=null;break;case "blur":$d=Zd=Yd=null;break;case "mousedown":ae=!0;break;case "contextmenu":case "mouseup":return ae=!1,be(c,d);case "selectionchange":if(Wd)break;
case "keydown":case "keyup":return be(c,d)}return null}};Ga.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));wa=Qa.getFiberCurrentPropsFromNode;xa=Qa.getInstanceFromNode;ya=Qa.getNodeFromInstance;Ga.injectEventPluginsByName({SimpleEventPlugin:Ed,EnterLeaveEventPlugin:jd,ChangeEventPlugin:bd,SelectEventPlugin:ce,BeforeInputEventPlugin:Ib});
var de="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,ee=Date,fe=setTimeout,ge=clearTimeout,he=void 0;if("object"===typeof performance&&"function"===typeof performance.now){var ie=performance;he=function(){return ie.now()}}else he=function(){return ee.now()};var je=void 0,ke=void 0;
if(m.canUseDOM){var le="function"===typeof de?de:function(){A("276")},L=null,me=null,ne=-1,oe=!1,pe=!1,qe=0,re=33,se=33,te={didTimeout:!1,timeRemaining:function(){var a=qe-he();return 0<a?a:0}},ve=function(a,b){var c=a.scheduledCallback,d=!1;try{c(b),d=!0}finally{ke(a),d||(oe=!0,window.postMessage(ue,"*"))}},ue="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===ue&&(oe=!1,null!==L)){if(null!==L){var b=he();if(!(-1===
ne||ne>b)){a=-1;for(var c=[],d=L;null!==d;){var e=d.timeoutTime;-1!==e&&e<=b?c.push(d):-1!==e&&(-1===a||e<a)&&(a=e);d=d.next}if(0<c.length)for(te.didTimeout=!0,b=0,d=c.length;b<d;b++)ve(c[b],te);ne=a}}for(a=he();0<qe-a&&null!==L;)a=L,te.didTimeout=!1,ve(a,te),a=he();null===L||pe||(pe=!0,le(we))}},!1);var we=function(a){pe=!1;var b=a-qe+se;b<se&&re<se?(8>b&&(b=8),se=b<re?re:b):re=b;qe=a+se;oe||(oe=!0,window.postMessage(ue,"*"))};je=function(a,b){var c=-1;null!=b&&"number"===typeof b.timeout&&(c=he()+
b.timeout);if(-1===ne||-1!==c&&c<ne)ne=c;a={scheduledCallback:a,timeoutTime:c,prev:null,next:null};null===L?L=a:(b=a.prev=me,null!==b&&(b.next=a));me=a;pe||(pe=!0,le(we));return a};ke=function(a){if(null!==a.prev||L===a){var b=a.next,c=a.prev;a.next=null;a.prev=null;null!==b?null!==c?(c.next=b,b.prev=c):(b.prev=null,L=b):null!==c?(c.next=null,me=c):me=L=null}}}else{var xe=new Map;je=function(a){var b={scheduledCallback:a,timeoutTime:0,next:null,prev:null},c=fe(function(){a({timeRemaining:function(){return Infinity},
didTimeout:!1})});xe.set(a,c);return b};ke=function(a){var b=xe.get(a.scheduledCallback);xe.delete(a);ge(b)}}function ye(a){var b="";ba.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function ze(a,b){a=p({children:void 0},b);if(b=ye(b.children))a.children=b;return a}
function Ae(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Be(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Ce(a,b){null!=b.dangerouslySetInnerHTML?A("91"):void 0;return p({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function De(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?A("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:A("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Ee(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Fe(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Ge={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function He(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ie(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?He(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Je=void 0,Ke=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Ge.svg||"innerHTML"in a)a.innerHTML=b;else{Je=Je||document.createElement("div");Je.innerHTML="<svg>"+b+"</svg>";for(b=Je.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Le(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Me={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ne=["Webkit","ms","Moz","O"];Object.keys(Me).forEach(function(a){Ne.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Me[b]=Me[a]})});
function Oe(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Me.hasOwnProperty(e)&&Me[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Pe=p({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Qe(a,b,c){b&&(Pe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?A("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?A("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:A("61")),null!=b.style&&"object"!==typeof b.style?A("62",c()):void 0)}
function Re(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Se=v.thatReturns("");
function Te(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Sd(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Nd("scroll",a);break;case "focus":case "blur":Nd("focus",a);Nd("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":$b(e,!0)&&Nd(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===jb.indexOf(e)&&K(e,a)}c[e]=!0}}}
function Ue(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Ge.html&&(d=He(a));d===Ge.html?"script"===a?(a=c.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function Ve(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function We(a,b,c,d){var e=Re(b,c);switch(b){case "iframe":case "object":K("load",a);var f=c;break;case "video":case "audio":for(f=0;f<jb.length;f++)K(jb[f],a);f=c;break;case "source":K("error",a);f=c;break;case "img":case "image":case "link":K("error",a);K("load",a);f=c;break;case "form":K("reset",a);K("submit",a);f=c;break;case "details":K("toggle",a);f=c;break;case "input":Ic(a,c);f=Hc(a,c);K("invalid",a);Te(d,"onChange");break;case "option":f=ze(a,c);break;case "select":Be(a,c);f=p({},c,{value:void 0});
K("invalid",a);Te(d,"onChange");break;case "textarea":De(a,c);f=Ce(a,c);K("invalid",a);Te(d,"onChange");break;default:f=c}Qe(b,f,Se);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?Oe(a,k,Se):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Ke(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&Le(a,k):"number"===typeof k&&Le(a,""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ra.hasOwnProperty(h)?null!=k&&Te(d,
h):null!=k&&Gc(a,h,k,e))}switch(b){case "input":cc(a);Nc(a,c,!1);break;case "textarea":cc(a);Fe(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Ae(a,!!c.multiple,b,!1):null!=c.defaultValue&&Ae(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=v)}}
function Xe(a,b,c,d,e){var f=null;switch(b){case "input":c=Hc(a,c);d=Hc(a,d);f=[];break;case "option":c=ze(a,c);d=ze(a,d);f=[];break;case "select":c=p({},c,{value:void 0});d=p({},d,{value:void 0});f=[];break;case "textarea":c=Ce(a,c);d=Ce(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=v)}Qe(b,d,Se);b=a=void 0;var g=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var h=c[a];for(b in h)h.hasOwnProperty(b)&&(g||
(g={}),g[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ra.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];h=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==h&&(null!=k||null!=h))if("style"===a)if(h){for(b in h)!h.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(g||(g={}),g[b]="");for(b in k)k.hasOwnProperty(b)&&h[b]!==k[b]&&(g||(g={}),g[b]=k[b])}else g||(f||(f=[]),f.push(a,g)),
g=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(a,""+k)):"children"===a?h===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ra.hasOwnProperty(a)?(null!=k&&Te(e,a),f||h===k||(f=[])):(f=f||[]).push(a,k))}g&&(f=f||[]).push("style",g);return f}
function Ye(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Kc(a,e);Re(c,d);d=Re(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?Oe(a,h,Se):"dangerouslySetInnerHTML"===g?Ke(a,h):"children"===g?Le(a,h):Gc(a,g,h,d)}switch(c){case "input":Lc(a,e);break;case "textarea":Ee(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Ae(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
Ae(a,!!e.multiple,e.defaultValue,!0):Ae(a,!!e.multiple,e.multiple?[]:"",!1))}}
function Ze(a,b,c,d,e){switch(b){case "iframe":case "object":K("load",a);break;case "video":case "audio":for(d=0;d<jb.length;d++)K(jb[d],a);break;case "source":K("error",a);break;case "img":case "image":case "link":K("error",a);K("load",a);break;case "form":K("reset",a);K("submit",a);break;case "details":K("toggle",a);break;case "input":Ic(a,c);K("invalid",a);Te(e,"onChange");break;case "select":Be(a,c);K("invalid",a);Te(e,"onChange");break;case "textarea":De(a,c),K("invalid",a),Te(e,"onChange")}Qe(b,
c,Se);d=null;for(var f in c)if(c.hasOwnProperty(f)){var g=c[f];"children"===f?"string"===typeof g?a.textContent!==g&&(d=["children",g]):"number"===typeof g&&a.textContent!==""+g&&(d=["children",""+g]):ra.hasOwnProperty(f)&&null!=g&&Te(e,f)}switch(b){case "input":cc(a);Nc(a,c,!0);break;case "textarea":cc(a);Fe(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=v)}return d}function $e(a,b){return a.nodeValue!==b}
var af={createElement:Ue,createTextNode:Ve,setInitialProperties:We,diffProperties:Xe,updateProperties:Ye,diffHydratedProperties:Ze,diffHydratedText:$e,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Lc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;
c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Pa(d);e?void 0:A("90");dc(d);Lc(d,e)}}}break;case "textarea":Ee(a,c);break;case "select":b=c.value,null!=b&&Ae(a,!!c.multiple,b,!1)}}},bf=null,cf=null;function df(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function ef(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html}var ff=he,gf=je,hf=ke;function jf(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function kf(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var lf=[],mf=-1;function nf(a){return{current:a}}
function M(a){0>mf||(a.current=lf[mf],lf[mf]=null,mf--)}function N(a,b){mf++;lf[mf]=a.current;a.current=b}var of=nf(ha),O=nf(!1),pf=ha;function qf(a){return rf(a)?pf:of.current}
function sf(a,b){var c=a.type.contextTypes;if(!c)return ha;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function rf(a){return 2===a.tag&&null!=a.type.childContextTypes}function tf(a){rf(a)&&(M(O,a),M(of,a))}function uf(a){M(O,a);M(of,a)}
function vf(a,b,c){of.current!==ha?A("168"):void 0;N(of,b,a);N(O,c,a)}function wf(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:A("108",uc(a)||"Unknown",e);return p({},b,c)}function xf(a){if(!rf(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ha;pf=of.current;N(of,b,a);N(O,O.current,a);return!0}
function yf(a,b){var c=a.stateNode;c?void 0:A("169");if(b){var d=wf(a,pf);c.__reactInternalMemoizedMergedChildContext=d;M(O,a);M(of,a);N(of,d,a)}else M(O,a);N(O,b,a)}
function zf(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function Af(a,b,c){var d=a.alternate;null===d?(d=new zf(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function Bf(a,b,c){var d=a.type,e=a.key;a=a.props;if("function"===typeof d)var f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case ic:return Cf(a.children,b,c,e);case pc:f=11;b|=3;break;case jc:f=11;b|=2;break;case kc:return d=new zf(15,a,e,b|4),d.type=kc,d.expirationTime=c,d;case rc:f=16;b|=2;break;default:a:{switch("object"===typeof d&&null!==d?d.$$typeof:null){case lc:f=13;break a;case mc:f=12;break a;case qc:f=14;break a;default:A("130",null==d?
d:typeof d,"")}f=void 0}}b=new zf(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Cf(a,b,c,d){a=new zf(10,a,d,b);a.expirationTime=c;return a}function Df(a,b,c){a=new zf(6,a,null,b);a.expirationTime=c;return a}function Ef(a,b,c){b=new zf(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function Ff(a,b,c){b=new zf(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a}var Gf=null,Hf=null;function If(a){return function(b){try{return a(b)}catch(c){}}}
function Jf(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Gf=If(function(a){return b.onCommitFiberRoot(c,a)});Hf=If(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Kf(a){"function"===typeof Gf&&Gf(a)}function Lf(a){"function"===typeof Hf&&Hf(a)}var Mf=!1;
function Nf(a){return{expirationTime:0,baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Of(a){return{expirationTime:a.expirationTime,baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Pf(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Qf(a,b,c){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b);if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c}
function Rf(a,b,c){var d=a.alternate;if(null===d){var e=a.updateQueue;var f=null;null===e&&(e=a.updateQueue=Nf(a.memoizedState))}else e=a.updateQueue,f=d.updateQueue,null===e?null===f?(e=a.updateQueue=Nf(a.memoizedState),f=d.updateQueue=Nf(d.memoizedState)):e=a.updateQueue=Of(f):null===f&&(f=d.updateQueue=Of(e));null===f||e===f?Qf(e,b,c):null===e.lastUpdate||null===f.lastUpdate?(Qf(e,b,c),Qf(f,b,c)):(Qf(e,b,c),f.lastUpdate=b)}
function Sf(a,b,c){var d=a.updateQueue;d=null===d?a.updateQueue=Nf(a.memoizedState):Tf(a,d);null===d.lastCapturedUpdate?d.firstCapturedUpdate=d.lastCapturedUpdate=b:(d.lastCapturedUpdate.next=b,d.lastCapturedUpdate=b);if(0===d.expirationTime||d.expirationTime>c)d.expirationTime=c}function Tf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Of(b));return b}
function Uf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return p({},d,e);case 2:Mf=!0}return d}
function Vf(a,b,c,d,e){Mf=!1;if(!(0===b.expirationTime||b.expirationTime>e)){b=Tf(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,n=f;null!==k;){var r=k.expirationTime;if(r>e){if(null===g&&(g=k,f=n),0===h||h>r)h=r}else n=Uf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k));k=k.next}r=null;for(k=b.firstCapturedUpdate;null!==k;){var w=k.expirationTime;if(w>e){if(null===r&&(r=k,null===
g&&(f=n)),0===h||h>w)h=w}else n=Uf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k));k=k.next}null===g&&(b.lastUpdate=null);null===r?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===r&&(f=n);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=r;b.expirationTime=h;a.memoizedState=n}}
function Wf(a,b){"function"!==typeof a?A("191",a):void 0;a.call(b)}
function Xf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);a=b.firstEffect;for(b.firstEffect=b.lastEffect=null;null!==a;){var d=a.callback;null!==d&&(a.callback=null,Wf(d,c));a=a.nextEffect}a=b.firstCapturedEffect;for(b.firstCapturedEffect=b.lastCapturedEffect=null;null!==a;)b=a.callback,null!==b&&(a.callback=null,Wf(b,c)),a=a.nextEffect}
function Yf(a,b){return{value:a,source:b,stack:vc(b)}}var Zf=nf(null),$f=nf(null),ag=nf(0);function bg(a){var b=a.type._context;N(ag,b._changedBits,a);N($f,b._currentValue,a);N(Zf,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode}function cg(a){var b=ag.current,c=$f.current;M(Zf,a);M($f,a);M(ag,a);a=a.type._context;a._currentValue=c;a._changedBits=b}var dg={},eg=nf(dg),fg=nf(dg),gg=nf(dg);function hg(a){a===dg?A("174"):void 0;return a}
function jg(a,b){N(gg,b,a);N(fg,a,a);N(eg,dg,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ie(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Ie(b,c)}M(eg,a);N(eg,b,a)}function kg(a){M(eg,a);M(fg,a);M(gg,a)}function lg(a){fg.current===a&&(M(eg,a),M(fg,a))}function mg(a,b,c){var d=a.memoizedState;b=b(c,d);d=null===b||void 0===b?d:p({},d,b);a.memoizedState=d;a=a.updateQueue;null!==a&&0===a.expirationTime&&(a.baseState=d)}
var qg={isMounted:function(a){return(a=a._reactInternalFiber)?2===kd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=ng();d=og(d,a);var e=Pf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Rf(a,e,d);pg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=ng();d=og(d,a);var e=Pf(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Rf(a,e,d);pg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=ng();c=og(c,a);var d=Pf(c);d.tag=2;void 0!==
b&&null!==b&&(d.callback=b);Rf(a,d,c);pg(a,c)}};function rg(a,b,c,d,e,f){var g=a.stateNode;a=a.type;return"function"===typeof g.shouldComponentUpdate?g.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ea(b,c)||!ea(d,e):!0}
function sg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&qg.enqueueReplaceState(b,b.state,null)}
function tg(a,b){var c=a.type,d=a.stateNode,e=a.pendingProps,f=qf(a);d.props=e;d.state=a.memoizedState;d.refs=ha;d.context=sf(a,f);f=a.updateQueue;null!==f&&(Vf(a,f,e,d,b),d.state=a.memoizedState);f=a.type.getDerivedStateFromProps;"function"===typeof f&&(mg(a,f,e),d.state=a.memoizedState);"function"===typeof c.getDerivedStateFromProps||"function"===typeof d.getSnapshotBeforeUpdate||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||(c=d.state,"function"===typeof d.componentWillMount&&
d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount(),c!==d.state&&qg.enqueueReplaceState(d,d.state,null),f=a.updateQueue,null!==f&&(Vf(a,f,e,d,b),d.state=a.memoizedState));"function"===typeof d.componentDidMount&&(a.effectTag|=4)}var ug=Array.isArray;
function vg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?A("110"):void 0,d=c.stateNode);d?void 0:A("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ha?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?A("148"):void 0;c._owner?void 0:A("254",a)}return a}
function wg(a,b){"textarea"!==a.type&&A("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function xg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Af(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Df(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=vg(a,b,c),d.return=a,d;d=Bf(c,a.mode,d);d.ref=vg(a,b,c);d.return=a;return d}function n(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
Ef(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function r(a,b,c,d,f){if(null===b||10!==b.tag)return b=Cf(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function w(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Df(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case gc:return c=Bf(b,a.mode,c),c.ref=vg(a,null,b),c.return=a,c;case hc:return b=Ef(b,a.mode,c),b.return=a,b}if(ug(b)||tc(b))return b=Cf(b,a.mode,c,null),b.return=
a,b;wg(a,b)}return null}function P(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case gc:return c.key===e?c.type===ic?r(a,b,c.props.children,d,e):k(a,b,c,d):null;case hc:return c.key===e?n(a,b,c,d):null}if(ug(c)||tc(c))return null!==e?null:r(a,b,c,d,null);wg(a,c)}return null}function nc(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);
if("object"===typeof d&&null!==d){switch(d.$$typeof){case gc:return a=a.get(null===d.key?c:d.key)||null,d.type===ic?r(b,a,d.props.children,e,d.key):k(b,a,d,e);case hc:return a=a.get(null===d.key?c:d.key)||null,n(b,a,d,e)}if(ug(d)||tc(d))return a=a.get(c)||null,r(b,a,d,e,null);wg(b,d)}return null}function Jd(e,g,h,k){for(var u=null,x=null,t=g,q=g=0,n=null;null!==t&&q<h.length;q++){t.index>q?(n=t,t=null):n=t.sibling;var l=P(e,t,h[q],k);if(null===l){null===t&&(t=n);break}a&&t&&null===l.alternate&&b(e,
t);g=f(l,g,q);null===x?u=l:x.sibling=l;x=l;t=n}if(q===h.length)return c(e,t),u;if(null===t){for(;q<h.length;q++)if(t=w(e,h[q],k))g=f(t,g,q),null===x?u=t:x.sibling=t,x=t;return u}for(t=d(e,t);q<h.length;q++)if(n=nc(t,e,q,h[q],k))a&&null!==n.alternate&&t.delete(null===n.key?q:n.key),g=f(n,g,q),null===x?u=n:x.sibling=n,x=n;a&&t.forEach(function(a){return b(e,a)});return u}function E(e,g,h,k){var u=tc(h);"function"!==typeof u?A("150"):void 0;h=u.call(h);null==h?A("151"):void 0;for(var t=u=null,n=g,x=
g=0,y=null,l=h.next();null!==n&&!l.done;x++,l=h.next()){n.index>x?(y=n,n=null):y=n.sibling;var r=P(e,n,l.value,k);if(null===r){n||(n=y);break}a&&n&&null===r.alternate&&b(e,n);g=f(r,g,x);null===t?u=r:t.sibling=r;t=r;n=y}if(l.done)return c(e,n),u;if(null===n){for(;!l.done;x++,l=h.next())l=w(e,l.value,k),null!==l&&(g=f(l,g,x),null===t?u=l:t.sibling=l,t=l);return u}for(n=d(e,n);!l.done;x++,l=h.next())l=nc(n,e,x,l.value,k),null!==l&&(a&&null!==l.alternate&&n.delete(null===l.key?x:l.key),g=f(l,g,x),null===
t?u=l:t.sibling=l,t=l);a&&n.forEach(function(a){return b(e,a)});return u}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ic&&null===f.key;k&&(f=f.props.children);var n="object"===typeof f&&null!==f;if(n)switch(f.$$typeof){case gc:a:{n=f.key;for(k=d;null!==k;){if(k.key===n)if(10===k.tag?f.type===ic:k.type===f.type){c(a,k.sibling);d=e(k,f.type===ic?f.props.children:f.props,h);d.ref=vg(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=k.sibling}f.type===ic?(d=Cf(f.props.children,
a.mode,h,f.key),d.return=a,a=d):(h=Bf(f,a.mode,h),h.ref=vg(a,d,f),h.return=a,a=h)}return g(a);case hc:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Ef(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=
a,a=d):(c(a,d),d=Df(f,a.mode,h),d.return=a,a=d),g(a);if(ug(f))return Jd(a,d,f,h);if(tc(f))return E(a,d,f,h);n&&wg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 2:case 1:h=a.type,A("152",h.displayName||h.name||"Component")}return c(a,d)}}var yg=xg(!0),zg=xg(!1),Ag=null,Bg=null,Cg=!1;function Dg(a,b){var c=new zf(5,null,null,0);c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Eg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}function Fg(a){if(Cg){var b=Bg;if(b){var c=b;if(!Eg(a,b)){b=jf(c);if(!b||!Eg(a,b)){a.effectTag|=2;Cg=!1;Ag=a;return}Dg(Ag,c)}Ag=a;Bg=kf(b)}else a.effectTag|=2,Cg=!1,Ag=a}}
function Gg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;Ag=a}function Hg(a){if(a!==Ag)return!1;if(!Cg)return Gg(a),Cg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!ef(b,a.memoizedProps))for(b=Bg;b;)Dg(a,b),b=jf(b);Gg(a);Bg=Ag?jf(a.stateNode):null;return!0}function Ig(){Bg=Ag=null;Cg=!1}function Q(a,b,c){Jg(a,b,c,b.expirationTime)}function Jg(a,b,c,d){b.child=null===a?zg(b,null,c,d):yg(b,a.child,c,d)}
function Kg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Lg(a,b,c,d,e){Kg(a,b);var f=0!==(b.effectTag&64);if(!c&&!f)return d&&yf(b,!1),R(a,b);c=b.stateNode;ec.current=b;var g=f?null:c.render();b.effectTag|=1;f&&(Jg(a,b,null,e),b.child=null);Jg(a,b,g,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&yf(b,!0);return b.child}
function Mg(a){var b=a.stateNode;b.pendingContext?vf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&vf(a,b.context,!1);jg(a,b.containerInfo)}
function Ng(a,b,c,d){var e=a.child;null!==e&&(e.return=a);for(;null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=d;else break;f=f.return}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=
e.child}if(null!==f)f.return=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){e.return=f.return;f=e;break}f=f.return}e=f}}
function Rg(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps,g=!0;if(O.current)g=!1;else if(f===e)return b.stateNode=0,bg(b),R(a,b);var h=e.value;b.memoizedProps=e;if(null===f)h=1073741823;else if(f.value===e.value){if(f.children===e.children&&g)return b.stateNode=0,bg(b),R(a,b);h=0}else{var k=f.value;if(k===h&&(0!==k||1/k===1/h)||k!==k&&h!==h){if(f.children===e.children&&g)return b.stateNode=0,bg(b),R(a,b);h=0}else if(h="function"===typeof d._calculateChangedBits?d._calculateChangedBits(k,
h):1073741823,h|=0,0===h){if(f.children===e.children&&g)return b.stateNode=0,bg(b),R(a,b)}else Ng(b,d,h,c)}b.stateNode=h;bg(b);Q(a,b,e.children);return b.child}function R(a,b){null!==a&&b.child!==a.child?A("153"):void 0;if(null!==b.child){a=b.child;var c=Af(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Af(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Sg(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:Mg(b);break;case 2:xf(b);break;case 4:jg(b,b.stateNode.containerInfo);break;case 13:bg(b)}return null}switch(b.tag){case 0:null!==a?A("155"):void 0;var d=b.type,e=b.pendingProps,f=qf(b);f=sf(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,f=f.getDerivedStateFromProps,"function"===
typeof f&&mg(b,f,e),e=xf(b),d.updater=qg,b.stateNode=d,d._reactInternalFiber=b,tg(b,c),a=Lg(a,b,!0,e,c)):(b.tag=1,Q(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,O.current||b.memoizedProps!==c?(d=qf(b),d=sf(b,d),e=e(c,d),b.effectTag|=1,Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 2:e=xf(b);if(null===a)if(null===b.stateNode){var g=b.pendingProps,h=b.type;d=qf(b);var k=2===b.tag&&null!=b.type.contextTypes;f=k?sf(b,d):ha;g=new h(g,f);b.memoizedState=null!==
g.state&&void 0!==g.state?g.state:null;g.updater=qg;b.stateNode=g;g._reactInternalFiber=b;k&&(k=b.stateNode,k.__reactInternalMemoizedUnmaskedChildContext=d,k.__reactInternalMemoizedMaskedChildContext=f);tg(b,c);d=!0}else{h=b.type;d=b.stateNode;k=b.memoizedProps;f=b.pendingProps;d.props=k;var n=d.context;g=qf(b);g=sf(b,g);var r=h.getDerivedStateFromProps;(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(k!==f||n!==g)&&sg(b,d,f,g);Mf=!1;var w=b.memoizedState;n=d.state=w;var P=b.updateQueue;null!==P&&(Vf(b,P,f,d,c),n=b.memoizedState);k!==f||w!==n||O.current||Mf?("function"===typeof r&&(mg(b,r,f),n=b.memoizedState),(k=Mf||rg(b,k,f,w,n,g))?(h||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||("function"===typeof d.componentWillMount&&d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount()),"function"===typeof d.componentDidMount&&
(b.effectTag|=4)):("function"===typeof d.componentDidMount&&(b.effectTag|=4),b.memoizedProps=f,b.memoizedState=n),d.props=f,d.state=n,d.context=g,d=k):("function"===typeof d.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.type,d=b.stateNode,f=b.memoizedProps,k=b.pendingProps,d.props=f,n=d.context,g=qf(b),g=sf(b,g),r=h.getDerivedStateFromProps,(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(f!==k||n!==g)&&sg(b,d,k,g),Mf=!1,n=b.memoizedState,w=d.state=n,P=b.updateQueue,null!==P&&(Vf(b,P,k,d,c),w=b.memoizedState),f!==k||n!==w||O.current||Mf?("function"===typeof r&&(mg(b,r,k),w=b.memoizedState),(r=Mf||rg(b,f,k,n,w,g))?(h||"function"!==typeof d.UNSAFE_componentWillUpdate&&"function"!==typeof d.componentWillUpdate||("function"===typeof d.componentWillUpdate&&d.componentWillUpdate(k,w,g),"function"===typeof d.UNSAFE_componentWillUpdate&&d.UNSAFE_componentWillUpdate(k,w,g)),"function"===typeof d.componentDidUpdate&&
(b.effectTag|=4),"function"===typeof d.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),b.memoizedProps=k,b.memoizedState=w),d.props=k,d.state=w,d.context=g,d=r):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||
f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),d=!1);return Lg(a,b,d,e,c);case 3:Mg(b);e=b.updateQueue;if(null!==e)if(d=b.memoizedState,d=null!==d?d.element:null,Vf(b,e,b.pendingProps,null,c),e=b.memoizedState.element,e===d)Ig(),a=R(a,b);else{d=b.stateNode;if(d=(null===a||null===a.child)&&d.hydrate)Bg=kf(b.stateNode.containerInfo),Ag=b,d=Cg=!0;d?(b.effectTag|=2,b.child=zg(b,null,e,c)):(Ig(),Q(a,b,e));a=b.child}else Ig(),a=R(a,b);return a;case 5:a:{hg(gg.current);e=hg(eg.current);d=Ie(e,
b.type);e!==d&&(N(fg,b,b),N(eg,d,b));null===a&&Fg(b);e=b.type;k=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!O.current&&k===d){if(k=b.mode&1&&!!d.hidden)b.expirationTime=1073741823;if(!k||1073741823!==c){a=R(a,b);break a}}k=d.children;ef(e,d)?k=null:f&&ef(e,f)&&(b.effectTag|=16);Kg(a,b);1073741823!==c&&b.mode&1&&d.hidden?(b.expirationTime=1073741823,b.memoizedProps=d,a=null):(Q(a,b,k),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Fg(b),b.memoizedProps=b.pendingProps,
null;case 16:return null;case 4:return jg(b,b.stateNode.containerInfo),e=b.pendingProps,O.current||b.memoizedProps!==e?(null===a?b.child=yg(b,null,e,c):Q(a,b,e),b.memoizedProps=e,a=b.child):a=R(a,b),a;case 14:return e=b.type.render,c=b.pendingProps,d=b.ref,O.current||b.memoizedProps!==c||d!==(null!==a?a.ref:null)?(e=e(c,d),Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 10:return c=b.pendingProps,O.current||b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 11:return c=
b.pendingProps.children,O.current||null!==c&&b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 15:return c=b.pendingProps,b.memoizedProps===c?a=R(a,b):(Q(a,b,c.children),b.memoizedProps=c,a=b.child),a;case 13:return Rg(a,b,c);case 12:a:if(d=b.type,f=b.pendingProps,k=b.memoizedProps,e=d._currentValue,g=d._changedBits,O.current||0!==g||k!==f){b.memoizedProps=f;h=f.unstable_observedBits;if(void 0===h||null===h)h=1073741823;b.stateNode=h;if(0!==(g&h))Ng(b,d,g,c);else if(k===f){a=
R(a,b);break a}c=f.children;c=c(e);b.effectTag|=1;Q(a,b,c);a=b.child}else a=R(a,b);return a;default:A("156")}}function Tg(a){a.effectTag|=4}var Ug=void 0,Vg=void 0,Wg=void 0;Ug=function(){};Vg=function(a,b,c){(b.updateQueue=c)&&Tg(b)};Wg=function(a,b,c,d){c!==d&&Tg(b)};
function Xg(a,b){var c=b.pendingProps;switch(b.tag){case 1:return null;case 2:return tf(b),null;case 3:kg(b);uf(b);var d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)Hg(b),b.effectTag&=-3;Ug(b);return null;case 5:lg(b);d=hg(gg.current);var e=b.type;if(null!==a&&null!=b.stateNode){var f=a.memoizedProps,g=b.stateNode,h=hg(eg.current);g=Xe(g,e,f,c,d);Vg(a,b,g,e,f,c,d,h);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!c)return null===b.stateNode?
A("166"):void 0,null;a=hg(eg.current);if(Hg(b))c=b.stateNode,e=b.type,f=b.memoizedProps,c[C]=b,c[Ma]=f,d=Ze(c,e,f,a,d),b.updateQueue=d,null!==d&&Tg(b);else{a=Ue(e,c,d,a);a[C]=b;a[Ma]=c;a:for(f=b.child;null!==f;){if(5===f.tag||6===f.tag)a.appendChild(f.stateNode);else if(4!==f.tag&&null!==f.child){f.child.return=f;f=f.child;continue}if(f===b)break;for(;null===f.sibling;){if(null===f.return||f.return===b)break a;f=f.return}f.sibling.return=f.return;f=f.sibling}We(a,e,c,d);df(e,c)&&Tg(b);b.stateNode=
a}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)Wg(a,b,a.memoizedProps,c);else{if("string"!==typeof c)return null===b.stateNode?A("166"):void 0,null;d=hg(gg.current);hg(eg.current);Hg(b)?(d=b.stateNode,c=b.memoizedProps,d[C]=b,$e(d,c)&&Tg(b)):(d=Ve(c,d),d[C]=b,b.stateNode=d)}return null;case 14:return null;case 16:return null;case 10:return null;case 11:return null;case 15:return null;case 4:return kg(b),Ug(b),null;case 13:return cg(b),null;case 12:return null;case 0:A("167");
default:A("156")}}function Yg(a,b){var c=b.source;null===b.stack&&null!==c&&vc(c);null!==c&&uc(c);b=b.value;null!==a&&2===a.tag&&uc(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}function Zg(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){$g(a,c)}else b.current=null}
function ah(a){"function"===typeof Lf&&Lf(a);switch(a.tag){case 2:Zg(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){$g(a,c)}break;case 5:Zg(a);break;case 4:bh(a)}}function ch(a){return 5===a.tag||3===a.tag||4===a.tag}
function dh(a){a:{for(var b=a.return;null!==b;){if(ch(b)){var c=b;break a}b=b.return}A("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:A("161")}c.effectTag&16&&(Le(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||ch(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(f=b,g=e.stateNode,8===f.nodeType?f.parentNode.insertBefore(g,f):f.appendChild(g)):b.appendChild(e.stateNode);else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===
e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function bh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?A("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(ah(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?d=b.stateNode.containerInfo:ah(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function eh(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&(c[Ma]=d,Ye(c,f,e,a,d))}break;case 6:null===b.stateNode?A("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 15:break;case 16:break;default:A("163")}}function fh(a,b,c){c=Pf(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){gh(d);Yg(a,b)};return c}
function hh(a,b,c){c=Pf(c);c.tag=3;var d=a.stateNode;null!==d&&"function"===typeof d.componentDidCatch&&(c.callback=function(){null===ih?ih=new Set([this]):ih.add(this);var c=b.value,d=b.stack;Yg(a,b);this.componentDidCatch(c,{componentStack:null!==d?d:""})});return c}
function jh(a,b,c,d,e,f){c.effectTag|=512;c.firstEffect=c.lastEffect=null;d=Yf(d,c);a=b;do{switch(a.tag){case 3:a.effectTag|=1024;d=fh(a,d,f);Sf(a,d,f);return;case 2:if(b=d,c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&(null===ih||!ih.has(c))){a.effectTag|=1024;d=hh(a,b,f);Sf(a,d,f);return}}a=a.return}while(null!==a)}
function kh(a){switch(a.tag){case 2:tf(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return kg(a),uf(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return lg(a),null;case 16:return b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 4:return kg(a),null;case 13:return cg(a),null;default:return null}}var lh=ff(),mh=2,nh=lh,oh=0,ph=0,qh=!1,S=null,rh=null,T=0,sh=-1,th=!1,U=null,uh=!1,vh=!1,ih=null;
function wh(){if(null!==S)for(var a=S.return;null!==a;){var b=a;switch(b.tag){case 2:tf(b);break;case 3:kg(b);uf(b);break;case 5:lg(b);break;case 4:kg(b);break;case 13:cg(b)}a=a.return}rh=null;T=0;sh=-1;th=!1;S=null;vh=!1}
function xh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){b=Xg(b,a,T);var e=a;if(1073741823===T||1073741823!==e.expirationTime){var f=0;switch(e.tag){case 3:case 2:var g=e.updateQueue;null!==g&&(f=g.expirationTime)}for(g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&
(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{vh=!0;break}}else{a=kh(a,th,T);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}
function yh(a){var b=Sg(a.alternate,a,T);null===b&&(b=xh(a));ec.current=null;return b}
function zh(a,b,c){qh?A("243"):void 0;qh=!0;if(b!==T||a!==rh||null===S)wh(),rh=a,T=b,sh=-1,S=Af(rh.current,null,T),a.pendingCommitExpirationTime=0;var d=!1;th=!c||T<=mh;do{try{if(c)for(;null!==S&&!Ah();)S=yh(S);else for(;null!==S;)S=yh(S)}catch(f){if(null===S)d=!0,gh(f);else{null===S?A("271"):void 0;c=S;var e=c.return;if(null===e){d=!0;gh(f);break}jh(a,e,c,f,th,T,nh);S=xh(c)}}break}while(1);qh=!1;if(d)return null;if(null===S){if(vh)return a.pendingCommitExpirationTime=b,a.current.alternate;th?A("262"):
void 0;0<=sh&&setTimeout(function(){var b=a.current.expirationTime;0!==b&&(0===a.remainingExpirationTime||a.remainingExpirationTime<b)&&Bh(a,b)},sh);Ch(a.current.expirationTime)}return null}
function $g(a,b){var c;a:{qh&&!uh?A("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 2:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromCatch||"function"===typeof d.componentDidCatch&&(null===ih||!ih.has(d))){a=Yf(b,a);a=hh(c,a,1);Rf(c,a,1);pg(c,1);c=void 0;break a}break;case 3:a=Yf(b,a);a=fh(c,a,1);Rf(c,a,1);pg(c,1);c=void 0;break a}c=c.return}3===a.tag&&(c=Yf(b,a),c=fh(a,c,1),Rf(a,c,1),pg(a,1));c=void 0}return c}
function Dh(){var a=2+25*(((ng()-2+500)/25|0)+1);a<=oh&&(a=oh+1);return oh=a}function og(a,b){a=0!==ph?ph:qh?uh?1:T:b.mode&1?Eh?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1):1;Eh&&(0===Fh||a>Fh)&&(Fh=a);return a}
function pg(a,b){for(;null!==a;){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a.return)if(3===a.tag){var c=a.stateNode;!qh&&0!==T&&b<T&&wh();var d=c.current.expirationTime;qh&&!uh&&rh===c||Bh(c,d);Gh>Hh&&A("185")}else break;a=a.return}}function ng(){nh=ff()-lh;return mh=(nh/10|0)+2}
function Ih(a){var b=ph;ph=2+25*(((ng()-2+500)/25|0)+1);try{return a()}finally{ph=b}}function Jh(a,b,c,d,e){var f=ph;ph=1;try{return a(b,c,d,e)}finally{ph=f}}var Kh=null,V=null,Lh=0,Mh=void 0,W=!1,X=null,Y=0,Fh=0,Nh=!1,Oh=!1,Ph=null,Qh=null,Z=!1,Rh=!1,Eh=!1,Sh=null,Hh=1E3,Gh=0,Th=1;function Uh(a){if(0!==Lh){if(a>Lh)return;null!==Mh&&hf(Mh)}var b=ff()-lh;Lh=a;Mh=gf(Vh,{timeout:10*(a-2)-b})}
function Bh(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===V?(Kh=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=Kh);else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}W||(Z?Rh&&(X=a,Y=1,Wh(a,1,!1)):1===b?Xh():Uh(b))}
function Yh(){var a=0,b=null;if(null!==V)for(var c=V,d=Kh;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===V?A("244"):void 0;if(d===d.nextScheduledRoot){Kh=V=d.nextScheduledRoot=null;break}else if(d===Kh)Kh=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=Kh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===V)break;
c=d;d=d.nextScheduledRoot}}c=X;null!==c&&c===b&&1===a?Gh++:Gh=0;X=b;Y=a}function Vh(a){Zh(0,!0,a)}function Xh(){Zh(1,!1,null)}function Zh(a,b,c){Qh=c;Yh();if(b)for(;null!==X&&0!==Y&&(0===a||a>=Y)&&(!Nh||ng()>=Y);)ng(),Wh(X,Y,!Nh),Yh();else for(;null!==X&&0!==Y&&(0===a||a>=Y);)Wh(X,Y,!1),Yh();null!==Qh&&(Lh=0,Mh=null);0!==Y&&Uh(Y);Qh=null;Nh=!1;$h()}function ai(a,b){W?A("253"):void 0;X=a;Y=b;Wh(a,b,!1);Xh();$h()}
function $h(){Gh=0;if(null!==Sh){var a=Sh;Sh=null;for(var b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){Oh||(Oh=!0,Ph=d)}}}if(Oh)throw a=Ph,Ph=null,Oh=!1,a;}function Wh(a,b,c){W?A("245"):void 0;W=!0;c?(c=a.finishedWork,null!==c?bi(a,c,b):(c=zh(a,b,!0),null!==c&&(Ah()?a.finishedWork=c:bi(a,c,b)))):(c=a.finishedWork,null!==c?bi(a,c,b):(c=zh(a,b,!1),null!==c&&bi(a,c,b)));W=!1}
function bi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Sh?Sh=[d]:Sh.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=0;return}a.finishedWork=null;uh=qh=!0;c=b.stateNode;c.current===b?A("177"):void 0;d=c.pendingCommitExpirationTime;0===d?A("261"):void 0;c.pendingCommitExpirationTime=0;ng();ec.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var e=b.firstEffect}else e=b;else e=b.firstEffect;bf=Id;var f=da();if(Vd(f)){if("selectionStart"in
f)var g={start:f.selectionStart,end:f.selectionEnd};else a:{var h=window.getSelection&&window.getSelection();if(h&&0!==h.rangeCount){g=h.anchorNode;var k=h.anchorOffset,n=h.focusNode;h=h.focusOffset;try{g.nodeType,n.nodeType}catch(Wa){g=null;break a}var r=0,w=-1,P=-1,nc=0,Jd=0,E=f,t=null;b:for(;;){for(var x;;){E!==g||0!==k&&3!==E.nodeType||(w=r+k);E!==n||0!==h&&3!==E.nodeType||(P=r+h);3===E.nodeType&&(r+=E.nodeValue.length);if(null===(x=E.firstChild))break;t=E;E=x}for(;;){if(E===f)break b;t===g&&
++nc===k&&(w=r);t===n&&++Jd===h&&(P=r);if(null!==(x=E.nextSibling))break;E=t;t=E.parentNode}E=x}g=-1===w||-1===P?null:{start:w,end:P}}else g=null}g=g||{start:0,end:0}}else g=null;cf={focusedElem:f,selectionRange:g};Kd(!1);for(U=e;null!==U;){f=!1;g=void 0;try{for(;null!==U;){if(U.effectTag&256){var u=U.alternate;k=U;switch(k.tag){case 2:if(k.effectTag&256&&null!==u){var y=u.memoizedProps,D=u.memoizedState,ja=k.stateNode;ja.props=k.memoizedProps;ja.state=k.memoizedState;var ni=ja.getSnapshotBeforeUpdate(y,
D);ja.__reactInternalSnapshotBeforeUpdate=ni}break;case 3:case 5:case 6:case 4:break;default:A("163")}}U=U.nextEffect}}catch(Wa){f=!0,g=Wa}f&&(null===U?A("178"):void 0,$g(U,g),null!==U&&(U=U.nextEffect))}for(U=e;null!==U;){u=!1;y=void 0;try{for(;null!==U;){var q=U.effectTag;q&16&&Le(U.stateNode,"");if(q&128){var z=U.alternate;if(null!==z){var l=z.ref;null!==l&&("function"===typeof l?l(null):l.current=null)}}switch(q&14){case 2:dh(U);U.effectTag&=-3;break;case 6:dh(U);U.effectTag&=-3;eh(U.alternate,
U);break;case 4:eh(U.alternate,U);break;case 8:D=U,bh(D),D.return=null,D.child=null,D.alternate&&(D.alternate.child=null,D.alternate.return=null)}U=U.nextEffect}}catch(Wa){u=!0,y=Wa}u&&(null===U?A("178"):void 0,$g(U,y),null!==U&&(U=U.nextEffect))}l=cf;z=da();q=l.focusedElem;u=l.selectionRange;if(z!==q&&fa(document.documentElement,q)){null!==u&&Vd(q)&&(z=u.start,l=u.end,void 0===l&&(l=z),"selectionStart"in q?(q.selectionStart=z,q.selectionEnd=Math.min(l,q.value.length)):window.getSelection&&(z=window.getSelection(),
y=q[lb()].length,l=Math.min(u.start,y),u=void 0===u.end?l:Math.min(u.end,y),!z.extend&&l>u&&(y=u,u=l,l=y),y=Ud(q,l),D=Ud(q,u),y&&D&&(1!==z.rangeCount||z.anchorNode!==y.node||z.anchorOffset!==y.offset||z.focusNode!==D.node||z.focusOffset!==D.offset)&&(ja=document.createRange(),ja.setStart(y.node,y.offset),z.removeAllRanges(),l>u?(z.addRange(ja),z.extend(D.node,D.offset)):(ja.setEnd(D.node,D.offset),z.addRange(ja)))));z=[];for(l=q;l=l.parentNode;)1===l.nodeType&&z.push({element:l,left:l.scrollLeft,
top:l.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<z.length;q++)l=z[q],l.element.scrollLeft=l.left,l.element.scrollTop=l.top}cf=null;Kd(bf);bf=null;c.current=b;for(U=e;null!==U;){e=!1;q=void 0;try{for(z=d;null!==U;){var ig=U.effectTag;if(ig&36){var oc=U.alternate;l=U;u=z;switch(l.tag){case 2:var ca=l.stateNode;if(l.effectTag&4)if(null===oc)ca.props=l.memoizedProps,ca.state=l.memoizedState,ca.componentDidMount();else{var xi=oc.memoizedProps,yi=oc.memoizedState;ca.props=l.memoizedProps;
ca.state=l.memoizedState;ca.componentDidUpdate(xi,yi,ca.__reactInternalSnapshotBeforeUpdate)}var Og=l.updateQueue;null!==Og&&(ca.props=l.memoizedProps,ca.state=l.memoizedState,Xf(l,Og,ca,u));break;case 3:var Pg=l.updateQueue;if(null!==Pg){y=null;if(null!==l.child)switch(l.child.tag){case 5:y=l.child.stateNode;break;case 2:y=l.child.stateNode}Xf(l,Pg,y,u)}break;case 5:var zi=l.stateNode;null===oc&&l.effectTag&4&&df(l.type,l.memoizedProps)&&zi.focus();break;case 6:break;case 4:break;case 15:break;case 16:break;
default:A("163")}}if(ig&128){l=void 0;var yc=U.ref;if(null!==yc){var Qg=U.stateNode;switch(U.tag){case 5:l=Qg;break;default:l=Qg}"function"===typeof yc?yc(l):yc.current=l}}var Ai=U.nextEffect;U.nextEffect=null;U=Ai}}catch(Wa){e=!0,q=Wa}e&&(null===U?A("178"):void 0,$g(U,q),null!==U&&(U=U.nextEffect))}qh=uh=!1;"function"===typeof Kf&&Kf(b.stateNode);b=c.current.expirationTime;0===b&&(ih=null);a.remainingExpirationTime=b}function Ah(){return null===Qh||Qh.timeRemaining()>Th?!1:Nh=!0}
function gh(a){null===X?A("246"):void 0;X.remainingExpirationTime=0;Oh||(Oh=!0,Ph=a)}function Ch(a){null===X?A("246"):void 0;X.remainingExpirationTime=a}function ci(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Xh()}}function di(a,b){if(Z&&!Rh){Rh=!0;try{return a(b)}finally{Rh=!1}}return a(b)}function ei(a,b){W?A("187"):void 0;var c=Z;Z=!0;try{return Jh(a,b)}finally{Z=c,Xh()}}
function fi(a,b,c){if(Eh)return a(b,c);Z||W||0===Fh||(Zh(Fh,!1,null),Fh=0);var d=Eh,e=Z;Z=Eh=!0;try{return a(b,c)}finally{Eh=d,(Z=e)||W||Xh()}}function gi(a){var b=Z;Z=!0;try{Jh(a)}finally{(Z=b)||W||Zh(1,!1,null)}}
function hi(a,b,c,d,e){var f=b.current;if(c){c=c._reactInternalFiber;var g;b:{2===kd(c)&&2===c.tag?void 0:A("170");for(g=c;3!==g.tag;){if(rf(g)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}(g=g.return)?void 0:A("171")}g=g.stateNode.context}c=rf(c)?wf(c,g):g}else c=ha;null===b.context?b.context=c:b.pendingContext=c;b=e;e=Pf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);Rf(f,e,d);pg(f,d);return d}
function ii(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?A("188"):A("268",Object.keys(a)));a=nd(b);return null===a?null:a.stateNode}function ji(a,b,c,d){var e=b.current,f=ng();e=og(f,e);return hi(a,b,c,e,d)}function ki(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}
function li(a){var b=a.findFiberByHostInstance;return Jf(p({},a,{findHostInstanceByFiber:function(a){a=nd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}
var mi={updateContainerAtExpirationTime:hi,createContainer:function(a,b,c){return Ff(a,b,c)},updateContainer:ji,flushRoot:ai,requestWork:Bh,computeUniqueAsyncExpiration:Dh,batchedUpdates:ci,unbatchedUpdates:di,deferredUpdates:Ih,syncUpdates:Jh,interactiveUpdates:fi,flushInteractiveUpdates:function(){W||0===Fh||(Zh(Fh,!1,null),Fh=0)},flushControlled:gi,flushSync:ei,getPublicRootInstance:ki,findHostInstance:ii,findHostInstanceWithNoPortals:function(a){a=od(a);return null===a?null:a.stateNode},injectIntoDevTools:li};
function oi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:hc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}Kb.injectFiberControlledHostComponent(af);function pi(a){this._expirationTime=Dh();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}
pi.prototype.render=function(a){this._defer?void 0:A("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new qi;hi(a,b,null,c,d._onCommit);return d};pi.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
pi.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:A("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?A("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;ai(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};pi.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function qi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}qi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
qi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?A("191",c):void 0;c()}}};function ri(a,b,c){this._internalRoot=Ff(a,b,c)}ri.prototype.render=function(a,b){var c=this._internalRoot,d=new qi;b=void 0===b?null:b;null!==b&&d.then(b);ji(a,c,null,d._onCommit);return d};
ri.prototype.unmount=function(a){var b=this._internalRoot,c=new qi;a=void 0===a?null:a;null!==a&&c.then(a);ji(null,b,null,c._onCommit);return c};ri.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new qi;c=void 0===c?null:c;null!==c&&e.then(c);ji(b,d,a,e._onCommit);return e};
ri.prototype.createBatch=function(){var a=new pi(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function si(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Sb=mi.batchedUpdates;Tb=mi.interactiveUpdates;Ub=mi.flushInteractiveUpdates;
function ti(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new ri(a,!1,b)}
function ui(a,b,c,d,e){si(c)?void 0:A("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=ki(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=ti(c,d);if("function"===typeof e){var h=e;e=function(){var a=ki(f._internalRoot);h.call(a)}}di(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return ki(f._internalRoot)}
function vi(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;si(b)?void 0:A("200");return oi(a,b,null,c)}
var wi={createPortal:vi,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:ii(a)},hydrate:function(a,b,c){return ui(null,a,b,!0,c)},render:function(a,b,c){return ui(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?A("38"):void 0;return ui(a,b,c,!1,d)},unmountComponentAtNode:function(a){si(a)?void 0:A("40");return a._reactRootContainer?(di(function(){ui(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return vi.apply(void 0,
arguments)},unstable_batchedUpdates:ci,unstable_deferredUpdates:Ih,unstable_interactiveUpdates:fi,flushSync:ei,unstable_flushControlled:gi,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ka,EventPluginRegistry:va,EventPropagators:$a,ReactControlledComponent:Rb,ReactDOMComponentTree:Qa,ReactDOMEventListener:Od},unstable_createRoot:function(a,b){return new ri(a,!0,null!=b&&!0===b.hydrate)}};li({findFiberByHostInstance:Na,bundleType:0,version:"16.4.2",rendererPackageName:"react-dom"});
var Bi={default:wi},Ci=Bi&&wi||Bi;module.exports=Ci.default?Ci.default:Ci;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(380);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(381);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Main__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_api_analytics_reporting__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_persist_integration_react__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_common_CenteredLoader__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_api_redux_watson_app_config__ = __webpack_require__(669);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(){var _ref;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_this.state={hasError:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:'componentDidMount',value:function componentDidMount(){var el=document.getElementById('staticloader');el.parentNode.removeChild(el);}},{key:'componentDidCatch',value:function componentDidCatch(e){Object(__WEBPACK_IMPORTED_MODULE_4_app_api_analytics_reporting__["b" /* noticeError */])(e);this.setState({hasError:true});}},{key:'render',value:function render(){if(this.state.hasError){return'Oops! Something went wrong. Please try again later!';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_7_app_api_redux_watson_app_config__["b" /* store */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_persist_integration_react__["a" /* PersistGate */],{loading:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__core_common_CenteredLoader__["a" /* default */],{fullScreen:true}),persistor:__WEBPACK_IMPORTED_MODULE_7_app_api_redux_watson_app_config__["a" /* persistor */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Main__["a" /* default */],null))));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(73);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(387);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.hoistNonReactStatics = factory());
}(this, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(406);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(123);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(394);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(33), __webpack_require__(122)(module)))

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(403);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(400);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(398);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(33)))

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(125);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(402);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(123);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(124);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(407);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(73);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MainTest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_util_connect_enhancer__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_BrandedFavicon__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Pages__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_common_CenteredLoader__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_redux_route_routes__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_ui_route_RedirectOnce__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_common_CSSFeatures__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__analytics_ClickTracker__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__analytics_AnalyticsInit__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__analytics_HistoryTracker__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_Main_css__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_Main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__style_Main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_redux_watson_app_init__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_ui_config_ThemedFocus__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_env__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DevTools__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__config_DocLang__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_ui_analytics_ReporterContext__ = __webpack_require__(667);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Main=function(_React$Component){_inherits(Main,_React$Component);function Main(){_classCallCheck(this,Main);return _possibleConstructorReturn(this,(Main.__proto__||Object.getPrototypeOf(Main)).apply(this,arguments));}_createClass(Main,[{key:'componentDidMount',value:function componentDidMount(){this.props.initAppData();}},{key:'render',value:function render(){if(this.props.status===__WEBPACK_IMPORTED_MODULE_12__api_redux_watson_app_init__["b" /* LOADING */]){return(// We are not using MainSizer in order to not pull in all the stuff
// associated with that import during the initial load
// (e.g react-modal)
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__core_common_CenteredLoader__["a" /* default */],{fullScreen:true})));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__core_common_CSSFeatures__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_app_ui_config_ThemedFocus__["h" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__config_BrandedFavicon__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Pages__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__analytics_AnalyticsInit__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_app_ui_analytics_ReporterContext__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__analytics_ClickTracker__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__analytics_HistoryTracker__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__config_DocLang__["a" /* default */],null),Object(__WEBPACK_IMPORTED_MODULE_14__utils_env__["c" /* isDevOrLocal */])()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__DevTools__["a" /* default */],null),this.props.status===__WEBPACK_IMPORTED_MODULE_12__api_redux_watson_app_init__["a" /* ERROR */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_app_ui_route_RedirectOnce__["a" /* default */],{to:__WEBPACK_IMPORTED_MODULE_5__api_redux_route_routes__["T" /* SYSTEM_ERROR */]}));}}]);return Main;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){return{status:Object(__WEBPACK_IMPORTED_MODULE_12__api_redux_watson_app_init__["c" /* getAppInitStatus */])(state)};};var mapDispatchToProps={initAppData:__WEBPACK_IMPORTED_MODULE_12__api_redux_watson_app_init__["d" /* initAppData */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_util_connect_enhancer__["a" /* default */])(mapStateToProps,mapDispatchToProps)(Main));var MainTest=Main;

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(76);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(127);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createBrowserHistory);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(127);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createHashHistory);

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(75);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createMemoryHistory);

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(76);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(418);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(77);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(128);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(422);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(424);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(132);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(426);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(77);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(428);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(78);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(132);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(78);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(432);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(130);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_common_Favicon__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_redux_watson_watson_config_selectors__ = __webpack_require__(4);
function BrandedFavicon(_ref){var icon=_ref.icon;if(icon){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__core_common_Favicon__["a" /* default */],{icon:icon});}return null;}var mapStateToProps=function mapStateToProps(state){return{icon:Object(__WEBPACK_IMPORTED_MODULE_3__api_redux_watson_watson_config_selectors__["f" /* getBrandCommon */])(state).favicon};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(BrandedFavicon));

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Favicon=function(_Component){_inherits(Favicon,_Component);function Favicon(){_classCallCheck(this,Favicon);return _possibleConstructorReturn(this,(Favicon.__proto__||Object.getPrototypeOf(Favicon)).apply(this,arguments));}_createClass(Favicon,[{key:'componentDidMount',value:function componentDidMount(){this.updateFavicon(this.props.icon);}},{key:'UNSAFE_componentWillReceiveProps',value:function UNSAFE_componentWillReceiveProps(nextProps){if(this.props.icon!==nextProps.icon){this.updateFavicon(nextProps.icon);}}},{key:'updateFavicon',value:function updateFavicon(icon){// TODO: Temp path for testing
document.querySelector("link[rel*='icon']").href=""+'/'+icon;}},{key:'render',value:function render(){return null;}}]);return Favicon;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Favicon);Favicon.propTypes={icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(436);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 436 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 437 */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncatched exception popping up in devtools
	return Promise.resolve().then(function() {
		throw new Error("Cannot find module '" + req + "'.");
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = 437;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(439);
var objectAssign = __webpack_require__(54);
var decodeComponent = __webpack_require__(440);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
}

function parse(str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: parse(extract(str), opts)
	};
};


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// HumanizeDuration.js - https://git.io/j0HgmQ

;(function () {
  var languages = {
    ar: {
      y: function (c) { return c === 1 ? 'سنة' : 'سنوات' },
      mo: function (c) { return c === 1 ? 'شهر' : 'أشهر' },
      w: function (c) { return c === 1 ? 'أسبوع' : 'أسابيع' },
      d: function (c) { return c === 1 ? 'يوم' : 'أيام' },
      h: function (c) { return c === 1 ? 'ساعة' : 'ساعات' },
      m: function (c) { return c === 1 ? 'دقيقة' : 'دقائق' },
      s: function (c) { return c === 1 ? 'ثانية' : 'ثواني' },
      ms: function (c) { return c === 1 ? 'جزء من الثانية' : 'أجزاء من الثانية' },
      decimal: ','
    },
    bg: {
      y: function (c) { return ['години', 'година', 'години'][getSlavicForm(c)] },
      mo: function (c) { return ['месеца', 'месец', 'месеца'][getSlavicForm(c)] },
      w: function (c) { return ['седмици', 'седмица', 'седмици'][getSlavicForm(c)] },
      d: function (c) { return ['дни', 'ден', 'дни'][getSlavicForm(c)] },
      h: function (c) { return ['часа', 'час', 'часа'][getSlavicForm(c)] },
      m: function (c) { return ['минути', 'минута', 'минути'][getSlavicForm(c)] },
      s: function (c) { return ['секунди', 'секунда', 'секунди'][getSlavicForm(c)] },
      ms: function (c) { return ['милисекунди', 'милисекунда', 'милисекунди'][getSlavicForm(c)] },
      decimal: ','
    },
    ca: {
      y: function (c) { return 'any' + (c === 1 ? '' : 's') },
      mo: function (c) { return 'mes' + (c === 1 ? '' : 'os') },
      w: function (c) { return 'setman' + (c === 1 ? 'a' : 'es') },
      d: function (c) { return 'di' + (c === 1 ? 'a' : 'es') },
      h: function (c) { return 'hor' + (c === 1 ? 'a' : 'es') },
      m: function (c) { return 'minut' + (c === 1 ? '' : 's') },
      s: function (c) { return 'segon' + (c === 1 ? '' : 's') },
      ms: function (c) { return 'milisegon' + (c === 1 ? '' : 's') },
      decimal: ','
    },
    cs: {
      y: function (c) { return ['rok', 'roku', 'roky', 'let'][getCzechOrSlovakForm(c)] },
      mo: function (c) { return ['měsíc', 'měsíce', 'měsíce', 'měsíců'][getCzechOrSlovakForm(c)] },
      w: function (c) { return ['týden', 'týdne', 'týdny', 'týdnů'][getCzechOrSlovakForm(c)] },
      d: function (c) { return ['den', 'dne', 'dny', 'dní'][getCzechOrSlovakForm(c)] },
      h: function (c) { return ['hodina', 'hodiny', 'hodiny', 'hodin'][getCzechOrSlovakForm(c)] },
      m: function (c) { return ['minuta', 'minuty', 'minuty', 'minut'][getCzechOrSlovakForm(c)] },
      s: function (c) { return ['sekunda', 'sekundy', 'sekundy', 'sekund'][getCzechOrSlovakForm(c)] },
      ms: function (c) { return ['milisekunda', 'milisekundy', 'milisekundy', 'milisekund'][getCzechOrSlovakForm(c)] },
      decimal: ','
    },
    da: {
      y: 'år',
      mo: function (c) { return 'måned' + (c === 1 ? '' : 'er') },
      w: function (c) { return 'uge' + (c === 1 ? '' : 'r') },
      d: function (c) { return 'dag' + (c === 1 ? '' : 'e') },
      h: function (c) { return 'time' + (c === 1 ? '' : 'r') },
      m: function (c) { return 'minut' + (c === 1 ? '' : 'ter') },
      s: function (c) { return 'sekund' + (c === 1 ? '' : 'er') },
      ms: function (c) { return 'millisekund' + (c === 1 ? '' : 'er') },
      decimal: ','
    },
    de: {
      y: function (c) { return 'Jahr' + (c === 1 ? '' : 'e') },
      mo: function (c) { return 'Monat' + (c === 1 ? '' : 'e') },
      w: function (c) { return 'Woche' + (c === 1 ? '' : 'n') },
      d: function (c) { return 'Tag' + (c === 1 ? '' : 'e') },
      h: function (c) { return 'Stunde' + (c === 1 ? '' : 'n') },
      m: function (c) { return 'Minute' + (c === 1 ? '' : 'n') },
      s: function (c) { return 'Sekunde' + (c === 1 ? '' : 'n') },
      ms: function (c) { return 'Millisekunde' + (c === 1 ? '' : 'n') },
      decimal: ','
    },
    en: {
      y: function (c) { return 'year' + (c === 1 ? '' : 's') },
      mo: function (c) { return 'month' + (c === 1 ? '' : 's') },
      w: function (c) { return 'week' + (c === 1 ? '' : 's') },
      d: function (c) { return 'day' + (c === 1 ? '' : 's') },
      h: function (c) { return 'hour' + (c === 1 ? '' : 's') },
      m: function (c) { return 'minute' + (c === 1 ? '' : 's') },
      s: function (c) { return 'second' + (c === 1 ? '' : 's') },
      ms: function (c) { return 'millisecond' + (c === 1 ? '' : 's') },
      decimal: '.'
    },
    es: {
      y: function (c) { return 'año' + (c === 1 ? '' : 's') },
      mo: function (c) { return 'mes' + (c === 1 ? '' : 'es') },
      w: function (c) { return 'semana' + (c === 1 ? '' : 's') },
      d: function (c) { return 'día' + (c === 1 ? '' : 's') },
      h: function (c) { return 'hora' + (c === 1 ? '' : 's') },
      m: function (c) { return 'minuto' + (c === 1 ? '' : 's') },
      s: function (c) { return 'segundo' + (c === 1 ? '' : 's') },
      ms: function (c) { return 'milisegundo' + (c === 1 ? '' : 's') },
      decimal: ','
    },
    fa: {
      y: 'سال',
      mo: 'ماه',
      w: 'هفته',
      d: 'روز',
      h: 'ساعت',
      m: 'دقیقه',
      s: 'ثانیه',
      ms: 'میلی ثانیه',
      decimal: '.'
    },
    fi: {
      y: function (c) { return c === 1 ? 'vuosi' : 'vuotta' },
      mo: function (c) { return c === 1 ? 'kuukausi' : 'kuukautta' },
      w: function (c) { return 'viikko' + (c === 1 ? '' : 'a') },
      d: function (c) { return 'päivä' + (c === 1 ? '' : 'ä') },
      h: function (c) { return 'tunti' + (c === 1 ? '' : 'a') },
      m: function (c) { return 'minuutti' + (c === 1 ? '' : 'a') },
      s: function (c) { return 'sekunti' + (c === 1 ? '' : 'a') },
      ms: function (c) { return 'millisekunti' + (c === 1 ? '' : 'a') },
      decimal: ','
    },
    fr: {
      y: function (c) { return 'an' + (c >= 2 ? 's' : '') },
      mo: 'mois',
      w: function (c) { return 'semaine' + (c >= 2 ? 's' : '') },
      d: function (c) { return 'jour' + (c >= 2 ? 's' : '') },
      h: function (c) { return 'heure' + (c >= 2 ? 's' : '') },
      m: function (c) { return 'minute' + (c >= 2 ? 's' : '') },
      s: function (c) { return 'seconde' + (c >= 2 ? 's' : '') },
      ms: function (c) { return 'milliseconde' + (c >= 2 ? 's' : '') },
      decimal: ','
    },
    gr: {
      y: function (c) { return c === 1 ? 'χρόνος' : 'χρόνια' },
      mo: function (c) { return c === 1 ? 'μήνας' : 'μήνες' },
      w: function (c) { return c === 1 ? 'εβδομάδα' : 'εβδομάδες' },
      d: function (c) { return c === 1 ? 'μέρα' : 'μέρες' },
      h: function (c) { return c === 1 ? 'ώρα' : 'ώρες' },
      m: function (c) { return c === 1 ? 'λεπτό' : 'λεπτά' },
      s: function (c) { return c === 1 ? 'δευτερόλεπτο' : 'δευτερόλεπτα' },
      ms: function (c) { return c === 1 ? 'χιλιοστό του δευτερολέπτου' : 'χιλιοστά του δευτερολέπτου' },
      decimal: ','
    },
    hr: {
      y: function (c) {
        if (c % 10 === 2 || c % 10 === 3 || c % 10 === 4) {
          return 'godine'
        }
        return 'godina'
      },
      mo: function (c) {
        if (c === 1) {
          return 'mjesec'
        } else if (c === 2 || c === 3 || c === 4) {
          return 'mjeseca'
        }
        return 'mjeseci'
      },
      w: function (c) {
        if (c % 10 === 1 && c !== 11) {
          return 'tjedan'
        }
        return 'tjedna'
      },
      d: function (c) { return c === 1 ? 'dan' : 'dana' },
      h: function (c) {
        if (c === 1) {
          return 'sat'
        } else if (c === 2 || c === 3 || c === 4) {
          return 'sata'
        }
        return 'sati'
      },
      m: function (c) {
        var mod10 = c % 10
        if ((mod10 === 2 || mod10 === 3 || mod10 === 4) && (c < 10 || c > 14)) {
          return 'minute'
        }
        return 'minuta'
      },
      s: function (c) {
        if ((c === 10 || c === 11 || c === 12 || c === 13 || c === 14 || c === 16 || c === 17 || c === 18 || c === 19) || (c % 10 === 5)) {
          return 'sekundi'
        } else if (c % 10 === 1) {
          return 'sekunda'
        } else if (c % 10 === 2 || c % 10 === 3 || c % 10 === 4) {
          return 'sekunde'
        }
        return 'sekundi'
      },
      ms: function (c) {
        if (c === 1) {
          return 'milisekunda'
        } else if (c % 10 === 2 || c % 10 === 3 || c % 10 === 4) {
          return 'milisekunde'
        }
        return 'milisekundi'
      },
      decimal: ','
    },
    hu: {
      y: 'év',
      mo: 'hónap',
      w: 'hét',
      d: 'nap',
      h: 'óra',
      m: 'perc',
      s: 'másodperc',
      ms: 'ezredmásodperc',
      decimal: ','
    },
    id: {
      y: 'tahun',
      mo: 'bulan',
      w: 'minggu',
      d: 'hari',
      h: 'jam',
      m: 'menit',
      s: 'detik',
      ms: 'milidetik',
      decimal: '.'
    },
    is: {
      y: 'ár',
      mo: function (c) { return 'mánuð' + (c === 1 ? 'ur' : 'ir') },
      w: function (c) { return 'vik' + (c === 1 ? 'a' : 'ur') },
      d: function (c) { return 'dag' + (c === 1 ? 'ur' : 'ar') },
      h: function (c) { return 'klukkutím' + (c === 1 ? 'i' : 'ar') },
      m: function (c) { return 'mínút' + (c === 1 ? 'a' : 'ur') },
      s: function (c) { return 'sekúnd' + (c === 1 ? 'a' : 'ur') },
      ms: function (c) { return 'millisekúnd' + (c === 1 ? 'a' : 'ur') },
      decimal: '.'
    },
    it: {
      y: function (c) { return 'ann' + (c === 1 ? 'o' : 'i') },
      mo: function (c) { return 'mes' + (c === 1 ? 'e' : 'i') },
      w: function (c) { return 'settiman' + (c === 1 ? 'a' : 'e') },
      d: function (c) { return 'giorn' + (c === 1 ? 'o' : 'i') },
      h: function (c) { return 'or' + (c === 1 ? 'a' : 'e') },
      m: function (c) { return 'minut' + (c === 1 ? 'o' : 'i') },
      s: function (c) { return 'second' + (c === 1 ? 'o' : 'i') },
      ms: function (c) { return 'millisecond' + (c === 1 ? 'o' : 'i') },
      decimal: ','
    },
    ja: {
      y: '年',
      mo: '月',
      w: '週',
      d: '日',
      h: '時間',
      m: '分',
      s: '秒',
      ms: 'ミリ秒',
      decimal: '.'
    },
    ko: {
      y: '년',
      mo: '개월',
      w: '주일',
      d: '일',
      h: '시간',
      m: '분',
      s: '초',
      ms: '밀리 초',
      decimal: '.'
    },
    lo: {
      y: 'ປີ',
      mo: 'ເດືອນ',
      w: 'ອາທິດ',
      d: 'ມື້',
      h: 'ຊົ່ວໂມງ',
      m: 'ນາທີ',
      s: 'ວິນາທີ',
      ms: 'ມິນລິວິນາທີ',
      decimal: ','
    },
    lt: {
      y: function (c) { return ((c % 10 === 0) || (c % 100 >= 10 && c % 100 <= 20)) ? 'metų' : 'metai' },
      mo: function (c) { return ['mėnuo', 'mėnesiai', 'mėnesių'][getLithuanianForm(c)] },
      w: function (c) { return ['savaitė', 'savaitės', 'savaičių'][getLithuanianForm(c)] },
      d: function (c) { return ['diena', 'dienos', 'dienų'][getLithuanianForm(c)] },
      h: function (c) { return ['valanda', 'valandos', 'valandų'][getLithuanianForm(c)] },
      m: function (c) { return ['minutė', 'minutės', 'minučių'][getLithuanianForm(c)] },
      s: function (c) { return ['sekundė', 'sekundės', 'sekundžių'][getLithuanianForm(c)] },
      ms: function (c) { return ['milisekundė', 'milisekundės', 'milisekundžių'][getLithuanianForm(c)] },
      decimal: ','
    },
    ms: {
      y: 'tahun',
      mo: 'bulan',
      w: 'minggu',
      d: 'hari',
      h: 'jam',
      m: 'minit',
      s: 'saat',
      ms: 'milisaat',
      decimal: '.'
    },
    nl: {
      y: 'jaar',
      mo: function (c) { return c === 1 ? 'maand' : 'maanden' },
      w: function (c) { return c === 1 ? 'week' : 'weken' },
      d: function (c) { return c === 1 ? 'dag' : 'dagen' },
      h: 'uur',
      m: function (c) { return c === 1 ? 'minuut' : 'minuten' },
      s: function (c) { return c === 1 ? 'seconde' : 'seconden' },
      ms: function (c) { return c === 1 ? 'milliseconde' : 'milliseconden' },
      decimal: ','
    },
    no: {
      y: 'år',
      mo: function (c) { return 'måned' + (c === 1 ? '' : 'er') },
      w: function (c) { return 'uke' + (c === 1 ? '' : 'r') },
      d: function (c) { return 'dag' + (c === 1 ? '' : 'er') },
      h: function (c) { return 'time' + (c === 1 ? '' : 'r') },
      m: function (c) { return 'minutt' + (c === 1 ? '' : 'er') },
      s: function (c) { return 'sekund' + (c === 1 ? '' : 'er') },
      ms: function (c) { return 'millisekund' + (c === 1 ? '' : 'er') },
      decimal: ','
    },
    pl: {
      y: function (c) { return ['rok', 'roku', 'lata', 'lat'][getPolishForm(c)] },
      mo: function (c) { return ['miesiąc', 'miesiąca', 'miesiące', 'miesięcy'][getPolishForm(c)] },
      w: function (c) { return ['tydzień', 'tygodnia', 'tygodnie', 'tygodni'][getPolishForm(c)] },
      d: function (c) { return ['dzień', 'dnia', 'dni', 'dni'][getPolishForm(c)] },
      h: function (c) { return ['godzina', 'godziny', 'godziny', 'godzin'][getPolishForm(c)] },
      m: function (c) { return ['minuta', 'minuty', 'minuty', 'minut'][getPolishForm(c)] },
      s: function (c) { return ['sekunda', 'sekundy', 'sekundy', 'sekund'][getPolishForm(c)] },
      ms: function (c) { return ['milisekunda', 'milisekundy', 'milisekundy', 'milisekund'][getPolishForm(c)] },
      decimal: ','
    },
    pt: {
      y: function (c) { return 'ano' + (c === 1 ? '' : 's') },
      mo: function (c) { return c === 1 ? 'mês' : 'meses' },
      w: function (c) { return 'semana' + (c === 1 ? '' : 's') },
      d: function (c) { return 'dia' + (c === 1 ? '' : 's') },
      h: function (c) { return 'hora' + (c === 1 ? '' : 's') },
      m: function (c) { return 'minuto' + (c === 1 ? '' : 's') },
      s: function (c) { return 'segundo' + (c === 1 ? '' : 's') },
      ms: function (c) { return 'milissegundo' + (c === 1 ? '' : 's') },
      decimal: ','
    },
    ru: {
      y: function (c) { return ['лет', 'год', 'года'][getSlavicForm(c)] },
      mo: function (c) { return ['месяцев', 'месяц', 'месяца'][getSlavicForm(c)] },
      w: function (c) { return ['недель', 'неделя', 'недели'][getSlavicForm(c)] },
      d: function (c) { return ['дней', 'день', 'дня'][getSlavicForm(c)] },
      h: function (c) { return ['часов', 'час', 'часа'][getSlavicForm(c)] },
      m: function (c) { return ['минут', 'минута', 'минуты'][getSlavicForm(c)] },
      s: function (c) { return ['секунд', 'секунда', 'секунды'][getSlavicForm(c)] },
      ms: function (c) { return ['миллисекунд', 'миллисекунда', 'миллисекунды'][getSlavicForm(c)] },
      decimal: ','
    },
    uk: {
      y: function (c) { return ['років', 'рік', 'роки'][getSlavicForm(c)] },
      mo: function (c) { return ['місяців', 'місяць', 'місяці'][getSlavicForm(c)] },
      w: function (c) { return ['тижнів', 'тиждень', 'тижні'][getSlavicForm(c)] },
      d: function (c) { return ['днів', 'день', 'дні'][getSlavicForm(c)] },
      h: function (c) { return ['годин', 'година', 'години'][getSlavicForm(c)] },
      m: function (c) { return ['хвилин', 'хвилина', 'хвилини'][getSlavicForm(c)] },
      s: function (c) { return ['секунд', 'секунда', 'секунди'][getSlavicForm(c)] },
      ms: function (c) { return ['мілісекунд', 'мілісекунда', 'мілісекунди'][getSlavicForm(c)] },
      decimal: ','
    },
    ur: {
      y: 'سال',
      mo: function (c) { return c === 1 ? 'مہینہ' : 'مہینے' },
      w: function (c) { return c === 1 ? 'ہفتہ' : 'ہفتے' },
      d: 'دن',
      h: function (c) { return c === 1 ? 'گھنٹہ' : 'گھنٹے' },
      m: 'منٹ',
      s: 'سیکنڈ',
      ms: 'ملی سیکنڈ',
      decimal: '.'
    },
    sk: {
      y: function (c) { return ['rok', 'roky', 'roky', 'rokov'][getCzechOrSlovakForm(c)] },
      mo: function (c) { return ['mesiac', 'mesiace', 'mesiace', 'mesiacov'][getCzechOrSlovakForm(c)] },
      w: function (c) { return ['týždeň', 'týždne', 'týždne', 'týždňov'][getCzechOrSlovakForm(c)] },
      d: function (c) { return ['deň', 'dni', 'dni', 'dní'][getCzechOrSlovakForm(c)] },
      h: function (c) { return ['hodina', 'hodiny', 'hodiny', 'hodín'][getCzechOrSlovakForm(c)] },
      m: function (c) { return ['minúta', 'minúty', 'minúty', 'minút'][getCzechOrSlovakForm(c)] },
      s: function (c) { return ['sekunda', 'sekundy', 'sekundy', 'sekúnd'][getCzechOrSlovakForm(c)] },
      ms: function (c) { return ['milisekunda', 'milisekundy', 'milisekundy', 'milisekúnd'][getCzechOrSlovakForm(c)] },
      decimal: ','
    },
    sv: {
      y: 'år',
      mo: function (c) { return 'månad' + (c === 1 ? '' : 'er') },
      w: function (c) { return 'veck' + (c === 1 ? 'a' : 'or') },
      d: function (c) { return 'dag' + (c === 1 ? '' : 'ar') },
      h: function (c) { return 'timm' + (c === 1 ? 'e' : 'ar') },
      m: function (c) { return 'minut' + (c === 1 ? '' : 'er') },
      s: function (c) { return 'sekund' + (c === 1 ? '' : 'er') },
      ms: function (c) { return 'millisekund' + (c === 1 ? '' : 'er') },
      decimal: ','
    },
    tr: {
      y: 'yıl',
      mo: 'ay',
      w: 'hafta',
      d: 'gün',
      h: 'saat',
      m: 'dakika',
      s: 'saniye',
      ms: 'milisaniye',
      decimal: ','
    },
    vi: {
      y: 'năm',
      mo: 'tháng',
      w: 'tuần',
      d: 'ngày',
      h: 'giờ',
      m: 'phút',
      s: 'giây',
      ms: 'mili giây',
      decimal: ','
    },
    zh_CN: {
      y: '年',
      mo: '个月',
      w: '周',
      d: '天',
      h: '小时',
      m: '分钟',
      s: '秒',
      ms: '毫秒',
      decimal: '.'
    },
    zh_TW: {
      y: '年',
      mo: '個月',
      w: '周',
      d: '天',
      h: '小時',
      m: '分鐘',
      s: '秒',
      ms: '毫秒',
      decimal: '.'
    }
  }

  // You can create a humanizer, which returns a function with default
  // parameters.
  function humanizer (passedOptions) {
    var result = function humanizer (ms, humanizerOptions) {
      var options = extend({}, result, humanizerOptions || {})
      return doHumanization(ms, options)
    }

    return extend(result, {
      language: 'en',
      delimiter: ', ',
      spacer: ' ',
      conjunction: '',
      serialComma: true,
      units: ['y', 'mo', 'w', 'd', 'h', 'm', 's'],
      languages: {},
      round: false,
      unitMeasures: {
        y: 31557600000,
        mo: 2629800000,
        w: 604800000,
        d: 86400000,
        h: 3600000,
        m: 60000,
        s: 1000,
        ms: 1
      }
    }, passedOptions)
  }

  // The main function is just a wrapper around a default humanizer.
  var humanizeDuration = humanizer({})

  // doHumanization does the bulk of the work.
  function doHumanization (ms, options) {
    var i, len, piece

    // Make sure we have a positive number.
    // Has the nice sideffect of turning Number objects into primitives.
    ms = Math.abs(ms)

    var dictionary = options.languages[options.language] || languages[options.language]
    if (!dictionary) {
      throw new Error('No language ' + dictionary + '.')
    }

    var pieces = []

    // Start at the top and keep removing units, bit by bit.
    var unitName, unitMS, unitCount
    for (i = 0, len = options.units.length; i < len; i++) {
      unitName = options.units[i]
      unitMS = options.unitMeasures[unitName]

      // What's the number of full units we can fit?
      if (i + 1 === len) {
        unitCount = ms / unitMS
      } else {
        unitCount = Math.floor(ms / unitMS)
      }

      // Add the string.
      pieces.push({
        unitCount: unitCount,
        unitName: unitName
      })

      // Remove what we just figured out.
      ms -= unitCount * unitMS
    }

    var firstOccupiedUnitIndex = 0
    for (i = 0; i < pieces.length; i++) {
      if (pieces[i].unitCount) {
        firstOccupiedUnitIndex = i
        break
      }
    }

    if (options.round) {
      var ratioToLargerUnit, previousPiece
      for (i = pieces.length - 1; i >= 0; i--) {
        piece = pieces[i]
        piece.unitCount = Math.round(piece.unitCount)

        if (i === 0) { break }

        previousPiece = pieces[i - 1]

        ratioToLargerUnit = options.unitMeasures[previousPiece.unitName] / options.unitMeasures[piece.unitName]
        if ((piece.unitCount % ratioToLargerUnit) === 0 || (options.largest && ((options.largest - 1) < (i - firstOccupiedUnitIndex)))) {
          previousPiece.unitCount += piece.unitCount / ratioToLargerUnit
          piece.unitCount = 0
        }
      }
    }

    var result = []
    for (i = 0, pieces.length; i < len; i++) {
      piece = pieces[i]
      if (piece.unitCount) {
        result.push(render(piece.unitCount, piece.unitName, dictionary, options))
      }

      if (result.length === options.largest) { break }
    }

    if (result.length) {
      if (!options.conjunction || result.length === 1) {
        return result.join(options.delimiter)
      } else if (result.length === 2) {
        return result.join(options.conjunction)
      } else if (result.length > 2) {
        return result.slice(0, -1).join(options.delimiter) + (options.serialComma ? ',' : '') + options.conjunction + result.slice(-1)
      }
    } else {
      return render(0, options.units[options.units.length - 1], dictionary, options)
    }
  }

  function render (count, type, dictionary, options) {
    var decimal
    if (options.decimal === void 0) {
      decimal = dictionary.decimal
    } else {
      decimal = options.decimal
    }

    var countStr = count.toString().replace('.', decimal)

    var dictionaryValue = dictionary[type]
    var word
    if (typeof dictionaryValue === 'function') {
      word = dictionaryValue(count)
    } else {
      word = dictionaryValue
    }

    return countStr + options.spacer + word
  }

  function extend (destination) {
    var source
    for (var i = 1; i < arguments.length; i++) {
      source = arguments[i]
      for (var prop in source) {
        if (source.hasOwnProperty(prop)) {
          destination[prop] = source[prop]
        }
      }
    }
    return destination
  }

  // Internal helper function for Polish language.
  function getPolishForm (c) {
    if (c === 1) {
      return 0
    } else if (Math.floor(c) !== c) {
      return 1
    } else if (c % 10 >= 2 && c % 10 <= 4 && !(c % 100 > 10 && c % 100 < 20)) {
      return 2
    } else {
      return 3
    }
  }

  // Internal helper function for Russian and Ukranian languages.
  function getSlavicForm (c) {
    if (Math.floor(c) !== c) {
      return 2
    } else if ((c % 100 >= 5 && c % 100 <= 20) || (c % 10 >= 5 && c % 10 <= 9) || c % 10 === 0) {
      return 0
    } else if (c % 10 === 1) {
      return 1
    } else if (c > 1) {
      return 2
    } else {
      return 0
    }
  }

  // Internal helper function for Slovak language.
  function getCzechOrSlovakForm (c) {
    if (c === 1) {
      return 0
    } else if (Math.floor(c) !== c) {
      return 1
    } else if (c % 10 >= 2 && c % 10 <= 4 && c % 100 < 10) {
      return 2
    } else {
      return 3
    }
  }

  // Internal helper function for Lithuanian language.
  function getLithuanianForm (c) {
    if (c === 1 || (c % 10 === 1 && c % 100 > 20)) {
      return 0
    } else if (Math.floor(c) !== c || (c % 10 >= 2 && c % 100 > 20) || (c % 10 >= 2 && c % 100 < 10)) {
      return 1
    } else {
      return 2
    }
  }

  humanizeDuration.getSupportedLanguages = function getSupportedLanguages () {
    var result = []
    for (var language in languages) {
      if (languages.hasOwnProperty(language)) {
        result.push(language)
      }
    }
    return result
  }

  humanizeDuration.humanizer = humanizer

  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return humanizeDuration
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module !== 'undefined' && module.exports) {
    module.exports = humanizeDuration
  } else {
    this.humanizeDuration = humanizeDuration
  }
})(); // eslint-disable-line semi


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.Honeybadger = factory());
}(this, function () { 'use strict';

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function builder() {
    var VERSION = '2.0.0',
        NOTIFIER = {
      name: 'honeybadger.js',
      url: 'https://github.com/honeybadger-io/honeybadger-js',
      version: VERSION,
      language: 'javascript'
    }; // Used to control initial setup across clients.

    var loaded = false,
        installed = false; // Used to prevent reporting duplicate errors across instances.

    var currentErr, currentPayload; // Utilities.

    function merge(obj1, obj2) {
      var obj3 = {};

      for (var k in obj1) {
        obj3[k] = obj1[k];
      }

      for (var k in obj2) {
        obj3[k] = obj2[k];
      }

      return obj3;
    }

    function mergeErr(err1, err2) {
      var ret = merge(err1, err2);

      if (err1.context && err2.context) {
        ret.context = merge(err1.context, err2.context);
      }

      return ret;
    }

    function currentErrIs(err) {
      if (!currentErr) {
        return false;
      }

      if (currentErr.name !== err.name) {
        return false;
      }

      if (currentErr.message !== err.message) {
        return false;
      }

      if (currentErr.stack !== err.stack) {
        return false;
      }

      return true;
    }

    function isIgnored(err, patterns) {
      var msg = err.message;

      for (var p in patterns) {
        if (msg.match(patterns[p])) {
          return true;
        }
      }

      return false;
    }

    function cgiData() {
      var data = {};
      data['HTTP_USER_AGENT'] = navigator.userAgent;

      if (document.referrer.match(/\S/)) {
        data['HTTP_REFERER'] = document.referrer;
      }

      return data;
    }

    function encodeCookie(object) {
      if (_typeof(object) !== 'object') {
        return undefined;
      }

      var cookies = [];

      for (var k in object) {
        cookies.push(k + '=' + object[k]);
      }

      return cookies.join(';');
    }

    function stackTrace(err) {
      // From TraceKit: Opera 10 *destroys* its stacktrace property if you try to
      // access the stack property first.
      return err.stacktrace || err.stack || undefined;
    }

    function generateStackTrace(err) {
      var stack;
      var maxStackSize = 10;

      if (err && (stack = stackTrace(err))) {
        return {
          stack: stack,
          generator: undefined
        };
      }

      try {
        throw new Error('');
      } catch (e) {
        if (stack = stackTrace(e)) {
          return {
            stack: stack,
            generator: 'throw'
          };
        }
      }

      stack = ['<call-stack>'];
      var curr = arguments.callee;

      while (curr && stack.length < maxStackSize) {
        if (/function(?:\s+([\w$]+))+\s*\(/.test(curr.toString())) {
          stack.push(RegExp.$1 || '<anonymous>');
        } else {
          stack.push('<anonymous>');
        }

        try {
          curr = curr.caller;
        } catch (e) {
          break;
        }
      }

      return {
        stack: stack.join('\n'),
        generator: 'walk'
      };
    }

    function checkHandlers(handlers, err) {
      var handler, i, len;

      for (i = 0, len = handlers.length; i < len; i++) {
        handler = handlers[i];

        if (handler(err) === false) {
          return true;
        }
      }

      return false;
    }

    function objectIsEmpty(obj) {
      for (var k in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, k)) {
          return false;
        }
      }

      return true;
    }

    function objectIsExtensible(obj) {
      if (typeof Object.isExtensible !== 'function') {
        return true;
      }

      return Object.isExtensible(obj);
    } // Client factory.


    var factory = function factory(opts) {
      var notSingleton = installed;
      var defaultProps = [];
      var queue = [];
      var self = {
        context: {},
        beforeNotifyHandlers: [],
        errorsSent: 0
      };

      if (_typeof(opts) === 'object') {
        for (var k in opts) {
          self[k] = opts[k];
        }
      }

      function log() {
        var console = window.console;

        if (console) {
          var args = Array.prototype.slice.call(arguments);
          args.unshift('[Honeybadger]');
          console.log.apply(console, args);
        }
      }

      function debug() {
        if (config('debug')) {
          return log.apply(this, arguments);
        }
      }

      function config(key, fallback) {
        var value = self[key];

        if (value === undefined) {
          value = self[key.toLowerCase()];
        }

        if (value === 'false') {
          value = false;
        }

        if (value !== undefined) {
          return value;
        }

        return fallback;
      }

      function onErrorEnabled() {
        if (notSingleton) {
          return false;
        }

        return config('onerror', true);
      }

      function onUnhandledRejectionEnabled() {
        if (notSingleton) {
          return false;
        }

        return config('onunhandledrejection', true);
      }

      function baseURL() {
        return 'http' + (config('ssl', true) && 's' || '') + '://' + config('host', 'api.honeybadger.io');
      }

      function canSerialize(obj) {
        // Functions are TMI and Symbols can't convert to strings.
        if (/function|symbol/.test(_typeof(obj))) {
          return false;
        } // No prototype, likely created with `Object.create(null)`.


        if (_typeof(obj) === 'object' && typeof obj.hasOwnProperty === 'undefined') {
          return false;
        }

        return true;
      }

      function serialize(obj, depth) {
        var k, v, ret;
        ret = {};

        if (!depth) {
          depth = 0;
        }

        if (depth >= config('max_depth', 8)) {
          return '[MAX DEPTH REACHED]';
        }

        for (k in obj) {
          v = obj[k];

          if (Object.prototype.hasOwnProperty.call(obj, k) && k != null && v != null) {
            if (!canSerialize(v)) {
              v = Object.prototype.toString.call(v);
            }

            ret[k] = _typeof(v) === 'object' ? serialize(v, depth + 1) : v;
          }
        }

        return ret;
      }

      function request(apiKey, payload) {
        try {
          var x = new XMLHttpRequest();
          x.open('POST', baseURL() + '/v1/notices/js', config('async', true));
          x.setRequestHeader('X-API-Key', apiKey);
          x.setRequestHeader('Content-Type', 'application/json');
          x.setRequestHeader('Accept', 'text/json, application/json');
          x.send(JSON.stringify(serialize(payload)));
        } catch (err) {
          log('Unable to send error report: error while initializing request', err, payload);
        }
      }

      function send(payload) {
        currentErr = currentPayload = null;

        if (config('disabled', false)) {
          debug('Dropping notice: honeybadger.js is disabled', payload);
          return false;
        }

        var apiKey = config('apiKey', config('api_key'));

        if (!apiKey) {
          log('Unable to send error report: no API key has been configured');
          return false;
        }

        if (exceedsMaxErrors()) {
          debug('Dropping notice: max errors exceeded', payload);
          return false;
        }

        incrementErrorsCount();
        request(apiKey, payload);
        return true;
      }

      function notify(err, generated) {
        if (!err) {
          err = {};
        }

        if (Object.prototype.toString.call(err) === '[object Error]') {
          var e = err;
          err = merge(err, {
            name: e.name,
            message: e.message,
            stack: stackTrace(e)
          });
        }

        if (!(_typeof(err) === 'object')) {
          var m = String(err);
          err = {
            message: m
          };
        }

        if (currentErrIs(err)) {
          // Skip the duplicate error.
          return false;
        } else if (currentPayload && loaded) {
          // This is a different error, send the old one now.
          send(currentPayload);
        }

        if (objectIsEmpty(err)) {
          return false;
        }

        var generator;

        if (generated) {
          err.stack = generated.stack;
          generator = generated.generator;
        }

        err = merge(err, {
          name: err.name || 'Error',
          context: merge(self.context, err.context),
          url: err.url || document.URL,
          projectRoot: err.projectRoot || err.project_root || config('projectRoot', config('project_root', window.location.protocol + '//' + window.location.host)),
          environment: err.environment || config('environment'),
          component: err.component || config('component'),
          action: err.action || config('action'),
          revision: err.revision || config('revision')
        });
        var stack_before_handlers = err.stack;

        if (checkHandlers(self.beforeNotifyHandlers, err)) {
          return false;
        }

        if (err.stack != stack_before_handlers) {
          // Stack changed, so it's not generated.
          generator = undefined;
        }

        if (isIgnored(err, config('ignorePatterns'))) {
          return false;
        }

        var data = cgiData();

        if (typeof err.cookies === 'string') {
          data['HTTP_COOKIE'] = err.cookies;
        } else if (_typeof(err.cookies) === 'object') {
          data['HTTP_COOKIE'] = encodeCookie(err.cookies);
        }

        var payload = {
          'notifier': NOTIFIER,
          'error': {
            'class': err.name,
            'message': err.message,
            'backtrace': err.stack,
            'generator': generator,
            'fingerprint': err.fingerprint
          },
          'request': {
            'url': err.url,
            'component': err.component,
            'action': err.action,
            'context': err.context,
            'cgi_data': data,
            'params': err.params
          },
          'server': {
            'project_root': err.projectRoot,
            'environment_name': err.environment,
            'revision': err.revision
          }
        };
        currentPayload = payload;
        currentErr = err;

        if (loaded) {
          debug('Deferring notice', err, payload);
          window.setTimeout(function () {
            if (currentErrIs(err)) {
              send(payload);
            }
          });
        } else {
          debug('Queuing notice', err, payload);
          queue.push(payload);
        }

        return err;
      }

      var preferCatch = true; // IE < 10

      if (!window.atob) {
        preferCatch = false;
      } // See https://developer.mozilla.org/en-US/docs/Web/API/ErrorEvent


      if (window.ErrorEvent) {
        try {
          if (new window.ErrorEvent('').colno === 0) {
            preferCatch = false;
          }
        } catch (_e) {}
      } // wrap always returns the same function so that callbacks can be removed via
      // removeEventListener.


      function wrap(fn, force) {
        try {
          if (typeof fn !== 'function') {
            return fn;
          }

          if (!objectIsExtensible(fn)) {
            return fn;
          }

          if (!fn.___hb) {
            fn.___hb = function () {
              var onerror = onErrorEnabled(); // Don't catch if the browser is old or supports the new error
              // object and there is a window.onerror handler available instead.

              if (preferCatch && (onerror || force) || force && !onerror) {
                try {
                  return fn.apply(this, arguments);
                } catch (e) {
                  notify(e);
                  throw e;
                }
              } else {
                return fn.apply(this, arguments);
              }
            };
          }

          fn.___hb.___hb = fn.___hb;
          return fn.___hb;
        } catch (_e) {
          return fn;
        }
      } // Public API.


      self.notify = function (err, name, extra) {
        if (!err) {
          err = {};
        }

        if (Object.prototype.toString.call(err) === '[object Error]') {
          var e = err;
          err = merge(err, {
            name: e.name,
            message: e.message,
            stack: stackTrace(e)
          });
        }

        if (!(_typeof(err) === 'object')) {
          var m = String(err);
          err = {
            message: m
          };
        }

        if (name && !(_typeof(name) === 'object')) {
          var n = String(name);
          name = {
            name: n
          };
        }

        if (name) {
          err = mergeErr(err, name);
        }

        if (_typeof(extra) === 'object') {
          err = mergeErr(err, extra);
        }

        return notify(err, generateStackTrace(err));
      };

      self.wrap = function (func) {
        return wrap(func, true);
      };

      self.setContext = function (context) {
        if (_typeof(context) === 'object') {
          self.context = merge(self.context, context);
        }

        return self;
      };

      self.resetContext = function (context) {
        if (_typeof(context) === 'object') {
          self.context = merge({}, context);
        } else {
          self.context = {};
        }

        return self;
      };

      self.configure = function (opts) {
        for (var k in opts) {
          self[k] = opts[k];
        }

        return self;
      };

      self.beforeNotify = function (handler) {
        self.beforeNotifyHandlers.push(handler);
        return self;
      };

      var indexOf = [].indexOf || function (item) {
        for (var i = 0, l = this.length; i < l; i++) {
          if (i in this && this[i] === item) return i;
        }

        return -1;
      };

      self.reset = function () {
        self.context = {};
        self.beforeNotifyHandlers = [];

        for (var k in self) {
          if (indexOf.call(defaultProps, k) == -1) {
            self[k] = undefined;
          }
        }

        self.resetMaxErrors();
        return self;
      };

      self.resetMaxErrors = function () {
        return self.errorsSent = 0;
      };

      self.getVersion = function () {
        return VERSION;
      }; // Install instrumentation.
      // This should happen once for the first factory call.


      function instrument(object, name, replacement) {
        if (notSingleton) {
          return;
        }

        if (!object || !name || !replacement) {
          return;
        }

        var original = object[name];
        object[name] = replacement(original);
      }

      var instrumentTimer = function instrumentTimer(original) {
        // See https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setTimeout
        return function (func, delay) {
          if (typeof func === 'function') {
            var args = Array.prototype.slice.call(arguments, 2);
            func = wrap(func);
            return original(function () {
              func.apply(null, args);
            }, delay);
          } else {
            return original(func, delay);
          }
        };
      };

      instrument(window, 'setTimeout', instrumentTimer);
      instrument(window, 'setInterval', instrumentTimer); // Event targets borrowed from bugsnag-js:
      // See https://github.com/bugsnag/bugsnag-js/blob/d55af916a4d3c7757f979d887f9533fe1a04cc93/src/bugsnag.js#L542

      'EventTarget Window Node ApplicationCache AudioTrackList ChannelMergerNode CryptoOperation EventSource FileReader HTMLUnknownElement IDBDatabase IDBRequest IDBTransaction KeyOperation MediaController MessagePort ModalWindow Notification SVGElementInstance Screen TextTrack TextTrackCue TextTrackList WebSocket WebSocketWorker Worker XMLHttpRequest XMLHttpRequestEventTarget XMLHttpRequestUpload'.replace(/\w+/g, function (prop) {
        var prototype = window[prop] && window[prop].prototype;

        if (prototype && prototype.hasOwnProperty && prototype.hasOwnProperty('addEventListener')) {
          instrument(prototype, 'addEventListener', function (original) {
            // See https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
            return function (type, listener, useCapture, wantsUntrusted) {
              try {
                if (listener && listener.handleEvent != null) {
                  listener.handleEvent = wrap(listener.handleEvent);
                }
              } catch (e) {
                // Ignore 'Permission denied to access property "handleEvent"' errors.
                log(e);
              }

              return original.call(this, type, wrap(listener), useCapture, wantsUntrusted);
            };
          });
          instrument(prototype, 'removeEventListener', function (original) {
            return function (type, listener, useCapture, wantsUntrusted) {
              original.call(this, type, listener, useCapture, wantsUntrusted);
              return original.call(this, type, wrap(listener), useCapture, wantsUntrusted);
            };
          });
        }
      });
      instrument(window, 'onerror', function (original) {
        function onerror(msg, url, line, col, err) {
          debug('window.onerror callback invoked', arguments); // Skip if the error is already being sent.

          if (currentErr) {
            return;
          }

          if (!onErrorEnabled()) {
            return;
          }

          if (line === 0 && /Script error\.?/.test(msg)) {
            // See https://developer.mozilla.org/en/docs/Web/API/GlobalEventHandlers/onerror#Notes
            log('Ignoring cross-domain script error: enable CORS to track these types of errors', arguments);
            return;
          } // simulate v8 stack


          var stack = [msg, '\n    at ? (', url || 'unknown', ':', line || 0, ':', col || 0, ')'].join('');

          if (err) {
            var generated = {
              stack: stackTrace(err)
            };

            if (!generated.stack) {
              generated = {
                stack: stack
              };
            }

            notify(err, generated);
            return;
          }

          notify({
            name: 'window.onerror',
            message: msg,
            stack: stack
          });
        } // See https://developer.mozilla.org/en-US/docs/Web/API/GlobalEventHandlers/onerror


        return function (msg, url, line, col, err) {
          onerror(msg, url, line, col, err);

          if (typeof original === 'function' && config('_onerror_call_orig', true)) {
            return original.apply(this, arguments);
          }

          return false;
        };
      });
      instrument(window, 'onunhandledrejection', function (original) {
        // See https://developer.mozilla.org/en-US/docs/Web/API/Window/unhandledrejection_event
        function onunhandledrejection(promiseRejectionEvent) {
          debug('window.onunhandledrejection callback invoked', arguments); // Skip if the error is already being sent.

          if (currentErr) {
            return;
          }

          if (!onUnhandledRejectionEnabled()) {
            return;
          }

          var reason = promiseRejectionEvent.reason;

          if (reason instanceof Error) {
            // simulate v8 stack
            var fileName = reason.fileName || 'unknown';
            var lineNumber = reason.lineNumber || 0;
            var stackFallback = "".concat(reason.message, "\n    at ? (").concat(fileName, ":").concat(lineNumber, ")");
            var stack = stackTrace(reason) || stackFallback;
            notify({
              name: reason.name,
              message: "UnhandledPromiseRejectionWarning: ".concat(reason),
              stack: stack
            });
            return;
          }

          var message = typeof reason === 'string' ? reason : JSON.stringify(reason);
          notify({
            name: 'window.onunhandledrejection',
            message: "UnhandledPromiseRejectionWarning: ".concat(message)
          });
        }

        return function (promiseRejectionEvent) {
          onunhandledrejection(promiseRejectionEvent);

          if (typeof original === 'function') {
            original.apply(this, arguments);
          }
        };
      });

      function incrementErrorsCount() {
        return self.errorsSent++;
      }

      function exceedsMaxErrors() {
        var maxErrors = config('maxErrors');
        return maxErrors && self.errorsSent >= maxErrors;
      } // End of instrumentation.


      installed = true; // Save original state for reset()

      for (var k in self) {
        defaultProps.push(k);
      } // Initialization.


      debug('Initializing honeybadger.js ' + VERSION); // See https://developer.mozilla.org/en-US/docs/Web/API/Document/readyState
      // https://www.w3.org/TR/html5/dom.html#dom-document-readystate
      // The 'loaded' state is for older versions of Safari.

      if (/complete|interactive|loaded/.test(document.readyState)) {
        loaded = true;
        debug('honeybadger.js ' + VERSION + ' ready');
      } else {
        debug('Installing ready handler');

        var domReady = function domReady() {
          loaded = true;
          debug('honeybadger.js ' + VERSION + ' ready');
          var notice;

          while (notice = queue.pop()) {
            send(notice);
          }
        };

        if (document.addEventListener) {
          document.addEventListener('DOMContentLoaded', domReady, true);
        } else {
          window.attachEvent('onload', domReady);
        }
      }

      return self;
    };

    return factory;
  }

  var factory = builder();
  var singleton = factory();
  singleton.factory = factory;

  return singleton;

}));
//# sourceMappingURL=honeybadger.js.map


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export convertVstuiColors */
/* harmony export (immutable) */ __webpack_exports__["a"] = loadTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_merge__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config_themes_vstuibase__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config_themes_vstuibase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_config_themes_vstuibase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_api_redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_api_redux_watson_watson_config_selectors__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_ui_core_vstui_color_extender__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_api_redux_watson_watson_config_action__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_api_analytics_reporting__ = __webpack_require__(14);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function finalizeDefault(){return function(dispatch){dispatch(finalizeVstuiTheme({base:'jrPurple',primary:'red',secondary:'blue',focus:'orange',secondaryStudent:'jrLegacyGold'}));};}function finalizeVstuiTheme(colorMap){return function(dispatch){var colors=convertVstuiColors(colorMap);var data=__WEBPACK_IMPORTED_MODULE_1_merge___default.a.recursive(__WEBPACK_IMPORTED_MODULE_2_config_themes_vstuibase___default.a,{colors:colors});dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_app_api_redux_util_async_helpers__["g" /* createSuccessAction */])(__WEBPACK_IMPORTED_MODULE_6_app_api_redux_watson_watson_config_action__["c" /* THEME_KEY */],data));};}function finalizeTheme(data){return function(dispatch){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_app_api_redux_util_async_helpers__["g" /* createSuccessAction */])(__WEBPACK_IMPORTED_MODULE_6_app_api_redux_watson_watson_config_action__["c" /* THEME_KEY */],data));};}/**
 * @param config e.g. { primary: "magic", secondary: "cheddar", ...}
 * @return eg. { "vstui-primary-1": "#ff0000", ... }
 */function convertVstuiColors(config){var result={};Object.keys(config).forEach(function(k){for(var i=1;i<=10;i++){if(config[k]){result[buildKey(k,i)]=__WEBPACK_IMPORTED_MODULE_5_app_ui_core_vstui_color_extender__["a" /* default */][config[k]].getShade(i);}}});return result;}function buildKey(id,index){return'vstui-'+id+'-'+index;}function loadTheme(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch,getState){var brandData,mode,name,data,vstuiChoices;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_app_api_redux_util_async_helpers__["f" /* createStartAction */])(__WEBPACK_IMPORTED_MODULE_6_app_api_redux_watson_watson_config_action__["c" /* THEME_KEY */]));if(!Object(__WEBPACK_IMPORTED_MODULE_4_app_api_redux_watson_watson_config_selectors__["A" /* hasBrandError */])(getState())){_context.next=3;break;}return _context.abrupt('return',dispatch(finalizeDefault()));case 3:brandData=Object(__WEBPACK_IMPORTED_MODULE_4_app_api_redux_watson_watson_config_selectors__["e" /* getBrand */])(getState());mode=brandData.common.colors.mode;_context.prev=5;if(!(mode==='custom')){_context.next=14;break;}name=brandData.common.colors.custom.name;_context.next=10;return __webpack_require__(457)("./"+name+'.json');case 10:data=_context.sent;return _context.abrupt('return',dispatch(finalizeTheme(data)));case 14:if(!(mode==='vstui')){_context.next=19;break;}vstuiChoices=brandData.common.colors.vstui;return _context.abrupt('return',dispatch(finalizeVstuiTheme(Object.assign({},vstuiChoices,{secondaryStudent:vstuiChoices.secondary}))));case 19:return _context.abrupt('return',dispatch(finalizeDefault()));case 20:_context.next=25;break;case 22:_context.prev=22;_context.t0=_context['catch'](5);Object(__WEBPACK_IMPORTED_MODULE_7_app_api_analytics_reporting__["b" /* noticeError */])(_context.t0);case 25:return _context.abrupt('return',dispatch(finalizeDefault()));case 26:case'end':return _context.stop();}}},_callee,this,[[5,22]]);}));return function(_x,_x2){return _ref.apply(this,arguments);};}();}

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chameleonjs__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chameleonjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chameleonjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vitalsource_vstui_colors_createColorPalette__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vitalsource_vstui_colors_createColorPalette___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__vitalsource_vstui_colors_createColorPalette__);
/**
 * We need to keep this for app parity for now
 */var jrLegacyGold=__WEBPACK_IMPORTED_MODULE_1__vitalsource_vstui_colors_createColorPalette___default()([null,'#FFF2D3','#FFE29C','#FFD560','#FFCC33','#E8B520','#BE8A0D','#9A6F07','#855F07','#715005','#5A4206']);var vstuiColors=Object.assign({},__WEBPACK_IMPORTED_MODULE_0_chameleonjs__["colors"],{jrLegacyGold:jrLegacyGold});/* harmony default export */ __webpack_exports__["a"] = (vstuiColors);

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var rgb = __webpack_require__(446)
var wcag = __webpack_require__(447)
var isBlank = __webpack_require__(450)
var isNamedCssColor = __webpack_require__(453)
var cssColorNames = __webpack_require__(456)

module.exports.ratio = ratio
module.exports.score = score
module.exports.isAccessible = isAccessible
module.exports.isNotTransparent = isNotTransparent

function ratio(colorOne, colorTwo, options) {
  colorOne = getRgbTriplet(colorOne, options)
  colorTwo = getRgbTriplet(colorTwo, options)

  return wcag.rgb(colorOne, colorTwo)
}

function score(colorOne, colorTwo, options) {
  var wcagScore = wcag.score(ratio(colorOne, colorTwo, options))

  if (isBlank(wcagScore)) {
    return 'F'
  } else {
    return wcagScore
  }
}

function isAccessible(colorOne, colorTwo, options) {
  return ratio(colorOne, colorTwo, options) > 4.5
}

function getRgbTriplet(color, options) {
  if (typeof color !== 'string') {
    throw new TypeError('get-contrast expects colors as strings')
  }

  if (isNamedCssColor(color)) {
    color = cssColorNames[color]
  }

  color = isNotTransparent(color, options)
  return color.match(/\((.*)\)/)[1].split(',').slice(0, 3)
}

function isNotTransparent(color, options) {
  options = options || {}

  // Convert to RGB.
  color = rgb(color)
  // Check if the rgb returned color is rgba and if the 'a' value is 0.
  var cArray = color.match(/\((.*)\)/)[1].split(',')
  if (cArray.length == 4 && cArray[3] == '0' && !options.ignoreAlpha) {
    throw new TypeError('get-contrast cannot contrast transparent colors')
  } else {
    return color
  }
}


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
color
*/

var colors = {
    maroon      : "#800000",
    red         : "#ff0000",
    orange      : "#ffA500",
    yellow      : "#ffff00",
    olive       : "#808000",
    purple      : "#800080",
    fuchsia     : "#ff00ff",
    white       : "#ffffff",
    lime        : "#00ff00",
    green       : "#008000",
    navy        : "#000080",
    blue        : "#0000ff",
    aqua        : "#00ffff",
    teal        : "#008080",
    black       : "#000000",
    silver      : "#c0c0c0",
    gray        : "#808080",
    transparent : "#0000"
}

var RGBtoRGB = function(r, g, b, a){
    if (a == null || a === "") a = 1
    r = parseFloat(r)
    g = parseFloat(g)
    b = parseFloat(b)
    a = parseFloat(a)
    if (!(r <= 255 && r >= 0 && g <= 255 && g >= 0 && b <= 255 && b >= 0 && a <= 1 && a >= 0)) return null

    return [Math.round(r), Math.round(g), Math.round(b), a]
}

var HEXtoRGB = function(hex){
    if (hex.length === 3) hex += "f"
    if (hex.length === 4){
        var h0 = hex.charAt(0),
            h1 = hex.charAt(1),
            h2 = hex.charAt(2),
            h3 = hex.charAt(3)

        hex = h0 + h0 + h1 + h1 + h2 + h2 + h3 + h3
    }
    if (hex.length === 6) hex += "ff"
    var rgb = []
    for (var i = 0, l = hex.length; i < l; i += 2) rgb.push(parseInt(hex.substr(i, 2), 16) / (i === 6 ? 255 : 1))
    return rgb
}

// HSL to RGB conversion from:
// http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript
// thank you!

var HUEtoRGB = function(p, q, t){
    if (t < 0) t += 1
    if (t > 1) t -= 1
    if (t < 1 / 6) return p + (q - p) * 6 * t
    if (t < 1 / 2) return q
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6
    return p
}

var HSLtoRGB = function(h, s, l, a){
    var r, b, g
    if (a == null || a === "") a = 1
    h = parseFloat(h) / 360
    s = parseFloat(s) / 100
    l = parseFloat(l) / 100
    a = parseFloat(a) / 1
    if (h > 1 || h < 0 || s > 1 || s < 0 || l > 1 || l < 0 || a > 1 || a < 0) return null
    if (s === 0){
        r = b = g = l
    } else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s
        var p = 2 * l - q
        r = HUEtoRGB(p, q, h + 1 / 3)
        g = HUEtoRGB(p, q, h)
        b = HUEtoRGB(p, q, h - 1 / 3)
    }
    return [r * 255, g * 255, b * 255, a]
}

var keys = []
for (var c in colors) keys.push(c)

var shex  = "(?:#([a-f0-9]{3,8}))",
    sval  = "\\s*([.\\d%]+)\\s*",
    sop   = "(?:,\\s*([.\\d]+)\\s*)?",
    slist = "\\(" + [sval, sval, sval] + sop + "\\)",
    srgb  = "(?:rgb)a?",
    shsl  = "(?:hsl)a?",
    skeys = "(" + keys.join("|") + ")"


var xhex   = RegExp(shex, "i"),
    xrgb   = RegExp(srgb + slist, "i"),
    xhsl   = RegExp(shsl + slist, "i")

var color = function(input, array){
    if (input == null) return null
    input = (input + "").replace(/\s+/, "")

    var match = colors[input]
    if (match){
        return color(match, array)
    } else if (match = input.match(xhex)){
        input = HEXtoRGB(match[1])
    } else if (match = input.match(xrgb)){
        input = match.slice(1)
    } else if (match = input.match(xhsl)){
        input = HSLtoRGB.apply(null, match.slice(1))
    } else return null

    if (!(input && (input = RGBtoRGB.apply(null, input)))) return null
    if (array) return input
    if (input[3] === 1) input.splice(3, 1)
    return "rgb" + (input.length === 4 ? "a" : "") + "(" + input + ")"
}

var regexp = RegExp([skeys, shex, srgb + slist, shsl + slist].join("|"), "gi")

color.replace = function(string, method){
    if (!method) method = function(match){
        return color(match)
    }
    return (string + "").replace(regexp, method)
}

color.matches = function(string){
    return !!(string + "").match(regexp)
}

module.exports = color


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var luminance = __webpack_require__(448);
var hexRgb = __webpack_require__(449);

// http://www.w3.org/TR/WCAG20/#contrast-ratiodef

module.exports.luminance = fromLum;
module.exports.rgb = fromRGB;
module.exports.hex = fromHex;
module.exports.score = score;

/*
 * @param {number} a luminance value
 * @param {number} b luminance value
 * @returns {number} contrast ratio
 */
function fromLum(a, b) {
    var l1 = Math.max(a, b),
        l2 = Math.min(a, b);
    return (l1 + 0.05) / (l2 + 0.05);
}

/*
 * @param {array} a rgb value
 * @param {array} b rgb value
 * @returns {number} contrast ratio
 */
function fromRGB(a, b) {
    return fromLum(luminance(a), luminance(b));
}

/*
 * @param {string} a hex value
 * @param {string} b hex value
 * @returns {number} contrast ratio
 */
function fromHex(a, b) {
    return fromRGB(hexRgb(a), hexRgb(b));
}

/*
 * @param {array} a rgb value
 * @param {array} b rgb value
 * @returns {number} contrast ratio
 */
function score(contrast) {
    return (contrast >= 7) ? 'AAA' : (contrast >= 4.5) ? 'AA' : '';
}


/***/ }),
/* 448 */
/***/ (function(module, exports) {

// # Relative luminance
//
// http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
// https://en.wikipedia.org/wiki/Luminance_(relative)
// https://en.wikipedia.org/wiki/Luminosity_function
// https://en.wikipedia.org/wiki/Rec._709#Luma_coefficients

// red, green, and blue coefficients
var rc = 0.2126,
    gc = 0.7152,
    bc = 0.0722,
    // low-gamma adjust coefficient
    lowc = 1 / 12.92;

function adjustGamma(_) {
    return Math.pow((_ + 0.055) / 1.055, 2.4);
}

module.exports = function(rgb) {
    var rsrgb = rgb[0] / 255,
        gsrgb = rgb[1] / 255,
        bsrgb = rgb[2] / 255;

    var r = (rsrgb <= 0.03928) ? (rsrgb * lowc) : adjustGamma(rsrgb),
        g = (gsrgb <= 0.03928) ? (gsrgb * lowc) : adjustGamma(gsrgb),
        b = (bsrgb <= 0.03928) ? (bsrgb * lowc) : adjustGamma(bsrgb);

    return r * rc + g * gc + b * bc;
};


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (hex) {
	if (typeof hex !== 'string') {
		throw new TypeError('Expected a string');
	}

	hex = hex.replace(/^#/, '');

	if (hex.length === 3) {
		hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
	}

	var num = parseInt(hex, 16);

	return [num >> 16, num >> 8 & 255, num & 255];
};


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var isEmpty = __webpack_require__(451)
var isWhitespace = __webpack_require__(452)

module.exports = function isBlank (object) {
  if (typeof object === 'boolean') {
    return false
  }

  if (typeof object === 'string' && object.length) {
    return isWhitespace(object)
  } else {
    return isEmpty(object)
  }
}


/***/ }),
/* 451 */
/***/ (function(module, exports) {


/**
 * Expose `isEmpty`.
 */

module.exports = isEmpty;


/**
 * Has.
 */

var has = Object.prototype.hasOwnProperty;


/**
 * Test whether a value is "empty".
 *
 * @param {Mixed} val
 * @return {Boolean}
 */

function isEmpty (val) {
  if (null == val) return true;
  if ('number' == typeof val) return 0 === val;
  if (undefined !== val.length) return 0 === val.length;
  for (var key in val) if (has.call(val, key)) return false;
  return true;
}

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * is-whitespace <https://github.com/jonschlinkert/is-whitespace>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */



var cache;

module.exports = function isWhitespace(str) {
  return (typeof str === 'string') && regex().test(str);
};

function regex() {
  // ensure that runtime compilation only happens once
  return cache || (cache = new RegExp('^[\\s\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF"]+$'));
}


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cssColors = __webpack_require__(454)

module.exports = function isNamedCssColor (color) {
  if (typeof color !== 'string') {
    throw new TypeError('is-named-css-color expects a string')
  }

  var cssColorRegex = new RegExp('^' + cssColors().join('|') + '$', 'i')
  return cssColorRegex.test(color)
}


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cssColorNames = __webpack_require__(455);

module.exports = function cssColorList() {
  return Object.keys(cssColorNames);
}


/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports = {"aqua":"#00ffff","aliceblue":"#f0f8ff","antiquewhite":"#faebd7","black":"#000000","blue":"#0000ff","cyan":"#00ffff","darkblue":"#00008b","darkcyan":"#008b8b","darkgreen":"#006400","darkturquoise":"#00ced1","deepskyblue":"#00bfff","green":"#008000","lime":"#00ff00","mediumblue":"#0000cd","mediumspringgreen":"#00fa9a","navy":"#000080","springgreen":"#00ff7f","teal":"#008080","midnightblue":"#191970","dodgerblue":"#1e90ff","lightseagreen":"#20b2aa","forestgreen":"#228b22","seagreen":"#2e8b57","darkslategray":"#2f4f4f","darkslategrey":"#2f4f4f","limegreen":"#32cd32","mediumseagreen":"#3cb371","turquoise":"#40e0d0","royalblue":"#4169e1","steelblue":"#4682b4","darkslateblue":"#483d8b","mediumturquoise":"#48d1cc","indigo":"#4b0082","darkolivegreen":"#556b2f","cadetblue":"#5f9ea0","cornflowerblue":"#6495ed","mediumaquamarine":"#66cdaa","dimgray":"#696969","dimgrey":"#696969","slateblue":"#6a5acd","olivedrab":"#6b8e23","slategray":"#708090","slategrey":"#708090","lightslategray":"#778899","lightslategrey":"#778899","mediumslateblue":"#7b68ee","lawngreen":"#7cfc00","aquamarine":"#7fffd4","chartreuse":"#7fff00","gray":"#808080","grey":"#808080","maroon":"#800000","olive":"#808000","purple":"#800080","lightskyblue":"#87cefa","skyblue":"#87ceeb","blueviolet":"#8a2be2","darkmagenta":"#8b008b","darkred":"#8b0000","saddlebrown":"#8b4513","darkseagreen":"#8fbc8f","lightgreen":"#90ee90","mediumpurple":"#9370db","darkviolet":"#9400d3","palegreen":"#98fb98","darkorchid":"#9932cc","yellowgreen":"#9acd32","sienna":"#a0522d","brown":"#a52a2a","darkgray":"#a9a9a9","darkgrey":"#a9a9a9","greenyellow":"#adff2f","lightblue":"#add8e6","paleturquoise":"#afeeee","lightsteelblue":"#b0c4de","powderblue":"#b0e0e6","firebrick":"#b22222","darkgoldenrod":"#b8860b","mediumorchid":"#ba55d3","rosybrown":"#bc8f8f","darkkhaki":"#bdb76b","silver":"#c0c0c0","mediumvioletred":"#c71585","indianred":"#cd5c5c","peru":"#cd853f","chocolate":"#d2691e","tan":"#d2b48c","lightgray":"#d3d3d3","lightgrey":"#d3d3d3","thistle":"#d8bfd8","goldenrod":"#daa520","orchid":"#da70d6","palevioletred":"#db7093","crimson":"#dc143c","gainsboro":"#dcdcdc","plum":"#dda0dd","burlywood":"#deb887","lightcyan":"#e0ffff","lavender":"#e6e6fa","darksalmon":"#e9967a","palegoldenrod":"#eee8aa","violet":"#ee82ee","azure":"#f0ffff","honeydew":"#f0fff0","khaki":"#f0e68c","lightcoral":"#f08080","sandybrown":"#f4a460","beige":"#f5f5dc","mintcream":"#f5fffa","wheat":"#f5deb3","whitesmoke":"#f5f5f5","ghostwhite":"#f8f8ff","lightgoldenrodyellow":"#fafad2","linen":"#faf0e6","salmon":"#fa8072","oldlace":"#fdf5e6","bisque":"#ffe4c4","blanchedalmond":"#ffebcd","coral":"#ff7f50","cornsilk":"#fff8dc","darkorange":"#ff8c00","deeppink":"#ff1493","floralwhite":"#fffaf0","fuchsia":"#ff00ff","gold":"#ffd700","hotpink":"#ff69b4","ivory":"#fffff0","lavenderblush":"#fff0f5","lemonchiffon":"#fffacd","lightpink":"#ffb6c1","lightsalmon":"#ffa07a","lightyellow":"#ffffe0","magenta":"#ff00ff","mistyrose":"#ffe4e1","moccasin":"#ffe4b5","navajowhite":"#ffdead","orange":"#ffa500","orangered":"#ff4500","papayawhip":"#ffefd5","peachpuff":"#ffdab9","pink":"#ffc0cb","red":"#ff0000","seashell":"#fff5ee","snow":"#fffafa","tomato":"#ff6347","white":"#ffffff","yellow":"#ffff00","rebeccapurple":"#663399"}

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports = {"aliceblue":"#f0f8ff","antiquewhite":"#faebd7","aqua":"#00ffff","aquamarine":"#7fffd4","azure":"#f0ffff","beige":"#f5f5dc","bisque":"#ffe4c4","black":"#000000","blanchedalmond":"#ffebcd","blue":"#0000ff","blueviolet":"#8a2be2","brown":"#a52a2a","burlywood":"#deb887","cadetblue":"#5f9ea0","chartreuse":"#7fff00","chocolate":"#d2691e","coral":"#ff7f50","cornflowerblue":"#6495ed","cornsilk":"#fff8dc","crimson":"#dc143c","cyan":"#00ffff","darkblue":"#00008b","darkcyan":"#008b8b","darkgoldenrod":"#b8860b","darkgray":"#a9a9a9","darkgreen":"#006400","darkgrey":"#a9a9a9","darkkhaki":"#bdb76b","darkmagenta":"#8b008b","darkolivegreen":"#556b2f","darkorange":"#ff8c00","darkorchid":"#9932cc","darkred":"#8b0000","darksalmon":"#e9967a","darkseagreen":"#8fbc8f","darkslateblue":"#483d8b","darkslategray":"#2f4f4f","darkslategrey":"#2f4f4f","darkturquoise":"#00ced1","darkviolet":"#9400d3","deeppink":"#ff1493","deepskyblue":"#00bfff","dimgray":"#696969","dimgrey":"#696969","dodgerblue":"#1e90ff","firebrick":"#b22222","floralwhite":"#fffaf0","forestgreen":"#228b22","fuchsia":"#ff00ff","gainsboro":"#dcdcdc","ghostwhite":"#f8f8ff","gold":"#ffd700","goldenrod":"#daa520","gray":"#808080","green":"#008000","greenyellow":"#adff2f","grey":"#808080","honeydew":"#f0fff0","hotpink":"#ff69b4","indianred":"#cd5c5c","indigo":"#4b0082","ivory":"#fffff0","khaki":"#f0e68c","lavender":"#e6e6fa","lavenderblush":"#fff0f5","lawngreen":"#7cfc00","lemonchiffon":"#fffacd","lightblue":"#add8e6","lightcoral":"#f08080","lightcyan":"#e0ffff","lightgoldenrodyellow":"#fafad2","lightgray":"#d3d3d3","lightgreen":"#90ee90","lightgrey":"#d3d3d3","lightpink":"#ffb6c1","lightsalmon":"#ffa07a","lightseagreen":"#20b2aa","lightskyblue":"#87cefa","lightslategray":"#778899","lightslategrey":"#778899","lightsteelblue":"#b0c4de","lightyellow":"#ffffe0","lime":"#00ff00","limegreen":"#32cd32","linen":"#faf0e6","magenta":"#ff00ff","maroon":"#800000","mediumaquamarine":"#66cdaa","mediumblue":"#0000cd","mediumorchid":"#ba55d3","mediumpurple":"#9370db","mediumseagreen":"#3cb371","mediumslateblue":"#7b68ee","mediumspringgreen":"#00fa9a","mediumturquoise":"#48d1cc","mediumvioletred":"#c71585","midnightblue":"#191970","mintcream":"#f5fffa","mistyrose":"#ffe4e1","moccasin":"#ffe4b5","navajowhite":"#ffdead","navy":"#000080","oldlace":"#fdf5e6","olive":"#808000","olivedrab":"#6b8e23","orange":"#ffa500","orangered":"#ff4500","orchid":"#da70d6","palegoldenrod":"#eee8aa","palegreen":"#98fb98","paleturquoise":"#afeeee","palevioletred":"#db7093","papayawhip":"#ffefd5","peachpuff":"#ffdab9","peru":"#cd853f","pink":"#ffc0cb","plum":"#dda0dd","powderblue":"#b0e0e6","purple":"#800080","rebeccapurple":"#663399","red":"#ff0000","rosybrown":"#bc8f8f","royalblue":"#4169e1","saddlebrown":"#8b4513","salmon":"#fa8072","sandybrown":"#f4a460","seagreen":"#2e8b57","seashell":"#fff5ee","sienna":"#a0522d","silver":"#c0c0c0","skyblue":"#87ceeb","slateblue":"#6a5acd","slategray":"#708090","slategrey":"#708090","snow":"#fffafa","springgreen":"#00ff7f","steelblue":"#4682b4","tan":"#d2b48c","teal":"#008080","thistle":"#d8bfd8","tomato":"#ff6347","turquoise":"#40e0d0","violet":"#ee82ee","wheat":"#f5deb3","white":"#ffffff","whitesmoke":"#f5f5f5","yellow":"#ffff00","yellowgreen":"#9acd32"}

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./veoyleo.json": [
		742,
		145
	],
	"./vstuibase.json": [
		141
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 457;
module.exports = webpackAsyncContext;

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__route_PrivateRoute__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_home_HomePage__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_reader_ReaderPage__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_ui_core_common_withLoading__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteTransition__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_redux_bridge_session_selectors__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_ui_route_RedirectOnce__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__route_DevRoute__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__route_SimpleRoute__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__route_CookieRoute__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__route_TeacherRoute__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_browser__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__route_TokenRoute__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_login__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__api_redux_watson_watson_config_selectors__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_app_ui_pages_redirect_LoginRedirect__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_app_ui_pages_error_SystemError__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_app_ui_pages_redirect_ForwardToBookshelf__ = __webpack_require__(656);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Load the system error outright so we can show it even if something blows up with code splitting
var CookieError=Object(__WEBPACK_IMPORTED_MODULE_6_app_ui_core_common_withLoading__["a" /* default */])(function(){return __webpack_require__.e/* import() */(135).then(__webpack_require__.bind(null, 765));});var BookNotFound=Object(__WEBPACK_IMPORTED_MODULE_6_app_ui_core_common_withLoading__["a" /* default */])(function(){return __webpack_require__.e/* import() */(141).then(__webpack_require__.bind(null, 766));});var BookAccessDenied=Object(__WEBPACK_IMPORTED_MODULE_6_app_ui_core_common_withLoading__["a" /* default */])(function(){return __webpack_require__.e/* import() */(144).then(__webpack_require__.bind(null, 767));});var FileNotFound=Object(__WEBPACK_IMPORTED_MODULE_6_app_ui_core_common_withLoading__["a" /* default */])(function(){return __webpack_require__.e/* import() */(140).then(__webpack_require__.bind(null, 768));});var NoGroups=Object(__WEBPACK_IMPORTED_MODULE_6_app_ui_core_common_withLoading__["a" /* default */])(function(){return __webpack_require__.e/* import() */(143).then(__webpack_require__.bind(null, 769));});var AdminPage=Object(__WEBPACK_IMPORTED_MODULE_6_app_ui_core_common_withLoading__["a" /* default */])(function(){return __webpack_require__.e/* import() */(130).then(__webpack_require__.bind(null, 770));});var WebView=Object(__WEBPACK_IMPORTED_MODULE_6_app_ui_core_common_withLoading__["a" /* default */])(function(){return __webpack_require__.e/* import() */(128).then(__webpack_require__.bind(null, 771));});var ThemeViewer=Object(__WEBPACK_IMPORTED_MODULE_6_app_ui_core_common_withLoading__["a" /* default */])(function(){return __webpack_require__.e/* import() */(137).then(__webpack_require__.bind(null, 772));});var BrandViewer=Object(__WEBPACK_IMPORTED_MODULE_6_app_ui_core_common_withLoading__["a" /* default */])(function(){return __webpack_require__.e/* import() */(139).then(__webpack_require__.bind(null, 773));});var LocaleViewer=Object(__WEBPACK_IMPORTED_MODULE_6_app_ui_core_common_withLoading__["a" /* default */])(function(){return __webpack_require__.e/* import() */(138).then(__webpack_require__.bind(null, 774));});var RedirectPage=Object(__WEBPACK_IMPORTED_MODULE_6_app_ui_core_common_withLoading__["a" /* default */])(function(){return __webpack_require__.e/* import() */(136).then(__webpack_require__.bind(null, 775));});var BookshelfReaderRedirectPage=Object(__WEBPACK_IMPORTED_MODULE_6_app_ui_core_common_withLoading__["a" /* default */])(function(){return __webpack_require__.e/* import() */(158).then(__webpack_require__.bind(null, 776));});var AssignmentCreatorRedirect=Object(__WEBPACK_IMPORTED_MODULE_6_app_ui_core_common_withLoading__["a" /* default */])(function(){return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 143));});var JigsawLibrary=Object(__WEBPACK_IMPORTED_MODULE_6_app_ui_core_common_withLoading__["a" /* default */])(function(){return __webpack_require__.e/* import() */(142).then(__webpack_require__.bind(null, 777));});var Pages=function(_React$Component){_inherits(Pages,_React$Component);function Pages(){_classCallCheck(this,Pages);return _possibleConstructorReturn(this,(Pages.__proto__||Object.getPrototypeOf(Pages)).apply(this,arguments));}_createClass(Pages,[{key:'render',value:function render(){var _this2=this;var switchStatement=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* Switch */],{location:this.props.location},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__route_CookieRoute__["a" /* default */],{bridgeRequired:true,path:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["I" /* LOGIN */],exact:true,component:__WEBPACK_IMPORTED_MODULE_17__pages_login__["StudentLoginPage"]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__route_CookieRoute__["a" /* default */],{bridgeRequired:true,path:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["K" /* LOGIN_TEACHER */],exact:true,component:__WEBPACK_IMPORTED_MODULE_17__pages_login__["TeacherLoginPage"]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__route_CookieRoute__["a" /* default */],{path:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["S" /* RESET_PASSWORD */],exact:true,component:__WEBPACK_IMPORTED_MODULE_17__pages_login__["ResetPassword"]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__route_CookieRoute__["a" /* default */],{path:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["y" /* CREATE_ACCOUNT */],exact:true,component:__WEBPACK_IMPORTED_MODULE_17__pages_login__["CreateAccount"]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__route_TokenRoute__["a" /* default */],{path:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["w" /* COMPLETE_ACCOUNT */],exact:true,component:__WEBPACK_IMPORTED_MODULE_17__pages_login__["CompleteAccount"]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__route_TokenRoute__["a" /* default */],{path:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["U" /* UPDATE_PASSWORD */],exact:true,component:__WEBPACK_IMPORTED_MODULE_17__pages_login__["UpdatePassword"]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__route_SimpleRoute__["a" /* default */],{path:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["x" /* COOKIE_ERROR */],exact:true,component:CookieError}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__route_SimpleRoute__["a" /* default */],{path:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["q" /* BOOK_NOT_FOUND */],exact:true,component:BookNotFound}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__route_SimpleRoute__["a" /* default */],{path:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["T" /* SYSTEM_ERROR */],exact:true,component:__WEBPACK_IMPORTED_MODULE_20_app_ui_pages_error_SystemError__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__route_SimpleRoute__["a" /* default */],{path:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["G" /* FILE_NOT_FOUND */],exact:true,component:FileNotFound}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__route_SimpleRoute__["a" /* default */],{path:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["M" /* NO_GROUPS */],exact:true,component:NoGroups}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__route_SimpleRoute__["a" /* default */],{path:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["p" /* BOOK_ACCESS_DENIED */],exact:true,component:BookAccessDenied}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__route_PrivateRoute__["a" /* default */],{path:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["H" /* HOME */],component:__WEBPACK_IMPORTED_MODULE_4__pages_home_HomePage__["b" /* default */],bridgeRequired:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__route_SimpleRoute__["a" /* default */],{path:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["Q" /* REDIRECT */],exact:true,component:RedirectPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__route_SimpleRoute__["a" /* default */],{path:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["n" /* BOOKSHELF_READER_REDIRECT */],exact:true,component:BookshelfReaderRedirectPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__route_SimpleRoute__["a" /* default */],{path:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["l" /* ASSIGNMENT_CREATOR */],exact:true,component:AssignmentCreatorRedirect}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__route_PrivateRoute__["a" /* default */],{path:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["O" /* READER */],component:__WEBPACK_IMPORTED_MODULE_5__pages_reader_ReaderPage__["b" /* default */]}),this.props.hasTeacherPortal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__route_TeacherRoute__["a" /* default */],{path:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["b" /* ADMIN */],component:AdminPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__route_DevRoute__["a" /* default */],{path:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["E" /* DEV_THEME */],exact:true,component:ThemeViewer}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__route_DevRoute__["a" /* default */],{path:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["B" /* DEV_BRAND */],exact:true,component:BrandViewer}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__route_DevRoute__["a" /* default */],{path:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["D" /* DEV_LOCALE */],exact:true,component:LocaleViewer}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__route_DevRoute__["a" /* default */],{path:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["C" /* DEV_JIGSAW_LIBRARY */],exact:true,component:JigsawLibrary}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__route_SimpleRoute__["a" /* default */],{path:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["V" /* WEBVIEW */],component:WebView}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__route_SimpleRoute__["a" /* default */],{path:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["J" /* LOGIN_REDIRECT */],component:__WEBPACK_IMPORTED_MODULE_19_app_ui_pages_redirect_LoginRedirect__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__route_SimpleRoute__["a" /* default */],{path:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["A" /* DEFAULT */],exact:true,render:function render(){if(_this2.props.teacher&&_this2.props.hasTeacherPortal){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_ui_route_RedirectOnce__["a" /* default */],{to:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["b" /* ADMIN */]});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_ui_route_RedirectOnce__["a" /* default */],{to:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["H" /* HOME */]});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__route_PrivateRoute__["a" /* default */],{path:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["z" /* DECIDE */],component:__WEBPACK_IMPORTED_MODULE_21_app_ui_pages_redirect_ForwardToBookshelf__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_app_ui_route_RedirectOnce__["a" /* default */],{to:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_route_routes__["G" /* FILE_NOT_FOUND */]}));if(Object(__WEBPACK_IMPORTED_MODULE_15__utils_browser__["c" /* isIENotEdge */])()){return switchStatement;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__RouteTransition__["b" /* default */],{location:this.props.location},switchStatement);}}]);return Pages;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){return{teacher:Object(__WEBPACK_IMPORTED_MODULE_8__api_redux_bridge_session_selectors__["i" /* isTeacher */])(state),hasTeacherPortal:Object(__WEBPACK_IMPORTED_MODULE_18__api_redux_watson_watson_config_selectors__["F" /* isTeacherPortalEnabled */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["h" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_14_react_redux__["b" /* connect */])(mapStateToProps)(Pages)));

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);

var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];

function isWebpackReady(getModuleIds) {
  if (( false ? "undefined" : _typeof(__webpack_require__.m)) !== "object") {
    return false;
  }

  return getModuleIds().every(function (moduleId) {
    return typeof moduleId !== "undefined" && typeof __webpack_require__.m[moduleId] !== "undefined";
  });
}

function load(loader) {
  var promise = loader();

  var state = {
    loading: true,
    loaded: null,
    error: null
  };

  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  }).catch(function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });

  return state;
}

function loadMap(obj) {
  var state = {
    loading: false,
    loaded: {},
    error: null
  };

  var promises = [];

  try {
    Object.keys(obj).forEach(function (key) {
      var result = load(obj[key]);

      if (!result.loading) {
        state.loaded[key] = result.loaded;
        state.error = result.error;
      } else {
        state.loading = true;
      }

      promises.push(result.promise);

      result.promise.then(function (res) {
        state.loaded[key] = res;
      }).catch(function (err) {
        state.error = err;
      });
    });
  } catch (err) {
    state.error = err;
  }

  state.promise = Promise.all(promises).then(function (res) {
    state.loading = false;
    return res;
  }).catch(function (err) {
    state.loading = false;
    throw err;
  });

  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj.default : obj;
}

function render(loaded, props) {
  return React.createElement(resolve(loaded), props);
}

function createLoadableComponent(loadFn, options) {
  var _class, _temp;

  if (!options.loading) {
    throw new Error("react-loadable requires a `loading` component");
  }

  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    render: render,
    webpack: null,
    modules: null
  }, options);

  var res = null;

  function init() {
    if (!res) {
      res = loadFn(opts.loader);
    }
    return res.promise;
  }

  ALL_INITIALIZERS.push(init);

  if (typeof opts.webpack === "function") {
    READY_INITIALIZERS.push(function () {
      if (isWebpackReady(opts.webpack)) {
        return init();
      }
    });
  }

  return _temp = _class = function (_React$Component) {
    _inherits(LoadableComponent, _React$Component);

    function LoadableComponent(props) {
      _classCallCheck(this, LoadableComponent);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

      _this.retry = function () {
        _this.setState({ error: null, loading: true, timedOut: false });
        res = loadFn(opts.loader);
        _this._loadModule();
      };

      init();

      _this.state = {
        error: res.error,
        pastDelay: false,
        timedOut: false,
        loading: res.loading,
        loaded: res.loaded
      };
      return _this;
    }

    LoadableComponent.preload = function preload() {
      return init();
    };

    LoadableComponent.prototype.componentWillMount = function componentWillMount() {
      this._mounted = true;
      this._loadModule();
    };

    LoadableComponent.prototype._loadModule = function _loadModule() {
      var _this2 = this;

      if (this.context.loadable && Array.isArray(opts.modules)) {
        opts.modules.forEach(function (moduleName) {
          _this2.context.loadable.report(moduleName);
        });
      }

      if (!res.loading) {
        return;
      }

      if (typeof opts.delay === "number") {
        if (opts.delay === 0) {
          this.setState({ pastDelay: true });
        } else {
          this._delay = setTimeout(function () {
            _this2.setState({ pastDelay: true });
          }, opts.delay);
        }
      }

      if (typeof opts.timeout === "number") {
        this._timeout = setTimeout(function () {
          _this2.setState({ timedOut: true });
        }, opts.timeout);
      }

      var update = function update() {
        if (!_this2._mounted) {
          return;
        }

        _this2.setState({
          error: res.error,
          loaded: res.loaded,
          loading: res.loading
        });

        _this2._clearTimeouts();
      };

      res.promise.then(function () {
        update();
      }).catch(function (err) {
        update();
      });
    };

    LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      this._mounted = false;
      this._clearTimeouts();
    };

    LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    };

    LoadableComponent.prototype.render = function render() {
      if (this.state.loading || this.state.error) {
        return React.createElement(opts.loading, {
          isLoading: this.state.loading,
          pastDelay: this.state.pastDelay,
          timedOut: this.state.timedOut,
          error: this.state.error,
          retry: this.retry
        });
      } else if (this.state.loaded) {
        return opts.render(this.state.loaded, this.props);
      } else {
        return null;
      }
    };

    return LoadableComponent;
  }(React.Component), _class.contextTypes = {
    loadable: PropTypes.shape({
      report: PropTypes.func.isRequired
    })
  }, _temp;
}

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function LoadableMap(opts) {
  if (typeof opts.render !== "function") {
    throw new Error("LoadableMap requires a `render(loaded, props)` function");
  }

  return createLoadableComponent(loadMap, opts);
}

Loadable.Map = LoadableMap;

var Capture = function (_React$Component2) {
  _inherits(Capture, _React$Component2);

  function Capture() {
    _classCallCheck(this, Capture);

    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
  }

  Capture.prototype.getChildContext = function getChildContext() {
    return {
      loadable: {
        report: this.props.report
      }
    };
  };

  Capture.prototype.render = function render() {
    return React.Children.only(this.props.children);
  };

  return Capture;
}(React.Component);

Capture.propTypes = {
  report: PropTypes.func.isRequired
};
Capture.childContextTypes = {
  loadable: PropTypes.shape({
    report: PropTypes.func.isRequired
  }).isRequired
};


Loadable.Capture = Capture;

function flushInitializers(initializers) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init());
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolve, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolve, reject);
  });
};

Loadable.preloadReady = function () {
  return new Promise(function (resolve, reject) {
    // We always will resolve, errors should be handled within loading UIs.
    flushInitializers(READY_INITIALIZERS).then(resolve, resolve);
  });
};

module.exports = Loadable;

/***/ }),
/* 460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styletron_core__ = __webpack_require__(462);


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/* eslint-env browser */
var DECL_REGEX = /.([^:{]+)(:[^{]+)?{([^}]+)}/g;
/**
 * A Styletron class for rendering styles in the browser
 * @extends StyletronCore
 * @packagename styletron-client
 * @example
 * const elements = document.getElementsByClassName('_styletron_hydrate_');
 * const styletron = new StyletronClient(elements);
 */

var StyletronClient =
/*#__PURE__*/
function (_StyletronCore) {
  _inheritsLoose(StyletronClient, _StyletronCore);

  /**
   * Create a new StyletronClient instance
   * @param {NodeList|HTMLCollection|HTMLStyleElement[]} [serverStyles] - List of server style elements
   * @param {object} [opts] - StyletronCore options
   */
  function StyletronClient(serverStyles, opts) {
    var _this;

    _this = _StyletronCore.call(this, opts) || this;
    _this.uniqueCount = 0;
    _this.mediaSheets = {};

    if (serverStyles && serverStyles.length > 0) {
      for (var i = 0; i < serverStyles.length; i++) {
        var element = serverStyles[i];

        if (element.media) {
          _this.mediaSheets[element.media] = element;
        } else {
          _this.mainSheet = element;
        }

        _this.hydrateCacheFromCssString(element.textContent, element.media);
      }
    } else {
      var styleSheet = document.createElement('style');
      document.head.appendChild(styleSheet);
      _this.mainSheet = styleSheet;
    }

    return _this;
  }
  /*
   * Hydrate the cache from a css string and media string
   * @param {string} css   - The stylesheet css content
   * @param {string} media - The stylesheet media string
   */


  var _proto = StyletronClient.prototype;

  _proto.hydrateCacheFromCssString = function hydrateCacheFromCssString(css, media) {
    var decl; // {
    //  1: className,
    //  2: pseudo,
    //  3: block,
    // }

    while (decl = DECL_REGEX.exec(css)) {
      _StyletronCore.prototype.incrementVirtualCount.call(this);

      __WEBPACK_IMPORTED_MODULE_0_styletron_core__["a" /* default */].assignDecl(this.cache, {
        block: decl[3],
        pseudo: decl[2],
        media: media
      }, decl[1]);
    }
  };
  /**
   * Inject declaration into the stylesheet and return the unique class name
   * @return {string}      class name
   * @example
   * // <style id="styletron">.a{color:red}</style>
   * const styletron = new StyletronClient(document.getElementsByClassName('_styletron_hydrate_'));
   * styletron.injectDeclaration({prop: 'color', val: 'blue'});
   * // → 'b'
   * styletron.injectDeclaration({prop: 'color', val: 'red', media: '(min-width: 800px)'});
   * // → 'c'
   * styletron.injectDeclaration({prop: 'color', val: 'red'});
   * // → 'a'
   */


  _proto.injectDeclaration = function injectDeclaration(_ref) {
    var prop = _ref.prop,
        val = _ref.val,
        media = _ref.media,
        pseudo = _ref.pseudo;
    return this.injectRawDeclaration({
      block: prop + ":" + val,
      media: media,
      pseudo: pseudo
    });
  };
  /**
   * Inject raw declaration into the stylesheet and return the unique class name
   * @return {string}      class name
   * @example
   * // <style id="styletron">.a{color:red}</style>
   * const styletron = new StyletronClient(document.getElementsByClassName('_styletron_hydrate_'));
   * styletron.injectRawDeclaration({block: 'color:blue'});
   * // → 'b'
   * styletron.injectRawDeclaration({block: 'color:red', media: '(min-width: 800px)'});
   * // → 'c'
   * styletron.injectRawDeclaration({block: 'color:red'});
   * // → 'a'
   */


  _proto.injectRawDeclaration = function injectRawDeclaration(decl) {
    var oldCount = this.uniqueCount;

    var className = _StyletronCore.prototype.injectRawDeclaration.call(this, decl);

    if (oldCount !== this.uniqueCount) {
      var rule = declarationToRule(className, decl);
      var sheet;

      if (decl.media) {
        if (!this.mediaSheets[decl.media]) {
          var mediaSheet = document.createElement('style');
          mediaSheet.media = decl.media;
          this.mediaSheets[decl.media] = mediaSheet;
          this.mainSheet.parentNode.appendChild(mediaSheet);
        }

        sheet = this.mediaSheets[decl.media].sheet;
      } else {
        sheet = this.mainSheet.sheet;
      }

      sheet.insertRule(rule, sheet.cssRules.length);
    }

    return className;
  };

  return StyletronClient;
}(__WEBPACK_IMPORTED_MODULE_0_styletron_core__["a" /* default */]);

/*
 * Injection helpers
 */

function declarationToRule(className, _ref2) {
  var block = _ref2.block,
      pseudo = _ref2.pseudo;
  var selector = "." + className;

  if (pseudo) {
    selector += pseudo;
  }

  return selector + "{" + block + "}";
}

/* harmony default export */ __webpack_exports__["a"] = (StyletronClient);
//# sourceMappingURL=browser.es5.es.js.map


/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The core styletron module
 * @packagename styletron-core
 */
var StyletronCore =
/*#__PURE__*/
function () {
  /**
   * Create a new StyletronCore instance
   * @param {object} [opts]           An object containing options
   * @param {string} [opts.prefix=''] A prefix for generated CSS class names
   */
  function StyletronCore(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        _ref$prefix = _ref.prefix,
        prefix = _ref$prefix === void 0 ? '' : _ref$prefix;

    this.cache = {
      media: {},
      pseudo: {}
    };
    this.prefix = prefix === '' ? false : prefix;
    this.uniqueCount = 0;
    this.offset = 10; // skip 0-9

    this.msb = 35;
    this.power = 1;
  }

  StyletronCore.assignDecl = function assignDecl(target, decl, className) {
    var block = decl.block,
        media = decl.media,
        pseudo = decl.pseudo;
    var targetEntry;

    if (media) {
      if (!target.media[media]) {
        target.media[media] = {
          pseudo: {}
        };
      }

      targetEntry = target.media[media];
    } else {
      targetEntry = target;
    }

    if (pseudo) {
      if (!targetEntry.pseudo[pseudo]) {
        targetEntry.pseudo[pseudo] = {};
      }

      targetEntry = targetEntry.pseudo[pseudo];
    }

    targetEntry[block] = className;
  };
  /**
   * Injects a declaration (if not already injected) and returns a class name
   * @param  {object} decl          The CSS declaration object
   * @param  {string} decl.prop     The property name
   * @param  {string} decl.val      The property value
   * @param  {string} [decl.media]  The media query
   * @param  {string} [decl.pseudo] The pseudo selector
   * @return {string|undefined}     The class name for the declaration
   */


  var _proto = StyletronCore.prototype;

  _proto.injectDeclaration = function injectDeclaration(_ref2) {
    var prop = _ref2.prop,
        val = _ref2.val,
        media = _ref2.media,
        pseudo = _ref2.pseudo;
    return this.injectRawDeclaration({
      block: prop + ":" + val,
      media: media,
      pseudo: pseudo
    });
  };
  /**
   * Injects a raw declaration (if not already injected) and returns a class name
   * @param  {object} decl          The CSS declaration object
   * @param  {string} decl.block    The declaration block
   * @param  {string} [decl.media]  The media query
   * @param  {string} [decl.pseudo] The pseudo selector
   * @return {string|undefined}     The class name for the declaration
   */


  _proto.injectRawDeclaration = function injectRawDeclaration(decl) {
    var cached = this.getCachedDeclaration(decl);

    if (cached) {
      return cached;
    }

    var virtualCount = this.incrementVirtualCount();
    var hash = virtualCount.toString(36);
    var className = this.prefix ? this.prefix + hash : hash;
    StyletronCore.assignDecl(this.cache, decl, className);
    return className;
  };
  /**
   * Get the next virtual class number, while setting
   * the uniqueCount, offset, and msb counters appropriately.
   * @return {number} The virtual class count
   * @private
   */


  _proto.incrementVirtualCount = function incrementVirtualCount() {
    var virtualCount = this.uniqueCount + this.offset;

    if (virtualCount === this.msb) {
      this.offset += (this.msb + 1) * 9;
      this.msb = Math.pow(36, ++this.power) - 1;
    }

    this.uniqueCount++;
    return virtualCount;
  };
  /**
   * Gets the class name for an already injected declaration
   * @param  {object} decl          The CSS declaration object
   * @param  {string} decl.block    The declaration block
   * @param  {string} [decl.media]  The media query
   * @param  {string} [decl.pseudo] The pseudo selector
   * @return {string|undefined}     The class name for the declaration
   * @private
   */


  _proto.getCachedDeclaration = function getCachedDeclaration(_ref3) {
    var block = _ref3.block,
        media = _ref3.media,
        pseudo = _ref3.pseudo;
    var entry;

    if (media) {
      entry = this.cache.media[media];

      if (!entry) {
        return false;
      }
    } else {
      entry = this.cache;
    }

    if (pseudo) {
      entry = entry.pseudo[pseudo];

      if (!entry) {
        return false;
      }
    }

    return entry[block];
  };

  return StyletronCore;
}();

/* harmony default export */ __webpack_exports__["a"] = (StyletronCore);
//# sourceMappingURL=browser.es5.es.js.map


/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return injectStyle; });
/* unused harmony export injectStylePrefixed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inline_style_prefixer_static__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inline_style_prefixer_static___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_inline_style_prefixer_static__);


var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};
function hyphenateStyleName(prop) {
  return prop in cache ? cache[prop] : cache[prop] = prop.replace(uppercasePattern, '-$&').toLowerCase().replace(msPattern, '-ms-');
}

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function injectStyle(styletron, styles, media, pseudo) {
  var classString = '';

  for (var key in styles) {
    var val = styles[key];

    var valType = _typeof(val);

    if (valType === 'string' || valType === 'number') {
      classString += ' ' + styletron.injectRawDeclaration({
        block: hyphenateStyleName(key) + ":" + val,
        media: media,
        pseudo: pseudo
      });
      continue;
    }

    if (Array.isArray(val)) {
      if (val.length === 0) {
        continue;
      }

      var hyphenated = hyphenateStyleName(key);
      var block = hyphenated + ":" + val[0];

      for (var i = 1; i < val.length; i++) {
        block += ";" + hyphenated + ":" + val[i];
      }

      classString += ' ' + styletron.injectRawDeclaration({
        block: block,
        media: media,
        pseudo: pseudo
      });
      continue;
    }

    if (valType === 'object') {
      if (key[0] === ':') {
        classString += ' ' + injectStyle(styletron, val, media, key);
        continue;
      }

      if (key.substring(0, 6) === '@media') {
        classString += ' ' + injectStyle(styletron, val, key.substr(7), pseudo);
        continue;
      }
    }
  } // remove leading space on way out


  return classString.slice(1);
}

function _typeof$1(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$1 = function _typeof(obj) { return typeof obj; }; } else { _typeof$1 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$1(obj); }

var prefixedBlockCache = {};
function injectStylePrefixed(styletron, styles, media, pseudo, cache) {
  if (cache === void 0) {
    cache = prefixedBlockCache;
  }

  var classString = '';

  for (var originalKey in styles) {
    var originalVal = styles[originalKey];

    var originalValType = _typeof$1(originalVal);

    var isPrimitiveVal = originalValType === 'string' || originalValType === 'number';

    if (isPrimitiveVal || Array.isArray(originalVal)) {
      var block = '';

      if (isPrimitiveVal && cache.hasOwnProperty(originalKey) && cache[originalKey].hasOwnProperty(originalVal)) {
        block = cache[originalKey][originalVal];
      } else {
        var _prefixAll;

        var prefixed = __WEBPACK_IMPORTED_MODULE_0_inline_style_prefixer_static___default()((_prefixAll = {}, _prefixAll[originalKey] = originalVal, _prefixAll));

        for (var prefixedKey in prefixed) {
          var prefixedVal = prefixed[prefixedKey];

          var prefixedValType = _typeof$1(prefixedVal);

          if (prefixedValType === 'string' || prefixedValType === 'number') {
            block += hyphenateStyleName(prefixedKey) + ":" + prefixedVal + ";";
            continue;
          }

          if (Array.isArray(prefixedVal)) {
            var hyphenated = hyphenateStyleName(prefixedKey);

            for (var i = 0; i < prefixedVal.length; i++) {
              block += hyphenated + ":" + prefixedVal[i] + ";";
            }

            continue;
          }
        }

        block = block.slice(0, -1); // Remove trailing semicolon

        if (isPrimitiveVal) {
          if (!cache.hasOwnProperty(originalKey)) {
            cache[originalKey] = {};
          }

          cache[originalKey][originalVal] = block;
        }
      }

      classString += ' ' + styletron.injectRawDeclaration({
        block: block,
        media: media,
        pseudo: pseudo
      });
    }

    if (originalValType === 'object') {
      if (originalKey[0] === ':') {
        classString += ' ' + injectStylePrefixed(styletron, originalVal, media, originalKey, cache);
        continue;
      }

      if (originalKey.substring(0, 6) === '@media') {
        classString += ' ' + injectStylePrefixed(styletron, originalVal, originalKey.substr(7), pseudo, cache);
        continue;
      }
    }
  } // remove leading space on way out


  return classString.slice(1);
}


//# sourceMappingURL=browser.es5.es.js.map


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createPrefixer = __webpack_require__(465);

var _createPrefixer2 = _interopRequireDefault(_createPrefixer);

var _staticData = __webpack_require__(470);

var _staticData2 = _interopRequireDefault(_staticData);

var _cursor = __webpack_require__(471);

var _cursor2 = _interopRequireDefault(_cursor);

var _crossFade = __webpack_require__(472);

var _crossFade2 = _interopRequireDefault(_crossFade);

var _filter = __webpack_require__(473);

var _filter2 = _interopRequireDefault(_filter);

var _flex = __webpack_require__(474);

var _flex2 = _interopRequireDefault(_flex);

var _flexboxOld = __webpack_require__(475);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

var _gradient = __webpack_require__(476);

var _gradient2 = _interopRequireDefault(_gradient);

var _imageSet = __webpack_require__(477);

var _imageSet2 = _interopRequireDefault(_imageSet);

var _position = __webpack_require__(478);

var _position2 = _interopRequireDefault(_position);

var _sizing = __webpack_require__(479);

var _sizing2 = _interopRequireDefault(_sizing);

var _transition = __webpack_require__(480);

var _transition2 = _interopRequireDefault(_transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plugins = [_crossFade2.default, _cursor2.default, _filter2.default, _flexboxOld2.default, _gradient2.default, _imageSet2.default, _position2.default, _sizing2.default, _transition2.default, _flex2.default];

exports.default = (0, _createPrefixer2.default)({
  prefixMap: _staticData2.default.prefixMap,
  plugins: plugins
});
module.exports = exports["default"];

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPrefixer;

var _prefixProperty = __webpack_require__(466);

var _prefixProperty2 = _interopRequireDefault(_prefixProperty);

var _prefixValue = __webpack_require__(467);

var _prefixValue2 = _interopRequireDefault(_prefixValue);

var _addNewValuesOnly = __webpack_require__(468);

var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);

var _isObject = __webpack_require__(469);

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;

  function prefixAll(style) {
    for (var property in style) {
      var value = style[property];

      // handle nested objects
      if ((0, _isObject2.default)(value)) {
        style[property] = prefixAll(value);
        // handle array values
      } else if (Array.isArray(value)) {
        var combinedValue = [];

        for (var i = 0, len = value.length; i < len; ++i) {
          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
        }

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (combinedValue.length > 0) {
          style[property] = combinedValue;
        }
      } else {
        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (_processedValue) {
          style[property] = _processedValue;
        }

        style = (0, _prefixProperty2.default)(prefixMap, property, style);
      }
    }

    return style;
  }

  return prefixAll;
}
module.exports = exports["default"];

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixProperty;

var _capitalizeString = __webpack_require__(147);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prefixProperty(prefixProperties, property, style) {
  if (prefixProperties.hasOwnProperty(property)) {
    var newStyle = {};
    var requiredPrefixes = prefixProperties[property];
    var capitalizedProperty = (0, _capitalizeString2.default)(property);
    var keys = Object.keys(style);
    for (var i = 0; i < keys.length; i++) {
      var styleProperty = keys[i];
      if (styleProperty === property) {
        for (var j = 0; j < requiredPrefixes.length; j++) {
          newStyle[requiredPrefixes[j] + capitalizedProperty] = style[property];
        }
      }
      newStyle[styleProperty] = style[styleProperty];
    }
    return newStyle;
  }
  return style;
}
module.exports = exports["default"];

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixValue;
function prefixValue(plugins, property, value, style, metaData) {
  for (var i = 0, len = plugins.length; i < len; ++i) {
    var processedValue = plugins[i](property, value, style, metaData);

    // we can stop processing if a value is returned
    // as all plugin criteria are unique
    if (processedValue) {
      return processedValue;
    }
  }
}
module.exports = exports["default"];

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addNewValuesOnly;
function addIfNew(list, value) {
  if (list.indexOf(value) === -1) {
    list.push(value);
  }
}

function addNewValuesOnly(list, values) {
  if (Array.isArray(values)) {
    for (var i = 0, len = values.length; i < len; ++i) {
      addIfNew(list, values[i]);
    }
  } else {
    addIfNew(list, values);
  }
}
module.exports = exports["default"];

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObject;
function isObject(value) {
  return value instanceof Object && !Array.isArray(value);
}
module.exports = exports["default"];

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var w = ["Webkit"];
var m = ["Moz"];
var ms = ["ms"];
var wm = ["Webkit", "Moz"];
var wms = ["Webkit", "ms"];
var wmms = ["Webkit", "Moz", "ms"];

exports.default = {
  plugins: [],
  prefixMap: { "appearance": wm, "textEmphasisPosition": w, "textEmphasis": w, "textEmphasisStyle": w, "textEmphasisColor": w, "boxDecorationBreak": w, "maskImage": w, "maskMode": w, "maskRepeat": w, "maskPosition": w, "maskClip": w, "maskOrigin": w, "maskSize": w, "maskComposite": w, "mask": w, "maskBorderSource": w, "maskBorderMode": w, "maskBorderSlice": w, "maskBorderWidth": w, "maskBorderOutset": w, "maskBorderRepeat": w, "maskBorder": w, "maskType": w, "textDecorationStyle": w, "textDecorationSkip": w, "textDecorationLine": w, "textDecorationColor": w, "userSelect": wmms, "backdropFilter": w, "fontKerning": w, "scrollSnapType": wms, "scrollSnapPointsX": wms, "scrollSnapPointsY": wms, "scrollSnapDestination": wms, "scrollSnapCoordinate": wms, "clipPath": w, "shapeImageThreshold": w, "shapeImageMargin": w, "shapeImageOutside": w, "filter": w, "hyphens": wms, "flowInto": wms, "flowFrom": wms, "breakBefore": wms, "breakAfter": wms, "breakInside": wms, "regionFragment": wms, "writingMode": wms, "tabSize": m, "fontFeatureSettings": w, "columnCount": w, "columnFill": w, "columnGap": w, "columnRule": w, "columnRuleColor": w, "columnRuleStyle": w, "columnRuleWidth": w, "columns": w, "columnSpan": w, "columnWidth": w, "wrapFlow": ms, "wrapThrough": ms, "wrapMargin": ms, "gridTemplateColumns": ms, "gridTemplateRows": ms, "gridTemplateAreas": ms, "gridTemplate": ms, "gridAutoColumns": ms, "gridAutoRows": ms, "gridAutoFlow": ms, "grid": ms, "gridRowStart": ms, "gridColumnStart": ms, "gridRowEnd": ms, "gridRow": ms, "gridColumn": ms, "gridColumnEnd": ms, "gridColumnGap": ms, "gridRowGap": ms, "gridArea": ms, "gridGap": ms, "textSizeAdjust": wms, "flex": w, "flexBasis": w, "flexDirection": w, "flexGrow": w, "flexFlow": w, "flexShrink": w, "flexWrap": w, "alignContent": w, "alignItems": w, "alignSelf": w, "justifyContent": w, "order": w, "transform": w, "transformOrigin": w, "transformOriginX": w, "transformOriginY": w, "backfaceVisibility": w, "perspective": w, "perspectiveOrigin": w, "transformStyle": w, "transformOriginZ": w, "animation": w, "animationDelay": w, "animationDirection": w, "animationFillMode": w, "animationDuration": w, "animationIterationCount": w, "animationName": w, "animationPlayState": w, "animationTimingFunction": w }
};
module.exports = exports["default"];

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cursor;
var prefixes = ["-webkit-", "-moz-", ""];

var values = {
  "zoom-in": true,
  "zoom-out": true,
  grab: true,
  grabbing: true
};

function cursor(property, value) {
  if (property === "cursor" && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports["default"];

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = crossFade;

var _isPrefixedValue = __webpack_require__(47);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#search=cross-fade
var prefixes = ["-webkit-", ""];
function crossFade(property, value) {
  if (typeof value === "string" && !(0, _isPrefixedValue2.default)(value) && value.indexOf("cross-fade(") > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/cross-fade\(/g, prefix + "cross-fade(");
    });
  }
}
module.exports = exports["default"];

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filter;

var _isPrefixedValue = __webpack_require__(47);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-filter-function
var prefixes = ["-webkit-", ""];
function filter(property, value) {
  if (typeof value === "string" && !(0, _isPrefixedValue2.default)(value) && value.indexOf("filter(") > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/filter\(/g, prefix + "filter(");
    });
  }
}
module.exports = exports["default"];

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = {
  flex: ["-webkit-box", "-moz-box", "-ms-flexbox", "-webkit-flex", "flex"],
  "inline-flex": ["-webkit-inline-box", "-moz-inline-box", "-ms-inline-flexbox", "-webkit-inline-flex", "inline-flex"]
};

function flex(property, value) {
  if (property === "display" && values.hasOwnProperty(value)) {
    return values[value];
  }
}
module.exports = exports["default"];

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;
var alternativeValues = {
  "space-around": "justify",
  "space-between": "justify",
  "flex-start": "start",
  "flex-end": "end",
  "wrap-reverse": "multiple",
  wrap: "multiple"
};

var alternativeProps = {
  alignItems: "WebkitBoxAlign",
  justifyContent: "WebkitBoxPack",
  flexWrap: "WebkitBoxLines"
};

function flexboxOld(property, value, style) {
  if (property === "flexDirection" && typeof value === "string") {
    if (value.indexOf("column") > -1) {
      style.WebkitBoxOrient = "vertical";
    } else {
      style.WebkitBoxOrient = "horizontal";
    }
    if (value.indexOf("reverse") > -1) {
      style.WebkitBoxDirection = "reverse";
    } else {
      style.WebkitBoxDirection = "normal";
    }
  }
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports["default"];

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _isPrefixedValue = __webpack_require__(47);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ["-webkit-", "-moz-", ""];

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;

function gradient(property, value) {
  if (typeof value === "string" && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports["default"];

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = imageSet;

var _isPrefixedValue = __webpack_require__(47);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-image-set
var prefixes = ["-webkit-", ""];
function imageSet(property, value) {
  if (typeof value === "string" && !(0, _isPrefixedValue2.default)(value) && value.indexOf("image-set(") > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/image-set\(/g, prefix + "image-set(");
    });
  }
}
module.exports = exports["default"];

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = position;
function position(property, value) {
  if (property === "position" && value === "sticky") {
    return ["-webkit-sticky", "sticky"];
  }
}
module.exports = exports["default"];

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;
var prefixes = ["-webkit-", "-moz-", ""];

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  "min-content": true,
  "max-content": true,
  "fill-available": true,
  "fit-content": true,
  "contain-floats": true
};

function sizing(property, value) {
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports["default"];

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateProperty = __webpack_require__(481);

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

var _isPrefixedValue = __webpack_require__(47);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

var _capitalizeString = __webpack_require__(147);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var prefixMapping = {
  Webkit: "-webkit-",
  Moz: "-moz-",
  ms: "-ms-"
};

function prefixValue(value, propertyPrefixMap) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  for (var i = 0, len = multipleValues.length; i < len; ++i) {
    var singleValue = multipleValues[i];
    var values = [singleValue];
    for (var property in propertyPrefixMap) {
      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);

      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== "order") {
        var prefixes = propertyPrefixMap[property];
        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
          // join all prefixes and create a new value
          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
        }
      }
    }

    multipleValues[i] = values.join(",");
  }

  return multipleValues.join(",");
}

function transition(property, value, style, propertyPrefixMap) {
  // also check for already prefixed transitions
  if (typeof value === "string" && properties.hasOwnProperty(property)) {
    var outputValue = prefixValue(value, propertyPrefixMap);
    // if the property is already prefixed
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-moz-|-ms-/.test(val);
    }).join(",");

    if (property.indexOf("Webkit") > -1) {
      return webkitOutput;
    }

    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-webkit-|-ms-/.test(val);
    }).join(",");

    if (property.indexOf("Moz") > -1) {
      return mozOutput;
    }

    style["Webkit" + (0, _capitalizeString2.default)(property)] = webkitOutput;
    style["Moz" + (0, _capitalizeString2.default)(property)] = mozOutput;
    return outputValue;
  }
}
module.exports = exports["default"];

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateProperty;

var _hyphenateStyleName = __webpack_require__(482);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2.default)(property);
}
module.exports = exports['default'];

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function hyphenateStyleName(string) {
    return string in cache
    ? cache[string]
    : cache[string] = string
      .replace(uppercasePattern, '-$&')
      .toLowerCase()
      .replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Bowser - a browser detector
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */

!function (root, name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) __webpack_require__(484)(name, definition)
  else root[name] = definition()
}(this, 'bowser', function () {
  /**
    * See useragents.js for examples of navigator.userAgent
    */

  var t = true

  function detect(ua) {

    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[1]) || '';
    }

    function getSecondMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[2]) || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
      , likeAndroid = /like android/i.test(ua)
      , android = !likeAndroid && /android/i.test(ua)
      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
      , chromeos = /CrOS/.test(ua)
      , silk = /silk/i.test(ua)
      , sailfish = /sailfish/i.test(ua)
      , tizen = /tizen/i.test(ua)
      , webos = /(web|hpw)(o|0)s/i.test(ua)
      , windowsphone = /windows phone/i.test(ua)
      , samsungBrowser = /SamsungBrowser/i.test(ua)
      , windows = !windowsphone && /windows/i.test(ua)
      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
      , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
      , mobile = !tablet && /[^-]mobi/i.test(ua)
      , xbox = /xbox/i.test(ua)
      , result

    if (/opera/i.test(ua)) {
      //  an old Opera
      result = {
        name: 'Opera'
      , opera: t
      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
      }
    } else if (/opr\/|opios/i.test(ua)) {
      // a new Opera
      result = {
        name: 'Opera'
        , opera: t
        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/SamsungBrowser/i.test(ua)) {
      result = {
        name: 'Samsung Internet for Android'
        , samsungBrowser: t
        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/Whale/i.test(ua)) {
      result = {
        name: 'NAVER Whale browser'
        , whale: t
        , version: getFirstMatch(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/MZBrowser/i.test(ua)) {
      result = {
        name: 'MZ Browser'
        , mzbrowser: t
        , version: getFirstMatch(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/coast/i.test(ua)) {
      result = {
        name: 'Opera Coast'
        , coast: t
        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/focus/i.test(ua)) {
      result = {
        name: 'Focus'
        , focus: t
        , version: getFirstMatch(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/yabrowser/i.test(ua)) {
      result = {
        name: 'Yandex Browser'
      , yandexbrowser: t
      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/ucbrowser/i.test(ua)) {
      result = {
          name: 'UC Browser'
        , ucbrowser: t
        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/mxios/i.test(ua)) {
      result = {
        name: 'Maxthon'
        , maxthon: t
        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/epiphany/i.test(ua)) {
      result = {
        name: 'Epiphany'
        , epiphany: t
        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/puffin/i.test(ua)) {
      result = {
        name: 'Puffin'
        , puffin: t
        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
      }
    }
    else if (/sleipnir/i.test(ua)) {
      result = {
        name: 'Sleipnir'
        , sleipnir: t
        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/k-meleon/i.test(ua)) {
      result = {
        name: 'K-Meleon'
        , kMeleon: t
        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (windowsphone) {
      result = {
        name: 'Windows Phone'
      , osname: 'Windows Phone'
      , windowsphone: t
      }
      if (edgeVersion) {
        result.msedge = t
        result.version = edgeVersion
      }
      else {
        result.msie = t
        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer'
      , msie: t
      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      }
    } else if (chromeos) {
      result = {
        name: 'Chrome'
      , osname: 'Chrome OS'
      , chromeos: t
      , chromeBook: t
      , chrome: t
      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    } else if (/edg([ea]|ios)/i.test(ua)) {
      result = {
        name: 'Microsoft Edge'
      , msedge: t
      , version: edgeVersion
      }
    }
    else if (/vivaldi/i.test(ua)) {
      result = {
        name: 'Vivaldi'
        , vivaldi: t
        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (sailfish) {
      result = {
        name: 'Sailfish'
      , osname: 'Sailfish OS'
      , sailfish: t
      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey'
      , seamonkey: t
      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/firefox|iceweasel|fxios/i.test(ua)) {
      result = {
        name: 'Firefox'
      , firefox: t
      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
      }
      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t
        result.osname = 'Firefox OS'
      }
    }
    else if (silk) {
      result =  {
        name: 'Amazon Silk'
      , silk: t
      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS'
      , phantom: t
      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/slimerjs/i.test(ua)) {
      result = {
        name: 'SlimerJS'
        , slimer: t
        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry'
      , osname: 'BlackBerry OS'
      , blackberry: t
      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      }
    }
    else if (webos) {
      result = {
        name: 'WebOS'
      , osname: 'WebOS'
      , webos: t
      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t)
    }
    else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada'
      , osname: 'Bada'
      , bada: t
      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    }
    else if (tizen) {
      result = {
        name: 'Tizen'
      , osname: 'Tizen'
      , tizen: t
      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    }
    else if (/qupzilla/i.test(ua)) {
      result = {
        name: 'QupZilla'
        , qupzilla: t
        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
      }
    }
    else if (/chromium/i.test(ua)) {
      result = {
        name: 'Chromium'
        , chromium: t
        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome'
        , chrome: t
        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    }
    else if (android) {
      result = {
        name: 'Android'
        , version: versionIdentifier
      }
    }
    else if (/safari|applewebkit/i.test(ua)) {
      result = {
        name: 'Safari'
      , safari: t
      }
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if (iosdevice) {
      result = {
        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
      }
      // WTF: version is not part of user agent in web apps
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if(/googlebot/i.test(ua)) {
      result = {
        name: 'Googlebot'
      , googlebot: t
      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
      }
    }
    else {
      result = {
        name: getFirstMatch(/^(.*)\/(.*) /),
        version: getSecondMatch(/^(.*)\/(.*) /)
     };
   }

    // set webkit or gecko flag for browsers based on these engines
    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
      if (/(apple)?webkit\/537\.36/i.test(ua)) {
        result.name = result.name || "Blink"
        result.blink = t
      } else {
        result.name = result.name || "Webkit"
        result.webkit = t
      }
      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko"
      result.gecko = t
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
    }

    // set OS flags for platforms that have multiple browsers
    if (!result.windowsphone && (android || result.silk)) {
      result.android = t
      result.osname = 'Android'
    } else if (!result.windowsphone && iosdevice) {
      result[iosdevice] = t
      result.ios = t
      result.osname = 'iOS'
    } else if (mac) {
      result.mac = t
      result.osname = 'macOS'
    } else if (xbox) {
      result.xbox = t
      result.osname = 'Xbox'
    } else if (windows) {
      result.windows = t
      result.osname = 'Windows'
    } else if (linux) {
      result.linux = t
      result.osname = 'Linux'
    }

    function getWindowsVersion (s) {
      switch (s) {
        case 'NT': return 'NT'
        case 'XP': return 'XP'
        case 'NT 5.0': return '2000'
        case 'NT 5.1': return 'XP'
        case 'NT 5.2': return '2003'
        case 'NT 6.0': return 'Vista'
        case 'NT 6.1': return '7'
        case 'NT 6.2': return '8'
        case 'NT 6.3': return '8.1'
        case 'NT 10.0': return '10'
        default: return undefined
      }
    }

    // OS version extraction
    var osVersion = '';
    if (result.windows) {
      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
    } else if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (result.mac) {
      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
      result.osversion = osVersion;
    }

    // device type extraction
    var osMajorVersion = !result.windows && osVersion.split('.')[0];
    if (
         tablet
      || nexusTablet
      || iosdevice == 'ipad'
      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
      || result.silk
    ) {
      result.tablet = t
    } else if (
         mobile
      || iosdevice == 'iphone'
      || iosdevice == 'ipod'
      || android
      || nexusMobile
      || result.blackberry
      || result.webos
      || result.bada
    ) {
      result.mobile = t
    }

    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    if (result.msedge ||
        (result.msie && result.version >= 10) ||
        (result.yandexbrowser && result.version >= 15) ||
		    (result.vivaldi && result.version >= 1.0) ||
        (result.chrome && result.version >= 20) ||
        (result.samsungBrowser && result.version >= 4) ||
        (result.whale && compareVersions([result.version, '1.0']) === 1) ||
        (result.mzbrowser && compareVersions([result.version, '6.0']) === 1) ||
        (result.focus && compareVersions([result.version, '1.0']) === 1) ||
        (result.firefox && result.version >= 20.0) ||
        (result.safari && result.version >= 6) ||
        (result.opera && result.version >= 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
        (result.blackberry && result.version >= 10.1)
        || (result.chromium && result.version >= 20)
        ) {
      result.a = t;
    }
    else if ((result.msie && result.version < 10) ||
        (result.chrome && result.version < 20) ||
        (result.firefox && result.version < 20.0) ||
        (result.safari && result.version < 6) ||
        (result.opera && result.version < 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
        || (result.chromium && result.version < 20)
        ) {
      result.c = t
    } else result.x = t

    return result
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')

  bowser.test = function (browserList) {
    for (var i = 0; i < browserList.length; ++i) {
      var browserItem = browserList[i];
      if (typeof browserItem=== 'string') {
        if (browserItem in bowser) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  function getVersionPrecision(version) {
    return version.split(".").length;
  }

  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  function map(arr, iterator) {
    var result = [], i;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }
    for (i = 0; i < arr.length; i++) {
      result.push(iterator(arr[i]));
    }
    return result;
  }

  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
   *
   * @param  {Array<String>} versions versions to compare
   * @return {Number} comparison result
   */
  function compareVersions(versions) {
    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
    var chunks = map(versions, function (version) {
      var delta = precision - getVersionPrecision(version);

      // 2) "9" -> "9.0" (for precision = 2)
      version = version + new Array(delta + 1).join(".0");

      // 3) "9.0" -> ["000000000"", "000000009"]
      return map(version.split("."), function (chunk) {
        return new Array(20 - chunk.length).join("0") + chunk;
      }).reverse();
    });

    // iterate in reverse order by reversed chunks array
    while (--precision >= 0) {
      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }
      else if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === 0) {
          // all version chunks are same
          return 0;
        }
      }
      else {
        return -1;
      }
    }
  }

  /**
   * Check if browser is unsupported
   *
   * @example
   *   bowser.isUnsupportedBrowser({
   *     msie: "10",
   *     firefox: "23",
   *     chrome: "29",
   *     safari: "5.1",
   *     opera: "16",
   *     phantom: "534"
   *   });
   *
   * @param  {Object}  minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function isUnsupportedBrowser(minVersions, strictMode, ua) {
    var _bowser = bowser;

    // make strictMode param optional with ua param usage
    if (typeof strictMode === 'string') {
      ua = strictMode;
      strictMode = void(0);
    }

    if (strictMode === void(0)) {
      strictMode = false;
    }
    if (ua) {
      _bowser = detect(ua);
    }

    var version = "" + _bowser.version;
    for (var browser in minVersions) {
      if (minVersions.hasOwnProperty(browser)) {
        if (_bowser[browser]) {
          if (typeof minVersions[browser] !== 'string') {
            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
          }

          // browser version and min supported version.
          return compareVersions([version, minVersions[browser]]) < 0;
        }
      }
    }

    return strictMode; // not found
  }

  /**
   * Check if browser is supported
   *
   * @param  {Object} minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function check(minVersions, strictMode, ua) {
    return !isUnsupportedBrowser(minVersions, strictMode, ua);
  }

  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
  bowser.compareVersions = compareVersions;
  bowser.check = check;

  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */
  bowser._detect = detect;

  /*
   * Set our detect public method to the main bowser object
   * This is needed to implement bowser in server side
   */
  bowser.detect = detect;
  return bowser
});


/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 485 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 486 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0),
    PropTypes = __webpack_require__(1),
    withSideEffect = __webpack_require__(488);

function reducePropsToState(propsList) {
  var innermostProps = propsList[propsList.length - 1];
  if (innermostProps) {
    return innermostProps.title;
  }
}

function handleStateChangeOnClient(title) {
  var nextTitle = title || '';
  if (nextTitle !== document.title) {
    document.title = nextTitle;
  }
}

function DocumentTitle() {}
DocumentTitle.prototype = Object.create(React.Component.prototype);

DocumentTitle.displayName = 'DocumentTitle';
DocumentTitle.propTypes = {
  title: PropTypes.string.isRequired
};

DocumentTitle.prototype.render = function() {
  if (this.props.children) {
    return React.Children.only(this.props.children);
  } else {
    return null;
  }
};

module.exports = withSideEffect(
  reducePropsToState,
  handleStateChangeOnClient
)(DocumentTitle);


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__(151);

var _exenv2 = _interopRequireDefault(_exenv);

var _shallowequal = __webpack_require__(489);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = void 0;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !(0, _shallowequal2.default)(nextProps, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return _react2.default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(_react.Component);

    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
    SideEffect.canUseDOM = _exenv2.default.canUseDOM;


    return SideEffect;
  };
};

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports = function shallowEqual(objA, objB, compare, compareContext) {

    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

    if(ret !== void 0) {
        return !!ret;
    }

    if(objA === objB) {
        return true;
    }

    if(typeof objA !== 'object' || !objA ||
       typeof objB !== 'object' || !objB) {
        return false;
    }

    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);

    if(keysA.length !== keysB.length) {
        return false;
    }

    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++) {

        var key = keysA[idx];

        if(!bHasOwnProperty(key)) {
            return false;
        }

        var valueA = objA[key];
        var valueB = objB[key];

        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

        if(ret === false ||
           ret === void 0 && valueA !== valueB) {
            return false;
        }

    }

    return true;

};


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var PropTypes = _interopRequireWildcard(_propTypes);

var _addClass = __webpack_require__(491);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(493);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Transition = __webpack_require__(84);

var _Transition2 = _interopRequireDefault(_Transition);

var _PropTypes = __webpack_require__(154);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass2.default)(node, c);
  });
};
var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass2.default)(node, c);
  });
};

var propTypes = _extends({}, _Transition2.default.propTypes, {

  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply spread
   * them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
});

/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/m77l2vp00x?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 */

var CSSTransition = function (_React$Component) {
  _inherits(CSSTransition, _React$Component);

  function CSSTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');
      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');
      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    }, _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    }, _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');
      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    }, _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;


      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;

      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';

      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';

      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
    var _getClassNames = this.getClassNames(type),
        className = _getClassNames.className,
        activeClassName = _getClassNames.activeClassName,
        doneClassName = _getClassNames.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */
      addClass(node, className);
    }
  };

  CSSTransition.prototype.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;

    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react2.default.Component);

CSSTransition.propTypes =  false ? propTypes : {};

exports.default = CSSTransition;
module.exports = exports['default'];

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(492);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}
module.exports = exports['default'];

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(26);

var _TransitionGroup = __webpack_require__(155);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  in: _propTypes2.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react2.default.Children.count(props[propName]) !== 2) return new Error('"' + propName + '" must be exactly two transition components.');

    return null;
  }
};

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition = function (_React$Component) {
  _inherits(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, ReplaceTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  ReplaceTransition.prototype.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react2.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  ReplaceTransition.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        inProp = _props.in,
        props = _objectWithoutProperties(_props, ['children', 'in']);

    var _React$Children$toArr = _react2.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;

    return _react2.default.createElement(
      _TransitionGroup2.default,
      props,
      inProp ? _react2.default.cloneElement(first, {
        key: 'first',
        onEnter: this.handleEnter,
        onEntering: this.handleEntering,
        onEntered: this.handleEntered

      }) : _react2.default.cloneElement(second, {
        key: 'second',
        onEnter: this.handleExit,
        onEntering: this.handleExiting,
        onEntered: this.handleExited
      })
    );
  };

  return ReplaceTransition;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleEnter = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _this2.handleLifecycle('onEnter', 0, args);
  };

  this.handleEntering = function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _this2.handleLifecycle('onEntering', 0, args);
  };

  this.handleEntered = function () {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return _this2.handleLifecycle('onEntered', 0, args);
  };

  this.handleExit = function () {
    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    return _this2.handleLifecycle('onExit', 1, args);
  };

  this.handleExiting = function () {
    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    return _this2.handleLifecycle('onExiting', 1, args);
  };

  this.handleExited = function () {
    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    return _this2.handleLifecycle('onExited', 1, args);
  };
};

ReplaceTransition.propTypes =  false ? propTypes : {};

exports.default = ReplaceTransition;
module.exports = exports['default'];

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = Object.create(null);

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);

  Object.keys(children).forEach(function (key) {
    var child = children[key];

    if (!(0, _react.isValidElement)(child)) return;

    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;

    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;

    // item is new (entering)
    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, { in: false });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });

  return children;
}

/***/ }),
/* 496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_func__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dom__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EventNotifications__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_redux_jigsaw_jigsaw_events__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_api_events__ = __webpack_require__(187);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SetFocusOnPageLoad=function(_React$Component){_inherits(SetFocusOnPageLoad,_React$Component);function SetFocusOnPageLoad(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SetFocusOnPageLoad);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SetFocusOnPageLoad.__proto__||Object.getPrototypeOf(SetFocusOnPageLoad)).call.apply(_ref,[this].concat(args))),_this),_this.state={blocked:false},_this.modalOpened=function(){_this.setState({blocked:true});},_this.focusAfterTimeout=Object(__WEBPACK_IMPORTED_MODULE_1__utils_func__["c" /* once */])(function(){_this.timeoutId=setTimeout(function(){var container=__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(_this);var toFocus=Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["e" /* getFirstFocusableElement */])(container);if(toFocus){toFocus.focus();}},100);}),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SetFocusOnPageLoad,[{key:'componentDidMount',value:function componentDidMount(){document.addEventListener(__WEBPACK_IMPORTED_MODULE_6_app_api_events__["c" /* MODAL_OPENED */],this.modalOpened);}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearTimeout(this.timeoutId);document.removeEventListener(__WEBPACK_IMPORTED_MODULE_6_app_api_events__["c" /* MODAL_OPENED */],this.modalOpened);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.props.children,!this.state.blocked&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__EventNotifications__["a" /* default */],{events:[__WEBPACK_IMPORTED_MODULE_5__api_redux_jigsaw_jigsaw_events__["PAGE_LOAD"]],onJigsawEvent:this.focusAfterTimeout,retryInterval:10}));}}]);return SetFocusOnPageLoad;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (SetFocusOnPageLoad);

/***/ }),
/* 500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(26);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(502);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(158);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(86);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(85);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _reactDom2.default.createPortal !== undefined;

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      parent.removeChild(_this.node);
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

exports.default = Modal;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(503);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(504);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(158);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(505);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(86);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      bodyOpenClassName && classList.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus();
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen();
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus();
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.afterClose();
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      bodyOpenClassName && classList.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      return this.shouldBeClosed() ? null : _react2.default.createElement(
        "div",
        {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", overlayClassName),
          style: _extends({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        },
        _react2.default.createElement(
          "div",
          _extends({
            ref: this.setContentRef,
            style: _extends({}, contentStyles, this.props.style.content),
            className: this.buildClassName("content", className),
            tabIndex: "-1",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            "aria-label": this.props.contentLabel
          }, this.attributesFromObject("aria", this.props.aria || {}), this.attributesFromObject("data", this.props.data || {}), {
            "data-testid": this.props.testId
          }),
          this.props.children
        )
      );
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(157);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus();
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(157);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  var target;
  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof tabbable[x] === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  tabbable[x].focus();
}
module.exports = exports["default"];

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dumpClassLists = dumpClassLists;
var htmlClassList = {};
var docBodyClassList = {};

function dumpClassLists() {
  if (false) {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n";
    }

    classes = document.body.className;

    // eslint-disable-next-line max-len
    buffer += "\n\ndoc.body (" + classes + "):\n";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
    }

    buffer += "\n";

    // eslint-disable-next-line no-console
    console.log(buffer);
  }
}

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Manager = function (_Component) {
  _inherits(Manager, _Component);

  function Manager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Manager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
      _this._targetNode = node;
    }, _this._getTargetNode = function () {
      return _this._targetNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Manager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this._setTargetNode,
          getTargetNode: this._getTargetNode
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tag = _props.tag,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['tag', 'children']);

      if (tag !== false) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(tag, restProps, children);
      } else {
        return children;
      }
    }
  }]);

  return Manager;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Manager.childContextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
Manager.propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Manager.defaultProps = {
  tag: 'div'
};


/* harmony default export */ __webpack_exports__["a"] = (Manager);

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Target = function Target(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'div' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popperManager = context.popperManager;

  var targetRef = function targetRef(node) {
    popperManager.setTargetNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };

  if (typeof children === 'function') {
    var targetProps = { ref: targetRef };
    return children({ targetProps: targetProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps);

  if (typeof component === 'string') {
    componentProps.ref = targetRef;
  } else {
    componentProps.innerRef = targetRef;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
};

Target.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

Target.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

/* harmony default export */ __webpack_exports__["a"] = (Target);

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return placements; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_popper_js__ = __webpack_require__(509);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var placements = __WEBPACK_IMPORTED_MODULE_2_popper_js__["a" /* default */].placements;

var Popper = function (_Component) {
  _inherits(Popper, _Component);

  function Popper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
      _this._arrowNode = node;
    }, _this._getTargetNode = function () {
      if (_this.props.target) {
        return _this.props.target;
      } else if (!_this.context.popperManager || !_this.context.popperManager.getTargetNode()) {
        throw new Error('Target missing. Popper must be given a target from the Popper Manager, or as a prop.');
      }
      return _this.context.popperManager.getTargetNode();
    }, _this._getOffsets = function (data) {
      return Object.keys(data.offsets).map(function (key) {
        return data.offsets[key];
      });
    }, _this._isDataDirty = function (data) {
      if (_this.state.data) {
        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
      } else {
        return true;
      }
    }, _this._updateStateModifier = {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        if (_this._isDataDirty(data)) {
          _this.setState({ data: data });
        }
        return data;
      }
    }, _this._getPopperStyle = function () {
      var data = _this.state.data;


      if (!_this._popper || !data) {
        return {
          position: 'absolute',
          pointerEvents: 'none',
          opacity: 0
        };
      }

      return _extends({
        position: data.offsets.popper.position
      }, data.styles);
    }, _this._getPopperPlacement = function () {
      return _this.state.data ? _this.state.data.placement : undefined;
    }, _this._getPopperHide = function () {
      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
    }, _this._getArrowStyle = function () {
      if (!_this.state.data || !_this.state.data.offsets.arrow) {
        return {};
      } else {
        var _this$state$data$offs = _this.state.data.offsets.arrow,
            top = _this$state$data$offs.top,
            left = _this$state$data$offs.left;

        return { top: top, left: left };
      }
    }, _this._handlePopperRef = function (node) {
      _this._popperNode = node;
      if (node) {
        _this._createPopper();
      } else {
        _this._destroyPopper();
      }
      if (_this.props.innerRef) {
        _this.props.innerRef(node);
      }
    }, _this._scheduleUpdate = function () {
      _this._popper && _this._popper.scheduleUpdate();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popper, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popper: {
          setArrowNode: this._setArrowNode,
          getArrowStyle: this._getArrowStyle
        }
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(lastProps) {
      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled || lastProps.target !== this.props.target) {
        this._destroyPopper();
        this._createPopper();
      }
      if (lastProps.children !== this.props.children) {
        this._scheduleUpdate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._destroyPopper();
    }
  }, {
    key: '_createPopper',
    value: function _createPopper() {
      var _this2 = this;

      var _props = this.props,
          placement = _props.placement,
          eventsEnabled = _props.eventsEnabled,
          positionFixed = _props.positionFixed;

      var modifiers = _extends({}, this.props.modifiers, {
        applyStyle: { enabled: false },
        updateState: this._updateStateModifier
      });
      if (this._arrowNode) {
        modifiers.arrow = _extends({}, this.props.modifiers.arrow || {}, {
          element: this._arrowNode
        });
      }
      this._popper = new __WEBPACK_IMPORTED_MODULE_2_popper_js__["a" /* default */](this._getTargetNode(), this._popperNode, {
        placement: placement,
        positionFixed: positionFixed,
        eventsEnabled: eventsEnabled,
        modifiers: modifiers
      });

      // TODO: look into setTimeout scheduleUpdate call, without it, the popper will not position properly on creation
      setTimeout(function () {
        return _this2._scheduleUpdate();
      });
    }
  }, {
    key: '_destroyPopper',
    value: function _destroyPopper() {
      if (this._popper) {
        this._popper.destroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          component = _props2.component,
          innerRef = _props2.innerRef,
          placement = _props2.placement,
          eventsEnabled = _props2.eventsEnabled,
          positionFixed = _props2.positionFixed,
          modifiers = _props2.modifiers,
          children = _props2.children,
          restProps = _objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'positionFixed', 'modifiers', 'children']);

      var popperStyle = this._getPopperStyle();
      var popperPlacement = this._getPopperPlacement();
      var popperHide = this._getPopperHide();

      if (typeof children === 'function') {
        var popperProps = {
          ref: this._handlePopperRef,
          style: popperStyle,
          'data-placement': popperPlacement,
          'data-x-out-of-boundaries': popperHide
        };
        return children({
          popperProps: popperProps,
          restProps: restProps,
          scheduleUpdate: this._scheduleUpdate
        });
      }

      var componentProps = _extends({}, restProps, {
        style: _extends({}, restProps.style, popperStyle),
        'data-placement': popperPlacement,
        'data-x-out-of-boundaries': popperHide
      });

      if (typeof component === 'string') {
        componentProps.ref = this._handlePopperRef;
      } else {
        componentProps.innerRef = this._handlePopperRef;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
    }
  }]);

  return Popper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Popper.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
Popper.childContextTypes = {
  popper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
Popper.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(placements),
  eventsEnabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  positionFixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([
  // the following check is needed for SSR
  __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(typeof Element !== 'undefined' ? Element : Object), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    getBoundingClientRect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    clientWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    clientHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  })])
};
Popper.defaultProps = {
  component: 'div',
  placement: 'bottom',
  eventsEnabled: true,
  positionFixed: false,
  modifiers: {}
};


/* harmony default export */ __webpack_exports__["a"] = (Popper);

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.14.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var css = getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Tells if you are running Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @argument {number} version to check
 * @returns {Boolean} isIE
 */
var cache = {};

var isIE = function () {
  var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'all';

  version = version.toString();
  if (cache.hasOwnProperty(version)) {
    return cache[version];
  }
  switch (version) {
    case '11':
      cache[version] = navigator.userAgent.indexOf('Trident') !== -1;
      break;
    case '10':
      cache[version] = navigator.appVersion.indexOf('MSIE 10') !== -1;
      break;
    case 'all':
      cache[version] = navigator.userAgent.indexOf('Trident') !== -1 || navigator.userAgent.indexOf('MSIE') !== -1;
      break;
  }

  //Set IE
  cache.all = cache.all || Object.keys(cache).some(function (key) {
    return cache[key];
  });
  return cache[version];
};

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? html['offset' + axis] + computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')] + computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')] : 0);
}

function getWindowSizes() {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes() : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && parent.nodeName === 'HTML') {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  boundaries.left += padding;
  boundaries.top += padding;
  boundaries.right -= padding;
  boundaries.bottom -= padding;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var styles = getComputedStyle(element);
  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroy the popper
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger onUpdate callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  // floor sides to avoid blurry text
  var offsets = {
    left: Math.floor(popper.left),
    top: Math.floor(popper.top),
    bottom: Math.floor(popper.bottom),
    right: Math.floor(popper.right)
  };

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    top = -offsetParentRect.height + offsets.bottom;
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    left = -offsetParentRect.width + offsets.right;
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjuction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-right` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unitless, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the height.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > More on this [reading this issue](https://github.com/FezVrasta/popper.js/issues/373)
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * An scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper this makes sure the popper has always a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier, can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near eachothers
   * without leaving any gap between the two. Expecially useful when the arrow is
   * enabled and you want to assure it to point to its reference element.
   * It cares only about the first axis, you can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjuction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations).
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position,
     * the popper will never be placed outside of the defined boundaries
     * (except if keepTogether is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define you own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the informations used by Popper.js
 * this object get passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper.
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements.
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overriden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass as 3rd argument an object with the same
 * structure of this object, example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated, this callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Create a new Popper.js instance
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as popper.
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedule an update, it will run on the next UI update available
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(33)))

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Arrow = function Arrow(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'span' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popper = context.popper;

  var arrowRef = function arrowRef(node) {
    popper.setArrowNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };
  var arrowStyle = popper.getArrowStyle();

  if (typeof children === 'function') {
    var arrowProps = {
      ref: arrowRef,
      style: arrowStyle
    };
    return children({ arrowProps: arrowProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps, {
    style: _extends({}, arrowStyle, restProps.style)
  });

  if (typeof component === 'string') {
    componentProps.ref = arrowRef;
  } else {
    componentProps.innerRef = arrowRef;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
};

Arrow.contextTypes = {
  popper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

Arrow.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

/* harmony default export */ __webpack_exports__["a"] = (Arrow);

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__withBrand__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_utils_objects__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
function BrandToggleBoolean(_ref){var children=_ref.children,brand=_ref.brand,configKey=_ref.configKey;var configVal=Object(__WEBPACK_IMPORTED_MODULE_2_app_utils_objects__["b" /* findKeyInObj */])(brand,configKey);if(configVal){return children[0];}return children[1];}BrandToggleBoolean.propTypes={brand:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,configKey:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,children:function children(props,propName){var arr=__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.toArray(props[propName]);if(arr.length!==2){return new Error('Invalid children. Exactly two must be provided');}}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__withBrand__["a" /* default */])(BrandToggleBoolean));

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findBookmarkForThumb;
function bookmarkMatchesThumb(bookmark,thumb){return bookmark.page===thumb.label;}function findBookmarkForThumb(bookmarks,thumb){return bookmarks.filter(function(b){return bookmarkMatchesThumb(b,thumb);})[0];}

/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof='function'==typeof Symbol&&'symbol'==typeof Symbol.iterator?function(obj){return typeof obj}:function(obj){return obj&&'function'==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?'symbol':typeof obj},_extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_templateObject=_taggedTemplateLiteral(['\n  /* Remove the margin in Firefox and Safari. */\n  margin: 0;\n\n  /* Show the overflow in IE. */\n  overflow: visible;\n\n  /* Remove the inheritance of text transform in Edge, Firefox, and IE. */\n  text-transform: none;\n\n  /* Remove the inner border and padding in Firefox. */\n  &::-moz-focus-inner {\n    border-style: none;\n    padding: 0;\n  }\n\n  /* Restore the focus styles unset by the previous rule. */\n  &:-moz-focusring {\n    outline: 1px dotted;\n  }\n\n  /* Change the cursor in all browsers. */\n  cursor: pointer;\n\n  /* Restore the default cursor to disabled elements unset by the previous rule. */\n  &:disabled {\n    cursor: default;\n  }\n\n  /* Remove gaps in links underline in iOS 8+ and Safari 8+. */\n  text-decoration-skip: objects;\n  text-decoration-skip-ink: none;\n'],['\n  /* Remove the margin in Firefox and Safari. */\n  margin: 0;\n\n  /* Show the overflow in IE. */\n  overflow: visible;\n\n  /* Remove the inheritance of text transform in Edge, Firefox, and IE. */\n  text-transform: none;\n\n  /* Remove the inner border and padding in Firefox. */\n  &::-moz-focus-inner {\n    border-style: none;\n    padding: 0;\n  }\n\n  /* Restore the focus styles unset by the previous rule. */\n  &:-moz-focusring {\n    outline: 1px dotted;\n  }\n\n  /* Change the cursor in all browsers. */\n  cursor: pointer;\n\n  /* Restore the default cursor to disabled elements unset by the previous rule. */\n  &:disabled {\n    cursor: default;\n  }\n\n  /* Remove gaps in links underline in iOS 8+ and Safari 8+. */\n  text-decoration-skip: objects;\n  text-decoration-skip-ink: none;\n']),_templateObject2=_taggedTemplateLiteral(['\n      /* top/bottom padding needs to be 0 so <button> and <a> render the same\n      (<button> has some padding by default) */\n      padding: 0 ',';\n    '],['\n      /* top/bottom padding needs to be 0 so <button> and <a> render the same\n      (<button> has some padding by default) */\n      padding: 0 ',';\n    ']),_templateObject3=_taggedTemplateLiteral(['\n      max-width: ',';\n      height: ',';\n    '],['\n      max-width: ',';\n      height: ',';\n    ']),_templateObject4=_taggedTemplateLiteral(['\n      margin-',': ',';\n    '],['\n      margin-',': ',';\n    ']),_templateObject5=_taggedTemplateLiteral(['\n          fill: ','; /* cloud 5 */\n        '],['\n          fill: ','; /* cloud 5 */\n        ']),_templateObject6=_taggedTemplateLiteral(['\n        display: inline;\n      '],['\n        display: inline;\n      ']),_templateObject7=_taggedTemplateLiteral(['\n      display: inline-block;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    '],['\n      display: inline-block;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    ']),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes),_styledComponents=__webpack_require__(8),_styledComponents2=_interopRequireDefault(_styledComponents),_themes=__webpack_require__(5),_styles=__webpack_require__(17),_propTypes3=__webpack_require__(10),_Tooltip=__webpack_require__(578),_Tooltip2=_interopRequireDefault(_Tooltip),_componentTheme=__webpack_require__(581),_componentTheme2=_interopRequireDefault(_componentTheme),_utils=__webpack_require__(25);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj)0<=keys.indexOf(i)||Object.prototype.hasOwnProperty.call(obj,i)&&(target[i]=obj[i]);return target}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}))}var getVariant=function(color,naked,secondary){if('neutral'===color)return naked?'neutralNaked':'neutral';return'white'===color?naked?'whiteNaked':'white':secondary?naked?'themeSecondaryNaked':'themeSecondary':naked?'themePrimaryNaked':'themePrimary'},getVariantStyle=function(property,state){return function(props){var _props$sc=props.sc,color=_props$sc.color,naked=_props$sc.naked,secondary=_props$sc.secondary,variant=getVariant(color,naked,secondary),token='Button_'+property+'_'+variant+(state?'_'+state:'');return(0,_themes.getStyle)(token)}},getHeight=function(){return function(props){var _props$sc2=props.sc,inline=_props$sc2.inline,size=_props$sc2.size;if(inline)return'auto';var _props$theme$vstui=props.theme.vstui,rem=_props$theme$vstui.rem,typography=_props$theme$vstui.typography,minHeight=(0,_themes.getStyle)('Button_minHeight_'+size)(props),height=Math.max(minHeight,1.5*typography.fontSize);return rem(height)}},normalizeStyles=(0,_styles.css)(_templateObject),Styled={div:{},span:{}};Styled.Tooltip=(0,_styledComponents2.default)(_Tooltip2.default).withConfig({displayName:'Button__Tooltip'})(['display:inline-block;width:',';'],function(_ref){var sc=_ref.sc;return sc.fullWidth&&'100%'}),Styled.button=_styledComponents2.default.button.withConfig({displayName:'Button__button'})(['',';',';display:',';box-sizing:border-box;align-items:center;width:',';max-width:100%;height:',';min-height:',';',';background-color:',';border-width:',';border-style:',';border-color:',';border-radius:',';color:',';font-family:',';font-size:',';font-weight:',';text-decoration:',';-webkit-font-smoothing:antialiased;transition-property:none;transition-duration:',';transition-timing-function:',';&:-moz-focusring{outline-color:',';}&:focus{background-color:',';border-color:',';outline:none;box-shadow:',';color:',';}&:hover{background-color:',';border-color:',';color:',';&:focus{border-color:',';}}&:active{background-color:',';border-color:',';color:',';}&:disabled{background-color:',';border-color:',';color:',';font-weight:',';text-decoration:none;}'],function(props){return props.inheritStyles?'':_styles.resetInheritedStyles},normalizeStyles,function(_ref2){var sc=_ref2.sc;return sc.inline?'inline':'inline-flex'},function(_ref3){var sc=_ref3.sc;return sc.fullWidth&&'100%'},getHeight(),getHeight(),function(_ref4){var sc=_ref4.sc,fullWidth=sc.fullWidth,iconEnd=sc.iconEnd,iconStart=sc.iconStart,inline=sc.inline,size=sc.size;if(inline)return 0;var paddingHorizontal,sizeCapitalized=size.replace(/^\w/,function(letter){return letter.toUpperCase()});return paddingHorizontal=fullWidth?(0,_themes.getStyle)('Button_paddingHorizontal_fullWidth'):iconStart||iconEnd?(0,_themes.getStyle)('Button_paddingHorizontal_withIcon'+sizeCapitalized):(0,_themes.getStyle)('Button_paddingHorizontal_'+size),(0,_styles.css)(_templateObject2,paddingHorizontal)},getVariantStyle('backgroundColor'),(0,_themes.getStyle)('Button_borderWidth'),(0,_themes.getStyle)('Button_borderStyle'),getVariantStyle('borderColor'),(0,_themes.getStyle)('Button_borderRadius'),getVariantStyle('color'),(0,_themes.getStyle)('Button_fontFamily'),function(props){return props.sc.inline?props.theme.vstui.rem((0,_themes.getStyle)('Button_fontSize_inline')(props)):props.theme.vstui.rem((0,_themes.getStyle)('Button_fontSize_'+props.sc.size)(props))},function(_ref5){var sc=_ref5.sc,theme=_ref5.theme,color=sc.color,naked=sc.naked,secondary=sc.secondary;return naked?theme.vstui.Button_fontWeight_naked:'neutral'===color?theme.vstui.Button_fontWeight_neutral:'white'===color?theme.vstui.Button_fontWeight_white:secondary?theme.vstui.Button_fontWeight_themeSecondary:theme.vstui.Button_fontWeight_themePrimary},function(props){return props.sc.inline?(0,_themes.getStyle)('Button_textDecoration_inline'):(0,_themes.getStyle)('Button_textDecoration')},(0,_themes.getStyle)('Button_transitionDuration'),function(_ref6){var theme=_ref6.theme;return theme.vstui.Button_transitionEasing},function(_ref7){var sc=_ref7.sc,theme=_ref7.theme,color=sc.color,secondary=sc.secondary;return'neutral'===color?null:'white'===color?theme.vstui.Button_backgroundColor_white:secondary?theme.vstui.Button_backgroundColor_themeSecondary_hover:theme.vstui.Button_backgroundColor_themePrimary_hover},getVariantStyle('backgroundColor','focus'),getVariantStyle('borderColor','focus'),getVariantStyle('boxShadow','focus'),getVariantStyle('color','focus'),getVariantStyle('backgroundColor','hover'),getVariantStyle('borderColor','hover'),getVariantStyle('color','hover'),getVariantStyle('borderColor','focus'),getVariantStyle('backgroundColor','active'),getVariantStyle('borderColor','active'),getVariantStyle('color','active'),getVariantStyle('backgroundColor','disabled'),getVariantStyle('borderColor','disabled'),getVariantStyle('color','disabled'),(0,_themes.getStyle)('Button_fontWeight_disabled')),Styled.button.displayName='Styled_button',Styled.a=Styled.button.withComponent('a'),Styled.a.displayName='Styled_a',Styled.div.buttonContent=_styledComponents2.default.div.withConfig({displayName:'Button__buttonContent'})(['display:',';align-items:center;justify-content:',';min-width:100%;'],function(_ref8){var sc=_ref8.sc;return sc.inline?'inline':'flex'},function(_ref9){var theme=_ref9.theme;return theme.vstui.ButtonContent_justifyContent}),Styled.div.iconWrapper=_styledComponents2.default.div.withConfig({displayName:'Button__iconWrapper'})(['display:flex;align-self:center;flex-shrink:0;',';',';svg{max-width:100%;max-height:100%;}',':disabled & > svg{',';}'],function(_ref10){var sc=_ref10.sc,theme=_ref10.theme,size=sc.size,height=theme.vstui['size_'+size],iconSize='auto';return 28>height?iconSize='14px':32>height&&(iconSize='16px'),(0,_styles.css)(_templateObject3,iconSize,iconSize)},function(_ref11){var sc=_ref11.sc,hasContent=sc.hasContent,iconPosition=sc.iconPosition,naked=sc.naked,margin='0';hasContent&&(naked&&(margin='6px'),margin='10px');var side='start'===iconPosition?'right':'left';return(0,_styles.css)(_templateObject4,side,margin)},Styled.button,function(_ref12){var sc=_ref12.sc,color=sc.color;return'theme'===color||'neutral'===color?(0,_styles.css)(_templateObject5,(0,_themes.getStyle)('ButtonIcon_fill_disabled')):null}),Styled.div.labelText=_styledComponents2.default.div.withConfig({displayName:'Button__labelText'})(['',';'],function(_ref13){var sc=_ref13.sc,inline=sc.inline;return inline?(0,_styles.css)(_templateObject6):(0,_styles.css)(_templateObject7)}),Styled.div.labelText.displayName='Styled_div_label',Styled.span.hidden=_styledComponents2.default.span.withConfig({displayName:'Button__hidden'})(['',';'],(0,_styles.visuallyHidden)());var Button=function(_Component){function Button(){_classCallCheck(this,Button);var _this=_possibleConstructorReturn(this,(Button.__proto__||Object.getPrototypeOf(Button)).call(this));return _this.tooltipId=(0,_utils.generateUniqueId)('tooltip'),_this}return _inherits(Button,_Component),_createClass(Button,[{key:'renderButton',value:function renderButton(_ref14){var theme=_ref14.theme,tooltipId=_ref14.tooltipId,_props=this.props,children=_props.children,className=_props.className,color=_props.color,colorBehindButton=_props.colorBehindButton,description=_props.description,disabled=_props.disabled,fullWidth=_props.fullWidth,href=_props.href,iconEndProp=_props.iconEnd,iconStartProp=_props.iconStart,inline=_props.inline,inheritStyles=_props.inheritStyles,label=_props.label,nakedProp=_props.naked,secondary=_props.secondary,size=_props.size,target=_props.target,themeIgnored=_props.theme,tooltipPlacementIgnored=_props.tooltipPlacement,otherProps=_objectWithoutProperties(_props,['children','className','color','colorBehindButton','description','disabled','fullWidth','href','iconEnd','iconStart','inline','inheritStyles','label','naked','secondary','size','target','theme','tooltipPlacement']),iconEnd=iconEndProp&&_react2.default.cloneElement(iconEndProp,{className:iconEndProp.props.className}),iconStart=iconStartProp&&_react2.default.cloneElement(iconStartProp,{className:iconStartProp.props.className}),hasContent=void 0!==children&&''!==children,ButtonComponent=href&&!disabled?Styled.a:Styled.button,conditionalProps={};description&&(conditionalProps['aria-describedby']=tooltipId),target&&(conditionalProps.rel='noopener'),tooltipId||(conditionalProps.className=className);var height=theme.vstui['size_'+size];return _react2.default.createElement(ButtonComponent,_extends({},otherProps,conditionalProps,{"aria-label":label,disabled:disabled,href:href,sc:{color:color,colorBehindButton:colorBehindButton,fullWidth:fullWidth,height:height,iconEnd:iconEnd,iconStart:iconStart,inline:inline,inheritStyles:inheritStyles,naked:inline||nakedProp,secondary:secondary,size:size},target:target,theme:theme}),_react2.default.createElement(Styled.div.buttonContent,{sc:{fullWidth:fullWidth,inline:inline},theme:theme},iconStart&&_react2.default.createElement(Styled.div.iconWrapper,{sc:{color:color,hasContent:hasContent,iconPosition:'start',size:size},theme:theme},iconStart),_react2.default.createElement(Styled.div.labelText,{sc:{inline:inline}},children,'_blank'===target&&_react2.default.createElement(Styled.span.hidden,null,' (opens in a new window)')),iconEnd&&_react2.default.createElement(Styled.div.iconWrapper,{sc:{color:color,height:height,hasContent:hasContent,iconPosition:'end'},theme:theme},iconEnd)))}},{key:'render',value:function render(){var _props2=this.props,className=_props2.className,description=_props2.description,disabled=_props2.disabled,fullWidth=_props2.fullWidth,inheritStyles=_props2.inheritStyles,label=_props2.label,themeProp=_props2.theme,tooltipPlacement=_props2.tooltipPlacement,theme=(0,_componentTheme2.default)(themeProp);return!disabled&&(description||label)?_react2.default.createElement(Styled.Tooltip,{className:className,id:this.tooltipId,placement:tooltipPlacement,sc:{fullWidth:fullWidth,inheritStyles:inheritStyles},theme:theme,title:description||label},this.renderButton({theme:theme,tooltipId:this.tooltipId})):this.renderButton({theme:theme})}}]),Button}(_react.Component);Button.propTypes={children:_propTypes2.default.node,className:_propTypes2.default.string,color:_propTypes2.default.oneOf(['theme','neutral','white']),colorBehindButton:function colorBehindButton(props,propName,componentName){if('white'===props.color&&!props.naked&&!props.inline){if(props[propName]===void 0)return new Error('Please add prop `'+propName+'` to `'+componentName+'`');if('string'!=typeof props[propName])return new Error('Invalid prop `'+propName+'` of type `'+_typeof(props[propName])+'` supplied to `'+componentName+'`, expected `string`.')}},description:_propTypes2.default.string,disabled:_propTypes2.default.bool,fullWidth:_propTypes2.default.bool,href:_propTypes2.default.string,iconEnd:function(props,propName,componentName){var iconEnd=props[propName];if(iconEnd&&'Icon'!==iconEnd.type.vstuiName)return new Error('Invalid prop `'+propName+'` of type `'+iconEnd.type.displayName+'` supplied to `'+componentName+'`, expected instance of `Icon`.')},iconStart:function(props,propName,componentName){var iconStart=props[propName];if(iconStart&&'Icon'!==iconStart.type.vstuiName)return new Error('Invalid prop `'+propName+'` of type `'+iconStart.type.displayName+'` supplied to `'+componentName+'`, expected instance of `Icon`.')},inheritStyles:_propTypes2.default.bool,inline:_propTypes2.default.bool,label:function label(props,propName,componentName){if(props.children===void 0||''===props.children){if(props[propName]===void 0)return new Error('Please add either prop `'+propName+'` or prop `children` to `'+componentName+'`.');if('string'!=typeof props[propName])return new Error('Invalid prop `'+propName+'` of type `'+_typeof(props[propName])+'` supplied to `'+componentName+'`, expected `string`.')}},naked:_propTypes2.default.bool,secondary:_propTypes2.default.bool,size:_propTypes2.default.oneOf(['small','medium','large']),target:_propTypes2.default.string,theme:_propTypes3.themeShape,tooltipPlacement:_propTypes2.default.oneOf(['auto','top','right','bottom','left','auto-start','top-start','right-start','bottom-start','left-start','auto-end','top-end','right-end','bottom-end','left-end'])},Button.defaultProps={color:'theme',size:'medium',tooltipPlacement:'top',theme:(0,_themes.createTheme)()},Button.displayName='Button';var ButtonWithTheme=(0,_themes.withTheme)(Button);ButtonWithTheme.WrappedComponent=Button,exports.default=ButtonWithTheme;

/***/ }),
/* 521 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(523);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */
(function (factory) {/* eslint-disable */
	 true ? (module['exports'] = factory(null)) :
		typeof define === 'function' && define['amd'] ? define(factory(null)) :
			(window['stylis'] = factory(null))
}(/** @param {*=} options */function factory (options) {/* eslint-disable */

	'use strict'

	/**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */

	var nullptn = /^\0+/g /* matches leading null characters */
	var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
	var colonptn = /: */g /* splits animation rules */
	var cursorptn = /zoo|gra/ /* assert cursor varient */
	var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
	var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
	var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
	var elementptn = / *[\0] */g /* selector elements */
	var selectorptn = /,\r+?/g /* splits selectors */
	var andptn = /([\t\r\n ])*\f?&/g /* match & */
	var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
	var invalidptn = /\W+/g /* removes invalid characters from keyframes */
	var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
	var plcholdrptn = /::(place)/g /* match ::placeholder varient */
	var readonlyptn = /:(read-only)/g /* match :read-only varient */
	var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
	var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
	var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
	var whiteptn = /\s{2,}/g /* matches repeating whitespace */
	var pseudoptn = /([^\(])(:+) */g /* pseudo element */
	var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
	var gradientptn = /([\w-]+t\()/g /* match *gradient property */
	var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
	var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
	var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
	var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
	var trimptn = /[ \t]+$/ /* match tail whitspace */
	var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */
	var imgsrcptn = /([^-])(image-set\()/

	/* vendors */
	var webkit = '-webkit-'
	var moz = '-moz-'
	var ms = '-ms-'

	/* character codes */
	var SEMICOLON = 59 /* ; */
	var CLOSEBRACES = 125 /* } */
	var OPENBRACES = 123 /* { */
	var OPENPARENTHESES = 40 /* ( */
	var CLOSEPARENTHESES = 41 /* ) */
	var OPENBRACKET = 91 /* [ */
	var CLOSEBRACKET = 93 /* ] */
	var NEWLINE = 10 /* \n */
	var CARRIAGE = 13 /* \r */
	var TAB = 9 /* \t */
	var AT = 64 /* @ */
	var SPACE = 32 /*   */
	var AND = 38 /* & */
	var DASH = 45 /* - */
	var UNDERSCORE = 95 /* _ */
	var STAR = 42 /* * */
	var COMMA = 44 /* , */
	var COLON = 58 /* : */
	var SINGLEQUOTE = 39 /* ' */
	var DOUBLEQUOTE = 34 /* " */
	var FOWARDSLASH = 47 /* / */
	var GREATERTHAN = 62 /* > */
	var PLUS = 43 /* + */
	var TILDE = 126 /* ~ */
	var NULL = 0 /* \0 */
	var FORMFEED = 12 /* \f */
	var VERTICALTAB = 11 /* \v */

	/* special identifiers */
	var KEYFRAME = 107 /* k */
	var MEDIA = 109 /* m */
	var SUPPORTS = 115 /* s */
	var PLACEHOLDER = 112 /* p */
	var READONLY = 111 /* o */
	var IMPORT = 105 /* <at>i */
	var CHARSET = 99 /* <at>c */
	var DOCUMENT = 100 /* <at>d */
	var PAGE = 112 /* <at>p */

	var column = 1 /* current column */
	var line = 1 /* current line numebr */
	var pattern = 0 /* :pattern */

	var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
	var prefix = 1 /* vendor prefix */
	var escape = 1 /* escape :global() pattern */
	var compress = 0 /* compress output */
	var semicolon = 0 /* no/semicolon option */
	var preserve = 0 /* preserve empty selectors */

	/* empty reference */
	var array = []

	/* plugins */
	var plugins = []
	var plugged = 0
	var should = null

	/* plugin context */
	var POSTS = -2
	var PREPS = -1
	var UNKWN = 0
	var PROPS = 1
	var BLCKS = 2
	var ATRUL = 3

	/* plugin newline context */
	var unkwn = 0

	/* keyframe animation */
	var keyed = 1
	var key = ''

	/* selector namespace */
	var nscopealt = ''
	var nscope = ''

	/**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */
	function compile (parent, current, body, id, depth) {
		var bracket = 0 /* brackets [] */
		var comment = 0 /* comments /* // or /* */
		var parentheses = 0 /* functions () */
		var quote = 0 /* quotes '', "" */

		var first = 0 /* first character code */
		var second = 0 /* second character code */
		var code = 0 /* current character code */
		var tail = 0 /* previous character code */
		var trail = 0 /* character before previous code */
		var peak = 0 /* previous non-whitespace code */

		var counter = 0 /* count sequence termination */
		var context = 0 /* track current context */
		var atrule = 0 /* track @at-rule context */
		var pseudo = 0 /* track pseudo token index */
		var caret = 0 /* current character index */
		var format = 0 /* control character formating context */
		var insert = 0 /* auto semicolon insertion */
		var invert = 0 /* inverted selector pattern */
		var length = 0 /* generic length address */
		var eof = body.length /* end of file(length) */
		var eol = eof - 1 /* end of file(characters) */

		var char = '' /* current character */
		var chars = '' /* current buffer of characters */
		var child = '' /* next buffer of characters */
		var out = '' /* compiled body */
		var children = '' /* compiled children */
		var flat = '' /* compiled leafs */
		var selector /* generic selector address */
		var result /* generic address */

		// ...build body
		while (caret < eof) {
			code = body.charCodeAt(caret)

			// eof varient
			if (caret === eol) {
				// last character + noop context, add synthetic padding for noop context to terminate
				if (comment + quote + parentheses + bracket !== 0) {
					if (comment !== 0) {
						code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
					}

					quote = parentheses = bracket = 0
					eof++
					eol++
				}
			}

			if (comment + quote + parentheses + bracket === 0) {
				// eof varient
				if (caret === eol) {
					if (format > 0) {
						chars = chars.replace(formatptn, '')
					}

					if (chars.trim().length > 0) {
						switch (code) {
							case SPACE:
							case TAB:
							case SEMICOLON:
							case CARRIAGE:
							case NEWLINE: {
								break
							}
							default: {
								chars += body.charAt(caret)
							}
						}

						code = SEMICOLON
					}
				}

				// auto semicolon insertion
				if (insert === 1) {
					switch (code) {
						// false flags
						case OPENBRACES:
						case CLOSEBRACES:
						case SEMICOLON:
						case DOUBLEQUOTE:
						case SINGLEQUOTE:
						case OPENPARENTHESES:
						case CLOSEPARENTHESES:
						case COMMA: {
							insert = 0
						}
						// ignore
						case TAB:
						case CARRIAGE:
						case NEWLINE:
						case SPACE: {
							break
						}
						// valid
						default: {
							insert = 0
							length = caret
							first = code
							caret--
							code = SEMICOLON

							while (length < eof) {
								switch (body.charCodeAt(length++)) {
									case NEWLINE:
									case CARRIAGE:
									case SEMICOLON: {
										++caret
										code = first
										length = eof
										break
									}
									case COLON: {
										if (format > 0) {
											++caret
											code = first
										}
									}
									case OPENBRACES: {
										length = eof
									}
								}
							}
						}
					}
				}

				// token varient
				switch (code) {
					case OPENBRACES: {
						chars = chars.trim()
						first = chars.charCodeAt(0)
						counter = 1
						length = ++caret

						while (caret < eof) {
							switch (code = body.charCodeAt(caret)) {
								case OPENBRACES: {
									counter++
									break
								}
								case CLOSEBRACES: {
									counter--
									break
								}
								case FOWARDSLASH: {
									switch (second = body.charCodeAt(caret + 1)) {
										// /*, //
										case STAR:
										case FOWARDSLASH: {
											caret = delimited(second, caret, eol, body)
										}
									}
									break
								}
								// given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
								case OPENBRACKET: {
									code++
								}
								// given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
								case OPENPARENTHESES: {
									code++
								}
								// quote tail delimiter is identical to the head delimiter hence noop,
								// fallthrough clauses have been shited to the correct tail delimiter
								case DOUBLEQUOTE:
								case SINGLEQUOTE: {
									while (caret++ < eol) {
										if (body.charCodeAt(caret) === code) {
											break
										}
									}
								}
							}

							if (counter === 0) {
								break
							}

							caret++
						}

						child = body.substring(length, caret)

						if (first === NULL) {
							first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
						}

						switch (first) {
							// @at-rule
							case AT: {
								if (format > 0) {
									chars = chars.replace(formatptn, '')
								}

								second = chars.charCodeAt(1)

								switch (second) {
									case DOCUMENT:
									case MEDIA:
									case SUPPORTS:
									case DASH: {
										selector = current
										break
									}
									default: {
										selector = array
									}
								}

								child = compile(current, selector, child, second, depth+1)
								length = child.length

								// preserve empty @at-rule
								if (preserve > 0 && length === 0) {
									length = chars.length
								}

								// execute plugins, @at-rule context
								if (plugged > 0) {
									selector = select(array, chars, invert)
									result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
									chars = selector.join('')

									if (result !== void 0) {
										if ((length = (child = result.trim()).length) === 0) {
											second = 0
											child = ''
										}
									}
								}

								if (length > 0) {
									switch (second) {
										case SUPPORTS: {
											chars = chars.replace(supportsptn, supports)
										}
										case DOCUMENT:
										case MEDIA:
										case DASH: {
											child = chars + '{' + child + '}'
											break
										}
										case KEYFRAME: {
											chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
											child = chars + '{' + child + '}'

											if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
												child = '@' + webkit + child + '@' + child
											} else {
												child = '@' + child
											}
											break
										}
										default: {
											child = chars + child

											if (id === PAGE) {
												child = (out += child, '')
											}
										}
									}
								} else {
									child = ''
								}

								break
							}
							// selector
							default: {
								child = compile(current, select(current, chars, invert), child, id, depth+1)
							}
						}

						children += child

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						atrule = 0
						chars = ''
						child = ''
						code = body.charCodeAt(++caret)
						break
					}
					case CLOSEBRACES:
					case SEMICOLON: {
						chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()

						if ((length = chars.length) > 1) {
							// monkey-patch missing colon
							if (pseudo === 0) {
								first = chars.charCodeAt(0)

								// first character is a letter or dash, buffer has a space character
								if ((first === DASH || first > 96 && first < 123)) {
									length = (chars = chars.replace(' ', ':')).length
								}
							}

							// execute plugins, property context
							if (plugged > 0) {
								if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
									if ((length = (chars = result.trim()).length) === 0) {
										chars = '\0\0'
									}
								}
							}

							first = chars.charCodeAt(0)
							second = chars.charCodeAt(1)

							switch (first) {
								case NULL: {
									break
								}
								case AT: {
									if (second === IMPORT || second === CHARSET) {
										flat += chars + body.charAt(caret)
										break
									}
								}
								default: {
									if (chars.charCodeAt(length-1) === COLON) {
										break
									}

									out += property(chars, first, second, chars.charCodeAt(2))
								}
							}
						}

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						chars = ''
						code = body.charCodeAt(++caret)
						break
					}
				}
			}

			// parse characters
			switch (code) {
				case CARRIAGE:
				case NEWLINE: {
					// auto insert semicolon
					if (comment + quote + parentheses + bracket + semicolon === 0) {
						// valid non-whitespace characters that
						// may precede a newline
						switch (peak) {
							case CLOSEPARENTHESES:
							case SINGLEQUOTE:
							case DOUBLEQUOTE:
							case AT:
							case TILDE:
							case GREATERTHAN:
							case STAR:
							case PLUS:
							case FOWARDSLASH:
							case DASH:
							case COLON:
							case COMMA:
							case SEMICOLON:
							case OPENBRACES:
							case CLOSEBRACES: {
								break
							}
							default: {
								// current buffer has a colon
								if (pseudo > 0) {
									insert = 1
								}
							}
						}
					}

					// terminate line comment
					if (comment === FOWARDSLASH) {
						comment = 0
					} else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
						format = 1
						chars += '\0'
					}

					// execute plugins, newline context
					if (plugged * unkwn > 0) {
						proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
					}

					// next line, reset column position
					column = 1
					line++
					break
				}
				case SEMICOLON:
				case CLOSEBRACES: {
					if (comment + quote + parentheses + bracket === 0) {
						column++
						break
					}
				}
				default: {
					// increment column position
					column++

					// current character
					char = body.charAt(caret)

					// remove comments, escape functions, strings, attributes and prepare selectors
					switch (code) {
						case TAB:
						case SPACE: {
							if (quote + bracket + comment === 0) {
								switch (tail) {
									case COMMA:
									case COLON:
									case TAB:
									case SPACE: {
										char = ''
										break
									}
									default: {
										if (code !== SPACE) {
											char = ' '
										}
									}
								}
							}
							break
						}
						// escape breaking control characters
						case NULL: {
							char = '\\0'
							break
						}
						case FORMFEED: {
							char = '\\f'
							break
						}
						case VERTICALTAB: {
							char = '\\v'
							break
						}
						// &
						case AND: {
							// inverted selector pattern i.e html &
							if (quote + comment + bracket === 0 && cascade > 0) {
								invert = 1
								format = 1
								char = '\f' + char
							}
							break
						}
						// ::p<l>aceholder, l
						// :read-on<l>y, l
						case 108: {
							if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
								switch (caret - pseudo) {
									// ::placeholder
									case 2: {
										if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
											pattern = tail
										}
									}
									// :read-only
									case 8: {
										if (trail === READONLY) {
											pattern = trail
										}
									}
								}
							}
							break
						}
						// :<pattern>
						case COLON: {
							if (quote + comment + bracket === 0) {
								pseudo = caret
							}
							break
						}
						// selectors
						case COMMA: {
							if (comment + parentheses + quote + bracket === 0) {
								format = 1
								char += '\r'
							}
							break
						}
						// quotes
						case DOUBLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						case SINGLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						// attributes
						case OPENBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket++
							}
							break
						}
						case CLOSEBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket--
							}
							break
						}
						// functions
						case CLOSEPARENTHESES: {
							if (quote + comment + bracket === 0) {
								parentheses--
							}
							break
						}
						case OPENPARENTHESES: {
							if (quote + comment + bracket === 0) {
								if (context === 0) {
									switch (tail*2 + trail*3) {
										// :matches
										case 533: {
											break
										}
										// :global, :not, :nth-child etc...
										default: {
											counter = 0
											context = 1
										}
									}
								}

								parentheses++
							}
							break
						}
						case AT: {
							if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
								atrule = 1
							}
							break
						}
						// block/line comments
						case STAR:
						case FOWARDSLASH: {
							if (quote + bracket + parentheses > 0) {
								break
							}

							switch (comment) {
								// initialize line/block comment context
								case 0: {
									switch (code*2 + body.charCodeAt(caret+1)*3) {
										// //
										case 235: {
											comment = FOWARDSLASH
											break
										}
										// /*
										case 220: {
											length = caret
											comment = STAR
											break
										}
									}
									break
								}
								// end block comment context
								case STAR: {
									if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
										// /*<!> ... */, !
										if (body.charCodeAt(length+2) === 33) {
											out += body.substring(length, caret+1)
										}
										char = ''
										comment = 0
									}
								}
							}
						}
					}

					// ignore comment blocks
					if (comment === 0) {
						// aggressive isolation mode, divide each individual selector
						// including selectors in :not function but excluding selectors in :global function
						if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
							switch (code) {
								case COMMA:
								case TILDE:
								case GREATERTHAN:
								case PLUS:
								case CLOSEPARENTHESES:
								case OPENPARENTHESES: {
									if (context === 0) {
										// outside of an isolated context i.e nth-child(<...>)
										switch (tail) {
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												char = char + '\0'
												break
											}
											default: {
												char = '\0' + char + (code === COMMA ? '' : '\0')
											}
										}
										format = 1
									} else {
										// within an isolated context, sleep untill it's terminated
										switch (code) {
											case OPENPARENTHESES: {
												// :globa<l>(
												if (pseudo + 7 === caret && tail === 108) {
													pseudo = 0
												}
												context = ++counter
												break
											}
											case CLOSEPARENTHESES: {
												if ((context = --counter) === 0) {
													format = 1
													char += '\0'
												}
												break
											}
										}
									}
									break
								}
								case TAB:
								case SPACE: {
									switch (tail) {
										case NULL:
										case OPENBRACES:
										case CLOSEBRACES:
										case SEMICOLON:
										case COMMA:
										case FORMFEED:
										case TAB:
										case SPACE:
										case NEWLINE:
										case CARRIAGE: {
											break
										}
										default: {
											// ignore in isolated contexts
											if (context === 0) {
												format = 1
												char += '\0'
											}
										}
									}
								}
							}
						}

						// concat buffer of characters
						chars += char

						// previous non-whitespace character code
						if (code !== SPACE && code !== TAB) {
							peak = code
						}
					}
				}
			}

			// tail character codes
			trail = tail
			tail = code

			// visit every character
			caret++
		}

		length = out.length

		// preserve empty selector
 		if (preserve > 0) {
 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
					length = current.join(',').length + 2
 				}
 			}
		}

		if (length > 0) {
			// cascade isolation mode?
			selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current

			// execute plugins, block context
			if (plugged > 0) {
				result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)

				if (result !== void 0 && (out = result).length === 0) {
					return flat + out + children
				}
			}

			out = selector.join(',') + '{' + out + '}'

			if (prefix*pattern !== 0) {
				if (prefix === 2 && !vendor(out, 2))
					pattern = 0

				switch (pattern) {
					// ::read-only
					case READONLY: {
						out = out.replace(readonlyptn, ':'+moz+'$1')+out
						break
					}
					// ::placeholder
					case PLACEHOLDER: {
						out = (
							out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
							out.replace(plcholdrptn, '::' + moz + '$1') +
							out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
						)
						break
					}
				}

				pattern = 0
			}
		}

		return flat + out + children
	}

	/**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */
	function select (parent, current, invert) {
		var selectors = current.trim().split(selectorptn)
		var out = selectors

		var length = selectors.length
		var l = parent.length

		switch (l) {
			// 0-1 parent selectors
			case 0:
			case 1: {
				for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
					out[i] = scope(selector, out[i], invert, l).trim()
				}
				break
			}
			// >2 parent selectors, nested
			default: {
				for (var i = 0, j = 0, out = []; i < length; ++i) {
					for (var k = 0; k < l; ++k) {
						out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
					}
				}
			}
		}

		return out
	}

	/**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */
	function scope (parent, current, invert, level) {
		var selector = current
		var code = selector.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (selector = selector.trim()).charCodeAt(0)
		}

		switch (code) {
			// &
			case AND: {
				switch (cascade + level) {
					case 0:
					case 1: {
						if (parent.trim().length === 0) {
							break
						}
					}
					default: {
						return selector.replace(andptn, '$1'+parent.trim())
					}
				}
				break
			}
			// :
			case COLON: {
				switch (selector.charCodeAt(1)) {
					// g in :global
					case 103: {
						if (escape > 0 && cascade > 0) {
							return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
						}
						break
					}
					default: {
						// :hover
						return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
					}
				}
			}
			default: {
				// html &
				if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
					return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
				}
			}
		}

		return parent + selector
	}

	/**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */
	function property (input, first, second, third) {
		var index = 0
		var out = input + ';'
		var hash = (first*2) + (second*3) + (third*4)
		var cache

		// animation: a, n, i characters
		if (hash === 944) {
			return animation(out)
		} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
			return out
		}

		// vendor prefix
		switch (hash) {
			// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
			case 1015: {
				// text-shadow/text-align/text-transform, a
				return out.charCodeAt(10) === 97 ? webkit + out + out : out
			}
			// filter/fill f, i, l
			case 951: {
				// filter, t
				return out.charCodeAt(3) === 116 ? webkit + out + out : out
			}
			// color/column, c, o, l
			case 963: {
				// column, n
				return out.charCodeAt(5) === 110 ? webkit + out + out : out
			}
			// box-decoration-break, b, o, x
			case 1009: {
				if (out.charCodeAt(4) !== 100) {
					break
				}
			}
			// mask, m, a, s
			// clip-path, c, l, i
			case 969:
			case 942: {
				return webkit + out + out
			}
			// appearance: a, p, p
			case 978: {
				return webkit + out + moz + out + out
			}
			// hyphens: h, y, p
			// user-select: u, s, e
			case 1019:
			case 983: {
				return webkit + out + moz + out + ms + out + out
			}
			// background/backface-visibility, b, a, c
			case 883: {
				// backface-visibility, -
				if (out.charCodeAt(8) === DASH) {
					return webkit + out + out
				}

				// image-set(...)
				if (out.indexOf('image-set(', 11) > 0) {
					return out.replace(imgsrcptn, '$1'+webkit+'$2') + out
				}

				return out
			}
			// flex: f, l, e
			case 932: {
				if (out.charCodeAt(4) === DASH) {
					switch (out.charCodeAt(5)) {
						// flex-grow, g
						case 103: {
							return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
						}
						// flex-shrink, s
						case 115: {
							return webkit + out + ms + out.replace('shrink', 'negative') + out
						}
						// flex-basis, b
						case 98: {
							return webkit + out + ms + out.replace('basis', 'preferred-size') + out
						}
					}
				}

				return webkit + out + ms + out + out
			}
			// order: o, r, d
			case 964: {
				return webkit + out + ms + 'flex' + '-' + out + out
			}
			// justify-items/justify-content, j, u, s
			case 1023: {
				// justify-content, c
				if (out.charCodeAt(8) !== 99) {
					break
				}

				cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
				return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
			}
			// cursor, c, u, r
			case 1005: {
				return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
			}
			// writing-mode, w, r, i
			case 1000: {
				cache = out.substring(13).trim()
				index = cache.indexOf('-') + 1

				switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
					// vertical-lr
					case 226: {
						cache = out.replace(writingptn, 'tb')
						break
					}
					// vertical-rl
					case 232: {
						cache = out.replace(writingptn, 'tb-rl')
						break
					}
					// horizontal-tb
					case 220: {
						cache = out.replace(writingptn, 'lr')
						break
					}
					default: {
						return out
					}
				}

				return webkit + out + ms + cache + out
			}
			// position: sticky
			case 1017: {
				if (out.indexOf('sticky', 9) === -1) {
					return out
				}
			}
			// display(flex/inline-flex/inline-box): d, i, s
			case 975: {
				index = (out = input).length - 10
				cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()

				switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
					// inline-
					case 203: {
						// inline-box
						if (cache.charCodeAt(8) < 111) {
							break
						}
					}
					// inline-box/sticky
					case 115: {
						out = out.replace(cache, webkit+cache)+';'+out
						break
					}
					// inline-flex
					// flex
					case 207:
					case 102: {
						out = (
							out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
							out.replace(cache, webkit+cache)+';'+
							out.replace(cache, ms+cache+'box')+';'+
							out
						)
					}
				}

				return out + ';'
			}
			// align-items, align-center, align-self: a, l, i, -
			case 938: {
				if (out.charCodeAt(5) === DASH) {
					switch (out.charCodeAt(6)) {
						// align-items, i
						case 105: {
							cache = out.replace('-items', '')
							return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
						}
						// align-self, s
						case 115: {
							return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
						}
						// align-content
						default: {
							return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
						}
					}
				}
				break
			}
			// min/max
			case 973:
			case 989: {
				// min-/max- height/width/block-size/inline-size
				if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
					break
				}
			}
			// height/width: min-content / width: max-content
			case 931:
			case 953: {
				if (dimensionptn.test(input) === true) {
					// stretch
					if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
						return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
					else
						return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
				}
				break
			}
			// transform, transition: t, r, a
			case 962: {
				out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out

				// transitions
				if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
					return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
				}

				break
			}
		}

		return out
	}

	/**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */
	function vendor (content, context) {
		var index = content.indexOf(context === 1 ? ':' : '{')
		var key = content.substring(0, context !== 3 ? index : 10)
		var value = content.substring(index + 1, content.length - 1)

		return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
	}

	/**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */
	function supports (match, group) {
		var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))

		return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
	}

	/**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */
	function animation (input) {
		var length = input.length
		var index = input.indexOf(':', 9) + 1
		var declare = input.substring(0, index).trim()
		var out = input.substring(index, length-1).trim()

		switch (input.charCodeAt(9)*keyed) {
			case 0: {
				break
			}
			// animation-*, -
			case DASH: {
				// animation-name, n
				if (input.charCodeAt(10) !== 110) {
					break
				}
			}
			// animation/animation-name
			default: {
				// split in case of multiple animations
				var list = out.split((out = '', animationptn))

				for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
					var value = list[i]
					var items = value.split(propertiesptn)

					while (value = items[index]) {
						var peak = value.charCodeAt(0)

						if (keyed === 1 && (
							// letters
							(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
							// dash but not in sequence i.e --
							(peak === DASH && value.charCodeAt(1) !== DASH)
						)) {
							// not a number/function
							switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
								case 1: {
									switch (value) {
										// not a valid reserved keyword
										case 'infinite': case 'alternate': case 'backwards': case 'running':
										case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
										case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
										case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
										case 'initial': case 'unset': case 'step-start': case 'step-end': {
											break
										}
										default: {
											value += key
										}
									}
								}
							}
						}

						items[index++] = value
					}

					out += (i === 0 ? '' : ',') + items.join(' ')
				}
			}
		}

		out = declare + out + ';'

		if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
			return webkit + out + out

		return out
	}

	/**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */
	function isolate (current) {
		for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
			// split individual elements in a selector i.e h1 h2 === [h1, h2]
			var elements = current[i].split(elementptn)
			var out = ''

			for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
				// empty element
				if ((size = (element = elements[j]).length) === 0 && l > 1) {
					continue
				}

				tail = out.charCodeAt(out.length-1)
				code = element.charCodeAt(0)
				padding = ''

				if (j !== 0) {
					// determine if we need padding
					switch (tail) {
						case STAR:
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case OPENPARENTHESES:  {
							break
						}
						default: {
							padding = ' '
						}
					}
				}

				switch (code) {
					case AND: {
						element = padding + nscopealt
					}
					case TILDE:
					case GREATERTHAN:
					case PLUS:
					case SPACE:
					case CLOSEPARENTHESES:
					case OPENPARENTHESES: {
						break
					}
					case OPENBRACKET: {
						element = padding + element + nscopealt
						break
					}
					case COLON: {
						switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
							// :global
							case 530: {
								if (escape > 0) {
									element = padding + element.substring(8, size - 1)
									break
								}
							}
							// :hover, :nth-child(), ...
							default: {
								if (j < 1 || elements[j-1].length < 1) {
									element = padding + nscopealt + element
								}
							}
						}
						break
					}
					case COMMA: {
						padding = ''
					}
					default: {
						if (size > 1 && element.indexOf(':') > 0) {
							element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
						} else {
							element = padding + element + nscopealt
						}
					}
				}

				out += element
			}

			selector[i] = out.replace(formatptn, '').trim()
		}

		return selector
	}

	/**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */
	function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
		for (var i = 0, out = content, next; i < plugged; ++i) {
			switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
				case void 0:
				case false:
				case true:
				case null: {
					break
				}
				default: {
					out = next
				}
			}
		}

		switch (out) {
			case void 0:
			case false:
			case true:
			case null:
			case content: {
				break
			}
			default: {
				return out
			}
		}
	}

	/**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */
	function delimited (code, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				// /*
				case FOWARDSLASH: {
					if (code === STAR) {
						if (body.charCodeAt(i - 1) === STAR &&  index + 2 !== i) {
							return i + 1
						}
					}
					break
				}
				// //
				case NEWLINE: {
					if (code === FOWARDSLASH) {
						return i + 1
					}
				}
			}
		}

		return i
	}

	/**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */
	function match (type, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				case type: {
					return i
				}
			}
		}

		return i
	}

	/**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */
	function minify (output) {
		return output
			.replace(formatptn, '')
			.replace(beforeptn, '')
			.replace(afterptn, '$1')
			.replace(tailptn, '$1')
			.replace(whiteptn, ' ')
	}

	/**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */
	function use (plugin) {
		switch (plugin) {
			case void 0:
			case null: {
				plugged = plugins.length = 0
				break
			}
			default: {
				switch (plugin.constructor) {
					case Array: {
						for (var i = 0, length = plugin.length; i < length; ++i) {
							use(plugin[i])
						}
						break
					}
					case Function: {
						plugins[plugged++] = plugin
						break
					}
					case Boolean: {
						unkwn = !!plugin|0
					}
				}
			}
 		}

 		return use
	}

	/**
	 * Set
	 *
	 * @param {*} options
	 */
	function set (options) {
		for (var name in options) {
			var value = options[name]
			switch (name) {
				case 'keyframe': keyed = value|0; break
				case 'global': escape = value|0; break
				case 'cascade': cascade = value|0; break
				case 'compress': compress = value|0; break
				case 'semicolon': semicolon = value|0; break
				case 'preserve': preserve = value|0; break
				case 'prefix':
					should = null

					if (!value) {
						prefix = 0
					} else if (typeof value !== 'function') {
						prefix = 1
					} else {
						prefix = 2
						should = value
					}
			}
		}

		return set
	}

	/**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */
	function stylis (selector, input) {
		if (this !== void 0 && this.constructor === stylis) {
			return factory(selector)
		}

		// setup
		var ns = selector
		var code = ns.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (ns = ns.trim()).charCodeAt(0)
		}

		// keyframe/animation namespace
		if (keyed > 0) {
			key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
		}

		// reset, used to assert if a plugin is moneky-patching the return value
		code = 1

		// cascade/isolate
		if (cascade === 1) {
			nscope = ns
		} else {
			nscopealt = ns
		}

		var selectors = [nscope]
		var result

		// execute plugins, pre-process context
		if (plugged > 0) {
			result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)

			if (result !== void 0 && typeof result === 'string') {
				input = result
			}
		}

		// build
		var output = compile(array, selectors, input, 0, 0)

		// execute plugins, post-process context
		if (plugged > 0) {
			result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)

			// bypass minification
			if (result !== void 0 && typeof(output = result) !== 'string') {
				code = 0
			}
		}

		// reset
		key = ''
		nscope = ''
		nscopealt = ''
		pattern = 0
		line = 1
		column = 1

		return compress*code === 0 ? output : minify(output)
	}

	stylis['use'] = use
	stylis['set'] = set

	if (options !== void 0) {
		set(options)
	}

	return stylis
}));


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(527);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.2
 * react-is.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.forward_ref"):60112,n=b?Symbol.for("react.timeout"):60113;
function q(a){if("object"===typeof a&&null!==a){var p=a.$$typeof;switch(p){case c:switch(a=a.type,a){case l:case e:case g:case f:return a;default:switch(a=a&&a.$$typeof,a){case k:case m:case h:return a;default:return p}}case d:return p}}}exports.typeOf=q;exports.AsyncMode=l;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=m;exports.Fragment=e;exports.Profiler=g;exports.Portal=d;exports.StrictMode=f;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===l||a===g||a===f||a===n||"object"===typeof a&&null!==a&&(a.$$typeof===h||a.$$typeof===k||a.$$typeof===m)};exports.isAsyncMode=function(a){return q(a)===l};exports.isContextConsumer=function(a){return q(a)===k};exports.isContextProvider=function(a){return q(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return q(a)===m};
exports.isFragment=function(a){return q(a)===e};exports.isProfiler=function(a){return q(a)===g};exports.isPortal=function(a){return q(a)===d};exports.isStrictMode=function(a){return q(a)===f};


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _colors=__webpack_require__(163),black='#000000',white='#ffffff',transparent='rgba(0, 0, 0, 0)',createThemePalette=function(options){var _options$primary=options.primary,primary=_options$primary===void 0?_colors.ocean:_options$primary,_options$secondary=options.secondary,secondary=_options$secondary===void 0?primary:_options$secondary,_options$surface=options.surface,surface=_options$surface===void 0?white:_options$surface,_options$error=options.error,error=_options$error===void 0?'#cc313d':_options$error,_options$onPrimary=options.onPrimary,onPrimary=_options$onPrimary===void 0?white:_options$onPrimary,_options$onSecondary=options.onSecondary,onSecondary=_options$onSecondary===void 0?white:_options$onSecondary,_options$onSurface=options.onSurface,onSurface=_options$onSurface===void 0?_colors.ninja.getShade(11):_options$onSurface;return{primary:primary,secondary:secondary,surface:surface,onPrimary:onPrimary,onSecondary:onSecondary,onSurface:onSurface,error:error,black:black,white:white,transparent:transparent,cloud:_colors.cloud,ninja:_colors.ninja}};exports.default=createThemePalette;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=__webpack_require__(11),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var blue={1:'#eef7ff',2:'#deedfd',3:'#bddbf4',4:'#84baeb',5:'#3b8fde',6:'#1176d4',7:'#0d66b8',8:'#09549c',9:'#0a4276',10:'#072d52',inflection:6};exports.default=(0,_createColorPalette2.default)(blue,'blue');

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=__webpack_require__(11),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var brick={1:'#fef3f1',2:'#fac3bb',3:'#faa094',4:'#fa7d6d',5:'#eb4f3b',6:'#d24634',7:'#b83e2e',8:'#9e3528',9:'#7a291f',10:'#571d16',inflection:6};exports.default=(0,_createColorPalette2.default)(brick,'brick');

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=__webpack_require__(11),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var cheddar={1:'#fef3e9',2:'#fec491',3:'#fead64',4:'#f58525',5:'#e06107',6:'#ca500f',7:'#b0430c',8:'#983600',9:'#772700',10:'#571d00',inflection:6};exports.default=(0,_createColorPalette2.default)(cheddar,'cheddar');

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=__webpack_require__(11),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var cherry={1:'#f54250',2:'#cc313d'};exports.default=(0,_createColorPalette2.default)(cherry,'cherry');

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=__webpack_require__(11),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var cloud={1:'#fafafa',2:'#f6f6f6',3:'#ececec',4:'#dadada',5:'#949494',6:'#757575',7:'#646464',8:'#525252',9:'#3c3c3c',10:'#1c1c1c',inflection:6};exports.default=(0,_createColorPalette2.default)(cloud,'cloud');

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=__webpack_require__(11),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var eggplant={1:'#f8f5fa',2:'#ddcbe9',3:'#c4a4d9',4:'#b389d0',5:'#a775c9',6:'#945eb9',7:'#794d96',8:'#5e3c75',9:'#3f284f',10:'#2d1c38',inflection:6};exports.default=(0,_createColorPalette2.default)(eggplant,'eggplant');

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=__webpack_require__(11),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var gold={1:'#fff5dd',2:'#ffe29c',3:'#ffd560',4:'#e8b520',5:'#be8a0d',6:'#9a6f07',7:'#855f07',8:'#715005',9:'#5a4206',10:'#3b2b04',inflection:6};exports.default=(0,_createColorPalette2.default)(gold,'gold');

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=__webpack_require__(11),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var grass={1:'#21a921',2:'#0a870a'};exports.default=(0,_createColorPalette2.default)(grass,'grass');

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=__webpack_require__(11),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var green={1:'#edf7ed',2:'#d1ead1',3:'#a3d4a3',4:'#79c679',5:'#35a335',6:'#048a04',7:'#047103',8:'#015e02',9:'#024d03',10:'#023302',inflection:6};exports.default=(0,_createColorPalette2.default)(green,'green');

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=__webpack_require__(11),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var jungle={1:'#e8f7f2',2:'#c0eadb',3:'#86e0c2',4:'#24c991',5:'#1a9c6e',6:'#16825c',7:'#12694a',8:'#0d4f38',9:'#0a3c2b',10:'#07291d',inflection:6};exports.default=(0,_createColorPalette2.default)(jungle,'jungle');

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=__webpack_require__(11),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var magic={1:'#f2f4f9',2:'#d2d9ed',3:'#b2bee0',4:'#91a3d4',5:'#7188c7',6:'#5773bf',7:'#425ba1',8:'#334a88',9:'#24386e',10:'#002244',inflection:6};exports.default=(0,_createColorPalette2.default)(magic,'magic');

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=__webpack_require__(11),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var mist={1:'#ebf9fc',2:'#c9e5ea',3:'#acd5dd',4:'#6eadba',5:'#5f96a1',6:'#4f7e87',7:'#41666e',8:'#324e54',9:'#273e42',10:'#1d2d30',inflection:6};exports.default=(0,_createColorPalette2.default)(mist,'mist');

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=__webpack_require__(11),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var ninja={9:'#40404c',10:'#2f2f39',11:'#1b1b26'};exports.default=(0,_createColorPalette2.default)(ninja,'ninja');

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=__webpack_require__(11),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var ocean={1:'#eaf7fc',2:'#b0e3f4',3:'#75cfec',4:'#00a7db',5:'#0093c4',6:'#007fad',7:'#006c94',8:'#005a75',9:'#00465c',10:'#003342',inflection:6};exports.default=(0,_createColorPalette2.default)(ocean,'ocean');

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=__webpack_require__(11),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var orange={1:'#fff3e3',2:'#ffd69b',3:'#ffb55f',4:'#ff943b',5:'#e65f14',6:'#d04a00',7:'#b54102',8:'#983702',9:'#7a2d00',10:'#541f00',inflection:6};exports.default=(0,_createColorPalette2.default)(orange,'orange');

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=__webpack_require__(11),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var pickle={1:'#f4f6ea',2:'#e0eab8',3:'#ccde87',4:'#a3c523',5:'#7e9e06',6:'#637d05',7:'#536904',8:'#415203',9:'#303d02',10:'#202902',inflection:6};exports.default=(0,_createColorPalette2.default)(pickle,'pickle');

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=__webpack_require__(11),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var purple={1:'#f7f5ff',2:'#e3dbff',3:'#ccbdfe',4:'#bca9fa',5:'#9375f2',6:'#8956f0',7:'#683ac8',8:'#532ca6',9:'#3f1c86',10:'#2a1359',inflection:6};exports.default=(0,_createColorPalette2.default)(purple,'purple');

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=__webpack_require__(11),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var red={1:'#fff2f4',2:'#ffe1e6',3:'#fabcc5',4:'#f78394',5:'#ed596f',6:'#e71d3a',7:'#d21c35',8:'#a9172c',9:'#7e1021',10:'#5c0c18',inflection:6};exports.default=(0,_createColorPalette2.default)(red,'red');

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=__webpack_require__(11),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var sangria={1:'#fdf2f5',2:'#fbcada',3:'#f8a2bf',4:'#f57aa3',5:'#ed3e79',6:'#d81e5d',7:'#bf1b52',8:'#a61747',9:'#8c143c',10:'#610e29',inflection:6};exports.default=(0,_createColorPalette2.default)(sangria,'sangria');

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=__webpack_require__(11),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var silver={1:'#fafafa',2:'#f6f6f6',3:'#ececec',4:'#dadada',5:'#949494',6:'#757575',7:'#646464',8:'#525252',9:'#3c3c3c',10:'#1c1c1c',inflection:6};exports.default=(0,_createColorPalette2.default)(silver,'silver');

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var createTypography=function(options){var _options$fontFamily=options.fontFamily,fontFamily=_options$fontFamily===void 0?'"Roboto", sans-serif':_options$fontFamily,_options$fontSize=options.fontSize,fontSize=_options$fontSize===void 0?14:_options$fontSize,_options$fontWeightLi=options.fontWeightLight,fontWeightLight=_options$fontWeightLi===void 0?300:_options$fontWeightLi,_options$fontWeightRe=options.fontWeightRegular,fontWeightRegular=_options$fontWeightRe===void 0?400:_options$fontWeightRe,_options$fontWeightMe=options.fontWeightMedium,fontWeightMedium=_options$fontWeightMe===void 0?500:_options$fontWeightMe,_options$fontWeightBo=options.fontWeightBold,fontWeightBold=_options$fontWeightBo===void 0?700:_options$fontWeightBo,_options$fontWeightBl=options.fontWeightBlack,fontWeightBlack=_options$fontWeightBl===void 0?900:_options$fontWeightBl,_options$htmlFontSize=options.htmlFontSize,htmlFontSize=_options$htmlFontSize===void 0?16:_options$htmlFontSize;return{fontFamily:fontFamily,htmlFontSize:htmlFontSize,fontSize:Math.max(fontSize,12),fontWeightLight:fontWeightLight,fontWeightRegular:fontWeightRegular,fontWeightMedium:fontWeightMedium,fontWeightBold:fontWeightBold,fontWeightBlack:fontWeightBlack,pxToRem:function pxToRem(value){return value/htmlFontSize+'rem'}}};exports.default=createTypography;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _deepmerge=__webpack_require__(551),_deepmerge2=_interopRequireDefault(_deepmerge);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var createTransitions=function(options){return(0,_deepmerge2.default)({easing:{easeIn:'ease-in',easeOut:'ease-out'},duration:{shortest:'100ms',short:'250ms',enteringScreen:'250ms',leavingScreen:'250ms'}},options)};exports.default=createTransitions;

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ __webpack_exports__["default"] = (deepmerge_1);


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var createShape=function(options){var _options$borderStyle=options.borderStyle,borderStyle=_options$borderStyle===void 0?'solid':_options$borderStyle,_options$borderWidth=options.borderWidth,borderWidth=_options$borderWidth===void 0?'1px':_options$borderWidth,_options$borderRadius=options.borderRadius,borderRadius=_options$borderRadius===void 0?'4px':_options$borderRadius;return{borderStyle:borderStyle,borderWidth:borderWidth,borderRadius:borderRadius}};exports.default=createShape;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:!0});var createSizes=function(options){var _options$small=options.small,small=_options$small===void 0?24:_options$small,_options$medium=options.medium,medium=_options$medium===void 0?32:_options$medium,_options$large=options.large,large=_options$large===void 0?44:_options$large;return{small:small,medium:medium,large:large}};exports.default=createSizes;

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:!0});var createZIndex=function(options){var _options$modal=options.modal,modal=_options$modal===void 0?1300:_options$modal,_options$tooltip=options.tooltip,tooltip=_options$tooltip===void 0?1500:_options$tooltip;return{modal:modal,tooltip:tooltip}};exports.default=createZIndex;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var createBoxShadows=function(options){var _options$menu=options.menu,menu=_options$menu===void 0?'0 1px 3px rgba(0, 0, 0, 0.5)':_options$menu,_options$low=options.low,low=_options$low===void 0?'0 1px 3px rgba(0, 0, 0, 0.2)':_options$low,_options$medium=options.medium,medium=_options$medium===void 0?'0 2px 8px rgba(0, 0, 0, 0.2)':_options$medium,_options$high=options.high,high=_options$high===void 0?'0 4px 15px rgba(0, 0, 0, 0.2)':_options$high;return{menu:menu,low:low,medium:medium,high:high}};exports.default=createBoxShadows;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target};Object.defineProperty(exports,'__esModule',{value:!0});exports.default=createThemedComponent;var _react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_withTheme=__webpack_require__(164),_withTheme2=_interopRequireDefault(_withTheme),_createComponentTheme=__webpack_require__(161),_createComponentTheme2=_interopRequireDefault(_createComponentTheme);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj)0<=keys.indexOf(i)||Object.prototype.hasOwnProperty.call(obj,i)&&(target[i]=obj[i]);return target}function getComponentDisplayName(Component){return'string'==typeof Component?Component:Component.displayName||Component.name||'Component'}function createThemedComponent(ComponentToTheme,styleOverrides){var ThemedComponent=function(props,context){var theme=props.theme,otherProps=_objectWithoutProperties(props,['theme']),componentStyles='function'==typeof styleOverrides?styleOverrides(props,context):styleOverrides,componentTheme=(0,_createComponentTheme2.default)(theme,componentStyles);return _react2.default.createElement(ComponentToTheme,_extends({},otherProps,{theme:componentTheme}))};return ThemedComponent.propTypes=ComponentToTheme.propTypes,ThemedComponent.displayName='Themed('+getComponentDisplayName(ComponentToTheme)+')',(0,_withTheme2.default)(ThemedComponent)}

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var getStyle=function(token){return function(props){var style=props.theme.vstui[token],styleValue='function'==typeof style?style(props):style;return(void 0===styleValue||'string'==typeof styleValue&&(-1!==styleValue.indexOf('undefined')||-1!==styleValue.indexOf('null')||-1!==styleValue.indexOf('NaN')))&&console.log('Token \''+token+'\' does not exist.'),styleValue}};exports.default=getStyle;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes),_styledComponents=__webpack_require__(8),_createTheme=__webpack_require__(162),_createTheme2=_interopRequireDefault(_createTheme),_propTypes3=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var ThemeProvider=function(props){var theme=props.theme?props.theme:(0,_createTheme2.default)();return _react2.default.createElement(_styledComponents.ThemeProvider,{theme:theme},props.children)};ThemeProvider.propTypes={children:_propTypes2.default.node,theme:_propTypes3.themeShape},exports.default=ThemeProvider;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var themeShape=_propTypes2.default.shape({vstui:_propTypes2.default.shape({direction:_propTypes2.default.oneOf(['ltr','rtl']),palette:_propTypes2.default.shape({common:_propTypes2.default.shape({black:_propTypes2.default.string,white:_propTypes2.default.string,transparent:_propTypes2.default.string}),primary:_propTypes2.default.shape({getShade:_propTypes2.default.func,getMainShade:_propTypes2.default.func,name:_propTypes2.default.string}),secondary:_propTypes2.default.shape({getShade:_propTypes2.default.func,getMainShade:_propTypes2.default.func,name:_propTypes2.default.string}),error:_propTypes2.default.shape({getShade:_propTypes2.default.func,getMainShade:_propTypes2.default.func,name:_propTypes2.default.string}),success:_propTypes2.default.shape({getShade:_propTypes2.default.func,getMainShade:_propTypes2.default.func,name:_propTypes2.default.string})}),typography:_propTypes2.default.shape({fontFamily:_propTypes2.default.string,fontSize:_propTypes2.default.number,fontWeightLight:_propTypes2.default.number,fontWeightRegular:_propTypes2.default.number,fontWeightMedium:_propTypes2.default.number,fontWeightBold:_propTypes2.default.number,fontWeightBlack:_propTypes2.default.number,htmlFontSize:_propTypes2.default.number,pxToRem:_propTypes2.default.func}),transitions:_propTypes2.default.shape({easing:_propTypes2.default.shape({easeIn:_propTypes2.default.string,easeOut:_propTypes2.default.string}),duration:_propTypes2.default.shape({shortest:_propTypes2.default.string,short:_propTypes2.default.string,enteringScreen:_propTypes2.default.string,leavingScreen:_propTypes2.default.string})}),sizes:_propTypes2.default.shape({small:_propTypes2.default.number,medium:_propTypes2.default.number,large:_propTypes2.default.number})})});exports.default=themeShape;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _styledComponents=__webpack_require__(8),_styledComponents2=_interopRequireDefault(_styledComponents);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var createStyledComponent=function(element,styleTemplate){return(0,_styledComponents2.default)(element).withConfig({displayName:'createStyledComponent'})(['',';'],styleTemplate)};exports.default=createStyledComponent;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _styledComponents=__webpack_require__(8);Object.defineProperty(exports,'default',{enumerable:!0,get:function get(){return _styledComponents.css}});

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_typeof='function'==typeof Symbol&&'symbol'==typeof Symbol.iterator?function(obj){return typeof obj}:function(obj){return obj&&'function'==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?'symbol':typeof obj},_slicedToArray=function(){function sliceIterator(arr,i){var _arr=[],_n=!0,_d=!1,_e=void 0;try{for(var _s,_i=arr[Symbol.iterator]();!(_n=(_s=_i.next()).done)&&(_arr.push(_s.value),!(i&&_arr.length===i));_n=!0);}catch(err){_d=!0,_e=err}finally{try{!_n&&_i['return']&&_i['return']()}finally{if(_d)throw _e}}return _arr}return function(arr,i){if(Array.isArray(arr))return arr;if(Symbol.iterator in Object(arr))return sliceIterator(arr,i);throw new TypeError('Invalid attempt to destructure non-iterable instance')}}(),_utils=__webpack_require__(25);Object.defineProperty(exports,'__esModule',{value:!0});function _defineProperty(obj,key,value){return key in obj?Object.defineProperty(obj,key,{value:value,enumerable:!0,configurable:!0,writable:!0}):obj[key]=value,obj}var validProperties=['display','position','top','right','bottom','left','width','minWidth','maxWidth','height','minHeight','maxHeight','margin','marginTop','marginRight','marginBottom','marginLeft','zIndex','flex','flexGrow','flexShrink','flexBasis','alignSelf','float'],filterLayoutStyles=function(styles){if(styles===void 0)return{};var filteredStyles=(0,_utils.entries)(styles).reduce(function(accumulator,_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],value=_ref2[1];if('object'===('undefined'==typeof value?'undefined':_typeof(value))){if(0!==key.indexOf('@media'))return accumulator;var filteredValue=(0,_utils.entries)(value).reduce(function(mediaAccumulator,_ref3){var _ref4=_slicedToArray(_ref3,2),mediaKey=_ref4[0],mediaValue=_ref4[1];return'object'===('undefined'==typeof mediaValue?'undefined':_typeof(mediaValue))?mediaAccumulator:_extends({},mediaAccumulator,_defineProperty({},mediaKey,mediaValue))},{});return _extends({},accumulator,_defineProperty({},key,filteredValue))}return validProperties.includes(key)?_extends({},accumulator,_defineProperty({},key,value)):accumulator},{});return filteredStyles};exports.default=filterLayoutStyles;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var createEvent=function(type,_ref){var bubbles=_ref.bubbles,cancelable=_ref.cancelable,event=void 0;return'function'==typeof Event?event=new Event(type,{bubbles:bubbles,cancelable:cancelable}):(event=document.createEvent('Event'),event.initEvent(type,bubbles,cancelable)),event};exports.default=createEvent;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:!0});var entries=function(obj){for(var ownProps=Object.keys(obj),i=ownProps.length,resArray=Array(i);i--;)resArray[i]=[ownProps[i],obj[ownProps[i]]];return resArray};exports.default=entries;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _shortid=__webpack_require__(566),_shortid2=_interopRequireDefault(_shortid);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var generateUniqueId=function(){var name=0<arguments.length&&arguments[0]!==void 0?arguments[0]:'id';return name+'-'+_shortid2.default.generate()};exports.default=generateUniqueId;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(567);


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = __webpack_require__(57);
var build = __webpack_require__(569);
var isValid = __webpack_require__(573);

// if you are using cluster or multiple servers use this to make each instance
// has a unique value for worker
// Note: I don't know if this is automatically set when using third
// party cluster solutions such as pm2.
var clusterWorkerId = __webpack_require__(574) || 0;

/**
 * Set the seed.
 * Highly recommended if you don't want people to try to figure out your id schema.
 * exposed as shortid.seed(int)
 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
 */
function seed(seedValue) {
    alphabet.seed(seedValue);
    return module.exports;
}

/**
 * Set the cluster worker or machine id
 * exposed as shortid.worker(int)
 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
 * returns shortid module so it can be chained.
 */
function worker(workerId) {
    clusterWorkerId = workerId;
    return module.exports;
}

/**
 *
 * sets new characters to use in the alphabet
 * returns the shuffled alphabet
 */
function characters(newCharacters) {
    if (newCharacters !== undefined) {
        alphabet.characters(newCharacters);
    }

    return alphabet.shuffled();
}

/**
 * Generate unique id
 * Returns string id
 */
function generate() {
  return build(clusterWorkerId);
}

// Export all other functions as properties of the generate function
module.exports = generate;
module.exports.generate = generate;
module.exports.seed = seed;
module.exports.worker = worker;
module.exports.characters = characters;
module.exports.isValid = isValid;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Found this seed-based random generator somewhere
// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)

var seed = 1;

/**
 * return a random number based on a seed
 * @param seed
 * @returns {number}
 */
function getNextValue() {
    seed = (seed * 9301 + 49297) % 233280;
    return seed/(233280.0);
}

function setSeed(_seed_) {
    seed = _seed_;
}

module.exports = {
    nextValue: getNextValue,
    seed: setSeed
};


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var generate = __webpack_require__(570);
var alphabet = __webpack_require__(57);

// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
// This number should be updated every year or so to keep the generated id short.
// To regenerate `new Date() - 0` and bump the version. Always bump the version!
var REDUCE_TIME = 1459707606518;

// don't change unless we change the algos or REDUCE_TIME
// must be an integer and less than 16
var version = 6;

// Counter is used when shortid is called multiple times in one second.
var counter;

// Remember the last time shortid was called in case counter is needed.
var previousSeconds;

/**
 * Generate unique id
 * Returns string id
 */
function build(clusterWorkerId) {
    var str = '';

    var seconds = Math.floor((Date.now() - REDUCE_TIME) * 0.001);

    if (seconds === previousSeconds) {
        counter++;
    } else {
        counter = 0;
        previousSeconds = seconds;
    }

    str = str + generate(version);
    str = str + generate(clusterWorkerId);
    if (counter > 0) {
        str = str + generate(counter);
    }
    str = str + generate(seconds);
    return str;
}

module.exports = build;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = __webpack_require__(57);
var random = __webpack_require__(571);
var format = __webpack_require__(572);

function generate(number) {
    var loopCounter = 0;
    var done;

    var str = '';

    while (!done) {
        str = str + format(random, alphabet.get(), 1);
        done = number < (Math.pow(16, loopCounter + 1 ) );
        loopCounter++;
    }
    return str;
}

module.exports = generate;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var crypto = typeof window === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto

var randomByte;

if (!crypto || !crypto.getRandomValues) {
    randomByte = function(size) {
        var bytes = [];
        for (var i = 0; i < size; i++) {
            bytes.push(Math.floor(Math.random() * 256));
        }
        return bytes;
    };
} else {
    randomByte = function(size) {
        return crypto.getRandomValues(new Uint8Array(size));
    };
}

module.exports = randomByte;


/***/ }),
/* 572 */
/***/ (function(module, exports) {

/**
 * Secure random string generator with custom alphabet.
 *
 * Alphabet must contain 256 symbols or less. Otherwise, the generator
 * will not be secure.
 *
 * @param {generator} random The random bytes generator.
 * @param {string} alphabet Symbols to be used in new random string.
 * @param {size} size The number of symbols in new random string.
 *
 * @return {string} Random string.
 *
 * @example
 * const format = require('nanoid/format')
 *
 * function random (size) {
 *   const result = []
 *   for (let i = 0; i < size; i++) {
 *     result.push(randomByte())
 *   }
 *   return result
 * }
 *
 * format(random, "abcdef", 5) //=> "fbaef"
 *
 * @name format
 * @function
 */
module.exports = function (random, alphabet, size) {
  var mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1
  var step = Math.ceil(1.6 * mask * size / alphabet.length)

  var id = ''
  while (true) {
    var bytes = random(step)
    for (var i = 0; i < step; i++) {
      var byte = bytes[i] & mask
      if (alphabet[byte]) {
        id += alphabet[byte]
        if (id.length === size) return id
      }
    }
  }
}

/**
 * @callback generator
 * @param {number} bytes The number of bytes to generate.
 * @return {number[]} Random bytes.
 */


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var alphabet = __webpack_require__(57);

function isShortId(id) {
    if (!id || typeof id !== 'string' || id.length < 6 ) {
        return false;
    }

    var nonAlphabetic = new RegExp('[^' +
      alphabet.get().replace(/[|\\{}()[\]^$+*?.-]/g, '\\$&') +
    ']');
    return !nonAlphabetic.test(id);
}

module.exports = isShortId;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = 0;


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_slicedToArray=function(){function sliceIterator(arr,i){var _arr=[],_n=!0,_d=!1,_e=void 0;try{for(var _s,_i=arr[Symbol.iterator]();!(_n=(_s=_i.next()).done)&&(_arr.push(_s.value),!(i&&_arr.length===i));_n=!0);}catch(err){_d=!0,_e=err}finally{try{!_n&&_i['return']&&_i['return']()}finally{if(_d)throw _e}}return _arr}return function(arr,i){if(Array.isArray(arr))return arr;if(Symbol.iterator in Object(arr))return sliceIterator(arr,i);throw new TypeError('Invalid attempt to destructure non-iterable instance')}}(),_inherited=__webpack_require__(576),_inherited2=_interopRequireDefault(_inherited),_utils=__webpack_require__(25);Object.defineProperty(exports,'__esModule',{value:!0}),exports.resetInheritedStylesObject=void 0;function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _defineProperty(obj,key,value){return key in obj?Object.defineProperty(obj,key,{value:value,enumerable:!0,configurable:!0,writable:!0}):obj[key]=value,obj}var snakeToCamel=function(s){return s.replace(/(-\w)/g,function(m){return m[1].toUpperCase()})},modifyStyles=function(obj){return(0,_utils.entries)(obj).map(function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],value=_ref2[1];return'text-align'===key?[key,'left']:[key,value]}).reduce(function(o,_ref3){var _ref4=_slicedToArray(_ref3,2),k=_ref4[0],v=_ref4[1];return _extends({},o,_defineProperty({},k,v))},{})},toCSS=function(obj){return Object.keys(obj).map(function(key){return key+': '+obj[key]+';'}).join('\n')},toObject=function(obj){return(0,_utils.entries)(obj).map(function(_ref5){var _ref6=_slicedToArray(_ref5,2),key=_ref6[0],value=_ref6[1];return[snakeToCamel(key),value]}).reduce(function(o,_ref7){var _ref8=_slicedToArray(_ref7,2),k=_ref8[0],v=_ref8[1];return _extends({},o,_defineProperty({},k,v))},{})},modifiedStyles=modifyStyles(_inherited2.default),resetInheritedStyles='\n  '+toCSS(modifiedStyles)+'\n',resetInheritedStylesObject=exports.resetInheritedStylesObject=toObject(modifiedStyles);exports.default=resetInheritedStyles;

/***/ }),
/* 576 */
/***/ (function(module, exports) {

module.exports = {
  "azimuth": "center",
  "border-collapse": "separate",
  "border-spacing": "0",
  "caption-side": "top",
  "caret-color": "auto",
  "color": "initial",
  "cursor": "auto",
  "empty-cells": "show",
  "font-family": "initial",
  "font-feature-settings": "normal",
  "font-kerning": "auto",
  "font-language-override": "normal",
  "font-size": "medium",
  "font-size-adjust": "none",
  "font-stretch": "normal",
  "font-style": "normal",
  "font-synthesis": "weight style",
  "font-variant": "normal",
  "font-variant-alternates": "normal",
  "font-variant-caps": "normal",
  "font-variant-east-asian": "normal",
  "font-variant-ligatures": "normal",
  "font-variant-numeric": "normal",
  "font-variant-position": "normal",
  "font-weight": "normal",
  "hyphens": "manual",
  "image-orientation": "0deg",
  "image-rendering": "auto",
  "image-resolution": "1dppx",
  "letter-spacing": "normal",
  "line-height": "normal",
  "list-style-image": "none",
  "list-style-position": "outside",
  "list-style-type": "disc",
  "object-position": "50% 50%",
  "orphans": "2",
  "overflow-wrap": "normal",
  "pointer-events": "auto",
  "quotes": "initial",
  "ruby-align": "space-around",
  "ruby-merge": "separate",
  "ruby-position": "over",
  "tab-size": "8",
  "text-align": "initial",
  "text-align-last": "auto",
  "text-combine-upright": "none",
  "text-indent": "0",
  "text-justify": "auto",
  "text-orientation": "mixed",
  "text-rendering": "auto",
  "text-shadow": "none",
  "text-transform": "none",
  "text-underline-position": "auto",
  "visibility": "visible",
  "white-space": "normal",
  "widows": "2",
  "word-break": "normal",
  "word-spacing": "normal",
  "word-wrap": "normal",
  "writing-mode": "horizontal-tb",
  "-webkit-appearance": "none",
  "-moz-appearance": "none",
  "-ms-appearance": "none",
  "appearance": "none"
};

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:!0});var visuallyHidden=function(){return"\n    position: absolute;\n    left: -10000px;\n    top: auto;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n  "};exports.default=visuallyHidden;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _Tooltip=__webpack_require__(579);Object.defineProperty(exports,'default',{enumerable:!0,get:function get(){return _interopRequireDefault(_Tooltip).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes),_styledComponents=__webpack_require__(8),_styledComponents2=_interopRequireDefault(_styledComponents),_reactPopper=__webpack_require__(190),_styles=__webpack_require__(17),_themes=__webpack_require__(5),_propTypes3=__webpack_require__(10),_componentTheme=__webpack_require__(580),_componentTheme2=_interopRequireDefault(_componentTheme);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj)0<=keys.indexOf(i)||Object.prototype.hasOwnProperty.call(obj,i)&&(target[i]=obj[i]);return target}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var Styled={div:{}};Styled.Manager=(0,_styledComponents2.default)(_reactPopper.Manager).withConfig({displayName:'Tooltip__Manager'})(['display:inline-block;']),Styled.div.tooltip=_styledComponents2.default.div.withConfig({displayName:'Tooltip__tooltip'})(['padding:3px 8px;opacity:',';background:',';border-radius:2px;box-shadow:0 2px 8px rgba(0,0,0,0.2);color:',';font-family:',';font-size:',';font-weight:',';-webkit-font-smoothing:antialiased;transform:translate( ',',',' );transition-property:opacity transform;transition-duration:',';transition-timing-function:',';'],function(props){return props.sc.open?1:0},function(props){return props.theme.vstui.Tooltip_backgroundColor},function(props){return props.theme.vstui.Tooltip_color},function(props){return props.theme.vstui.Tooltip_fontFamily},function(props){return props.theme.vstui.Tooltip_fontSize},function(props){return props.theme.vstui.Tooltip_fontWeight},function(props){return props.sc.open?0:-1===props.sc.placement.indexOf('left')?-1===props.sc.placement.indexOf('right')?0:'-2px':'2px'},function(props){return props.sc.open?0:0===props.sc.placement.indexOf('top')?'2px':0===props.sc.placement.indexOf('bottom')?'-2px':0},function(props){return props.theme.vstui.Tooltip_transitionDuration},function(props){return props.theme.vstui.Tooltip_transitionEasing});var Tooltip=function(_PureComponent){function Tooltip(props){_classCallCheck(this,Tooltip);var _this=_possibleConstructorReturn(this,(Tooltip.__proto__||Object.getPrototypeOf(Tooltip)).call(this,props));return _this.state={open:!1},_this.handleBlur=_this.handleBlur.bind(_this),_this.handleFocus=_this.handleFocus.bind(_this),_this.handleKeyDown=_this.handleKeyDown.bind(_this),_this.handleTargetMouseEnter=_this.handleTargetMouseEnter.bind(_this),_this.handleTargetMouseLeave=_this.handleTargetMouseLeave.bind(_this),_this.handlePopperMouseEnter=_this.handlePopperMouseEnter.bind(_this),_this.handlePopperMouseLeave=_this.handlePopperMouseLeave.bind(_this),_this}return _inherits(Tooltip,_PureComponent),_createClass(Tooltip,[{key:'componentDidMount',value:function componentDidMount(){void 0===this.props.theme.vstui.fontFamily&&(this.theme=(0,_themes.createTheme)()),document.addEventListener('keydown',this.handleKeyDown)}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.clearOpenTimeout(),this.clearCloseTimeout(),document.removeEventListener('keydown',this.handleKeyDown)}},{key:'handleBlur',value:function handleBlur(){this.close()}},{key:'handleFocus',value:function handleFocus(){this.delayedOpen()}},{key:'handleKeyDown',value:function handleKeyDown(event){var open=this.state.open;open&&event.which===27&&this.close()}},{key:'handleTargetMouseEnter',value:function handleTargetMouseEnter(event){event.target.disabled||this.delayedOpen()}},{key:'handleTargetMouseLeave',value:function handleTargetMouseLeave(){this.delayedClose()}},{key:'handlePopperMouseEnter',value:function handlePopperMouseEnter(){this.clearCloseTimeout()}},{key:'handlePopperMouseLeave',value:function handlePopperMouseLeave(){this.delayedClose()}},{key:'clearOpenTimeout',value:function clearOpenTimeout(){clearTimeout(this.openTimeout),this.openTimeout=null}},{key:'clearCloseTimeout',value:function clearCloseTimeout(){clearTimeout(this.closeTimeout),this.closeTimeout=null}},{key:'delayedOpen',value:function delayedOpen(){var _this2=this,open=this.state.open;this.clearOpenTimeout(),this.clearCloseTimeout(),open||(this.openTimeout=setTimeout(function(){_this2.setState({open:!0})},500))}},{key:'close',value:function close(){this.clearOpenTimeout(),this.clearCloseTimeout(),this.setState({open:!1})}},{key:'delayedClose',value:function delayedClose(){var _this3=this;this.clearOpenTimeout(),this.clearCloseTimeout(),this.closeTimeout=setTimeout(function(){_this3.setState({open:!1})},0)}},{key:'render',value:function render(){var _this4=this,_props=this.props,children=_props.children,className=_props.className,id=_props.id,inheritStyles=_props.inheritStyles,placement=_props.placement,themeProp=_props.theme,title=_props.title,theme=(0,_componentTheme2.default)(themeProp),offset=4;return _react2.default.createElement(Styled.Manager,{className:className,style:inheritStyles?{}:_styles.resetInheritedStylesObject,tag:'div'},_react2.default.createElement(_reactPopper.Target,null,function(_ref){var targetProps=_ref.targetProps;return _react2.default.cloneElement(children,{innerRef:targetProps.ref,onBlur:_this4.handleBlur,onFocus:_this4.handleFocus,onMouseEnter:_this4.handleTargetMouseEnter,onMouseLeave:_this4.handleTargetMouseLeave})}),_react2.default.createElement(_reactPopper.Popper,{modifiers:{offset:{offset:'0, '+offset+'px'}},placement:placement},function(_ref2){var popperProps=_ref2.popperProps,open=_this4.state.open,style=popperProps.style,otherProps=_objectWithoutProperties(popperProps,['style']);style.pointerEvents=open?'auto':'none',style.cursor='default',style.zIndex=theme.vstui.Tooltip_zIndex;var conditionalProps=open?otherProps:{};return _react2.default.createElement('div',_extends({},conditionalProps,{"aria-hidden":'true',id:id,onMouseEnter:_this4.handlePopperMouseEnter,onMouseLeave:_this4.handlePopperMouseLeave,role:'tooltip',style:style}),_react2.default.createElement('div',{style:{position:'absolute',top:'-'+offset+'px',right:'-'+offset+'px',bottom:'-'+offset+'px',left:'-'+offset+'px'}}),_react2.default.createElement(Styled.div.tooltip,{sc:{open:open,placement:popperProps['data-placement']||''},theme:theme},title))}))}}]),Tooltip}(_react.PureComponent);Tooltip.propTypes={children:_propTypes2.default.element.isRequired,className:_propTypes2.default.string,id:_propTypes2.default.string,inheritStyles:_propTypes2.default.bool,title:_propTypes2.default.string,open:_propTypes2.default.bool,placement:_propTypes2.default.oneOf(['auto','top','right','bottom','left','auto-start','top-start','right-start','bottom-start','left-start','auto-end','top-end','right-end','bottom-end','left-end']),theme:_propTypes3.themeShape},Tooltip.defaultProps={theme:{vstui:{}}},Tooltip.displayName=Tooltip;var TooltipWithTheme=(0,_themes.withTheme)(Tooltip);TooltipWithTheme.WrappedComponent=Tooltip,exports.default=TooltipWithTheme;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _themes=__webpack_require__(5),componentTheme=function(baseTheme){var _baseTheme$vstui=baseTheme.vstui,color=_baseTheme$vstui.color,typography=_baseTheme$vstui.typography,zIndex=_baseTheme$vstui.zIndex;return(0,_themes.createComponentTheme)(baseTheme,{Tooltip_backgroundColor:color.ninja.getShade(10),Tooltip_color:color.white,Tooltip_fontFamily:typography.fontFamily,Tooltip_fontSize:typography.pxToRem(typography.fontSize-2),Tooltip_fontWeight:typography.fontWeightRegular,Tooltip_transitionDuration:'150ms',Tooltip_transitionEasing:'cubic-bezier(0.7, 0, 0.7, 1)',Tooltip_zIndex:zIndex.tooltip})};exports.default=componentTheme;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _themes=__webpack_require__(5),componentTheme=function(baseTheme){var _Mathround=Math.round,_baseTheme$vstui=baseTheme.vstui,color=_baseTheme$vstui.color,rem=_baseTheme$vstui.rem,shape=_baseTheme$vstui.shape,size=_baseTheme$vstui.size,transition=_baseTheme$vstui.transition,typography=_baseTheme$vstui.typography,primaryMain=function(_ref){var sc=_ref.sc;return color.primary.getMainShade({backgroundColor:sc.colorBehindButton})},primaryDarker=function(_ref2){var sc=_ref2.sc;return color.primary.getMainShade({backgroundColor:sc.colorBehindButton,offset:1})},primaryDarkest=function(_ref3){var sc=_ref3.sc;return color.primary.getMainShade({backgroundColor:sc.colorBehindButton,offset:2})},secondaryMain=function(_ref4){var sc=_ref4.sc;return color.secondary.getMainShade({backgroundColor:sc.colorBehindButton})},secondaryDarker=function(_ref5){var sc=_ref5.sc;return color.secondary.getMainShade({backgroundColor:sc.colorBehindButton,offset:1})},secondaryDarkest=function(_ref6){var sc=_ref6.sc;return color.secondary.getMainShade({backgroundColor:sc.colorBehindButton,offset:2})},cloud3=color.cloud.getShade(3),cloud4=color.cloud.getShade(4),ninja9=color.ninja.getShade(9),black43='rgba(0, 0, 0, 0.43)',backgroundColor_disabled=color.transparent,backgroundColor_naked=color.transparent,borderColor_disabled='rgba(0, 0, 0, 0.20)',borderColor_naked=color.transparent,color_disabled=color.black,white80='rgba(255, 255, 255, 0.8)';return(0,_themes.createComponentTheme)(baseTheme,{Button_backgroundColor_themePrimary:primaryMain,Button_backgroundColor_themePrimary_disabled:backgroundColor_disabled,Button_backgroundColor_themePrimary_active:primaryDarker,Button_backgroundColor_themePrimary_focus:primaryDarker,Button_backgroundColor_themePrimary_hover:primaryDarker,Button_backgroundColor_themePrimaryNaked:backgroundColor_naked,Button_backgroundColor_themePrimaryNaked_disabled:backgroundColor_naked,Button_backgroundColor_themePrimaryNaked_active:backgroundColor_naked,Button_backgroundColor_themePrimaryNaked_focus:backgroundColor_naked,Button_backgroundColor_themePrimaryNaked_hover:backgroundColor_naked,Button_backgroundColor_themeSecondary:secondaryMain,Button_backgroundColor_themeSecondary_disabled:backgroundColor_disabled,Button_backgroundColor_themeSecondary_active:secondaryDarker,Button_backgroundColor_themeSecondary_focus:secondaryDarker,Button_backgroundColor_themeSecondary_hover:secondaryDarker,Button_backgroundColor_themeSecondaryNaked:backgroundColor_naked,Button_backgroundColor_themeSecondaryNaked_disabled:backgroundColor_naked,Button_backgroundColor_themeSecondaryNaked_active:backgroundColor_naked,Button_backgroundColor_themeSecondaryNaked_focus:backgroundColor_naked,Button_backgroundColor_themeSecondaryNaked_hover:backgroundColor_naked,Button_backgroundColor_neutral:cloud3,Button_backgroundColor_neutral_disabled:backgroundColor_disabled,Button_backgroundColor_neutral_active:cloud4,Button_backgroundColor_neutral_focus:cloud4,Button_backgroundColor_neutral_hover:cloud4,Button_backgroundColor_neutralNaked:backgroundColor_naked,Button_backgroundColor_neutralNaked_disabled:backgroundColor_naked,Button_backgroundColor_neutralNaked_active:backgroundColor_naked,Button_backgroundColor_neutralNaked_focus:backgroundColor_naked,Button_backgroundColor_neutralNaked_hover:backgroundColor_naked,Button_backgroundColor_white:color.surface,Button_backgroundColor_white_disabled:backgroundColor_disabled,Button_backgroundColor_white_active:white80,Button_backgroundColor_white_focus:white80,Button_backgroundColor_white_hover:white80,Button_backgroundColor_whiteNaked:backgroundColor_naked,Button_backgroundColor_whiteNaked_disabled:backgroundColor_naked,Button_backgroundColor_whiteNaked_active:backgroundColor_naked,Button_backgroundColor_whiteNaked_focus:backgroundColor_naked,Button_backgroundColor_whiteNaked_hover:backgroundColor_naked,Button_borderColor_themePrimary:primaryMain,Button_borderColor_themePrimary_disabled:borderColor_disabled,Button_borderColor_themePrimary_active:primaryDarker,Button_borderColor_themePrimary_focus:primaryDarker,Button_borderColor_themePrimary_hover:primaryDarker,Button_borderColor_themePrimaryNaked:borderColor_naked,Button_borderColor_themePrimaryNaked_disabled:borderColor_naked,Button_borderColor_themePrimaryNaked_active:borderColor_naked,Button_borderColor_themePrimaryNaked_focus:borderColor_naked,Button_borderColor_themePrimaryNaked_hover:borderColor_naked,Button_borderColor_themeSecondary:secondaryMain,Button_borderColor_themeSecondary_disabled:borderColor_disabled,Button_borderColor_themeSecondary_active:secondaryDarker,Button_borderColor_themeSecondary_focus:secondaryDarker,Button_borderColor_themeSecondary_hover:secondaryDarker,Button_borderColor_themeSecondaryNaked:borderColor_naked,Button_borderColor_themeSecondaryNaked_disabled:borderColor_naked,Button_borderColor_themeSecondaryNaked_active:borderColor_naked,Button_borderColor_themeSecondaryNaked_focus:borderColor_naked,Button_borderColor_themeSecondaryNaked_hover:borderColor_naked,Button_borderColor_neutral:black43,Button_borderColor_neutral_disabled:borderColor_disabled,Button_borderColor_neutral_active:black43,Button_borderColor_neutral_focus:black43,Button_borderColor_neutral_hover:black43,Button_borderColor_neutralNaked:borderColor_naked,Button_borderColor_neutralNaked_disabled:borderColor_naked,Button_borderColor_neutralNaked_active:borderColor_naked,Button_borderColor_neutralNaked_focus:borderColor_naked,Button_borderColor_neutralNaked_hover:borderColor_naked,Button_borderColor_white:color.surface,Button_borderColor_white_disabled:color.surface,Button_borderColor_white_active:white80,Button_borderColor_white_focus:white80,Button_borderColor_white_hover:white80,Button_borderColor_whiteNaked:borderColor_naked,Button_borderColor_whiteNaked_disabled:borderColor_naked,Button_borderColor_whiteNaked_active:borderColor_naked,Button_borderColor_whiteNaked_focus:borderColor_naked,Button_borderColor_whiteNaked_hover:borderColor_naked,Button_borderRadius:shape.borderRadius,Button_borderStyle:shape.borderStyle,Button_borderWidth:shape.borderWidth,Button_boxShadow_themePrimary_focus:function Button_boxShadow_themePrimary_focus(props){return'0 0 0 2px '+color.onPrimary+', 0 0 0 4px '+primaryDarker(props)},Button_boxShadow_themePrimaryNaked_focus:function Button_boxShadow_themePrimaryNaked_focus(props){return'0 0 0 2px '+primaryDarker(props)},Button_boxShadow_themeSecondary_focus:function Button_boxShadow_themeSecondary_focus(props){return'0 0 0 2px '+color.onSecondary+', 0 0 0 4px '+secondaryDarker(props)},Button_boxShadow_themeSecondaryNaked_focus:function Button_boxShadow_themeSecondaryNaked_focus(props){return'0 0 0 2px '+secondaryDarker(props)},Button_boxShadow_neutral_focus:'0 0 0 2px '+color.surface+', 0 0 0 4px '+black43,Button_boxShadow_neutralNaked_focus:'0 0 0 2px '+black43,Button_boxShadow_white_focus:function Button_boxShadow_white_focus(_ref7){var sc=_ref7.sc;return'0 0 0 2px '+(sc.colorBehindButton||color.black)+', 0 0 0 4px '+white80},Button_boxShadow_whiteNaked_focus:'0 0 0 2px '+white80,Button_fontFamily:typography.fontFamily,Button_fontSize_small:typography.fontSize-2,Button_fontSize_medium:typography.fontSize,Button_fontSize_large:typography.fontSize+4,Button_fontSize_inline:'inherit',Button_fontWeight_themePrimary:typography.fontWeightMedium,Button_fontWeight_themeSecondary:typography.fontWeightMedium,Button_fontWeight_neutral:typography.fontWeightRegular,Button_fontWeight_white:typography.fontWeightMedium,Button_fontWeight_naked:typography.fontWeightMedium,Button_fontWeight_disabled:typography.fontWeightLight,Button_minHeight_small:size.small,Button_minHeight_medium:size.medium,Button_minHeight_large:size.large,Button_textDecoration:'none',Button_textDecoration_inline:'underline',Button_color_themePrimary:color.onPrimary,Button_color_themePrimary_disabled:color_disabled,Button_color_themePrimary_active:color.onPrimary,Button_color_themePrimary_focus:color.onPrimary,Button_color_themePrimary_hover:color.onPrimary,Button_color_themePrimaryNaked:primaryDarker,Button_color_themePrimaryNaked_disabled:color_disabled,Button_color_themePrimaryNaked_active:primaryDarkest,Button_color_themePrimaryNaked_focus:primaryDarkest,Button_color_themePrimaryNaked_hover:primaryDarkest,Button_color_themeSecondary:color.onSecondary,Button_color_themeSecondary_disabled:color_disabled,Button_color_themeSecondary_active:color.onSecondary,Button_color_themeSecondary_focus:color.onSecondary,Button_color_themeSecondary_hover:color.onSecondary,Button_color_themeSecondaryNaked:secondaryDarker,Button_color_themeSecondaryNaked_disabled:color_disabled,Button_color_themeSecondaryNaked_active:secondaryDarkest,Button_color_themeSecondaryNaked_focus:secondaryDarkest,Button_color_themeSecondaryNaked_hover:secondaryDarkest,Button_color_neutral:color.black,Button_color_neutral_disabled:color_disabled,Button_color_neutral_active:color.black,Button_color_neutral_focus:color.black,Button_color_neutral_hover:color.black,Button_color_neutralNaked:color.black,Button_color_neutralNaked_disabled:color_disabled,Button_color_neutralNaked_active:ninja9,Button_color_neutralNaked_focus:ninja9,Button_color_neutralNaked_hover:ninja9,Button_color_white:function Button_color_white(_ref8){var sc=_ref8.sc;return sc.colorBehindButton||color.black},Button_color_white_disabled:color.surface,Button_color_white_active:function Button_color_white_active(_ref9){var sc=_ref9.sc;return sc.colorBehindButton||color.black},Button_color_white_focus:function Button_color_white_focus(_ref10){var sc=_ref10.sc;return sc.colorBehindButton||color.black},Button_color_white_hover:function Button_color_white_hover(_ref11){var sc=_ref11.sc;return sc.colorBehindButton||color.black},Button_color_whiteNaked:color.surface,Button_color_whiteNaked_disabled:color.surface,Button_color_whiteNaked_active:white80,Button_color_whiteNaked_focus:white80,Button_color_whiteNaked_hover:white80,Button_paddingHorizontal_small:_Mathround(size.small*(2/3))+'px',Button_paddingHorizontal_medium:_Mathround(size.medium*(2/3))+'px',Button_paddingHorizontal_large:_Mathround(size.large*(2/3))+'px',Button_paddingHorizontal_fullWidth:''+rem(typography.fontSize-2),Button_paddingHorizontal_withIconSmall:''+rem(typography.fontSize-2),Button_paddingHorizontal_withIconMedium:''+rem(typography.fontSize),Button_paddingHorizontal_withIconLarge:''+rem(typography.fontSize),Button_transitionDuration:transition.duration.shortest,Button_transitionEasing:transition.easing.easeIn,ButtonContent_justifyContent:'center',ButtonIcon_fill_disabled:'rgba(0, 0, 0, 0.3)'})};exports.default=componentTheme;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes),_styledComponents=__webpack_require__(8),_styledComponents2=_interopRequireDefault(_styledComponents),_themes=__webpack_require__(5),_propTypes3=__webpack_require__(10),_componentTheme=__webpack_require__(583),_componentTheme2=_interopRequireDefault(_componentTheme);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj)0<=keys.indexOf(i)||Object.prototype.hasOwnProperty.call(obj,i)&&(target[i]=obj[i]);return target}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var Styled={div:{}};Styled.div.root=_styledComponents2.default.div.withConfig({displayName:'Card__root'})(['display:inline-block;padding:',';overflow:hidden;background-color:',';border-color:',';border-width:',';border-style:',';border-radius:',';box-shadow:',';transition-property:none;transition-duration:',';transition-timing-function:',';&:hover{box-shadow:',';}@media print{border:1px solid black;box-shadow:none;}'],(0,_themes.getStyle)('Card_padding'),(0,_themes.getStyle)('Card_backgroundColor'),(0,_themes.getStyle)('Card_borderColor'),(0,_themes.getStyle)('Card_borderWidth'),function(_ref){var sc=_ref.sc;return sc.raised?(0,_themes.getStyle)('Card_borderStyle_raised'):(0,_themes.getStyle)('Card_borderStyle')},(0,_themes.getStyle)('Card_borderRadius'),function(_ref2){var sc=_ref2.sc;return sc.raised?(0,_themes.getStyle)('Card_boxShadow_raised'):(0,_themes.getStyle)('Card_boxShadow')},function(props){return props.theme.vstui.transition.duration.shortest},function(props){return props.theme.vstui.transition.easing.easeIn},function(_ref3){var sc=_ref3.sc;return sc.raised&&sc.interactive?(0,_themes.getStyle)('Card_boxShadow_raisedInteractive_hover'):sc.raised?(0,_themes.getStyle)('Card_boxShadow_raised_hover'):(0,_themes.getStyle)('Card_boxShadow_hover')});var Card=function(_PureComponent){function Card(){return _classCallCheck(this,Card),_possibleConstructorReturn(this,(Card.__proto__||Object.getPrototypeOf(Card)).apply(this,arguments))}return _inherits(Card,_PureComponent),_createClass(Card,[{key:'render',value:function render(){var _props=this.props,className=_props.className,interactive=_props.interactive,raised=_props.raised,themeProp=_props.theme,otherProps=_objectWithoutProperties(_props,['className','interactive','raised','theme']),theme=(0,_componentTheme2.default)(themeProp);return _react2.default.createElement(Styled.div.root,_extends({},otherProps,{className:className,sc:{interactive:interactive,raised:raised},theme:theme}))}}]),Card}(_react.PureComponent);Card.propTypes={children:_propTypes2.default.node.isRequired,className:_propTypes2.default.string,interactive:_propTypes2.default.bool,raised:_propTypes2.default.bool,theme:_propTypes3.themeShape},Card.defaultProps={theme:(0,_themes.createTheme)()},Card.displayName='Card';var CardWithTheme=(0,_themes.withTheme)(Card);CardWithTheme.WrappedComponent=Card,exports.default=CardWithTheme;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _themes=__webpack_require__(5),componentTheme=function(baseTheme){var _baseTheme$vstui=baseTheme.vstui,color=_baseTheme$vstui.color,shape=_baseTheme$vstui.shape,shadow=_baseTheme$vstui.shadow,cloud3=color.cloud.getShade(3);return(0,_themes.createComponentTheme)(baseTheme,{Card_padding:0,Card_backgroundColor:color.surface,Card_borderColor:cloud3,Card_borderRadius:shape.borderRadius,Card_borderStyle:shape.borderStyle,Card_borderStyle_raised:'none',Card_borderWidth:shape.borderWidth,Card_boxShadow:'none',Card_boxShadow_hover:'none',Card_boxShadow_raised:shadow.low,Card_boxShadow_raised_hover:shadow.low,Card_boxShadow_raisedInteractive_hover:shadow.high})};exports.default=componentTheme;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _Checkbox=__webpack_require__(585);Object.defineProperty(exports,'default',{enumerable:!0,get:function get(){return _interopRequireDefault(_Checkbox).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof='function'==typeof Symbol&&'symbol'==typeof Symbol.iterator?function(obj){return typeof obj}:function(obj){return obj&&'function'==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?'symbol':typeof obj},_extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes),_FormGroup=__webpack_require__(87),_FormGroup2=_interopRequireDefault(_FormGroup),_CheckboxControl=__webpack_require__(592),_CheckboxControl2=_interopRequireDefault(_CheckboxControl),_themes=__webpack_require__(5),_propTypes3=__webpack_require__(10),_utils=__webpack_require__(25);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj)0<=keys.indexOf(i)||Object.prototype.hasOwnProperty.call(obj,i)&&(target[i]=obj[i]);return target}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var Checkbox=function(_Component){function Checkbox(props){_classCallCheck(this,Checkbox);var _this=_possibleConstructorReturn(this,(Checkbox.__proto__||Object.getPrototypeOf(Checkbox)).call(this,props));return _this.generatedId=(0,_utils.generateUniqueId)('checkbox'),_this.state={id:props.id||_this.generatedId,validationMessage:''},_this.handleFormControlRef=_this.handleFormControlRef.bind(_this),_this.handleNativeFormControlRef=_this.handleNativeFormControlRef.bind(_this),_this.handleValidate=_this.handleValidate.bind(_this),_this}return _inherits(Checkbox,_Component),_createClass(Checkbox,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var id=nextProps.id||this.generatedId;id!==this.state.id&&this.setState({id:id})}},{key:'focus',value:function focus(){this.nativeFormControl&&this.nativeFormControl.focus()}},{key:'validate',value:function validate(callback){this.formControl&&this.formControl.validate(callback)}},{key:'handleFormControlRef',value:function handleFormControlRef(node){this.formControl=node}},{key:'handleNativeFormControlRef',value:function handleNativeFormControlRef(node){var nativeFormControlRef=this.props.nativeFormControlRef;this.nativeFormControl=node,nativeFormControlRef&&nativeFormControlRef(node)}},{key:'handleValidate',value:function handleValidate(valid,validationMessage){this.setState({validationMessage:validationMessage})}},{key:'render',value:function render(){var _props=this.props,className=_props.className,disabled=_props.disabled,fullWidth=_props.fullWidth,helperText=_props.helperText,idIgnored=_props.id,inheritStyles=_props.inheritStyles,label=_props.label,labelHidden=_props.labelHidden,rootProps=_props.rootProps,secondary=_props.secondary,size=_props.size,theme=_props.theme,otherProps=_objectWithoutProperties(_props,['className','disabled','fullWidth','helperText','id','inheritStyles','label','labelHidden','rootProps','secondary','size','theme']),_state=this.state,id=_state.id,validationMessage=_state.validationMessage;return _react2.default.createElement(_FormGroup2.default,{checkboxControl:_react2.default.createElement(_CheckboxControl2.default,_extends({},otherProps,{innerRef:this.handleFormControlRef,labelHidden:labelHidden,nativeFormControlRef:this.handleNativeFormControlRef,onValidate:this.handleValidate,theme:theme})),className:className,disabled:disabled,fullWidth:fullWidth,helperText:helperText,id:id,inheritStyles:inheritStyles,label:label,labelHidden:labelHidden,rootProps:rootProps,secondary:secondary,size:size,theme:theme,validationMessage:validationMessage})}}]),Checkbox}(_react.Component);Checkbox.propTypes={checked:_propTypes2.default.bool,className:_propTypes2.default.string,defaultChecked:function defaultChecked(props,propName,componentName){if(props[propName]!==void 0){if(props.checked!==void 0)throw new Error('Props `defaultChecked` and `checked` are both defined in `'+componentName+'`, but only one is allowed. Use `defaultChecked` for an uncontrolled component, or `checked` for a controlled component.');if('boolean'!=typeof props[propName]&&null!==props[propName])return new Error('Invalid prop `'+propName+'` of type `'+_typeof(props[propName])+'` supplied to `'+componentName+'`, expected `boolean`, or a value of `null`.')}},disabled:_propTypes2.default.bool,fullWidth:_propTypes2.default.bool,helperText:_propTypes2.default.string,id:_propTypes2.default.string,inheritStyles:_propTypes2.default.bool,label:_propTypes2.default.node.isRequired,labelHidden:_propTypes2.default.bool,nativeFormControlRef:_propTypes2.default.func,onBlur:_propTypes2.default.func,onChange:_propTypes2.default.func,onFocus:_propTypes2.default.func,required:_propTypes2.default.bool,rootProps:_propTypes2.default.object,secondary:_propTypes2.default.bool,size:_propTypes2.default.oneOf(['small','medium','large']),theme:_propTypes3.themeShape,validate:_propTypes2.default.func},Checkbox.defaultProps={size:'medium',theme:(0,_themes.createTheme)()},Checkbox.displayName='Checkbox';var CheckboxWithTheme=(0,_themes.withTheme)(Checkbox);CheckboxWithTheme.WrappedComponent=Checkbox,exports.default=CheckboxWithTheme;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes),_styledComponents=__webpack_require__(8),_styledComponents2=_interopRequireDefault(_styledComponents),_propTypes3=__webpack_require__(10),_themes=__webpack_require__(5),_styles=__webpack_require__(17),_Label=__webpack_require__(166),_Label2=_interopRequireDefault(_Label),_FormControlMessage=__webpack_require__(589),_FormControlMessage2=_interopRequireDefault(_FormControlMessage);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var Styled={};Styled.div={},Styled.div.root=_styledComponents2.default.div.withConfig({displayName:'FormGroup__root'})(['',';width:',';max-width:100%;margin:0 0 20px 0;font-size:10px;vertical-align:top;'],function(props){return props.inheritStyles?'':_styles.resetInheritedStyles},function(_ref){var sc=_ref.sc;return sc.fullWidth?'100%':'270px'}),Styled.Label=(0,_styledComponents2.default)(_Label2.default).withConfig({displayName:'FormGroup__Label'})(['display:block;margin:0 0 7px 0;']),Styled.Label.displayName='Styled_Label',Styled.FormControlMessage=(0,_styledComponents2.default)(_FormControlMessage2.default).withConfig({displayName:'FormGroup__FormControlMessage'})(['margin:7px 0 0 0;']),Styled.FormControlMessage.displayName='Styled_FormControlMessage';var FormGroup=function(_PureComponent){function FormGroup(){return _classCallCheck(this,FormGroup),_possibleConstructorReturn(this,(FormGroup.__proto__||Object.getPrototypeOf(FormGroup)).apply(this,arguments))}return _inherits(FormGroup,_PureComponent),_createClass(FormGroup,[{key:'renderCheckboxControl',value:function renderCheckboxControl(){var _props=this.props,checkboxControl=_props.checkboxControl,disabled=_props.disabled,fullWidth=_props.fullWidth,id=_props.id,label=_props.label,labelHidden=_props.labelHidden,secondary=_props.secondary,size=_props.size,theme=_props.theme;return checkboxControl?_react2.default.cloneElement(checkboxControl,{disabled:disabled,fullWidth:fullWidth,id:id,inheritStyles:!0,label:label,labelHidden:labelHidden,secondary:secondary,size:size,theme:theme}):null}},{key:'renderFormControl',value:function renderFormControl(){var conditionalProps=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},_props2=this.props,disabled=_props2.disabled,formControl=_props2.formControl,fullWidth=_props2.fullWidth,id=_props2.id,secondary=_props2.secondary,size=_props2.size,theme=_props2.theme;return formControl?_react2.default.cloneElement(formControl,_extends({},conditionalProps,{disabled:disabled,fullWidth:fullWidth,id:id,inheritStyles:!0,secondary:secondary,size:size,theme:theme})):null}},{key:'render',value:function render(){var _props3=this.props,className=_props3.className,disabled=_props3.disabled,fullWidth=_props3.fullWidth,helperText=_props3.helperText,id=_props3.id,inheritStyles=_props3.inheritStyles,label=_props3.label,labelHidden=_props3.labelHidden,rootProps=_props3.rootProps,secondary=_props3.secondary,size=_props3.size,theme=_props3.theme,validationMessage=_props3.validationMessage,formControlMessage=validationMessage||helperText,formControlMessageId=id+'-form-control-message',conditionalFormControlProps={};formControlMessage&&(conditionalFormControlProps['aria-describedby']=formControlMessageId);var checkboxControl=this.renderCheckboxControl(),formControl=this.renderFormControl(conditionalFormControlProps);return _react2.default.createElement(Styled.div.root,_extends({},rootProps,{className:className,inheritStyles:inheritStyles,sc:{fullWidth:fullWidth}}),formControl&&label&&_react2.default.createElement(Styled.Label,{disabled:disabled,htmlFor:id,inheritStyles:!0,secondary:secondary,size:size,theme:theme,visuallyHidden:labelHidden},label),formControl||checkboxControl,formControlMessage&&_react2.default.createElement(Styled.FormControlMessage,{disabled:disabled,error:!!validationMessage,id:formControlMessageId,inheritStyles:!0,secondary:secondary,size:size,theme:theme},formControlMessage))}}]),FormGroup}(_react.PureComponent);FormGroup.propTypes={checkboxControl:_propTypes2.default.node,className:_propTypes2.default.string,disabled:_propTypes2.default.bool,formControl:_propTypes2.default.node,fullWidth:_propTypes2.default.bool,helperText:_propTypes2.default.string,id:_propTypes2.default.string,inheritStyles:_propTypes2.default.bool,label:_propTypes2.default.node,labelHidden:_propTypes2.default.bool,rootProps:_propTypes2.default.object,secondary:_propTypes2.default.bool,size:_propTypes2.default.oneOf(['small','medium','large']),theme:_propTypes3.themeShape,validationMessage:_propTypes2.default.string},FormGroup.defaultProps={theme:(0,_themes.createTheme)()},FormGroup.displayName='FormGroup';var FormGroupWithTheme=(0,_themes.withTheme)(FormGroup);FormGroupWithTheme.WrappedComponent=FormGroup,exports.default=FormGroupWithTheme;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes),_styledComponents=__webpack_require__(8),_styledComponents2=_interopRequireDefault(_styledComponents),_themes=__webpack_require__(5),_styles=__webpack_require__(17),_propTypes3=__webpack_require__(10),_componentTheme=__webpack_require__(588),_componentTheme2=_interopRequireDefault(_componentTheme);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj)0<=keys.indexOf(i)||Object.prototype.hasOwnProperty.call(obj,i)&&(target[i]=obj[i]);return target}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var Styled={label:_styledComponents2.default.label.withConfig({displayName:'Label__label'})(['',';color:',';font-family:',';font-size:',';font-weight:',';-webkit-font-smoothing:antialiased;transition-property:none;transition-duration:',';transition-timing-function:',';',';'],function(props){return props.inheritStyles?'':_styles.resetInheritedStyles},function(props){return props.sc.disabled?(0,_themes.getStyle)('Label_color_disabled'):(0,_themes.getStyle)('Label_color')},(0,_themes.getStyle)('Label_fontFamily'),function(props){return props.theme.vstui.rem((0,_themes.getStyle)('Label_fontSize_'+props.sc.size)(props))},(0,_themes.getStyle)('Label_fontWeight'),function(props){return props.theme.vstui.transition.duration.shortest},function(props){return props.theme.vstui.transition.easing.easeIn},function(props){return props.sc.visuallyHidden&&(0,_styles.visuallyHidden)()})},Label=function(_Component){function Label(){return _classCallCheck(this,Label),_possibleConstructorReturn(this,(Label.__proto__||Object.getPrototypeOf(Label)).apply(this,arguments))}return _inherits(Label,_Component),_createClass(Label,[{key:'render',value:function render(){var _props=this.props,children=_props.children,className=_props.className,disabled=_props.disabled,inheritStyles=_props.inheritStyles,size=_props.size,themeProp=_props.theme,visuallyHidden=_props.visuallyHidden,otherProps=_objectWithoutProperties(_props,['children','className','disabled','inheritStyles','size','theme','visuallyHidden']),theme=(0,_componentTheme2.default)(themeProp);return _react2.default.createElement(Styled.label,_extends({},otherProps,{className:className,inheritStyles:inheritStyles,sc:{disabled:disabled,size:size,visuallyHidden:visuallyHidden},theme:theme}),children)}}]),Label}(_react.Component);Label.propTypes={children:_propTypes2.default.node.isRequired,className:_propTypes2.default.string,disabled:_propTypes2.default.bool,inheritStyles:_propTypes2.default.bool,size:_propTypes2.default.oneOf(['small','medium','large']),visuallyHidden:_propTypes2.default.bool,theme:_propTypes3.themeShape},Label.defaultProps={size:'medium',theme:(0,_themes.createTheme)()},Label.displayName='Label';var LabelWithTheme=(0,_themes.withTheme)(Label);LabelWithTheme.WrappedComponent=Label,exports.default=LabelWithTheme;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _themes=__webpack_require__(5),componentTheme=function(baseTheme){var _baseTheme$vstui=baseTheme.vstui,color=_baseTheme$vstui.color,typography=_baseTheme$vstui.typography;return(0,_themes.createComponentTheme)(baseTheme,{Label_fontFamily:typography.fontFamily,Label_fontSize_small:typography.fontSize-1,Label_fontSize_medium:typography.fontSize-1,Label_fontSize_large:typography.fontSize,Label_fontWeight:typography.fontWeightMedium,Label_color:color.onSurface,Label_color_disabled:'rgba(0, 0, 0, 0.57)'})};exports.default=componentTheme;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _FormControlMessage=__webpack_require__(590);Object.defineProperty(exports,'default',{enumerable:!0,get:function get(){return _interopRequireDefault(_FormControlMessage).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes),_styledComponents=__webpack_require__(8),_styledComponents2=_interopRequireDefault(_styledComponents),_styles=__webpack_require__(17),_themes=__webpack_require__(5),_propTypes3=__webpack_require__(10),_componentTheme=__webpack_require__(591),_componentTheme2=_interopRequireDefault(_componentTheme);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj)0<=keys.indexOf(i)||Object.prototype.hasOwnProperty.call(obj,i)&&(target[i]=obj[i]);return target}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var Styled={div:_styledComponents2.default.div.withConfig({displayName:'FormControlMessage__div'})(['',';color:',';font-family:',';font-size:',';font-weight:',';-webkit-font-smoothing:antialiased;transition-property:none;transition-duration:',';transition-timing-function:',';'],function(props){return props.sc.inheritStyles?'':_styles.resetInheritedStyles},function(props){return props.sc.disabled?(0,_themes.getStyle)('FormControlMessage_color_disabled'):props.sc.error?(0,_themes.getStyle)('FormControlMessage_color_error'):(0,_themes.getStyle)('FormControlMessage_color')},(0,_themes.getStyle)('FormControlMessage_fontFamily'),function(props){return(0,_themes.getStyle)('FormControlMessage_fontSize_'+props.sc.size)},(0,_themes.getStyle)('FormControlMessage_fontWeight'),function(props){return props.theme.vstui.transition.duration.shortest},function(props){return props.theme.vstui.transition.easing.easeIn})},FormControlMessage=function(_PureComponent){function FormControlMessage(){return _classCallCheck(this,FormControlMessage),_possibleConstructorReturn(this,(FormControlMessage.__proto__||Object.getPrototypeOf(FormControlMessage)).apply(this,arguments))}return _inherits(FormControlMessage,_PureComponent),_createClass(FormControlMessage,[{key:'render',value:function render(){var _props=this.props,className=_props.className,disabled=_props.disabled,error=_props.error,inheritStyles=_props.inheritStyles,size=_props.size,themeProp=_props.theme,otherProps=_objectWithoutProperties(_props,['className','disabled','error','inheritStyles','size','theme']),theme=(0,_componentTheme2.default)(themeProp);return _react2.default.createElement(Styled.div,_extends({},otherProps,{className:className,"data-vstui-test":'FormControlMessage',sc:{disabled:disabled,error:error,inheritStyles:inheritStyles,size:size},theme:theme}),this.props.children)}}]),FormControlMessage}(_react.PureComponent);FormControlMessage.propTypes={children:_propTypes2.default.node.isRequired,className:_propTypes2.default.string,disabled:_propTypes2.default.bool,error:_propTypes2.default.bool,inheritStyles:_propTypes2.default.bool,size:_propTypes2.default.oneOf(['small','medium','large']),theme:_propTypes3.themeShape},FormControlMessage.defaultProps={size:'medium',theme:(0,_themes.createTheme)()},FormControlMessage.displayName='FormControlMessage';var FormControlMessageWithTheme=(0,_themes.withTheme)(FormControlMessage);FormControlMessageWithTheme.WrappedComponent=FormControlMessage,exports.default=FormControlMessageWithTheme;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _themes=__webpack_require__(5),componentTheme=function(baseTheme){var _baseTheme$vstui=baseTheme.vstui,color=_baseTheme$vstui.color,rem=_baseTheme$vstui.rem,typography=_baseTheme$vstui.typography;return(0,_themes.createComponentTheme)(baseTheme,{FormControlMessage_fontFamily:typography.fontFamily,FormControlMessage_fontSize_small:rem(typography.fontSize-1),FormControlMessage_fontSize_medium:rem(typography.fontSize-1),FormControlMessage_fontSize_large:rem(typography.fontSize),FormControlMessage_fontWeight:typography.fontWeightRegular,FormControlMessage_color:color.onSurface,FormControlMessage_color_disabled:'rgba(0, 0, 0, 0.57)',FormControlMessage_color_error:color.error})};exports.default=componentTheme;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _CheckboxControl=__webpack_require__(593);Object.defineProperty(exports,'default',{enumerable:!0,get:function get(){return _interopRequireDefault(_CheckboxControl).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes),_styledComponents=__webpack_require__(8),_styledComponents2=_interopRequireDefault(_styledComponents),_classnames=__webpack_require__(100),_classnames2=_interopRequireDefault(_classnames),_styles=__webpack_require__(17),_propTypes3=__webpack_require__(10),_themes=__webpack_require__(5),_Label=__webpack_require__(166),_Label2=_interopRequireDefault(_Label),_CheckboxIcon=__webpack_require__(594),_CheckboxIcon2=_interopRequireDefault(_CheckboxIcon),_FormControl=__webpack_require__(58),_FormControl2=_interopRequireDefault(_FormControl),_componentTheme=__webpack_require__(167),_componentTheme2=_interopRequireDefault(_componentTheme);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj)0<=keys.indexOf(i)||Object.prototype.hasOwnProperty.call(obj,i)&&(target[i]=obj[i]);return target}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var lineHeight=1.4,Styled={};Styled.div={},Styled.div.root=_styledComponents2.default.div.withConfig({displayName:'CheckboxControl__root'})(['',';display:inline-flex;box-sizing:border-box;align-items:center;width:',';max-width:100%;vertical-align:top;&.required{display:flex;min-height:',';padding:0 38px 0 12px;background-color:',';background-image:',';background-position:',';background-repeat:no-repeat;background-size:',';border-color:',';border-style:',';border-width:',';border-radius:',';}&.invalid{background-image:',';}'],function(props){return props.sc.inheritStyles?'':_styles.resetInheritedStyles},function(props){return props.sc.fullWidth?'100%':(0,_themes.getStyle)('CheckboxControl_width')},function(props){return props.theme.vstui.rem((0,_themes.getStyle)('CheckboxControl_minHeight_'+props.sc.size)(props))},(0,_themes.getStyle)('CheckboxContainer_backgroundColor'),(0,_themes.getStyle)('CheckboxControl_backgroundImage'),function(props){return(0,_themes.getStyle)('CheckboxControl_backgroundPosition_'+props.sc.size)(props)},(0,_themes.getStyle)('CheckboxControl_backgroundSize'),(0,_themes.getStyle)('CheckboxContainer_borderColor'),(0,_themes.getStyle)('CheckboxContainer_borderStyle'),(0,_themes.getStyle)('CheckboxContainer_borderWidth'),(0,_themes.getStyle)('CheckboxContainer_borderRadius'),(0,_themes.getStyle)('CheckboxControl_backgroundImage_invalid')),Styled.input=_styledComponents2.default.input.withConfig({displayName:'CheckboxControl__input'})(['',';'],(0,_styles.visuallyHidden)()),Styled.div.checkboxIcon=_styledComponents2.default.div.withConfig({displayName:'CheckboxControl__checkboxIcon'})(['display:flex;align-items:center;height:',';'],function(props){return props.theme.vstui.typography.pxToRem(props.theme.vstui.typography.fontSize*lineHeight)}),Styled.div.labelContent=_styledComponents2.default.div.withConfig({displayName:'CheckboxControl__labelContent'})(['display:inline-block;align-self:center;flex-grow:1;margin:0 0 0 10px;line-height:',';user-select:none;',';'],lineHeight,function(props){return props.sc.visuallyHidden?(0,_styles.visuallyHidden)():''}),Styled.div.labelContent.displayName='Styled_div_labelContent',Styled.Label=(0,_styledComponents2.default)(_Label2.default).withConfig({displayName:'CheckboxControl__Label'})(['position:relative;display:flex;font-size:',';font-weight:',';cursor:pointer;.required &{width:100%;padding:10px 0;}&.disabled{cursor:default;}'],function(props){return props.theme.vstui.rem((0,_themes.getStyle)('CheckboxControl_fontSize_'+props.sc.size)(props))},(0,_themes.getStyle)('CheckboxControl_fontWeight')),Styled.Label.displayName='Styled_Label';var CheckboxControl=function(_PureComponent){function CheckboxControl(){_classCallCheck(this,CheckboxControl);var _this=_possibleConstructorReturn(this,(CheckboxControl.__proto__||Object.getPrototypeOf(CheckboxControl)).call(this));return _this.handleFormControlRef=_this.handleFormControlRef.bind(_this),_this.handleValidate=_this.handleValidate.bind(_this),_this.renderContent=_this.renderContent.bind(_this),_this}return _inherits(CheckboxControl,_PureComponent),_createClass(CheckboxControl,[{key:'getValidationMessage',value:function getValidationMessage(validity){return validity.valueMissing?'Please check this box if you want to proceed.':''}},{key:'validate',value:function validate(callback){this.formControl.validate(callback)}},{key:'handleFormControlRef',value:function handleFormControlRef(node){this.formControl=node}},{key:'handleValidate',value:function handleValidate(validity){var _ref2=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},callback=_ref2.callback,onlyValidateIfValid=_ref2.onlyValidateIfValid,_ref=arguments[2],checked=_ref.checked,updateValidationState=_ref.updateValidationState,value=_ref.value,_props=this.props,onValidate=_props.onValidate,validate=_props.validate,passedDefaultValidation=validity.valid,defaultValidationMessage=this.getValidationMessage(validity,{checked:checked,value:value}),customValidationMessagePromise=Promise.resolve(validate?validate(value):''),update=function(valid,validationMessage){(!onlyValidateIfValid||onlyValidateIfValid&&valid)&&updateValidationState(valid,validationMessage,onValidate)};update(passedDefaultValidation,defaultValidationMessage),passedDefaultValidation?customValidationMessagePromise.then(function(customValidationMessage){var passedCustomValidation=!customValidationMessage;update(passedCustomValidation,customValidationMessage),callback&&callback(passedCustomValidation,customValidationMessage)}):callback&&callback(passedDefaultValidation,defaultValidationMessage)}},{key:'renderContent',value:function renderContent(_ref3){var checked=_ref3.checked,checkedFormControlValue=_ref3.checkedFormControlValue,defaultChecked=_ref3.defaultChecked,focused=_ref3.focused,invalid=_ref3.invalid,handleBlur=_ref3.handleBlur,handleChange=_ref3.handleChange,handleFocus=_ref3.handleFocus,handleNativeFormControlRef=_ref3.handleNativeFormControlRef,_props2=this.props,classNameProp=_props2.className,disabled=_props2.disabled,fullWidth=_props2.fullWidth,id=_props2.id,inheritStyles=_props2.inheritStyles,label=_props2.label,labelHidden=_props2.labelHidden,labelledBy=_props2.labelledBy,nativeFormControlRefIgnored=_props2.nativeFormControlRef,onBlurIgnored=_props2.onBlur,onChangeIgnored=_props2.onChange,onValidateIgnored=_props2.onValidate,required=_props2.required,secondary=_props2.secondary,size=_props2.size,themeProp=_props2.theme,validateIgnored=_props2.validate,otherProps=_objectWithoutProperties(_props2,['className','disabled','fullWidth','id','inheritStyles','label','labelHidden','labelledBy','nativeFormControlRef','onBlur','onChange','onValidate','required','secondary','size','theme','validate']),theme=(0,_componentTheme2.default)(themeProp),className=(0,_classnames2.default)(classNameProp,{invalid:invalid,required:required}),conditionalProps={};return invalid&&(conditionalProps['aria-invalid']=!0),required&&(conditionalProps['aria-required']=!0),_react2.default.createElement(Styled.div.root,{className:className,sc:{fullWidth:fullWidth,inheritStyles:inheritStyles,size:size},theme:theme},_react2.default.createElement(Styled.input,_extends({},otherProps,conditionalProps,{"aria-labelledby":labelledBy,checked:checkedFormControlValue,defaultChecked:defaultChecked,disabled:disabled,id:id,innerRef:handleNativeFormControlRef,onBlur:handleBlur,onChange:handleChange,onFocus:handleFocus,required:required,theme:theme,type:'checkbox'})),_react2.default.createElement(Styled.Label,{disabled:disabled,htmlFor:id,inheritStyles:!0,sc:{size:size},theme:theme},_react2.default.createElement(Styled.div.checkboxIcon,{theme:theme},_react2.default.createElement(_CheckboxIcon2.default,{checked:checked,disabled:disabled,focused:focused,invalid:invalid,secondary:secondary,theme:theme})),label&&_react2.default.createElement(Styled.div.labelContent,{sc:{visuallyHidden:labelHidden},theme:theme},label)))}},{key:'render',value:function render(){var _props3=this.props,checked=_props3.checked,defaultChecked=_props3.defaultChecked,nativeFormControlRef=_props3.nativeFormControlRef,onBlur=_props3.onBlur,onChange=_props3.onChange,theme=_props3.theme;return _react2.default.createElement(_FormControl2.default,{checked:checked,defaultChecked:defaultChecked,nativeFormControlRef:nativeFormControlRef,onFormControlBlur:onBlur,onFormControlChange:onChange,onValidate:this.handleValidate,ref:this.handleFormControlRef,render:this.renderContent,theme:theme,type:'checkbox'})}}]),CheckboxControl}(_react.PureComponent);CheckboxControl.propTypes={checked:_propTypes2.default.bool,className:_propTypes2.default.string,defaultChecked:_propTypes2.default.bool,disabled:_propTypes2.default.bool,fullWidth:_propTypes2.default.bool,id:_propTypes2.default.string,inheritStyles:_propTypes2.default.bool,label:_propTypes2.default.node,labelHidden:_propTypes2.default.bool,labelledBy:_propTypes2.default.string,nativeFormControlRef:_propTypes2.default.func,onBlur:_propTypes2.default.func,onChange:_propTypes2.default.func,onFocus:_propTypes2.default.func,onValidate:_propTypes2.default.func,required:_propTypes2.default.bool,secondary:_propTypes2.default.bool,size:_propTypes2.default.oneOf(['small','medium','large']),theme:_propTypes3.themeShape,validate:_propTypes2.default.func},CheckboxControl.defaultProps={size:'medium',theme:(0,_themes.createTheme)()},CheckboxControl.displayName='CheckboxControl';var CheckboxControlWithTheme=(0,_themes.withTheme)(CheckboxControl);CheckboxControlWithTheme.WrappedComponent=CheckboxControl,exports.default=CheckboxControlWithTheme;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes),_styledComponents=__webpack_require__(8),_styledComponents2=_interopRequireDefault(_styledComponents),_propTypes3=__webpack_require__(10),_themes=__webpack_require__(5),_icons=__webpack_require__(114),_componentTheme=__webpack_require__(167),_componentTheme2=_interopRequireDefault(_componentTheme);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var Styled={div:{}};Styled.div.root=_styledComponents2.default.div.withConfig({displayName:'CheckboxIcon__root'})(['width:14px;height:14px;border-radius:50%;box-shadow:0 0 0 ',' ',';transition-property:none;transition-duration:',';'],function(props){return props.sc.focused?'7px':0},function(props){return props.sc.highlightColor},function(props){return props.theme.vstui.transition.duration.shortest});var CheckboxIcon=function(_PureComponent){function CheckboxIcon(){return _classCallCheck(this,CheckboxIcon),_possibleConstructorReturn(this,(CheckboxIcon.__proto__||Object.getPrototypeOf(CheckboxIcon)).apply(this,arguments))}return _inherits(CheckboxIcon,_PureComponent),_createClass(CheckboxIcon,[{key:'render',value:function render(){var _props=this.props,checked=_props.checked,disabled=_props.disabled,focused=_props.focused,invalid=_props.invalid,secondary=_props.secondary,themeProp=_props.theme,theme=(0,_componentTheme2.default)(themeProp),variant=secondary?'secondary':'primary',iconColor=void 0,highlightColor=void 0;return checked?disabled?(iconColor={color1:theme.vstui['CheckboxIcon_borderColor_'+variant+'_checkedDisabled'],color2:theme.vstui['CheckboxIcon_backgroundColor_'+variant+'_checkedDisabled'],color3:theme.vstui['CheckboxIcon_color_'+variant+'_checkedDisabled']},highlightColor=theme.vstui['CheckboxIconHighlight_backgroundColor_'+variant+'_checkedDisabled']):invalid&&focused?(iconColor={color1:theme.vstui['CheckboxIcon_borderColor_'+variant+'_checkedInvalidFocus'],color2:theme.vstui['CheckboxIcon_backgroundColor_'+variant+'_checkedInvalidFocus'],color3:theme.vstui['CheckboxIcon_color_'+variant+'_checkedInvalidFocus']},highlightColor=theme.vstui['CheckboxIconHighlight_backgroundColor_'+variant+'_checkedInvalidFocus']):invalid?(iconColor={color1:theme.vstui['CheckboxIcon_borderColor_'+variant+'_checkedInvalid'],color2:theme.vstui['CheckboxIcon_backgroundColor_'+variant+'_checkedInvalid'],color3:theme.vstui['CheckboxIcon_color_'+variant+'_checkedInvalid']},highlightColor=theme.vstui['CheckboxIconHighlight_backgroundColor_'+variant+'_checkedInvalid']):focused?(iconColor={color1:theme.vstui['CheckboxIcon_borderColor_'+variant+'_checkedFocus'],color2:theme.vstui['CheckboxIcon_backgroundColor_'+variant+'_checkedFocus'],color3:theme.vstui['CheckboxIcon_color_'+variant+'_checkedFocus']},highlightColor=theme.vstui['CheckboxIconHighlight_backgroundColor_'+variant+'_checkedFocus']):(iconColor={color1:theme.vstui['CheckboxIcon_borderColor_'+variant+'_checked'],color2:theme.vstui['CheckboxIcon_backgroundColor_'+variant+'_checked'],color3:theme.vstui['CheckboxIcon_color_'+variant+'_checked']},highlightColor=theme.vstui['CheckboxIconHighlight_backgroundColor_'+variant+'_checked']):disabled?(iconColor={color1:theme.vstui['CheckboxIcon_borderColor_'+variant+'_disabled'],color2:theme.vstui['CheckboxIcon_backgroundColor_'+variant+'_disabled'],color3:theme.vstui['CheckboxIcon_backgroundColor_'+variant+'_disabled']},highlightColor=theme.vstui['CheckboxIconHighlight_backgroundColor_'+variant+'_disabled']):invalid&&focused?(iconColor={color1:theme.vstui['CheckboxIcon_borderColor_'+variant+'_invalidFocus'],color2:theme.vstui['CheckboxIcon_backgroundColor_'+variant+'_invalidFocus'],color3:theme.vstui['CheckboxIcon_backgroundColor_'+variant+'_invalidFocus']},highlightColor=theme.vstui['CheckboxIconHighlight_backgroundColor_'+variant+'_invalidFocus']):invalid?(iconColor={color1:theme.vstui['CheckboxIcon_borderColor_'+variant+'_invalid'],color2:theme.vstui['CheckboxIcon_backgroundColor_'+variant+'_invalidFocus'],color3:theme.vstui['CheckboxIcon_backgroundColor_'+variant+'_invalidFocus']},highlightColor=theme.vstui['CheckboxIconHighlight_backgroundColor_'+variant+'_invalid']):focused?(iconColor={color1:theme.vstui['CheckboxIcon_borderColor_'+variant+'_focus'],color2:theme.vstui['CheckboxIcon_backgroundColor_'+variant+'_focus'],color3:theme.vstui['CheckboxIcon_backgroundColor_'+variant+'_focus']},highlightColor=theme.vstui['CheckboxIconHighlight_backgroundColor_'+variant+'_focus']):(iconColor={color1:theme.vstui['CheckboxIcon_borderColor_'+variant],color2:theme.vstui['CheckboxIcon_backgroundColor_'+variant],color3:theme.vstui['CheckboxIcon_backgroundColor_'+variant]},highlightColor=theme.vstui['CheckboxIconHighlight_backgroundColor_'+variant]),_react2.default.createElement(Styled.div.root,{sc:{highlightColor:highlightColor,focused:focused,invalid:invalid},theme:theme},_react2.default.createElement(_icons.CheckboxChecked,{color:iconColor}))}}]),CheckboxIcon}(_react.PureComponent);CheckboxIcon.propTypes={checked:_propTypes2.default.bool,disabled:_propTypes2.default.bool,focused:_propTypes2.default.bool,invalid:_propTypes2.default.bool,secondary:_propTypes2.default.bool,theme:_propTypes3.themeShape},CheckboxIcon.defaultProps={theme:(0,_themes.createTheme)()},CheckboxIcon.displayName='CheckboxIcon';var CheckboxIconWithTheme=(0,_themes.withTheme)(CheckboxIcon);CheckboxIconWithTheme.WrappedComponent=CheckboxIcon,exports.default=CheckboxIconWithTheme;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_Icon=__webpack_require__(16),_Icon2=_interopRequireDefault(_Icon);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var CaretDownSmall=function(_PureComponent){function CaretDownSmall(){return _classCallCheck(this,CaretDownSmall),_possibleConstructorReturn(this,(CaretDownSmall.__proto__||Object.getPrototypeOf(CaretDownSmall)).apply(this,arguments))}return _inherits(CaretDownSmall,_PureComponent),_createClass(CaretDownSmall,[{key:'render',value:function render(){return _react2.default.createElement(_Icon2.default,_extends({},this.props,{height:6,width:10}),_react2.default.createElement('path',{d:'M5 3.586L8.293.293a.999.999 0 1 1 1.414 1.414l-4 4a.999.999 0 0 1-1.414 0l-4-4a.997.997 0 0 1 0-1.414.999.999 0 0 1 1.414 0L5 3.586z'}))}}]),CaretDownSmall}(_react.PureComponent);CaretDownSmall.displayName='CaretDownSmall',CaretDownSmall.vstuiName='Icon',exports.default=CaretDownSmall;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes),_styledComponents=__webpack_require__(8),_styledComponents2=_interopRequireDefault(_styledComponents);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj)0<=keys.indexOf(i)||Object.prototype.hasOwnProperty.call(obj,i)&&(target[i]=obj[i]);return target}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var Styled={svg:_styledComponents2.default.svg.withConfig({displayName:'Icon__svg'})(['display:inline-block;width:','px;height:','px;vertical-align:top;fill:',';.color1{fill:',';}.color2{fill:',';}.color3{fill:',';}'],function(props){return props.sc.width},function(props){return props.sc.height},function(props){return props.sc.color.color1},function(props){return props.sc.color.color1},function(props){return props.sc.color.color2},function(props){return props.sc.color.color3})},Icon=function(_PureComponent){function Icon(){return _classCallCheck(this,Icon),_possibleConstructorReturn(this,(Icon.__proto__||Object.getPrototypeOf(Icon)).apply(this,arguments))}return _inherits(Icon,_PureComponent),_createClass(Icon,[{key:'render',value:function render(){var _props=this.props,children=_props.children,colorProp=_props.color,height=_props.height,width=_props.width,otherProps=_objectWithoutProperties(_props,['children','color','height','width']),color={};return'string'==typeof colorProp?color.color1=colorProp:color=Object.assign({},colorProp),_react2.default.createElement(Styled.svg,_extends({"aria-hidden":!0,focusable:'false',sc:{color:color,height:height,width:width},viewBox:'0 0 '+width+' '+height},otherProps),children)}}]),Icon}(_react.PureComponent);Icon.propTypes={children:_propTypes2.default.node.isRequired,color:_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.shape({color1:_propTypes2.default.string.isRequired,color2:_propTypes2.default.string.isRequired,color3:_propTypes2.default.string})]),height:_propTypes2.default.number.isRequired,width:_propTypes2.default.number.isRequired},Icon.defaultProps={color:'currentColor'},Icon.vstuiName='Icon',exports.default=Icon;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_Icon=__webpack_require__(16),_Icon2=_interopRequireDefault(_Icon);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var CaretLeftSmall=function(_PureComponent){function CaretLeftSmall(){return _classCallCheck(this,CaretLeftSmall),_possibleConstructorReturn(this,(CaretLeftSmall.__proto__||Object.getPrototypeOf(CaretLeftSmall)).apply(this,arguments))}return _inherits(CaretLeftSmall,_PureComponent),_createClass(CaretLeftSmall,[{key:'render',value:function render(){return _react2.default.createElement(_Icon2.default,_extends({},this.props,{height:10,width:6}),_react2.default.createElement('path',{d:'M2.414 5l3.293 3.293a.999.999 0 1 1-1.414 1.414l-4-4a.999.999 0 0 1 0-1.414l4-4a.997.997 0 0 1 1.414 0 .999.999 0 0 1 0 1.414L2.414 5z'}))}}]),CaretLeftSmall}(_react.PureComponent);CaretLeftSmall.displayName='CaretLeftSmall',CaretLeftSmall.vstuiName='Icon',exports.default=CaretLeftSmall;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_Icon=__webpack_require__(16),_Icon2=_interopRequireDefault(_Icon);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var CaretRightSmall=function(_PureComponent){function CaretRightSmall(){return _classCallCheck(this,CaretRightSmall),_possibleConstructorReturn(this,(CaretRightSmall.__proto__||Object.getPrototypeOf(CaretRightSmall)).apply(this,arguments))}return _inherits(CaretRightSmall,_PureComponent),_createClass(CaretRightSmall,[{key:'render',value:function render(){return _react2.default.createElement(_Icon2.default,_extends({},this.props,{height:10,width:6}),_react2.default.createElement('path',{d:'M3.586 5L.293 1.707A.999.999 0 1 1 1.707.293l4 4a.999.999 0 0 1 0 1.414l-4 4a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L3.586 5z'}))}}]),CaretRightSmall}(_react.PureComponent);CaretRightSmall.displayName='CaretRightSmall',CaretRightSmall.vstuiName='Icon',exports.default=CaretRightSmall;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_Icon=__webpack_require__(16),_Icon2=_interopRequireDefault(_Icon);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var Checkbox=function(_PureComponent){function Checkbox(){return _classCallCheck(this,Checkbox),_possibleConstructorReturn(this,(Checkbox.__proto__||Object.getPrototypeOf(Checkbox)).apply(this,arguments))}return _inherits(Checkbox,_PureComponent),_createClass(Checkbox,[{key:'render',value:function render(){return _react2.default.createElement(_Icon2.default,_extends({},this.props,{height:14,width:14}),_react2.default.createElement('rect',{className:'color2',height:'14',rx:'3',width:'14'}),_react2.default.createElement('path',{className:'color1',d:'M1 3.003v7.994C1 12.104 1.896 13 3.003 13h7.994A2.002 2.002 0 0 0 13 10.997V3.003A2.002 2.002 0 0 0 10.997 1H3.003A2.002 2.002 0 0 0 1 3.003zm-1 0A3.002 3.002 0 0 1 3.003 0h7.994A3.002 3.002 0 0 1 14 3.003v7.994A3.002 3.002 0 0 1 10.997 14H3.003A3.002 3.002 0 0 1 0 10.997V3.003z'}))}}]),Checkbox}(_react.PureComponent);Checkbox.displayName='Checkbox',Checkbox.vstuiName='Icon',exports.default=Checkbox;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_Icon=__webpack_require__(16),_Icon2=_interopRequireDefault(_Icon);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var CheckboxChecked=function(_PureComponent){function CheckboxChecked(){return _classCallCheck(this,CheckboxChecked),_possibleConstructorReturn(this,(CheckboxChecked.__proto__||Object.getPrototypeOf(CheckboxChecked)).apply(this,arguments))}return _inherits(CheckboxChecked,_PureComponent),_createClass(CheckboxChecked,[{key:'render',value:function render(){return _react2.default.createElement(_Icon2.default,_extends({},this.props,{height:14,width:14}),_react2.default.createElement('rect',{className:'color3',height:'14',rx:'3',width:'14'}),_react2.default.createElement('path',{className:'color2',d:'M10.793 5.563L6.648 9.707c-.39.39-1.024.39-1.415 0l-1.94-1.94A1 1 0 1 1 4.707 6.35L5.94 7.585 9.379 4.15a.999.999 0 1 1 1.414 1.413M11 0H3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V3a2.999 2.999 0 0 0-3-3'}),_react2.default.createElement('path',{className:'color1',d:'M1 3.003v7.994C1 12.104 1.896 13 3.003 13h7.994A2.002 2.002 0 0 0 13 10.997V3.003A2.002 2.002 0 0 0 10.997 1H3.003A2.002 2.002 0 0 0 1 3.003zm-1 0A3.002 3.002 0 0 1 3.003 0h7.994A3.002 3.002 0 0 1 14 3.003v7.994A3.002 3.002 0 0 1 10.997 14H3.003A3.002 3.002 0 0 1 0 10.997V3.003z'}))}}]),CheckboxChecked}(_react.PureComponent);CheckboxChecked.displayName='CheckboxChecked',CheckboxChecked.vstuiName='Icon',exports.default=CheckboxChecked;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_Icon=__webpack_require__(16),_Icon2=_interopRequireDefault(_Icon);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var Checkmark=function(_PureComponent){function Checkmark(){return _classCallCheck(this,Checkmark),_possibleConstructorReturn(this,(Checkmark.__proto__||Object.getPrototypeOf(Checkmark)).apply(this,arguments))}return _inherits(Checkmark,_PureComponent),_createClass(Checkmark,[{key:'render',value:function render(){return _react2.default.createElement(_Icon2.default,_extends({},this.props,{height:10,width:13}),_react2.default.createElement('path',{d:'M4 10a.997.997 0 0 1-.707-.293l-3-3a.999.999 0 1 1 1.414-1.414L4 7.586 11.293.293a.999.999 0 1 1 1.414 1.414l-8 8A.997.997 0 0 1 4 10'}))}}]),Checkmark}(_react.PureComponent);Checkmark.displayName='Checkmark',Checkmark.vstuiName='Icon',exports.default=Checkmark;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_Icon=__webpack_require__(16),_Icon2=_interopRequireDefault(_Icon);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var CheckmarkCircle=function(_PureComponent){function CheckmarkCircle(){return _classCallCheck(this,CheckmarkCircle),_possibleConstructorReturn(this,(CheckmarkCircle.__proto__||Object.getPrototypeOf(CheckmarkCircle)).apply(this,arguments))}return _inherits(CheckmarkCircle,_PureComponent),_createClass(CheckmarkCircle,[{key:'render',value:function render(){return _react2.default.createElement(_Icon2.default,_extends({},this.props,{height:18,width:18}),_react2.default.createElement('path',{d:'M9 16c-3.859 0-7-3.141-7-7s3.141-7 7-7 7 3.141 7 7-3.141 7-7 7M9 0a9 9 0 0 1 9 9 9 9 0 0 1-9 9 9 9 0 0 1-9-9 9 9 0 0 1 9-9zm4.706 6.05a.999.999 0 0 0-1.414 0l-4.534 4.536-2.063-2.062a.999.999 0 1 0-1.414 1.414l2.77 2.769a1 1 0 0 0 1.414 0l5.241-5.241a1 1 0 0 0 0-1.415z',fillRule:'evenodd'}))}}]),CheckmarkCircle}(_react.PureComponent);CheckmarkCircle.displayName='CheckmarkCircle',CheckmarkCircle.vstuiName='Icon',exports.default=CheckmarkCircle;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_Icon=__webpack_require__(16),_Icon2=_interopRequireDefault(_Icon);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var ExclamationCircle=function(_PureComponent){function ExclamationCircle(){return _classCallCheck(this,ExclamationCircle),_possibleConstructorReturn(this,(ExclamationCircle.__proto__||Object.getPrototypeOf(ExclamationCircle)).apply(this,arguments))}return _inherits(ExclamationCircle,_PureComponent),_createClass(ExclamationCircle,[{key:'render',value:function render(){return _react2.default.createElement(_Icon2.default,_extends({},this.props,{height:18,width:18}),_react2.default.createElement('path',{d:'M9 18a9 9 0 0 0 9-9 9 9 0 0 0-9-9 9 9 0 0 0-9 9 9 9 0 0 0 9 9m0-2c-3.859 0-7-3.141-7-7s3.141-7 7-7 7 3.141 7 7-3.141 7-7 7zM9 4.25a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1zm1.25 8.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0z'}))}}]),ExclamationCircle}(_react.PureComponent);ExclamationCircle.displayName='ExclamationCircle',ExclamationCircle.vstuiName='Icon',exports.default=ExclamationCircle;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_Icon=__webpack_require__(16),_Icon2=_interopRequireDefault(_Icon);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var FormError=function(_PureComponent){function FormError(){return _classCallCheck(this,FormError),_possibleConstructorReturn(this,(FormError.__proto__||Object.getPrototypeOf(FormError)).apply(this,arguments))}return _inherits(FormError,_PureComponent),_createClass(FormError,[{key:'render',value:function render(){return _react2.default.createElement(_Icon2.default,_extends({},this.props,{height:14,width:14}),_react2.default.createElement('path',{d:'M8 6a1 1 0 1 1-2 0V4a1 1 0 1 1 2 0v2zm-1 5a1 1 0 1 1 0-2 1 1 0 1 1 0 2zM7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0z'}))}}]),FormError}(_react.PureComponent);FormError.displayName='FormError',FormError.vstuiName='Icon',exports.default=FormError;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_Icon=__webpack_require__(16),_Icon2=_interopRequireDefault(_Icon);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var ICircle=function(_PureComponent){function ICircle(){return _classCallCheck(this,ICircle),_possibleConstructorReturn(this,(ICircle.__proto__||Object.getPrototypeOf(ICircle)).apply(this,arguments))}return _inherits(ICircle,_PureComponent),_createClass(ICircle,[{key:'render',value:function render(){return _react2.default.createElement(_Icon2.default,_extends({},this.props,{height:18,width:18}),_react2.default.createElement('path',{d:'M9 0a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9m0 2c3.859 0 7 3.141 7 7s-3.141 7-7 7-7-3.141-7-7 3.141-7 7-7zm0 11.75a1 1 0 0 0 1-1v-4a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1zM7.75 5.5a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0z'}))}}]),ICircle}(_react.PureComponent);ICircle.displayName='ICircle',ICircle.vstuiName='Icon',exports.default=ICircle;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_Icon=__webpack_require__(16),_Icon2=_interopRequireDefault(_Icon);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var RadioButton=function(_PureComponent){function RadioButton(){return _classCallCheck(this,RadioButton),_possibleConstructorReturn(this,(RadioButton.__proto__||Object.getPrototypeOf(RadioButton)).apply(this,arguments))}return _inherits(RadioButton,_PureComponent),_createClass(RadioButton,[{key:'render',value:function render(){return _react2.default.createElement(_Icon2.default,_extends({},this.props,{height:14,width:14}),_react2.default.createElement('circle',{cx:'7',cy:'7',fill:'#ffffff',r:'7'}),_react2.default.createElement('path',{d:'M7 13A6 6 0 1 0 7 1a6 6 0 0 0 0 12zm0 1A7 7 0 1 1 7 0a7 7 0 0 1 0 14z'}))}}]),RadioButton}(_react.PureComponent);RadioButton.displayName='RadioButton',RadioButton.vstuiName='Icon',exports.default=RadioButton;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_Icon=__webpack_require__(16),_Icon2=_interopRequireDefault(_Icon);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var RadioButtonSelected=function(_PureComponent){function RadioButtonSelected(){return _classCallCheck(this,RadioButtonSelected),_possibleConstructorReturn(this,(RadioButtonSelected.__proto__||Object.getPrototypeOf(RadioButtonSelected)).apply(this,arguments))}return _inherits(RadioButtonSelected,_PureComponent),_createClass(RadioButtonSelected,[{key:'render',value:function render(){return _react2.default.createElement(_Icon2.default,_extends({},this.props,{height:14,width:14}),_react2.default.createElement('circle',{cx:'7',cy:'7',r:'7'}),_react2.default.createElement('path',{d:'M7 13A6 6 0 1 0 7 1a6 6 0 0 0 0 12zm0 1A7 7 0 1 1 7 0a7 7 0 0 1 0 14z'}),_react2.default.createElement('circle',{cx:'7',cy:'7',fill:'#ffffff',r:'2'}))}}]),RadioButtonSelected}(_react.PureComponent);RadioButtonSelected.displayName='RadioButtonSelected',RadioButtonSelected.vstuiName='Icon',exports.default=RadioButtonSelected;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_Icon=__webpack_require__(16),_Icon2=_interopRequireDefault(_Icon);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var XSmall=function(_PureComponent){function XSmall(){return _classCallCheck(this,XSmall),_possibleConstructorReturn(this,(XSmall.__proto__||Object.getPrototypeOf(XSmall)).apply(this,arguments))}return _inherits(XSmall,_PureComponent),_createClass(XSmall,[{key:'render',value:function render(){return _react2.default.createElement(_Icon2.default,_extends({},this.props,{height:10,width:10}),_react2.default.createElement('path',{d:'M6.414 5l3.293-3.293A.999.999 0 1 0 8.293.293L5 3.586 1.707.293A.999.999 0 1 0 .293 1.707L3.586 5 .293 8.293a.999.999 0 1 0 1.414 1.414L5 6.414l3.293 3.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L6.414 5z'}))}}]),XSmall}(_react.PureComponent);XSmall.displayName='XSmall',XSmall.vstuiName='Icon',exports.default=XSmall;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof='function'==typeof Symbol&&'symbol'==typeof Symbol.iterator?function(obj){return typeof obj}:function(obj){return obj&&'function'==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?'symbol':typeof obj},_extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes),_FormContext=__webpack_require__(168),_FormContext2=_interopRequireDefault(_FormContext);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var FormControl=function(_Component){function FormControl(props){_classCallCheck(this,FormControl);var _this=_possibleConstructorReturn(this,(FormControl.__proto__||Object.getPrototypeOf(FormControl)).call(this,props));return _this.state={checked:!1,checkedFormControlValue:!1,focused:!1,invalid:!1,touched:!1,value:''},_this.focus=_this.focus.bind(_this),_this.handleBlur=_this.handleBlur.bind(_this),_this.handleChange=_this.handleChange.bind(_this),_this.handleFocus=_this.handleFocus.bind(_this),_this.handleNativeFormControlRef=_this.handleNativeFormControlRef.bind(_this),_this.handleValidate=_this.handleValidate.bind(_this),_this.reset=_this.reset.bind(_this),_this.validate=_this.validate.bind(_this),_this}return _inherits(FormControl,_Component),_createClass(FormControl,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,checkedProp=_props.checked,defaultCheckedProp=_props.defaultChecked,defaultValueProp=_props.defaultValue,type=_props.type,valueProp=_props.value,checked=this.getChecked(checkedProp),defaultChecked=this.getChecked(defaultCheckedProp),defaultValue=this.getValue(defaultValueProp),value=this.getValue(valueProp),usesChecked='checkbox'===type||'radio'===type;this.isControlled=usesChecked?void 0!==checked:void 0!==value,usesChecked?this.setState({defaultChecked:defaultChecked,checkedFormControlValue:this.isControlled?checked:void 0,checked:checked}):this.setState({defaultValue:defaultValue,value:this.isControlled?value:void 0})}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var checked=this.getChecked(nextProps.checked),value=this.getValue(nextProps.value);this.setState({checkedFormControlValue:checked,checked:checked,value:value})}},{key:'getChecked',value:function getChecked(checked){return null!==checked&&checked}},{key:'getValue',value:function getValue(value){return null===value?'':value}},{key:'focus',value:function focus(){this.nativeFormControl.focus()}},{key:'reset',value:function reset(){var type=this.props.type;this.setState({invalid:!1,touched:!1}),('checkbox'===type||'radio'===type)&&this.setState({checked:!1}),this.isControlled||('checkbox'===type||'radio'===type?this.nativeFormControl.checked=!1:this.nativeFormControl.value=''),this.handleValidate({valid:!0})}},{key:'validate',value:function validate(callback){this.handleValidate(this.nativeFormControl.validity,{callback:callback})}},{key:'handleBlur',value:function handleBlur(event){var _this2=this,validity=event.target.validity,onFormControlBlur=this.props.onFormControlBlur,touched=this.state.touched;this.setState({focused:!1,touched:!0},function(){touched||_this2.handleValidate(validity)}),onFormControlBlur&&onFormControlBlur(event)}},{key:'handleChange',value:function handleChange(event){var _this3=this,input=event.target,checked=input.checked,type=input.type,validity=input.validity,value=input.value,onFormControlChange=this.props.onFormControlChange,touched=this.state.touched;if(('checkbox'===type||'radio'===type)&&this.setState({checked:checked}),this.isControlled){var updatedState={};'checkbox'===type||'radio'===type?updatedState.checkedFormControlValue=checked:updatedState.value=value,this.setState(updatedState,function(){touched&&_this3.handleValidate(validity)})}onFormControlChange&&onFormControlChange(event),!this.isControlled&&touched&&this.handleValidate(validity)}},{key:'handleFocus',value:function handleFocus(event){var onFormControlFocus=this.props.onFormControlFocus;this.setState({focused:!0}),onFormControlFocus&&onFormControlFocus(event)}},{key:'handleNativeFormControlRef',value:function handleNativeFormControlRef(node){var nativeFormControlRef=this.props.nativeFormControlRef;this.nativeFormControl=node,this.nativeFormControl&&this.registerFormControl&&this.registerFormControl({focus:this.focus,id:this.nativeFormControl.id,reset:this.reset,validate:this.validate}),nativeFormControlRef&&nativeFormControlRef(node)}},{key:'handleValidate',value:function handleValidate(validity,options){var _this4=this,onValidate=this.props.onValidate;onValidate(validity,options,_extends({updateValidationState:function updateValidationState(valid,validationMessage,onValidateCallback){_this4.setState({invalid:!valid,touched:!0}),onValidateCallback&&onValidateCallback(valid,validationMessage)}},this.state))}},{key:'render',value:function render(){var _this5=this,_state=this.state,checked=_state.checked,checkedFormControlValue=_state.checkedFormControlValue,defaultChecked=_state.defaultChecked,defaultValue=_state.defaultValue,focused=_state.focused,invalid=_state.invalid,value=_state.value;return _react2.default.createElement(_FormContext2.default.Consumer,null,function(registerFormControl){return _this5.registerFormControl=registerFormControl,_this5.props.render({checked:checked,checkedFormControlValue:checkedFormControlValue,defaultChecked:defaultChecked,defaultValue:defaultValue,focused:focused,invalid:invalid,handleBlur:_this5.handleBlur,handleChange:_this5.handleChange,handleFocus:_this5.handleFocus,handleNativeFormControlRef:_this5.handleNativeFormControlRef,value:value})})}}]),FormControl}(_react.Component);FormControl.propTypes={checked:_propTypes2.default.bool,defaultChecked:_propTypes2.default.bool,defaultValue:function defaultValue(props,propName,componentName){if(props[propName]!==void 0){if(props.value!==void 0)throw new Error('Props `defaultValue` and `value` are both defined in `'+componentName+'`, but only one is allowed. Use `defaultValue` for an uncontrolled component, or `value` for a controlled component.');if('string'!=typeof props[propName]&&null!==props[propName])return new Error('Invalid prop `'+propName+'` of type `'+_typeof(props[propName])+'` supplied to `'+componentName+'`, expected `string`, or a value of `null`.')}},nativeFormControlRef:_propTypes2.default.func,onFormControlBlur:_propTypes2.default.func,onFormControlChange:_propTypes2.default.func,onFormControlFocus:_propTypes2.default.func,onValidate:_propTypes2.default.func,render:_propTypes2.default.func,type:_propTypes2.default.string,value:_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.number])},FormControl.defaultProps={},FormControl.displayName='FormControl',FormControl.WrappedComponent=FormControl,exports.default=FormControl;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(611);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(612);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(613);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(72);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _Dialog=__webpack_require__(615);Object.defineProperty(exports,'default',{enumerable:!0,get:function get(){return _interopRequireDefault(_Dialog).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_templateObject=_taggedTemplateLiteral(['\n      transition-duration: ','ms;\n    '],['\n      transition-duration: ','ms;\n    ']),_templateObject2=_taggedTemplateLiteral(['\n      width: 100%;\n      max-width: 100%;\n      max-height: 100%;\n      height: 100%;\n      border-radius: 0;\n\n      transition-duration: ','ms;\n\n      transform: translate(\n        -50%,\n        ','\n      );\n    '],['\n      width: 100%;\n      max-width: 100%;\n      max-height: 100%;\n      height: 100%;\n      border-radius: 0;\n\n      transition-duration: ','ms;\n\n      transform: translate(\n        -50%,\n        ','\n      );\n    ']),_templateObject3=_taggedTemplateLiteral(['\n      margin: 44px 0 0 0;\n      padding: 24px 20px 12px;\n      height: auto;\n      line-height: 1.35;\n      background-color: ',';\n      border-radius: ',';\n      color: ',';\n    '],['\n      margin: 44px 0 0 0;\n      padding: 24px 20px 12px;\n      height: auto;\n      line-height: 1.35;\n      background-color: ',';\n      border-radius: ',';\n      color: ',';\n    ']),_templateObject4=_taggedTemplateLiteral(['\n      margin: 0;\n      padding: 0 20px 24px 20px;\n      max-height: calc(100vh - (58px + 44px));\n    '],['\n      margin: 0;\n      padding: 0 20px 24px 20px;\n      max-height: calc(100vh - (58px + 44px));\n    ']),_templateObject5=_taggedTemplateLiteral(['\n      position: fixed;\n      top: 0;\n      right: 0;\n      left: 0;\n      display: flex;\n      justify-content: space-between;\n      height: 44px;\n      padding: 0;\n      background-color: ',';\n      border-radius: ',';\n    '],['\n      position: fixed;\n      top: 0;\n      right: 0;\n      left: 0;\n      display: flex;\n      justify-content: space-between;\n      height: 44px;\n      padding: 0;\n      background-color: ',';\n      border-radius: ',';\n    ']),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes),_a11yDialog=__webpack_require__(616),_a11yDialog2=_interopRequireDefault(_a11yDialog),_styledComponents=__webpack_require__(8),_styledComponents2=_interopRequireDefault(_styledComponents),_classnames=__webpack_require__(100),_classnames2=_interopRequireDefault(_classnames),_reactMedia=__webpack_require__(617),_reactMedia2=_interopRequireDefault(_reactMedia),_Transition=__webpack_require__(84),_Transition2=_interopRequireDefault(_Transition),_utils=__webpack_require__(25),_DialogCloseButton=__webpack_require__(618),_DialogCloseButton2=_interopRequireDefault(_DialogCloseButton),_DialogFullScreenActionButton=__webpack_require__(619),_DialogFullScreenActionButton2=_interopRequireDefault(_DialogFullScreenActionButton),_Button=__webpack_require__(43),_Button2=_interopRequireDefault(_Button),_Form=__webpack_require__(169),_Form2=_interopRequireDefault(_Form),_themes=__webpack_require__(5),_componentTheme=__webpack_require__(621),_componentTheme2=_interopRequireDefault(_componentTheme),_styles=__webpack_require__(17),_propTypes3=__webpack_require__(10);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}))}var transitionDurationSmallExpand=150,transitionDurationSmallCollapse=75,transitionDurationLargeExpand=300,transitionDurationLargeCollapse=350,Styled={div:{},h2:{}};Styled.div.root=_styledComponents2.default.div.withConfig({displayName:'Dialog__root'})(['',';position:fixed;z-index:',';opacity:',';font-family:',';-webkit-font-smoothing:antialiased;&[aria-hidden=\'true\']{display:',';}transition-property:opacity;transition-duration:','ms;transition-timing-function:cubic-bezier(0,0,0.2,1);',';'],function(props){return props.inheritStyles?'':_styles.resetInheritedStyles},(0,_themes.getStyle)('Dialog_zIndex'),function(props){return'entering'===props.sc.transitionState||'entered'===props.sc.transitionState?1:0},(0,_themes.getStyle)('Dialog_fontFamily'),function(props){return'exited'===props.sc.transitionState?'none':'block'},function(props){return'entering'===props.sc.transitionState||'entered'===props.sc.transitionState?transitionDurationSmallExpand:transitionDurationSmallCollapse},function(props){return props.sc.fullScreen&&(0,_styles.css)(_templateObject,'entering'===props.sc.transitionState||'entered'===props.sc.transitionState?transitionDurationLargeExpand:transitionDurationLargeCollapse)}),Styled.div.backdrop=_styledComponents2.default.div.withConfig({displayName:'Dialog__backdrop'})(['position:fixed;top:0;right:0;bottom:0;left:0;z-index:-1;background-color:',';'],(0,_themes.getStyle)('DialogBackdrop_backgroundColor')),Styled.div.dialog=_styledComponents2.default.div.withConfig({displayName:'Dialog__dialog'})(['position:fixed;top:50%;left:50%;width:',';max-width:calc(100% - 40px);min-height:160px;max-height:calc(100% - 40px);background-color:',';border-radius:',';box-shadow:',';transform:translate(-50%,-50%) scale( ',' );transition-property:transform;transition-duration:','ms;transition-timing-function:cubic-bezier(0,0,0.2,1);',';'],function(props){return(0,_themes.getStyle)('Dialog_width_'+props.size)},(0,_themes.getStyle)('Dialog_backgroundColor'),(0,_themes.getStyle)('Dialog_borderRadius'),(0,_themes.getStyle)('Dialog_boxShadow'),function(props){return'entering'===props.sc.transitionState||'entered'===props.sc.transitionState?1:0.9},function(props){return'entering'===props.sc.transitionState||'entered'===props.sc.transitionState?transitionDurationSmallExpand:transitionDurationSmallCollapse},function(props){return props.sc.fullScreen&&(0,_styles.css)(_templateObject2,'entering'===props.sc.transitionState||'entered'===props.sc.transitionState?transitionDurationLargeExpand:transitionDurationLargeCollapse,'entering'===props.sc.transitionState||'entered'===props.sc.transitionState?'-50%':'50%')}),Styled.div.content=_styledComponents2.default.div.withConfig({displayName:'Dialog__content'})(['display:flex;flex-direction:column;']),Styled.DialogCloseButton=(0,_styledComponents2.default)(_DialogCloseButton2.default).withConfig({displayName:'Dialog__DialogCloseButton'})(['position:absolute;top:0;right:0;z-index:2;']),Styled.h2.DialogTitle=_styledComponents2.default.h2.withConfig({displayName:'Dialog__DialogTitle'})(['z-index:1;height:',';margin:0;padding:',';background-color:',';border-radius:',';box-shadow:',';color:',';font-size:',';font-weight:',';line-height:',';transition-property:none;transition-duration:',';transition-timing-function:',';',';'],function(props){return props.sc.darkHeader?'48px':'auto'},function(props){return props.sc.darkHeader?'0 24px':'24px 24px 12px 24px'},function(props){return props.sc.darkHeader?props.sc.secondary?(0,_themes.getStyle)('DialogTitle_backgroundColor_darkHeaderSecondary'):(0,_themes.getStyle)('DialogTitle_backgroundColor_darkHeaderPrimary'):(0,_themes.getStyle)('DialogTitle_backgroundColor')},(0,_themes.getStyle)('DialogTitle_borderRadius'),function(props){return props.sc.canScrollUp?(0,_themes.getStyle)('DialogTitle_boxShadow'):'none'},function(props){return props.sc.darkHeader?props.sc.secondary?(0,_themes.getStyle)('DialogTitle_color_darkHeaderSecondary'):(0,_themes.getStyle)('DialogTitle_color_darkHeaderPrimary'):props.sc.secondary?(0,_themes.getStyle)('DialogTitle_color_secondary'):(0,_themes.getStyle)('DialogTitle_color_primary')},(0,_themes.getStyle)('DialogTitle_fontSize'),(0,_themes.getStyle)('DialogTitle_fontWeight'),function(props){return props.sc.darkHeader?'48px':'1.35'},function(props){return props.theme.vstui.transition.duration.shortest},function(props){return props.theme.vstui.transition.easing.easeIn},function(props){return props.sc.fullScreen&&(0,_styles.css)(_templateObject3,(0,_themes.getStyle)('DialogTitle_backgroundColor_fullScreen'),(0,_themes.getStyle)('DialogTitle_borderRadius_fullScreen'),props.sc.secondary?(0,_themes.getStyle)('DialogTitle_color_secondary_fullScreen'):(0,_themes.getStyle)('DialogTitle_color_primary_fullScreen'))}),Styled.div.DialogContent=_styledComponents2.default.div.withConfig({displayName:'Dialog__DialogContent'})(['box-sizing:border-box;flex:1 1 auto;min-height:22px;max-height:calc(100vh - (20px + 20px + 58px + 56px + 24px));margin:0 0 calc(56px + 24px) 0;padding:',';overflow-y:auto;color:',';font-size:',';line-height:1.43;word-break:break-word;',';'],function(props){return props.sc.darkHeader?'20px 24px 0':'0 24px'},(0,_themes.getStyle)('DialogContent_color'),(0,_themes.getStyle)('DialogContent_fontSize'),function(props){return props.sc.fullScreen&&(0,_styles.css)(_templateObject4)}),Styled.div.dialogActions=_styledComponents2.default.div.withConfig({displayName:'Dialog__dialogActions'})(['position:absolute;right:0;bottom:0;left:0;display:flex;justify-content:flex-end;padding:24px;background-color:',';border-radius:',';box-shadow:',';transition-property:none;transition-duration:',';transition-timing-function:',';',';'],(0,_themes.getStyle)('DialogActions_backgroundColor'),(0,_themes.getStyle)('DialogActions_borderRadius'),function(props){return props.sc.canScrollDown?(0,_themes.getStyle)('DialogActions_boxShadow'):'none'},function(props){return props.theme.vstui.transition.duration.shortest},function(props){return props.theme.vstui.transition.easing.easeIn},function(props){return props.sc.fullScreen&&(0,_styles.css)(_templateObject5,props.sc.secondary?(0,_themes.getStyle)('DialogActions_backgroundColor_secondary_fullScreen'):(0,_themes.getStyle)('DialogActions_backgroundColor_primary_fullScreen'),(0,_themes.getStyle)('DialogActions_borderRadius_fullScreen'))});var Dialog=function(_Component){function Dialog(props){_classCallCheck(this,Dialog);var _this=_possibleConstructorReturn(this,(Dialog.__proto__||Object.getPrototypeOf(Dialog)).call(this,props));return _this.generatedId=(0,_utils.generateUniqueId)('dialog'),_this.state={canScrollDown:!1,canScrollUp:!1,id:props.id||_this.generatedId},_this.handleCloseButtonClick=_this.handleCloseButtonClick.bind(_this),_this.handleContentRef=_this.handleContentRef.bind(_this),_this.handleFormRef=_this.handleFormRef.bind(_this),_this.handleKeyDown=_this.handleKeyDown.bind(_this),_this.handleOverlayClick=_this.handleOverlayClick.bind(_this),_this.handleRef=_this.handleRef.bind(_this),_this.handleScroll=_this.handleScroll.bind(_this),_this}return _inherits(Dialog,_Component),_createClass(Dialog,[{key:'componentDidMount',value:function componentDidMount(){this.a11yDialog=this.a11yDialog||this.initDialog(),this.props.open&&this.show()}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var id=nextProps.id||this.generatedId;id!==this.state.id&&this.setState({id:id}),!1===nextProps.open&&!1!==this.props.open&&this.form&&this.form.reset()}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){prevProps.open!==this.props.open&&(this.props.open?this.show():this.hide()),this.updateScrollState()}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('keydown',this.handleKeyDown),this.content&&this.content.removeEventListener('scroll',this.handleScroll),this.a11yDialog&&this.a11yDialog.destroy(),this.moveNodeBack()}},{key:'show',value:function show(){document.addEventListener('keydown',this.handleKeyDown),this.a11yDialog.show()}},{key:'hide',value:function hide(){document.removeEventListener('keydown',this.handleKeyDown),this.a11yDialog.hide(),this.props.onRequestClose()}},{key:'moveNodeBack',value:function moveNodeBack(){this.mainContainer&&(this.mainContainer.parentNode.removeChild(this.node),this.ancestor.appendChild(this.node))}},{key:'moveNode',value:function moveNode(){this.mainContainer&&(this.ancestor.removeChild(this.node),this.mainContainer.parentNode.appendChild(this.node))}},{key:'initDialog',value:function initDialog(){return this.mainContainer=document.querySelector(this.props.rootSelector),this.ancestor=this.node.parentNode,this.moveNode(),new _a11yDialog2.default(this.node,this.mainContainer)}},{key:'handleContentRef',value:function handleContentRef(node){this.content=node,this.content&&(this.content.addEventListener('scroll',this.handleScroll),this.updateScrollState())}},{key:'handleFormRef',value:function handleFormRef(node){this.form=node;var formProps=this.props.formProps;formProps&&formProps.innerRef&&formProps.innerRef(node)}},{key:'handleRef',value:function handleRef(node){this.node=node}},{key:'handleOverlayClick',value:function handleOverlayClick(){this.props.requireInteraction||this.props.onRequestClose()}},{key:'handleCloseButtonClick',value:function handleCloseButtonClick(){this.props.onRequestClose()}},{key:'handleKeyDown',value:function handleKeyDown(event){event.which===27&&(event.stopImmediatePropagation(),!this.props.requireInteraction&&this.props.onRequestClose())}},{key:'handleScroll',value:function handleScroll(){this.updateScrollState()}},{key:'updateScrollState',value:function updateScrollState(){var _state=this.state,canScrollDown=_state.canScrollDown,canScrollUp=_state.canScrollUp,_content=this.content,clientHeight=_content.clientHeight,scrollHeight=_content.scrollHeight,scrollTop=_content.scrollTop;!canScrollUp&&0<scrollTop?this.setState({canScrollUp:!0}):canScrollUp&&0===scrollTop&&this.setState({canScrollUp:!1}),!canScrollDown&&scrollTop+clientHeight<scrollHeight?this.setState({canScrollDown:!0}):canScrollDown&&scrollTop+clientHeight===scrollHeight&&this.setState({canScrollDown:!1})}},{key:'renderDialogActions',value:function renderDialogActions(theme,fullScreen){var _props=this.props,primaryActionButtonProp=_props.primaryActionButton,secondary=_props.secondary,secondaryActionButtonProp=_props.secondaryActionButton,canScrollDown=this.state.canScrollDown,primaryActionButton=primaryActionButtonProp?_react2.default.createElement(_Button2.default,{key:primaryActionButtonProp.label,onClick:primaryActionButtonProp.onClick,secondary:secondary,theme:theme},primaryActionButtonProp.label):null,secondaryActionButton=secondaryActionButtonProp?_react2.default.createElement(_Button2.default,{color:'neutral',key:secondaryActionButtonProp.label,naked:!0,onClick:secondaryActionButtonProp.onClick,secondary:secondary,theme:theme,type:'button'},secondaryActionButtonProp.label):null,primaryFullScreenActionButton=primaryActionButtonProp?_react2.default.createElement(_DialogFullScreenActionButton2.default,{key:primaryActionButtonProp.label,onClick:primaryActionButtonProp.onClick,secondary:secondary,theme:theme,variant:'primary'},primaryActionButtonProp.label):null,secondaryFullScreenActionButton=secondaryActionButtonProp?_react2.default.createElement(_DialogFullScreenActionButton2.default,{key:secondaryActionButtonProp.label,onClick:secondaryActionButtonProp.onClick,secondary:secondary,theme:theme,type:'button',variant:'secondary'},secondaryActionButtonProp.label):null;return _react2.default.createElement(Styled.div.dialogActions,{sc:{canScrollDown:canScrollDown,fullScreen:fullScreen,secondary:secondary},theme:theme},fullScreen?secondaryFullScreenActionButton:secondaryActionButton,fullScreen?primaryFullScreenActionButton:primaryActionButton)}},{key:'render',value:function render(){var _this2=this,_props2=this.props,alert=_props2.alert,ariaDescribedBy=_props2['aria-describedby'],children=_props2.children,classes=_props2.classes,className=_props2.className,closeButtonLabel=_props2.closeButtonLabel,darkHeader=_props2.darkHeader,formProps=_props2.formProps,idIgnored=_props2.id,inheritStyles=_props2.inheritStyles,open=_props2.open,requireInteraction=_props2.requireInteraction,secondary=_props2.secondary,size=_props2.size,themeProp=_props2.theme,title=_props2.title,id=this.state.id,theme=(0,_componentTheme2.default)(themeProp),canScrollUp=this.state.canScrollUp,titleId=id+'-title';return _react2.default.createElement(_reactMedia2.default,{query:theme.vstui.Dialog_breakpoint_xs},function(matches){var fullScreen=matches&&!alert;return _react2.default.createElement(_Transition2.default,{in:open,timeout:{enter:fullScreen?transitionDurationLargeExpand:transitionDurationSmallExpand,exit:fullScreen?transitionDurationLargeCollapse:transitionDurationSmallCollapse}},function(transitionState){return _react2.default.createElement(Styled.div.root,{"aria-hidden":!open,className:(0,_classnames2.default)(className,classes.root),id:id,inheritStyles:inheritStyles,innerRef:_this2.handleRef,sc:{fullScreen:fullScreen,transitionState:transitionState},theme:theme},_react2.default.createElement(Styled.div.backdrop,{className:classes.backdrop,onClick:_this2.handleOverlayClick,tabIndex:-1,theme:theme}),_react2.default.createElement(Styled.div.dialog,{"aria-describedby":ariaDescribedBy,"aria-labelledby":titleId,className:classes.dialog,role:'dialog',sc:{fullScreen:fullScreen,transitionState:transitionState},size:size,theme:theme},_react2.default.createElement(Styled.div.content,{className:classes.content,role:'document'},!requireInteraction&&!fullScreen&&_react2.default.createElement(Styled.DialogCloseButton,{className:classes.closeButton,color:darkHeader?'white':'neutral',label:closeButtonLabel,onClick:_this2.handleCloseButtonClick,theme:theme}),_react2.default.createElement(Styled.h2.DialogTitle,{id:titleId,sc:{darkHeader:darkHeader,fullScreen:fullScreen,canScrollUp:canScrollUp,secondary:secondary},theme:theme},title),_react2.default.createElement(Styled.div.DialogContent,{innerRef:_this2.handleContentRef,sc:{darkHeader:darkHeader,fullScreen:fullScreen},theme:theme},formProps&&_react2.default.createElement(_Form2.default,_extends({},formProps,{innerRef:_this2.handleFormRef}),children,_this2.renderDialogActions(theme,fullScreen)),!formProps&&children),!formProps&&_this2.renderDialogActions(theme,fullScreen))))})})}}]),Dialog}(_react.Component);Dialog.propTypes={"aria-describedby":_propTypes2.default.string,primaryActionButton:_propTypes2.default.shape({label:_propTypes2.default.string.isRequired,onClick:_propTypes2.default.func}),secondaryActionButton:_propTypes2.default.shape({label:_propTypes2.default.string.isRequired,onClick:_propTypes2.default.func}),formProps:_propTypes2.default.shape({action:_propTypes2.default.string,innerRef:_propTypes2.default.func,method:_propTypes2.default.oneOf(['get','post']),onSubmit:_propTypes2.default.func,onValidate:_propTypes2.default.func}),alert:_propTypes2.default.bool,children:_propTypes2.default.node,classes:_propTypes2.default.objectOf(_propTypes2.default.string),className:_propTypes2.default.string,closeButtonLabel:_propTypes2.default.string,darkHeader:_propTypes2.default.bool,id:_propTypes2.default.string,inheritStyles:_propTypes2.default.bool,onRequestClose:_propTypes2.default.func,open:_propTypes2.default.bool,requireInteraction:_propTypes2.default.bool,rootSelector:_propTypes2.default.string,secondary:_propTypes2.default.bool,size:_propTypes2.default.oneOf(['small','medium','large']),theme:_propTypes3.themeShape,title:_propTypes2.default.string.isRequired},Dialog.defaultProps={closeButtonLabel:'Close',rootSelector:'#root',classes:{root:'',backdrop:'',dialog:'',content:'',closeButton:''},size:'small',theme:(0,_themes.createTheme)()},Dialog.displayName='Dialog';var DialogWithTheme=(0,_themes.withTheme)(Dialog);DialogWithTheme.WrappedComponent=Dialog,exports.default=DialogWithTheme;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* global NodeList, Element, define */

(function (global) {
  'use strict';

  var FOCUSABLE_ELEMENTS = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[contenteditable]', '[tabindex]:not([tabindex^="-"])'];
  var TAB_KEY = 9;
  var ESCAPE_KEY = 27;
  var focusedBeforeDialog;

  /**
   * Define the constructor to instantiate a dialog
   *
   * @constructor
   * @param {Element} node
   * @param {(NodeList | Element | string)} targets
   */
  function A11yDialog (node, targets) {
    // Prebind the functions that will be bound in addEventListener and
    // removeEventListener to avoid losing references
    this._show = this.show.bind(this);
    this._hide = this.hide.bind(this);
    this._maintainFocus = this._maintainFocus.bind(this);
    this._bindKeypress = this._bindKeypress.bind(this);

    // Keep a reference of the node on the instance
    this.node = node;

    // Keep an object of listener types mapped to callback functions
    this._listeners = {};

    // Initialise everything needed for the dialog to work properly
    this.create(targets);
  }

  /**
   * Set up everything necessary for the dialog to be functioning
   *
   * @param {(NodeList | Element | string)} targets
   * @return {this}
   */
  A11yDialog.prototype.create = function (targets) {
    // Keep a collection of nodes to disable/enable when toggling the dialog
    this._targets = this._targets || collect(targets) || getSiblings(this.node);

    // Make sure the dialog element is disabled on load, and that the `shown`
    // property is synced with its value
    this.node.setAttribute('aria-hidden', true);
    this.shown = false;

    // Keep a collection of dialog openers, each of which will be bound a click
    // event listener to open the dialog
    this._openers = $$('[data-a11y-dialog-show="' + this.node.id + '"]');
    this._openers.forEach(function (opener) {
      opener.addEventListener('click', this._show);
    }.bind(this));

    // Keep a collection of dialog closers, each of which will be bound a click
    // event listener to close the dialog
    this._closers = $$('[data-a11y-dialog-hide]', this.node)
      .concat($$('[data-a11y-dialog-hide="' + this.node.id + '"]'));
    this._closers.forEach(function (closer) {
      closer.addEventListener('click', this._hide);
    }.bind(this));

    // Execute all callbacks registered for the `create` event
    this._fire('create');

    return this;
  };

  /**
   * Show the dialog element, disable all the targets (siblings), trap the
   * current focus within it, listen for some specific key presses and fire all
   * registered callbacks for `show` event
   *
   * @param {Event} event
   * @return {this}
   */
  A11yDialog.prototype.show = function (event) {
    // If the dialog is already open, abort
    if (this.shown) {
      return this;
    }

    this.shown = true;
    this.node.removeAttribute('aria-hidden');

    // Iterate over the targets to disable them by setting their `aria-hidden`
    // attribute to `true`; in case they already have this attribute, keep a
    // reference of their original value to be able to restore it later
    this._targets.forEach(function (target) {
      var original = target.getAttribute('aria-hidden');

      if (original) {
        target.setAttribute('data-a11y-dialog-original', original);
      }

      target.setAttribute('aria-hidden', 'true');
    });

    // Keep a reference to the currently focused element to be able to restore
    // it later, then set the focus to the first focusable child of the dialog
    // element
    focusedBeforeDialog = document.activeElement;
    setFocusToFirstItem(this.node);

    // Bind a focus event listener to the body element to make sure the focus
    // stays trapped inside the dialog while open, and start listening for some
    // specific key presses (TAB and ESC)
    document.body.addEventListener('focus', this._maintainFocus, true);
    document.addEventListener('keydown', this._bindKeypress);

    // Execute all callbacks registered for the `show` event
    this._fire('show', event);

    return this;
  };

  /**
   * Hide the dialog element, enable all the targets (siblings), restore the
   * focus to the previously active element, stop listening for some specific
   * key presses and fire all registered callbacks for `hide` event
   *
   * @param {Event} event
   * @return {this}
   */
  A11yDialog.prototype.hide = function (event) {
    // If the dialog is already closed, abort
    if (!this.shown) {
      return this;
    }

    this.shown = false;
    this.node.setAttribute('aria-hidden', 'true');

    // Iterate over the targets to enable them by remove their `aria-hidden`
    // attribute or resetting them to their initial value
    this._targets.forEach(function (target) {
      var original = target.getAttribute('data-a11y-dialog-original');

      if (original) {
        target.setAttribute('aria-hidden', original);
        target.removeAttribute('data-a11y-dialog-original');
      } else {
        target.removeAttribute('aria-hidden');
      }
    });

    // If their was a focused element before the dialog was opened, restore the
    // focus back to it
    if (focusedBeforeDialog) {
      focusedBeforeDialog.focus();
    }

    // Remove the focus event listener to the body element and stop listening
    // for specific key presses
    document.body.removeEventListener('focus', this._maintainFocus, true);
    document.removeEventListener('keydown', this._bindKeypress);

    // Execute all callbacks registered for the `hide` event
    this._fire('hide', event);

    return this;
  };

  /**
   * Destroy the current instance (after making sure the dialog has been hidden)
   * and remove all associated listeners from dialog openers and closers
   *
   * @return {this}
   */
  A11yDialog.prototype.destroy = function () {
    // Hide the dialog to avoid destroying an open instance
    this.hide();

    // Remove the click event listener from all dialog openers
    this._openers.forEach(function (opener) {
      opener.removeEventListener('click', this._show);
    }.bind(this));

    // Remove the click event listener from all dialog closers
    this._closers.forEach(function (closer) {
      closer.removeEventListener('click', this._hide);
    }.bind(this));

    // Execute all callbacks registered for the `destroy` event
    this._fire('destroy');

    // Keep an object of listener types mapped to callback functions
    this._listeners = {};

    return this;
  };

  /**
   * Register a new callback for the given event type
   *
   * @param {string} type
   * @param {Function} handler
   */
  A11yDialog.prototype.on = function (type, handler) {
    if (typeof this._listeners[type] === 'undefined') {
      this._listeners[type] = [];
    }

    this._listeners[type].push(handler);

    return this;
  };

  /**
   * Unregister an existing callback for the given event type
   *
   * @param {string} type
   * @param {Function} handler
   */
  A11yDialog.prototype.off = function (type, handler) {
    var index = this._listeners[type].indexOf(handler);

    if (index > -1) {
      this._listeners[type].splice(index, 1);
    }

    return this;
  };

  /**
   * Iterate over all registered handlers for given type and call them all with
   * the dialog element as first argument, event as second argument (if any).
   *
   * @access private
   * @param {string} type
   * @param {Event} event
   */
  A11yDialog.prototype._fire = function (type, event) {
    var listeners = this._listeners[type] || [];

    listeners.forEach(function (listener) {
      listener(this.node, event);
    }.bind(this));
  };

  /**
   * Private event handler used when listening to some specific key presses
   * (namely ESCAPE and TAB)
   *
   * @access private
   * @param {Event} event
   */
  A11yDialog.prototype._bindKeypress = function (event) {
    // If the dialog is shown and the ESCAPE key is being pressed, prevent any
    // further effects from the ESCAPE key and hide the dialog
    if (this.shown && event.which === ESCAPE_KEY) {
      event.preventDefault();
      this.hide();
    }

    // If the dialog is shown and the TAB key is being pressed, make sure the
    // focus stays trapped within the dialog element
    if (this.shown && event.which === TAB_KEY) {
      trapTabKey(this.node, event);
    }
  };

  /**
   * Private event handler used when making sure the focus stays within the
   * currently open dialog
   *
   * @access private
   * @param {Event} event
   */
  A11yDialog.prototype._maintainFocus = function (event) {
    // If the dialog is shown and the focus is not within the dialog element,
    // move it back to its first focusable child
    if (this.shown && !this.node.contains(event.target)) {
      setFocusToFirstItem(this.node);
    }
  };

  /**
   * Convert a NodeList into an array
   *
   * @param {NodeList} collection
   * @return {Array<Element>}
   */
  function toArray (collection) {
    return Array.prototype.slice.call(collection);
  }

  /**
   * Query the DOM for nodes matching the given selector, scoped to context (or
   * the whole document)
   *
   * @param {String} selector
   * @param {Element} [context = document]
   * @return {Array<Element>}
   */
  function $$ (selector, context) {
    return toArray((context || document).querySelectorAll(selector));
  }

  /**
   * Return an array of Element based on given argument (NodeList, Element or
   * string representing a selector)
   *
   * @param {(NodeList | Element | string)} target
   * @return {Array<Element>}
   */
  function collect (target) {
    if (NodeList.prototype.isPrototypeOf(target)) {
      return toArray(target);
    }

    if (Element.prototype.isPrototypeOf(target)) {
      return [target];
    }

    if (typeof target === 'string') {
      return $$(target);
    }
  }

  /**
   * Set the focus to the first focusable child of the given element
   *
   * @param {Element} node
   */
  function setFocusToFirstItem (node) {
    var focusableChildren = getFocusableChildren(node);

    if (focusableChildren.length) {
      focusableChildren[0].focus();
    }
  }

  /**
   * Get the focusable children of the given element
   *
   * @param {Element} node
   * @return {Array<Element>}
   */
  function getFocusableChildren (node) {
    return $$(FOCUSABLE_ELEMENTS.join(','), node).filter(function (child) {
      return !!(child.offsetWidth || child.offsetHeight || child.getClientRects().length);
    });
  }

  /**
   * Trap the focus inside the given element
   *
   * @param {Element} node
   * @param {Event} event
   */
  function trapTabKey (node, event) {
    var focusableChildren = getFocusableChildren(node);
    var focusedItemIndex = focusableChildren.indexOf(document.activeElement);

    // If the SHIFT key is being pressed while tabbing (moving backwards) and
    // the currently focused item is the first one, move the focus to the last
    // focusable item from the dialog element
    if (event.shiftKey && focusedItemIndex === 0) {
      focusableChildren[focusableChildren.length - 1].focus();
      event.preventDefault();
    // If the SHIFT key is not being pressed (moving forwards) and the currently
    // focused item is the last one, move the focus to the first focusable item
    // from the dialog element
    } else if (!event.shiftKey && focusedItemIndex === focusableChildren.length - 1) {
      focusableChildren[0].focus();
      event.preventDefault();
    }
  }

  /**
   * Retrieve siblings from given element
   *
   * @param {Element} node
   * @return {Array<Element>}
   */
  function getSiblings (node) {
    var nodes = toArray(node.parentNode.childNodes);
    var siblings = nodes.filter(function (node) {
      return node.nodeType === 1;
    });

    siblings.splice(siblings.indexOf(node), 1);

    return siblings;
  }

  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = A11yDialog;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return A11yDialog;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof global === 'object') {
    global.A11yDialog = A11yDialog;
  }
}(typeof global !== 'undefined' ? global : window));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

var emptyFunction_1 = emptyFunction;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var invariant_1 = invariant;

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction_1;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

var warning_1 = warning;

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

if (false) {
  var invariant$1 = invariant_1;
  var warning$1 = warning_1;
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant$1(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        warning$1(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning$1(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

var checkPropTypes_1 = checkPropTypes;

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant_1(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning_1(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction_1.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning_1(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction_1.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning_1(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction_1.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning_1(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction_1.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    invariant_1(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction_1;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var NODE_ENV = "production";

var invariant$3 = function(condition, format, a, b, c, d, e, f) {
  if (NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

var invariant_1$2 = invariant$3;

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

var camel2hyphen_1 = camel2hyphen;

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen_1(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and ';
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', ';
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

var json2mq_1 = json2mq;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

/**
 * Conditionally renders based on whether or not a media query matches.
 */

var Media = function (_React$Component) {
  inherits(Media, _React$Component);

  function Media() {
    var _temp, _this, _ret;

    classCallCheck(this, Media);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      matches: _this.props.defaultMatches
    }, _this.updateMatches = function () {
      return _this.setState({ matches: _this.mediaQueryList.matches });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Media.prototype.componentWillMount = function componentWillMount() {
    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== "object") return;

    var targetWindow = this.props.targetWindow || window;

    invariant_1$2(typeof targetWindow.matchMedia === "function", "<Media targetWindow> does not support `matchMedia`.");

    var query = this.props.query;

    if (typeof query !== "string") query = json2mq_1(query);

    this.mediaQueryList = targetWindow.matchMedia(query);
    this.mediaQueryList.addListener(this.updateMatches);
    this.updateMatches();
  };

  Media.prototype.componentWillUnmount = function componentWillUnmount() {
    this.mediaQueryList.removeListener(this.updateMatches);
  };

  Media.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        render = _props.render;
    var matches = this.state.matches;


    return render ? matches ? render() : null : children ? typeof children === "function" ? children(matches) : !Array.isArray(children) || children.length // Preact defaults to empty children array
    ? matches ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(children) : null : null : null;
  };

  return Media;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Media.propTypes = {
  defaultMatches: propTypes.bool,
  query: propTypes.oneOfType([propTypes.string, propTypes.object, propTypes.arrayOf(propTypes.object.isRequired)]).isRequired,
  render: propTypes.func,
  children: propTypes.oneOfType([propTypes.node, propTypes.func]),
  targetWindow: propTypes.object
};
Media.defaultProps = {
  defaultMatches: true
};

/* harmony default export */ __webpack_exports__["default"] = (Media);


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_Button=__webpack_require__(43),_Button2=_interopRequireDefault(_Button),_themes=__webpack_require__(5),_icons=__webpack_require__(114);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var ThemedButton=(0,_themes.createThemedComponent)(_Button2.default,{Button_paddingHorizontal_withIcon_medium:'10px',Button_minHeight_medium:30,Button_borderWidth:0,Button_color_neutralNaked:function Button_color_neutralNaked(props){return props.theme.vstui.color.cloud.getShade(5)},Button_color_neutralNaked_active:function Button_color_neutralNaked_active(props){return props.theme.vstui.color.cloud.getShade(6)},Button_color_neutralNaked_focus:function Button_color_neutralNaked_focus(props){return props.theme.vstui.color.cloud.getShade(6)},Button_color_neutralNaked_hover:function Button_color_neutralNaked_hover(props){return props.theme.vstui.color.cloud.getShade(6)}}),DialogCloseButton=function(_Component){function DialogCloseButton(){return _classCallCheck(this,DialogCloseButton),_possibleConstructorReturn(this,(DialogCloseButton.__proto__||Object.getPrototypeOf(DialogCloseButton)).apply(this,arguments))}return _inherits(DialogCloseButton,_Component),_createClass(DialogCloseButton,[{key:'render',value:function render(){return _react2.default.createElement(ThemedButton,_extends({},this.props,{iconStart:_react2.default.createElement(_icons.XSmall,null),naked:!0}))}}]),DialogCloseButton}(_react.Component);DialogCloseButton.defaultProps={},exports.default=DialogCloseButton;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes),_Button=__webpack_require__(43),_Button2=_interopRequireDefault(_Button),_themes=__webpack_require__(5),_propTypes3=__webpack_require__(10);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj)0<=keys.indexOf(i)||Object.prototype.hasOwnProperty.call(obj,i)&&(target[i]=obj[i]);return target}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var ThemedButton=(0,_themes.createThemedComponent)(_Button2.default,function(props){var typography=props.theme.vstui.typography;return{Button_paddingHorizontal_medium:'20px',Button_minHeight_medium:'44px',Button_borderRadius:0,Button_fontWeight_themePrimary:'primary'===props.sc.variant?typography.fontWeightMedium:typography.fontWeightRegular}}),DialogFullScreenActionButton=function(_Component){function DialogFullScreenActionButton(){return _classCallCheck(this,DialogFullScreenActionButton),_possibleConstructorReturn(this,(DialogFullScreenActionButton.__proto__||Object.getPrototypeOf(DialogFullScreenActionButton)).apply(this,arguments))}return _inherits(DialogFullScreenActionButton,_Component),_createClass(DialogFullScreenActionButton,[{key:'render',value:function render(){var _props=this.props,className=_props.className,theme=_props.theme,variant=_props.variant,otherProps=_objectWithoutProperties(_props,['className','theme','variant']);return _react2.default.createElement(ThemedButton,_extends({},otherProps,{className:className,sc:{variant:variant},theme:theme}))}}]),DialogFullScreenActionButton}(_react.Component);DialogFullScreenActionButton.propTypes={className:_propTypes2.default.string,theme:_propTypes3.themeShape,variant:_propTypes2.default.oneOf(['primary','secondary'])},DialogFullScreenActionButton.defaultProps={},exports.default=DialogFullScreenActionButton;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_slicedToArray=function(){function sliceIterator(arr,i){var _arr=[],_n=!0,_d=!1,_e=void 0;try{for(var _s,_i=arr[Symbol.iterator]();!(_n=(_s=_i.next()).done)&&(_arr.push(_s.value),!(i&&_arr.length===i));_n=!0);}catch(err){_d=!0,_e=err}finally{try{!_n&&_i['return']&&_i['return']()}finally{if(_d)throw _e}}return _arr}return function(arr,i){if(Array.isArray(arr))return arr;if(Symbol.iterator in Object(arr))return sliceIterator(arr,i);throw new TypeError('Invalid attempt to destructure non-iterable instance')}}(),_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes),_styledComponents=__webpack_require__(8),_styledComponents2=_interopRequireDefault(_styledComponents),_FormContext=__webpack_require__(168),_FormContext2=_interopRequireDefault(_FormContext),_propTypes3=__webpack_require__(10),_styles=__webpack_require__(17),_themes=__webpack_require__(5),_utils=__webpack_require__(25);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var Styled={form:_styledComponents2.default.form.withConfig({displayName:'Form__form'})(['',';color:',';font-family:',';font-size:',';font-weight:',';-webkit-font-smoothing:antialiased;'],function(props){return props.inheritStyles?'':_styles.resetInheritedStyles},function(props){return props.theme.vstui.color.onSurface},function(props){return props.theme.vstui.typography.fontFamily},function(props){return props.theme.vstui.typography.pxToRem(props.theme.vstui.typography.fontSize)},function(props){return props.theme.vstui.typography.fontWeightRegular})},Form=function(_Component){function Form(){_classCallCheck(this,Form);var _this=_possibleConstructorReturn(this,(Form.__proto__||Object.getPrototypeOf(Form)).call(this));return _this.isReadyToSubmit=!1,_this.isValidating=!1,_this.registeredFormControls={},_this.handleFormRef=_this.handleFormRef.bind(_this),_this.handleSubmit=_this.handleSubmit.bind(_this),_this.registerFormControl=_this.registerFormControl.bind(_this),_this}return _inherits(Form,_Component),_createClass(Form,[{key:'reset',value:function reset(){this.resetForm()}},{key:'validate',value:function validate(callback){this.validateForm(function(valid){callback&&callback(valid)})}},{key:'registerFormControl',value:function registerFormControl(_ref){var focus=_ref.focus,id=_ref.id,reset=_ref.reset,validate=_ref.validate;this.registeredFormControls[id]={focus:focus,reset:reset,validate:validate}}},{key:'handleFormRef',value:function handleFormRef(node){var innerRef=this.props.innerRef;node&&(this.nativeForm=node),innerRef&&innerRef(node)}},{key:'resetForm',value:function resetForm(){var _this2=this,onReset=this.props.onReset;this.nativeForm.reset();var resetFormControls=new Promise(function(resolve){Object.values(_this2.registeredFormControls).forEach(function(_ref2,i){var reset=_ref2.reset;reset(),i===Object.keys(_this2.registeredFormControls).length-1&&resolve()})});resetFormControls.then(function(){onReset&&onReset()})}},{key:'validateForm',value:function validateForm(callback){var _this3=this,onValidate=this.props.onValidate,focusFirstInvalidFormControl=void 0,validationMessages={},validateFormControls=new Promise(function(resolve){(0,_utils.entries)(_this3.registeredFormControls).forEach(function(_ref3){var _ref4=_slicedToArray(_ref3,2),key=_ref4[0],validate=_ref4[1].validate;validate(function(valid,validationMessage){validationMessages[key]=validationMessage,Object.keys(validationMessages).length===Object.keys(_this3.registeredFormControls).length&&resolve()})})});validateFormControls.then(function(){(0,_utils.entries)(_this3.registeredFormControls).forEach(function(_ref5){var _ref6=_slicedToArray(_ref5,2),key=_ref6[0],focus=_ref6[1].focus;!focusFirstInvalidFormControl&&validationMessages[key]&&(focusFirstInvalidFormControl=focus)}),focusFirstInvalidFormControl?(focusFirstInvalidFormControl(),onValidate&&onValidate(!1),callback&&callback(!1)):(onValidate&&onValidate(!0),callback&&callback(!0))})}},{key:'handleSubmit',value:function handleSubmit(event){var _this4=this,onSubmit=this.props.onSubmit;return this.isValidating?void event.preventDefault():void(this.isReadyToSubmit?(onSubmit&&onSubmit(event),!event.isTrusted&&!event.defaultPrevented&&this.nativeForm.submit(),this.isReadyToSubmit=!1):(event.preventDefault(),this.isValidating=!0,this.validateForm(function(valid){_this4.isValidating=!1,_this4.isReadyToSubmit=valid,valid&&_this4.dispatchSubmitEvent()})))}},{key:'dispatchSubmitEvent',value:function dispatchSubmitEvent(){var _this5=this,submitEvent=(0,_utils.createEvent)('submit',{bubbles:!0,cancelable:!0});setTimeout(function(){_this5.nativeForm.dispatchEvent(submitEvent)})}},{key:'render',value:function render(){return _react2.default.createElement(_FormContext2.default.Provider,{value:this.registerFormControl},_react2.default.createElement(Styled.form,_extends({},this.props,{innerRef:this.handleFormRef,noValidate:!0,onSubmit:this.handleSubmit})))}}]),Form}(_react.Component);Form.propTypes={innerRef:_propTypes2.default.func,onReset:_propTypes2.default.func,onSubmit:_propTypes2.default.func,onValidate:_propTypes2.default.func,theme:_propTypes3.themeShape},Form.defaultProps={theme:(0,_themes.createTheme)()},Form.displayName='Form';var FormWithTheme=(0,_themes.withTheme)(Form);FormWithTheme.WrappedComponent=Form,exports.default=FormWithTheme;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _themes=__webpack_require__(5),componentTheme=function(baseTheme){var _baseTheme$vstui=baseTheme.vstui,breakpoint=_baseTheme$vstui.breakpoint,color=_baseTheme$vstui.color,rem=_baseTheme$vstui.rem,shadow=_baseTheme$vstui.shadow,shape=_baseTheme$vstui.shape,typography=_baseTheme$vstui.typography,zIndex=_baseTheme$vstui.zIndex,primaryMain=color.primary.getMainShade(),secondaryMain=color.secondary.getMainShade();return(0,_themes.createComponentTheme)(baseTheme,{Dialog_zIndex:zIndex.modal,Dialog_width_small:'300px',Dialog_width_medium:'400px',Dialog_width_large:'500px',Dialog_backgroundColor:color.surface,Dialog_borderRadius:shape.borderRadius,Dialog_boxShadow:shadow.high,Dialog_fontFamily:typography.fontFamily,Dialog_breakpoint_xs:breakpoint.xs,DialogBackdrop_backgroundColor:'rgba(0, 0, 0, 0.5)',DialogTitle_backgroundColor:color.transparent,DialogTitle_backgroundColor_darkHeaderPrimary:primaryMain,DialogTitle_backgroundColor_darkHeaderSecondary:secondaryMain,DialogTitle_backgroundColor_fullScreen:color.transparent,DialogTitle_borderRadius:shape.borderRadius+' '+shape.borderRadius+' 0 0',DialogTitle_borderRadius_fullScreen:0,DialogTitle_boxShadow:'0 4px 3px -3px rgba(0, 0, 0, 0.2)',DialogTitle_fontSize:rem(typography.fontSize+3),DialogTitle_fontWeight:typography.fontWeightMedium,DialogTitle_color_darkHeaderPrimary:color.onPrimary,DialogTitle_color_darkHeaderSecondary:color.onSecondary,DialogTitle_color_primary:primaryMain,DialogTitle_color_secondary:secondaryMain,DialogTitle_color_primary_fullScreen:primaryMain,DialogTitle_color_secondary_fullScreen:secondaryMain,DialogContent_fontSize:rem(typography.fontSize),DialogContent_color:color.onSurface,DialogActions_backgroundColor:color.transparent,DialogActions_backgroundColor_primary_fullScreen:primaryMain,DialogActions_backgroundColor_secondary_fullScreen:secondaryMain,DialogActions_borderRadius:'0 0 '+shape.borderRadius+' '+shape.borderRadius,DialogActions_borderRadius_fullScreen:0,DialogActions_boxShadow:'0 -4px 3px -3px rgba(0, 0, 0, 0.2)'})};exports.default=componentTheme;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _Link=__webpack_require__(623);Object.defineProperty(exports,'default',{enumerable:!0,get:function get(){return _interopRequireDefault(_Link).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_themes=__webpack_require__(5),_Button=__webpack_require__(43),_Button2=_interopRequireDefault(_Button);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var ThemedButton=(0,_themes.createThemedComponent)(_Button2.default,{Button_minHeight_small:0,Button_minHeight_medium:0,Button_minHeight_large:0,Button_fontSize_small:'inherit',Button_fontSize_medium:'inherit',Button_fontSize_large:'inherit',Button_textDecoration:'underline',Button_paddingHorizontal_small:0,Button_paddingHorizontal_medium:0,Button_paddingHorizontal_large:0}),Link=function(_Component){function Link(){return _classCallCheck(this,Link),_possibleConstructorReturn(this,(Link.__proto__||Object.getPrototypeOf(Link)).apply(this,arguments))}return _inherits(Link,_Component),_createClass(Link,[{key:'render',value:function render(){return _react2.default.createElement(ThemedButton,_extends({},this.props,{naked:!0}))}}]),Link}(_react.Component);exports.default=Link;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _Select=__webpack_require__(625);Object.defineProperty(exports,'default',{enumerable:!0,get:function get(){return _interopRequireDefault(_Select).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof='function'==typeof Symbol&&'symbol'==typeof Symbol.iterator?function(obj){return typeof obj}:function(obj){return obj&&'function'==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?'symbol':typeof obj},_extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes),_styledComponents=__webpack_require__(8),_styledComponents2=_interopRequireDefault(_styledComponents),_propTypes3=__webpack_require__(10),_themes=__webpack_require__(5),_FormGroup=__webpack_require__(87),_FormGroup2=_interopRequireDefault(_FormGroup),_SelectControl=__webpack_require__(626),_SelectControl2=_interopRequireDefault(_SelectControl),_utils=__webpack_require__(25);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj)0<=keys.indexOf(i)||Object.prototype.hasOwnProperty.call(obj,i)&&(target[i]=obj[i]);return target}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var Styled={SelectControl:(0,_styledComponents2.default)(_SelectControl2.default).withConfig({displayName:'Select__SelectControl'})(['display:block;'])},Select=function(_Component){function Select(props){_classCallCheck(this,Select);var _this=_possibleConstructorReturn(this,(Select.__proto__||Object.getPrototypeOf(Select)).call(this,props));return _this.generatedId=(0,_utils.generateUniqueId)('select'),_this.state={id:props.id||_this.generatedId,validationMessage:null},_this.handleFormControlRef=_this.handleFormControlRef.bind(_this),_this.handleNativeFormControlRef=_this.handleNativeFormControlRef.bind(_this),_this.handleValidate=_this.handleValidate.bind(_this),_this}return _inherits(Select,_Component),_createClass(Select,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var id=nextProps.id||this.generatedId;id!==this.state.id&&this.setState({id:id})}},{key:'focus',value:function focus(){this.nativeFormControl&&this.nativeFormControl.focus()}},{key:'validate',value:function validate(callback){this.formControl&&this.formControl.validate(callback)}},{key:'handleFormControlRef',value:function handleFormControlRef(node){this.formControl=node}},{key:'handleNativeFormControlRef',value:function handleNativeFormControlRef(node){var nativeFormControlRef=this.props.nativeFormControlRef;this.nativeFormControl=node,nativeFormControlRef&&nativeFormControlRef(node)}},{key:'handleValidate',value:function handleValidate(valid,validationMessage){this.setState({validationMessage:validationMessage})}},{key:'render',value:function render(){var _props=this.props,className=_props.className,disabled=_props.disabled,fullWidth=_props.fullWidth,helperText=_props.helperText,idIgnored=_props.id,inheritStyles=_props.inheritStyles,label=_props.label,labelHidden=_props.labelHidden,nativeFormControlRefIgnored=_props.nativeFormControlRef,rootProps=_props.rootProps,secondary=_props.secondary,size=_props.size,theme=_props.theme,otherProps=_objectWithoutProperties(_props,['className','disabled','fullWidth','helperText','id','inheritStyles','label','labelHidden','nativeFormControlRef','rootProps','secondary','size','theme']),_state=this.state,id=_state.id,validationMessage=_state.validationMessage;return _react2.default.createElement(_FormGroup2.default,{className:className,disabled:disabled,formControl:_react2.default.createElement(Styled.SelectControl,_extends({},otherProps,{innerRef:this.handleFormControlRef,nativeFormControlRef:this.handleNativeFormControlRef,onValidate:this.handleValidate}),this.props.children),fullWidth:fullWidth,helperText:helperText,id:id,inheritStyles:inheritStyles,label:label,labelHidden:labelHidden,rootProps:rootProps,secondary:secondary,size:size,theme:theme,validationMessage:validationMessage})}}]),Select}(_react.Component);Select.propTypes={children:_propTypes2.default.node,className:_propTypes2.default.string,defaultValue:_propTypes2.default.string,disabled:_propTypes2.default.bool,fullWidth:_propTypes2.default.bool,helperText:_propTypes2.default.string,id:_propTypes2.default.string,inheritStyles:_propTypes2.default.bool,label:function label(props,propName,componentName){if(props.label===void 0&&props.labelledBy===void 0)return new Error(componentName+' requires either the `label` prop or the `labelledBy` prop.');if(void 0!==props[propName]){if('string'!=typeof props[propName])return new Error('Invalid prop `'+propName+'` of type `'+_typeof(props[propName])+'` supplied to `'+componentName+'`, expected `string`.');''===props[propName]}},labelHidden:_propTypes2.default.bool,labelledBy:function labelledBy(props,propName,componentName){if(props.label===void 0&&props.labelledBy===void 0)return new Error(componentName+' requires either the `label` prop or the `labelledBy` prop.');if(void 0!==props[propName]){if('string'!=typeof props[propName])return new Error('Invalid prop `'+propName+'` of type `'+_typeof(props[propName])+'` supplied to `'+componentName+'`, expected `string`.');''===props[propName]}},nativeFormControlRef:_propTypes2.default.func,onChange:_propTypes2.default.func,required:_propTypes2.default.bool,rootProps:_propTypes2.default.object,secondary:_propTypes2.default.bool,size:_propTypes2.default.oneOf(['small','medium','large']),theme:_propTypes3.themeShape,validate:_propTypes2.default.func,value:_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.number])},Select.defaultProps={size:'medium',theme:(0,_themes.createTheme)(),validate:function validate(){return''}},Select.displayName='Select';var SelectWithTheme=(0,_themes.withTheme)(Select);SelectWithTheme.WrappedComponent=Select,exports.default=SelectWithTheme;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _SelectControl=__webpack_require__(627);Object.defineProperty(exports,'default',{enumerable:!0,get:function get(){return _interopRequireDefault(_SelectControl).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes),_styledComponents=__webpack_require__(8),_styledComponents2=_interopRequireDefault(_styledComponents),_themes=__webpack_require__(5),_styles=__webpack_require__(17),_propTypes3=__webpack_require__(10),_FormControl=__webpack_require__(58),_FormControl2=_interopRequireDefault(_FormControl),_componentTheme=__webpack_require__(628),_componentTheme2=_interopRequireDefault(_componentTheme);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj)0<=keys.indexOf(i)||Object.prototype.hasOwnProperty.call(obj,i)&&(target[i]=obj[i]);return target}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var getHeight=function(){return function(props){var size=props.sc.size,_props$theme$vstui=props.theme.vstui,rem=_props$theme$vstui.rem,typography=_props$theme$vstui.typography,minHeight=(0,_themes.getStyle)('SelectControl_minHeight_'+size)(props)-4,height=Math.max(minHeight,1.4*typography.fontSize);return rem(height)}},Styled={};Styled.div={},Styled.select=_styledComponents2.default.select.withConfig({displayName:'SelectControl__select'})(['',';width:',';min-width:74px;max-width:100%;min-height:',';padding:0 34px 0 12px;background-color:',';background-image:',';background-position:',';background-repeat:no-repeat;background-size:10px 6px,14px 14px;border-color:',';border-style:',';border-width:',';border-radius:',';color:',';font-family:',';font-size:',';font-weight:',';-webkit-font-smoothing:antialiased;transition-property:none;transition-duration:',';transition-timing-function:',';cursor:pointer;appearance:none;option{height:',';}&::-ms-expand{display:none;}&:focus{outline:none;border-color:',';box-shadow:',';}&[aria-invalid]{padding-right:60px;background-image:',';border-color:',';&:focus{background-image:',';border-color:',';}}&:disabled{background-image:',';border-color:',';color:',';cursor:default;}'],function(props){return props.sc.inheritStyles?'':_styles.resetInheritedStyles},function(props){return props.sc.fullWidth?'100%':(0,_themes.getStyle)('SelectControl_width')},function(props){return props.theme.vstui.rem((0,_themes.getStyle)('SelectControl_minHeight_'+props.sc.size)(props))},(0,_themes.getStyle)('SelectControl_backgroundColor'),function(props){return props.sc.secondary?(0,_themes.getStyle)('SelectControl_backgroundImage_themeSecondary'):(0,_themes.getStyle)('SelectControl_backgroundImage_themePrimary')},function(props){return(0,_themes.getStyle)('SelectControl_backgroundPosition_'+props.sc.size)(props)},(0,_themes.getStyle)('SelectControl_borderColor'),(0,_themes.getStyle)('SelectControl_borderStyle'),(0,_themes.getStyle)('SelectControl_borderWidth'),(0,_themes.getStyle)('SelectControl_borderRadius'),(0,_themes.getStyle)('SelectControl_color'),(0,_themes.getStyle)('SelectControl_fontFamily'),function(props){return props.theme.vstui.rem((0,_themes.getStyle)('SelectControl_fontSize_'+props.sc.size)(props))},(0,_themes.getStyle)('SelectControl_fontWeight'),function(props){return props.theme.vstui.transition.duration.shortest},function(props){return props.theme.vstui.transition.easing.easeIn},getHeight(),(0,_themes.getStyle)('SelectControl_borderColor_focus'),(0,_themes.getStyle)('SelectControl_boxShadow_focus'),(0,_themes.getStyle)('SelectControl_backgroundImage_invalid'),(0,_themes.getStyle)('SelectControl_borderColor_invalid'),(0,_themes.getStyle)('SelectControl_backgroundImage_invalidFocus'),(0,_themes.getStyle)('SelectControl_borderColor_invalidFocus'),function(props){return props.sc.secondary?(0,_themes.getStyle)('SelectControl_backgroundImage_themeSecondary_disabled'):(0,_themes.getStyle)('SelectControl_backgroundImage_themePrimary_disabled')},(0,_themes.getStyle)('SelectControl_borderColor_disabled'),(0,_themes.getStyle)('SelectControl_color_disabled')),Styled.select.displayName='Styled_select';var SelectControl=function(_PureComponent){function SelectControl(props){_classCallCheck(this,SelectControl);var _this=_possibleConstructorReturn(this,(SelectControl.__proto__||Object.getPrototypeOf(SelectControl)).call(this,props));return _this.handleFormControlRef=_this.handleFormControlRef.bind(_this),_this.handleValidate=_this.handleValidate.bind(_this),_this.renderChildren=_this.renderChildren.bind(_this),_this.renderContent=_this.renderContent.bind(_this),_this}return _inherits(SelectControl,_PureComponent),_createClass(SelectControl,[{key:'getValidationMessage',value:function getValidationMessage(validity){return validity.valueMissing?'Please select an item in the list.':''}},{key:'validate',value:function validate(callback){this.formControl.validate(callback)}},{key:'handleFormControlRef',value:function handleFormControlRef(node){this.formControl=node}},{key:'handleValidate',value:function handleValidate(validity){var _ref2=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},callback=_ref2.callback,onlyValidateIfValid=_ref2.onlyValidateIfValid,_ref=arguments[2],updateValidationState=_ref.updateValidationState,value=_ref.value,_props=this.props,onValidate=_props.onValidate,validate=_props.validate,passedDefaultValidation=validity.valid,defaultValidationMessage=this.getValidationMessage(validity),customValidationMessagePromise=Promise.resolve(validate?validate(value):''),update=function(valid,validationMessage){(!onlyValidateIfValid||onlyValidateIfValid&&valid)&&updateValidationState(valid,validationMessage,onValidate)};update(passedDefaultValidation,defaultValidationMessage),passedDefaultValidation?customValidationMessagePromise.then(function(customValidationMessage){var passedCustomValidation=!customValidationMessage;update(passedCustomValidation,customValidationMessage),callback&&callback(passedCustomValidation,customValidationMessage)}):callback&&callback(passedDefaultValidation,defaultValidationMessage)}},{key:'renderChildren',value:function renderChildren(){var _this2=this;return _react2.default.Children.map(this.props.children,function(child){return _react2.default.cloneElement(child,{key:'option-'+_this2.props.id+'-'+child.props.value})})}},{key:'renderContent',value:function renderContent(_ref3){var defaultValue=_ref3.defaultValue,invalid=_ref3.invalid,handleBlur=_ref3.handleBlur,handleChange=_ref3.handleChange,handleFocus=_ref3.handleFocus,handleNativeFormControlRef=_ref3.handleNativeFormControlRef,value=_ref3.value,_props2=this.props,childrenIgnored=_props2.children,className=_props2.className,fullWidth=_props2.fullWidth,inheritStyles=_props2.inheritStyles,labelledBy=_props2.labelledBy,required=_props2.required,secondary=_props2.secondary,size=_props2.size,themeProp=_props2.theme,otherProps=_objectWithoutProperties(_props2,['children','className','fullWidth','inheritStyles','labelledBy','required','secondary','size','theme']),theme=(0,_componentTheme2.default)(themeProp),conditionalProps={};return invalid&&(conditionalProps['aria-invalid']=!0),required&&(conditionalProps['aria-required']=!0),_react2.default.createElement(Styled.select,_extends({},otherProps,conditionalProps,{"aria-labelledby":labelledBy,className:className,defaultValue:defaultValue,innerRef:handleNativeFormControlRef,onBlur:handleBlur,onChange:handleChange,onFocus:handleFocus,required:required,sc:{fullWidth:fullWidth,inheritStyles:inheritStyles,secondary:secondary,size:size},theme:theme,value:value}),this.renderChildren())}},{key:'render',value:function render(){var _props3=this.props,defaultValue=_props3.defaultValue,nativeFormControlRef=_props3.nativeFormControlRef,onBlur=_props3.onBlur,onChange=_props3.onChange,value=_props3.value;return _react2.default.createElement(_FormControl2.default,{defaultValue:defaultValue,nativeFormControlRef:nativeFormControlRef,onFormControlBlur:onBlur,onFormControlChange:onChange,onValidate:this.handleValidate,ref:this.handleFormControlRef,render:this.renderContent,value:value})}}]),SelectControl}(_react.PureComponent);SelectControl.propTypes={children:_propTypes2.default.node,className:_propTypes2.default.string,defaultValue:_propTypes2.default.string,disabled:_propTypes2.default.bool,fullWidth:_propTypes2.default.bool,id:_propTypes2.default.string,inheritStyles:_propTypes2.default.bool,labelledBy:_propTypes2.default.string,nativeFormControlRef:_propTypes2.default.func,onBlur:_propTypes2.default.func,onChange:_propTypes2.default.func,onFocus:_propTypes2.default.func,onValidate:_propTypes2.default.func,required:_propTypes2.default.bool,secondary:_propTypes2.default.bool,size:_propTypes2.default.oneOf(['small','medium','large']),theme:_propTypes3.themeShape,validate:_propTypes2.default.func,value:_propTypes2.default.oneOfType([_propTypes2.default.string,_propTypes2.default.number])},SelectControl.defaultProps={size:'medium',theme:(0,_themes.createTheme)(),validate:function validate(){return''}},SelectControl.displayName='SelectControl';var SelectControlWithTheme=(0,_themes.withTheme)(SelectControl);SelectControlWithTheme.WrappedComponent=SelectControl,exports.default=SelectControlWithTheme;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _themes=__webpack_require__(5),getBackgroundImage=function(caretColor,errorColor){var encodedCaretColor=encodeURIComponent(caretColor),encodedErrorColor=encodeURIComponent(errorColor);return'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 10 6\'%3E%3Cpath fill=\''+encodedCaretColor+'\' d=\'M5 3.586L8.293.293a.999.999 0 1 1 1.414 1.414l-4 4a.999.999 0 0 1-1.414 0l-4-4a.997.997 0 0 1 0-1.414.999.999 0 0 1 1.414 0L5 3.586z\' /%3E%3C/svg%3E%0A")'+', '+('url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 14 14\'%3E%3Cpath fill=\''+encodedErrorColor+'\' d=\'M8 6a1 1 0 1 1-2 0V4a1 1 0 1 1 2 0v2zm-1 5a1 1 0 1 1 0-2 1 1 0 1 1 0 2zM7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0z\' /%3E%3C/svg%3E%0A")')},componentTheme=function(baseTheme){var _baseTheme$vstui=baseTheme.vstui,color=_baseTheme$vstui.color,shape=_baseTheme$vstui.shape,size=_baseTheme$vstui.size,typography=_baseTheme$vstui.typography,ninja11=color.ninja.getShade(11),black57='rgba(0, 0, 0, 0.57)',primaryMain=color.primary.getMainShade(),secondaryMain=color.secondary.getMainShade(),backgroundImagePrimary=getBackgroundImage(primaryMain,color.transparent),backgroundImagePrimary_disabled=getBackgroundImage(primaryMain+'80',color.transparent),backgroundImageSecondary=getBackgroundImage(secondaryMain,color.transparent),backgroundImageSecondary_disabled=getBackgroundImage(secondaryMain+'80',color.transparent),backgroundImage_invalid=getBackgroundImage(color.error,color.error),backgroundImage_invalidFocus=getBackgroundImage(color.error,color.error);return(0,_themes.createComponentTheme)(baseTheme,{SelectControl_width:'270px',SelectControl_minHeight_small:size.small,SelectControl_minHeight_medium:size.medium,SelectControl_minHeight_large:size.large,SelectControl_backgroundColor:color.surface,SelectControl_backgroundColor_disabled:color.transparent,SelectControl_backgroundImage_themePrimary:backgroundImagePrimary,SelectControl_backgroundImage_themePrimary_disabled:backgroundImagePrimary_disabled,SelectControl_backgroundImage_themeSecondary:backgroundImageSecondary,SelectControl_backgroundImage_themeSecondary_disabled:backgroundImageSecondary_disabled,SelectControl_backgroundImage_invalid:backgroundImage_invalid,SelectControl_backgroundImage_invalidFocus:backgroundImage_invalidFocus,SelectControl_backgroundPosition_small:'right 12px center, right 34px center',SelectControl_backgroundPosition_medium:'right 12px center, right 34px center',SelectControl_backgroundPosition_large:'right 14px center, right 38px center',SelectControl_borderColor:'rgba(0, 0, 0, 0.43)',SelectControl_borderColor_focus:ninja11,SelectControl_borderColor_disabled:'rgba(0, 0, 0, 0.20)',SelectControl_borderColor_invalid:color.error,SelectControl_borderColor_invalidFocus:ninja11,SelectControl_borderStyle:shape.borderStyle,SelectControl_borderWidth:shape.borderWidth,SelectControl_borderRadius:shape.borderRadius,SelectControl_color:color.onSurface,SelectControl_color_disabled:black57,SelectControl_color_readOnly:black57,SelectControl_fontFamily:typography.fontFamily,SelectControl_fontSize_small:typography.fontSize,SelectControl_fontSize_medium:typography.fontSize,SelectControl_fontSize_large:typography.fontSize+2,SelectControl_fontWeight:typography.fontWeightRegular,SelectControl_boxShadow_focus:'0 0 0 1px '+ninja11})};exports.default=componentTheme;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _Table=__webpack_require__(630);Object.defineProperty(exports,'default',{enumerable:!0,get:function get(){return _interopRequireDefault(_Table).default}});var _TableBody=__webpack_require__(171);Object.defineProperty(exports,'TableBody',{enumerable:!0,get:function get(){return _interopRequireDefault(_TableBody).default}});var _TableDataCell=__webpack_require__(174);Object.defineProperty(exports,'TableDataCell',{enumerable:!0,get:function get(){return _interopRequireDefault(_TableDataCell).default}});var _TableHeader=__webpack_require__(170);Object.defineProperty(exports,'TableHeader',{enumerable:!0,get:function get(){return _interopRequireDefault(_TableHeader).default}});var _TableHeaderCell=__webpack_require__(173);Object.defineProperty(exports,'TableHeaderCell',{enumerable:!0,get:function get(){return _interopRequireDefault(_TableHeaderCell).default}});var _TableRow=__webpack_require__(172);Object.defineProperty(exports,'TableRow',{enumerable:!0,get:function get(){return _interopRequireDefault(_TableRow).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_templateObject=_taggedTemplateLiteral(['\n  box-sizing: border-box;\n  & *,\n  & *::before,\n  & *::after {\n    box-sizing: inherit;\n  }\n\n  button {\n    cursor: pointer;\n  }\n  button[disabled] {\n    cursor: default;\n  }\n'],['\n  box-sizing: border-box;\n  & *,\n  & *::before,\n  & *::after {\n    box-sizing: inherit;\n  }\n\n  button {\n    cursor: pointer;\n  }\n  button[disabled] {\n    cursor: default;\n  }\n']),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_reactDom=__webpack_require__(26),_reactDom2=_interopRequireDefault(_reactDom),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes),_styledComponents=__webpack_require__(8),_styledComponents2=_interopRequireDefault(_styledComponents),_TableHeader=__webpack_require__(170),_TableHeader2=_interopRequireDefault(_TableHeader),_TableBody=__webpack_require__(171),_TableBody2=_interopRequireDefault(_TableBody),_TableRow=__webpack_require__(172),_TableRow2=_interopRequireDefault(_TableRow),_TableHeaderCell=__webpack_require__(173),_TableHeaderCell2=_interopRequireDefault(_TableHeaderCell),_TableDataCell=__webpack_require__(174),_TableDataCell2=_interopRequireDefault(_TableDataCell),_Card=__webpack_require__(165),_Card2=_interopRequireDefault(_Card),_styles=__webpack_require__(17),_themes=__webpack_require__(5),_propTypes3=__webpack_require__(10),_componentTheme=__webpack_require__(632),_componentTheme2=_interopRequireDefault(_componentTheme);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++)arr2[i]=arr[i];return arr2}return Array.from(arr)}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}))}var Styled={Card:{},div:{},table:{}},normalizeStyles=(0,_styles.css)(_templateObject);Styled.Card.root=(0,_styledComponents2.default)(_Card2.default).withConfig({displayName:'Table__root'})(['',';',';width:',';max-width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;font-family:',';font-size:',';font-weight:',';line-height:1.5;@media print{max-width:none;overflow:visible;border:none;}'],_styles.resetInheritedStyles,normalizeStyles,function(props){return props.sc.fullWidth?'100%':'auto'},(0,_themes.getStyle)('Table_fontFamily'),function(props){return props.theme.vstui.rem((0,_themes.getStyle)('Table_fontSize')(props))},(0,_themes.getStyle)('Table_fontWeight')),Styled.div.tableWrapper=_styledComponents2.default.div.withConfig({displayName:'Table__tableWrapper'})(['position:relative;display:table;width:100%;']),Styled.div.headerTableWrapper=_styledComponents2.default.div.withConfig({displayName:'Table__headerTableWrapper'})(['position:absolute;top:0;right:0;bottom:0;left:0;z-index:2;margin-right:','px;pointer-events:none;'],function(props){return props.scrollable?props.scrollbarWidth:0}),Styled.table.header=_styledComponents2.default.table.withConfig({displayName:'Table__header'})(['position:absolute;top:0;left:0;width:100%;border-collapse:separate;border-spacing:0;thead{th{position:relative;pointer-events:auto;}position:relative;}tbody{visibility:hidden;tr{th,td{padding-top:0;padding-bottom:0;border-top:none;border-bottom:none;line-height:0.1;}& + tr th,& + tr td{line-height:0;}}}tbody tr:last-child td{border-bottom:none;}tfoot{position:relative;th,td{position:relative;}}@media print{display:none;}']),Styled.div.bodyTableWrapper=_styledComponents2.default.div.withConfig({displayName:'Table__bodyTableWrapper'})(['position:relative;z-index:1;width:100%;max-height:',';overflow-y:',';-webkit-overflow-scrolling:touch;outline-offset:-10px;@media print{max-height:100%;overflow:visible;}'],function(props){return props.maxHeight?props.theme.vstui.rem(props.maxHeight):'none'},function(props){return props.scrollable?'scroll':'visible'}),Styled.table.body=_styledComponents2.default.table.withConfig({displayName:'Table__body'})(['width:100%;border-collapse:separate;border-spacing:0;tbody tr:last-child td{border-bottom:none;}@media print{page-break-inside:avoid;}']);var Table=function(_Component){function Table(){_classCallCheck(this,Table);var _this=_possibleConstructorReturn(this,(Table.__proto__||Object.getPrototypeOf(Table)).call(this));return _this.handleBodyTableRef=_this.handleBodyTableRef.bind(_this),_this.handleHeaderClick=_this.handleHeaderClick.bind(_this),_this.compare=_this.compare.bind(_this),_this.state={scrollable:!1,sortOrder:1,sortedHeaderIndex:null,scrollbarWidth:_this.getScrollbarWidth()},_this}return _inherits(Table,_Component),_createClass(Table,[{key:'getScrollbarWidth',value:function getScrollbarWidth(){var outer=document.createElement('div');outer.style.visibility='hidden',outer.style.width='100px',document.body.appendChild(outer);var widthWithoutScroll=outer.offsetWidth;outer.style.overflow='scroll';var inner=document.createElement('div');inner.style.width='100%',outer.appendChild(inner);var widthWithScroll=inner.offsetWidth;return outer.parentNode.removeChild(outer),widthWithoutScroll-widthWithScroll}},{key:'getSortValue',value:function getSortValue(row){var cellData=Object.values(row)[this.state.sortedHeaderIndex];return null===cellData?null:cellData.content?cellData.sort||this.toString(cellData.content):this.toString(cellData)}},{key:'toString',value:function toString(element){var _this2=this;if(_react2.default.isValidElement(element))return this.toString(_react2.default.Children.toArray(element.props.children));if(Array.isArray(element)){var _ref,array=element.map(function(child){return'string'==typeof child?child.toLowerCase():_this2.toString(child)});return(_ref=[]).concat.apply(_ref,_toConsumableArray(array)).join('')}return element}},{key:'compare',value:function compare(rowA,rowB){var sortValueA=this.getSortValue(rowA),sortValueB=this.getSortValue(rowB);return sortValueA>sortValueB?this.state.sortOrder:sortValueA<sortValueB?-1*this.state.sortOrder:0}},{key:'handleBodyTableRef',value:function handleBodyTableRef(table){var maxStaticHeight=this.props.maxStaticHeight;if(table&&maxStaticHeight){var height,pxRegex=/px$/,percentRegex=/%$/;if(maxStaticHeight.match(pxRegex))height=parseInt(maxStaticHeight.split(pxRegex)[0],10);else if(maxStaticHeight.match(percentRegex)){var rootNode=_reactDom2.default.findDOMNode(this),parentHeight=rootNode.parentNode.offsetHeight;height=parentHeight*(parseInt(maxStaticHeight.split(percentRegex)[0],10)/100)}this.setState({maxHeight:height+'px',scrollable:!0})}}},{key:'handleHeaderClick',value:function handleHeaderClick(event,index){-1===this.state.sortOrder||this.state.sortedHeaderIndex!==index?this.setState({sortOrder:1,sortedHeaderIndex:index}):this.setState({sortOrder:-1,sortedHeaderIndex:index})}},{key:'renderHeaderTable',value:function renderHeaderTable(theme){return _react2.default.createElement(Styled.table.header,null,this.renderTableHeader('header',theme),this.renderTableBody(theme))}},{key:'renderBodyTable',value:function renderBodyTable(theme){return _react2.default.createElement(Styled.table.body,{innerRef:this.handleBodyTableRef},this.renderTableHeader('body',theme),this.renderTableBody(theme))}},{key:'renderTableHeader',value:function renderTableHeader(tableType,theme){var _this3=this,columns=this.props.columns,_state=this.state,sortedHeaderIndex=_state.sortedHeaderIndex,sortOrder=_state.sortOrder;return _react2.default.createElement(_TableHeader2.default,{theme:theme},_react2.default.createElement(_TableRow2.default,{theme:theme},columns.map(function(column,index){return _react2.default.createElement(_TableHeaderCell2.default,{hidden:!0===column.hiddenHeader,index:index,key:index,numeric:!0===column.numeric,onClick:_this3.handleHeaderClick,sortIndex:sortedHeaderIndex,sortOrder:sortOrder,tableType:tableType,theme:theme},column.header)})))}},{key:'renderTableBody',value:function renderTableBody(theme){var _this4=this,_props=this.props,rows=_props.rows,secondary=_props.secondary,_state2=this.state,sortedHeaderIndex=_state2.sortedHeaderIndex,sortOrder=_state2.sortOrder,sortedRows=void 0;return sortedRows=null===this.state.sortedHeaderIndex?rows:rows.sort(this.compare),_react2.default.createElement(_TableBody2.default,{secondary:secondary,sortIndex:sortedHeaderIndex,sortOrder:sortOrder,theme:theme},sortedRows.map(function(row,rowIndex){return _react2.default.createElement(_TableRow2.default,{key:rowIndex,theme:theme},_this4.props.columns.map(function(column,columnIndex){return _this4.renderTableDataCell(row,column,columnIndex,theme)}))}))}},{key:'renderTableDataCell',value:function renderTableDataCell(row,column,columnIndex,theme){var secondary=this.props.secondary,hover=this.state.hover,cellData=row[column.rowKey],content=void 0;return content=null===cellData?null:cellData.content?cellData.content:cellData,_react2.default.createElement(_TableDataCell2.default,{key:columnIndex,numeric:!0===column.numeric,rowHover:hover,secondary:secondary,theme:theme},content)}},{key:'render',value:function render(){var _props2=this.props,className=_props2.className,fullWidth=_props2.fullWidth,raised=_props2.raised,themeProp=_props2.theme,_state3=this.state,maxHeight=_state3.maxHeight,scrollable=_state3.scrollable,scrollbarWidth=_state3.scrollbarWidth,theme=(0,_componentTheme2.default)(themeProp);return _react2.default.createElement(Styled.Card.root,{className:className,raised:raised,sc:{fullWidth:fullWidth},theme:theme},_react2.default.createElement(Styled.div.tableWrapper,null,_react2.default.createElement(Styled.div.headerTableWrapper,{"aria-hidden":!0,scrollable:scrollable,scrollbarWidth:scrollbarWidth},this.renderHeaderTable(theme)),_react2.default.createElement(Styled.div.bodyTableWrapper,{maxHeight:maxHeight,role:'region',scrollable:scrollable,tabIndex:scrollable?0:void 0},this.renderBodyTable(theme))))}}]),Table}(_react.Component);Table.propTypes={className:_propTypes2.default.string,columns:_propTypes2.default.arrayOf(_propTypes2.default.shape({header:_propTypes2.default.string.isRequired,hiddenHeader:_propTypes2.default.bool,numeric:_propTypes2.default.bool,rowKey:_propTypes2.default.string.isRequired})).isRequired,fullWidth:_propTypes2.default.bool,maxStaticHeight:_propTypes2.default.string,raised:_propTypes2.default.bool,rows:_propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,secondary:_propTypes2.default.bool,theme:_propTypes3.themeShape},Table.defaultProps={theme:(0,_themes.createTheme)()},Table.displayName='Table';var TableWithTheme=(0,_themes.withTheme)(Table);TableWithTheme.WrappedComponent=Table,exports.default=TableWithTheme;

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes),_Icon=__webpack_require__(16),_Icon2=_interopRequireDefault(_Icon),_colors=__webpack_require__(163);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj)0<=keys.indexOf(i)||Object.prototype.hasOwnProperty.call(obj,i)&&(target[i]=obj[i]);return target}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var SortIcon=function(_PureComponent){function SortIcon(){return _classCallCheck(this,SortIcon),_possibleConstructorReturn(this,(SortIcon.__proto__||Object.getPrototypeOf(SortIcon)).apply(this,arguments))}return _inherits(SortIcon,_PureComponent),_createClass(SortIcon,[{key:'render',value:function render(){var _props=this.props,direction=_props.direction,other=_objectWithoutProperties(_props,['direction']);return'ascending'===direction&&(other.transform='rotate(180)'),_react2.default.createElement(_Icon2.default,_extends({},other,{height:4,width:6}),_react2.default.createElement('path',{d:'M5.547.2c.396 0 .6.474.327.762L3.358 3.617c-.18.24-.54.24-.717 0L.125.962A.45.45 0 0 1 .45.2h5.097z',fill:_colors.cloud.getShade(7)}))}}]),SortIcon}(_react.PureComponent);SortIcon.propTypes={direction:_propTypes2.default.oneOf(['ascending','descending'])},SortIcon.defaultProps={},SortIcon.displayName='SortIcon',exports.default=SortIcon;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _themes=__webpack_require__(5),componentTheme=function(baseTheme){var _baseTheme$vstui=baseTheme.vstui,color=_baseTheme$vstui.color,shape=_baseTheme$vstui.shape,typography=_baseTheme$vstui.typography,cloud2=color.cloud.getShade(2),cloud3=color.cloud.getShade(3),cloud4=color.cloud.getShade(4),cloud9=color.cloud.getShade(9);return(0,_themes.createComponentTheme)(baseTheme,{Table_borderRadius:shape.borderRadius,Table_fontFamily:typography.fontFamily,Table_fontSize:typography.fontSize,Table_fontWeight:typography.fontWeightRegular,TableDataCell_backgroundColor:color.surface,TableDataCell_backgroundColor_primary_hover:color.surface,TableDataCell_backgroundColor_secondary_hover:color.surface,TableDataCell_borderColor:cloud3,TableDataCell_color:color.onSurface,TableDataCell_fontFamily:typography.fontFamily,TableDataCell_fontSize:typography.fontSize,TableDataCell_fontWeight:typography.fontWeightRegular,TableHeaderCell_backgroundColor:cloud2,TableHeaderCell_borderColor:cloud4,TableHeaderCell_color:cloud9,TableHeaderCell_fontFamily:typography.fontFamily,TableHeaderCell_fontSize:typography.fontSize-1,TableHeaderCell_fontWeight:typography.fontWeightRegular})};exports.default=componentTheme;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _TextField=__webpack_require__(634);Object.defineProperty(exports,'default',{enumerable:!0,get:function get(){return _interopRequireDefault(_TextField).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof='function'==typeof Symbol&&'symbol'==typeof Symbol.iterator?function(obj){return typeof obj}:function(obj){return obj&&'function'==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?'symbol':typeof obj},_extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes),_styledComponents=__webpack_require__(8),_styledComponents2=_interopRequireDefault(_styledComponents),_propTypes3=__webpack_require__(10),_themes=__webpack_require__(5),_utils=__webpack_require__(25),_FormGroup=__webpack_require__(87),_FormGroup2=_interopRequireDefault(_FormGroup),_InputControl=__webpack_require__(635),_InputControl2=_interopRequireDefault(_InputControl),_TextAreaControl=__webpack_require__(638),_TextAreaControl2=_interopRequireDefault(_TextAreaControl);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj)0<=keys.indexOf(i)||Object.prototype.hasOwnProperty.call(obj,i)&&(target[i]=obj[i]);return target}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var Styled={};Styled.InputControl=(0,_styledComponents2.default)(_InputControl2.default).withConfig({displayName:'TextField__InputControl'})(['display:block;']),Styled.InputControl.displayName='Styled_InputControl',Styled.TextAreaControl=(0,_styledComponents2.default)(_TextAreaControl2.default).withConfig({displayName:'TextField__TextAreaControl'})(['display:block;']),Styled.TextAreaControl.displayName='Styled_TextAreaControl';var TextField=function(_Component){function TextField(props){_classCallCheck(this,TextField);var _this=_possibleConstructorReturn(this,(TextField.__proto__||Object.getPrototypeOf(TextField)).call(this,props));return _this.generatedId=(0,_utils.generateUniqueId)('text-field'),_this.state={id:props.id||_this.generatedId,validationMessage:''},_this.handleFormControlRef=_this.handleFormControlRef.bind(_this),_this.handleNativeFormControlRef=_this.handleNativeFormControlRef.bind(_this),_this.handleValidate=_this.handleValidate.bind(_this),_this}return _inherits(TextField,_Component),_createClass(TextField,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var id=nextProps.id||this.generatedId;id!==this.state.id&&this.setState({id:id})}},{key:'focus',value:function focus(){this.nativeFormControl&&this.nativeFormControl.focus()}},{key:'validate',value:function validate(callback){this.formControl&&this.formControl.validate(callback)}},{key:'handleFormControlRef',value:function handleFormControlRef(node){this.formControl=node}},{key:'handleNativeFormControlRef',value:function handleNativeFormControlRef(node){var nativeFormControlRef=this.props.nativeFormControlRef;this.nativeFormControl=node,nativeFormControlRef&&nativeFormControlRef(node)}},{key:'handleValidate',value:function handleValidate(valid,validationMessage){this.setState({validationMessage:validationMessage})}},{key:'render',value:function render(){var _props=this.props,className=_props.className,disabled=_props.disabled,fullWidth=_props.fullWidth,helperText=_props.helperText,idIgnored=_props.id,inheritStyles=_props.inheritStyles,label=_props.label,labelHidden=_props.labelHidden,max=_props.max,min=_props.min,multiline=_props.multiline,nativeFormControlRefIgnored=_props.nativeFormControlRef,pattern=_props.pattern,rootProps=_props.rootProps,rows=_props.rows,secondary=_props.secondary,size=_props.size,step=_props.step,theme=_props.theme,type=_props.type,otherProps=_objectWithoutProperties(_props,['className','disabled','fullWidth','helperText','id','inheritStyles','label','labelHidden','max','min','multiline','nativeFormControlRef','pattern','rootProps','rows','secondary','size','step','theme','type']),id=this.state.id,validationMessage=this.state.validationMessage,conditionalProps={};multiline?conditionalProps.rows=rows:(conditionalProps.max=max,conditionalProps.min=min,conditionalProps.pattern=pattern,conditionalProps.step=step,conditionalProps.type=type);var Control=multiline?Styled.TextAreaControl:Styled.InputControl;return _react2.default.createElement(_FormGroup2.default,{className:className,disabled:disabled,formControl:_react2.default.createElement(Control,_extends({},otherProps,conditionalProps,{innerRef:this.handleFormControlRef,nativeFormControlRef:this.handleNativeFormControlRef,onValidate:this.handleValidate})),fullWidth:fullWidth,helperText:helperText,id:id,inheritStyles:inheritStyles,label:label,labelHidden:labelHidden,rootProps:rootProps,secondary:secondary,size:size,theme:theme,validationMessage:validationMessage})}}]),TextField}(_react.Component);TextField.propTypes={className:_propTypes2.default.string,defaultValue:function defaultValue(props,propName,componentName){if(props[propName]!==void 0){if(props.value!==void 0)throw new Error('Props `defaultValue` and `value` are both defined in `'+componentName+'`, but only one is allowed. Use `defaultValue` for an uncontrolled component, or `value` for a controlled component.');if('string'!=typeof props[propName]&&'number'!=typeof props[propName]&&null!==props[propName])return new Error('Invalid prop `'+propName+'` of type `'+_typeof(props[propName])+'` supplied to `'+componentName+'`, expected `string`, `number`, or a value of `null`.')}},disabled:_propTypes2.default.bool,fullWidth:_propTypes2.default.bool,helperText:_propTypes2.default.string,id:_propTypes2.default.string,inheritStyles:_propTypes2.default.bool,label:function label(props,propName,componentName){if(props.label===void 0&&props.labelledBy===void 0)return new Error(componentName+' requires either the `label` prop or the `labelledBy` prop.');if(void 0!==props[propName]){if('string'!=typeof props[propName])return new Error('Invalid prop `'+propName+'` of type `'+_typeof(props[propName])+'` supplied to `'+componentName+'`, expected `string`.');''===props[propName]}},labelHidden:_propTypes2.default.bool,labelledBy:function labelledBy(props,propName,componentName){if(props.label===void 0&&props.labelledBy===void 0)return new Error(componentName+' requires either the `label` prop or the `labelledBy` prop.');if(void 0!==props[propName]){if('string'!=typeof props[propName])return new Error('Invalid prop `'+propName+'` of type `'+_typeof(props[propName])+'` supplied to `'+componentName+'`, expected `string`.');''===props[propName]}},max:function max(props,propName,componentName){if(props[propName]!==void 0&&'number'!=typeof props[propName]&&'string'!=typeof props[propName])return new Error('Invalid prop `'+propName+'` of type `'+_typeof(props[propName])+'` supplied to `'+componentName+'`, expected `number` or `string`.')},maxLength:function maxLength(props,propName,componentName){if(props[propName]!==void 0&&'number'!=typeof props[propName])return new Error('Invalid prop `'+propName+'` of type `'+_typeof(props[propName])+'` supplied to `'+componentName+'`, expected `number`.')},min:function min(props,propName,componentName){if(props[propName]!==void 0&&'number'!=typeof props[propName]&&'string'!=typeof props[propName])return new Error('Invalid prop `'+propName+'` of type `'+_typeof(props[propName])+'` supplied to `'+componentName+'`, expected `number` or `string`.')},minLength:function minLength(props,propName,componentName){if(props[propName]!==void 0&&'number'!=typeof props[propName])return new Error('Invalid prop `'+propName+'` of type `'+_typeof(props[propName])+'` supplied to `'+componentName+'`, expected `number`.')},multiline:_propTypes2.default.bool,nativeFormControlRef:_propTypes2.default.func,onChange:_propTypes2.default.func,pattern:_propTypes2.default.string,placeholder:_propTypes2.default.string,readOnly:_propTypes2.default.bool,required:_propTypes2.default.bool,rootProps:_propTypes2.default.object,rows:_propTypes2.default.number,secondary:_propTypes2.default.bool,size:_propTypes2.default.oneOf(['small','medium','large']),step:function step(props,propName,componentName){if(props[propName]!==void 0&&'number'!=typeof props[propName]&&'any'!==props[propName])return new Error('Invalid prop `'+propName+'` of type `'+_typeof(props[propName])+'` supplied to `'+componentName+'`, expected either `number`, or `string` with a value of "any".')},theme:_propTypes3.themeShape,type:_propTypes2.default.oneOf(['date','datetime-local','email','month','number','password','search','tel','text','time','url','week']),validate:_propTypes2.default.func,value:function value(props,propName,componentName){if(props[propName]!==void 0){if(props.defaultValue!==void 0)throw new Error('Props `defaultValue` and `value` are both defined in `'+componentName+'`, but only one is allowed. Use `defaultValue` for an uncontrolled component, or `value` for a controlled component.');if(void 0===props.onChange)throw new Error('Please add prop `onChange` to `'+componentName+'`. Prop `value` has been set, which makes this a controlled component.');if('string'!=typeof props[propName]&&'number'!=typeof props[propName]&&null!==props[propName])return new Error('Invalid prop `'+propName+'` of type `'+_typeof(props[propName])+'` supplied to `'+componentName+'`, expected `string`, `number`, or a value of `null`.')}}},TextField.defaultProps={rows:3,size:'medium',theme:(0,_themes.createTheme)(),validate:function validate(){return''}},TextField.displayName='TextField';var TextFieldWithTheme=(0,_themes.withTheme)(TextField);TextFieldWithTheme.WrappedComponent=TextField,exports.default=TextFieldWithTheme;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _InputControl=__webpack_require__(636);Object.defineProperty(exports,'default',{enumerable:!0,get:function get(){return _interopRequireDefault(_InputControl).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof='function'==typeof Symbol&&'symbol'==typeof Symbol.iterator?function(obj){return typeof obj}:function(obj){return obj&&'function'==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?'symbol':typeof obj},_extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes),_styledComponents=__webpack_require__(8),_styledComponents2=_interopRequireDefault(_styledComponents),_styles=__webpack_require__(17),_themes=__webpack_require__(5),_propTypes3=__webpack_require__(10),_FormControl=__webpack_require__(58),_FormControl2=_interopRequireDefault(_FormControl),_componentTheme=__webpack_require__(637),_componentTheme2=_interopRequireDefault(_componentTheme);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj)0<=keys.indexOf(i)||Object.prototype.hasOwnProperty.call(obj,i)&&(target[i]=obj[i]);return target}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var Styled={};Styled.input=_styledComponents2.default.input.withConfig({displayName:'InputControl__input'})(['',';box-sizing:border-box;width:',';max-width:100%;min-height:',';padding:0 12px;background-color:',';background-image:',';background-position:',';background-repeat:no-repeat;background-size:',';border-color:',';border-style:',';border-width:',';border-radius:',';color:',';font-family:',';font-size:',';font-weight:',';-webkit-font-smoothing:antialiased;transition-property:none;transition-duration:',';transition-timing-function:',';appearance:none;&[type=\'checkbox\'],&[type=\'radio\']{',';}&::-moz-placeholder{opacity:1;}&::placeholder{color:',';font-weight:',';}&:required{box-shadow:none;}&:read-only{background-color:',';color:',';}&:focus{outline:none;border-color:',';box-shadow:',';}&[aria-invalid]{padding-right:38px;background-image:',';border-color:',';box-shadow:none;&:focus{background-image:',';border-color:',';box-shadow:',';}}&:disabled{background-color:',';border-color:',';color:',';cursor:default;}'],function(props){return props.sc.inheritStyles?'':_styles.resetInheritedStyles},function(props){return props.sc.fullWidth?'100%':(0,_themes.getStyle)('InputControl_width')},function(props){return props.theme.vstui.rem((0,_themes.getStyle)('InputControl_minHeight_'+props.sc.size)(props))},(0,_themes.getStyle)('InputControl_backgroundColor'),(0,_themes.getStyle)('InputControl_backgroundImage'),function(props){return(0,_themes.getStyle)('InputControl_backgroundPosition_'+props.sc.size)(props)},(0,_themes.getStyle)('InputControl_backgroundSize'),(0,_themes.getStyle)('InputControl_borderColor'),(0,_themes.getStyle)('InputControl_borderStyle'),(0,_themes.getStyle)('InputControl_borderWidth'),(0,_themes.getStyle)('InputControl_borderRadius'),(0,_themes.getStyle)('InputControl_color'),(0,_themes.getStyle)('InputControl_fontFamily'),function(props){return props.theme.vstui.rem((0,_themes.getStyle)('InputControl_fontSize_'+props.sc.size)(props))},(0,_themes.getStyle)('InputControl_fontWeight'),function(props){return props.theme.vstui.transition.duration.shortest},function(props){return props.theme.vstui.transition.easing.easeIn},(0,_styles.visuallyHidden)(),(0,_themes.getStyle)('InputControlPlaceholder_color'),(0,_themes.getStyle)('InputControlPlaceholder_fontWeight'),(0,_themes.getStyle)('InputControl_backgroundColor_readOnly'),(0,_themes.getStyle)('InputControl_color_readOnly'),(0,_themes.getStyle)('InputControl_borderColor_focus'),(0,_themes.getStyle)('InputControl_boxShadow_focus'),(0,_themes.getStyle)('InputControl_backgroundImage_invalid'),(0,_themes.getStyle)('InputControl_borderColor_invalid'),(0,_themes.getStyle)('InputControl_backgroundImage_invalidFocus'),(0,_themes.getStyle)('InputControl_borderColor_invalidFocus'),(0,_themes.getStyle)('InputControl_boxShadow_focus'),(0,_themes.getStyle)('InputControl_backgroundColor_disabled'),(0,_themes.getStyle)('InputControl_borderColor_disabled'),(0,_themes.getStyle)('InputControl_color_disabled')),Styled.input.displayName='Styled_input';var InputControl=function(_Component){function InputControl(){_classCallCheck(this,InputControl);var _this=_possibleConstructorReturn(this,(InputControl.__proto__||Object.getPrototypeOf(InputControl)).call(this));return _this.handleFormControlRef=_this.handleFormControlRef.bind(_this),_this.handleValidate=_this.handleValidate.bind(_this),_this.renderContent=_this.renderContent.bind(_this),_this.formValidation={missingCheckbox:function missingCheckbox(){return'Please check this box if you want to proceed.'},missingEmail:function missingEmail(){return'Please enter an email address.'},missingNumber:function missingNumber(){return'Please enter a number.'},missingPassword:function missingPassword(){return'Please enter a password.'},missingTel:function missingTel(){return'Please enter a telephone number.'},missingUrl:function missingUrl(){return'Please enter a URL.'},missingText:function missingText(){return'Please fill out this field.'},typeMismatchEmail:function typeMismatchEmail(){return'Please enter a valid email address.'},typeMismatchUrl:function typeMismatchUrl(){return'Please enter a valid URL.'},patternMismatch:function patternMismatch(){return'Please match the requested format.'},tooLong:function tooLong(maxLength,currentLength){return'Please shorten this text to '+maxLength+' characters or less (you are currently using '+currentLength+' characters).'},tooShort:function tooShort(minLength,currentLength){return'Please use at least '+minLength+' characters (you are currently using '+currentLength+' characters).'},rangeUnderflow:function rangeUnderflow(min){return'Value must be greater than or equal to '+min+'.'},rangeOverflow:function rangeOverflow(max){return'Value must be less than or equal to '+max+'.'},rangeUnderflowDatetime:function rangeUnderflowDatetime(date){return'Value must be '+date+' or later.'},rangeOverflowDatetime:function rangeOverflowDatetime(date){return'Value must be '+date+' or earlier.'},stepMismatch:function stepMismatch(value1,value2){return'Please enter a valid value. The two nearest valid values are '+value1+' and '+value2+'.'},stepMismatchOneValue:function stepMismatchOneValue(value){return'Please enter a valid value. The nearest valid value is '+value+'.'},badInputDatetime:function badInputDatetime(){return'Please enter a valid value. The field is incomplete or has an invalid date.'},badInputNumber:function badInputNumber(){return'Please enter a valid number.'}},_this}return _inherits(InputControl,_Component),_createClass(InputControl,[{key:'getValidationMessage',value:function getValidationMessage(validity,_ref){var max=_ref.max,maxLength=_ref.maxLength,min=_ref.min,minLength=_ref.minLength,type=_ref.type,value=_ref.value;if(validity.valueMissing)return'checkbox'===type?this.formValidation.missingCheckbox():'email'===type?this.formValidation.missingEmail():'number'===type?this.formValidation.missingNumber():'password'===type?this.formValidation.missingPassword():'tel'===type?this.formValidation.missingTel():'url'===type?this.formValidation.missingUrl():this.formValidation.missingText();if(validity.typeMismatch){if('email'===type)return this.formValidation.typeMismatchEmail();if('url'===type)return this.formValidation.typeMismatchUrl()}else{if(validity.patternMismatch)return this.formValidation.patternMismatch();if(validity.tooLong)return this.formValidation.tooLong(maxLength,value.length);if(validity.tooShort)return this.formValidation.tooShort(minLength,value.length);if(validity.rangeUnderflow)return this.isTypeDatetime(type)?this.formValidation.rangeUnderflowDatetime(min):this.formValidation.rangeUnderflow(min);if(validity.rangeOverflow)return this.isTypeDatetime(type)?this.formValidation.rangeOverflowDatetime(max):this.formValidation.rangeOverflow(max);if(validity.stepMismatch)return'Please enter a valid value.';if(validity.badInput)return this.isTypeDatetime(type)?this.formValidation.badInputDatetime():this.formValidation.badInputNumber()}return''}},{key:'isTypeDatetime',value:function isTypeDatetime(type){return'date'===type||'datetime-local'===type||'month'===type||'time'===type||'week'===type}},{key:'validate',value:function validate(callback){this.formControl.validate(callback)}},{key:'handleFormControlRef',value:function handleFormControlRef(node){this.formControl=node}},{key:'handleValidate',value:function handleValidate(validity){var _ref3=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},callback=_ref3.callback,onlyValidateIfValid=_ref3.onlyValidateIfValid,_ref2=arguments[2],checked=_ref2.checked,updateValidationState=_ref2.updateValidationState,value=_ref2.value,_props=this.props,max=_props.max,maxLength=_props.maxLength,min=_props.min,minLength=_props.minLength,onValidate=_props.onValidate,type=_props.type,validate=_props.validate,passedDefaultValidation=validity.valid,defaultValidationMessage=this.getValidationMessage(validity,{checked:checked,max:max,maxLength:maxLength,min:min,minLength:minLength,type:type,value:value}),customValidationMessagePromise=Promise.resolve(validate?validate(value):''),update=function(valid,validationMessage){(!onlyValidateIfValid||onlyValidateIfValid&&valid)&&updateValidationState(valid,validationMessage,onValidate)};update(passedDefaultValidation,defaultValidationMessage),passedDefaultValidation?customValidationMessagePromise.then(function(customValidationMessage){var passedCustomValidation=!customValidationMessage;update(passedCustomValidation,customValidationMessage),callback&&callback(passedCustomValidation,customValidationMessage)}):callback&&callback(passedDefaultValidation,defaultValidationMessage)}},{key:'renderContent',value:function renderContent(_ref4){var checked=_ref4.checked,defaultChecked=_ref4.defaultChecked,defaultValue=_ref4.defaultValue,invalid=_ref4.invalid,handleBlur=_ref4.handleBlur,handleChange=_ref4.handleChange,handleNativeFormControlRef=_ref4.handleNativeFormControlRef,value=_ref4.value,_props2=this.props,className=_props2.className,disabled=_props2.disabled,fullWidth=_props2.fullWidth,inheritStyles=_props2.inheritStyles,labelledBy=_props2.labelledBy,max=_props2.max,maxLength=_props2.maxLength,min=_props2.min,minLength=_props2.minLength,nativeFormControlRefIgnored=_props2.nativeFormControlRef,onBlurIgnored=_props2.onBlur,onChangeIgnored=_props2.onChange,onValidateIgnored=_props2.onValidate,pattern=_props2.pattern,placeholder=_props2.placeholder,readOnly=_props2.readOnly,required=_props2.required,secondary=_props2.secondary,size=_props2.size,step=_props2.step,themeProp=_props2.theme,type=_props2.type,validateIgnored=_props2.validate,otherProps=_objectWithoutProperties(_props2,['className','disabled','fullWidth','inheritStyles','labelledBy','max','maxLength','min','minLength','nativeFormControlRef','onBlur','onChange','onValidate','pattern','placeholder','readOnly','required','secondary','size','step','theme','type','validate']),theme=(0,_componentTheme2.default)(themeProp),conditionalProps={};return invalid&&(conditionalProps['aria-invalid']=!0),required&&(conditionalProps['aria-required']=!0),_react2.default.createElement(Styled.input,_extends({},otherProps,conditionalProps,{"aria-labelledby":labelledBy,checked:checked,className:className,defaultChecked:defaultChecked,defaultValue:defaultValue,disabled:disabled,innerRef:handleNativeFormControlRef,max:max,maxLength:maxLength,min:min,minLength:minLength,onBlur:handleBlur,onChange:handleChange,pattern:pattern,placeholder:placeholder,readOnly:readOnly,required:required,sc:{fullWidth:fullWidth,inheritStyles:inheritStyles,secondary:secondary,size:size},step:step,theme:theme,type:type,value:value}))}},{key:'render',value:function render(){var _props3=this.props,checked=_props3.checked,defaultChecked=_props3.defaultChecked,defaultValue=_props3.defaultValue,nativeFormControlRef=_props3.nativeFormControlRef,onBlur=_props3.onBlur,onChange=_props3.onChange,type=_props3.type,value=_props3.value;return _react2.default.createElement(_FormControl2.default,{checked:checked,defaultChecked:defaultChecked,defaultValue:defaultValue,nativeFormControlRef:nativeFormControlRef,onFormControlBlur:onBlur,onFormControlChange:onChange,onValidate:this.handleValidate,ref:this.handleFormControlRef,render:this.renderContent,type:type,value:value})}}]),InputControl}(_react.Component);InputControl.propTypes={checked:_propTypes2.default.bool,className:_propTypes2.default.string,defaultChecked:_propTypes2.default.bool,defaultValue:function defaultValue(props,propName,componentName){if(props[propName]!==void 0){if(props.value!==void 0)throw new Error('Props `defaultValue` and `value` are both defined in `'+componentName+'`, but only one is allowed. Use `defaultValue` for an uncontrolled component, or `value` for a controlled component.');if('string'!=typeof props[propName]&&'number'!=typeof props[propName]&&null!==props[propName])return new Error('Invalid prop `'+propName+'` of type `'+_typeof(props[propName])+'` supplied to `'+componentName+'`, expected `string`, `number`, or a value of `null`.')}},disabled:_propTypes2.default.bool,fullWidth:_propTypes2.default.bool,inheritStyles:_propTypes2.default.bool,labelledBy:_propTypes2.default.string,max:function max(props,propName,componentName){if(props[propName]!==void 0&&'number'!=typeof props[propName]&&'string'!=typeof props[propName])return new Error('Invalid prop `'+propName+'` of type `'+_typeof(props[propName])+'` supplied to `'+componentName+'`, expected `number` or `string`.')},maxLength:function maxLength(props,propName,componentName){if(props[propName]!==void 0&&'number'!=typeof props[propName])return new Error('Invalid prop `'+propName+'` of type `'+_typeof(props[propName])+'` supplied to `'+componentName+'`, expected `number`.')},min:function min(props,propName,componentName){if(props[propName]!==void 0&&'number'!=typeof props[propName]&&'string'!=typeof props[propName])return new Error('Invalid prop `'+propName+'` of type `'+_typeof(props[propName])+'` supplied to `'+componentName+'`, expected `number` or `string`.')},minLength:function minLength(props,propName,componentName){if(props[propName]!==void 0&&'number'!=typeof props[propName])return new Error('Invalid prop `'+propName+'` of type `'+_typeof(props[propName])+'` supplied to `'+componentName+'`, expected `number`.')},nativeFormControlRef:_propTypes2.default.func,onBlur:_propTypes2.default.func,onChange:_propTypes2.default.func,onValidate:_propTypes2.default.func,pattern:_propTypes2.default.string,placeholder:_propTypes2.default.string,readOnly:_propTypes2.default.bool,required:_propTypes2.default.bool,secondary:_propTypes2.default.bool,size:_propTypes2.default.oneOf(['small','medium','large']),step:function step(props,propName,componentName){if(props[propName]!==void 0&&'number'!=typeof props[propName]&&'any'!==props[propName])return new Error('Invalid prop `'+propName+'` of type `'+_typeof(props[propName])+'` supplied to `'+componentName+'`, expected either `number`, or `string` with a value of "any".')},theme:_propTypes3.themeShape,type:_propTypes2.default.string,validate:_propTypes2.default.func,value:function value(props,propName,componentName){if(props[propName]!==void 0){if(props.defaultValue!==void 0)throw new Error('Props `defaultValue` and `value` are both defined in `'+componentName+'`, but only one is allowed. Use `defaultValue` for an uncontrolled component, or `value` for a controlled component.');if(void 0===props.onChange)throw new Error('Please add prop `onChange` to `'+componentName+'`. Prop `value` has been set, which makes this a controlled component.');if('string'!=typeof props[propName]&&'number'!=typeof props[propName]&&null!==props[propName])return new Error('Invalid prop `'+propName+'` of type `'+_typeof(props[propName])+'` supplied to `'+componentName+'`, expected `string`, `number`, or a value of `null`.')}}},InputControl.defaultProps={size:'medium',theme:(0,_themes.createTheme)(),validate:function validate(){return''}},InputControl.displayName='InputControl';var InputControlWithTheme=(0,_themes.withTheme)(InputControl);InputControlWithTheme.WrappedComponent=InputControl,exports.default=InputControlWithTheme;

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _themes=__webpack_require__(5),getBackgroundImage=function(color){var encodedColor=encodeURIComponent(color);return'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 14 14\'%3E%3Cpath fill=\''+encodedColor+'\' d=\'M8 6a1 1 0 1 1-2 0V4a1 1 0 1 1 2 0v2zm-1 5a1 1 0 1 1 0-2 1 1 0 1 1 0 2zM7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0z\' /%3E%3C/svg%3E%0A")'},componentTheme=function(baseTheme){var _baseTheme$vstui=baseTheme.vstui,color=_baseTheme$vstui.color,shape=_baseTheme$vstui.shape,size=_baseTheme$vstui.size,typography=_baseTheme$vstui.typography,cloud2=color.cloud.getShade(2),ninja11=color.ninja.getShade(11),backgroundImage=getBackgroundImage(color.transparent),backgroundImage_invalid=getBackgroundImage(color.error),backgroundImage_invalidFocus=getBackgroundImage(color.error),black57='rgba(0, 0, 0, 0.57)';return(0,_themes.createComponentTheme)(baseTheme,{InputControl_width:'270px',InputControl_minHeight_small:size.small,InputControl_minHeight_medium:size.medium,InputControl_minHeight_large:size.large,InputControl_backgroundColor:color.surface,InputControl_backgroundColor_disabled:color.transparent,InputControl_backgroundColor_readOnly:cloud2,InputControl_backgroundImage:backgroundImage,InputControl_backgroundImage_invalid:backgroundImage_invalid,InputControl_backgroundImage_invalidFocus:backgroundImage_invalidFocus,InputControl_backgroundPosition_small:'right 12px top '+(size.small-2-14)/2+'px',InputControl_backgroundPosition_medium:'right 12px top '+(size.medium-2-14)/2+'px',InputControl_backgroundPosition_large:'right 14px top '+(size.large-2-14)/2+'px',InputControl_backgroundSize:'14px 14px',InputControl_borderColor:'rgba(0, 0, 0, 0.43)',InputControl_borderColor_focus:ninja11,InputControl_borderColor_disabled:'rgba(0, 0, 0, 0.20)',InputControl_borderColor_invalid:color.error,InputControl_borderColor_invalidFocus:ninja11,InputControl_borderStyle:shape.borderStyle,InputControl_borderWidth:shape.borderWidth,InputControl_borderRadius:shape.borderRadius,InputControl_fontFamily:typography.fontFamily,InputControl_fontSize_small:typography.fontSize,InputControl_fontSize_medium:typography.fontSize,InputControl_fontSize_large:typography.fontSize+2,InputControl_fontWeight:typography.fontWeightRegular,InputControl_color:color.onSurface,InputControl_color_disabled:black57,InputControl_color_readOnly:black57,InputControl_boxShadow_focus:'0 0 0 1px '+ninja11,InputControlPlaceholder_fontWeight:typography.fontWeightLight,InputControlPlaceholder_color:black57})};exports.default=componentTheme;

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _TextAreaControl=__webpack_require__(639);Object.defineProperty(exports,'default',{enumerable:!0,get:function get(){return _interopRequireDefault(_TextAreaControl).default}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof='function'==typeof Symbol&&'symbol'==typeof Symbol.iterator?function(obj){return typeof obj}:function(obj){return obj&&'function'==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?'symbol':typeof obj},_extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(1),_propTypes2=_interopRequireDefault(_propTypes),_styledComponents=__webpack_require__(8),_styledComponents2=_interopRequireDefault(_styledComponents),_styles=__webpack_require__(17),_themes=__webpack_require__(5),_propTypes3=__webpack_require__(10),_FormControl=__webpack_require__(58),_FormControl2=_interopRequireDefault(_FormControl),_componentTheme=__webpack_require__(640),_componentTheme2=_interopRequireDefault(_componentTheme);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj)0<=keys.indexOf(i)||Object.prototype.hasOwnProperty.call(obj,i)&&(target[i]=obj[i]);return target}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var Styled={};Styled.div={},Styled.textarea=_styledComponents2.default.textarea.withConfig({displayName:'TextAreaControl__textarea'})(['',';box-sizing:border-box;width:',';max-width:100%;min-height:',';padding:5px 12px;background-color:',';background-image:',';background-position:',';background-repeat:no-repeat;background-size:',';border-color:',';border-style:',';border-width:',';border-radius:',';color:',';font-family:',';font-size:',';font-weight:',';-webkit-font-smoothing:antialiased;line-height:1.5;white-space:pre-wrap;vertical-align:top;transition-property:none;transition-duration:',';transition-timing-function:',';appearance:none;resize:none;word-wrap:break-word;&::-moz-placeholder{opacity:1;}&::placeholder{color:',';font-weight:',';}&:required{box-shadow:none;}&:read-only{background-color:',';color:',';}&:focus{outline:none;border-color:',';box-shadow:',';}&[aria-invalid]{padding-right:38px;background-image:',';border-color:',';box-shadow:none;&:focus{background-image:',';border-color:',';box-shadow:',';}}&:disabled{background-color:',';border-color:',';color:',';cursor:default;}'],function(props){return props.inheritStyles?'':_styles.resetInheritedStyles},function(props){return props.sc.fullWidth?'100%':(0,_themes.getStyle)('TextAreaControl_width')},function(props){return props.theme.vstui.rem((0,_themes.getStyle)('InputControl_minHeight_'+props.sc.size)(props))},(0,_themes.getStyle)('TextAreaControl_backgroundColor'),(0,_themes.getStyle)('TextAreaControl_backgroundImage'),function(props){return(0,_themes.getStyle)('TextAreaControl_backgroundPosition_'+props.sc.size)(props)},(0,_themes.getStyle)('TextAreaControl_backgroundSize'),(0,_themes.getStyle)('TextAreaControl_borderColor'),(0,_themes.getStyle)('TextAreaControl_borderStyle'),(0,_themes.getStyle)('TextAreaControl_borderWidth'),(0,_themes.getStyle)('TextAreaControl_borderRadius'),(0,_themes.getStyle)('TextAreaControl_color'),(0,_themes.getStyle)('TextAreaControl_fontFamily'),function(props){return props.theme.vstui.rem((0,_themes.getStyle)('TextAreaControl_fontSize_'+props.sc.size)(props))},(0,_themes.getStyle)('TextAreaControl_fontWeight'),function(props){return props.theme.vstui.transition.duration.shortest},function(props){return props.theme.vstui.transition.easing.easeIn},(0,_themes.getStyle)('TextAreaControlPlaceholder_color'),(0,_themes.getStyle)('TextAreaControlPlaceholder_fontWeight'),(0,_themes.getStyle)('TextAreaControl_backgroundColor_readOnly'),(0,_themes.getStyle)('TextAreaControl_color_readOnly'),(0,_themes.getStyle)('TextAreaControl_borderColor_focus'),(0,_themes.getStyle)('TextAreaControl_boxShadow_focus'),(0,_themes.getStyle)('TextAreaControl_backgroundImage_invalid'),(0,_themes.getStyle)('TextAreaControl_borderColor_invalid'),(0,_themes.getStyle)('TextAreaControl_backgroundImage_invalidFocus'),(0,_themes.getStyle)('TextAreaControl_borderColor_invalidFocus'),(0,_themes.getStyle)('TextAreaControl_boxShadow_focus'),(0,_themes.getStyle)('TextAreaControl_backgroundColor_disabled'),(0,_themes.getStyle)('TextAreaControl_borderColor_disabled'),(0,_themes.getStyle)('TextAreaControl_color_disabled')),Styled.textarea.displayName='Styled_textarea';var TextAreaControl=function(_PureComponent){function TextAreaControl(props){_classCallCheck(this,TextAreaControl);var _this=_possibleConstructorReturn(this,(TextAreaControl.__proto__||Object.getPrototypeOf(TextAreaControl)).call(this,props));return _this.handleFormControlRef=_this.handleFormControlRef.bind(_this),_this.handleValidate=_this.handleValidate.bind(_this),_this.renderContent=_this.renderContent.bind(_this),_this.formValidation={missingText:function missingText(){return'Please fill out this field.'},tooLong:function tooLong(maxLength,currentLength){return'Please shorten this text to '+maxLength+' characters or less (you are currently using '+currentLength+' characters).'},tooShort:function tooShort(minLength,currentLength){return'Please use at least '+minLength+' characters (you are currently using '+currentLength+' characters).'}},_this}return _inherits(TextAreaControl,_PureComponent),_createClass(TextAreaControl,[{key:'getValidationMessage',value:function getValidationMessage(validity){var _props=this.props,maxLength=_props.maxLength,minLength=_props.minLength,value=_props.value;return validity.valueMissing?this.formValidation.missingText():validity.tooLong?this.formValidation.tooLong(maxLength,value.length):validity.tooShort?this.formValidation.tooShort(minLength,value.length):''}},{key:'validate',value:function validate(callback){this.formControl.validate(callback)}},{key:'handleFormControlRef',value:function handleFormControlRef(node){this.formControl=node}},{key:'handleValidate',value:function handleValidate(validity){var _ref2=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},callback=_ref2.callback,onlyValidateIfValid=_ref2.onlyValidateIfValid,_ref=arguments[2],updateValidationState=_ref.updateValidationState,value=_ref.value,_props2=this.props,onValidate=_props2.onValidate,validate=_props2.validate,passedDefaultValidation=validity.valid,defaultValidationMessage=this.getValidationMessage(validity),customValidationMessagePromise=Promise.resolve(validate?validate(value):''),update=function(valid,validationMessage){(!onlyValidateIfValid||onlyValidateIfValid&&valid)&&updateValidationState(valid,validationMessage,onValidate)};update(passedDefaultValidation,defaultValidationMessage),passedDefaultValidation?customValidationMessagePromise.then(function(customValidationMessage){var passedCustomValidation=!customValidationMessage;update(passedCustomValidation,customValidationMessage),callback&&callback(passedCustomValidation,customValidationMessage)}):callback&&callback(passedDefaultValidation,defaultValidationMessage)}},{key:'renderContent',value:function renderContent(_ref3){var defaultValue=_ref3.defaultValue,invalid=_ref3.invalid,handleBlur=_ref3.handleBlur,handleChange=_ref3.handleChange,handleNativeFormControlRef=_ref3.handleNativeFormControlRef,value=_ref3.value,_props3=this.props,className=_props3.className,disabled=_props3.disabled,fullWidth=_props3.fullWidth,inheritStyles=_props3.inheritStyles,labelledBy=_props3.labelledBy,nativeFormControlRefIgnored=_props3.nativeFormControlRef,onValidateIgnored=_props3.onValidate,placeholder=_props3.placeholder,readOnly=_props3.readOnly,required=_props3.required,rows=_props3.rows,secondary=_props3.secondary,size=_props3.size,themeProp=_props3.theme,otherProps=_objectWithoutProperties(_props3,['className','disabled','fullWidth','inheritStyles','labelledBy','nativeFormControlRef','onValidate','placeholder','readOnly','required','rows','secondary','size','theme']),theme=(0,_componentTheme2.default)(themeProp),conditionalProps={};return invalid&&(conditionalProps['aria-invalid']=!0),required&&(conditionalProps['aria-required']=!0),_react2.default.createElement(Styled.textarea,_extends({},otherProps,conditionalProps,{"aria-labelledby":labelledBy,className:className,defaultValue:defaultValue,disabled:disabled,innerRef:handleNativeFormControlRef,onBlur:handleBlur,onChange:handleChange,placeholder:placeholder,readOnly:readOnly,required:required,rows:rows,sc:{fullWidth:fullWidth,inheritStyles:inheritStyles,secondary:secondary,size:size},theme:theme,value:value}))}},{key:'render',value:function render(){var _props4=this.props,defaultValue=_props4.defaultValue,nativeFormControlRef=_props4.nativeFormControlRef,onBlur=_props4.onBlur,onChange=_props4.onChange,theme=_props4.theme,value=_props4.value;return _react2.default.createElement(_FormControl2.default,{defaultValue:defaultValue,nativeFormControlRef:nativeFormControlRef,onFormControlBlur:onBlur,onFormControlChange:onChange,onValidate:this.handleValidate,ref:this.handleFormControlRef,render:this.renderContent,theme:theme,value:value})}}]),TextAreaControl}(_react.PureComponent);TextAreaControl.propTypes={className:_propTypes2.default.string,defaultValue:function defaultValue(props,propName,componentName){if(props[propName]!==void 0){if(props.value!==void 0)throw new Error('Props `defaultValue` and `value` are both defined in `'+componentName+'`, but only one is allowed. Use `defaultValue` for an uncontrolled component, or `value` for a controlled component.');if('string'!=typeof props[propName]&&'number'!=typeof props[propName]&&null!==props[propName])return new Error('Invalid prop `'+propName+'` of type `'+_typeof(props[propName])+'` supplied to `'+componentName+'`, expected `string`, `number`, or a value of `null`.')}},disabled:_propTypes2.default.bool,fullWidth:_propTypes2.default.bool,inheritStyles:_propTypes2.default.bool,labelledBy:_propTypes2.default.string,maxLength:function maxLength(props,propName,componentName){if(props[propName]!==void 0&&'number'!=typeof props[propName])return new Error('Invalid prop `'+propName+'` of type `'+_typeof(props[propName])+'` supplied to `'+componentName+'`, expected `number`.')},minLength:function minLength(props,propName,componentName){if(props[propName]!==void 0&&'number'!=typeof props[propName])return new Error('Invalid prop `'+propName+'` of type `'+_typeof(props[propName])+'` supplied to `'+componentName+'`, expected `number`.')},nativeFormControlRef:_propTypes2.default.func,onBlur:_propTypes2.default.func,onChange:_propTypes2.default.func,onValidate:_propTypes2.default.func,placeholder:_propTypes2.default.string,readOnly:_propTypes2.default.bool,required:_propTypes2.default.bool,rows:_propTypes2.default.number,secondary:_propTypes2.default.bool,size:_propTypes2.default.oneOf(['small','medium','large']),theme:_propTypes3.themeShape,validate:_propTypes2.default.func,value:function value(props,propName,componentName){if(props[propName]!==void 0){if(props.defaultValue!==void 0)throw new Error('Props `defaultValue` and `value` are both defined in `'+componentName+'`, but only one is allowed. Use `defaultValue` for an uncontrolled component, or `value` for a controlled component.');if(void 0===props.onChange)throw new Error('Please add prop `onChange` to `'+componentName+'`. Prop `value` has been set, which makes this a controlled component.');if('string'!=typeof props[propName]&&'number'!=typeof props[propName]&&null!==props[propName])return new Error('Invalid prop `'+propName+'` of type `'+_typeof(props[propName])+'` supplied to `'+componentName+'`, expected `string`, `number`, or a value of `null`.')}}},TextAreaControl.defaultProps={rows:3,size:'medium',theme:(0,_themes.createTheme)(),validate:function validate(){return''}},TextAreaControl.displayName='TextAreaControl';var TextAreaControlWithTheme=(0,_themes.withTheme)(TextAreaControl);TextAreaControlWithTheme.WrappedComponent=TextAreaControl,exports.default=TextAreaControlWithTheme;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _themes=__webpack_require__(5),getBackgroundImage=function(color){var encodedColor=encodeURIComponent(color);return'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 14 14\'%3E%3Cpath fill=\''+encodedColor+'\' d=\'M8 6a1 1 0 1 1-2 0V4a1 1 0 1 1 2 0v2zm-1 5a1 1 0 1 1 0-2 1 1 0 1 1 0 2zM7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0z\' /%3E%3C/svg%3E%0A")'},componentTheme=function(baseTheme){var _baseTheme$vstui=baseTheme.vstui,color=_baseTheme$vstui.color,shape=_baseTheme$vstui.shape,size=_baseTheme$vstui.size,typography=_baseTheme$vstui.typography,cloud2=color.cloud.getShade(2),ninja11=color.ninja.getShade(11),black57='rgba(0, 0, 0, 0.57)',backgroundImage=getBackgroundImage(color.transparent),backgroundImage_invalid=getBackgroundImage(color.error),backgroundImage_invalidFocus=getBackgroundImage(color.error);return(0,_themes.createComponentTheme)(baseTheme,{TextAreaControl_width:'270px',InputControl_minHeight_small:size.small,InputControl_minHeight_medium:size.medium,InputControl_minHeight_large:size.large,TextAreaControl_backgroundColor:color.surface,TextAreaControl_backgroundColor_disabled:color.transparent,TextAreaControl_backgroundColor_readOnly:cloud2,TextAreaControl_backgroundImage:backgroundImage,TextAreaControl_backgroundImage_invalid:backgroundImage_invalid,TextAreaControl_backgroundImage_invalidFocus:backgroundImage_invalidFocus,TextAreaControl_backgroundPosition_small:'right 12px top '+(size.small-2-14)/2+'px',TextAreaControl_backgroundPosition_medium:'right 12px top '+(size.medium-2-14)/2+'px',TextAreaControl_backgroundPosition_large:'right 14px top '+(size.large-2-14)/2+'px',TextAreaControl_backgroundSize:'14px 14px',TextAreaControl_borderColor:'rgba(0, 0, 0, 0.43)',TextAreaControl_borderColor_focus:ninja11,TextAreaControl_borderColor_disabled:'rgba(0, 0, 0, 0.20)',TextAreaControl_borderColor_invalid:color.error,TextAreaControl_borderColor_invalidFocus:ninja11,TextAreaControl_borderStyle:shape.borderStyle,TextAreaControl_borderWidth:shape.borderWidth,TextAreaControl_borderRadius:shape.borderRadius,TextAreaControl_fontFamily:typography.fontFamily,TextAreaControl_fontSize_small:typography.fontSize,TextAreaControl_fontSize_medium:typography.fontSize,TextAreaControl_fontSize_large:typography.fontSize+2,TextAreaControl_fontWeight:typography.fontWeightRegular,TextAreaControl_color:color.onSurface,TextAreaControl_color_disabled:black57,TextAreaControl_color_readOnly:black57,TextAreaControl_boxShadow_focus:'0 0 0 1px '+ninja11,TextAreaControlPlaceholder_fontWeight:typography.fontWeightLight,TextAreaControlPlaceholder_color:black57})};exports.default=componentTheme;

/***/ }),
/* 641 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_common_HundredPercentContainer__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_common_MainSizer__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CookieBanner__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_MainSizerWithBanner_css__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_MainSizerWithBanner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_MainSizerWithBanner_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MainSizerWithBanner=function(_React$Component){_inherits(MainSizerWithBanner,_React$Component);function MainSizerWithBanner(){_classCallCheck(this,MainSizerWithBanner);return _possibleConstructorReturn(this,(MainSizerWithBanner.__proto__||Object.getPrototypeOf(MainSizerWithBanner)).apply(this,arguments));}_createClass(MainSizerWithBanner,[{key:'render',value:function render(){var _props=this.props,children=_props.children,sizerProps=_objectWithoutProperties(_props,['children']);if(sizerProps.minHeight){var intHeight=parseInt(sizerProps.minHeight.split('px').join(''),10);// Height also in this component's css for pseudo support
sizerProps.minHeight=intHeight+__WEBPACK_IMPORTED_MODULE_3__CookieBanner__["a" /* BANNER_HEIGHT */]+'px';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__core_common_HundredPercentContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__core_common_MainSizer__["a" /* default */],sizerProps,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MainSizerWithBanner__Content'},this.props.children),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__CookieBanner__["b" /* default */],null)));}}]);return MainSizerWithBanner;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (MainSizerWithBanner);

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BANNER_HEIGHT; });
/* unused harmony export CookieBannerTest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_CookieBanner_css__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_CookieBanner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_CookieBanner_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_ui_config_LocaleString__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_redux_watson_watson_config_selectors__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_api_redux_util_connect_enhancer__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_ui_config_SimpleThemer__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_common_Button__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_common_SimpleTextLink__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_cookies__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_redux_route_route_utils__ = __webpack_require__(362);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BANNER_HEIGHT=72;var CookieBanner=function(_React$Component){_inherits(CookieBanner,_React$Component);function CookieBanner(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CookieBanner);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CookieBanner.__proto__||Object.getPrototypeOf(CookieBanner)).call.apply(_ref,[this].concat(args))),_this),_this.state={showing:_this.props.enabled&&!Object(__WEBPACK_IMPORTED_MODULE_8__api_cookies__["c" /* cookiesAccepted */])()},_this.onAccept=function(){Object(__WEBPACK_IMPORTED_MODULE_8__api_cookies__["a" /* acceptCookies */])();_this.setState({showing:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CookieBanner,[{key:'render',value:function render(){var _this2=this;if(!this.state.showing){return null;}var linkStyles={color:'common.ErrorPageLink'};var buttonStyles={backgroundColor:'common.TextButton.default.base.bg',color:'common.TextButton.default.base.fg',hoverBackgroundColor:'common.TextButton.default.hover.bg',hoverColor:'common.TextButton.default.hover.fg'};if(Object(__WEBPACK_IMPORTED_MODULE_9__api_redux_route_route_utils__["c" /* isTeacherRoute */])(this.props.location.pathname)){linkStyles={color:'teacher.textLink'};buttonStyles={backgroundColor:'teacher.matchVstuiButton.default',hoverBackgroundColor:'teacher.matchVstuiButton.hover'};}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CookieBanner',role:'banner',style:{height:BANNER_HEIGHT}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_ui_config_LocaleString__["a" /* default */],{id:'common.cookie.info',params:{policyLink:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_ui_config_SimpleThemer__["a" /* default */],Object.assign({key:'link'},linkStyles,{render:function render(c){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__core_common_SimpleTextLink__["a" /* default */],{className:c,href:_this2.props.link},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_ui_config_LocaleString__["a" /* default */],{id:'common.cookie.cookiePolicy'}));}}))}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_ui_config_SimpleThemer__["a" /* default */],Object.assign({},buttonStyles,{render:function render(c){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__core_common_Button__["a" /* default */],{className:c,onClick:_this2.onAccept},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_app_ui_config_LocaleString__["a" /* default */],{id:'common.cookie.acceptAndClose'}));}})));}}]);return CookieBanner;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_4_app_api_redux_util_connect_enhancer__["a" /* default */])(function(state){return{link:Object(__WEBPACK_IMPORTED_MODULE_3__api_redux_watson_watson_config_selectors__["r" /* getString */])(state,'common.links.cookies'),enabled:Object(__WEBPACK_IMPORTED_MODULE_3__api_redux_watson_watson_config_selectors__["h" /* getBrandItem */])(state,'common.cookieBanner.enabled')};})(CookieBanner));var CookieBannerTest=CookieBanner;

/***/ }),
/* 644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports = {"domains":["vitalsource.com","vitalsource.co.uk","vitalbook.com"],"protocols":["http:","https:","vbk:"]}

/***/ }),
/* 647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_env__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_redux_route_routes__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteRenderer__ = __webpack_require__(56);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DevRoute=function(_React$Component){_inherits(DevRoute,_React$Component);function DevRoute(){_classCallCheck(this,DevRoute);return _possibleConstructorReturn(this,(DevRoute.__proto__||Object.getPrototypeOf(DevRoute)).apply(this,arguments));}_createClass(DevRoute,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RouteRenderer__["a" /* default */],Object.assign({redirectTo:__WEBPACK_IMPORTED_MODULE_2__api_redux_route_routes__["G" /* FILE_NOT_FOUND */],hasAccess:Object(__WEBPACK_IMPORTED_MODULE_1__utils_env__["c" /* isDevOrLocal */])()},this.props));}}]);return DevRoute;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (DevRoute);

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RouteRenderer__ = __webpack_require__(56);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SimpleRoute=function(_React$Component){_inherits(SimpleRoute,_React$Component);function SimpleRoute(){_classCallCheck(this,SimpleRoute);return _possibleConstructorReturn(this,(SimpleRoute.__proto__||Object.getPrototypeOf(SimpleRoute)).apply(this,arguments));}_createClass(SimpleRoute,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RouteRenderer__["a" /* default */],Object.assign({hasAccess:true},this.props));}}]);return SimpleRoute;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (SimpleRoute);

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PrivateRoute__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_redux_bridge_session_selectors__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_redux_route_routes__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PrivateContentRenderer__ = __webpack_require__(83);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TeacherRoute=function(_React$Component){_inherits(TeacherRoute,_React$Component);function TeacherRoute(){_classCallCheck(this,TeacherRoute);return _possibleConstructorReturn(this,(TeacherRoute.__proto__||Object.getPrototypeOf(TeacherRoute)).apply(this,arguments));}_createClass(TeacherRoute,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PrivateRoute__["a" /* default */],{path:this.props.path,exact:this.props.exact,render:function render(routeProps){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__PrivateContentRenderer__["a" /* default */],{hasAccess:_this2.props.teacher,redirectTo:__WEBPACK_IMPORTED_MODULE_4__api_redux_route_routes__["G" /* FILE_NOT_FOUND */],render:_this2.props.render,component:_this2.props.component,innerProps:routeProps});}});}}]);return TeacherRoute;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){return{teacher:Object(__WEBPACK_IMPORTED_MODULE_3__api_redux_bridge_session_selectors__["i" /* isTeacher */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(TeacherRoute));

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_route__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CookieRoute__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_redux_route_routes__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PrivateContentRenderer__ = __webpack_require__(83);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var hasTokenVar=Object(__WEBPACK_IMPORTED_MODULE_1__utils_route__["f" /* getQueryValue */])('token');var TokenRoute=function(_React$Component){_inherits(TokenRoute,_React$Component);function TokenRoute(){_classCallCheck(this,TokenRoute);return _possibleConstructorReturn(this,(TokenRoute.__proto__||Object.getPrototypeOf(TokenRoute)).apply(this,arguments));}_createClass(TokenRoute,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CookieRoute__["a" /* default */],{path:this.props.path,exact:this.props.exact,render:function render(routeProps){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__PrivateContentRenderer__["a" /* default */],{hasAccess:hasTokenVar,redirectTo:__WEBPACK_IMPORTED_MODULE_3__api_redux_route_routes__["G" /* FILE_NOT_FOUND */],render:_this2.props.render,component:_this2.props.component,innerProps:routeProps});}});}}]);return TokenRoute;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (TokenRoute);

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LoginRedirectTest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_util_connect_enhancer__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_redux_jigsaw_jigsaw_action__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__route_RedirectOnce__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_redux_route_routes__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoginRedirect=function(_React$Component){_inherits(LoginRedirect,_React$Component);function LoginRedirect(){_classCallCheck(this,LoginRedirect);return _possibleConstructorReturn(this,(LoginRedirect.__proto__||Object.getPrototypeOf(LoginRedirect)).apply(this,arguments));}_createClass(LoginRedirect,[{key:'componentDidMount',value:function componentDidMount(){this.props.setLastBrand();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__route_RedirectOnce__["a" /* default */],{to:__WEBPACK_IMPORTED_MODULE_4__api_redux_route_routes__["A" /* DEFAULT */]});}}]);return LoginRedirect;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setLastBrand:function setLastBrand(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__api_redux_jigsaw_jigsaw_action__["z" /* setLastBrandAccessed */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_util_connect_enhancer__["a" /* default */])(null,mapDispatchToProps)(LoginRedirect));var LoginRedirectTest=LoginRedirect;

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SystemError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ErrorPageTemplate__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_ui_bo_BoBroken__ = __webpack_require__(206);
function SystemError(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ErrorPageTemplate__["a" /* default */],{disableLogoLink:true,bo:__WEBPACK_IMPORTED_MODULE_2_app_ui_bo_BoBroken__["a" /* default */],messageIds:['common.errorPages.systemError1','common.errorPages.systemError2']});}

/***/ }),
/* 654 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 655 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_ui_route_RedirectOffSite__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_api_redux_watson_watson_config_selectors__ = __webpack_require__(4);
function ForwardToBookshelf(_ref){var bookshelfUrl=_ref.bookshelfUrl,_ref$location=_ref.location,pathname=_ref$location.pathname,search=_ref$location.search;var url=bookshelfUrl+'/'+pathname+search;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_app_ui_route_RedirectOffSite__["a" /* default */],{to:url,params:{sso:true,newWin:false}});}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{bookshelfUrl:Object(__WEBPACK_IMPORTED_MODULE_3_app_api_redux_watson_watson_config_selectors__["d" /* getBookshelfUrl */])(state)};})(ForwardToBookshelf));

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createFeenyAction;
function createFeenyAction(apiCall){return function(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return{feeny:{apiCall:apiCall,args:args}};};}

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CSSFeatures;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_browser__ = __webpack_require__(61);
function CSSFeatures(_ref){var children=_ref.children;function getClasses(){var classes=['CSSFeatures'];if(Object(__WEBPACK_IMPORTED_MODULE_1__utils_browser__["g" /* isTouchDevice */])()){classes.push('CSSFeatures--Touch');}if(Object(__WEBPACK_IMPORTED_MODULE_1__utils_browser__["i" /* supportsSvgCssAnimation */])()){classes.push('CSSFeatures--SvgCssAnimation');}return classes.join(' ');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:getClasses()},children);}

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_analytics_google__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_redux_watson_watson_config_selectors__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_api_analytics_reporting__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClickTracker=function(_React$Component){_inherits(ClickTracker,_React$Component);function ClickTracker(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClickTracker);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClickTracker.__proto__||Object.getPrototypeOf(ClickTracker)).call.apply(_ref,[this].concat(args))),_this),_this.boundClickHandler=_this.clickHandler.bind(_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClickTracker,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('click',this.boundClickHandler,true);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('click',this.boundClickHandler,true);}},{key:'clickHandler',value:function clickHandler(e){try{var el=Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["c" /* findNearestElementMatchingTags */])(e.target,['a','button']);if(el&&!el.disabled){var msgEl=el.querySelector('[data-msg-id]');var msg=void 0;if(msgEl){msg=msgEl.getAttribute('data-msg-id');}var category=el.getAttribute('data-ga-category')||'clicks';var action=el.getAttribute('data-ga-action')||msg;var label=el.getAttribute('data-ga-label');var value=el.getAttribute('data-ga-value');Object(__WEBPACK_IMPORTED_MODULE_2__api_analytics_google__["b" /* trackEvent */])(category+'/'+(this.props.uiBase||'unknown'),action,label,value);}}catch(e){Object(__WEBPACK_IMPORTED_MODULE_5_app_api_analytics_reporting__["b" /* noticeError */])(e);}}},{key:'render',value:function render(){return null;}}]);return ClickTracker;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){return{uiBase:Object(__WEBPACK_IMPORTED_MODULE_4__api_redux_watson_watson_config_selectors__["z" /* getUiBase */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(ClickTracker));

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_analytics_google__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_redux_watson_watson_config_selectors__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AnalyticsInit=function(_React$Component){_inherits(AnalyticsInit,_React$Component);function AnalyticsInit(){_classCallCheck(this,AnalyticsInit);return _possibleConstructorReturn(this,(AnalyticsInit.__proto__||Object.getPrototypeOf(AnalyticsInit)).apply(this,arguments));}_createClass(AnalyticsInit,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_1__api_analytics_google__["a" /* init */])(this.props.trackingCode);}},{key:'render',value:function render(){return null;}}]);return AnalyticsInit;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){return{trackingCode:Object(__WEBPACK_IMPORTED_MODULE_3__api_redux_watson_watson_config_selectors__["f" /* getBrandCommon */])(state).gaTrackingCode};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(AnalyticsInit));

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_analytics_google__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HistoryTracker=function(_React$Component){_inherits(HistoryTracker,_React$Component);function HistoryTracker(){_classCallCheck(this,HistoryTracker);return _possibleConstructorReturn(this,(HistoryTracker.__proto__||Object.getPrototypeOf(HistoryTracker)).apply(this,arguments));}_createClass(HistoryTracker,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_1__api_analytics_google__["c" /* trackPageView */])(this.props.location.pathname);}},{key:'UNSAFE_componentWillReceiveProps',value:function UNSAFE_componentWillReceiveProps(nextProps){if(nextProps.location.pathname!==this.props.location.pathname){Object(__WEBPACK_IMPORTED_MODULE_1__api_analytics_google__["c" /* trackPageView */])(nextProps.location.pathname);}}},{key:'render',value:function render(){return null;}}]);return HistoryTracker;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["h" /* withRouter */])(HistoryTracker));

/***/ }),
/* 662 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = initAppData;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOADING; });
/* unused harmony export SUCCESS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ERROR; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getAppInitStatus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_api_analytics_reporting__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__watson_config_action__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_bridge_session_actions__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__watson_config_selectors__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_dev_dev_actions__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_known_classes_known_class_actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_jigsaw_jigsaw_action__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_bridgesaw_bridgesaw_selectors__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_api_redux_ui_common_onboarding_actions__ = __webpack_require__(66);
function hasExternalScriptError(){return window.jigsawLoadError||window.bridgeLoadError;}function initAppData(){return function(dispatch){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__redux_dev_dev_actions__["e" /* tryLoadProdServices */])()).then(function(){return dispatch(initData());});};}function initData(){return function(dispatch){if(hasExternalScriptError()){Object(__WEBPACK_IMPORTED_MODULE_0_app_api_analytics_reporting__["b" /* noticeError */])(window.bridgeLoadError?'Bridge Load Error':'Jigsaw Load Error');dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__watson_config_action__["e" /* loadBrand */])()).then(function(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__watson_config_action__["f" /* loadLocaleAndTheme */])());});}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__redux_known_classes_known_class_actions__["e" /* removeExpiredClasses */])());// Config setup depends on the user's grade level, which comes from the session.
// However, there is some brand info we need in order to fetch the session. So
// let's do a minimal brand setup, get the session, then load everything else.
dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__watson_config_action__["e" /* loadBrand */])()).then(function(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_jigsaw_jigsaw_action__["y" /* setJigsawHost */])());}).then(function(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_bridge_session_actions__["a" /* getSession */])());}).then(function(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_jigsaw_jigsaw_action__["l" /* getUserInfo */])());})// Onboarding needs user info. Load before locale so we're sure it's done before content loads.
.then(function(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_app_api_redux_ui_common_onboarding_actions__["c" /* tryResetOnboarding */])());}).then(function(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__watson_config_action__["f" /* loadLocaleAndTheme */])());});}};}var LOADING='LOADING';var SUCCESS='SUCCESS';var ERROR='ERROR';function getAppInitStatus(state){var cfgLoaded=Object(__WEBPACK_IMPORTED_MODULE_3__watson_config_selectors__["B" /* isConfigLoaded */])(state);var userLoading=Object(__WEBPACK_IMPORTED_MODULE_7__redux_bridgesaw_bridgesaw_selectors__["c" /* isSessionPending */])(state);var scriptError=hasExternalScriptError();var cfgOk=Object(__WEBPACK_IMPORTED_MODULE_3__watson_config_selectors__["C" /* isConfigOk */])(state);if(!cfgLoaded){return LOADING;}if(cfgOk){if(scriptError){return ERROR;}else if(userLoading){return LOADING;}return SUCCESS;}else{return ERROR;}}

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_DevTools_css__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_DevTools_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_DevTools_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_ui_core_common_Button__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_api_redux_dev_dev_actions__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_ui_core_common_UnsafeHtml__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_api_redux_dev_dev_selectors__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_api_redux_route_routes__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_ui_config_SelectUIBase__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_utils_route__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_api_redux_watson_watson_config_selectors__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_api_redux_ui_common_onboarding_actions__ = __webpack_require__(66);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LETTER_D=68;function DevButton(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_ui_core_common_Button__["a" /* default */],Object.assign({className:'DevTools__Button'},props));}var DevTools=function(_React$Component){_inherits(DevTools,_React$Component);function DevTools(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DevTools);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DevTools.__proto__||Object.getPrototypeOf(DevTools)).call.apply(_ref,[this].concat(args))),_this),_this.state={showing:false},_this.boundKeyHandler=_this.keyEvent.bind(_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DevTools,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('keyup',this.boundKeyHandler);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('keyup',this.boundKeyHandler);}},{key:'keyEvent',value:function keyEvent(e){if(e.keyCode===LETTER_D&&e.altKey){this.setState({showing:true});}}},{key:'close',value:function close(){this.setState({showing:false});}},{key:'handle',value:function handle(fn){fn();this.close();}},{key:'reload',value:function reload(uiBase){Object(__WEBPACK_IMPORTED_MODULE_9_app_utils_route__["g" /* reloadWithParams */])({uiBase:uiBase});}},{key:'render',value:function render(){var _this2=this;if(this.state.showing){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DevTools'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DevTools__Inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_ui_core_common_Button__["a" /* default */],{className:'DevTools__CloseButton',onClick:function onClick(){return _this2.close();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_app_ui_core_common_UnsafeHtml__["a" /* default */],null,'\xD7')),Object(__WEBPACK_IMPORTED_MODULE_6_app_api_redux_dev_dev_selectors__["c" /* pointingToProd */])()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DevButton,{onClick:this.props.pointToDev},'Point to Dev'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DevButton,{onClick:this.props.pointToProd},'Point to Prod'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DevButton,{onClick:function onClick(){return _this2.handle(_this2.props.resetOnboarding);}},'Reset Onboarding'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DevButton,{onClick:function onClick(){return _this2.handle(_this2.props.toggleStringDebug);}},'Toggle Emojification'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DevButton,{onClick:function onClick(){return _this2.handle(_this2.props.toggleAssetStatus);}},'Toggle Asset Active/Inactive Flags'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DevButton,{to:__WEBPACK_IMPORTED_MODULE_7_app_api_redux_route_routes__["B" /* DEV_BRAND */]},'View Brand Data (',this.props.brandId,'/',this.props.uiBase,')'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DevButton,{to:__WEBPACK_IMPORTED_MODULE_7_app_api_redux_route_routes__["E" /* DEV_THEME */]},'View Theme Data (',this.props.uiBase,'/',this.props.themeId,')'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DevButton,{to:__WEBPACK_IMPORTED_MODULE_7_app_api_redux_route_routes__["D" /* DEV_LOCALE */]},'View Locale Data (',this.props.uiBase,'/',this.props.localeId,')'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_app_ui_config_SelectUIBase__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DevButton,{onClick:function onClick(){return _this2.reload('middle');}},'Switch to Tween/Middle'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DevButton,{onClick:function onClick(){return _this2.reload('kiddie');}},'Switch to Kiddie'))));}if(Object(__WEBPACK_IMPORTED_MODULE_6_app_api_redux_dev_dev_selectors__["c" /* pointingToProd */])()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DevTools__PointingToProd'},'Running in Production Environment',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_app_ui_core_common_Button__["a" /* default */],{className:'DevTools__PointingToProdButton',onClick:this.props.pointToDev},'Reset'));}return null;}}]);return DevTools;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){return{brandId:Object(__WEBPACK_IMPORTED_MODULE_10_app_api_redux_watson_watson_config_selectors__["g" /* getBrandId */])(state),localeId:Object(__WEBPACK_IMPORTED_MODULE_10_app_api_redux_watson_watson_config_selectors__["n" /* getLocaleId */])(state),themeId:Object(__WEBPACK_IMPORTED_MODULE_10_app_api_redux_watson_watson_config_selectors__["y" /* getThemeId */])(state),uiBase:Object(__WEBPACK_IMPORTED_MODULE_10_app_api_redux_watson_watson_config_selectors__["z" /* getUiBase */])(state)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{toggleStringDebug:function toggleStringDebug(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_app_api_redux_dev_dev_actions__["d" /* toggleStringDebug */])());},pointToDev:function pointToDev(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_app_api_redux_dev_dev_actions__["a" /* pointToDev */])());},pointToProd:function pointToProd(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_app_api_redux_dev_dev_actions__["b" /* pointToProd */])());},resetOnboarding:function resetOnboarding(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_app_api_redux_ui_common_onboarding_actions__["b" /* reset */])());},toggleAssetStatus:function toggleAssetStatus(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_app_api_redux_dev_dev_actions__["c" /* toggleAssetStatus */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(DevTools));

/***/ }),
/* 665 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_redux_watson_watson_config_selectors__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DocLang=function(_React$Component){_inherits(DocLang,_React$Component);function DocLang(){_classCallCheck(this,DocLang);return _possibleConstructorReturn(this,(DocLang.__proto__||Object.getPrototypeOf(DocLang)).apply(this,arguments));}_createClass(DocLang,[{key:'componentDidMount',value:function componentDidMount(){this.updateLang();}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.updateLang();}},{key:'updateLang',value:function updateLang(){var el=document.getElementsByTagName('html')[0];var code=this.props.lang.split('-')[0];el.setAttribute('lang',code);}},{key:'render',value:function render(){return null;}}]);return DocLang;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{lang:Object(__WEBPACK_IMPORTED_MODULE_2__api_redux_watson_watson_config_selectors__["n" /* getLocaleId */])(state)};})(DocLang));

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_api_analytics_reporting__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_api_redux_jigsaw_user_info_selectors__ = __webpack_require__(80);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReporterContext=function(_React$Component){_inherits(ReporterContext,_React$Component);function ReporterContext(){_classCallCheck(this,ReporterContext);return _possibleConstructorReturn(this,(ReporterContext.__proto__||Object.getPrototypeOf(ReporterContext)).apply(this,arguments));}_createClass(ReporterContext,[{key:'componentDidMount',value:function componentDidMount(){this.updateContext();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState,snapshot){if(this.props.jigsawUser!==prevProps.jigsawUser){this.updateContext();}}},{key:'updateContext',value:function updateContext(){Object(__WEBPACK_IMPORTED_MODULE_2_app_api_analytics_reporting__["c" /* setUser */])(this.props.jigsawUser);}},{key:'render',value:function render(){return null;}}]);return ReporterContext;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){return{jigsawUser:Object(__WEBPACK_IMPORTED_MODULE_3_app_api_redux_jigsaw_user_info_selectors__["a" /* getUserProfile */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(ReporterContext));

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PersistGate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

 // eslint-disable-line import/no-unresolved
// eslint-disable-line import/no-unresolved


var PersistGate = function (_PureComponent) {
  _inherits(PersistGate, _PureComponent);

  function PersistGate() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PersistGate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PersistGate.__proto__ || Object.getPrototypeOf(PersistGate)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      bootstrapped: false
    }, _this.handlePersistorState = function () {
      var persistor = _this.props.persistor;

      var _persistor$getState = persistor.getState(),
          bootstrapped = _persistor$getState.bootstrapped;

      if (bootstrapped) {
        if (_this.props.onBeforeLift) {
          Promise.resolve(_this.props.onBeforeLift()).then(function () {
            return _this.setState({ bootstrapped: true });
          }).catch(function () {
            return _this.setState({ bootstrapped: true });
          });
        } else {
          _this.setState({ bootstrapped: true });
        }
        _this._unsubscribe && _this._unsubscribe();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PersistGate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
      this.handlePersistorState();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._unsubscribe && this._unsubscribe();
    }
  }, {
    key: 'render',
    value: function render() {
      if (false) {
        if (typeof this.props.children === 'function' && this.props.loading) console.error('redux-persist: PersistGate expects either a function child or loading prop, but not both. The loading prop will be ignored.');
      }
      if (typeof this.props.children === 'function') {
        return this.props.children(this.state.bootstrapped);
      }

      return this.state.bootstrapped ? this.props.children : this.props.loading;
    }
  }]);

  return PersistGate;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
PersistGate.defaultProps = {
  loading: null
};

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return store; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return persistor; });
/* unused harmony export makeTestStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_middleware__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_api_redux_bridge_bridge_middleware__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_api_redux_feeny_middleware__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_api_reducer__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_thunk__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_utils_env__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_persist__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_persist_lib_storage__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_persist_lib_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_redux_persist_lib_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__migrations__ = __webpack_require__(738);
var composeEnhancers=__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* compose */];if(Object(__WEBPACK_IMPORTED_MODULE_6_app_utils_env__["c" /* isDevOrLocal */])()){// eslint-disable-next-line no-underscore-dangle
composeEnhancers=window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__||__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* compose */];}var persistConfig={key:'root',storage:__WEBPACK_IMPORTED_MODULE_8_redux_persist_lib_storage___default.a,whitelist:['knownClasses'],version:0,migrate:__WEBPACK_IMPORTED_MODULE_9__migrations__["a" /* default */]};var persistedReducer=Object(__WEBPACK_IMPORTED_MODULE_7_redux_persist__["b" /* persistReducer */])(persistConfig,__WEBPACK_IMPORTED_MODULE_4_app_api_reducer__["a" /* default */]);var middlewares=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_5_redux_thunk__["a" /* default */],__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_middleware__["a" /* default */],__WEBPACK_IMPORTED_MODULE_2_app_api_redux_bridge_bridge_middleware__["a" /* default */],__WEBPACK_IMPORTED_MODULE_3_app_api_redux_feeny_middleware__["a" /* default */]);var store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(persistedReducer,{},composeEnhancers(middlewares));var persistor=Object(__WEBPACK_IMPORTED_MODULE_7_redux_persist__["c" /* persistStore */])(store);function makeTestStore(){var preloadedState=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(__WEBPACK_IMPORTED_MODULE_4_app_api_reducer__["a" /* default */],preloadedState,middlewares);}

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jigsaw_events__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jigsaw_action__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jigsaw_auto_triggers__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jigsaw_proxy__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_route_route_actions__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__jigsaw_helpers__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_func__ = __webpack_require__(70);
function getCallback(store,apiCall,args,resolve){return Object(__WEBPACK_IMPORTED_MODULE_8__utils_func__["c" /* once */])(function(response){if(response.isSuccess()){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["g" /* createSuccessAction */])(apiCall,response.data,args));var autoTriggers=__WEBPACK_IMPORTED_MODULE_4__jigsaw_auto_triggers__["b" /* methods */][apiCall];if(autoTriggers){autoTriggers.forEach(function(t){return store.dispatch(t);});}resolve({success:true});}else{var normalizedError=Object(__WEBPACK_IMPORTED_MODULE_7__jigsaw_helpers__["d" /* getErrorContent */])(response);store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["c" /* createFailAction */])(apiCall,normalizedError,args));store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__redux_route_route_actions__["c" /* tryRedirectJigsawFailure */])(normalizedError,apiCall));resolve({success:false});}});}function getViewer(){return window.watsonViewer;}function setViewer(viewer){window.watsonViewer=viewer;}function tryCleanUpOldPageViewer(apiCall){if(apiCall===__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["i" /* DESTROY */]&&getViewer()){setViewer(null);}}function trySetUpNewPageViewer(apiCall,result,dispatch){if(apiCall===__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["c" /* CREATE_PAGE_VIEWER */]){setViewer(result);Object.keys(__WEBPACK_IMPORTED_MODULE_2__jigsaw_events__).forEach(function(name){var eventName=__WEBPACK_IMPORTED_MODULE_2__jigsaw_events__[name];getViewer().bind(eventName,function(event,data){var myEvent=Object(__WEBPACK_IMPORTED_MODULE_3__jigsaw_action__["a" /* createJigsawEventAction */])(eventName);dispatch(myEvent(data));var toRun=__WEBPACK_IMPORTED_MODULE_4__jigsaw_auto_triggers__["a" /* events */][eventName];if(toRun){toRun.forEach(function(f){return dispatch(f);});}});});}}/* harmony default export */ __webpack_exports__["a"] = (function(store){return function(next){return function(action){if(!action.jigsaw){// Normal action: pass it on
return next(action);}if(action.jigsaw.apiCall){return new Promise(function(resolve){var apiCall=action.jigsaw.apiCall;var apiContext=action.jigsaw.targetReader?getViewer():window;tryCleanUpOldPageViewer(apiCall);store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["f" /* createStartAction */])(apiCall,action.jigsaw.args));var apiResult=Object(__WEBPACK_IMPORTED_MODULE_5__jigsaw_proxy__["a" /* callApiByName */])(apiCall,apiContext,action.jigsaw.args,getCallback(store,apiCall,action.jigsaw.args,resolve));trySetUpNewPageViewer(apiCall,apiResult,store.dispatch);});}// This resolves because in a redux context we can end up with lots
// of uncaught in promise exceptions there's not a great way to handle,
// since rejections are ok and handled through redux
return Promise.resolve({success:false});};};});

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return events; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return methods; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jigsaw_events__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jigsaw_action__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jigsaw_methods__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_route_route_actions__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_ui_common_reader_actions__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_api_redux_jigsaw_userdata_highlights_actions__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_api_redux_jigsaw_userdata_bookmarks_actions__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_api_redux_jigsaw_userdata_notes_actions__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_api_redux_jigsaw_ancillaries_actions__ = __webpack_require__(672);
var _events,_methods;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var events=(_events={},_defineProperty(_events,__WEBPACK_IMPORTED_MODULE_0__jigsaw_events__["PAGE_READY"],[__WEBPACK_IMPORTED_MODULE_1__jigsaw_action__["p" /* hasNextPage */](),__WEBPACK_IMPORTED_MODULE_1__jigsaw_action__["q" /* hasPrevPage */](),Object(__WEBPACK_IMPORTED_MODULE_4__redux_ui_common_reader_actions__["a" /* refreshZoom */])()]),_defineProperty(_events,__WEBPACK_IMPORTED_MODULE_0__jigsaw_events__["USER_SIGNOUT"],[Object(__WEBPACK_IMPORTED_MODULE_3__redux_route_route_actions__["a" /* afterLogOut */])()]),_events);var methods=(_methods={},_defineProperty(_methods,__WEBPACK_IMPORTED_MODULE_2__jigsaw_methods__["c" /* CREATE_PAGE_VIEWER */],[__WEBPACK_IMPORTED_MODULE_1__jigsaw_action__["k" /* getToc */](),Object(__WEBPACK_IMPORTED_MODULE_6_app_api_redux_jigsaw_userdata_bookmarks_actions__["b" /* getBookmarks */])(),Object(__WEBPACK_IMPORTED_MODULE_7_app_api_redux_jigsaw_userdata_notes_actions__["c" /* getNotes */])(),Object(__WEBPACK_IMPORTED_MODULE_5_app_api_redux_jigsaw_userdata_highlights_actions__["b" /* getHighlights */])(),__WEBPACK_IMPORTED_MODULE_1__jigsaw_action__["j" /* getThumbnails */](),Object(__WEBPACK_IMPORTED_MODULE_4__redux_ui_common_reader_actions__["f" /* updateScrolling */])(),__WEBPACK_IMPORTED_MODULE_1__jigsaw_action__["h" /* getCitation */](),__WEBPACK_IMPORTED_MODULE_1__jigsaw_action__["i" /* getPageBreaks */](),Object(__WEBPACK_IMPORTED_MODULE_8_app_api_redux_jigsaw_ancillaries_actions__["a" /* tryGetAncillaries */])()]),_defineProperty(_methods,__WEBPACK_IMPORTED_MODULE_2__jigsaw_methods__["Q" /* SET_ZOOM_SCALE */],[Object(__WEBPACK_IMPORTED_MODULE_4__redux_ui_common_reader_actions__["f" /* updateScrolling */])()]),_defineProperty(_methods,__WEBPACK_IMPORTED_MODULE_2__jigsaw_methods__["H" /* INCREASE_ZOOM */],[Object(__WEBPACK_IMPORTED_MODULE_4__redux_ui_common_reader_actions__["f" /* updateScrolling */])()]),_defineProperty(_methods,__WEBPACK_IMPORTED_MODULE_2__jigsaw_methods__["e" /* DECREASE_ZOOM */],[Object(__WEBPACK_IMPORTED_MODULE_4__redux_ui_common_reader_actions__["f" /* updateScrolling */])()]),_methods);

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = tryGetAncillaries;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_api_redux_jigsaw_jigsaw_action__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_methods__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_api_redux_jigsaw_jigsaw_selectors__ = __webpack_require__(30);
var getAncillaries=Object(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_jigsaw_jigsaw_action__["b" /* createJigsawReaderAction */])(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_methods__["l" /* GET_ANCILLARIES */]);function tryGetAncillaries(){return function(dispatch,getState){if(Object(__WEBPACK_IMPORTED_MODULE_2_app_api_redux_jigsaw_jigsaw_selectors__["c" /* currentBookHasAncillaries */])(getState())){dispatch(getAncillaries());}};}

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bridge_proxy__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_route_route_actions__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bridge_auto_triggers__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_watson_watson_config_selectors__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bridge_method_remap__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_utils_objects__ = __webpack_require__(15);
// Bridge has an outstanding task to change these from strings to numbers
function cleanUpResponse(response){if(typeof response.offset==='string'){response.offset=parseInt(response.offset,10);}if(typeof response.limit==='string'){response.limit=parseInt(response.limit,10);}}/**
 * Load more pages without extra intervention from the UI
 */function tryLoadAnotherPage(response,action,store){if(!response.last&&typeof action.bridge.pagesAfterThis==='number'&&action.bridge.pagesAfterThis!==0){var newAction=Object(__WEBPACK_IMPORTED_MODULE_6_app_utils_objects__["a" /* deepClone */])(action);var args=newAction.bridge.args[0];args.offset=args.offset+args.limit;if(action.bridge.pagesAfterThis!==-1){newAction.bridge.pagesAfterThis=action.bridge.pagesAfterThis-1;}store.dispatch(newAction);}}function runAutoTriggers(apiId,store){var autoTriggers=__WEBPACK_IMPORTED_MODULE_3__bridge_auto_triggers__["a" /* methods */][apiId];if(autoTriggers){autoTriggers.forEach(function(t){return store.dispatch(t);});}}/* harmony default export */ __webpack_exports__["a"] = (function(store){return function(next){return function(action){if(!action.bridge){// Normal action: pass it on
return next(action);}if(action.bridge.apiCall){var apiId=action.bridge.apiCall;var apiMethod=Object(__WEBPACK_IMPORTED_MODULE_5__bridge_method_remap__["k" /* getBaseMethod */])(apiId);store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["f" /* createStartAction */])(apiId,action.bridge.args));return new Promise(function(resolve){Object(__WEBPACK_IMPORTED_MODULE_1__bridge_proxy__["a" /* callApiByName */])(apiMethod,window,action.bridge.args,Object(__WEBPACK_IMPORTED_MODULE_4__redux_watson_watson_config_selectors__["j" /* getComputedBridgeBrand */])(store.getState())).then(function(response){cleanUpResponse(response);store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["g" /* createSuccessAction */])(apiId,response,action.bridge.args));runAutoTriggers(apiId,store);tryLoadAnotherPage(response,action,store);resolve({success:true});},function(response){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["c" /* createFailAction */])(apiId,response,action.bridge.args));store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_route_route_actions__["b" /* tryRedirectBridgeFailure */])(response,apiId));// This resolves because in a redux context we can end up with lots
// of uncaught in promise exceptions there's not a great way to handle,
// since rejections are ok and handled through redux
resolve({success:false});});});}};};});

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return methods; });
/* unused harmony export tryAddRosterToLocalStorage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bridge_methods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__roster_selectors__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_known_classes_known_class_actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_route_route_actions__ = __webpack_require__(41);
var _methods;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var methods=(_methods={},_defineProperty(_methods,__WEBPACK_IMPORTED_MODULE_0__bridge_methods__["g" /* GET_ROSTER */],[tryAddRosterToLocalStorage()]),_defineProperty(_methods,__WEBPACK_IMPORTED_MODULE_0__bridge_methods__["q" /* LOG_OUT */],[Object(__WEBPACK_IMPORTED_MODULE_3__redux_route_route_actions__["a" /* afterLogOut */])()]),_methods);function tryAddRosterToLocalStorage(){return function(dispatch,getState){var roster=Object(__WEBPACK_IMPORTED_MODULE_1__roster_selectors__["b" /* getRosterData */])(getState());dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__redux_known_classes_known_class_actions__["c" /* addOrUpdateClass */])(roster.code,roster.name));};}

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resetInit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_api_redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_feeny_proxy__ = __webpack_require__(676);
var feenyInitPromise=null;// For tests
function resetInit(){feenyInitPromise=null;}/* harmony default export */ __webpack_exports__["a"] = (function(store){return function(next){return function(action){if(!action.feeny){// Normal action: pass it on
return next(action);}var apiCall=action.feeny.apiCall;var args=action.feeny.args;if(apiCall){if(window.feenyLoadError){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_util_async_helpers__["f" /* createStartAction */])(apiCall,args));store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_util_async_helpers__["c" /* createFailAction */])(apiCall,{},args));return Promise.resolve();}if(!feenyInitPromise){feenyInitPromise=window.Feeny.init();}store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_util_async_helpers__["f" /* createStartAction */])(apiCall,args));return feenyInitPromise.then(function(){return Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_feeny_proxy__["a" /* callApiByName */])(apiCall,args);}).then(function(response){return store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_util_async_helpers__["g" /* createSuccessAction */])(apiCall,response,args));}).catch(function(e){return store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_util_async_helpers__["c" /* createFailAction */])(apiCall,e,args));});}return Promise.resolve();};};});

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = callApiByName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_utils_objects__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_analytics_reporting__ = __webpack_require__(14);
function callApiByName(methodStr,params){var apiFunc=Object(__WEBPACK_IMPORTED_MODULE_0_app_utils_objects__["b" /* findKeyInObj */])(window,methodStr);var apiContext=Object(__WEBPACK_IMPORTED_MODULE_0_app_utils_objects__["c" /* findKeyParentInObj */])(window,methodStr);if(apiFunc&&apiContext){return apiFunc.apply(apiContext,params);}Object(__WEBPACK_IMPORTED_MODULE_1_app_api_analytics_reporting__["b" /* noticeError */])('Feeny API method not found: '+methodStr);return Promise.reject();}

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_ui_reducer__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_jigsaw_jigsaw_reducer__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_dev_dev_reducer__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_watson_watson_reducer__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_bridge_bridge_reducer__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_known_classes_known_class_reducer__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_feeny_reducer__ = __webpack_require__(734);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({config:__WEBPACK_IMPORTED_MODULE_4__redux_watson_watson_reducer__["a" /* default */],ui:__WEBPACK_IMPORTED_MODULE_1__redux_ui_reducer__["a" /* default */],jigsaw:__WEBPACK_IMPORTED_MODULE_2__redux_jigsaw_jigsaw_reducer__["a" /* default */],bridge:__WEBPACK_IMPORTED_MODULE_5__redux_bridge_bridge_reducer__["a" /* default */],dev:__WEBPACK_IMPORTED_MODULE_3__redux_dev_dev_reducer__["a" /* default */],knownClasses:__WEBPACK_IMPORTED_MODULE_6__redux_known_classes_known_class_reducer__["a" /* default */],feeny:__WEBPACK_IMPORTED_MODULE_7__redux_feeny_reducer__["a" /* default */]}));

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_reducer__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__middle_middle_reducer__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__kiddie_kiddie_reducer__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__teacher_reducer__ = __webpack_require__(693);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({common:__WEBPACK_IMPORTED_MODULE_1__common_reducer__["a" /* default */],middle:__WEBPACK_IMPORTED_MODULE_2__middle_middle_reducer__["a" /* default */],kiddie:__WEBPACK_IMPORTED_MODULE_3__kiddie_kiddie_reducer__["a" /* default */],teacher:__WEBPACK_IMPORTED_MODULE_4__teacher_reducer__["a" /* default */]}));

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reader_reducer__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__library_reducer__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__onboarding_reducer__ = __webpack_require__(682);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux__["c" /* combineReducers */])({reader:__WEBPACK_IMPORTED_MODULE_0__reader_reducer__["a" /* default */],library:__WEBPACK_IMPORTED_MODULE_1__library_reducer__["a" /* default */],onboarding:__WEBPACK_IMPORTED_MODULE_3__onboarding_reducer__["a" /* default */]}));

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reset_reducer_helpers__ = __webpack_require__(21);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__reset_reducer_helpers__["a" /* withDestroyViewerReset */])(Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({isFullScreen:Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__["d" /* createToggleAndSetReducer */])(__WEBPACK_IMPORTED_MODULE_2__actions__["e" /* toggleFullScreen */]().type,__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* setFullScreen */]().type,false),zoomScalingFactor:Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__["b" /* createSimpleKeyValueReducer */])(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* setZoomScalingFactor */]().type,1)})));

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(225);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({searchActive:Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__["d" /* createToggleAndSetReducer */])(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* toggleSearch */]().type,__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* setSearch */]().type,false)}));

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export testReducer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_utils_env__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_api_redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_api_redux_jigsaw_jigsaw_methods__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_utils_strings__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_persist__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_persist_lib_storage__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_persist_lib_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_redux_persist_lib_storage__);
var _handlers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function getExpiration(){if(Object(__WEBPACK_IMPORTED_MODULE_3_app_utils_env__["c" /* isDevOrLocal */])()){return __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(4,'days').format();}return null;}var handlers=(_handlers={},_defineProperty(_handlers,Object(__WEBPACK_IMPORTED_MODULE_4_app_api_redux_util_async_helpers__["g" /* createSuccessAction */])(__WEBPACK_IMPORTED_MODULE_5_app_api_redux_jigsaw_jigsaw_methods__["x" /* GET_USER_INFO */]).type,function(state,action){var hashVal=Object(__WEBPACK_IMPORTED_MODULE_6_app_utils_strings__["g" /* hash */])(action.data.user.email);return Object.assign({},state,{active:hashVal});}),_defineProperty(_handlers,Object(__WEBPACK_IMPORTED_MODULE_0__actions__["a" /* markSeen */])().type,function(state,action){return Object.assign({},state,_defineProperty({},state.active,Object.assign({expires:getExpiration()},state[state.active],_defineProperty({},action.id,{seen:true}))));}),_defineProperty(_handlers,Object(__WEBPACK_IMPORTED_MODULE_0__actions__["b" /* reset */])().type,function(state){return Object.assign({},state,_defineProperty({},state.active,{}));}),_handlers);var persistConfig={key:'onboarding',storage:__WEBPACK_IMPORTED_MODULE_8_redux_persist_lib_storage___default.a,blacklist:['active']};var reducer=Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_util_general_helpers__["a" /* createReducer */])({},handlers);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux_persist__["b" /* persistReducer */])(persistConfig,reducer));var testReducer=reducer;

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = autoMergeLevel1;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function autoMergeLevel1(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = _extends({}, reducedState);
  // only rehydrate if inboundState exists and is an object
  if (inboundState && (typeof inboundState === 'undefined' ? 'undefined' : _typeof(inboundState)) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return;
      // if reducer modifies substate, skip auto rehydration
      if (originalState[key] !== reducedState[key]) {
        if (false) console.log('redux-persist/stateReconciler: sub state for key `%s` modified, skipping.', key);
        return;
      }
      // otherwise hard set the new value
      newState[key] = inboundState[key];
    });
  }

  if (false) console.log('redux-persist/stateReconciler: rehydrated keys \'' + Object.keys(inboundState).join(', ') + '\'');

  return newState;
}

/*
  autoMergeLevel1: 
    - merges 1 level of substate
    - skips substate if already modified
*/

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__persistReducer__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stateReconciler_autoMergeLevel2__ = __webpack_require__(685);




// combineReducers + persistReducer with stateReconciler defaulted to autoMergeLevel2
function persistCombineReducers(config, reducers) {
  config.stateReconciler = config.stateReconciler === undefined ? __WEBPACK_IMPORTED_MODULE_2__stateReconciler_autoMergeLevel2__["a" /* default */] : config.stateReconciler;
  return Object(__WEBPACK_IMPORTED_MODULE_1__persistReducer__["a" /* default */])(config, Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])(reducers));
}

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = autoMergeLevel2;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function autoMergeLevel2(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = _extends({}, reducedState);
  // only rehydrate if inboundState exists and is an object
  if (inboundState && (typeof inboundState === 'undefined' ? 'undefined' : _typeof(inboundState)) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return;
      // if reducer modifies substate, skip auto rehydration
      if (originalState[key] !== reducedState[key]) {
        if (false) console.log('redux-persist/stateReconciler: sub state for key `%s` modified, skipping.', key);
        return;
      }
      if (isPlainEnoughObject(reducedState[key])) {
        // if object is plain enough shallow merge the new values (hence "Level2")
        newState[key] = _extends({}, newState[key], inboundState[key]);
        return;
      }
      // otherwise hard set
      newState[key] = inboundState[key];
    });
  }

  if (false) console.log('redux-persist/stateReconciler: rehydrated keys \'' + Object.keys(inboundState).join(', ') + '\'');

  return newState;
}

/*
  autoMergeLevel2: 
    - merges 2 level of substate
    - skips substate if already modified
    - this is essentially redux-perist v4 behavior
*/

function isPlainEnoughObject(o) {
  return o !== null && !Array.isArray(o) && (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object';
}

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = persistStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__persistReducer__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(31);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






var initialState = {
  registry: [],
  bootstrapped: false
};

var persistorReducer = function persistorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* REGISTER */]:
      return _extends({}, state, { registry: [].concat(_toConsumableArray(state.registry), [action.key]) });
    case __WEBPACK_IMPORTED_MODULE_2__constants__["h" /* REHYDRATE */]:
      var firstIndex = state.registry.indexOf(action.key);
      var registry = [].concat(_toConsumableArray(state.registry));
      registry.splice(firstIndex, 1);
      return _extends({}, state, { registry: registry, bootstrapped: registry.length === 0 });
    default:
      return state;
  }
};

function persistStore(store, options, cb) {
  // help catch incorrect usage of passing PersistConfig in as PersistorOptions
  if (false) {
    var optionsToTest = options || {};
    var bannedKeys = ['blacklist', 'whitelist', 'transforms', 'storage', 'keyPrefix', 'migrate'];
    bannedKeys.forEach(function (k) {
      if (!!optionsToTest[k]) console.error('redux-persist: invalid option passed to persistStore: "' + k + '". You may be incorrectly passing persistConfig into persistStore, whereas it should be passed into persistReducer.');
    });
  }
  var boostrappedCb = cb || false;

  var _pStore = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(persistorReducer, initialState, options ? options.enhancer : undefined);
  var register = function register(key) {
    _pStore.dispatch({
      type: __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* REGISTER */],
      key: key
    });
  };

  var rehydrate = function rehydrate(key, payload, err) {
    var rehydrateAction = {
      type: __WEBPACK_IMPORTED_MODULE_2__constants__["h" /* REHYDRATE */],
      payload: payload,
      err: err,
      key: key
      // dispatch to `store` to rehydrate and `persistor` to track result
    };store.dispatch(rehydrateAction);
    _pStore.dispatch(rehydrateAction);
    if (boostrappedCb && persistor.getState().bootstrapped) {
      boostrappedCb();
      boostrappedCb = false;
    }
  };

  var persistor = _extends({}, _pStore, {
    purge: function purge() {
      var results = [];
      store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["f" /* PURGE */],
        result: function result(purgeResult) {
          results.push(purgeResult);
        }
      });
      return Promise.all(results);
    },
    flush: function flush() {
      var results = [];
      store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* FLUSH */],
        result: function result(flushResult) {
          results.push(flushResult);
        }
      });
      return Promise.all(results);
    },
    pause: function pause() {
      store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* PAUSE */]
      });
    },
    persist: function persist() {
      store.dispatch({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* PERSIST */], register: register, rehydrate: rehydrate });
    }
  });

  persistor.persist();

  return persistor;
}

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMigrate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(31);


function createMigrate(migrations, config) {
  var _ref = config || {},
      debug = _ref.debug;

  return function (state, currentVersion) {
    if (!state) {
      if (false) console.log('redux-persist: no inbound state, skipping migration');
      return Promise.resolve(undefined);
    }

    var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DEFAULT_VERSION */];
    if (inboundVersion === currentVersion) {
      if (false) console.log('redux-persist: versions match, noop migration');
      return Promise.resolve(state);
    }
    if (inboundVersion > currentVersion) {
      if (false) console.error('redux-persist: downgrading version is not supported');
      return Promise.resolve(state);
    }

    var migrationKeys = Object.keys(migrations).map(function (ver) {
      return parseInt(ver);
    }).filter(function (key) {
      return currentVersion >= key && key > inboundVersion;
    }).sort(function (a, b) {
      return a - b;
    });

    if (false) console.log('redux-persist: migrationKeys', migrationKeys);
    try {
      var migratedState = migrationKeys.reduce(function (state, versionKey) {
        if (false) console.log('redux-persist: running migration for versionKey', versionKey);
        return migrations[versionKey](state);
      }, state);
      return Promise.resolve(migratedState);
    } catch (err) {
      return Promise.reject(err);
    }
  };
}

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */


function createTransform(
// @NOTE inbound: transform state coming from redux on its way to being serialized and stored
inbound,
// @NOTE outbound: transform state coming from storage, on its way to be rehydrated into redux
outbound) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var whitelist = config.whitelist || null;
  var blacklist = config.blacklist || null;

  function whitelistBlacklistCheck(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return true;
    if (blacklist && blacklist.indexOf(key) !== -1) return true;
    return false;
  }

  return {
    in: function _in(state, key, fullState) {
      return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
    },
    out: function out(state, key, fullState) {
      return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
    }
  };
}

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createWebStorage;

var _getStorage = __webpack_require__(690);

var _getStorage2 = _interopRequireDefault(_getStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createWebStorage(type) {
  var storage = (0, _getStorage2.default)(type);
  return {
    getItem: function getItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.getItem(key));
      });
    },
    setItem: function setItem(key, item) {
      return new Promise(function (resolve, reject) {
        resolve(storage.setItem(key, item));
      });
    },
    removeItem: function removeItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.removeItem(key));
      });
    }
  };
}

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = getStorage;


function noop() {}

var noopStorage = {
  getItem: noop,
  setItem: noop,
  removeItem: noop
};

function hasStorage(storageType) {
  if ((typeof self === 'undefined' ? 'undefined' : _typeof(self)) !== 'object' || !(storageType in self)) {
    return false;
  }

  try {
    var storage = self[storageType];
    var testKey = 'redux-persist ' + storageType + ' test';
    storage.setItem(testKey, 'test');
    storage.getItem(testKey);
    storage.removeItem(testKey);
  } catch (e) {
    if (false) console.warn('redux-persist ' + storageType + ' test failed, persistence will be disabled.');
    return false;
  }
  return true;
}

function getStorage(type) {
  var storageType = type + 'Storage';
  if (hasStorage(storageType)) return self[storageType];else {
    if (false) {
      console.error('redux-persist failed to create sync storage. falling back to memory storage.');
    }
    return noopStorage;
  }
}

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__middle_actions__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reset_reducer_helpers__ = __webpack_require__(21);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__reset_reducer_helpers__["a" /* withDestroyViewerReset */])(Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({isPanelOpen:Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__["c" /* createSimpleToggleReducer */])(__WEBPACK_IMPORTED_MODULE_2__middle_actions__["g" /* togglePanel */]().type,false),isSearchOpen:Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__["d" /* createToggleAndSetReducer */])(__WEBPACK_IMPORTED_MODULE_2__middle_actions__["i" /* toggleSearch */]().type,__WEBPACK_IMPORTED_MODULE_2__middle_actions__["c" /* setSearch */]().type,false),isReadAloudOpen:Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__["d" /* createToggleAndSetReducer */])(__WEBPACK_IMPORTED_MODULE_2__middle_actions__["h" /* toggleReadAloud */]().type,__WEBPACK_IMPORTED_MODULE_2__middle_actions__["b" /* setReadAloud */]().type,false),notesFilterOn:Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__["c" /* createSimpleToggleReducer */])(__WEBPACK_IMPORTED_MODULE_2__middle_actions__["f" /* toggleNotesFilter */]().type,true),highlightsFilterOn:Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__["c" /* createSimpleToggleReducer */])(__WEBPACK_IMPORTED_MODULE_2__middle_actions__["e" /* toggleHighlightsFilter */]().type,true),bookmarksFilterOn:Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__["c" /* createSimpleToggleReducer */])(__WEBPACK_IMPORTED_MODULE_2__middle_actions__["d" /* toggleBookmarksFilter */]().type,true)})));

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__kiddie_actions__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reset_reducer_helpers__ = __webpack_require__(21);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({isReadAloudOpen:Object(__WEBPACK_IMPORTED_MODULE_3__reset_reducer_helpers__["a" /* withDestroyViewerReset */])(Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__["c" /* createSimpleToggleReducer */])(__WEBPACK_IMPORTED_MODULE_2__kiddie_actions__["f" /* toggleReadAloud */]().type,false)),isBookCompleteShowing:Object(__WEBPACK_IMPORTED_MODULE_3__reset_reducer_helpers__["a" /* withDestroyViewerReset */])(Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__["c" /* createSimpleToggleReducer */])(__WEBPACK_IMPORTED_MODULE_2__kiddie_actions__["e" /* toggleBookCompletePage */]().type,false)),areToolsCollapsed:Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__["c" /* createSimpleToggleReducer */])(__WEBPACK_IMPORTED_MODULE_2__kiddie_actions__["g" /* toggleToolsCollapsed */]().type,false)}));

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__taxonomyFilters_reducer__ = __webpack_require__(694);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({taxonomyFilters:__WEBPACK_IMPORTED_MODULE_1__taxonomyFilters_reducer__["a" /* default */]}));

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(232);
var _activeHandlers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var activeHandlers=(_activeHandlers={},_defineProperty(_activeHandlers,Object(__WEBPACK_IMPORTED_MODULE_1__actions__["d" /* setFilter */])().type,function(state,action){return Object.assign({},state,_defineProperty({},action.taxonomy,Object.assign({},state[action.taxonomy],_defineProperty({},action.name,action.value))));}),_defineProperty(_activeHandlers,Object(__WEBPACK_IMPORTED_MODULE_1__actions__["c" /* clearSingleFilter */])().type,function(state,action){return Object.assign({},state,_defineProperty({},action.name,{}));}),_activeHandlers);var updateActive=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_general_helpers__["a" /* createReducer */])({},activeHandlers);var initial={};var initialState={active:initial,applied:initial};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];if(action.type===Object(__WEBPACK_IMPORTED_MODULE_1__actions__["a" /* applyFilters */])().type){return Object.assign({},state,{applied:state.active});}else if(action.type===Object(__WEBPACK_IMPORTED_MODULE_1__actions__["b" /* clearFilters */])().type){return initialState;}return Object.assign({},state,{active:updateActive(state.active,action)});});

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jigsaw_events__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jigsaw_methods__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__userdata_highlights_reducer__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__userdata_bookmarks_reducer__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__userdata_notes_reducer__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__error_collector__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__zoom_reducer__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__page_loading_reducer__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__devices_reducer__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dps_reducer__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_api_redux_jigsaw_page_load_event_reducer__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reset_reducer_helpers__ = __webpack_require__(21);
var _Object$assign;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var asyncViewerReset=[__WEBPACK_IMPORTED_MODULE_2__jigsaw_methods__["c" /* CREATE_PAGE_VIEWER */],__WEBPACK_IMPORTED_MODULE_2__jigsaw_methods__["D" /* HAS_NEXT_PAGE */],__WEBPACK_IMPORTED_MODULE_2__jigsaw_methods__["E" /* HAS_PREV_PAGE */],__WEBPACK_IMPORTED_MODULE_2__jigsaw_methods__["w" /* GET_TOC */],__WEBPACK_IMPORTED_MODULE_2__jigsaw_methods__["M" /* SEARCH_CONTENT */],__WEBPACK_IMPORTED_MODULE_2__jigsaw_methods__["v" /* GET_THUMBNAILS */],__WEBPACK_IMPORTED_MODULE_2__jigsaw_methods__["o" /* GET_CITATION */],__WEBPACK_IMPORTED_MODULE_2__jigsaw_methods__["t" /* GET_PAGE_BREAKS */],__WEBPACK_IMPORTED_MODULE_2__jigsaw_methods__["l" /* GET_ANCILLARIES */]];var keyValViewerReset=[__WEBPACK_IMPORTED_MODULE_1__jigsaw_events__["BOOK_PAGE_BREAK"]];function getReducers(keys,fn){return keys.map(function(k){return _defineProperty({},k,fn(k));}).reduce(function(acc,cv){return Object.assign(acc,cv);},{});}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])(Object.assign({},getReducers(asyncViewerReset,function(k){return Object(__WEBPACK_IMPORTED_MODULE_14__reset_reducer_helpers__["a" /* withDestroyViewerReset */])(Object(__WEBPACK_IMPORTED_MODULE_13__redux_util_async_helpers__["b" /* createBaseAsyncReducer */])(k));}),getReducers(keyValViewerReset,function(k){return Object(__WEBPACK_IMPORTED_MODULE_14__reset_reducer_helpers__["a" /* withDestroyViewerReset */])(Object(__WEBPACK_IMPORTED_MODULE_12__redux_util_general_helpers__["b" /* createSimpleKeyValueReducer */])(k));}),(_Object$assign={},_defineProperty(_Object$assign,__WEBPACK_IMPORTED_MODULE_2__jigsaw_methods__["n" /* GET_BOOK_LIST */],Object(__WEBPACK_IMPORTED_MODULE_13__redux_util_async_helpers__["b" /* createBaseAsyncReducer */])(__WEBPACK_IMPORTED_MODULE_2__jigsaw_methods__["n" /* GET_BOOK_LIST */])),_defineProperty(_Object$assign,__WEBPACK_IMPORTED_MODULE_2__jigsaw_methods__["x" /* GET_USER_INFO */],Object(__WEBPACK_IMPORTED_MODULE_13__redux_util_async_helpers__["b" /* createBaseAsyncReducer */])(__WEBPACK_IMPORTED_MODULE_2__jigsaw_methods__["x" /* GET_USER_INFO */])),_defineProperty(_Object$assign,__WEBPACK_IMPORTED_MODULE_1__jigsaw_events__["PAGE_LOAD"],__WEBPACK_IMPORTED_MODULE_11_app_api_redux_jigsaw_page_load_event_reducer__["a" /* default */]),_defineProperty(_Object$assign,'highlights',__WEBPACK_IMPORTED_MODULE_3__userdata_highlights_reducer__["a" /* default */]),_defineProperty(_Object$assign,'bookmarks',__WEBPACK_IMPORTED_MODULE_4__userdata_bookmarks_reducer__["a" /* default */]),_defineProperty(_Object$assign,'notes',__WEBPACK_IMPORTED_MODULE_5__userdata_notes_reducer__["a" /* default */]),_defineProperty(_Object$assign,'interactionErrors',__WEBPACK_IMPORTED_MODULE_6__error_collector__["a" /* default */]),_defineProperty(_Object$assign,'zoom',__WEBPACK_IMPORTED_MODULE_7__zoom_reducer__["a" /* default */]),_defineProperty(_Object$assign,'pageLoading',__WEBPACK_IMPORTED_MODULE_8__page_loading_reducer__["a" /* default */]),_defineProperty(_Object$assign,'devices',__WEBPACK_IMPORTED_MODULE_9__devices_reducer__["a" /* default */]),_defineProperty(_Object$assign,'dps',__WEBPACK_IMPORTED_MODULE_10__dps_reducer__["a" /* default */]),_Object$assign))));

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reset_reducer_helpers__ = __webpack_require__(21);
var _extras;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}// Needs to be delete start to stay consistent with highlight removal on the page
var deleteStart=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["f" /* createStartAction */])(__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["g" /* DELETE_HIGHLIGHT */]).type;var updateSuccess=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["g" /* createSuccessAction */])(__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["_3" /* UPDATE_HIGHLIGHT */]).type;var highlightCurrentSuccess=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["g" /* createSuccessAction */])(__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["F" /* HIGHLIGHT_CURRENT */]).type;function doDelete(state,action){var highlights=Object(__WEBPACK_IMPORTED_MODULE_3__utils_array__["f" /* removeFromArray */])(state.highlights,'syncId',action.data[0]);return Object.assign({},state,{highlights:highlights});}function doUpdate(state,action){var newHighlight=action.data.highlight;return Object.assign({},state,{highlights:state.highlights.map(function(h){return h.syncId===newHighlight.syncId?newHighlight:h;})});}function handleSuccess(state,action){return Object.assign({},state,{highlights:[].concat(_toConsumableArray(state.highlights),[action.data.highlight])});}var base=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["a" /* createBaseAsyncHandlers */])(__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["q" /* GET_HIGHLIGHTS */]);var extras=(_extras={},_defineProperty(_extras,deleteStart,Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["j" /* makeDataUpdater */])(doDelete)),_defineProperty(_extras,updateSuccess,Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["j" /* makeDataUpdater */])(doUpdate)),_defineProperty(_extras,highlightCurrentSuccess,Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["j" /* makeDataUpdater */])(handleSuccess)),_extras);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__reset_reducer_helpers__["a" /* withDestroyViewerReset */])(Object(__WEBPACK_IMPORTED_MODULE_2__redux_util_general_helpers__["a" /* createReducer */])(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["h" /* initialState */],base,extras)));

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_api_redux_jigsaw_userdata_utils_reducer_utils__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_methods__ = __webpack_require__(7);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_jigsaw_userdata_utils_reducer_utils__["a" /* createDataReducer */])({get:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_methods__["m" /* GET_BOOKMARKS */],add:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_methods__["N" /* SET_BOOKMARK */],del:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_methods__["f" /* DELETE_BOOKMARK */],itemName:'bookmark',listName:'bookmarks'}));

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createListReducer;
/* harmony export (immutable) */ __webpack_exports__["a"] = createEntryReducer;
/* unused harmony export createStatusReducer */
/* harmony export (immutable) */ __webpack_exports__["c"] = createPendingReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_utils_array__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_api_redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(9);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function createListReducer(_ref){var _extraHandlers;var get=_ref.get,add=_ref.add,del=_ref.del,listName=_ref.listName,itemName=_ref.itemName;function updateOnDelete(state,action){return Object.assign({},state,{items:Object(__WEBPACK_IMPORTED_MODULE_0_app_utils_array__["g" /* removeValue */])(state.items,action.data[0])});}function updateOnAdd(state,action){return Object.assign({},state,{items:[action.data[itemName].guid].concat(_toConsumableArray(state.items))});}var baseHandlers=Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_util_async_helpers__["a" /* createBaseAsyncHandlers */])(get,function(data){return{items:data[listName].map(function(b){return b.guid;})};});var extraHandlers=(_extraHandlers={},_defineProperty(_extraHandlers,Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_util_async_helpers__["f" /* createStartAction */])(del).type,Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_util_async_helpers__["j" /* makeDataUpdater */])(updateOnDelete)),_defineProperty(_extraHandlers,Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_util_async_helpers__["g" /* createSuccessAction */])(add).type,Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_util_async_helpers__["j" /* makeDataUpdater */])(updateOnAdd)),_extraHandlers);return Object(__WEBPACK_IMPORTED_MODULE_2_app_api_redux_util_general_helpers__["a" /* createReducer */])(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_util_async_helpers__["h" /* initialState */],baseHandlers,extraHandlers);}function createEntryReducer(_ref2){var get=_ref2.get,add=_ref2.add,update=_ref2.update,listName=_ref2.listName,itemName=_ref2.itemName;return function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];if(action.type===Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_util_async_helpers__["g" /* createSuccessAction */])(get).type){var newItems=action.data[listName].reduce(function(acc,cv){acc[cv.guid]=cv;return acc;},{});return Object.assign({},state,newItems);}else if(action.type===Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_util_async_helpers__["f" /* createStartAction */])(update).type){var id=action.data[0];var newData=action.data[1];var oldData=state[id];return Object.assign({},state,_defineProperty({},id,Object.assign({},oldData,newData)));}else if(action.type===Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_util_async_helpers__["g" /* createSuccessAction */])(add).type){var item=action.data[itemName];return Object.assign({},state,_defineProperty({},item.guid,item));}return state;};}function createStatusReducer(key){var _handlers;var handlers=(_handlers={},_defineProperty(_handlers,Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_util_async_helpers__["f" /* createStartAction */])(key).type,function(state,action){return[].concat(_toConsumableArray(state),[action.data[0]]);}),_defineProperty(_handlers,Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_util_async_helpers__["g" /* createSuccessAction */])(key).type,function(state,action){return Object(__WEBPACK_IMPORTED_MODULE_0_app_utils_array__["g" /* removeValue */])(state,action.args[0]);}),_defineProperty(_handlers,Object(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_util_async_helpers__["c" /* createFailAction */])(key).type,function(state,action){return Object(__WEBPACK_IMPORTED_MODULE_0_app_utils_array__["g" /* removeValue */])(state,action.args[0]);}),_handlers);return Object(__WEBPACK_IMPORTED_MODULE_2_app_api_redux_util_general_helpers__["a" /* createReducer */])([],handlers);}function createPendingReducer(_ref3){var add=_ref3.add,del=_ref3.del,update=_ref3.update;return Object(__WEBPACK_IMPORTED_MODULE_3_redux__["c" /* combineReducers */])({add:createStatusReducer(add),del:createStatusReducer(del),update:createStatusReducer(update)});}

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_api_redux_jigsaw_userdata_utils_reducer_utils__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_methods__ = __webpack_require__(7);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_jigsaw_userdata_utils_reducer_utils__["a" /* createDataReducer */])({get:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_methods__["s" /* GET_NOTES */],add:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_methods__["a" /* ADD_NOTE */],del:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_methods__["h" /* DELETE_NOTE */],update:__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_methods__["_4" /* UPDATE_NOTE */],itemName:'note',listName:'notes'}));

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reset_reducer_helpers__ = __webpack_require__(21);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var actions=[__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["_3" /* UPDATE_HIGHLIGHT */],__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["F" /* HIGHLIGHT_CURRENT */],__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["g" /* DELETE_HIGHLIGHT */],__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["f" /* DELETE_BOOKMARK */],__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["B" /* GO_TO_PAGE */],__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["z" /* GO_TO_CFI */],__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["A" /* GO_TO_HIGHLIGHT */],__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["N" /* SET_BOOKMARK */],__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["Q" /* SET_ZOOM_SCALE */],__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["H" /* INCREASE_ZOOM */],__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["e" /* DECREASE_ZOOM */],__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["m" /* GET_BOOKMARKS */],__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["q" /* GET_HIGHLIGHTS */],__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["s" /* GET_NOTES */],__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["y" /* GO_TO_BOOKMARK */],__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["_4" /* UPDATE_NOTE */],__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["a" /* ADD_NOTE */],__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["h" /* DELETE_NOTE */]];var collectionHandlers={};actions.forEach(function(a){var key=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["c" /* createFailAction */])(a).type;collectionHandlers[key]=function(state,action){return[].concat(_toConsumableArray(state),[{type:a,data:action.data}]);};});/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__reset_reducer_helpers__["a" /* withDestroyViewerReset */])(Object(__WEBPACK_IMPORTED_MODULE_2__redux_util_general_helpers__["a" /* createReducer */])([],collectionHandlers)));

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reset_reducer_helpers__ = __webpack_require__(21);
var _base;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var increaseSuccess=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["g" /* createSuccessAction */])(__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["H" /* INCREASE_ZOOM */]).type;var decreaseSuccess=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["g" /* createSuccessAction */])(__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["e" /* DECREASE_ZOOM */]).type;var setStart=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["f" /* createStartAction */])(__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["Q" /* SET_ZOOM_SCALE */]).type;var base=(_base={},_defineProperty(_base,increaseSuccess,function(state,action){return action.data.zoomScale;}),_defineProperty(_base,decreaseSuccess,function(state,action){return action.data.zoomScale;}),_defineProperty(_base,setStart,function(state,action){return action.data[0];}),_base);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__reset_reducer_helpers__["a" /* withDestroyViewerReset */])(Object(__WEBPACK_IMPORTED_MODULE_2__redux_util_general_helpers__["a" /* createReducer */])(1,base)));

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jigsaw_events__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reset_reducer_helpers__ = __webpack_require__(21);
var _base;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var notLoading=function notLoading(){return false;};var loading=function loading(){return true;};var base=(_base={},_defineProperty(_base,Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["f" /* createStartAction */])(__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["c" /* CREATE_PAGE_VIEWER */]).type,loading),_defineProperty(_base,__WEBPACK_IMPORTED_MODULE_3__jigsaw_events__["BOOK_NAV_REQUESTED"],loading),_defineProperty(_base,__WEBPACK_IMPORTED_MODULE_3__jigsaw_events__["PAGE_READY"],notLoading),_base);[__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["B" /* GO_TO_PAGE */],__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["A" /* GO_TO_HIGHLIGHT */],__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["C" /* GO_TO_SEARCH_RESULT */],__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["z" /* GO_TO_CFI */],__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["J" /* PREV_PAGE */],__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["I" /* NEXT_PAGE */]].map(function(m){return Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["c" /* createFailAction */])(m).type;}).forEach(function(k){return base[k]=notLoading;});/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__reset_reducer_helpers__["a" /* withDestroyViewerReset */])(Object(__WEBPACK_IMPORTED_MODULE_2__redux_util_general_helpers__["a" /* createReducer */])(true,base)));

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_array_find_index__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_array_find_index__);
var _extras;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var emptyArray=[];function doDeactivateStart(state,action){var index=__WEBPACK_IMPORTED_MODULE_4_array_find_index___default()(state.devices,function(e){return e.id===action.data[0];});if(index>=0){var toDeactivate=state.devices[index];var devices=Object(__WEBPACK_IMPORTED_MODULE_3__utils_array__["c" /* removeAtIndex */])(state.devices,index);var deletes=state.pendingDeactivations||emptyArray;return Object.assign({},state,{devices:devices,pendingDeactivations:[].concat(_toConsumableArray(deletes),[toDeactivate])});}return state;}function removePendingDeactivation(state,action){return state.pendingDeactivations.filter(function(k){return k.guid!==action.args[0];});}function doDeactivateSuccess(state,action){return Object.assign({},state,{pendingDeactivations:removePendingDeactivation(state,action)});}function doDeactivateFail(state,action){var failedItem=state.pendingDeactivations.filter(function(d){return d.id===action.args[0];})[0];return Object.assign({},state,{devices:[].concat(_toConsumableArray(state.devices),[failedItem]),pendingDeactivations:removePendingDeactivation(state,action)});}var deactivateStart=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["f" /* createStartAction */])(__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["d" /* DEACTIVATE_DEVICE */]).type;var deactivateSuccess=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["g" /* createSuccessAction */])(__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["d" /* DEACTIVATE_DEVICE */]).type;var deactivateFail=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["c" /* createFailAction */])(__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["d" /* DEACTIVATE_DEVICE */]).type;var base=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["a" /* createBaseAsyncHandlers */])(__WEBPACK_IMPORTED_MODULE_1__jigsaw_methods__["p" /* GET_DEVICES */]);var extras=(_extras={},_defineProperty(_extras,deactivateStart,Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["j" /* makeDataUpdater */])(doDeactivateStart)),_defineProperty(_extras,deactivateSuccess,Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["j" /* makeDataUpdater */])(doDeactivateSuccess)),_defineProperty(_extras,deactivateFail,Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["j" /* makeDataUpdater */])(doDeactivateFail)),_extras);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__redux_util_general_helpers__["a" /* createReducer */])(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["h" /* initialState */],base,extras));

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_api_redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_methods__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_api_reset_reducer_helpers__ = __webpack_require__(21);
function dpsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];if(action.type===Object(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_util_async_helpers__["f" /* createStartAction */])(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_methods__["O" /* SET_DPS */]).type){return action.data[0];}else if(action.type===Object(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_util_async_helpers__["f" /* createStartAction */])(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_methods__["c" /* CREATE_PAGE_VIEWER */]).type){return!!action.data[0].dpsOn;}else if(action.type===Object(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_util_async_helpers__["g" /* createSuccessAction */])(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_methods__["c" /* CREATE_PAGE_VIEWER */]).type){if(!action.data.dpsAvailable){return false;}}return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_app_api_reset_reducer_helpers__["a" /* withDestroyViewerReset */])(dpsReducer));

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_api_reset_reducer_helpers__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_events__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_api_redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_utils_objects__ = __webpack_require__(15);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/**
 * Maintain at least one object, array length should equal number of pages
 * Selectors should filter out unloaded items
 *
 * Keeps old page data around until a new event comes in because we don't
 * have a great way to tell what events go with what views
 */var pageLoadReducer=Object(__WEBPACK_IMPORTED_MODULE_2_app_api_redux_util_general_helpers__["a" /* createReducer */])([],_defineProperty({},__WEBPACK_IMPORTED_MODULE_1_app_api_redux_jigsaw_jigsaw_events__["PAGE_LOAD"],function(state,action){var newState=[].concat(_toConsumableArray(state));var oldData=state[action.data.documentIndex];if(!oldData||Object(__WEBPACK_IMPORTED_MODULE_3_app_utils_objects__["d" /* isEmpty */])(oldData)){newState[action.data.documentIndex]=action.data;}else{newState[action.data.documentIndex]=Object.assign({},action.data,{// Temporary workaround K8BK-86, where we get bad values from Jigsaw
// due to a bug in the loading event handling. Putting this in so
// we can meet our live date, but it needs to be fixed for real within
// Jigsaw.
boundingRectWidth:Math.max(action.data.boundingRectWidth,oldData.boundingRectWidth),boundingRectHeight:Math.max(action.data.boundingRectHeight,oldData.boundingRectHeight)});}// This is writeable! Who knew?
newState.length=action.data.dps?2:1;return newState;}));/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_app_api_reset_reducer_helpers__["a" /* withDestroyViewerReset */])(pageLoadReducer));

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dev_keys__ = __webpack_require__(82);
var _combineReducers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])((_combineReducers={},_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_2__dev_keys__["b" /* TOGGLE_STRING_DEBUG */],Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__["c" /* createSimpleToggleReducer */])(__WEBPACK_IMPORTED_MODULE_2__dev_keys__["b" /* TOGGLE_STRING_DEBUG */],false)),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_2__dev_keys__["a" /* TOGGLE_ASSET_STATUS */],Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__["c" /* createSimpleToggleReducer */])(__WEBPACK_IMPORTED_MODULE_2__dev_keys__["a" /* TOGGLE_ASSET_STATUS */],false)),_combineReducers)));

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__watson_config_action__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_util_general_helpers__ = __webpack_require__(3);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var standardAsync=[__WEBPACK_IMPORTED_MODULE_2__watson_config_action__["b" /* LOCALE_KEY */],__WEBPACK_IMPORTED_MODULE_2__watson_config_action__["a" /* BRAND_KEY */],__WEBPACK_IMPORTED_MODULE_2__watson_config_action__["c" /* THEME_KEY */]];function getReducers(keys,fn){return keys.map(function(k){return _defineProperty({},k,fn(k));}).reduce(function(acc,cv){return Object.assign(acc,cv);},{});}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])(Object.assign({},getReducers(standardAsync,__WEBPACK_IMPORTED_MODULE_1__redux_util_async_helpers__["b" /* createBaseAsyncReducer */]),_defineProperty({},__WEBPACK_IMPORTED_MODULE_2__watson_config_action__["d" /* UIBASE_KEY */],Object(__WEBPACK_IMPORTED_MODULE_3__redux_util_general_helpers__["b" /* createSimpleKeyValueReducer */])(__WEBPACK_IMPORTED_MODULE_2__watson_config_action__["d" /* UIBASE_KEY */],'')))));

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bridge_methods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__groups_reducer__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__adoptions_reducer__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_reducer__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__users_reducer__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assetGroups_reducer__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__taxonomy_reducer__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__errors_reducer__ = __webpack_require__(732);
var _combineReducers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])((_combineReducers={},_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_1__bridge_methods__["h" /* GET_SESSION */],Object(__WEBPACK_IMPORTED_MODULE_2__redux_util_async_helpers__["b" /* createBaseAsyncReducer */])(__WEBPACK_IMPORTED_MODULE_1__bridge_methods__["h" /* GET_SESSION */])),_defineProperty(_combineReducers,__WEBPACK_IMPORTED_MODULE_1__bridge_methods__["g" /* GET_ROSTER */],Object(__WEBPACK_IMPORTED_MODULE_2__redux_util_async_helpers__["b" /* createBaseAsyncReducer */])(__WEBPACK_IMPORTED_MODULE_1__bridge_methods__["g" /* GET_ROSTER */])),_defineProperty(_combineReducers,'assetGroups',__WEBPACK_IMPORTED_MODULE_7__assetGroups_reducer__["a" /* default */]),_defineProperty(_combineReducers,'groups',__WEBPACK_IMPORTED_MODULE_3__groups_reducer__["a" /* default */]),_defineProperty(_combineReducers,'adoptions',__WEBPACK_IMPORTED_MODULE_4__adoptions_reducer__["a" /* default */]),_defineProperty(_combineReducers,'assets',__WEBPACK_IMPORTED_MODULE_5__assets_reducer__["a" /* default */]),_defineProperty(_combineReducers,'users',__WEBPACK_IMPORTED_MODULE_6__users_reducer__["a" /* default */]),_defineProperty(_combineReducers,'taxonomy',__WEBPACK_IMPORTED_MODULE_8__taxonomy_reducer__["a" /* default */]),_defineProperty(_combineReducers,'errors',__WEBPACK_IMPORTED_MODULE_9__errors_reducer__["a" /* default */]),_combineReducers)));

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__list_reducer__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__users_reducer__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__single_reducer__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_reducer__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(9);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_redux__["c" /* combineReducers */])({list:__WEBPACK_IMPORTED_MODULE_0__list_reducer__["a" /* default */],single:__WEBPACK_IMPORTED_MODULE_2__single_reducer__["a" /* default */],users:__WEBPACK_IMPORTED_MODULE_1__users_reducer__["a" /* default */],data:__WEBPACK_IMPORTED_MODULE_3__data_reducer__["a" /* default */]}));

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bridge_methods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bridge_async_modifier__ = __webpack_require__(59);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__bridge_async_modifier__["a" /* getAsyncReducerWithModify */])({fetchKey:__WEBPACK_IMPORTED_MODULE_0__bridge_methods__["n" /* LIST_GROUPS */],appendNode:'content',itemParam:'id'}));

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bridge_method_remap__ = __webpack_require__(19);
var _listHandlers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var baseListReducer=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["b" /* createBaseAsyncReducer */])(__WEBPACK_IMPORTED_MODULE_2__bridge_method_remap__["e" /* LIST_ALL_USERS */],function(data){var users=data.users// Sometimes bridge gives us users with no id. They should fix this, but let's not crash the page if it happens.
.filter(function(u){return!!u.id;}).map(function(d){return d.id;});return Object.assign({},data,{users:users});});var listHandlers=(_listHandlers={},_defineProperty(_listHandlers,Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["g" /* createSuccessAction */])(__WEBPACK_IMPORTED_MODULE_2__bridge_method_remap__["e" /* LIST_ALL_USERS */]).type,function(state,action){var result=baseListReducer(state,action);if(state.data){result.data.users=[].concat(_toConsumableArray(state.data.users),_toConsumableArray(result.data.users));}return result;}),_defineProperty(_listHandlers,Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["c" /* createFailAction */])(__WEBPACK_IMPORTED_MODULE_2__bridge_method_remap__["e" /* LIST_ALL_USERS */]).type,function(state,action){return baseListReducer(state,action);}),_defineProperty(_listHandlers,Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["f" /* createStartAction */])(__WEBPACK_IMPORTED_MODULE_2__bridge_method_remap__["e" /* LIST_ALL_USERS */]).type,function(state,action){return baseListReducer(state,action);}),_listHandlers);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["d" /* createKeyedAsyncReducer */])({actionKeys:__WEBPACK_IMPORTED_MODULE_2__bridge_method_remap__["e" /* LIST_ALL_USERS */],param:'group',itemReducer:Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__["a" /* createReducer */])(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["h" /* initialState */],listHandlers)}));

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bridge_methods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_util_general_helpers__ = __webpack_require__(3);
var singleFetchBase=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["a" /* createBaseAsyncHandlers */])(__WEBPACK_IMPORTED_MODULE_1__bridge_methods__["f" /* GET_GROUP */],function(){return'OMITTED. USE THE GROUP LIST.';});/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["d" /* createKeyedAsyncReducer */])({actionKeys:__WEBPACK_IMPORTED_MODULE_1__bridge_methods__["f" /* GET_GROUP */],param:'id',itemReducer:Object(__WEBPACK_IMPORTED_MODULE_2__redux_util_general_helpers__["a" /* createReducer */])(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["h" /* initialState */],singleFetchBase)}));

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bridge_methods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_util_general_helpers__ = __webpack_require__(3);
var _handlers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var handlers=(_handlers={},_defineProperty(_handlers,Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["g" /* createSuccessAction */])(__WEBPACK_IMPORTED_MODULE_1__bridge_methods__["n" /* LIST_GROUPS */]).type,function(state,action){var newState=Object.assign({},state);action.data.content.forEach(function(g){newState[g.id]=g;});return newState;}),_defineProperty(_handlers,Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["g" /* createSuccessAction */])(__WEBPACK_IMPORTED_MODULE_1__bridge_methods__["f" /* GET_GROUP */]).type,function(state,action){return Object.assign({},state,_defineProperty({},action.data.group.id,action.data.group));}),_handlers);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__redux_util_general_helpers__["a" /* createReducer */])({},handlers));

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__list_reducer__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__users_reducer__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__single_reducer__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_reducer__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_reducer__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assetChanges_reducer__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(9);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_redux__["c" /* combineReducers */])({list:__WEBPACK_IMPORTED_MODULE_0__list_reducer__["a" /* default */],single:__WEBPACK_IMPORTED_MODULE_2__single_reducer__["a" /* default */],users:__WEBPACK_IMPORTED_MODULE_1__users_reducer__["a" /* default */],assets:__WEBPACK_IMPORTED_MODULE_4__assets_reducer__["a" /* default */],data:__WEBPACK_IMPORTED_MODULE_3__data_reducer__["a" /* default */],assetChanges:__WEBPACK_IMPORTED_MODULE_5__assetChanges_reducer__["a" /* default */]}));

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bridge_methods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bridge_async_modifier__ = __webpack_require__(59);
var itemReducer=Object(__WEBPACK_IMPORTED_MODULE_2__bridge_async_modifier__["a" /* getAsyncReducerWithModify */])({fetchKey:__WEBPACK_IMPORTED_MODULE_1__bridge_methods__["k" /* LIST_ADOPTIONS */],createKey:__WEBPACK_IMPORTED_MODULE_1__bridge_methods__["b" /* CREATE_ADOPTION */],deleteKey:__WEBPACK_IMPORTED_MODULE_1__bridge_methods__["d" /* DELETE_ADOPTION */],appendNode:'adoptions',itemParam:'id',appendNodeCreate:'adoption',// Single class list, show new ones at top
appendOnCreate:false});var undefinedUpdateReducer=Object(__WEBPACK_IMPORTED_MODULE_2__bridge_async_modifier__["a" /* getAsyncReducerWithModify */])({createKey:__WEBPACK_IMPORTED_MODULE_1__bridge_methods__["b" /* CREATE_ADOPTION */],deleteKey:__WEBPACK_IMPORTED_MODULE_1__bridge_methods__["d" /* DELETE_ADOPTION */],appendNode:'adoptions',itemParam:'id',appendNodeCreate:'adoption',// All adoptions list (menu), show new ones at bottom
appendOnCreate:true});/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["d" /* createKeyedAsyncReducer */])({actionKeys:[__WEBPACK_IMPORTED_MODULE_1__bridge_methods__["k" /* LIST_ADOPTIONS */],__WEBPACK_IMPORTED_MODULE_1__bridge_methods__["b" /* CREATE_ADOPTION */],__WEBPACK_IMPORTED_MODULE_1__bridge_methods__["d" /* DELETE_ADOPTION */]],param:'group',itemReducer:itemReducer,undefinedUpdateReducer:undefinedUpdateReducer}));

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bridge_method_remap__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bridge_async_modifier__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(184);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["d" /* createKeyedAsyncReducer */])({actionKeys:[__WEBPACK_IMPORTED_MODULE_1__bridge_method_remap__["c" /* LIST_ADOPTION_USERS */]],param:'adoption',itemReducer:Object(__WEBPACK_IMPORTED_MODULE_2__bridge_async_modifier__["a" /* getAsyncReducerWithModify */])({fetchKey:__WEBPACK_IMPORTED_MODULE_1__bridge_method_remap__["c" /* LIST_ADOPTION_USERS */],appendNode:'users',itemParam:'id'}),globalReducer:Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* getBatchUpdateReducer */])({updateAction:__WEBPACK_IMPORTED_MODULE_1__bridge_method_remap__["j" /* UPDATE_ADOPTION_USERS */],paramNodeName:'users',itemKeyName:'id',outputNodeName:'users',useStart:true})}));

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bridge_methods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_util_general_helpers__ = __webpack_require__(3);
var singleFetchBase=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["a" /* createBaseAsyncHandlers */])(__WEBPACK_IMPORTED_MODULE_1__bridge_methods__["e" /* GET_ADOPTION */],function(){return'OMITTED. USE THE ADOPTION LIST.';});/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["d" /* createKeyedAsyncReducer */])({actionKeys:__WEBPACK_IMPORTED_MODULE_1__bridge_methods__["e" /* GET_ADOPTION */],param:'id',itemReducer:Object(__WEBPACK_IMPORTED_MODULE_2__redux_util_general_helpers__["a" /* createReducer */])(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["h" /* initialState */],singleFetchBase)}));

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = adoptionDataReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bridge_methods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bridge_method_remap__ = __webpack_require__(19);
function adoptionDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];var newState=Object.assign({},state);if(action.type===Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["g" /* createSuccessAction */])(__WEBPACK_IMPORTED_MODULE_1__bridge_methods__["k" /* LIST_ADOPTIONS */]).type){action.data.adoptions.forEach(function(d){newState[d.id]=d;});return newState;}else if(action.type===Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["g" /* createSuccessAction */])(__WEBPACK_IMPORTED_MODULE_1__bridge_methods__["b" /* CREATE_ADOPTION */]).type){newState[action.data.adoption.id]=action.data.adoption;return newState;}else if(action.type===Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["f" /* createStartAction */])(__WEBPACK_IMPORTED_MODULE_2__bridge_method_remap__["i" /* UPDATE_ADOPTION_NAME */]).type){var adoptions=action.data[0].adoptions;adoptions.forEach(function(a){newState[a.id]=Object.assign({},newState[a.id],{name:a.name});});return newState;}else if(action.type===Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["g" /* createSuccessAction */])(__WEBPACK_IMPORTED_MODULE_1__bridge_methods__["e" /* GET_ADOPTION */]).type){if(action.data.adoption.id){newState[action.data.adoption.id]=action.data.adoption;return newState;}}else if(action.type===Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["g" /* createSuccessAction */])(__WEBPACK_IMPORTED_MODULE_1__bridge_methods__["d" /* DELETE_ADOPTION */]).type){newState[action.args[0].id]=null;return newState;}return state;}

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bridge_method_remap__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bridge_async_modifier__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(184);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["d" /* createKeyedAsyncReducer */])({actionKeys:[__WEBPACK_IMPORTED_MODULE_1__bridge_method_remap__["b" /* LIST_ADOPTION_ASSETS */]],param:'adoption',itemReducer:Object(__WEBPACK_IMPORTED_MODULE_2__bridge_async_modifier__["a" /* getAsyncReducerWithModify */])({fetchKey:__WEBPACK_IMPORTED_MODULE_1__bridge_method_remap__["b" /* LIST_ADOPTION_ASSETS */],appendNode:'content',itemParam:'vbid'}),globalReducer:Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* getBatchUpdateReducer */])({updateAction:__WEBPACK_IMPORTED_MODULE_1__bridge_method_remap__["h" /* UPDATE_ADOPTION_ASSETS */],paramNodeName:'assets',itemKeyName:'vbid',outputNodeName:'content',useStart:false})}));

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bridge_method_remap__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_uid__ = __webpack_require__(63);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];var success=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["g" /* createSuccessAction */])(__WEBPACK_IMPORTED_MODULE_1__bridge_method_remap__["h" /* UPDATE_ADOPTION_ASSETS */]).type;var fail=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["c" /* createFailAction */])(__WEBPACK_IMPORTED_MODULE_1__bridge_method_remap__["h" /* UPDATE_ADOPTION_ASSETS */]).type;if(action.type===success||action.type===fail){var changeData={params:action.args[0].adoptions,success:action.type===success,id:Object(__WEBPACK_IMPORTED_MODULE_2__utils_uid__["a" /* getUid */])()};return[changeData].concat(_toConsumableArray(state));}return state;});

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_jigsaw_jigsaw_methods__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bridge_method_remap__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_api_redux_bridge_bridge_methods__ = __webpack_require__(13);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var actions=[__WEBPACK_IMPORTED_MODULE_2__bridge_method_remap__["d" /* LIST_ALL_ASSETS */],__WEBPACK_IMPORTED_MODULE_2__bridge_method_remap__["f" /* SEARCH_ASSETS */],__WEBPACK_IMPORTED_MODULE_2__bridge_method_remap__["a" /* LIST_ACTIVE_ASSETS */],__WEBPACK_IMPORTED_MODULE_2__bridge_method_remap__["b" /* LIST_ADOPTION_ASSETS */]];var successes=actions.map(function(a){return Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["g" /* createSuccessAction */])(a).type;});function fixAdoptions(adoptions){if(!adoptions){return[];}// Bridge returns ints, but the UI is sometimes dealing in strings
// e.g. through the URL or input element attributes. Make them all
// strings so that comparisons work
return adoptions.map(function(a){return''+a;});}/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];var newState=Object.assign({},state);if(successes.indexOf(action.type)!==-1){action.data.content.forEach(function(d){newState[d.vbid]=Object.assign({},d,{adoptions:fixAdoptions(d.adoptions)});});return newState;}else if(action.type===Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["g" /* createSuccessAction */])(__WEBPACK_IMPORTED_MODULE_1__redux_jigsaw_jigsaw_methods__["c" /* CREATE_PAGE_VIEWER */]).type){var fakeBook={vbid:action.data.isbn,title:action.data.title,author:action.data.author,description:'',coverImageUrl:null,active:true,adoptions:[]};newState[fakeBook.vbid]=fakeBook;return newState;}else if(action.type===Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["g" /* createSuccessAction */])(__WEBPACK_IMPORTED_MODULE_2__bridge_method_remap__["h" /* UPDATE_ADOPTION_ASSETS */]).type){var adoptions=action.args[0].adoptions;adoptions.forEach(function(adoption){var adoptionId=''+adoption.id;adoption.assets.forEach(function(asset){if(newState[asset.vbid]){var oldAdoptions=newState[asset.vbid].adoptions||[];var index=oldAdoptions.indexOf(adoptionId);if(asset.assigned&&index===-1){newState[asset.vbid]=Object.assign({},newState[asset.vbid],{adoptions:[].concat(_toConsumableArray(oldAdoptions),[adoptionId])});}else if(!asset.assigned&&index!==-1){var updatedAdoptions=[].concat(_toConsumableArray(oldAdoptions));updatedAdoptions.splice(index,1);newState[asset.vbid]=Object.assign({},state[asset.vbid],{adoptions:updatedAdoptions});}}});});return newState;}else if(action.type===Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["f" /* createStartAction */])(__WEBPACK_IMPORTED_MODULE_3_app_api_redux_bridge_bridge_methods__["d" /* DELETE_ADOPTION */]).type){Object.keys(state).forEach(function(vbid){var data=state[vbid];var index=data.adoptions.indexOf(''+action.data[0].id);if(index!==-1){var _adoptions=[].concat(_toConsumableArray(data.adoptions));_adoptions.splice(index,1);newState[vbid]=Object.assign({},data,{adoptions:_adoptions});}});return newState;}else if(action.type===Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["g" /* createSuccessAction */])(__WEBPACK_IMPORTED_MODULE_3_app_api_redux_bridge_bridge_methods__["m" /* LIST_ASSETS_MULTI */]).type){var _newState=Object.assign({},state);action.data.lists.forEach(function(list){if(list.content){list.content.forEach(function(asset){_newState[asset.vbid]=Object.assign({},asset,{adoptions:fixAdoptions(asset.adoptions)});});}});return _newState;}return state;});

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bridge_method_remap__ = __webpack_require__(19);
var actions=[__WEBPACK_IMPORTED_MODULE_1__bridge_method_remap__["e" /* LIST_ALL_USERS */],__WEBPACK_IMPORTED_MODULE_1__bridge_method_remap__["c" /* LIST_ADOPTION_USERS */]];var successes=actions.map(function(a){return Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["g" /* createSuccessAction */])(a).type;});/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];if(successes.indexOf(action.type)!==-1){var newState=Object.assign({},state);action.data.users// Sometimes bridge gives us users with no id. They should fix this, but let's not crash the page if it happens.
.filter(function(u){return!!u.id;}).forEach(function(d){newState[d.id]=d;});return newState;}return state;});

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer_all__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_active__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducer_search__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__recommendations_reducer__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(9);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_redux__["c" /* combineReducers */])({all:__WEBPACK_IMPORTED_MODULE_0__reducer_all__["a" /* default */],active:__WEBPACK_IMPORTED_MODULE_1__reducer_active__["a" /* default */],search:__WEBPACK_IMPORTED_MODULE_2__reducer_search__["a" /* default */],recommendations:__WEBPACK_IMPORTED_MODULE_3__recommendations_reducer__["a" /* default */]}));

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer_helpers__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bridge_method_remap__ = __webpack_require__(19);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__reducer_helpers__["a" /* makeAssetReducer */])(__WEBPACK_IMPORTED_MODULE_1__bridge_method_remap__["d" /* LIST_ALL_ASSETS */]));

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_jigsaw_jigsaw_methods__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bridge_method_remap__ = __webpack_require__(19);
var _extras;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var baseHandlers=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["a" /* createBaseAsyncHandlers */])(__WEBPACK_IMPORTED_MODULE_4__bridge_method_remap__["a" /* LIST_ACTIVE_ASSETS */]);function doFetchStart(state,action){var baseResult=baseHandlers[action.type](state,action);baseResult.data=state.data;return baseResult;}function doFetchSuccess(state,action){var baseResult=baseHandlers[action.type](state,action);var oldBooks=state.data?state.data.content||[]:[];// Account for items copied in from allBooks during reorderItems
// that then get loaded into this list later
var vbids=baseResult.data.content.map(function(d){return d.vbid;});var content=Object(__WEBPACK_IMPORTED_MODULE_3__utils_array__["d" /* removeDuplicateValues */])(oldBooks.concat(vbids));baseResult.data=Object.assign({},baseResult.data,{content:content});return baseResult;}function doFetchFail(state,action){return baseHandlers[action.type](state,action);}function reorderBooks(state,action){var books=[];if(state.data&&state.data.content){books=[].concat(_toConsumableArray(state.data.content));}var updateContent=false;if(books.length>0){var index=books.indexOf(action.data.isbn);if(index>-1){// Move the recently-opened book to the front of the list
var book=books[index];books.splice(index,1);books.unshift(book);updateContent=true;}}if(!updateContent){// Put the book that was opened at the front of the list
books.unshift(action.data.isbn);updateContent=true;}if(updateContent){return Object.assign({},state,{data:Object.assign({},state.data,{content:books})});}return state;}var fetchStart=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["f" /* createStartAction */])(__WEBPACK_IMPORTED_MODULE_4__bridge_method_remap__["a" /* LIST_ACTIVE_ASSETS */]).type;var fetchSuccess=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["g" /* createSuccessAction */])(__WEBPACK_IMPORTED_MODULE_4__bridge_method_remap__["a" /* LIST_ACTIVE_ASSETS */]).type;var fetchFail=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["c" /* createFailAction */])(__WEBPACK_IMPORTED_MODULE_4__bridge_method_remap__["a" /* LIST_ACTIVE_ASSETS */]).type;var createViewer=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["g" /* createSuccessAction */])(__WEBPACK_IMPORTED_MODULE_2__redux_jigsaw_jigsaw_methods__["c" /* CREATE_PAGE_VIEWER */]).type;var extras=(_extras={},_defineProperty(_extras,fetchStart,doFetchStart),_defineProperty(_extras,fetchSuccess,doFetchSuccess),_defineProperty(_extras,fetchFail,doFetchFail),_defineProperty(_extras,createViewer,reorderBooks),_extras);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__["a" /* createReducer */])(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["h" /* initialState */],extras));

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer_helpers__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bridge_method_remap__ = __webpack_require__(19);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__reducer_helpers__["a" /* makeAssetReducer */])(__WEBPACK_IMPORTED_MODULE_1__bridge_method_remap__["f" /* SEARCH_ASSETS */]));

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_api_redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_bridge_bridge_methods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_api_redux_bridge_assetGroups_recommendations_utils__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_array_find_index__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_deep_equal__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_deep_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_deep_equal__);
function transformer(data){if(data&&data.content){return Object.assign({},data,{content:data.content.map(function(c){return c.vbid;})});}return Object.assign({},data,{content:[]});}var baseReducer=Object(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_util_async_helpers__["b" /* createBaseAsyncReducer */])(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_bridge_bridge_methods__["m" /* LIST_ASSETS_MULTI */],transformer);/**
 * Make each list loom like a separate async node
 */function createReducer(id){/**
   * Figure out which list index goes with this id by comparing to the
   * submitted params
   */function getIndex(lists){return __WEBPACK_IMPORTED_MODULE_4_array_find_index___default()(lists,function(el){return __WEBPACK_IMPORTED_MODULE_5_deep_equal___default()(Object(__WEBPACK_IMPORTED_MODULE_3_app_api_redux_bridge_assetGroups_recommendations_utils__["b" /* getParams */])(id),el);});}return function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:__WEBPACK_IMPORTED_MODULE_0_app_api_redux_util_async_helpers__["h" /* initialState */];var action=arguments[1];if(action.type===Object(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_util_async_helpers__["f" /* createStartAction */])(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_bridge_bridge_methods__["m" /* LIST_ASSETS_MULTI */]).type){var allParams=action.data[0].lists;var index=getIndex(allParams);if(index!==-1){return baseReducer(state,{type:action.type,// The params for just this list
data:allParams[index]});}}else if(action.type===Object(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_util_async_helpers__["g" /* createSuccessAction */])(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_bridge_bridge_methods__["m" /* LIST_ASSETS_MULTI */]).type){var arg=action.args[0];var _index=getIndex(arg.lists);if(_index!==-1){return baseReducer(state,{type:action.type,// Data and params for just this list
data:Object.assign({},action.data.lists[_index]),args:[arg.lists[_index]]});}}else if(action.type===Object(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_util_async_helpers__["c" /* createFailAction */])(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_bridge_bridge_methods__["m" /* LIST_ASSETS_MULTI */]).type){var _index2=getIndex(action.args[0].lists);if(_index2!==-1){// Failures do not require any data differentiation
return baseReducer(state,action);}}return state;};}var reducers=__WEBPACK_IMPORTED_MODULE_3_app_api_redux_bridge_assetGroups_recommendations_utils__["a" /* POSSIBLE_SWIMLANES */].reduce(function(acc,cv){acc[cv]=createReducer(cv);return acc;},{});/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux__["c" /* combineReducers */])(reducers));

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(729);
var isArguments = __webpack_require__(730);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 729 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 730 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bridge_methods__ = __webpack_require__(13);
var items=Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_async_helpers__["d" /* createKeyedAsyncReducer */])({actionKeys:__WEBPACK_IMPORTED_MODULE_2__bridge_methods__["i" /* GET_TAXONOMIES */],param:'id'});/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({items:items}));

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bridge_method_remap__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bridge_methods__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_uid__ = __webpack_require__(63);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var actions=[__WEBPACK_IMPORTED_MODULE_2__bridge_method_remap__["i" /* UPDATE_ADOPTION_NAME */],__WEBPACK_IMPORTED_MODULE_2__bridge_method_remap__["j" /* UPDATE_ADOPTION_USERS */],__WEBPACK_IMPORTED_MODULE_2__bridge_method_remap__["g" /* UPDATE_ADOPTION_ALL_USERS */],__WEBPACK_IMPORTED_MODULE_3__bridge_methods__["d" /* DELETE_ADOPTION */],__WEBPACK_IMPORTED_MODULE_3__bridge_methods__["b" /* CREATE_ADOPTION */]];var handlers={};actions.forEach(function(a){var key=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["c" /* createFailAction */])(a).type;handlers[key]=function(state,action){return[].concat(_toConsumableArray(state),[{type:a,data:action.args[0],id:Object(__WEBPACK_IMPORTED_MODULE_4__utils_uid__["a" /* getUid */])()}]);};});/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__["a" /* createReducer */])([],handlers));

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__known_class_actions__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_array_find_index__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_moment__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_util_general_helpers__ = __webpack_require__(3);
var _handlers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var handlers=(_handlers={},_defineProperty(_handlers,__WEBPACK_IMPORTED_MODULE_0__known_class_actions__["a" /* ADD */],function(state,action){if(!action.code||!action.name){return state;}var classes=state.slice();var index=__WEBPACK_IMPORTED_MODULE_1_array_find_index___default()(classes,function(c){return c.code===action.code;});if(index!==-1){var existingClass=classes[index];classes[index]=Object.assign({},existingClass,{name:action.name});}else{classes.push({code:action.code,name:action.name,expires:__WEBPACK_IMPORTED_MODULE_2_moment_moment___default()().add(11,'months').format()});}return classes;}),_defineProperty(_handlers,__WEBPACK_IMPORTED_MODULE_0__known_class_actions__["b" /* REMOVE */],function(state,action){var index=__WEBPACK_IMPORTED_MODULE_1_array_find_index___default()(state,function(el){return el.code===action.code;});if(index!==-1){var classes=state.slice();classes.splice(index,1);return classes;}return state;}),_handlers);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__redux_util_general_helpers__["a" /* createReducer */])([],handlers));

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignments_reducer__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__errors_reducer__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(9);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux__["c" /* combineReducers */])({assignments:__WEBPACK_IMPORTED_MODULE_0__assignments_reducer__["a" /* default */],errors:__WEBPACK_IMPORTED_MODULE_1__errors_reducer__["a" /* default */]}));

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_api_redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_redux_feeny_assignments_actions__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_utils_array__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_api_redux_util_general_helpers__ = __webpack_require__(3);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var baseHandlers=Object(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_util_async_helpers__["a" /* createBaseAsyncHandlers */])(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_feeny_assignments_actions__["a" /* ALL_ASSIGNMENTS */]);var deleteHandlers=_defineProperty({},Object(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_util_async_helpers__["f" /* createStartAction */])(__WEBPACK_IMPORTED_MODULE_1_app_api_redux_feeny_assignments_actions__["b" /* DELETE_ASSIGNMENT */]).type,function(state,action){if(!state.data){return state;}return Object.assign({},state,{data:{data:Object(__WEBPACK_IMPORTED_MODULE_2_app_utils_array__["f" /* removeFromArray */])(state.data.data,'uuid',action.data[0])}});});/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_app_api_redux_util_general_helpers__["a" /* createReducer */])(__WEBPACK_IMPORTED_MODULE_0_app_api_redux_util_async_helpers__["h" /* initialState */],baseHandlers,deleteHandlers));

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_uid__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_api_redux_feeny_assignments_actions__ = __webpack_require__(105);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var actions=[__WEBPACK_IMPORTED_MODULE_3_app_api_redux_feeny_assignments_actions__["b" /* DELETE_ASSIGNMENT */],__WEBPACK_IMPORTED_MODULE_3_app_api_redux_feeny_assignments_actions__["a" /* ALL_ASSIGNMENTS */]];var handlers={};actions.forEach(function(a){var key=Object(__WEBPACK_IMPORTED_MODULE_0__redux_util_async_helpers__["c" /* createFailAction */])(a).type;handlers[key]=function(state,action){return[].concat(_toConsumableArray(state),[{type:a,id:Object(__WEBPACK_IMPORTED_MODULE_2__utils_uid__["a" /* getUid */])()}]);};});/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__redux_util_general_helpers__["a" /* createReducer */])([],handlers));

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_persist__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__0000__ = __webpack_require__(739);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_persist__["a" /* createMigrate */])({0:__WEBPACK_IMPORTED_MODULE_1__0000__["a" /* default */]}));

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(state){return{knownClasses:state.knownClasses};});

/***/ }),
/* 740 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(383);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.0088dc56.js